export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Byte: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  Decimal: { input: any; output: any; }
  Long: { input: any; output: any; }
  Short: { input: any; output: any; }
  UUID: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type AddGoGoLiveParentGuideLocaleRequestInput = {
  goGoLiveParentGuideId: Scalars['Int']['input'];
  introduction?: InputMaybe<Scalars['String']['input']>;
  learningGoals?: InputMaybe<Array<Scalars['String']['input']>>;
  market: Scalars['String']['input'];
  showAndTell?: InputMaybe<Scalars['String']['input']>;
  user: Scalars['String']['input'];
};

export type AddGoGoLiveParentGuideRequestInput = {
  bookPage?: InputMaybe<Scalars['String']['input']>;
  introduction: Scalars['String']['input'];
  isNotifyTeams?: InputMaybe<Scalars['Boolean']['input']>;
  languagePoint: Scalars['String']['input'];
  learningGoals: Array<Scalars['String']['input']>;
  lessonTitle: Scalars['String']['input'];
  levelId: Scalars['String']['input'];
  previewVideoCoverImageFileName: Scalars['String']['input'];
  previewVideoVimeoId?: InputMaybe<Scalars['String']['input']>;
  printableSheet?: InputMaybe<Scalars['String']['input']>;
  sessions: Array<GoGoLiveSessionInfoInput>;
  showAndTell?: InputMaybe<Scalars['String']['input']>;
  songList: Array<GoGoLiveParentGuideSongInfoInput>;
  toys?: InputMaybe<Array<GoGoLiveToyInfoInput>>;
  user: Scalars['String']['input'];
  wordList: Array<TalkAlongCardInfoInput>;
  yearAndMonth: Scalars['String']['input'];
};

export enum AfBlobPath {
  AppEventBannerImage = 'APP_EVENT_BANNER_IMAGE',
  AppHomeBanners = 'APP_HOME_BANNERS',
  AppPushNotificationExcelFiles = 'APP_PUSH_NOTIFICATION_EXCEL_FILES',
  AppServiceBanners = 'APP_SERVICE_BANNERS',
  CapTaskAudios = 'CAP_TASK_AUDIOS',
  FaceCallImage = 'FACE_CALL_IMAGE',
  FaceCallPerformerAvatar = 'FACE_CALL_PERFORMER_AVATAR',
  FaceCallVideo = 'FACE_CALL_VIDEO',
  GoGoLiveImage = 'GO_GO_LIVE_IMAGE',
  GoGoLiveParentGuideImagesCover = 'GO_GO_LIVE_PARENT_GUIDE_IMAGES_COVER',
  GoGoLiveParentGuideImagesToy = 'GO_GO_LIVE_PARENT_GUIDE_IMAGES_TOY',
  GoGoLiveParentGuidePdfs = 'GO_GO_LIVE_PARENT_GUIDE_PDFS',
  GraduationAudio = 'GRADUATION_AUDIO',
  GraduationChildPhotos = 'GRADUATION_CHILD_PHOTOS',
  NotificationImage = 'NOTIFICATION_IMAGE',
  SalesContestReport = 'SALES_CONTEST_REPORT',
  Tev2TeBanners = 'TEV2_TE_BANNERS',
  TrialModeAppAnnouncementBarImages = 'TRIAL_MODE_APP_ANNOUNCEMENT_BAR_IMAGES',
  TrialModeCallToActionEncourageDesignedImages = 'TRIAL_MODE_CALL_TO_ACTION_ENCOURAGE_DESIGNED_IMAGES',
  TrialModeCallToActionEncouragePhotos = 'TRIAL_MODE_CALL_TO_ACTION_ENCOURAGE_PHOTOS',
  TrialModeDesignedCharacters = 'TRIAL_MODE_DESIGNED_CHARACTERS',
  TrialModeLocalEventFeaturedEventBanners = 'TRIAL_MODE_LOCAL_EVENT_FEATURED_EVENT_BANNERS',
  TrialModeLocalEventRegularEventBanners = 'TRIAL_MODE_LOCAL_EVENT_REGULAR_EVENT_BANNERS',
  TrialModeNotificationImages = 'TRIAL_MODE_NOTIFICATION_IMAGES',
  TrialModeOnlineExperienceAudios = 'TRIAL_MODE_ONLINE_EXPERIENCE_AUDIOS',
  TrialModeOnlineExperienceDweCategoryThumbnail = 'TRIAL_MODE_ONLINE_EXPERIENCE_DWE_CATEGORY_THUMBNAIL',
  TrialModeOnlineExperienceIntroVideos = 'TRIAL_MODE_ONLINE_EXPERIENCE_INTRO_VIDEOS',
  TrialModeOnlineExperienceLyrics = 'TRIAL_MODE_ONLINE_EXPERIENCE_LYRICS',
  TrialModeOnlineExperienceTestimonialVideos = 'TRIAL_MODE_ONLINE_EXPERIENCE_TESTIMONIAL_VIDEOS',
  TrialModeOnlineExperienceTestimonialVideosThumbnails = 'TRIAL_MODE_ONLINE_EXPERIENCE_TESTIMONIAL_VIDEOS_THUMBNAILS',
  TrialModeOnlineExperienceVideos = 'TRIAL_MODE_ONLINE_EXPERIENCE_VIDEOS',
  TrialModeOnlineExperienceVideosThumbnail = 'TRIAL_MODE_ONLINE_EXPERIENCE_VIDEOS_THUMBNAIL',
  VesPdf = 'VES_PDF',
  WfcDemoThumbnailsClubServices = 'WFC_DEMO_THUMBNAILS_CLUB_SERVICES',
  WfcDemoThumbnailsNews = 'WFC_DEMO_THUMBNAILS_NEWS',
  WfcDemoThumbnailsTestimonial = 'WFC_DEMO_THUMBNAILS_TESTIMONIAL',
  WfcDemoVideosClubServices = 'WFC_DEMO_VIDEOS_CLUB_SERVICES',
  WfcDemoVideosLearningPrograms = 'WFC_DEMO_VIDEOS_LEARNING_PROGRAMS',
  WfcDemoVideosNews = 'WFC_DEMO_VIDEOS_NEWS',
  WfcDemoVideosSalesBinders = 'WFC_DEMO_VIDEOS_SALES_BINDERS',
  WfcDemoVideosTestimonial = 'WFC_DEMO_VIDEOS_TESTIMONIAL'
}

export type AfGraduationChild = {
  __typename?: 'AfGraduationChild';
  childEnglishName?: Maybe<Scalars['String']['output']>;
  childHeight: Scalars['Int']['output'];
  childName?: Maybe<Scalars['String']['output']>;
  childNo?: Maybe<Scalars['String']['output']>;
  childPhotoFilename?: Maybe<Scalars['String']['output']>;
  childWeight: Scalars['Int']['output'];
  childWillingEnglishSpeech: Scalars['Boolean']['output'];
  isCambridge: Scalars['Boolean']['output'];
  isExcellent?: Maybe<Scalars['Boolean']['output']>;
  isGraduate: Scalars['Boolean']['output'];
  isSubmittedFromApp: Scalars['Boolean']['output'];
  market?: Maybe<Scalars['String']['output']>;
  memberNo?: Maybe<Scalars['String']['output']>;
  parentWillingChineseSpeech: Scalars['Boolean']['output'];
  seq: Scalars['Int']['output'];
  updatedTime: Scalars['DateTime']['output'];
  year: Scalars['Int']['output'];
};

export type AfGraduationChildFilterInput = {
  and?: InputMaybe<Array<AfGraduationChildFilterInput>>;
  childEnglishName?: InputMaybe<StringOperationFilterInput>;
  childHeight?: InputMaybe<IntOperationFilterInput>;
  childName?: InputMaybe<StringOperationFilterInput>;
  childNo?: InputMaybe<StringOperationFilterInput>;
  childPhotoFilename?: InputMaybe<StringOperationFilterInput>;
  childWeight?: InputMaybe<IntOperationFilterInput>;
  childWillingEnglishSpeech?: InputMaybe<BooleanOperationFilterInput>;
  isCambridge?: InputMaybe<BooleanOperationFilterInput>;
  isExcellent?: InputMaybe<BooleanOperationFilterInput>;
  isGraduate?: InputMaybe<BooleanOperationFilterInput>;
  isSubmittedFromApp?: InputMaybe<BooleanOperationFilterInput>;
  market?: InputMaybe<StringOperationFilterInput>;
  memberNo?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AfGraduationChildFilterInput>>;
  parentWillingChineseSpeech?: InputMaybe<BooleanOperationFilterInput>;
  seq?: InputMaybe<IntOperationFilterInput>;
  updatedTime?: InputMaybe<DateTimeOperationFilterInput>;
  year?: InputMaybe<IntOperationFilterInput>;
};

export type AfGraduationChildSortInput = {
  childEnglishName?: InputMaybe<SortEnumType>;
  childHeight?: InputMaybe<SortEnumType>;
  childName?: InputMaybe<SortEnumType>;
  childNo?: InputMaybe<SortEnumType>;
  childPhotoFilename?: InputMaybe<SortEnumType>;
  childWeight?: InputMaybe<SortEnumType>;
  childWillingEnglishSpeech?: InputMaybe<SortEnumType>;
  isCambridge?: InputMaybe<SortEnumType>;
  isExcellent?: InputMaybe<SortEnumType>;
  isGraduate?: InputMaybe<SortEnumType>;
  isSubmittedFromApp?: InputMaybe<SortEnumType>;
  market?: InputMaybe<SortEnumType>;
  memberNo?: InputMaybe<SortEnumType>;
  parentWillingChineseSpeech?: InputMaybe<SortEnumType>;
  seq?: InputMaybe<SortEnumType>;
  updatedTime?: InputMaybe<SortEnumType>;
  year?: InputMaybe<SortEnumType>;
};

export type AfMember = Node & {
  __typename?: 'AfMember';
  email?: Maybe<Scalars['String']['output']>;
  englishName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  market?: Maybe<Market>;
  memberNo: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type AfMemberConnection = {
  __typename?: 'AfMemberConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AfMemberEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<AfMember>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AfMemberEdge = {
  __typename?: 'AfMemberEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AfMember;
};

export type AfMemberFilterInput = {
  and?: InputMaybe<Array<AfMemberFilterInput>>;
  email?: InputMaybe<StringOperationFilterInput>;
  englishName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  market?: InputMaybe<NullableOfMarketOperationFilterInput>;
  memberNo?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AfMemberFilterInput>>;
};

export type AfMemberInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  englishName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Market>;
  memberNo: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type AfMemberSortInput = {
  email?: InputMaybe<SortEnumType>;
  englishName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  market?: InputMaybe<SortEnumType>;
  memberNo?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type AfNotificationInput = {
  actionButton?: InputMaybe<Scalars['String']['input']>;
  buttonLinksTo?: InputMaybe<Scalars['String']['input']>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  creator?: InputMaybe<Scalars['String']['input']>;
  imageFileName?: InputMaybe<Scalars['String']['input']>;
  market: Market;
  notificationId?: InputMaybe<Scalars['Int']['input']>;
  scheduleTime?: InputMaybe<Scalars['DateTime']['input']>;
  serviceTypeId?: InputMaybe<Scalars['String']['input']>;
  templateMessage?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AfUpdateChildGraduationOfHongKongInput = {
  childNumber: Scalars['Int']['input'];
  graduationDate: Scalars['DateTime']['input'];
  memberNumber: Scalars['String']['input'];
};

export type AfUpdateChildGraduationOfKoreaInput = {
  childNumber: Scalars['Int']['input'];
  memberNumber: Scalars['String']['input'];
  yearGraduated: Scalars['DateTime']['input'];
};

export type AfUpdateChildGraduationOfTaiwanInput = {
  childNumber: Scalars['String']['input'];
  creator?: InputMaybe<Scalars['String']['input']>;
  memberNumber: Scalars['String']['input'];
  registrationAge: Scalars['String']['input'];
  registrationDate: Scalars['DateTime']['input'];
};

export type ApiResponseOfGetLeadsReplySourceInformationResponse = {
  __typename?: 'ApiResponseOfGetLeadsReplySourceInformationResponse';
  data?: Maybe<GetLeadsReplySourceInformationResponse>;
  error?: Maybe<Scalars['String']['output']>;
};

export enum ApplyPolicy {
  AfterResolver = 'AFTER_RESOLVER',
  BeforeResolver = 'BEFORE_RESOLVER',
  Validation = 'VALIDATION'
}

export type BannerMarketInfo = {
  __typename?: 'BannerMarketInfo';
  marketName: Scalars['String']['output'];
};

export type BannerMarketInfoFilterInput = {
  and?: InputMaybe<Array<BannerMarketInfoFilterInput>>;
  marketName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BannerMarketInfoFilterInput>>;
};

export type BannerMarketInfoSortInput = {
  marketName?: InputMaybe<SortEnumType>;
};

export type BannerServiceInfo = {
  __typename?: 'BannerServiceInfo';
  serviceName: Scalars['String']['output'];
};

export type BannerServiceInfoFilterInput = {
  and?: InputMaybe<Array<BannerServiceInfoFilterInput>>;
  or?: InputMaybe<Array<BannerServiceInfoFilterInput>>;
  serviceName?: InputMaybe<StringOperationFilterInput>;
};

export type BannerServiceInfoSortInput = {
  serviceName?: InputMaybe<SortEnumType>;
};

export type BlobContainerSignatureOfAfBlobPath = {
  __typename?: 'BlobContainerSignatureOfAfBlobPath';
  error?: Maybe<Scalars['String']['output']>;
  path: AfBlobPath;
  token?: Maybe<Scalars['String']['output']>;
  uri?: Maybe<Scalars['String']['output']>;
};

export type BlobOfAfBlobPathInput = {
  file: Scalars['Upload']['input'];
  path: AfBlobPath;
};

export type BooleanOperationFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  neq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ByteOperationFilterInput = {
  eq?: InputMaybe<Scalars['Byte']['input']>;
  gt?: InputMaybe<Scalars['Byte']['input']>;
  gte?: InputMaybe<Scalars['Byte']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Byte']['input']>>>;
  lt?: InputMaybe<Scalars['Byte']['input']>;
  lte?: InputMaybe<Scalars['Byte']['input']>;
  neq?: InputMaybe<Scalars['Byte']['input']>;
  ngt?: InputMaybe<Scalars['Byte']['input']>;
  ngte?: InputMaybe<Scalars['Byte']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Byte']['input']>>>;
  nlt?: InputMaybe<Scalars['Byte']['input']>;
  nlte?: InputMaybe<Scalars['Byte']['input']>;
};

/** AppAuth */
export type Club_WorldFamilyClub_AppAuth = Node & {
  __typename?: 'Club_WorldFamilyClub_AppAuth';
  /** DeviceId */
  deviceId?: Maybe<Scalars['String']['output']>;
  /** [ID] Project */
  id: Scalars['ID']['output'];
  /** Region */
  region?: Maybe<Scalars['String']['output']>;
  /** SmsCode */
  smsCode?: Maybe<Scalars['String']['output']>;
  /** UserId */
  userId?: Maybe<Scalars['String']['output']>;
  /** UtcCdt */
  utcCdt?: Maybe<Scalars['DateTime']['output']>;
  /** Verified */
  verified?: Maybe<Scalars['Boolean']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_AppAuthConnection = {
  __typename?: 'Club_WorldFamilyClub_AppAuthConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_AppAuthEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_AppAuth>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_AppAuthEdge = {
  __typename?: 'Club_WorldFamilyClub_AppAuthEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_AppAuth;
};

/** AppAuth */
export type Club_WorldFamilyClub_AppAuthFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_AppAuthFilterInput>>;
  /** DeviceId */
  deviceId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_AppAuthFilterInput>>;
  /** [ID] Project */
  project?: InputMaybe<StringOperationFilterInput>;
  /** Region */
  region?: InputMaybe<StringOperationFilterInput>;
  /** SmsCode */
  smsCode?: InputMaybe<StringOperationFilterInput>;
  /** UserId */
  userId?: InputMaybe<StringOperationFilterInput>;
  /** UtcCdt */
  utcCdt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Verified */
  verified?: InputMaybe<BooleanOperationFilterInput>;
};

/** AppAuth */
export type Club_WorldFamilyClub_AppAuthInput = {
  /** DeviceId */
  deviceId?: InputMaybe<Scalars['String']['input']>;
  /** [ID] Project */
  project?: InputMaybe<Scalars['String']['input']>;
  /** Region */
  region?: InputMaybe<Scalars['String']['input']>;
  /** SmsCode */
  smsCode?: InputMaybe<Scalars['String']['input']>;
  /** UserId */
  userId?: InputMaybe<Scalars['String']['input']>;
  /** UtcCdt */
  utcCdt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Verified */
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

/** AppAuth */
export type Club_WorldFamilyClub_AppAuthSortInput = {
  /** DeviceId */
  deviceId?: InputMaybe<SortEnumType>;
  /** [ID] Project */
  project?: InputMaybe<SortEnumType>;
  /** Region */
  region?: InputMaybe<SortEnumType>;
  /** SmsCode */
  smsCode?: InputMaybe<SortEnumType>;
  /** UserId */
  userId?: InputMaybe<SortEnumType>;
  /** UtcCdt */
  utcCdt?: InputMaybe<SortEnumType>;
  /** Verified */
  verified?: InputMaybe<SortEnumType>;
};

/** AppBanner */
export type Club_WorldFamilyClub_AppBanner = Node & {
  __typename?: 'Club_WorldFamilyClub_AppBanner';
  /** Cdt */
  cdt?: Maybe<Scalars['DateTime']['output']>;
  /** [NOT NULL] EndTime */
  endTime?: Maybe<Scalars['DateTime']['output']>;
  /** [ID] Seq */
  id: Scalars['ID']['output'];
  /** ImageUrl */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** LinkType */
  linkType?: Maybe<Scalars['String']['output']>;
  /** LinkUrl */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** Sort */
  sort?: Maybe<Scalars['Short']['output']>;
  /** [NOT NULL] StartTime */
  startTime?: Maybe<Scalars['DateTime']['output']>;
  /** TextAlign */
  textAlign?: Maybe<Scalars['String']['output']>;
  /** TextContent */
  textContent?: Maybe<Scalars['String']['output']>;
  /** UseFlg */
  useFlg?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_AppBannerConnection = {
  __typename?: 'Club_WorldFamilyClub_AppBannerConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_AppBannerEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_AppBanner>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_AppBannerEdge = {
  __typename?: 'Club_WorldFamilyClub_AppBannerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_AppBanner;
};

/** AppBanner */
export type Club_WorldFamilyClub_AppBannerFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_AppBannerFilterInput>>;
  /** Cdt */
  cdt?: InputMaybe<DateTimeOperationFilterInput>;
  /** [NOT NULL] EndTime */
  endTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** ImageUrl */
  imageUrl?: InputMaybe<StringOperationFilterInput>;
  /** LinkType */
  linkType?: InputMaybe<StringOperationFilterInput>;
  /** LinkUrl */
  linkUrl?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_AppBannerFilterInput>>;
  /** [ID] Seq */
  seq?: InputMaybe<ShortOperationFilterInput>;
  /** Sort */
  sort?: InputMaybe<ShortOperationFilterInput>;
  /** [NOT NULL] StartTime */
  startTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** TextAlign */
  textAlign?: InputMaybe<StringOperationFilterInput>;
  /** TextContent */
  textContent?: InputMaybe<StringOperationFilterInput>;
  /** UseFlg */
  useFlg?: InputMaybe<StringOperationFilterInput>;
};

/** AppBanner */
export type Club_WorldFamilyClub_AppBannerInput = {
  /** Cdt */
  cdt?: InputMaybe<Scalars['DateTime']['input']>;
  /** [NOT NULL] EndTime */
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** ImageUrl */
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  /** LinkType */
  linkType?: InputMaybe<Scalars['String']['input']>;
  /** LinkUrl */
  linkUrl?: InputMaybe<Scalars['String']['input']>;
  /** [ID] Seq */
  seq: Scalars['Short']['input'];
  /** Sort */
  sort?: InputMaybe<Scalars['Short']['input']>;
  /** [NOT NULL] StartTime */
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** TextAlign */
  textAlign?: InputMaybe<Scalars['String']['input']>;
  /** TextContent */
  textContent?: InputMaybe<Scalars['String']['input']>;
  /** UseFlg */
  useFlg?: InputMaybe<Scalars['String']['input']>;
};

/** AppBanner */
export type Club_WorldFamilyClub_AppBannerSortInput = {
  /** Cdt */
  cdt?: InputMaybe<SortEnumType>;
  /** [NOT NULL] EndTime */
  endTime?: InputMaybe<SortEnumType>;
  /** ImageUrl */
  imageUrl?: InputMaybe<SortEnumType>;
  /** LinkType */
  linkType?: InputMaybe<SortEnumType>;
  /** LinkUrl */
  linkUrl?: InputMaybe<SortEnumType>;
  /** [ID] Seq */
  seq?: InputMaybe<SortEnumType>;
  /** Sort */
  sort?: InputMaybe<SortEnumType>;
  /** [NOT NULL] StartTime */
  startTime?: InputMaybe<SortEnumType>;
  /** TextAlign */
  textAlign?: InputMaybe<SortEnumType>;
  /** TextContent */
  textContent?: InputMaybe<SortEnumType>;
  /** UseFlg */
  useFlg?: InputMaybe<SortEnumType>;
};

/** AppDigitalMagazine */
export type Club_WorldFamilyClub_AppDigitalMagazine = Node & {
  __typename?: 'Club_WorldFamilyClub_AppDigitalMagazine';
  /** [NOT NULL] Cover */
  cover?: Maybe<Scalars['String']['output']>;
  /** [ID] Seq */
  id: Scalars['ID']['output'];
  /** [NOT NULL] LinkAddress */
  linkAddress?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Period */
  period?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Region */
  region?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Subject */
  subject?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_AppDigitalMagazineConnection = {
  __typename?: 'Club_WorldFamilyClub_AppDigitalMagazineConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_AppDigitalMagazineEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_AppDigitalMagazine>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_AppDigitalMagazineEdge = {
  __typename?: 'Club_WorldFamilyClub_AppDigitalMagazineEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_AppDigitalMagazine;
};

/** AppDigitalMagazine */
export type Club_WorldFamilyClub_AppDigitalMagazineFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_AppDigitalMagazineFilterInput>>;
  /** [NOT NULL] Cover */
  cover?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] LinkAddress */
  linkAddress?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_AppDigitalMagazineFilterInput>>;
  /** [NOT NULL] Period */
  period?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] Region */
  region?: InputMaybe<StringOperationFilterInput>;
  /** [ID] Seq */
  seq?: InputMaybe<ShortOperationFilterInput>;
  /** [NOT NULL] Subject */
  subject?: InputMaybe<StringOperationFilterInput>;
};

/** AppDigitalMagazine */
export type Club_WorldFamilyClub_AppDigitalMagazineInput = {
  /** [NOT NULL] Cover */
  cover?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] LinkAddress */
  linkAddress?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Period */
  period?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Region */
  region?: InputMaybe<Scalars['String']['input']>;
  /** [ID] Seq */
  seq: Scalars['Short']['input'];
  /** [NOT NULL] Subject */
  subject?: InputMaybe<Scalars['String']['input']>;
};

/** AppDigitalMagazine */
export type Club_WorldFamilyClub_AppDigitalMagazineSortInput = {
  /** [NOT NULL] Cover */
  cover?: InputMaybe<SortEnumType>;
  /** [NOT NULL] LinkAddress */
  linkAddress?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Period */
  period?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Region */
  region?: InputMaybe<SortEnumType>;
  /** [ID] Seq */
  seq?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Subject */
  subject?: InputMaybe<SortEnumType>;
};

/** AppMemberAuthorize */
export type Club_WorldFamilyClub_AppMemberAuthorize = Node & {
  __typename?: 'Club_WorldFamilyClub_AppMemberAuthorize';
  /** CreatedTime */
  createdTime?: Maybe<Scalars['DateTime']['output']>;
  /** [NOT NULL] ExpiresAtTime */
  expiresAtTime?: Maybe<Scalars['DateTime']['output']>;
  /** [ID] RefreshToken */
  id: Scalars['ID']['output'];
  /** [NOT NULL] IsUsed */
  isUsed?: Maybe<Scalars['Boolean']['output']>;
  /** [NOT NULL] Market */
  market?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Token */
  token?: Maybe<Scalars['String']['output']>;
  /** UpdatedTime */
  updatedTime?: Maybe<Scalars['DateTime']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_AppMemberAuthorizeConnection = {
  __typename?: 'Club_WorldFamilyClub_AppMemberAuthorizeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_AppMemberAuthorizeEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_AppMemberAuthorize>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_AppMemberAuthorizeEdge = {
  __typename?: 'Club_WorldFamilyClub_AppMemberAuthorizeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_AppMemberAuthorize;
};

/** AppMemberAuthorize */
export type Club_WorldFamilyClub_AppMemberAuthorizeFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_AppMemberAuthorizeFilterInput>>;
  /** CreatedTime */
  createdTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** [NOT NULL] ExpiresAtTime */
  expiresAtTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** [NOT NULL] IsUsed */
  isUsed?: InputMaybe<BooleanOperationFilterInput>;
  /** [NOT NULL] Market */
  market?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_AppMemberAuthorizeFilterInput>>;
  /** [ID] RefreshToken */
  refreshToken?: InputMaybe<UuidOperationFilterInput>;
  /** [NOT NULL] Token */
  token?: InputMaybe<StringOperationFilterInput>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<DateTimeOperationFilterInput>;
};

/** AppMemberAuthorize */
export type Club_WorldFamilyClub_AppMemberAuthorizeInput = {
  /** CreatedTime */
  createdTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** [NOT NULL] ExpiresAtTime */
  expiresAtTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** [NOT NULL] IsUsed */
  isUsed?: InputMaybe<Scalars['Boolean']['input']>;
  /** [NOT NULL] Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** [ID] RefreshToken */
  refreshToken?: InputMaybe<Scalars['UUID']['input']>;
  /** [NOT NULL] Token */
  token?: InputMaybe<Scalars['String']['input']>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<Scalars['DateTime']['input']>;
};

/** AppMemberAuthorizeLog */
export type Club_WorldFamilyClub_AppMemberAuthorizeLog = Node & {
  __typename?: 'Club_WorldFamilyClub_AppMemberAuthorizeLog';
  /** [NOT NULL] AppAccessToken */
  appAccessToken?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] AppRefreshToken */
  appRefreshToken?: Maybe<Scalars['UUID']['output']>;
  /** [NOT NULL] CreatedTime */
  createdTime?: Maybe<Scalars['DateTime']['output']>;
  /** [NOT NULL] DeviceId */
  deviceId?: Maybe<Scalars['String']['output']>;
  /** [ID] AppMemberAuthorizeLogId */
  id: Scalars['ID']['output'];
  /** [NOT NULL] IsAppRefreshTokenExists */
  isAppRefreshTokenExists?: Maybe<Scalars['Boolean']['output']>;
  /** [NOT NULL] IsAppRefreshTokenExpired */
  isAppRefreshTokenExpired?: Maybe<Scalars['Boolean']['output']>;
  /** [NOT NULL] IsAppRefreshTokenUsed */
  isAppRefreshTokenUsed?: Maybe<Scalars['Boolean']['output']>;
  /** [NOT NULL] IsWebsiteRefreshTokenValid */
  isWebsiteRefreshTokenValid?: Maybe<Scalars['Boolean']['output']>;
  /** [NOT NULL] Market */
  market?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] MemberNumber */
  memberNumber?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] WebsiteAccessToken */
  websiteAccessToken?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] WebsiteRefreshToken */
  websiteRefreshToken?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_AppMemberAuthorizeLogConnection = {
  __typename?: 'Club_WorldFamilyClub_AppMemberAuthorizeLogConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_AppMemberAuthorizeLogEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_AppMemberAuthorizeLog>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_AppMemberAuthorizeLogEdge = {
  __typename?: 'Club_WorldFamilyClub_AppMemberAuthorizeLogEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_AppMemberAuthorizeLog;
};

/** AppMemberAuthorizeLog */
export type Club_WorldFamilyClub_AppMemberAuthorizeLogFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_AppMemberAuthorizeLogFilterInput>>;
  /** [NOT NULL] AppAccessToken */
  appAccessToken?: InputMaybe<StringOperationFilterInput>;
  /** [ID] AppMemberAuthorizeLogId */
  appMemberAuthorizeLogId?: InputMaybe<LongOperationFilterInput>;
  /** [NOT NULL] AppRefreshToken */
  appRefreshToken?: InputMaybe<UuidOperationFilterInput>;
  /** [NOT NULL] CreatedTime */
  createdTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** [NOT NULL] DeviceId */
  deviceId?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] IsAppRefreshTokenExists */
  isAppRefreshTokenExists?: InputMaybe<BooleanOperationFilterInput>;
  /** [NOT NULL] IsAppRefreshTokenExpired */
  isAppRefreshTokenExpired?: InputMaybe<BooleanOperationFilterInput>;
  /** [NOT NULL] IsAppRefreshTokenUsed */
  isAppRefreshTokenUsed?: InputMaybe<BooleanOperationFilterInput>;
  /** [NOT NULL] IsWebsiteRefreshTokenValid */
  isWebsiteRefreshTokenValid?: InputMaybe<BooleanOperationFilterInput>;
  /** [NOT NULL] Market */
  market?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] MemberNumber */
  memberNumber?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_AppMemberAuthorizeLogFilterInput>>;
  /** [NOT NULL] WebsiteAccessToken */
  websiteAccessToken?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] WebsiteRefreshToken */
  websiteRefreshToken?: InputMaybe<StringOperationFilterInput>;
};

/** AppMemberAuthorizeLog */
export type Club_WorldFamilyClub_AppMemberAuthorizeLogInput = {
  /** [NOT NULL] AppAccessToken */
  appAccessToken?: InputMaybe<Scalars['String']['input']>;
  /** [ID] AppMemberAuthorizeLogId */
  appMemberAuthorizeLogId?: InputMaybe<Scalars['Long']['input']>;
  /** [NOT NULL] AppRefreshToken */
  appRefreshToken?: InputMaybe<Scalars['UUID']['input']>;
  /** [NOT NULL] CreatedTime */
  createdTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** [NOT NULL] DeviceId */
  deviceId?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] IsAppRefreshTokenExists */
  isAppRefreshTokenExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** [NOT NULL] IsAppRefreshTokenExpired */
  isAppRefreshTokenExpired?: InputMaybe<Scalars['Boolean']['input']>;
  /** [NOT NULL] IsAppRefreshTokenUsed */
  isAppRefreshTokenUsed?: InputMaybe<Scalars['Boolean']['input']>;
  /** [NOT NULL] IsWebsiteRefreshTokenValid */
  isWebsiteRefreshTokenValid?: InputMaybe<Scalars['Boolean']['input']>;
  /** [NOT NULL] Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] MemberNumber */
  memberNumber?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] WebsiteAccessToken */
  websiteAccessToken?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] WebsiteRefreshToken */
  websiteRefreshToken?: InputMaybe<Scalars['String']['input']>;
};

/** AppMemberAuthorizeLog */
export type Club_WorldFamilyClub_AppMemberAuthorizeLogSortInput = {
  /** [NOT NULL] AppAccessToken */
  appAccessToken?: InputMaybe<SortEnumType>;
  /** [ID] AppMemberAuthorizeLogId */
  appMemberAuthorizeLogId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] AppRefreshToken */
  appRefreshToken?: InputMaybe<SortEnumType>;
  /** [NOT NULL] CreatedTime */
  createdTime?: InputMaybe<SortEnumType>;
  /** [NOT NULL] DeviceId */
  deviceId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] IsAppRefreshTokenExists */
  isAppRefreshTokenExists?: InputMaybe<SortEnumType>;
  /** [NOT NULL] IsAppRefreshTokenExpired */
  isAppRefreshTokenExpired?: InputMaybe<SortEnumType>;
  /** [NOT NULL] IsAppRefreshTokenUsed */
  isAppRefreshTokenUsed?: InputMaybe<SortEnumType>;
  /** [NOT NULL] IsWebsiteRefreshTokenValid */
  isWebsiteRefreshTokenValid?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Market */
  market?: InputMaybe<SortEnumType>;
  /** [NOT NULL] MemberNumber */
  memberNumber?: InputMaybe<SortEnumType>;
  /** [NOT NULL] WebsiteAccessToken */
  websiteAccessToken?: InputMaybe<SortEnumType>;
  /** [NOT NULL] WebsiteRefreshToken */
  websiteRefreshToken?: InputMaybe<SortEnumType>;
};

/** AppMemberAuthorize */
export type Club_WorldFamilyClub_AppMemberAuthorizeSortInput = {
  /** CreatedTime */
  createdTime?: InputMaybe<SortEnumType>;
  /** [NOT NULL] ExpiresAtTime */
  expiresAtTime?: InputMaybe<SortEnumType>;
  /** [NOT NULL] IsUsed */
  isUsed?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Market */
  market?: InputMaybe<SortEnumType>;
  /** [ID] RefreshToken */
  refreshToken?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Token */
  token?: InputMaybe<SortEnumType>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<SortEnumType>;
};

/** AppMemberChild */
export type Club_WorldFamilyClub_AppMemberChild = Node & {
  __typename?: 'Club_WorldFamilyClub_AppMemberChild';
  /** [NOT NULL] ChildNumber */
  childNumber?: Maybe<Scalars['String']['output']>;
  /** CreatedTime */
  createdTime?: Maybe<Scalars['DateTime']['output']>;
  /** [ID] AppMemberChildId */
  id: Scalars['ID']['output'];
  /** [NOT NULL] Market */
  market?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] MemberNumber */
  memberNumber?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] PhotoFileName */
  photoFileName?: Maybe<Scalars['String']['output']>;
  /** UpdatedTime */
  updatedTime?: Maybe<Scalars['DateTime']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_AppMemberChildConnection = {
  __typename?: 'Club_WorldFamilyClub_AppMemberChildConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_AppMemberChildEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_AppMemberChild>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_AppMemberChildEdge = {
  __typename?: 'Club_WorldFamilyClub_AppMemberChildEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_AppMemberChild;
};

/** AppMemberChild */
export type Club_WorldFamilyClub_AppMemberChildFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_AppMemberChildFilterInput>>;
  /** [ID] AppMemberChildId */
  appMemberChildId?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] ChildNumber */
  childNumber?: InputMaybe<StringOperationFilterInput>;
  /** CreatedTime */
  createdTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** [NOT NULL] Market */
  market?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] MemberNumber */
  memberNumber?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_AppMemberChildFilterInput>>;
  /** [NOT NULL] PhotoFileName */
  photoFileName?: InputMaybe<StringOperationFilterInput>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<DateTimeOperationFilterInput>;
};

/** AppMemberChild */
export type Club_WorldFamilyClub_AppMemberChildInput = {
  /** [ID] AppMemberChildId */
  appMemberChildId?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] ChildNumber */
  childNumber?: InputMaybe<Scalars['String']['input']>;
  /** CreatedTime */
  createdTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** [NOT NULL] Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] MemberNumber */
  memberNumber?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] PhotoFileName */
  photoFileName?: InputMaybe<Scalars['String']['input']>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<Scalars['DateTime']['input']>;
};

/** AppMemberChild */
export type Club_WorldFamilyClub_AppMemberChildSortInput = {
  /** [ID] AppMemberChildId */
  appMemberChildId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] ChildNumber */
  childNumber?: InputMaybe<SortEnumType>;
  /** CreatedTime */
  createdTime?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Market */
  market?: InputMaybe<SortEnumType>;
  /** [NOT NULL] MemberNumber */
  memberNumber?: InputMaybe<SortEnumType>;
  /** [NOT NULL] PhotoFileName */
  photoFileName?: InputMaybe<SortEnumType>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<SortEnumType>;
};

/** AppMemberDevice */
export type Club_WorldFamilyClub_AppMemberDevice = Node & {
  __typename?: 'Club_WorldFamilyClub_AppMemberDevice';
  /** [NOT NULL] AppVersion */
  appVersion?: Maybe<Scalars['String']['output']>;
  /** CreatedTime */
  createdTime?: Maybe<Scalars['DateTime']['output']>;
  /** [NOT NULL] DeviceId */
  deviceId?: Maybe<Scalars['String']['output']>;
  /** [ID] AppMemberDeviceId */
  id: Scalars['ID']['output'];
  /** [NOT NULL] Market */
  market?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] MemberNumber */
  memberNumber?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] MobileBrand */
  mobileBrand?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] OsVersion */
  osVersion?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] PushToken */
  pushToken?: Maybe<Scalars['String']['output']>;
  /** UpdatedTime */
  updatedTime?: Maybe<Scalars['DateTime']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_AppMemberDeviceConnection = {
  __typename?: 'Club_WorldFamilyClub_AppMemberDeviceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_AppMemberDeviceEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_AppMemberDevice>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_AppMemberDeviceEdge = {
  __typename?: 'Club_WorldFamilyClub_AppMemberDeviceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_AppMemberDevice;
};

/** AppMemberDevice */
export type Club_WorldFamilyClub_AppMemberDeviceFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_AppMemberDeviceFilterInput>>;
  /** [ID] AppMemberDeviceId */
  appMemberDeviceId?: InputMaybe<LongOperationFilterInput>;
  /** [NOT NULL] AppVersion */
  appVersion?: InputMaybe<StringOperationFilterInput>;
  /** CreatedTime */
  createdTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** [NOT NULL] DeviceId */
  deviceId?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] Market */
  market?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] MemberNumber */
  memberNumber?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] MobileBrand */
  mobileBrand?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_AppMemberDeviceFilterInput>>;
  /** [NOT NULL] OsVersion */
  osVersion?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] PushToken */
  pushToken?: InputMaybe<StringOperationFilterInput>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<DateTimeOperationFilterInput>;
};

/** AppMemberDevice */
export type Club_WorldFamilyClub_AppMemberDeviceInput = {
  /** [ID] AppMemberDeviceId */
  appMemberDeviceId?: InputMaybe<Scalars['Long']['input']>;
  /** [NOT NULL] AppVersion */
  appVersion?: InputMaybe<Scalars['String']['input']>;
  /** CreatedTime */
  createdTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** [NOT NULL] DeviceId */
  deviceId?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] MemberNumber */
  memberNumber?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] MobileBrand */
  mobileBrand?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] OsVersion */
  osVersion?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] PushToken */
  pushToken?: InputMaybe<Scalars['String']['input']>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<Scalars['DateTime']['input']>;
};

/** AppMemberDevice */
export type Club_WorldFamilyClub_AppMemberDeviceSortInput = {
  /** [ID] AppMemberDeviceId */
  appMemberDeviceId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] AppVersion */
  appVersion?: InputMaybe<SortEnumType>;
  /** CreatedTime */
  createdTime?: InputMaybe<SortEnumType>;
  /** [NOT NULL] DeviceId */
  deviceId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Market */
  market?: InputMaybe<SortEnumType>;
  /** [NOT NULL] MemberNumber */
  memberNumber?: InputMaybe<SortEnumType>;
  /** [NOT NULL] MobileBrand */
  mobileBrand?: InputMaybe<SortEnumType>;
  /** [NOT NULL] OsVersion */
  osVersion?: InputMaybe<SortEnumType>;
  /** [NOT NULL] PushToken */
  pushToken?: InputMaybe<SortEnumType>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<SortEnumType>;
};

/** AppMemberFirstLogin */
export type Club_WorldFamilyClub_AppMemberFirstLogin = Node & {
  __typename?: 'Club_WorldFamilyClub_AppMemberFirstLogin';
  /** [NOT NULL] CreatedTime */
  createdTime?: Maybe<Scalars['DateTime']['output']>;
  /** [ID] AppMemberFirstLoginId */
  id: Scalars['ID']['output'];
  /** [NOT NULL] Market */
  market?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] MemberNumber */
  memberNumber?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_AppMemberFirstLoginConnection = {
  __typename?: 'Club_WorldFamilyClub_AppMemberFirstLoginConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_AppMemberFirstLoginEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_AppMemberFirstLogin>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_AppMemberFirstLoginEdge = {
  __typename?: 'Club_WorldFamilyClub_AppMemberFirstLoginEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_AppMemberFirstLogin;
};

/** AppMemberFirstLogin */
export type Club_WorldFamilyClub_AppMemberFirstLoginFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_AppMemberFirstLoginFilterInput>>;
  /** [ID] AppMemberFirstLoginId */
  appMemberFirstLoginId?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] CreatedTime */
  createdTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** [NOT NULL] Market */
  market?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] MemberNumber */
  memberNumber?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_AppMemberFirstLoginFilterInput>>;
};

/** AppMemberFirstLogin */
export type Club_WorldFamilyClub_AppMemberFirstLoginInput = {
  /** [ID] AppMemberFirstLoginId */
  appMemberFirstLoginId?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] CreatedTime */
  createdTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** [NOT NULL] Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] MemberNumber */
  memberNumber?: InputMaybe<Scalars['String']['input']>;
};

/** AppMemberFirstLogin */
export type Club_WorldFamilyClub_AppMemberFirstLoginSortInput = {
  /** [ID] AppMemberFirstLoginId */
  appMemberFirstLoginId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] CreatedTime */
  createdTime?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Market */
  market?: InputMaybe<SortEnumType>;
  /** [NOT NULL] MemberNumber */
  memberNumber?: InputMaybe<SortEnumType>;
};

/** AppMemberNotification */
export type Club_WorldFamilyClub_AppMemberNotification = Node & {
  __typename?: 'Club_WorldFamilyClub_AppMemberNotification';
  /** AfNotificationId */
  afNotificationId?: Maybe<Scalars['Int']['output']>;
  /** ButtonText */
  buttonText?: Maybe<Scalars['String']['output']>;
  /** CreatedTime */
  createdTime?: Maybe<Scalars['DateTime']['output']>;
  /** [ID] MemberNotificationId */
  id: Scalars['ID']['output'];
  /** ImageFileName */
  imageFileName?: Maybe<Scalars['String']['output']>;
  /** LinkNo */
  linkNo?: Maybe<Scalars['String']['output']>;
  /** LookedDate */
  lookedDate?: Maybe<Scalars['DateTime']['output']>;
  /** Market */
  market?: Maybe<Scalars['String']['output']>;
  /** MemberNumber */
  memberNumber?: Maybe<Scalars['String']['output']>;
  /** Message */
  message?: Maybe<Scalars['String']['output']>;
  /** MessageDate */
  messageDate?: Maybe<Scalars['DateTime']['output']>;
  /** NotificationTypeId */
  notificationTypeId?: Maybe<Scalars['String']['output']>;
  /** PublicFlg */
  publicFlg?: Maybe<Scalars['Boolean']['output']>;
  /** PushFlg */
  pushFlg?: Maybe<Scalars['String']['output']>;
  /** ScheduleTime */
  scheduleTime?: Maybe<Scalars['DateTime']['output']>;
  /** SendFlg */
  sendFlg?: Maybe<Scalars['String']['output']>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_AppMemberNotificationConnection = {
  __typename?: 'Club_WorldFamilyClub_AppMemberNotificationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_AppMemberNotificationEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_AppMemberNotification>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_AppMemberNotificationEdge = {
  __typename?: 'Club_WorldFamilyClub_AppMemberNotificationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_AppMemberNotification;
};

/** AppMemberNotification */
export type Club_WorldFamilyClub_AppMemberNotificationFilterInput = {
  /** AfNotificationId */
  afNotificationId?: InputMaybe<IntOperationFilterInput>;
  and?: InputMaybe<Array<Club_WorldFamilyClub_AppMemberNotificationFilterInput>>;
  /** ButtonText */
  buttonText?: InputMaybe<StringOperationFilterInput>;
  /** CreatedTime */
  createdTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** ImageFileName */
  imageFileName?: InputMaybe<StringOperationFilterInput>;
  /** LinkNo */
  linkNo?: InputMaybe<StringOperationFilterInput>;
  /** LookedDate */
  lookedDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Market */
  market?: InputMaybe<StringOperationFilterInput>;
  /** [ID] MemberNotificationId */
  memberNotificationId?: InputMaybe<IntOperationFilterInput>;
  /** MemberNumber */
  memberNumber?: InputMaybe<StringOperationFilterInput>;
  /** Message */
  message?: InputMaybe<StringOperationFilterInput>;
  /** MessageDate */
  messageDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** NotificationTypeId */
  notificationTypeId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_AppMemberNotificationFilterInput>>;
  /** PublicFlg */
  publicFlg?: InputMaybe<BooleanOperationFilterInput>;
  /** PushFlg */
  pushFlg?: InputMaybe<StringOperationFilterInput>;
  /** ScheduleTime */
  scheduleTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** SendFlg */
  sendFlg?: InputMaybe<StringOperationFilterInput>;
  /** Title */
  title?: InputMaybe<StringOperationFilterInput>;
};

/** AppMemberNotification */
export type Club_WorldFamilyClub_AppMemberNotificationInput = {
  /** AfNotificationId */
  afNotificationId?: InputMaybe<Scalars['Int']['input']>;
  /** ButtonText */
  buttonText?: InputMaybe<Scalars['String']['input']>;
  /** CreatedTime */
  createdTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** ImageFileName */
  imageFileName?: InputMaybe<Scalars['String']['input']>;
  /** LinkNo */
  linkNo?: InputMaybe<Scalars['String']['input']>;
  /** LookedDate */
  lookedDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** [ID] MemberNotificationId */
  memberNotificationId?: InputMaybe<Scalars['Int']['input']>;
  /** MemberNumber */
  memberNumber?: InputMaybe<Scalars['String']['input']>;
  /** Message */
  message?: InputMaybe<Scalars['String']['input']>;
  /** MessageDate */
  messageDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** NotificationTypeId */
  notificationTypeId?: InputMaybe<Scalars['String']['input']>;
  /** PublicFlg */
  publicFlg?: InputMaybe<Scalars['Boolean']['input']>;
  /** PushFlg */
  pushFlg?: InputMaybe<Scalars['String']['input']>;
  /** ScheduleTime */
  scheduleTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** SendFlg */
  sendFlg?: InputMaybe<Scalars['String']['input']>;
  /** Title */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** AppMemberNotificationPushFirebase */
export type Club_WorldFamilyClub_AppMemberNotificationPushFirebase = Node & {
  __typename?: 'Club_WorldFamilyClub_AppMemberNotificationPushFirebase';
  /** ActionButton */
  actionButton?: Maybe<Scalars['String']['output']>;
  /** CreatedTime */
  createdTime?: Maybe<Scalars['DateTime']['output']>;
  /** [ID] FirebasePushSeq */
  id: Scalars['ID']['output'];
  /** Market */
  market?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] MemberNotificationId */
  memberNotificationId?: Maybe<Scalars['Int']['output']>;
  /** MemberNumber */
  memberNumber?: Maybe<Scalars['String']['output']>;
  /** Message */
  message?: Maybe<Scalars['String']['output']>;
  /** MessageDate */
  messageDate?: Maybe<Scalars['DateTime']['output']>;
  /** PushToken */
  pushToken?: Maybe<Scalars['String']['output']>;
  /** SendFlg */
  sendFlg?: Maybe<Scalars['String']['output']>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_AppMemberNotificationPushFirebaseConnection = {
  __typename?: 'Club_WorldFamilyClub_AppMemberNotificationPushFirebaseConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_AppMemberNotificationPushFirebaseEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_AppMemberNotificationPushFirebase>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_AppMemberNotificationPushFirebaseEdge = {
  __typename?: 'Club_WorldFamilyClub_AppMemberNotificationPushFirebaseEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_AppMemberNotificationPushFirebase;
};

/** AppMemberNotificationPushFirebase */
export type Club_WorldFamilyClub_AppMemberNotificationPushFirebaseFilterInput = {
  /** ActionButton */
  actionButton?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<Club_WorldFamilyClub_AppMemberNotificationPushFirebaseFilterInput>>;
  /** CreatedTime */
  createdTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** [ID] FirebasePushSeq */
  firebasePushSeq?: InputMaybe<IntOperationFilterInput>;
  /** Market */
  market?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] MemberNotificationId */
  memberNotificationId?: InputMaybe<IntOperationFilterInput>;
  /** MemberNumber */
  memberNumber?: InputMaybe<StringOperationFilterInput>;
  /** Message */
  message?: InputMaybe<StringOperationFilterInput>;
  /** MessageDate */
  messageDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_AppMemberNotificationPushFirebaseFilterInput>>;
  /** PushToken */
  pushToken?: InputMaybe<StringOperationFilterInput>;
  /** SendFlg */
  sendFlg?: InputMaybe<StringOperationFilterInput>;
  /** Title */
  title?: InputMaybe<StringOperationFilterInput>;
};

/** AppMemberNotificationPushFirebase */
export type Club_WorldFamilyClub_AppMemberNotificationPushFirebaseInput = {
  /** ActionButton */
  actionButton?: InputMaybe<Scalars['String']['input']>;
  /** CreatedTime */
  createdTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** [ID] FirebasePushSeq */
  firebasePushSeq?: InputMaybe<Scalars['Int']['input']>;
  /** Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] MemberNotificationId */
  memberNotificationId?: InputMaybe<Scalars['Int']['input']>;
  /** MemberNumber */
  memberNumber?: InputMaybe<Scalars['String']['input']>;
  /** Message */
  message?: InputMaybe<Scalars['String']['input']>;
  /** MessageDate */
  messageDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** PushToken */
  pushToken?: InputMaybe<Scalars['String']['input']>;
  /** SendFlg */
  sendFlg?: InputMaybe<Scalars['String']['input']>;
  /** Title */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** AppMemberNotificationPushFirebase */
export type Club_WorldFamilyClub_AppMemberNotificationPushFirebaseSortInput = {
  /** ActionButton */
  actionButton?: InputMaybe<SortEnumType>;
  /** CreatedTime */
  createdTime?: InputMaybe<SortEnumType>;
  /** [ID] FirebasePushSeq */
  firebasePushSeq?: InputMaybe<SortEnumType>;
  /** Market */
  market?: InputMaybe<SortEnumType>;
  /** [NOT NULL] MemberNotificationId */
  memberNotificationId?: InputMaybe<SortEnumType>;
  /** MemberNumber */
  memberNumber?: InputMaybe<SortEnumType>;
  /** Message */
  message?: InputMaybe<SortEnumType>;
  /** MessageDate */
  messageDate?: InputMaybe<SortEnumType>;
  /** PushToken */
  pushToken?: InputMaybe<SortEnumType>;
  /** SendFlg */
  sendFlg?: InputMaybe<SortEnumType>;
  /** Title */
  title?: InputMaybe<SortEnumType>;
};

/** AppMemberNotification */
export type Club_WorldFamilyClub_AppMemberNotificationSortInput = {
  /** AfNotificationId */
  afNotificationId?: InputMaybe<SortEnumType>;
  /** ButtonText */
  buttonText?: InputMaybe<SortEnumType>;
  /** CreatedTime */
  createdTime?: InputMaybe<SortEnumType>;
  /** ImageFileName */
  imageFileName?: InputMaybe<SortEnumType>;
  /** LinkNo */
  linkNo?: InputMaybe<SortEnumType>;
  /** LookedDate */
  lookedDate?: InputMaybe<SortEnumType>;
  /** Market */
  market?: InputMaybe<SortEnumType>;
  /** [ID] MemberNotificationId */
  memberNotificationId?: InputMaybe<SortEnumType>;
  /** MemberNumber */
  memberNumber?: InputMaybe<SortEnumType>;
  /** Message */
  message?: InputMaybe<SortEnumType>;
  /** MessageDate */
  messageDate?: InputMaybe<SortEnumType>;
  /** NotificationTypeId */
  notificationTypeId?: InputMaybe<SortEnumType>;
  /** PublicFlg */
  publicFlg?: InputMaybe<SortEnumType>;
  /** PushFlg */
  pushFlg?: InputMaybe<SortEnumType>;
  /** ScheduleTime */
  scheduleTime?: InputMaybe<SortEnumType>;
  /** SendFlg */
  sendFlg?: InputMaybe<SortEnumType>;
  /** Title */
  title?: InputMaybe<SortEnumType>;
};

/** AppNotification */
export type Club_WorldFamilyClub_AppNotification = Node & {
  __typename?: 'Club_WorldFamilyClub_AppNotification';
  /** ActionButton */
  actionButton?: Maybe<Scalars['String']['output']>;
  /** ButtonLinksTo */
  buttonLinksTo?: Maybe<Scalars['String']['output']>;
  /** ButtonText */
  buttonText?: Maybe<Scalars['String']['output']>;
  /** CreatedTime */
  createdTime?: Maybe<Scalars['DateTime']['output']>;
  /** Creator */
  creator?: Maybe<Scalars['String']['output']>;
  /** Error */
  error?: Maybe<Scalars['String']['output']>;
  /** [ID] NotificationId */
  id: Scalars['ID']['output'];
  /** ImageFileName */
  imageFileName?: Maybe<Scalars['String']['output']>;
  /** IsAllMember */
  isAllMember?: Maybe<Scalars['Boolean']['output']>;
  /** JobStatus */
  jobStatus?: Maybe<Scalars['String']['output']>;
  /** Market */
  market?: Maybe<Scalars['String']['output']>;
  /** MutationOperation */
  mutationOperation?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] NotificationTypeId */
  notificationTypeId?: Maybe<Scalars['String']['output']>;
  /** RemoveNotificationId */
  removeNotificationId?: Maybe<Scalars['Int']['output']>;
  /** ScheduleTime */
  scheduleTime?: Maybe<Scalars['DateTime']['output']>;
  /** TemplateMessage */
  templateMessage?: Maybe<Scalars['String']['output']>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_AppNotificationConnection = {
  __typename?: 'Club_WorldFamilyClub_AppNotificationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_AppNotificationEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_AppNotification>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_AppNotificationEdge = {
  __typename?: 'Club_WorldFamilyClub_AppNotificationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_AppNotification;
};

/** AppNotification */
export type Club_WorldFamilyClub_AppNotificationFilterInput = {
  /** ActionButton */
  actionButton?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<Club_WorldFamilyClub_AppNotificationFilterInput>>;
  /** ButtonLinksTo */
  buttonLinksTo?: InputMaybe<StringOperationFilterInput>;
  /** ButtonText */
  buttonText?: InputMaybe<StringOperationFilterInput>;
  /** CreatedTime */
  createdTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** Creator */
  creator?: InputMaybe<StringOperationFilterInput>;
  /** Error */
  error?: InputMaybe<StringOperationFilterInput>;
  /** ImageFileName */
  imageFileName?: InputMaybe<StringOperationFilterInput>;
  /** IsAllMember */
  isAllMember?: InputMaybe<BooleanOperationFilterInput>;
  /** JobStatus */
  jobStatus?: InputMaybe<StringOperationFilterInput>;
  /** Market */
  market?: InputMaybe<StringOperationFilterInput>;
  /** MutationOperation */
  mutationOperation?: InputMaybe<StringOperationFilterInput>;
  /** [ID] NotificationId */
  notificationId?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] NotificationTypeId */
  notificationTypeId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_AppNotificationFilterInput>>;
  /** RemoveNotificationId */
  removeNotificationId?: InputMaybe<IntOperationFilterInput>;
  /** ScheduleTime */
  scheduleTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** TemplateMessage */
  templateMessage?: InputMaybe<StringOperationFilterInput>;
  /** Title */
  title?: InputMaybe<StringOperationFilterInput>;
};

/** AppNotification */
export type Club_WorldFamilyClub_AppNotificationInput = {
  /** ActionButton */
  actionButton?: InputMaybe<Scalars['String']['input']>;
  /** ButtonLinksTo */
  buttonLinksTo?: InputMaybe<Scalars['String']['input']>;
  /** ButtonText */
  buttonText?: InputMaybe<Scalars['String']['input']>;
  /** CreatedTime */
  createdTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Creator */
  creator?: InputMaybe<Scalars['String']['input']>;
  /** Error */
  error?: InputMaybe<Scalars['String']['input']>;
  /** ImageFileName */
  imageFileName?: InputMaybe<Scalars['String']['input']>;
  /** IsAllMember */
  isAllMember?: InputMaybe<Scalars['Boolean']['input']>;
  /** JobStatus */
  jobStatus?: InputMaybe<Scalars['String']['input']>;
  /** Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** MutationOperation */
  mutationOperation?: InputMaybe<Scalars['String']['input']>;
  /** [ID] NotificationId */
  notificationId?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] NotificationTypeId */
  notificationTypeId?: InputMaybe<Scalars['String']['input']>;
  /** RemoveNotificationId */
  removeNotificationId?: InputMaybe<Scalars['Int']['input']>;
  /** ScheduleTime */
  scheduleTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** TemplateMessage */
  templateMessage?: InputMaybe<Scalars['String']['input']>;
  /** Title */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** AppNotificationMember */
export type Club_WorldFamilyClub_AppNotificationMember = Node & {
  __typename?: 'Club_WorldFamilyClub_AppNotificationMember';
  /** [NOT NULL] ChildNumber */
  childNumber?: Maybe<Scalars['String']['output']>;
  /** [ID] NotificationMemberId */
  id: Scalars['ID']['output'];
  /** Market */
  market?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] MemberNumber */
  memberNumber?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] NotificationId */
  notificationId?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_AppNotificationMemberConnection = {
  __typename?: 'Club_WorldFamilyClub_AppNotificationMemberConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_AppNotificationMemberEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_AppNotificationMember>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_AppNotificationMemberEdge = {
  __typename?: 'Club_WorldFamilyClub_AppNotificationMemberEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_AppNotificationMember;
};

/** AppNotificationMember */
export type Club_WorldFamilyClub_AppNotificationMemberFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_AppNotificationMemberFilterInput>>;
  /** [NOT NULL] ChildNumber */
  childNumber?: InputMaybe<StringOperationFilterInput>;
  /** Market */
  market?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] MemberNumber */
  memberNumber?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] NotificationId */
  notificationId?: InputMaybe<IntOperationFilterInput>;
  /** [ID] NotificationMemberId */
  notificationMemberId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_AppNotificationMemberFilterInput>>;
};

/** AppNotificationMember */
export type Club_WorldFamilyClub_AppNotificationMemberInput = {
  /** [NOT NULL] ChildNumber */
  childNumber?: InputMaybe<Scalars['String']['input']>;
  /** Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] MemberNumber */
  memberNumber?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] NotificationId */
  notificationId?: InputMaybe<Scalars['Int']['input']>;
  /** [ID] NotificationMemberId */
  notificationMemberId?: InputMaybe<Scalars['Long']['input']>;
};

/** AppNotificationMember */
export type Club_WorldFamilyClub_AppNotificationMemberSortInput = {
  /** [NOT NULL] ChildNumber */
  childNumber?: InputMaybe<SortEnumType>;
  /** Market */
  market?: InputMaybe<SortEnumType>;
  /** [NOT NULL] MemberNumber */
  memberNumber?: InputMaybe<SortEnumType>;
  /** [NOT NULL] NotificationId */
  notificationId?: InputMaybe<SortEnumType>;
  /** [ID] NotificationMemberId */
  notificationMemberId?: InputMaybe<SortEnumType>;
};

/** AppNotification */
export type Club_WorldFamilyClub_AppNotificationSortInput = {
  /** ActionButton */
  actionButton?: InputMaybe<SortEnumType>;
  /** ButtonLinksTo */
  buttonLinksTo?: InputMaybe<SortEnumType>;
  /** ButtonText */
  buttonText?: InputMaybe<SortEnumType>;
  /** CreatedTime */
  createdTime?: InputMaybe<SortEnumType>;
  /** Creator */
  creator?: InputMaybe<SortEnumType>;
  /** Error */
  error?: InputMaybe<SortEnumType>;
  /** ImageFileName */
  imageFileName?: InputMaybe<SortEnumType>;
  /** IsAllMember */
  isAllMember?: InputMaybe<SortEnumType>;
  /** JobStatus */
  jobStatus?: InputMaybe<SortEnumType>;
  /** Market */
  market?: InputMaybe<SortEnumType>;
  /** MutationOperation */
  mutationOperation?: InputMaybe<SortEnumType>;
  /** [ID] NotificationId */
  notificationId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] NotificationTypeId */
  notificationTypeId?: InputMaybe<SortEnumType>;
  /** RemoveNotificationId */
  removeNotificationId?: InputMaybe<SortEnumType>;
  /** ScheduleTime */
  scheduleTime?: InputMaybe<SortEnumType>;
  /** TemplateMessage */
  templateMessage?: InputMaybe<SortEnumType>;
  /** Title */
  title?: InputMaybe<SortEnumType>;
};

/** AppNotificationType */
export type Club_WorldFamilyClub_AppNotificationType = Node & {
  __typename?: 'Club_WorldFamilyClub_AppNotificationType';
  /** [ID] NotificationTypeId */
  id: Scalars['ID']['output'];
  /** [NOT NULL] IsPublic */
  isPublic?: Maybe<Scalars['Boolean']['output']>;
  /** TypeName */
  typeName?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_AppNotificationTypeConnection = {
  __typename?: 'Club_WorldFamilyClub_AppNotificationTypeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_AppNotificationTypeEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_AppNotificationType>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_AppNotificationTypeEdge = {
  __typename?: 'Club_WorldFamilyClub_AppNotificationTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_AppNotificationType;
};

/** AppNotificationType */
export type Club_WorldFamilyClub_AppNotificationTypeFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_AppNotificationTypeFilterInput>>;
  /** [NOT NULL] IsPublic */
  isPublic?: InputMaybe<BooleanOperationFilterInput>;
  /** [ID] NotificationTypeId */
  notificationTypeId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_AppNotificationTypeFilterInput>>;
  /** TypeName */
  typeName?: InputMaybe<StringOperationFilterInput>;
};

/** AppNotificationType */
export type Club_WorldFamilyClub_AppNotificationTypeInput = {
  /** [NOT NULL] IsPublic */
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  /** [ID] NotificationTypeId */
  notificationTypeId?: InputMaybe<Scalars['String']['input']>;
  /** TypeName */
  typeName?: InputMaybe<Scalars['String']['input']>;
};

/** AppNotificationTypeMarket */
export type Club_WorldFamilyClub_AppNotificationTypeMarket = Node & {
  __typename?: 'Club_WorldFamilyClub_AppNotificationTypeMarket';
  /** ButtonLinksTo */
  buttonLinksTo?: Maybe<Scalars['String']['output']>;
  /** ButtonText */
  buttonText?: Maybe<Scalars['String']['output']>;
  /** [ID] NotificationTypeMarketId */
  id: Scalars['ID']['output'];
  /** Market */
  market?: Maybe<Scalars['String']['output']>;
  /** NotificationTypeId */
  notificationTypeId?: Maybe<Scalars['String']['output']>;
  /** TypeName */
  typeName?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_AppNotificationTypeMarketConnection = {
  __typename?: 'Club_WorldFamilyClub_AppNotificationTypeMarketConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_AppNotificationTypeMarketEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_AppNotificationTypeMarket>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_AppNotificationTypeMarketEdge = {
  __typename?: 'Club_WorldFamilyClub_AppNotificationTypeMarketEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_AppNotificationTypeMarket;
};

/** AppNotificationTypeMarket */
export type Club_WorldFamilyClub_AppNotificationTypeMarketFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_AppNotificationTypeMarketFilterInput>>;
  /** ButtonLinksTo */
  buttonLinksTo?: InputMaybe<StringOperationFilterInput>;
  /** ButtonText */
  buttonText?: InputMaybe<StringOperationFilterInput>;
  /** Market */
  market?: InputMaybe<StringOperationFilterInput>;
  /** NotificationTypeId */
  notificationTypeId?: InputMaybe<StringOperationFilterInput>;
  /** [ID] NotificationTypeMarketId */
  notificationTypeMarketId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_AppNotificationTypeMarketFilterInput>>;
  /** TypeName */
  typeName?: InputMaybe<StringOperationFilterInput>;
};

/** AppNotificationTypeMarket */
export type Club_WorldFamilyClub_AppNotificationTypeMarketInput = {
  /** ButtonLinksTo */
  buttonLinksTo?: InputMaybe<Scalars['String']['input']>;
  /** ButtonText */
  buttonText?: InputMaybe<Scalars['String']['input']>;
  /** Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** NotificationTypeId */
  notificationTypeId?: InputMaybe<Scalars['String']['input']>;
  /** [ID] NotificationTypeMarketId */
  notificationTypeMarketId?: InputMaybe<Scalars['Int']['input']>;
  /** TypeName */
  typeName?: InputMaybe<Scalars['String']['input']>;
};

/** AppNotificationTypeMarket */
export type Club_WorldFamilyClub_AppNotificationTypeMarketSortInput = {
  /** ButtonLinksTo */
  buttonLinksTo?: InputMaybe<SortEnumType>;
  /** ButtonText */
  buttonText?: InputMaybe<SortEnumType>;
  /** Market */
  market?: InputMaybe<SortEnumType>;
  /** NotificationTypeId */
  notificationTypeId?: InputMaybe<SortEnumType>;
  /** [ID] NotificationTypeMarketId */
  notificationTypeMarketId?: InputMaybe<SortEnumType>;
  /** TypeName */
  typeName?: InputMaybe<SortEnumType>;
};

/** AppNotificationType */
export type Club_WorldFamilyClub_AppNotificationTypeSortInput = {
  /** [NOT NULL] IsPublic */
  isPublic?: InputMaybe<SortEnumType>;
  /** [ID] NotificationTypeId */
  notificationTypeId?: InputMaybe<SortEnumType>;
  /** TypeName */
  typeName?: InputMaybe<SortEnumType>;
};

/** AppRegionEmergency */
export type Club_WorldFamilyClub_AppRegionEmergency = Node & {
  __typename?: 'Club_WorldFamilyClub_AppRegionEmergency';
  /** Cdt */
  cdt?: Maybe<Scalars['DateTime']['output']>;
  /** Creater */
  creater?: Maybe<Scalars['String']['output']>;
  /** Description */
  description?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] EndTime */
  endTime?: Maybe<Scalars['DateTime']['output']>;
  /** [ID] Region */
  id: Scalars['ID']['output'];
  /** Reviser */
  reviser?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] StartTime */
  startTime?: Maybe<Scalars['DateTime']['output']>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
  /** Udt */
  udt?: Maybe<Scalars['DateTime']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_AppRegionEmergencyConnection = {
  __typename?: 'Club_WorldFamilyClub_AppRegionEmergencyConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_AppRegionEmergencyEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_AppRegionEmergency>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_AppRegionEmergencyEdge = {
  __typename?: 'Club_WorldFamilyClub_AppRegionEmergencyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_AppRegionEmergency;
};

/** AppRegionEmergency */
export type Club_WorldFamilyClub_AppRegionEmergencyFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_AppRegionEmergencyFilterInput>>;
  /** Cdt */
  cdt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Creater */
  creater?: InputMaybe<StringOperationFilterInput>;
  /** Description */
  description?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] EndTime */
  endTime?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_AppRegionEmergencyFilterInput>>;
  /** [ID] Region */
  region?: InputMaybe<StringOperationFilterInput>;
  /** Reviser */
  reviser?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] StartTime */
  startTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** Title */
  title?: InputMaybe<StringOperationFilterInput>;
  /** Udt */
  udt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** AppRegionEmergency */
export type Club_WorldFamilyClub_AppRegionEmergencyInput = {
  /** Cdt */
  cdt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Creater */
  creater?: InputMaybe<Scalars['String']['input']>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] EndTime */
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** [ID] Region */
  region?: InputMaybe<Scalars['String']['input']>;
  /** Reviser */
  reviser?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] StartTime */
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Title */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Udt */
  udt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** AppRegionEmergency */
export type Club_WorldFamilyClub_AppRegionEmergencySortInput = {
  /** Cdt */
  cdt?: InputMaybe<SortEnumType>;
  /** Creater */
  creater?: InputMaybe<SortEnumType>;
  /** Description */
  description?: InputMaybe<SortEnumType>;
  /** [NOT NULL] EndTime */
  endTime?: InputMaybe<SortEnumType>;
  /** [ID] Region */
  region?: InputMaybe<SortEnumType>;
  /** Reviser */
  reviser?: InputMaybe<SortEnumType>;
  /** [NOT NULL] StartTime */
  startTime?: InputMaybe<SortEnumType>;
  /** Title */
  title?: InputMaybe<SortEnumType>;
  /** Udt */
  udt?: InputMaybe<SortEnumType>;
};

/** AppRelease */
export type Club_WorldFamilyClub_AppRelease = Node & {
  __typename?: 'Club_WorldFamilyClub_AppRelease';
  /** Appstore */
  appstore?: Maybe<Scalars['String']['output']>;
  /** Appversion */
  appversion?: Maybe<Scalars['String']['output']>;
  /** [ID] Seq */
  id: Scalars['ID']['output'];
  /** Osversion */
  osversion?: Maybe<Scalars['String']['output']>;
  /** ReleaseTime */
  releaseTime?: Maybe<Scalars['DateTime']['output']>;
  /** Version */
  version?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_AppReleaseConnection = {
  __typename?: 'Club_WorldFamilyClub_AppReleaseConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_AppReleaseEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_AppRelease>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_AppReleaseEdge = {
  __typename?: 'Club_WorldFamilyClub_AppReleaseEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_AppRelease;
};

/** AppRelease */
export type Club_WorldFamilyClub_AppReleaseFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_AppReleaseFilterInput>>;
  /** Appstore */
  appstore?: InputMaybe<StringOperationFilterInput>;
  /** Appversion */
  appversion?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_AppReleaseFilterInput>>;
  /** Osversion */
  osversion?: InputMaybe<StringOperationFilterInput>;
  /** ReleaseTime */
  releaseTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** [ID] Seq */
  seq?: InputMaybe<ShortOperationFilterInput>;
  /** Version */
  version?: InputMaybe<StringOperationFilterInput>;
};

/** AppRelease */
export type Club_WorldFamilyClub_AppReleaseInput = {
  /** Appstore */
  appstore?: InputMaybe<Scalars['String']['input']>;
  /** Appversion */
  appversion?: InputMaybe<Scalars['String']['input']>;
  /** Osversion */
  osversion?: InputMaybe<Scalars['String']['input']>;
  /** ReleaseTime */
  releaseTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** [ID] Seq */
  seq: Scalars['Short']['input'];
  /** Version */
  version?: InputMaybe<Scalars['String']['input']>;
};

/** AppRelease */
export type Club_WorldFamilyClub_AppReleaseSortInput = {
  /** Appstore */
  appstore?: InputMaybe<SortEnumType>;
  /** Appversion */
  appversion?: InputMaybe<SortEnumType>;
  /** Osversion */
  osversion?: InputMaybe<SortEnumType>;
  /** ReleaseTime */
  releaseTime?: InputMaybe<SortEnumType>;
  /** [ID] Seq */
  seq?: InputMaybe<SortEnumType>;
  /** Version */
  version?: InputMaybe<SortEnumType>;
};

/** AppServiceRegionFestivalImage */
export type Club_WorldFamilyClub_AppServiceRegionFestivalImage = Node & {
  __typename?: 'Club_WorldFamilyClub_AppServiceRegionFestivalImage';
  /** [NOT NULL] EndDate */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** [NOT NULL] FestivalId */
  festivalId?: Maybe<Scalars['String']['output']>;
  /** [ID] RegionId */
  id: Scalars['ID']['output'];
  /** ImageFileName */
  imageFileName?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] ServiceId */
  serviceId?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] StartDate */
  startDate?: Maybe<Scalars['DateTime']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_AppServiceRegionFestivalImageConnection = {
  __typename?: 'Club_WorldFamilyClub_AppServiceRegionFestivalImageConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_AppServiceRegionFestivalImageEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_AppServiceRegionFestivalImage>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_AppServiceRegionFestivalImageEdge = {
  __typename?: 'Club_WorldFamilyClub_AppServiceRegionFestivalImageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_AppServiceRegionFestivalImage;
};

/** AppServiceRegionFestivalImage */
export type Club_WorldFamilyClub_AppServiceRegionFestivalImageFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_AppServiceRegionFestivalImageFilterInput>>;
  /** [NOT NULL] EndDate */
  endDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** [NOT NULL] FestivalId */
  festivalId?: InputMaybe<StringOperationFilterInput>;
  /** ImageFileName */
  imageFileName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_AppServiceRegionFestivalImageFilterInput>>;
  /** [ID] RegionId */
  regionId?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] ServiceId */
  serviceId?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] StartDate */
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
};

/** AppServiceRegionFestivalImage */
export type Club_WorldFamilyClub_AppServiceRegionFestivalImageInput = {
  /** [NOT NULL] EndDate */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** [NOT NULL] FestivalId */
  festivalId?: InputMaybe<Scalars['String']['input']>;
  /** ImageFileName */
  imageFileName?: InputMaybe<Scalars['String']['input']>;
  /** [ID] RegionId */
  regionId?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] ServiceId */
  serviceId?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] StartDate */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

/** AppServiceRegionFestivalImage */
export type Club_WorldFamilyClub_AppServiceRegionFestivalImageSortInput = {
  /** [NOT NULL] EndDate */
  endDate?: InputMaybe<SortEnumType>;
  /** [NOT NULL] FestivalId */
  festivalId?: InputMaybe<SortEnumType>;
  /** ImageFileName */
  imageFileName?: InputMaybe<SortEnumType>;
  /** [ID] RegionId */
  regionId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] ServiceId */
  serviceId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] StartDate */
  startDate?: InputMaybe<SortEnumType>;
};

/** AppServiceRegionImage */
export type Club_WorldFamilyClub_AppServiceRegionImage = Node & {
  __typename?: 'Club_WorldFamilyClub_AppServiceRegionImage';
  /** [ID] RegionId */
  id: Scalars['ID']['output'];
  /** ImageFileName */
  imageFileName?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] ServiceId */
  serviceId?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_AppServiceRegionImageConnection = {
  __typename?: 'Club_WorldFamilyClub_AppServiceRegionImageConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_AppServiceRegionImageEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_AppServiceRegionImage>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_AppServiceRegionImageEdge = {
  __typename?: 'Club_WorldFamilyClub_AppServiceRegionImageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_AppServiceRegionImage;
};

/** AppServiceRegionImage */
export type Club_WorldFamilyClub_AppServiceRegionImageFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_AppServiceRegionImageFilterInput>>;
  /** ImageFileName */
  imageFileName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_AppServiceRegionImageFilterInput>>;
  /** [ID] RegionId */
  regionId?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] ServiceId */
  serviceId?: InputMaybe<StringOperationFilterInput>;
};

/** AppServiceRegionImage */
export type Club_WorldFamilyClub_AppServiceRegionImageInput = {
  /** ImageFileName */
  imageFileName?: InputMaybe<Scalars['String']['input']>;
  /** [ID] RegionId */
  regionId?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] ServiceId */
  serviceId?: InputMaybe<Scalars['String']['input']>;
};

/** AppServiceRegionImage */
export type Club_WorldFamilyClub_AppServiceRegionImageSortInput = {
  /** ImageFileName */
  imageFileName?: InputMaybe<SortEnumType>;
  /** [ID] RegionId */
  regionId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] ServiceId */
  serviceId?: InputMaybe<SortEnumType>;
};

/** AppSurvey */
export type Club_WorldFamilyClub_AppSurvey = Node & {
  __typename?: 'Club_WorldFamilyClub_AppSurvey';
  /** [ID] SurveyId */
  id: Scalars['ID']['output'];
  /** Region */
  region?: Maybe<Scalars['String']['output']>;
  /** SurveyDescription */
  surveyDescription?: Maybe<Scalars['String']['output']>;
  /** SurveyName */
  surveyName?: Maybe<Scalars['String']['output']>;
  /** SurveyReminder */
  surveyReminder?: Maybe<Scalars['String']['output']>;
  /** UtcCdt */
  utcCdt?: Maybe<Scalars['DateTime']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_AppSurveyConnection = {
  __typename?: 'Club_WorldFamilyClub_AppSurveyConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_AppSurveyEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_AppSurvey>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_AppSurveyEdge = {
  __typename?: 'Club_WorldFamilyClub_AppSurveyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_AppSurvey;
};

/** AppSurvey */
export type Club_WorldFamilyClub_AppSurveyFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_AppSurveyFilterInput>>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_AppSurveyFilterInput>>;
  /** Region */
  region?: InputMaybe<StringOperationFilterInput>;
  /** SurveyDescription */
  surveyDescription?: InputMaybe<StringOperationFilterInput>;
  /** [ID] SurveyId */
  surveyId?: InputMaybe<StringOperationFilterInput>;
  /** SurveyName */
  surveyName?: InputMaybe<StringOperationFilterInput>;
  /** SurveyReminder */
  surveyReminder?: InputMaybe<StringOperationFilterInput>;
  /** UtcCdt */
  utcCdt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** AppSurvey */
export type Club_WorldFamilyClub_AppSurveyInput = {
  /** Region */
  region?: InputMaybe<Scalars['String']['input']>;
  /** SurveyDescription */
  surveyDescription?: InputMaybe<Scalars['String']['input']>;
  /** [ID] SurveyId */
  surveyId?: InputMaybe<Scalars['String']['input']>;
  /** SurveyName */
  surveyName?: InputMaybe<Scalars['String']['input']>;
  /** SurveyReminder */
  surveyReminder?: InputMaybe<Scalars['String']['input']>;
  /** UtcCdt */
  utcCdt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** AppSurveyMember */
export type Club_WorldFamilyClub_AppSurveyMember = Node & {
  __typename?: 'Club_WorldFamilyClub_AppSurveyMember';
  /** AppItem */
  appItem?: Maybe<Scalars['String']['output']>;
  /** Cdt */
  cdt?: Maybe<Scalars['DateTime']['output']>;
  /** [ID] MemberNo */
  id: Scalars['ID']['output'];
  /** [NOT NULL] StarAnswer */
  starAnswer?: Maybe<Scalars['Short']['output']>;
  /** [NOT NULL] SurveySeq */
  surveySeq?: Maybe<Scalars['Short']['output']>;
  /** TextAnswer */
  textAnswer?: Maybe<Scalars['String']['output']>;
  /** UtcCdt */
  utcCdt?: Maybe<Scalars['DateTime']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_AppSurveyMemberConnection = {
  __typename?: 'Club_WorldFamilyClub_AppSurveyMemberConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_AppSurveyMemberEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_AppSurveyMember>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_AppSurveyMemberEdge = {
  __typename?: 'Club_WorldFamilyClub_AppSurveyMemberEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_AppSurveyMember;
};

/** AppSurveyMember */
export type Club_WorldFamilyClub_AppSurveyMemberFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_AppSurveyMemberFilterInput>>;
  /** AppItem */
  appItem?: InputMaybe<StringOperationFilterInput>;
  /** Cdt */
  cdt?: InputMaybe<DateTimeOperationFilterInput>;
  /** [ID] MemberNo */
  memberNo?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_AppSurveyMemberFilterInput>>;
  /** [NOT NULL] StarAnswer */
  starAnswer?: InputMaybe<ShortOperationFilterInput>;
  /** [NOT NULL] SurveySeq */
  surveySeq?: InputMaybe<ShortOperationFilterInput>;
  /** TextAnswer */
  textAnswer?: InputMaybe<StringOperationFilterInput>;
  /** UtcCdt */
  utcCdt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** AppSurveyMember */
export type Club_WorldFamilyClub_AppSurveyMemberInput = {
  /** AppItem */
  appItem?: InputMaybe<Scalars['String']['input']>;
  /** Cdt */
  cdt?: InputMaybe<Scalars['DateTime']['input']>;
  /** [ID] MemberNo */
  memberNo?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] StarAnswer */
  starAnswer?: InputMaybe<Scalars['Short']['input']>;
  /** [NOT NULL] SurveySeq */
  surveySeq?: InputMaybe<Scalars['Short']['input']>;
  /** TextAnswer */
  textAnswer?: InputMaybe<Scalars['String']['input']>;
  /** UtcCdt */
  utcCdt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** AppSurveyMember */
export type Club_WorldFamilyClub_AppSurveyMemberSortInput = {
  /** AppItem */
  appItem?: InputMaybe<SortEnumType>;
  /** Cdt */
  cdt?: InputMaybe<SortEnumType>;
  /** [ID] MemberNo */
  memberNo?: InputMaybe<SortEnumType>;
  /** [NOT NULL] StarAnswer */
  starAnswer?: InputMaybe<SortEnumType>;
  /** [NOT NULL] SurveySeq */
  surveySeq?: InputMaybe<SortEnumType>;
  /** TextAnswer */
  textAnswer?: InputMaybe<SortEnumType>;
  /** UtcCdt */
  utcCdt?: InputMaybe<SortEnumType>;
};

/** AppSurveyQa */
export type Club_WorldFamilyClub_AppSurveyQa = Node & {
  __typename?: 'Club_WorldFamilyClub_AppSurveyQa';
  /** AnswerType */
  answerType?: Maybe<Scalars['String']['output']>;
  /** [ID] SurveySeq */
  id: Scalars['ID']['output'];
  /** QuestionDetail */
  questionDetail?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] QuestionNo */
  questionNo?: Maybe<Scalars['Short']['output']>;
  /** Region */
  region?: Maybe<Scalars['String']['output']>;
  /** SurveyId */
  surveyId?: Maybe<Scalars['String']['output']>;
  /** UtcCdt */
  utcCdt?: Maybe<Scalars['DateTime']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_AppSurveyQaConnection = {
  __typename?: 'Club_WorldFamilyClub_AppSurveyQaConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_AppSurveyQaEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_AppSurveyQa>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_AppSurveyQaEdge = {
  __typename?: 'Club_WorldFamilyClub_AppSurveyQaEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_AppSurveyQa;
};

/** AppSurveyQa */
export type Club_WorldFamilyClub_AppSurveyQaFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_AppSurveyQaFilterInput>>;
  /** AnswerType */
  answerType?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_AppSurveyQaFilterInput>>;
  /** QuestionDetail */
  questionDetail?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] QuestionNo */
  questionNo?: InputMaybe<ShortOperationFilterInput>;
  /** Region */
  region?: InputMaybe<StringOperationFilterInput>;
  /** SurveyId */
  surveyId?: InputMaybe<StringOperationFilterInput>;
  /** [ID] SurveySeq */
  surveySeq?: InputMaybe<ShortOperationFilterInput>;
  /** UtcCdt */
  utcCdt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** AppSurveyQa */
export type Club_WorldFamilyClub_AppSurveyQaInput = {
  /** AnswerType */
  answerType?: InputMaybe<Scalars['String']['input']>;
  /** QuestionDetail */
  questionDetail?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] QuestionNo */
  questionNo?: InputMaybe<Scalars['Short']['input']>;
  /** Region */
  region?: InputMaybe<Scalars['String']['input']>;
  /** SurveyId */
  surveyId?: InputMaybe<Scalars['String']['input']>;
  /** [ID] SurveySeq */
  surveySeq: Scalars['Short']['input'];
  /** UtcCdt */
  utcCdt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** AppSurveyQa */
export type Club_WorldFamilyClub_AppSurveyQaSortInput = {
  /** AnswerType */
  answerType?: InputMaybe<SortEnumType>;
  /** QuestionDetail */
  questionDetail?: InputMaybe<SortEnumType>;
  /** [NOT NULL] QuestionNo */
  questionNo?: InputMaybe<SortEnumType>;
  /** Region */
  region?: InputMaybe<SortEnumType>;
  /** SurveyId */
  surveyId?: InputMaybe<SortEnumType>;
  /** [ID] SurveySeq */
  surveySeq?: InputMaybe<SortEnumType>;
  /** UtcCdt */
  utcCdt?: InputMaybe<SortEnumType>;
};

/** AppSurveyReminder */
export type Club_WorldFamilyClub_AppSurveyReminder = Node & {
  __typename?: 'Club_WorldFamilyClub_AppSurveyReminder';
  /** [ID] SurveyId */
  id: Scalars['ID']['output'];
  /** [NOT NULL] MemberNo */
  memberNo?: Maybe<Scalars['String']['output']>;
  /** Region */
  region?: Maybe<Scalars['String']['output']>;
  /** ReminderDate */
  reminderDate?: Maybe<Scalars['DateTime']['output']>;
  /** UtcReminderDate */
  utcReminderDate?: Maybe<Scalars['DateTime']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_AppSurveyReminderConnection = {
  __typename?: 'Club_WorldFamilyClub_AppSurveyReminderConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_AppSurveyReminderEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_AppSurveyReminder>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_AppSurveyReminderEdge = {
  __typename?: 'Club_WorldFamilyClub_AppSurveyReminderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_AppSurveyReminder;
};

/** AppSurveyReminder */
export type Club_WorldFamilyClub_AppSurveyReminderFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_AppSurveyReminderFilterInput>>;
  /** [NOT NULL] MemberNo */
  memberNo?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_AppSurveyReminderFilterInput>>;
  /** Region */
  region?: InputMaybe<StringOperationFilterInput>;
  /** ReminderDate */
  reminderDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** [ID] SurveyId */
  surveyId?: InputMaybe<StringOperationFilterInput>;
  /** UtcReminderDate */
  utcReminderDate?: InputMaybe<DateTimeOperationFilterInput>;
};

/** AppSurveyReminder */
export type Club_WorldFamilyClub_AppSurveyReminderInput = {
  /** [NOT NULL] MemberNo */
  memberNo?: InputMaybe<Scalars['String']['input']>;
  /** Region */
  region?: InputMaybe<Scalars['String']['input']>;
  /** ReminderDate */
  reminderDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** [ID] SurveyId */
  surveyId?: InputMaybe<Scalars['String']['input']>;
  /** UtcReminderDate */
  utcReminderDate?: InputMaybe<Scalars['DateTime']['input']>;
};

/** AppSurveyReminder */
export type Club_WorldFamilyClub_AppSurveyReminderSortInput = {
  /** [NOT NULL] MemberNo */
  memberNo?: InputMaybe<SortEnumType>;
  /** Region */
  region?: InputMaybe<SortEnumType>;
  /** ReminderDate */
  reminderDate?: InputMaybe<SortEnumType>;
  /** [ID] SurveyId */
  surveyId?: InputMaybe<SortEnumType>;
  /** UtcReminderDate */
  utcReminderDate?: InputMaybe<SortEnumType>;
};

/** AppSurvey */
export type Club_WorldFamilyClub_AppSurveySortInput = {
  /** Region */
  region?: InputMaybe<SortEnumType>;
  /** SurveyDescription */
  surveyDescription?: InputMaybe<SortEnumType>;
  /** [ID] SurveyId */
  surveyId?: InputMaybe<SortEnumType>;
  /** SurveyName */
  surveyName?: InputMaybe<SortEnumType>;
  /** SurveyReminder */
  surveyReminder?: InputMaybe<SortEnumType>;
  /** UtcCdt */
  utcCdt?: InputMaybe<SortEnumType>;
};

/** AzureFunction */
export type Club_WorldFamilyClub_AzureFunction = Node & {
  __typename?: 'Club_WorldFamilyClub_AzureFunction';
  /** [ID] AzureFunctionId */
  id: Scalars['ID']['output'];
  /** MinDate */
  minDate?: Maybe<Scalars['DateTime']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_AzureFunctionConnection = {
  __typename?: 'Club_WorldFamilyClub_AzureFunctionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_AzureFunctionEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_AzureFunction>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_AzureFunctionEdge = {
  __typename?: 'Club_WorldFamilyClub_AzureFunctionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_AzureFunction;
};

/** AzureFunction */
export type Club_WorldFamilyClub_AzureFunctionFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_AzureFunctionFilterInput>>;
  /** [ID] AzureFunctionId */
  azureFunctionId?: InputMaybe<StringOperationFilterInput>;
  /** MinDate */
  minDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_AzureFunctionFilterInput>>;
};

/** AzureFunction */
export type Club_WorldFamilyClub_AzureFunctionInput = {
  /** [ID] AzureFunctionId */
  azureFunctionId?: InputMaybe<Scalars['String']['input']>;
  /** MinDate */
  minDate?: InputMaybe<Scalars['DateTime']['input']>;
};

/** AzureFunction */
export type Club_WorldFamilyClub_AzureFunctionSortInput = {
  /** [ID] AzureFunctionId */
  azureFunctionId?: InputMaybe<SortEnumType>;
  /** MinDate */
  minDate?: InputMaybe<SortEnumType>;
};

/** BankCode */
export type Club_WorldFamilyClub_BankCode = Node & {
  __typename?: 'Club_WorldFamilyClub_BankCode';
  /** [NOT NULL] BankCode1 */
  bankCode1?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] BankName */
  bankName?: Maybe<Scalars['String']['output']>;
  /** [ID] Market */
  id: Scalars['ID']['output'];
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_BankCodeConnection = {
  __typename?: 'Club_WorldFamilyClub_BankCodeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_BankCodeEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_BankCode>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_BankCodeEdge = {
  __typename?: 'Club_WorldFamilyClub_BankCodeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_BankCode;
};

/** BankCode */
export type Club_WorldFamilyClub_BankCodeFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_BankCodeFilterInput>>;
  /** [NOT NULL] BankCode1 */
  bankCode1?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] BankName */
  bankName?: InputMaybe<StringOperationFilterInput>;
  /** [ID] Market */
  market?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_BankCodeFilterInput>>;
};

/** BankCode */
export type Club_WorldFamilyClub_BankCodeInput = {
  /** [NOT NULL] BankCode1 */
  bankCode1?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] BankName */
  bankName?: InputMaybe<Scalars['String']['input']>;
  /** [ID] Market */
  market?: InputMaybe<Scalars['String']['input']>;
};

/** BankCode */
export type Club_WorldFamilyClub_BankCodeSortInput = {
  /** [NOT NULL] BankCode1 */
  bankCode1?: InputMaybe<SortEnumType>;
  /** [NOT NULL] BankName */
  bankName?: InputMaybe<SortEnumType>;
  /** [ID] Market */
  market?: InputMaybe<SortEnumType>;
};

/** BroadcastPromotion */
export type Club_WorldFamilyClub_BroadcastPromotion = Node & {
  __typename?: 'Club_WorldFamilyClub_BroadcastPromotion';
  /** [NOT NULL] ContentId */
  contentId?: Maybe<Scalars['Int']['output']>;
  /** CreateTime */
  createTime?: Maybe<Scalars['DateTime']['output']>;
  /** Description */
  description?: Maybe<Scalars['String']['output']>;
  /** EventEndTime */
  eventEndTime?: Maybe<Scalars['DateTime']['output']>;
  /** EventStartTime */
  eventStartTime?: Maybe<Scalars['DateTime']['output']>;
  /** [ID] Seq */
  id: Scalars['ID']['output'];
  /** ParentGuideUrl */
  parentGuideUrl?: Maybe<Scalars['String']['output']>;
  /** Region */
  region?: Maybe<Scalars['String']['output']>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
  /** VideoUrl */
  videoUrl?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_BroadcastPromotionConnection = {
  __typename?: 'Club_WorldFamilyClub_BroadcastPromotionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_BroadcastPromotionEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_BroadcastPromotion>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_BroadcastPromotionEdge = {
  __typename?: 'Club_WorldFamilyClub_BroadcastPromotionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_BroadcastPromotion;
};

/** BroadcastPromotion */
export type Club_WorldFamilyClub_BroadcastPromotionFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_BroadcastPromotionFilterInput>>;
  /** [NOT NULL] ContentId */
  contentId?: InputMaybe<IntOperationFilterInput>;
  /** CreateTime */
  createTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** Description */
  description?: InputMaybe<StringOperationFilterInput>;
  /** EventEndTime */
  eventEndTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** EventStartTime */
  eventStartTime?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_BroadcastPromotionFilterInput>>;
  /** ParentGuideUrl */
  parentGuideUrl?: InputMaybe<StringOperationFilterInput>;
  /** Region */
  region?: InputMaybe<StringOperationFilterInput>;
  /** [ID] Seq */
  seq?: InputMaybe<IntOperationFilterInput>;
  /** Title */
  title?: InputMaybe<StringOperationFilterInput>;
  /** VideoUrl */
  videoUrl?: InputMaybe<StringOperationFilterInput>;
};

/** BroadcastPromotion */
export type Club_WorldFamilyClub_BroadcastPromotionInput = {
  /** [NOT NULL] ContentId */
  contentId?: InputMaybe<Scalars['Int']['input']>;
  /** CreateTime */
  createTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** EventEndTime */
  eventEndTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** EventStartTime */
  eventStartTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** ParentGuideUrl */
  parentGuideUrl?: InputMaybe<Scalars['String']['input']>;
  /** Region */
  region?: InputMaybe<Scalars['String']['input']>;
  /** [ID] Seq */
  seq?: InputMaybe<Scalars['Int']['input']>;
  /** Title */
  title?: InputMaybe<Scalars['String']['input']>;
  /** VideoUrl */
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

/** BroadcastPromotion */
export type Club_WorldFamilyClub_BroadcastPromotionSortInput = {
  /** [NOT NULL] ContentId */
  contentId?: InputMaybe<SortEnumType>;
  /** CreateTime */
  createTime?: InputMaybe<SortEnumType>;
  /** Description */
  description?: InputMaybe<SortEnumType>;
  /** EventEndTime */
  eventEndTime?: InputMaybe<SortEnumType>;
  /** EventStartTime */
  eventStartTime?: InputMaybe<SortEnumType>;
  /** ParentGuideUrl */
  parentGuideUrl?: InputMaybe<SortEnumType>;
  /** Region */
  region?: InputMaybe<SortEnumType>;
  /** [ID] Seq */
  seq?: InputMaybe<SortEnumType>;
  /** Title */
  title?: InputMaybe<SortEnumType>;
  /** VideoUrl */
  videoUrl?: InputMaybe<SortEnumType>;
};

/** CapGuidePdf */
export type Club_WorldFamilyClub_CapGuidePdf = Node & {
  __typename?: 'Club_WorldFamilyClub_CapGuidePdf';
  /** [ID] Market */
  id: Scalars['ID']['output'];
  /** TeBookPdf */
  teBookPdf?: Maybe<Scalars['String']['output']>;
  /** WfcGuideBookPdf */
  wfcGuideBookPdf?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_CapGuidePdfConnection = {
  __typename?: 'Club_WorldFamilyClub_CapGuidePdfConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_CapGuidePdfEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_CapGuidePdf>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_CapGuidePdfEdge = {
  __typename?: 'Club_WorldFamilyClub_CapGuidePdfEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_CapGuidePdf;
};

/** CapGuidePdf */
export type Club_WorldFamilyClub_CapGuidePdfFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_CapGuidePdfFilterInput>>;
  /** [ID] Market */
  market?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_CapGuidePdfFilterInput>>;
  /** TeBookPdf */
  teBookPdf?: InputMaybe<StringOperationFilterInput>;
  /** WfcGuideBookPdf */
  wfcGuideBookPdf?: InputMaybe<StringOperationFilterInput>;
};

/** CapGuidePdf */
export type Club_WorldFamilyClub_CapGuidePdfInput = {
  /** [ID] Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** TeBookPdf */
  teBookPdf?: InputMaybe<Scalars['String']['input']>;
  /** WfcGuideBookPdf */
  wfcGuideBookPdf?: InputMaybe<Scalars['String']['input']>;
};

/** CapGuidePdf */
export type Club_WorldFamilyClub_CapGuidePdfSortInput = {
  /** [ID] Market */
  market?: InputMaybe<SortEnumType>;
  /** TeBookPdf */
  teBookPdf?: InputMaybe<SortEnumType>;
  /** WfcGuideBookPdf */
  wfcGuideBookPdf?: InputMaybe<SortEnumType>;
};

/** ChildGraduationApplication */
export type Club_WorldFamilyClub_ChildGraduationApplication = Node & {
  __typename?: 'Club_WorldFamilyClub_ChildGraduationApplication';
  /** [NOT NULL] ApplicationCount */
  applicationCount?: Maybe<Scalars['Int']['output']>;
  /** [NOT NULL] ApplicationYear */
  applicationYear?: Maybe<Scalars['Int']['output']>;
  /** [NOT NULL] ApprovedCount */
  approvedCount?: Maybe<Scalars['Int']['output']>;
  /** [NOT NULL] ChildNo */
  childNo?: Maybe<Scalars['String']['output']>;
  /** GraduationDate */
  graduationDate?: Maybe<Scalars['DateTime']['output']>;
  /** [ID] ChildApplicationId */
  id: Scalars['ID']['output'];
  /** InReviewCount */
  inReviewCount?: Maybe<Scalars['Int']['output']>;
  /** IsExcellent */
  isExcellent?: Maybe<Scalars['Boolean']['output']>;
  /** LastApprovalDate */
  lastApprovalDate?: Maybe<Scalars['DateTime']['output']>;
  /** [NOT NULL] Market */
  market?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] MemberNo */
  memberNo?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] RejectedCount */
  rejectedCount?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_ChildGraduationApplicationConnection = {
  __typename?: 'Club_WorldFamilyClub_ChildGraduationApplicationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_ChildGraduationApplicationEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_ChildGraduationApplication>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_ChildGraduationApplicationEdge = {
  __typename?: 'Club_WorldFamilyClub_ChildGraduationApplicationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_ChildGraduationApplication;
};

/** ChildGraduationApplication */
export type Club_WorldFamilyClub_ChildGraduationApplicationFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_ChildGraduationApplicationFilterInput>>;
  /** [NOT NULL] ApplicationCount */
  applicationCount?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] ApplicationYear */
  applicationYear?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] ApprovedCount */
  approvedCount?: InputMaybe<IntOperationFilterInput>;
  /** [ID] ChildApplicationId */
  childApplicationId?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] ChildNo */
  childNo?: InputMaybe<StringOperationFilterInput>;
  /** GraduationDate */
  graduationDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** InReviewCount */
  inReviewCount?: InputMaybe<IntOperationFilterInput>;
  /** IsExcellent */
  isExcellent?: InputMaybe<BooleanOperationFilterInput>;
  /** LastApprovalDate */
  lastApprovalDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** [NOT NULL] Market */
  market?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] MemberNo */
  memberNo?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_ChildGraduationApplicationFilterInput>>;
  /** [NOT NULL] RejectedCount */
  rejectedCount?: InputMaybe<IntOperationFilterInput>;
};

/** ChildGraduationApplication */
export type Club_WorldFamilyClub_ChildGraduationApplicationInput = {
  /** [NOT NULL] ApplicationCount */
  applicationCount?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] ApplicationYear */
  applicationYear?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] ApprovedCount */
  approvedCount?: InputMaybe<Scalars['Int']['input']>;
  /** [ID] ChildApplicationId */
  childApplicationId?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] ChildNo */
  childNo?: InputMaybe<Scalars['String']['input']>;
  /** GraduationDate */
  graduationDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** InReviewCount */
  inReviewCount?: InputMaybe<Scalars['Int']['input']>;
  /** IsExcellent */
  isExcellent?: InputMaybe<Scalars['Boolean']['input']>;
  /** LastApprovalDate */
  lastApprovalDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** [NOT NULL] Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] MemberNo */
  memberNo?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] RejectedCount */
  rejectedCount?: InputMaybe<Scalars['Int']['input']>;
};

/** ChildGraduationApplication */
export type Club_WorldFamilyClub_ChildGraduationApplicationSortInput = {
  /** [NOT NULL] ApplicationCount */
  applicationCount?: InputMaybe<SortEnumType>;
  /** [NOT NULL] ApplicationYear */
  applicationYear?: InputMaybe<SortEnumType>;
  /** [NOT NULL] ApprovedCount */
  approvedCount?: InputMaybe<SortEnumType>;
  /** [ID] ChildApplicationId */
  childApplicationId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] ChildNo */
  childNo?: InputMaybe<SortEnumType>;
  /** GraduationDate */
  graduationDate?: InputMaybe<SortEnumType>;
  /** InReviewCount */
  inReviewCount?: InputMaybe<SortEnumType>;
  /** IsExcellent */
  isExcellent?: InputMaybe<SortEnumType>;
  /** LastApprovalDate */
  lastApprovalDate?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Market */
  market?: InputMaybe<SortEnumType>;
  /** [NOT NULL] MemberNo */
  memberNo?: InputMaybe<SortEnumType>;
  /** [NOT NULL] RejectedCount */
  rejectedCount?: InputMaybe<SortEnumType>;
};

/** CreditcardBankCode */
export type Club_WorldFamilyClub_CreditcardBankCode = Node & {
  __typename?: 'Club_WorldFamilyClub_CreditcardBankCode';
  /** [NOT NULL] CreditcardBankCode1 */
  creditcardBankCode1?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] CreditcardBankName */
  creditcardBankName?: Maybe<Scalars['String']['output']>;
  /** [ID] Market */
  id: Scalars['ID']['output'];
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_CreditcardBankCodeConnection = {
  __typename?: 'Club_WorldFamilyClub_CreditcardBankCodeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_CreditcardBankCodeEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_CreditcardBankCode>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_CreditcardBankCodeEdge = {
  __typename?: 'Club_WorldFamilyClub_CreditcardBankCodeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_CreditcardBankCode;
};

/** CreditcardBankCode */
export type Club_WorldFamilyClub_CreditcardBankCodeFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_CreditcardBankCodeFilterInput>>;
  /** [NOT NULL] CreditcardBankCode1 */
  creditcardBankCode1?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] CreditcardBankName */
  creditcardBankName?: InputMaybe<StringOperationFilterInput>;
  /** [ID] Market */
  market?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_CreditcardBankCodeFilterInput>>;
};

/** CreditcardBankCode */
export type Club_WorldFamilyClub_CreditcardBankCodeInput = {
  /** [NOT NULL] CreditcardBankCode1 */
  creditcardBankCode1?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] CreditcardBankName */
  creditcardBankName?: InputMaybe<Scalars['String']['input']>;
  /** [ID] Market */
  market?: InputMaybe<Scalars['String']['input']>;
};

/** CreditcardBankCode */
export type Club_WorldFamilyClub_CreditcardBankCodeSortInput = {
  /** [NOT NULL] CreditcardBankCode1 */
  creditcardBankCode1?: InputMaybe<SortEnumType>;
  /** [NOT NULL] CreditcardBankName */
  creditcardBankName?: InputMaybe<SortEnumType>;
  /** [ID] Market */
  market?: InputMaybe<SortEnumType>;
};

/** DweProductPackage */
export type Club_WorldFamilyClub_DweProductPackage = Node & {
  __typename?: 'Club_WorldFamilyClub_DweProductPackage';
  /** [COLLECTION] DweProductSongs */
  dweProductSongs?: Maybe<Array<Maybe<Club_WorldFamilyClub_DweProductSong>>>;
  /** [ID] DweProductPackageId */
  id: Scalars['ID']['output'];
  /** ProductFileName */
  productFileName?: Maybe<Scalars['String']['output']>;
  /** ProductName */
  productName?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_DweProductPackageConnection = {
  __typename?: 'Club_WorldFamilyClub_DweProductPackageConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_DweProductPackageEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_DweProductPackage>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_DweProductPackageEdge = {
  __typename?: 'Club_WorldFamilyClub_DweProductPackageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_DweProductPackage;
};

/** DweProductPackage */
export type Club_WorldFamilyClub_DweProductPackageFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_DweProductPackageFilterInput>>;
  /** [ID] DweProductPackageId */
  dweProductPackageId?: InputMaybe<IntOperationFilterInput>;
  /** [COLLECTION] DweProductSongs */
  dweProductSongs?: InputMaybe<ListFilterInputTypeOfClub_WorldFamilyClub_DweProductSongFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_DweProductPackageFilterInput>>;
  /** ProductFileName */
  productFileName?: InputMaybe<StringOperationFilterInput>;
  /** ProductName */
  productName?: InputMaybe<StringOperationFilterInput>;
};

/** DweProductPackage */
export type Club_WorldFamilyClub_DweProductPackageInput = {
  /** [ID] DweProductPackageId */
  dweProductPackageId?: InputMaybe<Scalars['Int']['input']>;
  /** [COLLECTION] DweProductSongs */
  dweProductSongs?: InputMaybe<Array<InputMaybe<Club_WorldFamilyClub_DweProductSongInput>>>;
  /** ProductFileName */
  productFileName?: InputMaybe<Scalars['String']['input']>;
  /** ProductName */
  productName?: InputMaybe<Scalars['String']['input']>;
};

/** DweProductPackage */
export type Club_WorldFamilyClub_DweProductPackageSortInput = {
  /** [ID] DweProductPackageId */
  dweProductPackageId?: InputMaybe<SortEnumType>;
  /** ProductFileName */
  productFileName?: InputMaybe<SortEnumType>;
  /** ProductName */
  productName?: InputMaybe<SortEnumType>;
};

/** DweProductSong */
export type Club_WorldFamilyClub_DweProductSong = Node & {
  __typename?: 'Club_WorldFamilyClub_DweProductSong';
  /** [NAVIGATION] DweProductPackage */
  dweProductPackage?: Maybe<Club_WorldFamilyClub_DweProductPackage>;
  /** DweProductPackageId */
  dweProductPackageId?: Maybe<Scalars['Int']['output']>;
  /** [COLLECTION] DweProductSongTools */
  dweProductSongTools?: Maybe<Array<Maybe<Club_WorldFamilyClub_DweProductSongTool>>>;
  /** [ID] DweProductSongId */
  id: Scalars['ID']['output'];
  /** Lyrics */
  lyrics?: Maybe<Scalars['String']['output']>;
  /** LyricsFileName */
  lyricsFileName?: Maybe<Scalars['String']['output']>;
  /** SongFileName */
  songFileName?: Maybe<Scalars['String']['output']>;
  /** SongName */
  songName?: Maybe<Scalars['String']['output']>;
  /** SongNumber */
  songNumber?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_DweProductSongConnection = {
  __typename?: 'Club_WorldFamilyClub_DweProductSongConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_DweProductSongEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_DweProductSong>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_DweProductSongEdge = {
  __typename?: 'Club_WorldFamilyClub_DweProductSongEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_DweProductSong;
};

/** DweProductSong */
export type Club_WorldFamilyClub_DweProductSongFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_DweProductSongFilterInput>>;
  /** [NAVIGATION] DweProductPackage */
  dweProductPackage?: InputMaybe<Club_WorldFamilyClub_DweProductPackageFilterInput>;
  /** DweProductPackageId */
  dweProductPackageId?: InputMaybe<IntOperationFilterInput>;
  /** [ID] DweProductSongId */
  dweProductSongId?: InputMaybe<IntOperationFilterInput>;
  /** [COLLECTION] DweProductSongTools */
  dweProductSongTools?: InputMaybe<ListFilterInputTypeOfClub_WorldFamilyClub_DweProductSongToolFilterInput>;
  /** Lyrics */
  lyrics?: InputMaybe<StringOperationFilterInput>;
  /** LyricsFileName */
  lyricsFileName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_DweProductSongFilterInput>>;
  /** SongFileName */
  songFileName?: InputMaybe<StringOperationFilterInput>;
  /** SongName */
  songName?: InputMaybe<StringOperationFilterInput>;
  /** SongNumber */
  songNumber?: InputMaybe<StringOperationFilterInput>;
};

/** DweProductSong */
export type Club_WorldFamilyClub_DweProductSongInput = {
  /** [NAVIGATION] DweProductPackage */
  dweProductPackage?: InputMaybe<Club_WorldFamilyClub_DweProductPackageInput>;
  /** DweProductPackageId */
  dweProductPackageId?: InputMaybe<Scalars['Int']['input']>;
  /** [ID] DweProductSongId */
  dweProductSongId?: InputMaybe<Scalars['Int']['input']>;
  /** [COLLECTION] DweProductSongTools */
  dweProductSongTools?: InputMaybe<Array<InputMaybe<Club_WorldFamilyClub_DweProductSongToolInput>>>;
  /** Lyrics */
  lyrics?: InputMaybe<Scalars['String']['input']>;
  /** LyricsFileName */
  lyricsFileName?: InputMaybe<Scalars['String']['input']>;
  /** SongFileName */
  songFileName?: InputMaybe<Scalars['String']['input']>;
  /** SongName */
  songName?: InputMaybe<Scalars['String']['input']>;
  /** SongNumber */
  songNumber?: InputMaybe<Scalars['String']['input']>;
};

/** DweProductSong */
export type Club_WorldFamilyClub_DweProductSongSortInput = {
  /** [NAVIGATION] DweProductPackage */
  dweProductPackage?: InputMaybe<Club_WorldFamilyClub_DweProductPackageSortInput>;
  /** DweProductPackageId */
  dweProductPackageId?: InputMaybe<SortEnumType>;
  /** [ID] DweProductSongId */
  dweProductSongId?: InputMaybe<SortEnumType>;
  /** Lyrics */
  lyrics?: InputMaybe<SortEnumType>;
  /** LyricsFileName */
  lyricsFileName?: InputMaybe<SortEnumType>;
  /** SongFileName */
  songFileName?: InputMaybe<SortEnumType>;
  /** SongName */
  songName?: InputMaybe<SortEnumType>;
  /** SongNumber */
  songNumber?: InputMaybe<SortEnumType>;
};

/** DweProductSongTool */
export type Club_WorldFamilyClub_DweProductSongTool = Node & {
  __typename?: 'Club_WorldFamilyClub_DweProductSongTool';
  /** [NAVIGATION] DweProductSong */
  dweProductSong?: Maybe<Club_WorldFamilyClub_DweProductSong>;
  /** DweProductSongId */
  dweProductSongId?: Maybe<Scalars['Int']['output']>;
  /** [NAVIGATION] DweProductTool */
  dweProductTool?: Maybe<Club_WorldFamilyClub_DweProductTool>;
  /** DweProductToolId */
  dweProductToolId?: Maybe<Scalars['Int']['output']>;
  /** [ID] DweProductSongToolId */
  id: Scalars['ID']['output'];
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_DweProductSongToolConnection = {
  __typename?: 'Club_WorldFamilyClub_DweProductSongToolConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_DweProductSongToolEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_DweProductSongTool>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_DweProductSongToolEdge = {
  __typename?: 'Club_WorldFamilyClub_DweProductSongToolEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_DweProductSongTool;
};

/** DweProductSongTool */
export type Club_WorldFamilyClub_DweProductSongToolFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_DweProductSongToolFilterInput>>;
  /** [NAVIGATION] DweProductSong */
  dweProductSong?: InputMaybe<Club_WorldFamilyClub_DweProductSongFilterInput>;
  /** DweProductSongId */
  dweProductSongId?: InputMaybe<IntOperationFilterInput>;
  /** [ID] DweProductSongToolId */
  dweProductSongToolId?: InputMaybe<IntOperationFilterInput>;
  /** [NAVIGATION] DweProductTool */
  dweProductTool?: InputMaybe<Club_WorldFamilyClub_DweProductToolFilterInput>;
  /** DweProductToolId */
  dweProductToolId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_DweProductSongToolFilterInput>>;
};

/** DweProductSongTool */
export type Club_WorldFamilyClub_DweProductSongToolInput = {
  /** [NAVIGATION] DweProductSong */
  dweProductSong?: InputMaybe<Club_WorldFamilyClub_DweProductSongInput>;
  /** DweProductSongId */
  dweProductSongId?: InputMaybe<Scalars['Int']['input']>;
  /** [ID] DweProductSongToolId */
  dweProductSongToolId?: InputMaybe<Scalars['Int']['input']>;
  /** [NAVIGATION] DweProductTool */
  dweProductTool?: InputMaybe<Club_WorldFamilyClub_DweProductToolInput>;
  /** DweProductToolId */
  dweProductToolId?: InputMaybe<Scalars['Int']['input']>;
};

/** DweProductSongTool */
export type Club_WorldFamilyClub_DweProductSongToolSortInput = {
  /** [NAVIGATION] DweProductSong */
  dweProductSong?: InputMaybe<Club_WorldFamilyClub_DweProductSongSortInput>;
  /** DweProductSongId */
  dweProductSongId?: InputMaybe<SortEnumType>;
  /** [ID] DweProductSongToolId */
  dweProductSongToolId?: InputMaybe<SortEnumType>;
  /** [NAVIGATION] DweProductTool */
  dweProductTool?: InputMaybe<Club_WorldFamilyClub_DweProductToolSortInput>;
  /** DweProductToolId */
  dweProductToolId?: InputMaybe<SortEnumType>;
};

/** DweProductTool */
export type Club_WorldFamilyClub_DweProductTool = Node & {
  __typename?: 'Club_WorldFamilyClub_DweProductTool';
  /** [COLLECTION] DweProductSongTools */
  dweProductSongTools?: Maybe<Array<Maybe<Club_WorldFamilyClub_DweProductSongTool>>>;
  /** [ID] DweProductToolId */
  id: Scalars['ID']['output'];
  /** ImageFileName */
  imageFileName?: Maybe<Scalars['String']['output']>;
  /** ToolName */
  toolName?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_DweProductToolConnection = {
  __typename?: 'Club_WorldFamilyClub_DweProductToolConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_DweProductToolEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_DweProductTool>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_DweProductToolEdge = {
  __typename?: 'Club_WorldFamilyClub_DweProductToolEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_DweProductTool;
};

/** DweProductTool */
export type Club_WorldFamilyClub_DweProductToolFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_DweProductToolFilterInput>>;
  /** [COLLECTION] DweProductSongTools */
  dweProductSongTools?: InputMaybe<ListFilterInputTypeOfClub_WorldFamilyClub_DweProductSongToolFilterInput>;
  /** [ID] DweProductToolId */
  dweProductToolId?: InputMaybe<IntOperationFilterInput>;
  /** ImageFileName */
  imageFileName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_DweProductToolFilterInput>>;
  /** ToolName */
  toolName?: InputMaybe<StringOperationFilterInput>;
};

/** DweProductTool */
export type Club_WorldFamilyClub_DweProductToolInput = {
  /** [COLLECTION] DweProductSongTools */
  dweProductSongTools?: InputMaybe<Array<InputMaybe<Club_WorldFamilyClub_DweProductSongToolInput>>>;
  /** [ID] DweProductToolId */
  dweProductToolId?: InputMaybe<Scalars['Int']['input']>;
  /** ImageFileName */
  imageFileName?: InputMaybe<Scalars['String']['input']>;
  /** ToolName */
  toolName?: InputMaybe<Scalars['String']['input']>;
};

/** DweProductTool */
export type Club_WorldFamilyClub_DweProductToolSortInput = {
  /** [ID] DweProductToolId */
  dweProductToolId?: InputMaybe<SortEnumType>;
  /** ImageFileName */
  imageFileName?: InputMaybe<SortEnumType>;
  /** ToolName */
  toolName?: InputMaybe<SortEnumType>;
};

/** EasypayOrderLog */
export type Club_WorldFamilyClub_EasypayOrderLog = Node & {
  __typename?: 'Club_WorldFamilyClub_EasypayOrderLog';
  /** Cdt */
  cdt?: Maybe<Scalars['DateTime']['output']>;
  /** Cno */
  cno?: Maybe<Scalars['String']['output']>;
  /** [ID] Seq */
  id: Scalars['ID']['output'];
  /** Ip */
  ip?: Maybe<Scalars['String']['output']>;
  /** MemberNo */
  memberNo?: Maybe<Scalars['String']['output']>;
  /** Msg */
  msg?: Maybe<Scalars['String']['output']>;
  /** Note */
  note?: Maybe<Scalars['String']['output']>;
  /** OrderId */
  orderId?: Maybe<Scalars['String']['output']>;
  /** OrderPlatform */
  orderPlatform?: Maybe<Scalars['String']['output']>;
  /** OrderTempId */
  orderTempId?: Maybe<Scalars['String']['output']>;
  /** SessionId */
  sessionId?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_EasypayOrderLogConnection = {
  __typename?: 'Club_WorldFamilyClub_EasypayOrderLogConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_EasypayOrderLogEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_EasypayOrderLog>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_EasypayOrderLogEdge = {
  __typename?: 'Club_WorldFamilyClub_EasypayOrderLogEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_EasypayOrderLog;
};

/** EasypayOrderLog */
export type Club_WorldFamilyClub_EasypayOrderLogFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_EasypayOrderLogFilterInput>>;
  /** Cdt */
  cdt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Cno */
  cno?: InputMaybe<StringOperationFilterInput>;
  /** Ip */
  ip?: InputMaybe<StringOperationFilterInput>;
  /** MemberNo */
  memberNo?: InputMaybe<StringOperationFilterInput>;
  /** Msg */
  msg?: InputMaybe<StringOperationFilterInput>;
  /** Note */
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_EasypayOrderLogFilterInput>>;
  /** OrderId */
  orderId?: InputMaybe<StringOperationFilterInput>;
  /** OrderPlatform */
  orderPlatform?: InputMaybe<StringOperationFilterInput>;
  /** OrderTempId */
  orderTempId?: InputMaybe<StringOperationFilterInput>;
  /** [ID] Seq */
  seq?: InputMaybe<IntOperationFilterInput>;
  /** SessionId */
  sessionId?: InputMaybe<StringOperationFilterInput>;
};

/** EasypayOrderLog */
export type Club_WorldFamilyClub_EasypayOrderLogInput = {
  /** Cdt */
  cdt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Cno */
  cno?: InputMaybe<Scalars['String']['input']>;
  /** Ip */
  ip?: InputMaybe<Scalars['String']['input']>;
  /** MemberNo */
  memberNo?: InputMaybe<Scalars['String']['input']>;
  /** Msg */
  msg?: InputMaybe<Scalars['String']['input']>;
  /** Note */
  note?: InputMaybe<Scalars['String']['input']>;
  /** OrderId */
  orderId?: InputMaybe<Scalars['String']['input']>;
  /** OrderPlatform */
  orderPlatform?: InputMaybe<Scalars['String']['input']>;
  /** OrderTempId */
  orderTempId?: InputMaybe<Scalars['String']['input']>;
  /** [ID] Seq */
  seq?: InputMaybe<Scalars['Int']['input']>;
  /** SessionId */
  sessionId?: InputMaybe<Scalars['String']['input']>;
};

/** EasypayOrderLog */
export type Club_WorldFamilyClub_EasypayOrderLogSortInput = {
  /** Cdt */
  cdt?: InputMaybe<SortEnumType>;
  /** Cno */
  cno?: InputMaybe<SortEnumType>;
  /** Ip */
  ip?: InputMaybe<SortEnumType>;
  /** MemberNo */
  memberNo?: InputMaybe<SortEnumType>;
  /** Msg */
  msg?: InputMaybe<SortEnumType>;
  /** Note */
  note?: InputMaybe<SortEnumType>;
  /** OrderId */
  orderId?: InputMaybe<SortEnumType>;
  /** OrderPlatform */
  orderPlatform?: InputMaybe<SortEnumType>;
  /** OrderTempId */
  orderTempId?: InputMaybe<SortEnumType>;
  /** [ID] Seq */
  seq?: InputMaybe<SortEnumType>;
  /** SessionId */
  sessionId?: InputMaybe<SortEnumType>;
};

/** EntryPackageOrder */
export type Club_WorldFamilyClub_EntryPackageOrder = Node & {
  __typename?: 'Club_WorldFamilyClub_EntryPackageOrder';
  /** Address1 */
  address1?: Maybe<Scalars['String']['output']>;
  /** Address2 */
  address2?: Maybe<Scalars['String']['output']>;
  /** BuldNo */
  buldNo?: Maybe<Scalars['String']['output']>;
  /** CanceledDate */
  canceledDate?: Maybe<Scalars['DateTime']['output']>;
  /** CreatedAt */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** CustomerName */
  customerName?: Maybe<Scalars['String']['output']>;
  /** EasyPayCno */
  easyPayCno?: Maybe<Scalars['String']['output']>;
  /** Email */
  email?: Maybe<Scalars['String']['output']>;
  /** EmdCd */
  emdCd?: Maybe<Scalars['String']['output']>;
  /** FullAddress */
  fullAddress?: Maybe<Scalars['String']['output']>;
  /** [ID] EntryPackageOrderId */
  id: Scalars['ID']['output'];
  /** IsAdvertisingInfoAgreed */
  isAdvertisingInfoAgreed?: Maybe<Scalars['Boolean']['output']>;
  /** IsMarketingInfoCollectionAgreed */
  isMarketingInfoCollectionAgreed?: Maybe<Scalars['Boolean']['output']>;
  /** Market */
  market?: Maybe<Scalars['String']['output']>;
  /** MemberNo */
  memberNo?: Maybe<Scalars['String']['output']>;
  /** OrderId */
  orderId?: Maybe<Scalars['String']['output']>;
  /** PackageNo */
  packageNo?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] PaidAmount */
  paidAmount?: Maybe<Scalars['Int']['output']>;
  /** [NOT NULL] PaymentAmount */
  paymentAmount?: Maybe<Scalars['Int']['output']>;
  /** PaymentDate */
  paymentDate?: Maybe<Scalars['DateTime']['output']>;
  /** PaymentMethod */
  paymentMethod?: Maybe<Scalars['String']['output']>;
  /** PaymentStatus */
  paymentStatus?: Maybe<Scalars['String']['output']>;
  /** PhoneNumber */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** ProductCode */
  productCode?: Maybe<Scalars['String']['output']>;
  /** RoadCd */
  roadCd?: Maybe<Scalars['String']['output']>;
  /** SggCd */
  sggCd?: Maybe<Scalars['String']['output']>;
  /** UpdatedAt */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** UpdatedBy */
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** ZipCode */
  zipCode?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_EntryPackageOrderConnection = {
  __typename?: 'Club_WorldFamilyClub_EntryPackageOrderConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_EntryPackageOrderEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_EntryPackageOrder>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_EntryPackageOrderEdge = {
  __typename?: 'Club_WorldFamilyClub_EntryPackageOrderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_EntryPackageOrder;
};

/** EntryPackageOrder */
export type Club_WorldFamilyClub_EntryPackageOrderFilterInput = {
  /** Address1 */
  address1?: InputMaybe<StringOperationFilterInput>;
  /** Address2 */
  address2?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<Club_WorldFamilyClub_EntryPackageOrderFilterInput>>;
  /** BuldNo */
  buldNo?: InputMaybe<StringOperationFilterInput>;
  /** CanceledDate */
  canceledDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** CreatedAt */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** CustomerName */
  customerName?: InputMaybe<StringOperationFilterInput>;
  /** EasyPayCno */
  easyPayCno?: InputMaybe<StringOperationFilterInput>;
  /** Email */
  email?: InputMaybe<StringOperationFilterInput>;
  /** EmdCd */
  emdCd?: InputMaybe<StringOperationFilterInput>;
  /** [ID] EntryPackageOrderId */
  entryPackageOrderId?: InputMaybe<IntOperationFilterInput>;
  /** FullAddress */
  fullAddress?: InputMaybe<StringOperationFilterInput>;
  /** IsAdvertisingInfoAgreed */
  isAdvertisingInfoAgreed?: InputMaybe<BooleanOperationFilterInput>;
  /** IsMarketingInfoCollectionAgreed */
  isMarketingInfoCollectionAgreed?: InputMaybe<BooleanOperationFilterInput>;
  /** Market */
  market?: InputMaybe<StringOperationFilterInput>;
  /** MemberNo */
  memberNo?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_EntryPackageOrderFilterInput>>;
  /** OrderId */
  orderId?: InputMaybe<StringOperationFilterInput>;
  /** PackageNo */
  packageNo?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] PaidAmount */
  paidAmount?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] PaymentAmount */
  paymentAmount?: InputMaybe<IntOperationFilterInput>;
  /** PaymentDate */
  paymentDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** PaymentMethod */
  paymentMethod?: InputMaybe<StringOperationFilterInput>;
  /** PaymentStatus */
  paymentStatus?: InputMaybe<StringOperationFilterInput>;
  /** PhoneNumber */
  phoneNumber?: InputMaybe<StringOperationFilterInput>;
  /** ProductCode */
  productCode?: InputMaybe<StringOperationFilterInput>;
  /** RoadCd */
  roadCd?: InputMaybe<StringOperationFilterInput>;
  /** SggCd */
  sggCd?: InputMaybe<StringOperationFilterInput>;
  /** UpdatedAt */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** UpdatedBy */
  updatedBy?: InputMaybe<StringOperationFilterInput>;
  /** ZipCode */
  zipCode?: InputMaybe<StringOperationFilterInput>;
};

/** EntryPackageOrder */
export type Club_WorldFamilyClub_EntryPackageOrderInput = {
  /** Address1 */
  address1?: InputMaybe<Scalars['String']['input']>;
  /** Address2 */
  address2?: InputMaybe<Scalars['String']['input']>;
  /** BuldNo */
  buldNo?: InputMaybe<Scalars['String']['input']>;
  /** CanceledDate */
  canceledDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** CreatedAt */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** CustomerName */
  customerName?: InputMaybe<Scalars['String']['input']>;
  /** EasyPayCno */
  easyPayCno?: InputMaybe<Scalars['String']['input']>;
  /** Email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** EmdCd */
  emdCd?: InputMaybe<Scalars['String']['input']>;
  /** [ID] EntryPackageOrderId */
  entryPackageOrderId?: InputMaybe<Scalars['Int']['input']>;
  /** FullAddress */
  fullAddress?: InputMaybe<Scalars['String']['input']>;
  /** IsAdvertisingInfoAgreed */
  isAdvertisingInfoAgreed?: InputMaybe<Scalars['Boolean']['input']>;
  /** IsMarketingInfoCollectionAgreed */
  isMarketingInfoCollectionAgreed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** MemberNo */
  memberNo?: InputMaybe<Scalars['String']['input']>;
  /** OrderId */
  orderId?: InputMaybe<Scalars['String']['input']>;
  /** PackageNo */
  packageNo?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] PaidAmount */
  paidAmount?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] PaymentAmount */
  paymentAmount?: InputMaybe<Scalars['Int']['input']>;
  /** PaymentDate */
  paymentDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** PaymentMethod */
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  /** PaymentStatus */
  paymentStatus?: InputMaybe<Scalars['String']['input']>;
  /** PhoneNumber */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** ProductCode */
  productCode?: InputMaybe<Scalars['String']['input']>;
  /** RoadCd */
  roadCd?: InputMaybe<Scalars['String']['input']>;
  /** SggCd */
  sggCd?: InputMaybe<Scalars['String']['input']>;
  /** UpdatedAt */
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** UpdatedBy */
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  /** ZipCode */
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/** EntryPackageOrder */
export type Club_WorldFamilyClub_EntryPackageOrderSortInput = {
  /** Address1 */
  address1?: InputMaybe<SortEnumType>;
  /** Address2 */
  address2?: InputMaybe<SortEnumType>;
  /** BuldNo */
  buldNo?: InputMaybe<SortEnumType>;
  /** CanceledDate */
  canceledDate?: InputMaybe<SortEnumType>;
  /** CreatedAt */
  createdAt?: InputMaybe<SortEnumType>;
  /** CustomerName */
  customerName?: InputMaybe<SortEnumType>;
  /** EasyPayCno */
  easyPayCno?: InputMaybe<SortEnumType>;
  /** Email */
  email?: InputMaybe<SortEnumType>;
  /** EmdCd */
  emdCd?: InputMaybe<SortEnumType>;
  /** [ID] EntryPackageOrderId */
  entryPackageOrderId?: InputMaybe<SortEnumType>;
  /** FullAddress */
  fullAddress?: InputMaybe<SortEnumType>;
  /** IsAdvertisingInfoAgreed */
  isAdvertisingInfoAgreed?: InputMaybe<SortEnumType>;
  /** IsMarketingInfoCollectionAgreed */
  isMarketingInfoCollectionAgreed?: InputMaybe<SortEnumType>;
  /** Market */
  market?: InputMaybe<SortEnumType>;
  /** MemberNo */
  memberNo?: InputMaybe<SortEnumType>;
  /** OrderId */
  orderId?: InputMaybe<SortEnumType>;
  /** PackageNo */
  packageNo?: InputMaybe<SortEnumType>;
  /** [NOT NULL] PaidAmount */
  paidAmount?: InputMaybe<SortEnumType>;
  /** [NOT NULL] PaymentAmount */
  paymentAmount?: InputMaybe<SortEnumType>;
  /** PaymentDate */
  paymentDate?: InputMaybe<SortEnumType>;
  /** PaymentMethod */
  paymentMethod?: InputMaybe<SortEnumType>;
  /** PaymentStatus */
  paymentStatus?: InputMaybe<SortEnumType>;
  /** PhoneNumber */
  phoneNumber?: InputMaybe<SortEnumType>;
  /** ProductCode */
  productCode?: InputMaybe<SortEnumType>;
  /** RoadCd */
  roadCd?: InputMaybe<SortEnumType>;
  /** SggCd */
  sggCd?: InputMaybe<SortEnumType>;
  /** UpdatedAt */
  updatedAt?: InputMaybe<SortEnumType>;
  /** UpdatedBy */
  updatedBy?: InputMaybe<SortEnumType>;
  /** ZipCode */
  zipCode?: InputMaybe<SortEnumType>;
};

/** EntryPackageOrdersMemberPaymentInfo */
export type Club_WorldFamilyClub_EntryPackageOrdersMemberPaymentInfo = Node & {
  __typename?: 'Club_WorldFamilyClub_EntryPackageOrdersMemberPaymentInfo';
  /** [NOT NULL] AccountHolderName */
  accountHolderName?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] BankCode */
  bankCode?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] BirthDate */
  birthDate?: Maybe<Scalars['String']['output']>;
  /** CreatedAt */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** CreditcardBankCode */
  creditcardBankCode?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] DisplayMask */
  displayMask?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] EntryPackageOrderId */
  entryPackageOrderId?: Maybe<Scalars['Int']['output']>;
  /** ExpiryMonth */
  expiryMonth?: Maybe<Scalars['String']['output']>;
  /** ExpiryYear */
  expiryYear?: Maybe<Scalars['String']['output']>;
  /** [ID] PaymentInfoId */
  id: Scalars['ID']['output'];
  /** [NOT NULL] PaymentNumberEncrypted */
  paymentNumberEncrypted?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] PaymentType */
  paymentType?: Maybe<Scalars['Byte']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_EntryPackageOrdersMemberPaymentInfoConnection = {
  __typename?: 'Club_WorldFamilyClub_EntryPackageOrdersMemberPaymentInfoConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_EntryPackageOrdersMemberPaymentInfoEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_EntryPackageOrdersMemberPaymentInfo>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_EntryPackageOrdersMemberPaymentInfoEdge = {
  __typename?: 'Club_WorldFamilyClub_EntryPackageOrdersMemberPaymentInfoEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_EntryPackageOrdersMemberPaymentInfo;
};

/** EntryPackageOrdersMemberPaymentInfo */
export type Club_WorldFamilyClub_EntryPackageOrdersMemberPaymentInfoFilterInput = {
  /** [NOT NULL] AccountHolderName */
  accountHolderName?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<Club_WorldFamilyClub_EntryPackageOrdersMemberPaymentInfoFilterInput>>;
  /** [NOT NULL] BankCode */
  bankCode?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] BirthDate */
  birthDate?: InputMaybe<StringOperationFilterInput>;
  /** CreatedAt */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** CreditcardBankCode */
  creditcardBankCode?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] DisplayMask */
  displayMask?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] EntryPackageOrderId */
  entryPackageOrderId?: InputMaybe<IntOperationFilterInput>;
  /** ExpiryMonth */
  expiryMonth?: InputMaybe<StringOperationFilterInput>;
  /** ExpiryYear */
  expiryYear?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_EntryPackageOrdersMemberPaymentInfoFilterInput>>;
  /** [ID] PaymentInfoId */
  paymentInfoId?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] PaymentNumberEncrypted */
  paymentNumberEncrypted?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] PaymentType */
  paymentType?: InputMaybe<ByteOperationFilterInput>;
};

/** EntryPackageOrdersMemberPaymentInfo */
export type Club_WorldFamilyClub_EntryPackageOrdersMemberPaymentInfoInput = {
  /** [NOT NULL] AccountHolderName */
  accountHolderName?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] BankCode */
  bankCode?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] BirthDate */
  birthDate?: InputMaybe<Scalars['String']['input']>;
  /** CreatedAt */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** CreditcardBankCode */
  creditcardBankCode?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] DisplayMask */
  displayMask?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] EntryPackageOrderId */
  entryPackageOrderId?: InputMaybe<Scalars['Int']['input']>;
  /** ExpiryMonth */
  expiryMonth?: InputMaybe<Scalars['String']['input']>;
  /** ExpiryYear */
  expiryYear?: InputMaybe<Scalars['String']['input']>;
  /** [ID] PaymentInfoId */
  paymentInfoId?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] PaymentNumberEncrypted */
  paymentNumberEncrypted?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] PaymentType */
  paymentType?: InputMaybe<Scalars['Byte']['input']>;
};

/** EntryPackageOrdersMemberPaymentInfo */
export type Club_WorldFamilyClub_EntryPackageOrdersMemberPaymentInfoSortInput = {
  /** [NOT NULL] AccountHolderName */
  accountHolderName?: InputMaybe<SortEnumType>;
  /** [NOT NULL] BankCode */
  bankCode?: InputMaybe<SortEnumType>;
  /** [NOT NULL] BirthDate */
  birthDate?: InputMaybe<SortEnumType>;
  /** CreatedAt */
  createdAt?: InputMaybe<SortEnumType>;
  /** CreditcardBankCode */
  creditcardBankCode?: InputMaybe<SortEnumType>;
  /** [NOT NULL] DisplayMask */
  displayMask?: InputMaybe<SortEnumType>;
  /** [NOT NULL] EntryPackageOrderId */
  entryPackageOrderId?: InputMaybe<SortEnumType>;
  /** ExpiryMonth */
  expiryMonth?: InputMaybe<SortEnumType>;
  /** ExpiryYear */
  expiryYear?: InputMaybe<SortEnumType>;
  /** [ID] PaymentInfoId */
  paymentInfoId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] PaymentNumberEncrypted */
  paymentNumberEncrypted?: InputMaybe<SortEnumType>;
  /** [NOT NULL] PaymentType */
  paymentType?: InputMaybe<SortEnumType>;
};

/** EventBanner */
export type Club_WorldFamilyClub_EventBanner = Node & {
  __typename?: 'Club_WorldFamilyClub_EventBanner';
  /** DisabledFlag */
  disabledFlag?: Maybe<Scalars['String']['output']>;
  /** [ID] Seq */
  id: Scalars['ID']['output'];
  /** ImageFileName */
  imageFileName?: Maybe<Scalars['String']['output']>;
  /** TextContent */
  textContent?: Maybe<Scalars['String']['output']>;
  /** TypeNo */
  typeNo?: Maybe<Scalars['String']['output']>;
  /** UtcCdt */
  utcCdt?: Maybe<Scalars['DateTime']['output']>;
  /** UtcUdt */
  utcUdt?: Maybe<Scalars['DateTime']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_EventBannerConnection = {
  __typename?: 'Club_WorldFamilyClub_EventBannerConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_EventBannerEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_EventBanner>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_EventBannerEdge = {
  __typename?: 'Club_WorldFamilyClub_EventBannerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_EventBanner;
};

/** EventBanner */
export type Club_WorldFamilyClub_EventBannerFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_EventBannerFilterInput>>;
  /** DisabledFlag */
  disabledFlag?: InputMaybe<StringOperationFilterInput>;
  /** ImageFileName */
  imageFileName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_EventBannerFilterInput>>;
  /** [ID] Seq */
  seq?: InputMaybe<IntOperationFilterInput>;
  /** TextContent */
  textContent?: InputMaybe<StringOperationFilterInput>;
  /** TypeNo */
  typeNo?: InputMaybe<StringOperationFilterInput>;
  /** UtcCdt */
  utcCdt?: InputMaybe<DateTimeOperationFilterInput>;
  /** UtcUdt */
  utcUdt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** EventBanner */
export type Club_WorldFamilyClub_EventBannerInput = {
  /** DisabledFlag */
  disabledFlag?: InputMaybe<Scalars['String']['input']>;
  /** ImageFileName */
  imageFileName?: InputMaybe<Scalars['String']['input']>;
  /** [ID] Seq */
  seq?: InputMaybe<Scalars['Int']['input']>;
  /** TextContent */
  textContent?: InputMaybe<Scalars['String']['input']>;
  /** TypeNo */
  typeNo?: InputMaybe<Scalars['String']['input']>;
  /** UtcCdt */
  utcCdt?: InputMaybe<Scalars['DateTime']['input']>;
  /** UtcUdt */
  utcUdt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** EventBannerRegion */
export type Club_WorldFamilyClub_EventBannerRegion = Node & {
  __typename?: 'Club_WorldFamilyClub_EventBannerRegion';
  /** [ID] Region */
  id: Scalars['ID']['output'];
  /** ImageFileName */
  imageFileName?: Maybe<Scalars['String']['output']>;
  /** RegionMainNo */
  regionMainNo?: Maybe<Scalars['String']['output']>;
  /** UtcCdt */
  utcCdt?: Maybe<Scalars['DateTime']['output']>;
  /** UtcUdt */
  utcUdt?: Maybe<Scalars['DateTime']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_EventBannerRegionConnection = {
  __typename?: 'Club_WorldFamilyClub_EventBannerRegionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_EventBannerRegionEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_EventBannerRegion>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_EventBannerRegionEdge = {
  __typename?: 'Club_WorldFamilyClub_EventBannerRegionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_EventBannerRegion;
};

/** EventBannerRegion */
export type Club_WorldFamilyClub_EventBannerRegionFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_EventBannerRegionFilterInput>>;
  /** ImageFileName */
  imageFileName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_EventBannerRegionFilterInput>>;
  /** [ID] Region */
  region?: InputMaybe<StringOperationFilterInput>;
  /** RegionMainNo */
  regionMainNo?: InputMaybe<StringOperationFilterInput>;
  /** UtcCdt */
  utcCdt?: InputMaybe<DateTimeOperationFilterInput>;
  /** UtcUdt */
  utcUdt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** EventBannerRegion */
export type Club_WorldFamilyClub_EventBannerRegionInput = {
  /** ImageFileName */
  imageFileName?: InputMaybe<Scalars['String']['input']>;
  /** [ID] Region */
  region?: InputMaybe<Scalars['String']['input']>;
  /** RegionMainNo */
  regionMainNo?: InputMaybe<Scalars['String']['input']>;
  /** UtcCdt */
  utcCdt?: InputMaybe<Scalars['DateTime']['input']>;
  /** UtcUdt */
  utcUdt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** EventBannerRegion */
export type Club_WorldFamilyClub_EventBannerRegionSortInput = {
  /** ImageFileName */
  imageFileName?: InputMaybe<SortEnumType>;
  /** [ID] Region */
  region?: InputMaybe<SortEnumType>;
  /** RegionMainNo */
  regionMainNo?: InputMaybe<SortEnumType>;
  /** UtcCdt */
  utcCdt?: InputMaybe<SortEnumType>;
  /** UtcUdt */
  utcUdt?: InputMaybe<SortEnumType>;
};

/** EventBanner */
export type Club_WorldFamilyClub_EventBannerSortInput = {
  /** DisabledFlag */
  disabledFlag?: InputMaybe<SortEnumType>;
  /** ImageFileName */
  imageFileName?: InputMaybe<SortEnumType>;
  /** [ID] Seq */
  seq?: InputMaybe<SortEnumType>;
  /** TextContent */
  textContent?: InputMaybe<SortEnumType>;
  /** TypeNo */
  typeNo?: InputMaybe<SortEnumType>;
  /** UtcCdt */
  utcCdt?: InputMaybe<SortEnumType>;
  /** UtcUdt */
  utcUdt?: InputMaybe<SortEnumType>;
};

/** EventCheckInAuth */
export type Club_WorldFamilyClub_EventCheckInAuth = Node & {
  __typename?: 'Club_WorldFamilyClub_EventCheckInAuth';
  /** DeviceId */
  deviceId?: Maybe<Scalars['String']['output']>;
  /** [ID] Region */
  id: Scalars['ID']['output'];
  /** SmsCode */
  smsCode?: Maybe<Scalars['String']['output']>;
  /** UserId */
  userId?: Maybe<Scalars['String']['output']>;
  /** UtcCdt */
  utcCdt?: Maybe<Scalars['DateTime']['output']>;
  /** Verified */
  verified?: Maybe<Scalars['Boolean']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_EventCheckInAuthConnection = {
  __typename?: 'Club_WorldFamilyClub_EventCheckInAuthConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_EventCheckInAuthEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_EventCheckInAuth>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_EventCheckInAuthEdge = {
  __typename?: 'Club_WorldFamilyClub_EventCheckInAuthEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_EventCheckInAuth;
};

/** EventCheckInAuth */
export type Club_WorldFamilyClub_EventCheckInAuthFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_EventCheckInAuthFilterInput>>;
  /** DeviceId */
  deviceId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_EventCheckInAuthFilterInput>>;
  /** [ID] Region */
  region?: InputMaybe<StringOperationFilterInput>;
  /** SmsCode */
  smsCode?: InputMaybe<StringOperationFilterInput>;
  /** UserId */
  userId?: InputMaybe<StringOperationFilterInput>;
  /** UtcCdt */
  utcCdt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Verified */
  verified?: InputMaybe<BooleanOperationFilterInput>;
};

/** EventCheckInAuth */
export type Club_WorldFamilyClub_EventCheckInAuthInput = {
  /** DeviceId */
  deviceId?: InputMaybe<Scalars['String']['input']>;
  /** [ID] Region */
  region?: InputMaybe<Scalars['String']['input']>;
  /** SmsCode */
  smsCode?: InputMaybe<Scalars['String']['input']>;
  /** UserId */
  userId?: InputMaybe<Scalars['String']['input']>;
  /** UtcCdt */
  utcCdt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Verified */
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

/** EventCheckInAuth */
export type Club_WorldFamilyClub_EventCheckInAuthSortInput = {
  /** DeviceId */
  deviceId?: InputMaybe<SortEnumType>;
  /** [ID] Region */
  region?: InputMaybe<SortEnumType>;
  /** SmsCode */
  smsCode?: InputMaybe<SortEnumType>;
  /** UserId */
  userId?: InputMaybe<SortEnumType>;
  /** UtcCdt */
  utcCdt?: InputMaybe<SortEnumType>;
  /** Verified */
  verified?: InputMaybe<SortEnumType>;
};

/** EventNotificationLog */
export type Club_WorldFamilyClub_EventNotificationLog = Node & {
  __typename?: 'Club_WorldFamilyClub_EventNotificationLog';
  /** BookingId */
  bookingId?: Maybe<Scalars['String']['output']>;
  /** EventType */
  eventType?: Maybe<Scalars['String']['output']>;
  /** [ID] SeqNo */
  id: Scalars['ID']['output'];
  /** MemberNo */
  memberNo?: Maybe<Scalars['String']['output']>;
  /** NoticeType */
  noticeType?: Maybe<Scalars['String']['output']>;
  /** Region */
  region?: Maybe<Scalars['String']['output']>;
  /** UtcCdt */
  utcCdt?: Maybe<Scalars['DateTime']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_EventNotificationLogConnection = {
  __typename?: 'Club_WorldFamilyClub_EventNotificationLogConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_EventNotificationLogEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_EventNotificationLog>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_EventNotificationLogEdge = {
  __typename?: 'Club_WorldFamilyClub_EventNotificationLogEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_EventNotificationLog;
};

/** EventNotificationLog */
export type Club_WorldFamilyClub_EventNotificationLogFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_EventNotificationLogFilterInput>>;
  /** BookingId */
  bookingId?: InputMaybe<StringOperationFilterInput>;
  /** EventType */
  eventType?: InputMaybe<StringOperationFilterInput>;
  /** MemberNo */
  memberNo?: InputMaybe<StringOperationFilterInput>;
  /** NoticeType */
  noticeType?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_EventNotificationLogFilterInput>>;
  /** Region */
  region?: InputMaybe<StringOperationFilterInput>;
  /** [ID] SeqNo */
  seqNo?: InputMaybe<IntOperationFilterInput>;
  /** UtcCdt */
  utcCdt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** EventNotificationLog */
export type Club_WorldFamilyClub_EventNotificationLogInput = {
  /** BookingId */
  bookingId?: InputMaybe<Scalars['String']['input']>;
  /** EventType */
  eventType?: InputMaybe<Scalars['String']['input']>;
  /** MemberNo */
  memberNo?: InputMaybe<Scalars['String']['input']>;
  /** NoticeType */
  noticeType?: InputMaybe<Scalars['String']['input']>;
  /** Region */
  region?: InputMaybe<Scalars['String']['input']>;
  /** [ID] SeqNo */
  seqNo?: InputMaybe<Scalars['Int']['input']>;
  /** UtcCdt */
  utcCdt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** EventNotificationLog */
export type Club_WorldFamilyClub_EventNotificationLogSortInput = {
  /** BookingId */
  bookingId?: InputMaybe<SortEnumType>;
  /** EventType */
  eventType?: InputMaybe<SortEnumType>;
  /** MemberNo */
  memberNo?: InputMaybe<SortEnumType>;
  /** NoticeType */
  noticeType?: InputMaybe<SortEnumType>;
  /** Region */
  region?: InputMaybe<SortEnumType>;
  /** [ID] SeqNo */
  seqNo?: InputMaybe<SortEnumType>;
  /** UtcCdt */
  utcCdt?: InputMaybe<SortEnumType>;
};

/** EventPromotion */
export type Club_WorldFamilyClub_EventPromotion = Node & {
  __typename?: 'Club_WorldFamilyClub_EventPromotion';
  /** CreatedTime */
  createdTime?: Maybe<Scalars['DateTime']['output']>;
  /** [NOT NULL] Creator */
  creator?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] EventEndDate */
  eventEndDate?: Maybe<Scalars['DateTime']['output']>;
  /** [NOT NULL] EventStartDate */
  eventStartDate?: Maybe<Scalars['DateTime']['output']>;
  /** [NOT NULL] EventSubType */
  eventSubType?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] EventSubTypeName */
  eventSubTypeName?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] EventThumbnail */
  eventThumbnail?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] EventTopicCode */
  eventTopicCode?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] EventTopicName */
  eventTopicName?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] EventType */
  eventType?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] EventTypeName */
  eventTypeName?: Maybe<Scalars['String']['output']>;
  /** [ID] EventPromotionId */
  id: Scalars['ID']['output'];
  /** [NOT NULL] IsPublished */
  isPublished?: Maybe<Scalars['Boolean']['output']>;
  /** [NOT NULL] Market */
  market?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] SortOrder */
  sortOrder?: Maybe<Scalars['Int']['output']>;
  /** UpdatedTime */
  updatedTime?: Maybe<Scalars['DateTime']['output']>;
  /** [NOT NULL] Updater */
  updater?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_EventPromotionConnection = {
  __typename?: 'Club_WorldFamilyClub_EventPromotionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_EventPromotionEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_EventPromotion>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_EventPromotionEdge = {
  __typename?: 'Club_WorldFamilyClub_EventPromotionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_EventPromotion;
};

/** EventPromotion */
export type Club_WorldFamilyClub_EventPromotionFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_EventPromotionFilterInput>>;
  /** CreatedTime */
  createdTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** [NOT NULL] Creator */
  creator?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] EventEndDate */
  eventEndDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** [ID] EventPromotionId */
  eventPromotionId?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] EventStartDate */
  eventStartDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** [NOT NULL] EventSubType */
  eventSubType?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] EventSubTypeName */
  eventSubTypeName?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] EventThumbnail */
  eventThumbnail?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] EventTopicCode */
  eventTopicCode?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] EventTopicName */
  eventTopicName?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] EventType */
  eventType?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] EventTypeName */
  eventTypeName?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] IsPublished */
  isPublished?: InputMaybe<BooleanOperationFilterInput>;
  /** [NOT NULL] Market */
  market?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_EventPromotionFilterInput>>;
  /** [NOT NULL] SortOrder */
  sortOrder?: InputMaybe<IntOperationFilterInput>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** [NOT NULL] Updater */
  updater?: InputMaybe<StringOperationFilterInput>;
};

/** EventPromotion */
export type Club_WorldFamilyClub_EventPromotionInput = {
  /** CreatedTime */
  createdTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** [NOT NULL] Creator */
  creator?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] EventEndDate */
  eventEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** [ID] EventPromotionId */
  eventPromotionId?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] EventStartDate */
  eventStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** [NOT NULL] EventSubType */
  eventSubType?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] EventSubTypeName */
  eventSubTypeName?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] EventThumbnail */
  eventThumbnail?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] EventTopicCode */
  eventTopicCode?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] EventTopicName */
  eventTopicName?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] EventType */
  eventType?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] EventTypeName */
  eventTypeName?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] IsPublished */
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  /** [NOT NULL] Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] SortOrder */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** [NOT NULL] Updater */
  updater?: InputMaybe<Scalars['String']['input']>;
};

/** EventPromotion */
export type Club_WorldFamilyClub_EventPromotionSortInput = {
  /** CreatedTime */
  createdTime?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Creator */
  creator?: InputMaybe<SortEnumType>;
  /** [NOT NULL] EventEndDate */
  eventEndDate?: InputMaybe<SortEnumType>;
  /** [ID] EventPromotionId */
  eventPromotionId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] EventStartDate */
  eventStartDate?: InputMaybe<SortEnumType>;
  /** [NOT NULL] EventSubType */
  eventSubType?: InputMaybe<SortEnumType>;
  /** [NOT NULL] EventSubTypeName */
  eventSubTypeName?: InputMaybe<SortEnumType>;
  /** [NOT NULL] EventThumbnail */
  eventThumbnail?: InputMaybe<SortEnumType>;
  /** [NOT NULL] EventTopicCode */
  eventTopicCode?: InputMaybe<SortEnumType>;
  /** [NOT NULL] EventTopicName */
  eventTopicName?: InputMaybe<SortEnumType>;
  /** [NOT NULL] EventType */
  eventType?: InputMaybe<SortEnumType>;
  /** [NOT NULL] EventTypeName */
  eventTypeName?: InputMaybe<SortEnumType>;
  /** [NOT NULL] IsPublished */
  isPublished?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Market */
  market?: InputMaybe<SortEnumType>;
  /** [NOT NULL] SortOrder */
  sortOrder?: InputMaybe<SortEnumType>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Updater */
  updater?: InputMaybe<SortEnumType>;
};

/** EventSeat */
export type Club_WorldFamilyClub_EventSeat = Node & {
  __typename?: 'Club_WorldFamilyClub_EventSeat';
  /** Area */
  area?: Maybe<Scalars['String']['output']>;
  /** Cdt */
  cdt?: Maybe<Scalars['DateTime']['output']>;
  /** Col */
  col?: Maybe<Scalars['Short']['output']>;
  /** DeviceId */
  deviceId?: Maybe<Scalars['String']['output']>;
  /** EventNo */
  eventNo?: Maybe<Scalars['String']['output']>;
  /** Floor */
  floor?: Maybe<Scalars['Short']['output']>;
  /** [ID] Seq */
  id: Scalars['ID']['output'];
  /** MemberNo */
  memberNo?: Maybe<Scalars['String']['output']>;
  /** Row */
  row?: Maybe<Scalars['Short']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_EventSeatConnection = {
  __typename?: 'Club_WorldFamilyClub_EventSeatConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_EventSeatEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_EventSeat>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_EventSeatEdge = {
  __typename?: 'Club_WorldFamilyClub_EventSeatEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_EventSeat;
};

/** EventSeat */
export type Club_WorldFamilyClub_EventSeatFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_EventSeatFilterInput>>;
  /** Area */
  area?: InputMaybe<StringOperationFilterInput>;
  /** Cdt */
  cdt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Col */
  col?: InputMaybe<ShortOperationFilterInput>;
  /** DeviceId */
  deviceId?: InputMaybe<StringOperationFilterInput>;
  /** EventNo */
  eventNo?: InputMaybe<StringOperationFilterInput>;
  /** Floor */
  floor?: InputMaybe<ShortOperationFilterInput>;
  /** MemberNo */
  memberNo?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_EventSeatFilterInput>>;
  /** Row */
  row?: InputMaybe<ShortOperationFilterInput>;
  /** [ID] Seq */
  seq?: InputMaybe<IntOperationFilterInput>;
};

/** EventSeat */
export type Club_WorldFamilyClub_EventSeatInput = {
  /** Area */
  area?: InputMaybe<Scalars['String']['input']>;
  /** Cdt */
  cdt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Col */
  col?: InputMaybe<Scalars['Short']['input']>;
  /** DeviceId */
  deviceId?: InputMaybe<Scalars['String']['input']>;
  /** EventNo */
  eventNo?: InputMaybe<Scalars['String']['input']>;
  /** Floor */
  floor?: InputMaybe<Scalars['Short']['input']>;
  /** MemberNo */
  memberNo?: InputMaybe<Scalars['String']['input']>;
  /** Row */
  row?: InputMaybe<Scalars['Short']['input']>;
  /** [ID] Seq */
  seq?: InputMaybe<Scalars['Int']['input']>;
};

/** EventSeat */
export type Club_WorldFamilyClub_EventSeatSortInput = {
  /** Area */
  area?: InputMaybe<SortEnumType>;
  /** Cdt */
  cdt?: InputMaybe<SortEnumType>;
  /** Col */
  col?: InputMaybe<SortEnumType>;
  /** DeviceId */
  deviceId?: InputMaybe<SortEnumType>;
  /** EventNo */
  eventNo?: InputMaybe<SortEnumType>;
  /** Floor */
  floor?: InputMaybe<SortEnumType>;
  /** MemberNo */
  memberNo?: InputMaybe<SortEnumType>;
  /** Row */
  row?: InputMaybe<SortEnumType>;
  /** [ID] Seq */
  seq?: InputMaybe<SortEnumType>;
};

/** EventType */
export type Club_WorldFamilyClub_EventType = Node & {
  __typename?: 'Club_WorldFamilyClub_EventType';
  /** [ID] TypeNo */
  id: Scalars['ID']['output'];
  /** SortBy */
  sortBy?: Maybe<Scalars['Short']['output']>;
  /** SubTypeCalendarColor */
  subTypeCalendarColor?: Maybe<Scalars['String']['output']>;
  /** SubTypes */
  subTypes?: Maybe<Scalars['String']['output']>;
  /** TypeChineseName */
  typeChineseName?: Maybe<Scalars['String']['output']>;
  /** TypeEnglishName */
  typeEnglishName?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_EventTypeConnection = {
  __typename?: 'Club_WorldFamilyClub_EventTypeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_EventTypeEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_EventType>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_EventTypeEdge = {
  __typename?: 'Club_WorldFamilyClub_EventTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_EventType;
};

/** EventType */
export type Club_WorldFamilyClub_EventTypeFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_EventTypeFilterInput>>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_EventTypeFilterInput>>;
  /** SortBy */
  sortBy?: InputMaybe<ShortOperationFilterInput>;
  /** SubTypeCalendarColor */
  subTypeCalendarColor?: InputMaybe<StringOperationFilterInput>;
  /** SubTypes */
  subTypes?: InputMaybe<StringOperationFilterInput>;
  /** TypeChineseName */
  typeChineseName?: InputMaybe<StringOperationFilterInput>;
  /** TypeEnglishName */
  typeEnglishName?: InputMaybe<StringOperationFilterInput>;
  /** [ID] TypeNo */
  typeNo?: InputMaybe<StringOperationFilterInput>;
};

/** EventType */
export type Club_WorldFamilyClub_EventTypeInput = {
  /** SortBy */
  sortBy?: InputMaybe<Scalars['Short']['input']>;
  /** SubTypeCalendarColor */
  subTypeCalendarColor?: InputMaybe<Scalars['String']['input']>;
  /** SubTypes */
  subTypes?: InputMaybe<Scalars['String']['input']>;
  /** TypeChineseName */
  typeChineseName?: InputMaybe<Scalars['String']['input']>;
  /** TypeEnglishName */
  typeEnglishName?: InputMaybe<Scalars['String']['input']>;
  /** [ID] TypeNo */
  typeNo?: InputMaybe<Scalars['String']['input']>;
};

/** EventType */
export type Club_WorldFamilyClub_EventTypeSortInput = {
  /** SortBy */
  sortBy?: InputMaybe<SortEnumType>;
  /** SubTypeCalendarColor */
  subTypeCalendarColor?: InputMaybe<SortEnumType>;
  /** SubTypes */
  subTypes?: InputMaybe<SortEnumType>;
  /** TypeChineseName */
  typeChineseName?: InputMaybe<SortEnumType>;
  /** TypeEnglishName */
  typeEnglishName?: InputMaybe<SortEnumType>;
  /** [ID] TypeNo */
  typeNo?: InputMaybe<SortEnumType>;
};

/** ExchangeApplication */
export type Club_WorldFamilyClub_ExchangeApplication = Node & {
  __typename?: 'Club_WorldFamilyClub_ExchangeApplication';
  /** ApplicationNo */
  applicationNo?: Maybe<Scalars['String']['output']>;
  /** CreatedTime */
  createdTime?: Maybe<Scalars['DateTime']['output']>;
  /** [ID] ApplicationId */
  id: Scalars['ID']['output'];
  /** Market */
  market?: Maybe<Scalars['String']['output']>;
  /** MemberNo */
  memberNo?: Maybe<Scalars['String']['output']>;
  /** Status */
  status?: Maybe<Scalars['String']['output']>;
  /** StatusUpdateDate */
  statusUpdateDate?: Maybe<Scalars['DateTime']['output']>;
  /** UpdatedBy */
  updatedBy?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_ExchangeApplicationConnection = {
  __typename?: 'Club_WorldFamilyClub_ExchangeApplicationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_ExchangeApplicationEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_ExchangeApplication>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_ExchangeApplicationEdge = {
  __typename?: 'Club_WorldFamilyClub_ExchangeApplicationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_ExchangeApplication;
};

/** ExchangeApplication */
export type Club_WorldFamilyClub_ExchangeApplicationFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_ExchangeApplicationFilterInput>>;
  /** [ID] ApplicationId */
  applicationId?: InputMaybe<LongOperationFilterInput>;
  /** ApplicationNo */
  applicationNo?: InputMaybe<StringOperationFilterInput>;
  /** CreatedTime */
  createdTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** Market */
  market?: InputMaybe<StringOperationFilterInput>;
  /** MemberNo */
  memberNo?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_ExchangeApplicationFilterInput>>;
  /** Status */
  status?: InputMaybe<StringOperationFilterInput>;
  /** StatusUpdateDate */
  statusUpdateDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** UpdatedBy */
  updatedBy?: InputMaybe<StringOperationFilterInput>;
};

/** ExchangeApplication */
export type Club_WorldFamilyClub_ExchangeApplicationInput = {
  /** [ID] ApplicationId */
  applicationId?: InputMaybe<Scalars['Long']['input']>;
  /** ApplicationNo */
  applicationNo?: InputMaybe<Scalars['String']['input']>;
  /** CreatedTime */
  createdTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** MemberNo */
  memberNo?: InputMaybe<Scalars['String']['input']>;
  /** Status */
  status?: InputMaybe<Scalars['String']['input']>;
  /** StatusUpdateDate */
  statusUpdateDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** UpdatedBy */
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

/** ExchangeApplicationItem */
export type Club_WorldFamilyClub_ExchangeApplicationItem = Node & {
  __typename?: 'Club_WorldFamilyClub_ExchangeApplicationItem';
  /** [NOT NULL] ApplicationId */
  applicationId?: Maybe<Scalars['Long']['output']>;
  /** [ID] ApplicationItemId */
  id: Scalars['ID']['output'];
  /** ProductId */
  productId?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Qty */
  qty?: Maybe<Scalars['Int']['output']>;
  /** ReasonId */
  reasonId?: Maybe<Scalars['String']['output']>;
  /** ReasonMemo */
  reasonMemo?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_ExchangeApplicationItemConnection = {
  __typename?: 'Club_WorldFamilyClub_ExchangeApplicationItemConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_ExchangeApplicationItemEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_ExchangeApplicationItem>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_ExchangeApplicationItemEdge = {
  __typename?: 'Club_WorldFamilyClub_ExchangeApplicationItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_ExchangeApplicationItem;
};

/** ExchangeApplicationItem */
export type Club_WorldFamilyClub_ExchangeApplicationItemFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_ExchangeApplicationItemFilterInput>>;
  /** [NOT NULL] ApplicationId */
  applicationId?: InputMaybe<LongOperationFilterInput>;
  /** [ID] ApplicationItemId */
  applicationItemId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_ExchangeApplicationItemFilterInput>>;
  /** ProductId */
  productId?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] Qty */
  qty?: InputMaybe<IntOperationFilterInput>;
  /** ReasonId */
  reasonId?: InputMaybe<StringOperationFilterInput>;
  /** ReasonMemo */
  reasonMemo?: InputMaybe<StringOperationFilterInput>;
};

/** ExchangeApplicationItem */
export type Club_WorldFamilyClub_ExchangeApplicationItemInput = {
  /** [NOT NULL] ApplicationId */
  applicationId?: InputMaybe<Scalars['Long']['input']>;
  /** [ID] ApplicationItemId */
  applicationItemId?: InputMaybe<Scalars['Long']['input']>;
  /** ProductId */
  productId?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Qty */
  qty?: InputMaybe<Scalars['Int']['input']>;
  /** ReasonId */
  reasonId?: InputMaybe<Scalars['String']['input']>;
  /** ReasonMemo */
  reasonMemo?: InputMaybe<Scalars['String']['input']>;
};

/** ExchangeApplicationItem */
export type Club_WorldFamilyClub_ExchangeApplicationItemSortInput = {
  /** [NOT NULL] ApplicationId */
  applicationId?: InputMaybe<SortEnumType>;
  /** [ID] ApplicationItemId */
  applicationItemId?: InputMaybe<SortEnumType>;
  /** ProductId */
  productId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Qty */
  qty?: InputMaybe<SortEnumType>;
  /** ReasonId */
  reasonId?: InputMaybe<SortEnumType>;
  /** ReasonMemo */
  reasonMemo?: InputMaybe<SortEnumType>;
};

/** ExchangeApplication */
export type Club_WorldFamilyClub_ExchangeApplicationSortInput = {
  /** [ID] ApplicationId */
  applicationId?: InputMaybe<SortEnumType>;
  /** ApplicationNo */
  applicationNo?: InputMaybe<SortEnumType>;
  /** CreatedTime */
  createdTime?: InputMaybe<SortEnumType>;
  /** Market */
  market?: InputMaybe<SortEnumType>;
  /** MemberNo */
  memberNo?: InputMaybe<SortEnumType>;
  /** Status */
  status?: InputMaybe<SortEnumType>;
  /** StatusUpdateDate */
  statusUpdateDate?: InputMaybe<SortEnumType>;
  /** UpdatedBy */
  updatedBy?: InputMaybe<SortEnumType>;
};

/** ExchangeReason */
export type Club_WorldFamilyClub_ExchangeReason = Node & {
  __typename?: 'Club_WorldFamilyClub_ExchangeReason';
  /** [ID] ReasonId */
  id: Scalars['ID']['output'];
  /** IsActive */
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /** ReasonText */
  reasonText?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] SortOrder */
  sortOrder?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_ExchangeReasonConnection = {
  __typename?: 'Club_WorldFamilyClub_ExchangeReasonConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_ExchangeReasonEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_ExchangeReason>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_ExchangeReasonEdge = {
  __typename?: 'Club_WorldFamilyClub_ExchangeReasonEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_ExchangeReason;
};

/** ExchangeReason */
export type Club_WorldFamilyClub_ExchangeReasonFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_ExchangeReasonFilterInput>>;
  /** IsActive */
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_ExchangeReasonFilterInput>>;
  /** [ID] ReasonId */
  reasonId?: InputMaybe<StringOperationFilterInput>;
  /** ReasonText */
  reasonText?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] SortOrder */
  sortOrder?: InputMaybe<IntOperationFilterInput>;
};

/** ExchangeReason */
export type Club_WorldFamilyClub_ExchangeReasonInput = {
  /** IsActive */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** [ID] ReasonId */
  reasonId?: InputMaybe<Scalars['String']['input']>;
  /** ReasonText */
  reasonText?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] SortOrder */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/** ExchangeReason */
export type Club_WorldFamilyClub_ExchangeReasonSortInput = {
  /** IsActive */
  isActive?: InputMaybe<SortEnumType>;
  /** [ID] ReasonId */
  reasonId?: InputMaybe<SortEnumType>;
  /** ReasonText */
  reasonText?: InputMaybe<SortEnumType>;
  /** [NOT NULL] SortOrder */
  sortOrder?: InputMaybe<SortEnumType>;
};

/** ExchangeReasonTranslation */
export type Club_WorldFamilyClub_ExchangeReasonTranslation = Node & {
  __typename?: 'Club_WorldFamilyClub_ExchangeReasonTranslation';
  /** [ID] ReasonTranslationId */
  id: Scalars['ID']['output'];
  /** Market */
  market?: Maybe<Scalars['String']['output']>;
  /** ReasonId */
  reasonId?: Maybe<Scalars['String']['output']>;
  /** ReasonText */
  reasonText?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_ExchangeReasonTranslationConnection = {
  __typename?: 'Club_WorldFamilyClub_ExchangeReasonTranslationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_ExchangeReasonTranslationEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_ExchangeReasonTranslation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_ExchangeReasonTranslationEdge = {
  __typename?: 'Club_WorldFamilyClub_ExchangeReasonTranslationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_ExchangeReasonTranslation;
};

/** ExchangeReasonTranslation */
export type Club_WorldFamilyClub_ExchangeReasonTranslationFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_ExchangeReasonTranslationFilterInput>>;
  /** Market */
  market?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_ExchangeReasonTranslationFilterInput>>;
  /** ReasonId */
  reasonId?: InputMaybe<StringOperationFilterInput>;
  /** ReasonText */
  reasonText?: InputMaybe<StringOperationFilterInput>;
  /** [ID] ReasonTranslationId */
  reasonTranslationId?: InputMaybe<IntOperationFilterInput>;
};

/** ExchangeReasonTranslation */
export type Club_WorldFamilyClub_ExchangeReasonTranslationInput = {
  /** Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** ReasonId */
  reasonId?: InputMaybe<Scalars['String']['input']>;
  /** ReasonText */
  reasonText?: InputMaybe<Scalars['String']['input']>;
  /** [ID] ReasonTranslationId */
  reasonTranslationId?: InputMaybe<Scalars['Int']['input']>;
};

/** ExchangeReasonTranslation */
export type Club_WorldFamilyClub_ExchangeReasonTranslationSortInput = {
  /** Market */
  market?: InputMaybe<SortEnumType>;
  /** ReasonId */
  reasonId?: InputMaybe<SortEnumType>;
  /** ReasonText */
  reasonText?: InputMaybe<SortEnumType>;
  /** [ID] ReasonTranslationId */
  reasonTranslationId?: InputMaybe<SortEnumType>;
};

/** FaceCallAndTelephoneEnglish */
export type Club_WorldFamilyClub_FaceCallAndTelephoneEnglish = Node & {
  __typename?: 'Club_WorldFamilyClub_FaceCallAndTelephoneEnglish';
  /** [NOT NULL] ActiveMembers */
  activeMembers?: Maybe<Scalars['Int']['output']>;
  /** [NOT NULL] BroadCastMembers */
  broadCastMembers?: Maybe<Scalars['Int']['output']>;
  /** [NOT NULL] CapMembers */
  capMembers?: Maybe<Scalars['Int']['output']>;
  /** [NOT NULL] ClubAppUsers */
  clubAppUsers?: Maybe<Scalars['Int']['output']>;
  /** [NOT NULL] DisneyLibraryMembers */
  disneyLibraryMembers?: Maybe<Scalars['Int']['output']>;
  /** [NOT NULL] EventMembers */
  eventMembers?: Maybe<Scalars['Int']['output']>;
  /** [NOT NULL] FacecallMembers */
  facecallMembers?: Maybe<Scalars['Int']['output']>;
  /** [NOT NULL] FacecallTypeMembers */
  facecallTypeMembers?: Maybe<Scalars['Int']['output']>;
  /** [NOT NULL] Gglmembers */
  gglmembers?: Maybe<Scalars['Int']['output']>;
  /** [NOT NULL] HighlightsLibraryMembers */
  highlightsLibraryMembers?: Maybe<Scalars['Int']['output']>;
  /** [ID] YearMonth */
  id: Scalars['ID']['output'];
  /** [NOT NULL] Region */
  region?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Temembers */
  temembers?: Maybe<Scalars['Int']['output']>;
  /** [NOT NULL] TetypeMembers */
  tetypeMembers?: Maybe<Scalars['Int']['output']>;
  /** [NOT NULL] VideoMembers */
  videoMembers?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_FaceCallAndTelephoneEnglishConnection = {
  __typename?: 'Club_WorldFamilyClub_FaceCallAndTelephoneEnglishConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_FaceCallAndTelephoneEnglishEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_FaceCallAndTelephoneEnglish>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_FaceCallAndTelephoneEnglishEdge = {
  __typename?: 'Club_WorldFamilyClub_FaceCallAndTelephoneEnglishEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_FaceCallAndTelephoneEnglish;
};

/** FaceCallAndTelephoneEnglish */
export type Club_WorldFamilyClub_FaceCallAndTelephoneEnglishFilterInput = {
  /** [NOT NULL] ActiveMembers */
  activeMembers?: InputMaybe<IntOperationFilterInput>;
  and?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallAndTelephoneEnglishFilterInput>>;
  /** [NOT NULL] BroadCastMembers */
  broadCastMembers?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] CapMembers */
  capMembers?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] ClubAppUsers */
  clubAppUsers?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] DisneyLibraryMembers */
  disneyLibraryMembers?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] EventMembers */
  eventMembers?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] FacecallMembers */
  facecallMembers?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] FacecallTypeMembers */
  facecallTypeMembers?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] Gglmembers */
  gglmembers?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] HighlightsLibraryMembers */
  highlightsLibraryMembers?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallAndTelephoneEnglishFilterInput>>;
  /** [NOT NULL] Region */
  region?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] Temembers */
  temembers?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] TetypeMembers */
  tetypeMembers?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] VideoMembers */
  videoMembers?: InputMaybe<IntOperationFilterInput>;
  /** [ID] YearMonth */
  yearMonth?: InputMaybe<StringOperationFilterInput>;
};

/** FaceCallAndTelephoneEnglish */
export type Club_WorldFamilyClub_FaceCallAndTelephoneEnglishInput = {
  /** [NOT NULL] ActiveMembers */
  activeMembers?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] BroadCastMembers */
  broadCastMembers?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] CapMembers */
  capMembers?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] ClubAppUsers */
  clubAppUsers?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] DisneyLibraryMembers */
  disneyLibraryMembers?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] EventMembers */
  eventMembers?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] FacecallMembers */
  facecallMembers?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] FacecallTypeMembers */
  facecallTypeMembers?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] Gglmembers */
  gglmembers?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] HighlightsLibraryMembers */
  highlightsLibraryMembers?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] Region */
  region?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Temembers */
  temembers?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] TetypeMembers */
  tetypeMembers?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] VideoMembers */
  videoMembers?: InputMaybe<Scalars['Int']['input']>;
  /** [ID] YearMonth */
  yearMonth?: InputMaybe<Scalars['String']['input']>;
};

/** FaceCallAndTelephoneEnglish */
export type Club_WorldFamilyClub_FaceCallAndTelephoneEnglishSortInput = {
  /** [NOT NULL] ActiveMembers */
  activeMembers?: InputMaybe<SortEnumType>;
  /** [NOT NULL] BroadCastMembers */
  broadCastMembers?: InputMaybe<SortEnumType>;
  /** [NOT NULL] CapMembers */
  capMembers?: InputMaybe<SortEnumType>;
  /** [NOT NULL] ClubAppUsers */
  clubAppUsers?: InputMaybe<SortEnumType>;
  /** [NOT NULL] DisneyLibraryMembers */
  disneyLibraryMembers?: InputMaybe<SortEnumType>;
  /** [NOT NULL] EventMembers */
  eventMembers?: InputMaybe<SortEnumType>;
  /** [NOT NULL] FacecallMembers */
  facecallMembers?: InputMaybe<SortEnumType>;
  /** [NOT NULL] FacecallTypeMembers */
  facecallTypeMembers?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Gglmembers */
  gglmembers?: InputMaybe<SortEnumType>;
  /** [NOT NULL] HighlightsLibraryMembers */
  highlightsLibraryMembers?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Region */
  region?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Temembers */
  temembers?: InputMaybe<SortEnumType>;
  /** [NOT NULL] TetypeMembers */
  tetypeMembers?: InputMaybe<SortEnumType>;
  /** [NOT NULL] VideoMembers */
  videoMembers?: InputMaybe<SortEnumType>;
  /** [ID] YearMonth */
  yearMonth?: InputMaybe<SortEnumType>;
};

/** FaceCallForTrialmode */
export type Club_WorldFamilyClub_FaceCallForTrialmode = Node & {
  __typename?: 'Club_WorldFamilyClub_FaceCallForTrialmode';
  /** [NOT NULL] FaceCallSongId */
  faceCallSongId?: Maybe<Scalars['Int']['output']>;
  /** [ID] FaceCallForTrialmodeId */
  id: Scalars['ID']['output'];
  /** Market */
  market?: Maybe<Scalars['String']['output']>;
  /** Segmentation */
  segmentation?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] SortId */
  sortId?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_FaceCallForTrialmodeConnection = {
  __typename?: 'Club_WorldFamilyClub_FaceCallForTrialmodeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_FaceCallForTrialmodeEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_FaceCallForTrialmode>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_FaceCallForTrialmodeEdge = {
  __typename?: 'Club_WorldFamilyClub_FaceCallForTrialmodeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_FaceCallForTrialmode;
};

/** FaceCallForTrialmode */
export type Club_WorldFamilyClub_FaceCallForTrialmodeFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallForTrialmodeFilterInput>>;
  /** [ID] FaceCallForTrialmodeId */
  faceCallForTrialmodeId?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] FaceCallSongId */
  faceCallSongId?: InputMaybe<IntOperationFilterInput>;
  /** Market */
  market?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallForTrialmodeFilterInput>>;
  /** Segmentation */
  segmentation?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] SortId */
  sortId?: InputMaybe<IntOperationFilterInput>;
};

/** FaceCallForTrialmode */
export type Club_WorldFamilyClub_FaceCallForTrialmodeInput = {
  /** [ID] FaceCallForTrialmodeId */
  faceCallForTrialmodeId?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] FaceCallSongId */
  faceCallSongId?: InputMaybe<Scalars['Int']['input']>;
  /** Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** Segmentation */
  segmentation?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] SortId */
  sortId?: InputMaybe<Scalars['Int']['input']>;
};

/** FaceCallForTrialmode */
export type Club_WorldFamilyClub_FaceCallForTrialmodeSortInput = {
  /** [ID] FaceCallForTrialmodeId */
  faceCallForTrialmodeId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] FaceCallSongId */
  faceCallSongId?: InputMaybe<SortEnumType>;
  /** Market */
  market?: InputMaybe<SortEnumType>;
  /** Segmentation */
  segmentation?: InputMaybe<SortEnumType>;
  /** [NOT NULL] SortId */
  sortId?: InputMaybe<SortEnumType>;
};

/** FaceCallHist */
export type Club_WorldFamilyClub_FaceCallHist = Node & {
  __typename?: 'Club_WorldFamilyClub_FaceCallHist';
  /** CreatedTime */
  createdTime?: Maybe<Scalars['DateTime']['output']>;
  /** [NAVIGATION] FaceCallHistCount */
  faceCallHistCount?: Maybe<Club_WorldFamilyClub_FaceCallHistCount>;
  /** FaceCallHistCountId */
  faceCallHistCountId?: Maybe<Scalars['Long']['output']>;
  /** [NAVIGATION] FaceCallSong */
  faceCallSong?: Maybe<Club_WorldFamilyClub_FaceCallSong>;
  /** [NOT NULL] FaceCallSongId */
  faceCallSongId?: Maybe<Scalars['Int']['output']>;
  /** [NAVIGATION] FaceCallSongPublic */
  faceCallSongPublic?: Maybe<Club_WorldFamilyClub_FaceCallSongPublic>;
  /** [NOT NULL] FaceCallSongPublicId */
  faceCallSongPublicId?: Maybe<Scalars['Int']['output']>;
  /** [ID] FaceCallHistId */
  id: Scalars['ID']['output'];
  /** [NOT NULL] MemberNumber */
  memberNumber?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_FaceCallHistConnection = {
  __typename?: 'Club_WorldFamilyClub_FaceCallHistConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_FaceCallHistEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_FaceCallHist>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** FaceCallHistCount */
export type Club_WorldFamilyClub_FaceCallHistCount = Node & {
  __typename?: 'Club_WorldFamilyClub_FaceCallHistCount';
  /** [NOT NULL] Count */
  count?: Maybe<Scalars['Int']['output']>;
  /** [NOT NULL] Date */
  date?: Maybe<Scalars['DateTime']['output']>;
  /** [COLLECTION] FaceCallHists */
  faceCallHists?: Maybe<Array<Maybe<Club_WorldFamilyClub_FaceCallHist>>>;
  /** [ID] FaceCallHistCountId */
  id: Scalars['ID']['output'];
  /** [NOT NULL] MemberNumber */
  memberNumber?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_FaceCallHistCountConnection = {
  __typename?: 'Club_WorldFamilyClub_FaceCallHistCountConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_FaceCallHistCountEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_FaceCallHistCount>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_FaceCallHistCountEdge = {
  __typename?: 'Club_WorldFamilyClub_FaceCallHistCountEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_FaceCallHistCount;
};

/** FaceCallHistCount */
export type Club_WorldFamilyClub_FaceCallHistCountFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallHistCountFilterInput>>;
  /** [NOT NULL] Count */
  count?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] Date */
  date?: InputMaybe<DateTimeOperationFilterInput>;
  /** [ID] FaceCallHistCountId */
  faceCallHistCountId?: InputMaybe<LongOperationFilterInput>;
  /** [COLLECTION] FaceCallHists */
  faceCallHists?: InputMaybe<ListFilterInputTypeOfClub_WorldFamilyClub_FaceCallHistFilterInput>;
  /** [NOT NULL] MemberNumber */
  memberNumber?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallHistCountFilterInput>>;
};

/** FaceCallHistCount */
export type Club_WorldFamilyClub_FaceCallHistCountInput = {
  /** [NOT NULL] Count */
  count?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] Date */
  date?: InputMaybe<Scalars['DateTime']['input']>;
  /** [ID] FaceCallHistCountId */
  faceCallHistCountId?: InputMaybe<Scalars['Long']['input']>;
  /** [COLLECTION] FaceCallHists */
  faceCallHists?: InputMaybe<Array<InputMaybe<Club_WorldFamilyClub_FaceCallHistInput>>>;
  /** [NOT NULL] MemberNumber */
  memberNumber?: InputMaybe<Scalars['String']['input']>;
};

/** FaceCallHistCount */
export type Club_WorldFamilyClub_FaceCallHistCountSortInput = {
  /** [NOT NULL] Count */
  count?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Date */
  date?: InputMaybe<SortEnumType>;
  /** [ID] FaceCallHistCountId */
  faceCallHistCountId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] MemberNumber */
  memberNumber?: InputMaybe<SortEnumType>;
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_FaceCallHistEdge = {
  __typename?: 'Club_WorldFamilyClub_FaceCallHistEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_FaceCallHist;
};

/** FaceCallHist */
export type Club_WorldFamilyClub_FaceCallHistFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallHistFilterInput>>;
  /** CreatedTime */
  createdTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** [NAVIGATION] FaceCallHistCount */
  faceCallHistCount?: InputMaybe<Club_WorldFamilyClub_FaceCallHistCountFilterInput>;
  /** FaceCallHistCountId */
  faceCallHistCountId?: InputMaybe<LongOperationFilterInput>;
  /** [ID] FaceCallHistId */
  faceCallHistId?: InputMaybe<LongOperationFilterInput>;
  /** [NAVIGATION] FaceCallSong */
  faceCallSong?: InputMaybe<Club_WorldFamilyClub_FaceCallSongFilterInput>;
  /** [NOT NULL] FaceCallSongId */
  faceCallSongId?: InputMaybe<IntOperationFilterInput>;
  /** [NAVIGATION] FaceCallSongPublic */
  faceCallSongPublic?: InputMaybe<Club_WorldFamilyClub_FaceCallSongPublicFilterInput>;
  /** [NOT NULL] FaceCallSongPublicId */
  faceCallSongPublicId?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] MemberNumber */
  memberNumber?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallHistFilterInput>>;
};

/** FaceCallHist */
export type Club_WorldFamilyClub_FaceCallHistInput = {
  /** CreatedTime */
  createdTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** [NAVIGATION] FaceCallHistCount */
  faceCallHistCount?: InputMaybe<Club_WorldFamilyClub_FaceCallHistCountInput>;
  /** FaceCallHistCountId */
  faceCallHistCountId?: InputMaybe<Scalars['Long']['input']>;
  /** [ID] FaceCallHistId */
  faceCallHistId?: InputMaybe<Scalars['Long']['input']>;
  /** [NAVIGATION] FaceCallSong */
  faceCallSong?: InputMaybe<Club_WorldFamilyClub_FaceCallSongInput>;
  /** [NOT NULL] FaceCallSongId */
  faceCallSongId?: InputMaybe<Scalars['Int']['input']>;
  /** [NAVIGATION] FaceCallSongPublic */
  faceCallSongPublic?: InputMaybe<Club_WorldFamilyClub_FaceCallSongPublicInput>;
  /** [NOT NULL] FaceCallSongPublicId */
  faceCallSongPublicId?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] MemberNumber */
  memberNumber?: InputMaybe<Scalars['String']['input']>;
};

/** FaceCallHist */
export type Club_WorldFamilyClub_FaceCallHistSortInput = {
  /** CreatedTime */
  createdTime?: InputMaybe<SortEnumType>;
  /** [NAVIGATION] FaceCallHistCount */
  faceCallHistCount?: InputMaybe<Club_WorldFamilyClub_FaceCallHistCountSortInput>;
  /** FaceCallHistCountId */
  faceCallHistCountId?: InputMaybe<SortEnumType>;
  /** [ID] FaceCallHistId */
  faceCallHistId?: InputMaybe<SortEnumType>;
  /** [NAVIGATION] FaceCallSong */
  faceCallSong?: InputMaybe<Club_WorldFamilyClub_FaceCallSongSortInput>;
  /** [NOT NULL] FaceCallSongId */
  faceCallSongId?: InputMaybe<SortEnumType>;
  /** [NAVIGATION] FaceCallSongPublic */
  faceCallSongPublic?: InputMaybe<Club_WorldFamilyClub_FaceCallSongPublicSortInput>;
  /** [NOT NULL] FaceCallSongPublicId */
  faceCallSongPublicId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] MemberNumber */
  memberNumber?: InputMaybe<SortEnumType>;
};

/** FaceCallMonthlyRecommend */
export type Club_WorldFamilyClub_FaceCallMonthlyRecommend = Node & {
  __typename?: 'Club_WorldFamilyClub_FaceCallMonthlyRecommend';
  /** CreatedTime */
  createdTime?: Maybe<Scalars['DateTime']['output']>;
  /** Creator */
  creator?: Maybe<Scalars['String']['output']>;
  /** [NAVIGATION] FaceCallSong */
  faceCallSong?: Maybe<Club_WorldFamilyClub_FaceCallSong>;
  /** [NOT NULL] FaceCallSongId */
  faceCallSongId?: Maybe<Scalars['Int']['output']>;
  /** [NAVIGATION] FaceCallSongPublic */
  faceCallSongPublic?: Maybe<Club_WorldFamilyClub_FaceCallSongPublic>;
  /** [NOT NULL] FaceCallSongPublicId */
  faceCallSongPublicId?: Maybe<Scalars['Int']['output']>;
  /** [ID] FaceCallMonthlyRecommendId */
  id: Scalars['ID']['output'];
  /** [NOT NULL] Month */
  month?: Maybe<Scalars['Byte']['output']>;
  /** UpdatedTime */
  updatedTime?: Maybe<Scalars['DateTime']['output']>;
  /** Updater */
  updater?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Year */
  year?: Maybe<Scalars['Short']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_FaceCallMonthlyRecommendConnection = {
  __typename?: 'Club_WorldFamilyClub_FaceCallMonthlyRecommendConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_FaceCallMonthlyRecommendEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_FaceCallMonthlyRecommend>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_FaceCallMonthlyRecommendEdge = {
  __typename?: 'Club_WorldFamilyClub_FaceCallMonthlyRecommendEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_FaceCallMonthlyRecommend;
};

/** FaceCallMonthlyRecommend */
export type Club_WorldFamilyClub_FaceCallMonthlyRecommendFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallMonthlyRecommendFilterInput>>;
  /** CreatedTime */
  createdTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** Creator */
  creator?: InputMaybe<StringOperationFilterInput>;
  /** [ID] FaceCallMonthlyRecommendId */
  faceCallMonthlyRecommendId?: InputMaybe<IntOperationFilterInput>;
  /** [NAVIGATION] FaceCallSong */
  faceCallSong?: InputMaybe<Club_WorldFamilyClub_FaceCallSongFilterInput>;
  /** [NOT NULL] FaceCallSongId */
  faceCallSongId?: InputMaybe<IntOperationFilterInput>;
  /** [NAVIGATION] FaceCallSongPublic */
  faceCallSongPublic?: InputMaybe<Club_WorldFamilyClub_FaceCallSongPublicFilterInput>;
  /** [NOT NULL] FaceCallSongPublicId */
  faceCallSongPublicId?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] Month */
  month?: InputMaybe<ByteOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallMonthlyRecommendFilterInput>>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** Updater */
  updater?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] Year */
  year?: InputMaybe<ShortOperationFilterInput>;
};

/** FaceCallMonthlyRecommend */
export type Club_WorldFamilyClub_FaceCallMonthlyRecommendInput = {
  /** CreatedTime */
  createdTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Creator */
  creator?: InputMaybe<Scalars['String']['input']>;
  /** [ID] FaceCallMonthlyRecommendId */
  faceCallMonthlyRecommendId?: InputMaybe<Scalars['Int']['input']>;
  /** [NAVIGATION] FaceCallSong */
  faceCallSong?: InputMaybe<Club_WorldFamilyClub_FaceCallSongInput>;
  /** [NOT NULL] FaceCallSongId */
  faceCallSongId?: InputMaybe<Scalars['Int']['input']>;
  /** [NAVIGATION] FaceCallSongPublic */
  faceCallSongPublic?: InputMaybe<Club_WorldFamilyClub_FaceCallSongPublicInput>;
  /** [NOT NULL] FaceCallSongPublicId */
  faceCallSongPublicId?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] Month */
  month?: InputMaybe<Scalars['Byte']['input']>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Updater */
  updater?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Year */
  year?: InputMaybe<Scalars['Short']['input']>;
};

/** FaceCallMonthlyRecommend */
export type Club_WorldFamilyClub_FaceCallMonthlyRecommendSortInput = {
  /** CreatedTime */
  createdTime?: InputMaybe<SortEnumType>;
  /** Creator */
  creator?: InputMaybe<SortEnumType>;
  /** [ID] FaceCallMonthlyRecommendId */
  faceCallMonthlyRecommendId?: InputMaybe<SortEnumType>;
  /** [NAVIGATION] FaceCallSong */
  faceCallSong?: InputMaybe<Club_WorldFamilyClub_FaceCallSongSortInput>;
  /** [NOT NULL] FaceCallSongId */
  faceCallSongId?: InputMaybe<SortEnumType>;
  /** [NAVIGATION] FaceCallSongPublic */
  faceCallSongPublic?: InputMaybe<Club_WorldFamilyClub_FaceCallSongPublicSortInput>;
  /** [NOT NULL] FaceCallSongPublicId */
  faceCallSongPublicId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Month */
  month?: InputMaybe<SortEnumType>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<SortEnumType>;
  /** Updater */
  updater?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Year */
  year?: InputMaybe<SortEnumType>;
};

/** FaceCallPerformer */
export type Club_WorldFamilyClub_FaceCallPerformer = Node & {
  __typename?: 'Club_WorldFamilyClub_FaceCallPerformer';
  /** [NOT NULL] AvatarFileName */
  avatarFileName?: Maybe<Scalars['String']['output']>;
  /** CreatedTime */
  createdTime?: Maybe<Scalars['DateTime']['output']>;
  /** Creator */
  creator?: Maybe<Scalars['String']['output']>;
  /** [COLLECTION] FaceCallSongAndPerformers */
  faceCallSongAndPerformers?: Maybe<Array<Maybe<Club_WorldFamilyClub_FaceCallSongAndPerformer>>>;
  /** HkFaceCallPerformerSeq */
  hkFaceCallPerformerSeq?: Maybe<Scalars['Int']['output']>;
  /** [ID] FaceCallPerformerId */
  id: Scalars['ID']['output'];
  /** KrFaceCallPerformerSeq */
  krFaceCallPerformerSeq?: Maybe<Scalars['Int']['output']>;
  /** [NOT NULL] Market */
  market?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] PerformerName */
  performerName?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] PublishdSongs */
  publishdSongs?: Maybe<Scalars['Int']['output']>;
  /** TwFaceCallPerformerSeq */
  twFaceCallPerformerSeq?: Maybe<Scalars['Int']['output']>;
  /** UpdatedTime */
  updatedTime?: Maybe<Scalars['DateTime']['output']>;
  /** Updater */
  updater?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] ZippyFlag */
  zippyFlag?: Maybe<Scalars['Boolean']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_FaceCallPerformerConnection = {
  __typename?: 'Club_WorldFamilyClub_FaceCallPerformerConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_FaceCallPerformerEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_FaceCallPerformer>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_FaceCallPerformerEdge = {
  __typename?: 'Club_WorldFamilyClub_FaceCallPerformerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_FaceCallPerformer;
};

/** FaceCallPerformer */
export type Club_WorldFamilyClub_FaceCallPerformerFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallPerformerFilterInput>>;
  /** [NOT NULL] AvatarFileName */
  avatarFileName?: InputMaybe<StringOperationFilterInput>;
  /** CreatedTime */
  createdTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** Creator */
  creator?: InputMaybe<StringOperationFilterInput>;
  /** [ID] FaceCallPerformerId */
  faceCallPerformerId?: InputMaybe<IntOperationFilterInput>;
  /** [COLLECTION] FaceCallSongAndPerformers */
  faceCallSongAndPerformers?: InputMaybe<ListFilterInputTypeOfClub_WorldFamilyClub_FaceCallSongAndPerformerFilterInput>;
  /** HkFaceCallPerformerSeq */
  hkFaceCallPerformerSeq?: InputMaybe<IntOperationFilterInput>;
  /** KrFaceCallPerformerSeq */
  krFaceCallPerformerSeq?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] Market */
  market?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallPerformerFilterInput>>;
  /** [NOT NULL] PerformerName */
  performerName?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] PublishdSongs */
  publishdSongs?: InputMaybe<IntOperationFilterInput>;
  /** TwFaceCallPerformerSeq */
  twFaceCallPerformerSeq?: InputMaybe<IntOperationFilterInput>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** Updater */
  updater?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] ZippyFlag */
  zippyFlag?: InputMaybe<BooleanOperationFilterInput>;
};

/** FaceCallPerformer */
export type Club_WorldFamilyClub_FaceCallPerformerInput = {
  /** [NOT NULL] AvatarFileName */
  avatarFileName?: InputMaybe<Scalars['String']['input']>;
  /** CreatedTime */
  createdTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Creator */
  creator?: InputMaybe<Scalars['String']['input']>;
  /** [ID] FaceCallPerformerId */
  faceCallPerformerId?: InputMaybe<Scalars['Int']['input']>;
  /** [COLLECTION] FaceCallSongAndPerformers */
  faceCallSongAndPerformers?: InputMaybe<Array<InputMaybe<Club_WorldFamilyClub_FaceCallSongAndPerformerInput>>>;
  /** HkFaceCallPerformerSeq */
  hkFaceCallPerformerSeq?: InputMaybe<Scalars['Int']['input']>;
  /** KrFaceCallPerformerSeq */
  krFaceCallPerformerSeq?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] PerformerName */
  performerName?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] PublishdSongs */
  publishdSongs?: InputMaybe<Scalars['Int']['input']>;
  /** TwFaceCallPerformerSeq */
  twFaceCallPerformerSeq?: InputMaybe<Scalars['Int']['input']>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Updater */
  updater?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] ZippyFlag */
  zippyFlag?: InputMaybe<Scalars['Boolean']['input']>;
};

/** FaceCallPerformer */
export type Club_WorldFamilyClub_FaceCallPerformerSortInput = {
  /** [NOT NULL] AvatarFileName */
  avatarFileName?: InputMaybe<SortEnumType>;
  /** CreatedTime */
  createdTime?: InputMaybe<SortEnumType>;
  /** Creator */
  creator?: InputMaybe<SortEnumType>;
  /** [ID] FaceCallPerformerId */
  faceCallPerformerId?: InputMaybe<SortEnumType>;
  /** HkFaceCallPerformerSeq */
  hkFaceCallPerformerSeq?: InputMaybe<SortEnumType>;
  /** KrFaceCallPerformerSeq */
  krFaceCallPerformerSeq?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Market */
  market?: InputMaybe<SortEnumType>;
  /** [NOT NULL] PerformerName */
  performerName?: InputMaybe<SortEnumType>;
  /** [NOT NULL] PublishdSongs */
  publishdSongs?: InputMaybe<SortEnumType>;
  /** TwFaceCallPerformerSeq */
  twFaceCallPerformerSeq?: InputMaybe<SortEnumType>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<SortEnumType>;
  /** Updater */
  updater?: InputMaybe<SortEnumType>;
  /** [NOT NULL] ZippyFlag */
  zippyFlag?: InputMaybe<SortEnumType>;
};

/** FaceCallSeasonHoliday */
export type Club_WorldFamilyClub_FaceCallSeasonHoliday = Node & {
  __typename?: 'Club_WorldFamilyClub_FaceCallSeasonHoliday';
  /** DateFrom */
  dateFrom?: Maybe<Scalars['DateTime']['output']>;
  /** DateTo */
  dateTo?: Maybe<Scalars['DateTime']['output']>;
  /** [COLLECTION] FaceCallSongPublics */
  faceCallSongPublics?: Maybe<Array<Maybe<Club_WorldFamilyClub_FaceCallSongPublic>>>;
  /** [COLLECTION] FaceCallSongs */
  faceCallSongs?: Maybe<Array<Maybe<Club_WorldFamilyClub_FaceCallSong>>>;
  /** IconFileName */
  iconFileName?: Maybe<Scalars['String']['output']>;
  /** [ID] FaceCallSeasonHolidayId */
  id: Scalars['ID']['output'];
  /** Name */
  name?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_FaceCallSeasonHolidayConnection = {
  __typename?: 'Club_WorldFamilyClub_FaceCallSeasonHolidayConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_FaceCallSeasonHolidayEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_FaceCallSeasonHoliday>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_FaceCallSeasonHolidayEdge = {
  __typename?: 'Club_WorldFamilyClub_FaceCallSeasonHolidayEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_FaceCallSeasonHoliday;
};

/** FaceCallSeasonHoliday */
export type Club_WorldFamilyClub_FaceCallSeasonHolidayFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallSeasonHolidayFilterInput>>;
  /** DateFrom */
  dateFrom?: InputMaybe<DateTimeOperationFilterInput>;
  /** DateTo */
  dateTo?: InputMaybe<DateTimeOperationFilterInput>;
  /** [ID] FaceCallSeasonHolidayId */
  faceCallSeasonHolidayId?: InputMaybe<IntOperationFilterInput>;
  /** [COLLECTION] FaceCallSongPublics */
  faceCallSongPublics?: InputMaybe<ListFilterInputTypeOfClub_WorldFamilyClub_FaceCallSongPublicFilterInput>;
  /** [COLLECTION] FaceCallSongs */
  faceCallSongs?: InputMaybe<ListFilterInputTypeOfClub_WorldFamilyClub_FaceCallSongFilterInput>;
  /** IconFileName */
  iconFileName?: InputMaybe<StringOperationFilterInput>;
  /** Name */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallSeasonHolidayFilterInput>>;
};

/** FaceCallSeasonHoliday */
export type Club_WorldFamilyClub_FaceCallSeasonHolidayInput = {
  /** DateFrom */
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /** DateTo */
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  /** [ID] FaceCallSeasonHolidayId */
  faceCallSeasonHolidayId?: InputMaybe<Scalars['Int']['input']>;
  /** [COLLECTION] FaceCallSongPublics */
  faceCallSongPublics?: InputMaybe<Array<InputMaybe<Club_WorldFamilyClub_FaceCallSongPublicInput>>>;
  /** [COLLECTION] FaceCallSongs */
  faceCallSongs?: InputMaybe<Array<InputMaybe<Club_WorldFamilyClub_FaceCallSongInput>>>;
  /** IconFileName */
  iconFileName?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** FaceCallSeasonHoliday */
export type Club_WorldFamilyClub_FaceCallSeasonHolidaySortInput = {
  /** DateFrom */
  dateFrom?: InputMaybe<SortEnumType>;
  /** DateTo */
  dateTo?: InputMaybe<SortEnumType>;
  /** [ID] FaceCallSeasonHolidayId */
  faceCallSeasonHolidayId?: InputMaybe<SortEnumType>;
  /** IconFileName */
  iconFileName?: InputMaybe<SortEnumType>;
  /** Name */
  name?: InputMaybe<SortEnumType>;
};

/** FaceCallSong */
export type Club_WorldFamilyClub_FaceCallSong = Node & {
  __typename?: 'Club_WorldFamilyClub_FaceCallSong';
  /** CreatedTime */
  createdTime?: Maybe<Scalars['DateTime']['output']>;
  /** Creator */
  creator?: Maybe<Scalars['String']['output']>;
  /** EndDate */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** [COLLECTION] FaceCallHists */
  faceCallHists?: Maybe<Array<Maybe<Club_WorldFamilyClub_FaceCallHist>>>;
  /** [COLLECTION] FaceCallMonthlyRecommends */
  faceCallMonthlyRecommends?: Maybe<Array<Maybe<Club_WorldFamilyClub_FaceCallMonthlyRecommend>>>;
  /** [NAVIGATION] FaceCallSeasonHoliday */
  faceCallSeasonHoliday?: Maybe<Club_WorldFamilyClub_FaceCallSeasonHoliday>;
  /** [NOT NULL] FaceCallSeasonHolidayId */
  faceCallSeasonHolidayId?: Maybe<Scalars['Int']['output']>;
  /** [COLLECTION] FaceCallSongAndPerformers */
  faceCallSongAndPerformers?: Maybe<Array<Maybe<Club_WorldFamilyClub_FaceCallSongAndPerformer>>>;
  /** HkFaceCallSongSeq */
  hkFaceCallSongSeq?: Maybe<Scalars['Int']['output']>;
  /** [ID] FaceCallSongId */
  id: Scalars['ID']['output'];
  /** JpFaceCallSongSeq */
  jpFaceCallSongSeq?: Maybe<Scalars['Int']['output']>;
  /** KrFaceCallSongSeq */
  krFaceCallSongSeq?: Maybe<Scalars['Int']['output']>;
  /** [COLLECTION] MyFavoriteFaceCalls */
  myFavoriteFaceCalls?: Maybe<Array<Maybe<Club_WorldFamilyClub_MyFavoriteFaceCall>>>;
  /** StartDate */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  /** [NAVIGATION] TeSong */
  teSong?: Maybe<Club_WorldFamilyClub_TeSong>;
  /** [NOT NULL] TeSongId */
  teSongId?: Maybe<Scalars['Int']['output']>;
  /** TwFaceCallSongSeq */
  twFaceCallSongSeq?: Maybe<Scalars['Int']['output']>;
  /** UpdatedTime */
  updatedTime?: Maybe<Scalars['DateTime']['output']>;
  /** Updater */
  updater?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] VimeoVideoId */
  vimeoVideoId?: Maybe<Scalars['String']['output']>;
  /** VimeoVideoThumbnail */
  vimeoVideoThumbnail?: Maybe<Scalars['String']['output']>;
};

/** FaceCallSongAndPerformer */
export type Club_WorldFamilyClub_FaceCallSongAndPerformer = Node & {
  __typename?: 'Club_WorldFamilyClub_FaceCallSongAndPerformer';
  /** [NAVIGATION] FaceCallPerformer */
  faceCallPerformer?: Maybe<Club_WorldFamilyClub_FaceCallPerformer>;
  /** [NOT NULL] FaceCallPerformerId */
  faceCallPerformerId?: Maybe<Scalars['Int']['output']>;
  /** [NAVIGATION] FaceCallSong */
  faceCallSong?: Maybe<Club_WorldFamilyClub_FaceCallSong>;
  /** [NOT NULL] FaceCallSongId */
  faceCallSongId?: Maybe<Scalars['Int']['output']>;
  /** [NAVIGATION] FaceCallSongPublic */
  faceCallSongPublic?: Maybe<Club_WorldFamilyClub_FaceCallSongPublic>;
  /** [NOT NULL] FaceCallSongPublicId */
  faceCallSongPublicId?: Maybe<Scalars['Int']['output']>;
  /** [ID] FaceCallSongAndPerformerId */
  id: Scalars['ID']['output'];
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_FaceCallSongAndPerformerConnection = {
  __typename?: 'Club_WorldFamilyClub_FaceCallSongAndPerformerConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_FaceCallSongAndPerformerEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_FaceCallSongAndPerformer>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_FaceCallSongAndPerformerEdge = {
  __typename?: 'Club_WorldFamilyClub_FaceCallSongAndPerformerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_FaceCallSongAndPerformer;
};

/** FaceCallSongAndPerformer */
export type Club_WorldFamilyClub_FaceCallSongAndPerformerFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallSongAndPerformerFilterInput>>;
  /** [NAVIGATION] FaceCallPerformer */
  faceCallPerformer?: InputMaybe<Club_WorldFamilyClub_FaceCallPerformerFilterInput>;
  /** [NOT NULL] FaceCallPerformerId */
  faceCallPerformerId?: InputMaybe<IntOperationFilterInput>;
  /** [NAVIGATION] FaceCallSong */
  faceCallSong?: InputMaybe<Club_WorldFamilyClub_FaceCallSongFilterInput>;
  /** [ID] FaceCallSongAndPerformerId */
  faceCallSongAndPerformerId?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] FaceCallSongId */
  faceCallSongId?: InputMaybe<IntOperationFilterInput>;
  /** [NAVIGATION] FaceCallSongPublic */
  faceCallSongPublic?: InputMaybe<Club_WorldFamilyClub_FaceCallSongPublicFilterInput>;
  /** [NOT NULL] FaceCallSongPublicId */
  faceCallSongPublicId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallSongAndPerformerFilterInput>>;
};

/** FaceCallSongAndPerformer */
export type Club_WorldFamilyClub_FaceCallSongAndPerformerInput = {
  /** [NAVIGATION] FaceCallPerformer */
  faceCallPerformer?: InputMaybe<Club_WorldFamilyClub_FaceCallPerformerInput>;
  /** [NOT NULL] FaceCallPerformerId */
  faceCallPerformerId?: InputMaybe<Scalars['Int']['input']>;
  /** [NAVIGATION] FaceCallSong */
  faceCallSong?: InputMaybe<Club_WorldFamilyClub_FaceCallSongInput>;
  /** [ID] FaceCallSongAndPerformerId */
  faceCallSongAndPerformerId?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] FaceCallSongId */
  faceCallSongId?: InputMaybe<Scalars['Int']['input']>;
  /** [NAVIGATION] FaceCallSongPublic */
  faceCallSongPublic?: InputMaybe<Club_WorldFamilyClub_FaceCallSongPublicInput>;
  /** [NOT NULL] FaceCallSongPublicId */
  faceCallSongPublicId?: InputMaybe<Scalars['Int']['input']>;
};

/** FaceCallSongAndPerformer */
export type Club_WorldFamilyClub_FaceCallSongAndPerformerSortInput = {
  /** [NAVIGATION] FaceCallPerformer */
  faceCallPerformer?: InputMaybe<Club_WorldFamilyClub_FaceCallPerformerSortInput>;
  /** [NOT NULL] FaceCallPerformerId */
  faceCallPerformerId?: InputMaybe<SortEnumType>;
  /** [NAVIGATION] FaceCallSong */
  faceCallSong?: InputMaybe<Club_WorldFamilyClub_FaceCallSongSortInput>;
  /** [ID] FaceCallSongAndPerformerId */
  faceCallSongAndPerformerId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] FaceCallSongId */
  faceCallSongId?: InputMaybe<SortEnumType>;
  /** [NAVIGATION] FaceCallSongPublic */
  faceCallSongPublic?: InputMaybe<Club_WorldFamilyClub_FaceCallSongPublicSortInput>;
  /** [NOT NULL] FaceCallSongPublicId */
  faceCallSongPublicId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_FaceCallSongConnection = {
  __typename?: 'Club_WorldFamilyClub_FaceCallSongConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_FaceCallSongEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_FaceCallSong>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_FaceCallSongEdge = {
  __typename?: 'Club_WorldFamilyClub_FaceCallSongEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_FaceCallSong;
};

/** FaceCallSong */
export type Club_WorldFamilyClub_FaceCallSongFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallSongFilterInput>>;
  /** CreatedTime */
  createdTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** Creator */
  creator?: InputMaybe<StringOperationFilterInput>;
  /** EndDate */
  endDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** [COLLECTION] FaceCallHists */
  faceCallHists?: InputMaybe<ListFilterInputTypeOfClub_WorldFamilyClub_FaceCallHistFilterInput>;
  /** [COLLECTION] FaceCallMonthlyRecommends */
  faceCallMonthlyRecommends?: InputMaybe<ListFilterInputTypeOfClub_WorldFamilyClub_FaceCallMonthlyRecommendFilterInput>;
  /** [NAVIGATION] FaceCallSeasonHoliday */
  faceCallSeasonHoliday?: InputMaybe<Club_WorldFamilyClub_FaceCallSeasonHolidayFilterInput>;
  /** [NOT NULL] FaceCallSeasonHolidayId */
  faceCallSeasonHolidayId?: InputMaybe<IntOperationFilterInput>;
  /** [COLLECTION] FaceCallSongAndPerformers */
  faceCallSongAndPerformers?: InputMaybe<ListFilterInputTypeOfClub_WorldFamilyClub_FaceCallSongAndPerformerFilterInput>;
  /** [ID] FaceCallSongId */
  faceCallSongId?: InputMaybe<IntOperationFilterInput>;
  /** HkFaceCallSongSeq */
  hkFaceCallSongSeq?: InputMaybe<IntOperationFilterInput>;
  /** JpFaceCallSongSeq */
  jpFaceCallSongSeq?: InputMaybe<IntOperationFilterInput>;
  /** KrFaceCallSongSeq */
  krFaceCallSongSeq?: InputMaybe<IntOperationFilterInput>;
  /** [COLLECTION] MyFavoriteFaceCalls */
  myFavoriteFaceCalls?: InputMaybe<ListFilterInputTypeOfClub_WorldFamilyClub_MyFavoriteFaceCallFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallSongFilterInput>>;
  /** StartDate */
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** [NAVIGATION] TeSong */
  teSong?: InputMaybe<Club_WorldFamilyClub_TeSongFilterInput>;
  /** [NOT NULL] TeSongId */
  teSongId?: InputMaybe<IntOperationFilterInput>;
  /** TwFaceCallSongSeq */
  twFaceCallSongSeq?: InputMaybe<IntOperationFilterInput>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** Updater */
  updater?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] VimeoVideoId */
  vimeoVideoId?: InputMaybe<StringOperationFilterInput>;
  /** VimeoVideoThumbnail */
  vimeoVideoThumbnail?: InputMaybe<StringOperationFilterInput>;
};

/** FaceCallSong */
export type Club_WorldFamilyClub_FaceCallSongInput = {
  /** CreatedTime */
  createdTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Creator */
  creator?: InputMaybe<Scalars['String']['input']>;
  /** EndDate */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** [COLLECTION] FaceCallHists */
  faceCallHists?: InputMaybe<Array<InputMaybe<Club_WorldFamilyClub_FaceCallHistInput>>>;
  /** [COLLECTION] FaceCallMonthlyRecommends */
  faceCallMonthlyRecommends?: InputMaybe<Array<InputMaybe<Club_WorldFamilyClub_FaceCallMonthlyRecommendInput>>>;
  /** [NAVIGATION] FaceCallSeasonHoliday */
  faceCallSeasonHoliday?: InputMaybe<Club_WorldFamilyClub_FaceCallSeasonHolidayInput>;
  /** [NOT NULL] FaceCallSeasonHolidayId */
  faceCallSeasonHolidayId?: InputMaybe<Scalars['Int']['input']>;
  /** [COLLECTION] FaceCallSongAndPerformers */
  faceCallSongAndPerformers?: InputMaybe<Array<InputMaybe<Club_WorldFamilyClub_FaceCallSongAndPerformerInput>>>;
  /** [ID] FaceCallSongId */
  faceCallSongId?: InputMaybe<Scalars['Int']['input']>;
  /** HkFaceCallSongSeq */
  hkFaceCallSongSeq?: InputMaybe<Scalars['Int']['input']>;
  /** JpFaceCallSongSeq */
  jpFaceCallSongSeq?: InputMaybe<Scalars['Int']['input']>;
  /** KrFaceCallSongSeq */
  krFaceCallSongSeq?: InputMaybe<Scalars['Int']['input']>;
  /** [COLLECTION] MyFavoriteFaceCalls */
  myFavoriteFaceCalls?: InputMaybe<Array<InputMaybe<Club_WorldFamilyClub_MyFavoriteFaceCallInput>>>;
  /** StartDate */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** [NAVIGATION] TeSong */
  teSong?: InputMaybe<Club_WorldFamilyClub_TeSongInput>;
  /** [NOT NULL] TeSongId */
  teSongId?: InputMaybe<Scalars['Int']['input']>;
  /** TwFaceCallSongSeq */
  twFaceCallSongSeq?: InputMaybe<Scalars['Int']['input']>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Updater */
  updater?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] VimeoVideoId */
  vimeoVideoId?: InputMaybe<Scalars['String']['input']>;
  /** VimeoVideoThumbnail */
  vimeoVideoThumbnail?: InputMaybe<Scalars['String']['input']>;
};

/** FaceCallSongPublic */
export type Club_WorldFamilyClub_FaceCallSongPublic = Node & {
  __typename?: 'Club_WorldFamilyClub_FaceCallSongPublic';
  /** CreatedTime */
  createdTime?: Maybe<Scalars['DateTime']['output']>;
  /** Creator */
  creator?: Maybe<Scalars['String']['output']>;
  /** EndDate */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** [COLLECTION] FaceCallHists */
  faceCallHists?: Maybe<Array<Maybe<Club_WorldFamilyClub_FaceCallHist>>>;
  /** [COLLECTION] FaceCallMonthlyRecommends */
  faceCallMonthlyRecommends?: Maybe<Array<Maybe<Club_WorldFamilyClub_FaceCallMonthlyRecommend>>>;
  /** [NAVIGATION] FaceCallSeasonHoliday */
  faceCallSeasonHoliday?: Maybe<Club_WorldFamilyClub_FaceCallSeasonHoliday>;
  /** [NOT NULL] FaceCallSeasonHolidayId */
  faceCallSeasonHolidayId?: Maybe<Scalars['Int']['output']>;
  /** [COLLECTION] FaceCallSongAndPerformers */
  faceCallSongAndPerformers?: Maybe<Array<Maybe<Club_WorldFamilyClub_FaceCallSongAndPerformer>>>;
  /** [ID] FaceCallSongPublicId */
  id: Scalars['ID']['output'];
  /** [COLLECTION] MyFavoriteFaceCalls */
  myFavoriteFaceCalls?: Maybe<Array<Maybe<Club_WorldFamilyClub_MyFavoriteFaceCall>>>;
  /** StartDate */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  /** [NAVIGATION] TeSong */
  teSong?: Maybe<Club_WorldFamilyClub_TeSong>;
  /** [NOT NULL] TeSongId */
  teSongId?: Maybe<Scalars['Int']['output']>;
  /** UpdatedTime */
  updatedTime?: Maybe<Scalars['DateTime']['output']>;
  /** Updater */
  updater?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] VimeoVideoId */
  vimeoVideoId?: Maybe<Scalars['String']['output']>;
  /** VimeoVideoThumbnail */
  vimeoVideoThumbnail?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_FaceCallSongPublicConnection = {
  __typename?: 'Club_WorldFamilyClub_FaceCallSongPublicConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_FaceCallSongPublicEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_FaceCallSongPublic>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_FaceCallSongPublicEdge = {
  __typename?: 'Club_WorldFamilyClub_FaceCallSongPublicEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_FaceCallSongPublic;
};

/** FaceCallSongPublic */
export type Club_WorldFamilyClub_FaceCallSongPublicFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallSongPublicFilterInput>>;
  /** CreatedTime */
  createdTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** Creator */
  creator?: InputMaybe<StringOperationFilterInput>;
  /** EndDate */
  endDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** [COLLECTION] FaceCallHists */
  faceCallHists?: InputMaybe<ListFilterInputTypeOfClub_WorldFamilyClub_FaceCallHistFilterInput>;
  /** [COLLECTION] FaceCallMonthlyRecommends */
  faceCallMonthlyRecommends?: InputMaybe<ListFilterInputTypeOfClub_WorldFamilyClub_FaceCallMonthlyRecommendFilterInput>;
  /** [NAVIGATION] FaceCallSeasonHoliday */
  faceCallSeasonHoliday?: InputMaybe<Club_WorldFamilyClub_FaceCallSeasonHolidayFilterInput>;
  /** [NOT NULL] FaceCallSeasonHolidayId */
  faceCallSeasonHolidayId?: InputMaybe<IntOperationFilterInput>;
  /** [COLLECTION] FaceCallSongAndPerformers */
  faceCallSongAndPerformers?: InputMaybe<ListFilterInputTypeOfClub_WorldFamilyClub_FaceCallSongAndPerformerFilterInput>;
  /** [ID] FaceCallSongPublicId */
  faceCallSongPublicId?: InputMaybe<IntOperationFilterInput>;
  /** [COLLECTION] MyFavoriteFaceCalls */
  myFavoriteFaceCalls?: InputMaybe<ListFilterInputTypeOfClub_WorldFamilyClub_MyFavoriteFaceCallFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallSongPublicFilterInput>>;
  /** StartDate */
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** [NAVIGATION] TeSong */
  teSong?: InputMaybe<Club_WorldFamilyClub_TeSongFilterInput>;
  /** [NOT NULL] TeSongId */
  teSongId?: InputMaybe<IntOperationFilterInput>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** Updater */
  updater?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] VimeoVideoId */
  vimeoVideoId?: InputMaybe<StringOperationFilterInput>;
  /** VimeoVideoThumbnail */
  vimeoVideoThumbnail?: InputMaybe<StringOperationFilterInput>;
};

/** FaceCallSongPublic */
export type Club_WorldFamilyClub_FaceCallSongPublicInput = {
  /** CreatedTime */
  createdTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Creator */
  creator?: InputMaybe<Scalars['String']['input']>;
  /** EndDate */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** [COLLECTION] FaceCallHists */
  faceCallHists?: InputMaybe<Array<InputMaybe<Club_WorldFamilyClub_FaceCallHistInput>>>;
  /** [COLLECTION] FaceCallMonthlyRecommends */
  faceCallMonthlyRecommends?: InputMaybe<Array<InputMaybe<Club_WorldFamilyClub_FaceCallMonthlyRecommendInput>>>;
  /** [NAVIGATION] FaceCallSeasonHoliday */
  faceCallSeasonHoliday?: InputMaybe<Club_WorldFamilyClub_FaceCallSeasonHolidayInput>;
  /** [NOT NULL] FaceCallSeasonHolidayId */
  faceCallSeasonHolidayId?: InputMaybe<Scalars['Int']['input']>;
  /** [COLLECTION] FaceCallSongAndPerformers */
  faceCallSongAndPerformers?: InputMaybe<Array<InputMaybe<Club_WorldFamilyClub_FaceCallSongAndPerformerInput>>>;
  /** [ID] FaceCallSongPublicId */
  faceCallSongPublicId?: InputMaybe<Scalars['Int']['input']>;
  /** [COLLECTION] MyFavoriteFaceCalls */
  myFavoriteFaceCalls?: InputMaybe<Array<InputMaybe<Club_WorldFamilyClub_MyFavoriteFaceCallInput>>>;
  /** StartDate */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** [NAVIGATION] TeSong */
  teSong?: InputMaybe<Club_WorldFamilyClub_TeSongInput>;
  /** [NOT NULL] TeSongId */
  teSongId?: InputMaybe<Scalars['Int']['input']>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Updater */
  updater?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] VimeoVideoId */
  vimeoVideoId?: InputMaybe<Scalars['String']['input']>;
  /** VimeoVideoThumbnail */
  vimeoVideoThumbnail?: InputMaybe<Scalars['String']['input']>;
};

/** FaceCallSongPublic */
export type Club_WorldFamilyClub_FaceCallSongPublicSortInput = {
  /** CreatedTime */
  createdTime?: InputMaybe<SortEnumType>;
  /** Creator */
  creator?: InputMaybe<SortEnumType>;
  /** EndDate */
  endDate?: InputMaybe<SortEnumType>;
  /** [NAVIGATION] FaceCallSeasonHoliday */
  faceCallSeasonHoliday?: InputMaybe<Club_WorldFamilyClub_FaceCallSeasonHolidaySortInput>;
  /** [NOT NULL] FaceCallSeasonHolidayId */
  faceCallSeasonHolidayId?: InputMaybe<SortEnumType>;
  /** [ID] FaceCallSongPublicId */
  faceCallSongPublicId?: InputMaybe<SortEnumType>;
  /** StartDate */
  startDate?: InputMaybe<SortEnumType>;
  /** [NAVIGATION] TeSong */
  teSong?: InputMaybe<Club_WorldFamilyClub_TeSongSortInput>;
  /** [NOT NULL] TeSongId */
  teSongId?: InputMaybe<SortEnumType>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<SortEnumType>;
  /** Updater */
  updater?: InputMaybe<SortEnumType>;
  /** [NOT NULL] VimeoVideoId */
  vimeoVideoId?: InputMaybe<SortEnumType>;
  /** VimeoVideoThumbnail */
  vimeoVideoThumbnail?: InputMaybe<SortEnumType>;
};

/** FaceCallSong */
export type Club_WorldFamilyClub_FaceCallSongSortInput = {
  /** CreatedTime */
  createdTime?: InputMaybe<SortEnumType>;
  /** Creator */
  creator?: InputMaybe<SortEnumType>;
  /** EndDate */
  endDate?: InputMaybe<SortEnumType>;
  /** [NAVIGATION] FaceCallSeasonHoliday */
  faceCallSeasonHoliday?: InputMaybe<Club_WorldFamilyClub_FaceCallSeasonHolidaySortInput>;
  /** [NOT NULL] FaceCallSeasonHolidayId */
  faceCallSeasonHolidayId?: InputMaybe<SortEnumType>;
  /** [ID] FaceCallSongId */
  faceCallSongId?: InputMaybe<SortEnumType>;
  /** HkFaceCallSongSeq */
  hkFaceCallSongSeq?: InputMaybe<SortEnumType>;
  /** JpFaceCallSongSeq */
  jpFaceCallSongSeq?: InputMaybe<SortEnumType>;
  /** KrFaceCallSongSeq */
  krFaceCallSongSeq?: InputMaybe<SortEnumType>;
  /** StartDate */
  startDate?: InputMaybe<SortEnumType>;
  /** [NAVIGATION] TeSong */
  teSong?: InputMaybe<Club_WorldFamilyClub_TeSongSortInput>;
  /** [NOT NULL] TeSongId */
  teSongId?: InputMaybe<SortEnumType>;
  /** TwFaceCallSongSeq */
  twFaceCallSongSeq?: InputMaybe<SortEnumType>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<SortEnumType>;
  /** Updater */
  updater?: InputMaybe<SortEnumType>;
  /** [NOT NULL] VimeoVideoId */
  vimeoVideoId?: InputMaybe<SortEnumType>;
  /** VimeoVideoThumbnail */
  vimeoVideoThumbnail?: InputMaybe<SortEnumType>;
};

/** GoGoLiveDesktopQrcode */
export type Club_WorldFamilyClub_GoGoLiveDesktopQrcode = Node & {
  __typename?: 'Club_WorldFamilyClub_GoGoLiveDesktopQrcode';
  /** ChildName */
  childName?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] ChildSeq */
  childSeq?: Maybe<Scalars['Int']['output']>;
  /** [NOT NULL] CreateTime */
  createTime?: Maybe<Scalars['DateTime']['output']>;
  /** ExpiredTime */
  expiredTime?: Maybe<Scalars['DateTime']['output']>;
  /** [ID] Seq */
  id: Scalars['ID']['output'];
  /** MemberNo */
  memberNo?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Qrcode */
  qrcode?: Maybe<Scalars['UUID']['output']>;
  /** [NOT NULL] UpdateTime */
  updateTime?: Maybe<Scalars['DateTime']['output']>;
  /** ZoomLink */
  zoomLink?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_GoGoLiveDesktopQrcodeConnection = {
  __typename?: 'Club_WorldFamilyClub_GoGoLiveDesktopQrcodeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_GoGoLiveDesktopQrcodeEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_GoGoLiveDesktopQrcode>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_GoGoLiveDesktopQrcodeEdge = {
  __typename?: 'Club_WorldFamilyClub_GoGoLiveDesktopQrcodeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_GoGoLiveDesktopQrcode;
};

/** GoGoLiveDesktopQrcode */
export type Club_WorldFamilyClub_GoGoLiveDesktopQrcodeFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveDesktopQrcodeFilterInput>>;
  /** ChildName */
  childName?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] ChildSeq */
  childSeq?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] CreateTime */
  createTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** ExpiredTime */
  expiredTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** MemberNo */
  memberNo?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveDesktopQrcodeFilterInput>>;
  /** [NOT NULL] Qrcode */
  qrcode?: InputMaybe<UuidOperationFilterInput>;
  /** [ID] Seq */
  seq?: InputMaybe<LongOperationFilterInput>;
  /** [NOT NULL] UpdateTime */
  updateTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** ZoomLink */
  zoomLink?: InputMaybe<StringOperationFilterInput>;
};

/** GoGoLiveDesktopQrcode */
export type Club_WorldFamilyClub_GoGoLiveDesktopQrcodeInput = {
  /** ChildName */
  childName?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] ChildSeq */
  childSeq?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] CreateTime */
  createTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** ExpiredTime */
  expiredTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** MemberNo */
  memberNo?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Qrcode */
  qrcode?: InputMaybe<Scalars['UUID']['input']>;
  /** [ID] Seq */
  seq?: InputMaybe<Scalars['Long']['input']>;
  /** [NOT NULL] UpdateTime */
  updateTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** ZoomLink */
  zoomLink?: InputMaybe<Scalars['String']['input']>;
};

/** GoGoLiveDesktopQrcode */
export type Club_WorldFamilyClub_GoGoLiveDesktopQrcodeSortInput = {
  /** ChildName */
  childName?: InputMaybe<SortEnumType>;
  /** [NOT NULL] ChildSeq */
  childSeq?: InputMaybe<SortEnumType>;
  /** [NOT NULL] CreateTime */
  createTime?: InputMaybe<SortEnumType>;
  /** ExpiredTime */
  expiredTime?: InputMaybe<SortEnumType>;
  /** MemberNo */
  memberNo?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Qrcode */
  qrcode?: InputMaybe<SortEnumType>;
  /** [ID] Seq */
  seq?: InputMaybe<SortEnumType>;
  /** [NOT NULL] UpdateTime */
  updateTime?: InputMaybe<SortEnumType>;
  /** ZoomLink */
  zoomLink?: InputMaybe<SortEnumType>;
};

/** GoGoLiveLevel */
export type Club_WorldFamilyClub_GoGoLiveLevel = Node & {
  __typename?: 'Club_WorldFamilyClub_GoGoLiveLevel';
  /** [ID] GoGoLiveLevelId */
  id: Scalars['ID']['output'];
  /** LevelName */
  levelName?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] SortOrder */
  sortOrder?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_GoGoLiveLevelConnection = {
  __typename?: 'Club_WorldFamilyClub_GoGoLiveLevelConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_GoGoLiveLevelEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_GoGoLiveLevel>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_GoGoLiveLevelEdge = {
  __typename?: 'Club_WorldFamilyClub_GoGoLiveLevelEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_GoGoLiveLevel;
};

/** GoGoLiveLevel */
export type Club_WorldFamilyClub_GoGoLiveLevelFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveLevelFilterInput>>;
  /** [ID] GoGoLiveLevelId */
  goGoLiveLevelId?: InputMaybe<StringOperationFilterInput>;
  /** LevelName */
  levelName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveLevelFilterInput>>;
  /** [NOT NULL] SortOrder */
  sortOrder?: InputMaybe<IntOperationFilterInput>;
};

/** GoGoLiveLevel */
export type Club_WorldFamilyClub_GoGoLiveLevelInput = {
  /** [ID] GoGoLiveLevelId */
  goGoLiveLevelId?: InputMaybe<Scalars['String']['input']>;
  /** LevelName */
  levelName?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] SortOrder */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/** GoGoLiveLevel */
export type Club_WorldFamilyClub_GoGoLiveLevelSortInput = {
  /** [ID] GoGoLiveLevelId */
  goGoLiveLevelId?: InputMaybe<SortEnumType>;
  /** LevelName */
  levelName?: InputMaybe<SortEnumType>;
  /** [NOT NULL] SortOrder */
  sortOrder?: InputMaybe<SortEnumType>;
};

/** GoGoLiveOpenDate */
export type Club_WorldFamilyClub_GoGoLiveOpenDate = Node & {
  __typename?: 'Club_WorldFamilyClub_GoGoLiveOpenDate';
  /** [ID] Region */
  id: Scalars['ID']['output'];
  /** OpenDate */
  openDate?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_GoGoLiveOpenDateConnection = {
  __typename?: 'Club_WorldFamilyClub_GoGoLiveOpenDateConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_GoGoLiveOpenDateEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_GoGoLiveOpenDate>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_GoGoLiveOpenDateEdge = {
  __typename?: 'Club_WorldFamilyClub_GoGoLiveOpenDateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_GoGoLiveOpenDate;
};

/** GoGoLiveOpenDate */
export type Club_WorldFamilyClub_GoGoLiveOpenDateFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveOpenDateFilterInput>>;
  /** OpenDate */
  openDate?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveOpenDateFilterInput>>;
  /** [ID] Region */
  region?: InputMaybe<StringOperationFilterInput>;
};

/** GoGoLiveOpenDate */
export type Club_WorldFamilyClub_GoGoLiveOpenDateInput = {
  /** OpenDate */
  openDate?: InputMaybe<Scalars['String']['input']>;
  /** [ID] Region */
  region?: InputMaybe<Scalars['String']['input']>;
};

/** GoGoLiveOpenDate */
export type Club_WorldFamilyClub_GoGoLiveOpenDateSortInput = {
  /** OpenDate */
  openDate?: InputMaybe<SortEnumType>;
  /** [ID] Region */
  region?: InputMaybe<SortEnumType>;
};

/** GoGoLiveParentGuide */
export type Club_WorldFamilyClub_GoGoLiveParentGuide = Node & {
  __typename?: 'Club_WorldFamilyClub_GoGoLiveParentGuide';
  /** BookPage */
  bookPage?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] ContentId */
  contentId?: Maybe<Scalars['Int']['output']>;
  /** CreatedTime */
  createdTime?: Maybe<Scalars['DateTime']['output']>;
  /** CreatedUser */
  createdUser?: Maybe<Scalars['String']['output']>;
  /** GoGoLiveLevelId */
  goGoLiveLevelId?: Maybe<Scalars['String']['output']>;
  /** [ID] GoGoLiveParentGuideId */
  id: Scalars['ID']['output'];
  /** Introduction */
  introduction?: Maybe<Scalars['String']['output']>;
  /** LanguagePoint */
  languagePoint?: Maybe<Scalars['String']['output']>;
  /** LearningGoals */
  learningGoals?: Maybe<Scalars['String']['output']>;
  /** LessonTitle */
  lessonTitle?: Maybe<Scalars['String']['output']>;
  /** PreviewVideoCoverImageFileName */
  previewVideoCoverImageFileName?: Maybe<Scalars['String']['output']>;
  /** PreviewVideoVimeoId */
  previewVideoVimeoId?: Maybe<Scalars['String']['output']>;
  /** PrintableSheet */
  printableSheet?: Maybe<Scalars['String']['output']>;
  /** ShowAndTell */
  showAndTell?: Maybe<Scalars['String']['output']>;
  /** UpdatedTime */
  updatedTime?: Maybe<Scalars['DateTime']['output']>;
  /** UpdatedUser */
  updatedUser?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] YearAndMonth */
  yearAndMonth?: Maybe<Scalars['DateTime']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_GoGoLiveParentGuideConnection = {
  __typename?: 'Club_WorldFamilyClub_GoGoLiveParentGuideConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuideEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuide>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_GoGoLiveParentGuideEdge = {
  __typename?: 'Club_WorldFamilyClub_GoGoLiveParentGuideEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_GoGoLiveParentGuide;
};

/** GoGoLiveParentGuide */
export type Club_WorldFamilyClub_GoGoLiveParentGuideFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuideFilterInput>>;
  /** BookPage */
  bookPage?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] ContentId */
  contentId?: InputMaybe<IntOperationFilterInput>;
  /** CreatedTime */
  createdTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** CreatedUser */
  createdUser?: InputMaybe<StringOperationFilterInput>;
  /** GoGoLiveLevelId */
  goGoLiveLevelId?: InputMaybe<StringOperationFilterInput>;
  /** [ID] GoGoLiveParentGuideId */
  goGoLiveParentGuideId?: InputMaybe<IntOperationFilterInput>;
  /** Introduction */
  introduction?: InputMaybe<StringOperationFilterInput>;
  /** LanguagePoint */
  languagePoint?: InputMaybe<StringOperationFilterInput>;
  /** LearningGoals */
  learningGoals?: InputMaybe<StringOperationFilterInput>;
  /** LessonTitle */
  lessonTitle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuideFilterInput>>;
  /** PreviewVideoCoverImageFileName */
  previewVideoCoverImageFileName?: InputMaybe<StringOperationFilterInput>;
  /** PreviewVideoVimeoId */
  previewVideoVimeoId?: InputMaybe<StringOperationFilterInput>;
  /** PrintableSheet */
  printableSheet?: InputMaybe<StringOperationFilterInput>;
  /** ShowAndTell */
  showAndTell?: InputMaybe<StringOperationFilterInput>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** UpdatedUser */
  updatedUser?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] YearAndMonth */
  yearAndMonth?: InputMaybe<DateTimeOperationFilterInput>;
};

/** GoGoLiveParentGuide */
export type Club_WorldFamilyClub_GoGoLiveParentGuideInput = {
  /** BookPage */
  bookPage?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] ContentId */
  contentId?: InputMaybe<Scalars['Int']['input']>;
  /** CreatedTime */
  createdTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** CreatedUser */
  createdUser?: InputMaybe<Scalars['String']['input']>;
  /** GoGoLiveLevelId */
  goGoLiveLevelId?: InputMaybe<Scalars['String']['input']>;
  /** [ID] GoGoLiveParentGuideId */
  goGoLiveParentGuideId?: InputMaybe<Scalars['Int']['input']>;
  /** Introduction */
  introduction?: InputMaybe<Scalars['String']['input']>;
  /** LanguagePoint */
  languagePoint?: InputMaybe<Scalars['String']['input']>;
  /** LearningGoals */
  learningGoals?: InputMaybe<Scalars['String']['input']>;
  /** LessonTitle */
  lessonTitle?: InputMaybe<Scalars['String']['input']>;
  /** PreviewVideoCoverImageFileName */
  previewVideoCoverImageFileName?: InputMaybe<Scalars['String']['input']>;
  /** PreviewVideoVimeoId */
  previewVideoVimeoId?: InputMaybe<Scalars['String']['input']>;
  /** PrintableSheet */
  printableSheet?: InputMaybe<Scalars['String']['input']>;
  /** ShowAndTell */
  showAndTell?: InputMaybe<Scalars['String']['input']>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** UpdatedUser */
  updatedUser?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] YearAndMonth */
  yearAndMonth?: InputMaybe<Scalars['DateTime']['input']>;
};

/** GoGoLiveParentGuideLocale */
export type Club_WorldFamilyClub_GoGoLiveParentGuideLocale = Node & {
  __typename?: 'Club_WorldFamilyClub_GoGoLiveParentGuideLocale';
  /** CreatedTime */
  createdTime?: Maybe<Scalars['DateTime']['output']>;
  /** CreatedUser */
  createdUser?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] GoGoLiveParentGuideId */
  goGoLiveParentGuideId?: Maybe<Scalars['Int']['output']>;
  /** [ID] GoGoLiveParentGuideLocaleId */
  id: Scalars['ID']['output'];
  /** Introduction */
  introduction?: Maybe<Scalars['String']['output']>;
  /** LearningGoals */
  learningGoals?: Maybe<Scalars['String']['output']>;
  /** Market */
  market?: Maybe<Scalars['String']['output']>;
  /** ShowAndTell */
  showAndTell?: Maybe<Scalars['String']['output']>;
  /** UpdatedTime */
  updatedTime?: Maybe<Scalars['DateTime']['output']>;
  /** UpdatedUser */
  updatedUser?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_GoGoLiveParentGuideLocaleConnection = {
  __typename?: 'Club_WorldFamilyClub_GoGoLiveParentGuideLocaleConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuideLocaleEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuideLocale>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_GoGoLiveParentGuideLocaleEdge = {
  __typename?: 'Club_WorldFamilyClub_GoGoLiveParentGuideLocaleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_GoGoLiveParentGuideLocale;
};

/** GoGoLiveParentGuideLocale */
export type Club_WorldFamilyClub_GoGoLiveParentGuideLocaleFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuideLocaleFilterInput>>;
  /** CreatedTime */
  createdTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** CreatedUser */
  createdUser?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] GoGoLiveParentGuideId */
  goGoLiveParentGuideId?: InputMaybe<IntOperationFilterInput>;
  /** [ID] GoGoLiveParentGuideLocaleId */
  goGoLiveParentGuideLocaleId?: InputMaybe<IntOperationFilterInput>;
  /** Introduction */
  introduction?: InputMaybe<StringOperationFilterInput>;
  /** LearningGoals */
  learningGoals?: InputMaybe<StringOperationFilterInput>;
  /** Market */
  market?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuideLocaleFilterInput>>;
  /** ShowAndTell */
  showAndTell?: InputMaybe<StringOperationFilterInput>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** UpdatedUser */
  updatedUser?: InputMaybe<StringOperationFilterInput>;
};

/** GoGoLiveParentGuideLocale */
export type Club_WorldFamilyClub_GoGoLiveParentGuideLocaleInput = {
  /** CreatedTime */
  createdTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** CreatedUser */
  createdUser?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] GoGoLiveParentGuideId */
  goGoLiveParentGuideId?: InputMaybe<Scalars['Int']['input']>;
  /** [ID] GoGoLiveParentGuideLocaleId */
  goGoLiveParentGuideLocaleId?: InputMaybe<Scalars['Int']['input']>;
  /** Introduction */
  introduction?: InputMaybe<Scalars['String']['input']>;
  /** LearningGoals */
  learningGoals?: InputMaybe<Scalars['String']['input']>;
  /** Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** ShowAndTell */
  showAndTell?: InputMaybe<Scalars['String']['input']>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** UpdatedUser */
  updatedUser?: InputMaybe<Scalars['String']['input']>;
};

/** GoGoLiveParentGuideLocale */
export type Club_WorldFamilyClub_GoGoLiveParentGuideLocaleSortInput = {
  /** CreatedTime */
  createdTime?: InputMaybe<SortEnumType>;
  /** CreatedUser */
  createdUser?: InputMaybe<SortEnumType>;
  /** [NOT NULL] GoGoLiveParentGuideId */
  goGoLiveParentGuideId?: InputMaybe<SortEnumType>;
  /** [ID] GoGoLiveParentGuideLocaleId */
  goGoLiveParentGuideLocaleId?: InputMaybe<SortEnumType>;
  /** Introduction */
  introduction?: InputMaybe<SortEnumType>;
  /** LearningGoals */
  learningGoals?: InputMaybe<SortEnumType>;
  /** Market */
  market?: InputMaybe<SortEnumType>;
  /** ShowAndTell */
  showAndTell?: InputMaybe<SortEnumType>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<SortEnumType>;
  /** UpdatedUser */
  updatedUser?: InputMaybe<SortEnumType>;
};

/** GoGoLiveParentGuideSession */
export type Club_WorldFamilyClub_GoGoLiveParentGuideSession = Node & {
  __typename?: 'Club_WorldFamilyClub_GoGoLiveParentGuideSession';
  /** [NOT NULL] GoGoLiveParentGuideId */
  goGoLiveParentGuideId?: Maybe<Scalars['Int']['output']>;
  /** [NOT NULL] GoGoLiveSessionId */
  goGoLiveSessionId?: Maybe<Scalars['Int']['output']>;
  /** [ID] GoGoLiveParentGuideSessionId */
  id: Scalars['ID']['output'];
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_GoGoLiveParentGuideSessionConnection = {
  __typename?: 'Club_WorldFamilyClub_GoGoLiveParentGuideSessionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuideSessionEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuideSession>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_GoGoLiveParentGuideSessionEdge = {
  __typename?: 'Club_WorldFamilyClub_GoGoLiveParentGuideSessionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_GoGoLiveParentGuideSession;
};

/** GoGoLiveParentGuideSession */
export type Club_WorldFamilyClub_GoGoLiveParentGuideSessionFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuideSessionFilterInput>>;
  /** [NOT NULL] GoGoLiveParentGuideId */
  goGoLiveParentGuideId?: InputMaybe<IntOperationFilterInput>;
  /** [ID] GoGoLiveParentGuideSessionId */
  goGoLiveParentGuideSessionId?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] GoGoLiveSessionId */
  goGoLiveSessionId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuideSessionFilterInput>>;
};

/** GoGoLiveParentGuideSession */
export type Club_WorldFamilyClub_GoGoLiveParentGuideSessionInput = {
  /** [NOT NULL] GoGoLiveParentGuideId */
  goGoLiveParentGuideId?: InputMaybe<Scalars['Int']['input']>;
  /** [ID] GoGoLiveParentGuideSessionId */
  goGoLiveParentGuideSessionId?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] GoGoLiveSessionId */
  goGoLiveSessionId?: InputMaybe<Scalars['Int']['input']>;
};

/** GoGoLiveParentGuideSession */
export type Club_WorldFamilyClub_GoGoLiveParentGuideSessionSortInput = {
  /** [NOT NULL] GoGoLiveParentGuideId */
  goGoLiveParentGuideId?: InputMaybe<SortEnumType>;
  /** [ID] GoGoLiveParentGuideSessionId */
  goGoLiveParentGuideSessionId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] GoGoLiveSessionId */
  goGoLiveSessionId?: InputMaybe<SortEnumType>;
};

/** GoGoLiveParentGuideSong */
export type Club_WorldFamilyClub_GoGoLiveParentGuideSong = Node & {
  __typename?: 'Club_WorldFamilyClub_GoGoLiveParentGuideSong';
  /** DiscCode */
  discCode?: Maybe<Scalars['String']['output']>;
  /** EtabCode */
  etabCode?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] GoGoLiveParentGuideId */
  goGoLiveParentGuideId?: Maybe<Scalars['Int']['output']>;
  /** [NOT NULL] GoGoLiveSongId */
  goGoLiveSongId?: Maybe<Scalars['Int']['output']>;
  /** [ID] GoGoLiveParentGuideSongId */
  id: Scalars['ID']['output'];
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_GoGoLiveParentGuideSongConnection = {
  __typename?: 'Club_WorldFamilyClub_GoGoLiveParentGuideSongConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuideSongEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuideSong>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_GoGoLiveParentGuideSongEdge = {
  __typename?: 'Club_WorldFamilyClub_GoGoLiveParentGuideSongEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_GoGoLiveParentGuideSong;
};

/** GoGoLiveParentGuideSong */
export type Club_WorldFamilyClub_GoGoLiveParentGuideSongFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuideSongFilterInput>>;
  /** DiscCode */
  discCode?: InputMaybe<StringOperationFilterInput>;
  /** EtabCode */
  etabCode?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] GoGoLiveParentGuideId */
  goGoLiveParentGuideId?: InputMaybe<IntOperationFilterInput>;
  /** [ID] GoGoLiveParentGuideSongId */
  goGoLiveParentGuideSongId?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] GoGoLiveSongId */
  goGoLiveSongId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuideSongFilterInput>>;
};

/** GoGoLiveParentGuideSong */
export type Club_WorldFamilyClub_GoGoLiveParentGuideSongInput = {
  /** DiscCode */
  discCode?: InputMaybe<Scalars['String']['input']>;
  /** EtabCode */
  etabCode?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] GoGoLiveParentGuideId */
  goGoLiveParentGuideId?: InputMaybe<Scalars['Int']['input']>;
  /** [ID] GoGoLiveParentGuideSongId */
  goGoLiveParentGuideSongId?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] GoGoLiveSongId */
  goGoLiveSongId?: InputMaybe<Scalars['Int']['input']>;
};

/** GoGoLiveParentGuideSong */
export type Club_WorldFamilyClub_GoGoLiveParentGuideSongSortInput = {
  /** DiscCode */
  discCode?: InputMaybe<SortEnumType>;
  /** EtabCode */
  etabCode?: InputMaybe<SortEnumType>;
  /** [NOT NULL] GoGoLiveParentGuideId */
  goGoLiveParentGuideId?: InputMaybe<SortEnumType>;
  /** [ID] GoGoLiveParentGuideSongId */
  goGoLiveParentGuideSongId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] GoGoLiveSongId */
  goGoLiveSongId?: InputMaybe<SortEnumType>;
};

/** GoGoLiveParentGuide */
export type Club_WorldFamilyClub_GoGoLiveParentGuideSortInput = {
  /** BookPage */
  bookPage?: InputMaybe<SortEnumType>;
  /** [NOT NULL] ContentId */
  contentId?: InputMaybe<SortEnumType>;
  /** CreatedTime */
  createdTime?: InputMaybe<SortEnumType>;
  /** CreatedUser */
  createdUser?: InputMaybe<SortEnumType>;
  /** GoGoLiveLevelId */
  goGoLiveLevelId?: InputMaybe<SortEnumType>;
  /** [ID] GoGoLiveParentGuideId */
  goGoLiveParentGuideId?: InputMaybe<SortEnumType>;
  /** Introduction */
  introduction?: InputMaybe<SortEnumType>;
  /** LanguagePoint */
  languagePoint?: InputMaybe<SortEnumType>;
  /** LearningGoals */
  learningGoals?: InputMaybe<SortEnumType>;
  /** LessonTitle */
  lessonTitle?: InputMaybe<SortEnumType>;
  /** PreviewVideoCoverImageFileName */
  previewVideoCoverImageFileName?: InputMaybe<SortEnumType>;
  /** PreviewVideoVimeoId */
  previewVideoVimeoId?: InputMaybe<SortEnumType>;
  /** PrintableSheet */
  printableSheet?: InputMaybe<SortEnumType>;
  /** ShowAndTell */
  showAndTell?: InputMaybe<SortEnumType>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<SortEnumType>;
  /** UpdatedUser */
  updatedUser?: InputMaybe<SortEnumType>;
  /** [NOT NULL] YearAndMonth */
  yearAndMonth?: InputMaybe<SortEnumType>;
};

/** GoGoLiveParentGuideTac */
export type Club_WorldFamilyClub_GoGoLiveParentGuideTac = Node & {
  __typename?: 'Club_WorldFamilyClub_GoGoLiveParentGuideTac';
  /** [NOT NULL] GoGoLiveParentGuideId */
  goGoLiveParentGuideId?: Maybe<Scalars['Int']['output']>;
  /** [ID] GoGoLiveParentGuideTacId */
  id: Scalars['ID']['output'];
  /** [NOT NULL] TalkAlongCardId */
  talkAlongCardId?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_GoGoLiveParentGuideTacConnection = {
  __typename?: 'Club_WorldFamilyClub_GoGoLiveParentGuideTacConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuideTacEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuideTac>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_GoGoLiveParentGuideTacEdge = {
  __typename?: 'Club_WorldFamilyClub_GoGoLiveParentGuideTacEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_GoGoLiveParentGuideTac;
};

/** GoGoLiveParentGuideTac */
export type Club_WorldFamilyClub_GoGoLiveParentGuideTacFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuideTacFilterInput>>;
  /** [NOT NULL] GoGoLiveParentGuideId */
  goGoLiveParentGuideId?: InputMaybe<IntOperationFilterInput>;
  /** [ID] GoGoLiveParentGuideTacId */
  goGoLiveParentGuideTacId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuideTacFilterInput>>;
  /** [NOT NULL] TalkAlongCardId */
  talkAlongCardId?: InputMaybe<IntOperationFilterInput>;
};

/** GoGoLiveParentGuideTac */
export type Club_WorldFamilyClub_GoGoLiveParentGuideTacInput = {
  /** [NOT NULL] GoGoLiveParentGuideId */
  goGoLiveParentGuideId?: InputMaybe<Scalars['Int']['input']>;
  /** [ID] GoGoLiveParentGuideTacId */
  goGoLiveParentGuideTacId?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] TalkAlongCardId */
  talkAlongCardId?: InputMaybe<Scalars['Int']['input']>;
};

/** GoGoLiveParentGuideTac */
export type Club_WorldFamilyClub_GoGoLiveParentGuideTacSortInput = {
  /** [NOT NULL] GoGoLiveParentGuideId */
  goGoLiveParentGuideId?: InputMaybe<SortEnumType>;
  /** [ID] GoGoLiveParentGuideTacId */
  goGoLiveParentGuideTacId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] TalkAlongCardId */
  talkAlongCardId?: InputMaybe<SortEnumType>;
};

/** GoGoLiveParentGuideToy */
export type Club_WorldFamilyClub_GoGoLiveParentGuideToy = Node & {
  __typename?: 'Club_WorldFamilyClub_GoGoLiveParentGuideToy';
  /** [NOT NULL] GoGoLiveParentGuideId */
  goGoLiveParentGuideId?: Maybe<Scalars['Int']['output']>;
  /** [NOT NULL] GoGoLiveToyId */
  goGoLiveToyId?: Maybe<Scalars['Int']['output']>;
  /** [ID] GoGoLiveParentGuideToyId */
  id: Scalars['ID']['output'];
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_GoGoLiveParentGuideToyConnection = {
  __typename?: 'Club_WorldFamilyClub_GoGoLiveParentGuideToyConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuideToyEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuideToy>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_GoGoLiveParentGuideToyEdge = {
  __typename?: 'Club_WorldFamilyClub_GoGoLiveParentGuideToyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_GoGoLiveParentGuideToy;
};

/** GoGoLiveParentGuideToy */
export type Club_WorldFamilyClub_GoGoLiveParentGuideToyFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuideToyFilterInput>>;
  /** [NOT NULL] GoGoLiveParentGuideId */
  goGoLiveParentGuideId?: InputMaybe<IntOperationFilterInput>;
  /** [ID] GoGoLiveParentGuideToyId */
  goGoLiveParentGuideToyId?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] GoGoLiveToyId */
  goGoLiveToyId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuideToyFilterInput>>;
};

/** GoGoLiveParentGuideToy */
export type Club_WorldFamilyClub_GoGoLiveParentGuideToyInput = {
  /** [NOT NULL] GoGoLiveParentGuideId */
  goGoLiveParentGuideId?: InputMaybe<Scalars['Int']['input']>;
  /** [ID] GoGoLiveParentGuideToyId */
  goGoLiveParentGuideToyId?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] GoGoLiveToyId */
  goGoLiveToyId?: InputMaybe<Scalars['Int']['input']>;
};

/** GoGoLiveParentGuideToy */
export type Club_WorldFamilyClub_GoGoLiveParentGuideToySortInput = {
  /** [NOT NULL] GoGoLiveParentGuideId */
  goGoLiveParentGuideId?: InputMaybe<SortEnumType>;
  /** [ID] GoGoLiveParentGuideToyId */
  goGoLiveParentGuideToyId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] GoGoLiveToyId */
  goGoLiveToyId?: InputMaybe<SortEnumType>;
};

/** GoGoLivePromotion */
export type Club_WorldFamilyClub_GoGoLivePromotion = Node & {
  __typename?: 'Club_WorldFamilyClub_GoGoLivePromotion';
  /** CapLevel */
  capLevel?: Maybe<Scalars['String']['output']>;
  /** CreateTime */
  createTime?: Maybe<Scalars['DateTime']['output']>;
  /** [ID] Seq */
  id: Scalars['ID']['output'];
  /** ParentGuideUrl */
  parentGuideUrl?: Maybe<Scalars['String']['output']>;
  /** PriceInformation */
  priceInformation?: Maybe<Scalars['String']['output']>;
  /** Region */
  region?: Maybe<Scalars['String']['output']>;
  /** ReviewPosterFileName */
  reviewPosterFileName?: Maybe<Scalars['String']['output']>;
  /** ServiceType */
  serviceType?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] TopicYearMonth */
  topicYearMonth?: Maybe<Scalars['DateTime']['output']>;
  /** VideoUrl */
  videoUrl?: Maybe<Scalars['String']['output']>;
  /** YearMonth */
  yearMonth?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_GoGoLivePromotionConnection = {
  __typename?: 'Club_WorldFamilyClub_GoGoLivePromotionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_GoGoLivePromotionEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_GoGoLivePromotion>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_GoGoLivePromotionEdge = {
  __typename?: 'Club_WorldFamilyClub_GoGoLivePromotionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_GoGoLivePromotion;
};

/** GoGoLivePromotion */
export type Club_WorldFamilyClub_GoGoLivePromotionFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLivePromotionFilterInput>>;
  /** CapLevel */
  capLevel?: InputMaybe<StringOperationFilterInput>;
  /** CreateTime */
  createTime?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLivePromotionFilterInput>>;
  /** ParentGuideUrl */
  parentGuideUrl?: InputMaybe<StringOperationFilterInput>;
  /** PriceInformation */
  priceInformation?: InputMaybe<StringOperationFilterInput>;
  /** Region */
  region?: InputMaybe<StringOperationFilterInput>;
  /** ReviewPosterFileName */
  reviewPosterFileName?: InputMaybe<StringOperationFilterInput>;
  /** [ID] Seq */
  seq?: InputMaybe<IntOperationFilterInput>;
  /** ServiceType */
  serviceType?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] TopicYearMonth */
  topicYearMonth?: InputMaybe<DateTimeOperationFilterInput>;
  /** VideoUrl */
  videoUrl?: InputMaybe<StringOperationFilterInput>;
  /** YearMonth */
  yearMonth?: InputMaybe<StringOperationFilterInput>;
};

/** GoGoLivePromotion */
export type Club_WorldFamilyClub_GoGoLivePromotionInput = {
  /** CapLevel */
  capLevel?: InputMaybe<Scalars['String']['input']>;
  /** CreateTime */
  createTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** ParentGuideUrl */
  parentGuideUrl?: InputMaybe<Scalars['String']['input']>;
  /** PriceInformation */
  priceInformation?: InputMaybe<Scalars['String']['input']>;
  /** Region */
  region?: InputMaybe<Scalars['String']['input']>;
  /** ReviewPosterFileName */
  reviewPosterFileName?: InputMaybe<Scalars['String']['input']>;
  /** [ID] Seq */
  seq?: InputMaybe<Scalars['Int']['input']>;
  /** ServiceType */
  serviceType?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] TopicYearMonth */
  topicYearMonth?: InputMaybe<Scalars['DateTime']['input']>;
  /** VideoUrl */
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  /** YearMonth */
  yearMonth?: InputMaybe<Scalars['String']['input']>;
};

/** GoGoLivePromotion */
export type Club_WorldFamilyClub_GoGoLivePromotionSortInput = {
  /** CapLevel */
  capLevel?: InputMaybe<SortEnumType>;
  /** CreateTime */
  createTime?: InputMaybe<SortEnumType>;
  /** ParentGuideUrl */
  parentGuideUrl?: InputMaybe<SortEnumType>;
  /** PriceInformation */
  priceInformation?: InputMaybe<SortEnumType>;
  /** Region */
  region?: InputMaybe<SortEnumType>;
  /** ReviewPosterFileName */
  reviewPosterFileName?: InputMaybe<SortEnumType>;
  /** [ID] Seq */
  seq?: InputMaybe<SortEnumType>;
  /** ServiceType */
  serviceType?: InputMaybe<SortEnumType>;
  /** [NOT NULL] TopicYearMonth */
  topicYearMonth?: InputMaybe<SortEnumType>;
  /** VideoUrl */
  videoUrl?: InputMaybe<SortEnumType>;
  /** YearMonth */
  yearMonth?: InputMaybe<SortEnumType>;
};

/** GoGoLiveSession */
export type Club_WorldFamilyClub_GoGoLiveSession = Node & {
  __typename?: 'Club_WorldFamilyClub_GoGoLiveSession';
  /** [ID] GoGoLiveSessionId */
  id: Scalars['ID']['output'];
  /** SessionName */
  sessionName?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_GoGoLiveSessionConnection = {
  __typename?: 'Club_WorldFamilyClub_GoGoLiveSessionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_GoGoLiveSessionEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_GoGoLiveSession>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_GoGoLiveSessionEdge = {
  __typename?: 'Club_WorldFamilyClub_GoGoLiveSessionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_GoGoLiveSession;
};

/** GoGoLiveSession */
export type Club_WorldFamilyClub_GoGoLiveSessionFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveSessionFilterInput>>;
  /** [ID] GoGoLiveSessionId */
  goGoLiveSessionId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveSessionFilterInput>>;
  /** SessionName */
  sessionName?: InputMaybe<StringOperationFilterInput>;
};

/** GoGoLiveSession */
export type Club_WorldFamilyClub_GoGoLiveSessionInput = {
  /** [ID] GoGoLiveSessionId */
  goGoLiveSessionId?: InputMaybe<Scalars['Int']['input']>;
  /** SessionName */
  sessionName?: InputMaybe<Scalars['String']['input']>;
};

/** GoGoLiveSession */
export type Club_WorldFamilyClub_GoGoLiveSessionSortInput = {
  /** [ID] GoGoLiveSessionId */
  goGoLiveSessionId?: InputMaybe<SortEnumType>;
  /** SessionName */
  sessionName?: InputMaybe<SortEnumType>;
};

/** GoGoLiveSong */
export type Club_WorldFamilyClub_GoGoLiveSong = Node & {
  __typename?: 'Club_WorldFamilyClub_GoGoLiveSong';
  /** [ID] GoGoLiveSongId */
  id: Scalars['ID']['output'];
  /** SongName */
  songName?: Maybe<Scalars['String']['output']>;
  /** SongNumber */
  songNumber?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_GoGoLiveSongConnection = {
  __typename?: 'Club_WorldFamilyClub_GoGoLiveSongConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_GoGoLiveSongEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_GoGoLiveSong>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_GoGoLiveSongEdge = {
  __typename?: 'Club_WorldFamilyClub_GoGoLiveSongEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_GoGoLiveSong;
};

/** GoGoLiveSong */
export type Club_WorldFamilyClub_GoGoLiveSongFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveSongFilterInput>>;
  /** [ID] GoGoLiveSongId */
  goGoLiveSongId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveSongFilterInput>>;
  /** SongName */
  songName?: InputMaybe<StringOperationFilterInput>;
  /** SongNumber */
  songNumber?: InputMaybe<StringOperationFilterInput>;
};

/** GoGoLiveSong */
export type Club_WorldFamilyClub_GoGoLiveSongInput = {
  /** [ID] GoGoLiveSongId */
  goGoLiveSongId?: InputMaybe<Scalars['Int']['input']>;
  /** SongName */
  songName?: InputMaybe<Scalars['String']['input']>;
  /** SongNumber */
  songNumber?: InputMaybe<Scalars['String']['input']>;
};

/** GoGoLiveSong */
export type Club_WorldFamilyClub_GoGoLiveSongSortInput = {
  /** [ID] GoGoLiveSongId */
  goGoLiveSongId?: InputMaybe<SortEnumType>;
  /** SongName */
  songName?: InputMaybe<SortEnumType>;
  /** SongNumber */
  songNumber?: InputMaybe<SortEnumType>;
};

/** GoGoLiveToy */
export type Club_WorldFamilyClub_GoGoLiveToy = Node & {
  __typename?: 'Club_WorldFamilyClub_GoGoLiveToy';
  /** [ID] GoGoLiveToyId */
  id: Scalars['ID']['output'];
  /** ToyImageFile */
  toyImageFile?: Maybe<Scalars['String']['output']>;
  /** ToyName */
  toyName?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_GoGoLiveToyConnection = {
  __typename?: 'Club_WorldFamilyClub_GoGoLiveToyConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_GoGoLiveToyEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_GoGoLiveToy>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_GoGoLiveToyEdge = {
  __typename?: 'Club_WorldFamilyClub_GoGoLiveToyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_GoGoLiveToy;
};

/** GoGoLiveToy */
export type Club_WorldFamilyClub_GoGoLiveToyFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveToyFilterInput>>;
  /** [ID] GoGoLiveToyId */
  goGoLiveToyId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveToyFilterInput>>;
  /** ToyImageFile */
  toyImageFile?: InputMaybe<StringOperationFilterInput>;
  /** ToyName */
  toyName?: InputMaybe<StringOperationFilterInput>;
};

/** GoGoLiveToy */
export type Club_WorldFamilyClub_GoGoLiveToyInput = {
  /** [ID] GoGoLiveToyId */
  goGoLiveToyId?: InputMaybe<Scalars['Int']['input']>;
  /** ToyImageFile */
  toyImageFile?: InputMaybe<Scalars['String']['input']>;
  /** ToyName */
  toyName?: InputMaybe<Scalars['String']['input']>;
};

/** GoGoLiveToy */
export type Club_WorldFamilyClub_GoGoLiveToySortInput = {
  /** [ID] GoGoLiveToyId */
  goGoLiveToyId?: InputMaybe<SortEnumType>;
  /** ToyImageFile */
  toyImageFile?: InputMaybe<SortEnumType>;
  /** ToyName */
  toyName?: InputMaybe<SortEnumType>;
};

/** GraduationApplication */
export type Club_WorldFamilyClub_GraduationApplication = Node & {
  __typename?: 'Club_WorldFamilyClub_GraduationApplication';
  /** Age */
  age?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] ApplicationDate */
  applicationDate?: Maybe<Scalars['DateTime']['output']>;
  /** ApprovalDate */
  approvalDate?: Maybe<Scalars['DateTime']['output']>;
  /** [NOT NULL] AudioFile */
  audioFile?: Maybe<Scalars['String']['output']>;
  /** ChildEnglishName */
  childEnglishName?: Maybe<Scalars['String']['output']>;
  /** ChildName */
  childName?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] ChildNo */
  childNo?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] CreatedTime */
  createdTime?: Maybe<Scalars['DateTime']['output']>;
  /** Creator */
  creator?: Maybe<Scalars['String']['output']>;
  /** FinishDate */
  finishDate?: Maybe<Scalars['DateTime']['output']>;
  /** [COLLECTION] GraduationApplicationEvaluations */
  graduationApplicationEvaluations?: Maybe<Array<Maybe<Club_WorldFamilyClub_GraduationApplicationEvaluation>>>;
  /** [COLLECTION] GraduationSubApplications */
  graduationSubApplications?: Maybe<Array<Maybe<Club_WorldFamilyClub_GraduationSubApplication>>>;
  /** [ID] ApplicationId */
  id: Scalars['ID']['output'];
  /** IsExcellent */
  isExcellent?: Maybe<Scalars['Boolean']['output']>;
  /** [NOT NULL] IsGraduationSpeechSelectionAgreed */
  isGraduationSpeechSelectionAgreed?: Maybe<Scalars['Boolean']['output']>;
  /** IsPassed */
  isPassed?: Maybe<Scalars['Boolean']['output']>;
  /** [NOT NULL] Market */
  market?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] MemberNo */
  memberNo?: Maybe<Scalars['String']['output']>;
  /** OverallComment */
  overallComment?: Maybe<Scalars['String']['output']>;
  /** [NAVIGATION] Task */
  task?: Maybe<Club_WorldFamilyClub_GraduationApplicationTask>;
  /** [NOT NULL] TaskId */
  taskId?: Maybe<Scalars['Int']['output']>;
  /** [NOT NULL] UpdatedTime */
  updatedTime?: Maybe<Scalars['DateTime']['output']>;
  /** Updater */
  updater?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] VideoUrl */
  videoUrl?: Maybe<Scalars['String']['output']>;
  /** YearCount */
  yearCount?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_GraduationApplicationConnection = {
  __typename?: 'Club_WorldFamilyClub_GraduationApplicationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_GraduationApplicationEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_GraduationApplication>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_GraduationApplicationEdge = {
  __typename?: 'Club_WorldFamilyClub_GraduationApplicationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_GraduationApplication;
};

/** GraduationApplicationEvaluation */
export type Club_WorldFamilyClub_GraduationApplicationEvaluation = Node & {
  __typename?: 'Club_WorldFamilyClub_GraduationApplicationEvaluation';
  /** [NAVIGATION] Application */
  application?: Maybe<Club_WorldFamilyClub_GraduationApplication>;
  /** [NOT NULL] ApplicationId */
  applicationId?: Maybe<Scalars['Int']['output']>;
  /** [NAVIGATION] Evaluation */
  evaluation?: Maybe<Club_WorldFamilyClub_GraduationEvaluation>;
  /** [NOT NULL] EvaluationId */
  evaluationId?: Maybe<Scalars['Int']['output']>;
  /** [ID] ApplicationEvaluationId */
  id: Scalars['ID']['output'];
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_GraduationApplicationEvaluationConnection = {
  __typename?: 'Club_WorldFamilyClub_GraduationApplicationEvaluationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_GraduationApplicationEvaluationEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_GraduationApplicationEvaluation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_GraduationApplicationEvaluationEdge = {
  __typename?: 'Club_WorldFamilyClub_GraduationApplicationEvaluationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_GraduationApplicationEvaluation;
};

/** GraduationApplicationEvaluation */
export type Club_WorldFamilyClub_GraduationApplicationEvaluationFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_GraduationApplicationEvaluationFilterInput>>;
  /** [NAVIGATION] Application */
  application?: InputMaybe<Club_WorldFamilyClub_GraduationApplicationFilterInput>;
  /** [ID] ApplicationEvaluationId */
  applicationEvaluationId?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] ApplicationId */
  applicationId?: InputMaybe<IntOperationFilterInput>;
  /** [NAVIGATION] Evaluation */
  evaluation?: InputMaybe<Club_WorldFamilyClub_GraduationEvaluationFilterInput>;
  /** [NOT NULL] EvaluationId */
  evaluationId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_GraduationApplicationEvaluationFilterInput>>;
};

/** GraduationApplicationEvaluation */
export type Club_WorldFamilyClub_GraduationApplicationEvaluationInput = {
  /** [NAVIGATION] Application */
  application?: InputMaybe<Club_WorldFamilyClub_GraduationApplicationInput>;
  /** [ID] ApplicationEvaluationId */
  applicationEvaluationId?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] ApplicationId */
  applicationId?: InputMaybe<Scalars['Int']['input']>;
  /** [NAVIGATION] Evaluation */
  evaluation?: InputMaybe<Club_WorldFamilyClub_GraduationEvaluationInput>;
  /** [NOT NULL] EvaluationId */
  evaluationId?: InputMaybe<Scalars['Int']['input']>;
};

/** GraduationApplicationEvaluation */
export type Club_WorldFamilyClub_GraduationApplicationEvaluationSortInput = {
  /** [NAVIGATION] Application */
  application?: InputMaybe<Club_WorldFamilyClub_GraduationApplicationSortInput>;
  /** [ID] ApplicationEvaluationId */
  applicationEvaluationId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] ApplicationId */
  applicationId?: InputMaybe<SortEnumType>;
  /** [NAVIGATION] Evaluation */
  evaluation?: InputMaybe<Club_WorldFamilyClub_GraduationEvaluationSortInput>;
  /** [NOT NULL] EvaluationId */
  evaluationId?: InputMaybe<SortEnumType>;
};

/** GraduationApplication */
export type Club_WorldFamilyClub_GraduationApplicationFilterInput = {
  /** Age */
  age?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<Club_WorldFamilyClub_GraduationApplicationFilterInput>>;
  /** [NOT NULL] ApplicationDate */
  applicationDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** [ID] ApplicationId */
  applicationId?: InputMaybe<IntOperationFilterInput>;
  /** ApprovalDate */
  approvalDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** [NOT NULL] AudioFile */
  audioFile?: InputMaybe<StringOperationFilterInput>;
  /** ChildEnglishName */
  childEnglishName?: InputMaybe<StringOperationFilterInput>;
  /** ChildName */
  childName?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] ChildNo */
  childNo?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] CreatedTime */
  createdTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** Creator */
  creator?: InputMaybe<StringOperationFilterInput>;
  /** FinishDate */
  finishDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** [COLLECTION] GraduationApplicationEvaluations */
  graduationApplicationEvaluations?: InputMaybe<ListFilterInputTypeOfClub_WorldFamilyClub_GraduationApplicationEvaluationFilterInput>;
  /** [COLLECTION] GraduationSubApplications */
  graduationSubApplications?: InputMaybe<ListFilterInputTypeOfClub_WorldFamilyClub_GraduationSubApplicationFilterInput>;
  /** IsExcellent */
  isExcellent?: InputMaybe<BooleanOperationFilterInput>;
  /** [NOT NULL] IsGraduationSpeechSelectionAgreed */
  isGraduationSpeechSelectionAgreed?: InputMaybe<BooleanOperationFilterInput>;
  /** IsPassed */
  isPassed?: InputMaybe<BooleanOperationFilterInput>;
  /** [NOT NULL] Market */
  market?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] MemberNo */
  memberNo?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_GraduationApplicationFilterInput>>;
  /** OverallComment */
  overallComment?: InputMaybe<StringOperationFilterInput>;
  /** [NAVIGATION] Task */
  task?: InputMaybe<Club_WorldFamilyClub_GraduationApplicationTaskFilterInput>;
  /** [NOT NULL] TaskId */
  taskId?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] UpdatedTime */
  updatedTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** Updater */
  updater?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] VideoUrl */
  videoUrl?: InputMaybe<StringOperationFilterInput>;
  /** YearCount */
  yearCount?: InputMaybe<StringOperationFilterInput>;
};

/** GraduationApplication */
export type Club_WorldFamilyClub_GraduationApplicationInput = {
  /** Age */
  age?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] ApplicationDate */
  applicationDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** [ID] ApplicationId */
  applicationId?: InputMaybe<Scalars['Int']['input']>;
  /** ApprovalDate */
  approvalDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** [NOT NULL] AudioFile */
  audioFile?: InputMaybe<Scalars['String']['input']>;
  /** ChildEnglishName */
  childEnglishName?: InputMaybe<Scalars['String']['input']>;
  /** ChildName */
  childName?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] ChildNo */
  childNo?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] CreatedTime */
  createdTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Creator */
  creator?: InputMaybe<Scalars['String']['input']>;
  /** FinishDate */
  finishDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** [COLLECTION] GraduationApplicationEvaluations */
  graduationApplicationEvaluations?: InputMaybe<Array<InputMaybe<Club_WorldFamilyClub_GraduationApplicationEvaluationInput>>>;
  /** [COLLECTION] GraduationSubApplications */
  graduationSubApplications?: InputMaybe<Array<InputMaybe<Club_WorldFamilyClub_GraduationSubApplicationInput>>>;
  /** IsExcellent */
  isExcellent?: InputMaybe<Scalars['Boolean']['input']>;
  /** [NOT NULL] IsGraduationSpeechSelectionAgreed */
  isGraduationSpeechSelectionAgreed?: InputMaybe<Scalars['Boolean']['input']>;
  /** IsPassed */
  isPassed?: InputMaybe<Scalars['Boolean']['input']>;
  /** [NOT NULL] Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] MemberNo */
  memberNo?: InputMaybe<Scalars['String']['input']>;
  /** OverallComment */
  overallComment?: InputMaybe<Scalars['String']['input']>;
  /** [NAVIGATION] Task */
  task?: InputMaybe<Club_WorldFamilyClub_GraduationApplicationTaskInput>;
  /** [NOT NULL] TaskId */
  taskId?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] UpdatedTime */
  updatedTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Updater */
  updater?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] VideoUrl */
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  /** YearCount */
  yearCount?: InputMaybe<Scalars['String']['input']>;
};

/** GraduationApplication */
export type Club_WorldFamilyClub_GraduationApplicationSortInput = {
  /** Age */
  age?: InputMaybe<SortEnumType>;
  /** [NOT NULL] ApplicationDate */
  applicationDate?: InputMaybe<SortEnumType>;
  /** [ID] ApplicationId */
  applicationId?: InputMaybe<SortEnumType>;
  /** ApprovalDate */
  approvalDate?: InputMaybe<SortEnumType>;
  /** [NOT NULL] AudioFile */
  audioFile?: InputMaybe<SortEnumType>;
  /** ChildEnglishName */
  childEnglishName?: InputMaybe<SortEnumType>;
  /** ChildName */
  childName?: InputMaybe<SortEnumType>;
  /** [NOT NULL] ChildNo */
  childNo?: InputMaybe<SortEnumType>;
  /** [NOT NULL] CreatedTime */
  createdTime?: InputMaybe<SortEnumType>;
  /** Creator */
  creator?: InputMaybe<SortEnumType>;
  /** FinishDate */
  finishDate?: InputMaybe<SortEnumType>;
  /** IsExcellent */
  isExcellent?: InputMaybe<SortEnumType>;
  /** [NOT NULL] IsGraduationSpeechSelectionAgreed */
  isGraduationSpeechSelectionAgreed?: InputMaybe<SortEnumType>;
  /** IsPassed */
  isPassed?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Market */
  market?: InputMaybe<SortEnumType>;
  /** [NOT NULL] MemberNo */
  memberNo?: InputMaybe<SortEnumType>;
  /** OverallComment */
  overallComment?: InputMaybe<SortEnumType>;
  /** [NAVIGATION] Task */
  task?: InputMaybe<Club_WorldFamilyClub_GraduationApplicationTaskSortInput>;
  /** [NOT NULL] TaskId */
  taskId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] UpdatedTime */
  updatedTime?: InputMaybe<SortEnumType>;
  /** Updater */
  updater?: InputMaybe<SortEnumType>;
  /** [NOT NULL] VideoUrl */
  videoUrl?: InputMaybe<SortEnumType>;
  /** YearCount */
  yearCount?: InputMaybe<SortEnumType>;
};

/** GraduationApplicationSubTask */
export type Club_WorldFamilyClub_GraduationApplicationSubTask = Node & {
  __typename?: 'Club_WorldFamilyClub_GraduationApplicationSubTask';
  /** [COLLECTION] GraduationSubApplications */
  graduationSubApplications?: Maybe<Array<Maybe<Club_WorldFamilyClub_GraduationSubApplication>>>;
  /** [COLLECTION] GraduationSubTaskMarketDescriptions */
  graduationSubTaskMarketDescriptions?: Maybe<Array<Maybe<Club_WorldFamilyClub_GraduationSubTaskMarketDescription>>>;
  /** [ID] SubTaskId */
  id: Scalars['ID']['output'];
  /** SortId */
  sortId?: Maybe<Scalars['Int']['output']>;
  /** [NAVIGATION] Task */
  task?: Maybe<Club_WorldFamilyClub_GraduationApplicationTask>;
  /** [NOT NULL] TaskId */
  taskId?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_GraduationApplicationSubTaskConnection = {
  __typename?: 'Club_WorldFamilyClub_GraduationApplicationSubTaskConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_GraduationApplicationSubTaskEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_GraduationApplicationSubTask>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_GraduationApplicationSubTaskEdge = {
  __typename?: 'Club_WorldFamilyClub_GraduationApplicationSubTaskEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_GraduationApplicationSubTask;
};

/** GraduationApplicationSubTask */
export type Club_WorldFamilyClub_GraduationApplicationSubTaskFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_GraduationApplicationSubTaskFilterInput>>;
  /** [COLLECTION] GraduationSubApplications */
  graduationSubApplications?: InputMaybe<ListFilterInputTypeOfClub_WorldFamilyClub_GraduationSubApplicationFilterInput>;
  /** [COLLECTION] GraduationSubTaskMarketDescriptions */
  graduationSubTaskMarketDescriptions?: InputMaybe<ListFilterInputTypeOfClub_WorldFamilyClub_GraduationSubTaskMarketDescriptionFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_GraduationApplicationSubTaskFilterInput>>;
  /** SortId */
  sortId?: InputMaybe<IntOperationFilterInput>;
  /** [ID] SubTaskId */
  subTaskId?: InputMaybe<IntOperationFilterInput>;
  /** [NAVIGATION] Task */
  task?: InputMaybe<Club_WorldFamilyClub_GraduationApplicationTaskFilterInput>;
  /** [NOT NULL] TaskId */
  taskId?: InputMaybe<IntOperationFilterInput>;
};

/** GraduationApplicationSubTask */
export type Club_WorldFamilyClub_GraduationApplicationSubTaskInput = {
  /** [COLLECTION] GraduationSubApplications */
  graduationSubApplications?: InputMaybe<Array<InputMaybe<Club_WorldFamilyClub_GraduationSubApplicationInput>>>;
  /** [COLLECTION] GraduationSubTaskMarketDescriptions */
  graduationSubTaskMarketDescriptions?: InputMaybe<Array<InputMaybe<Club_WorldFamilyClub_GraduationSubTaskMarketDescriptionInput>>>;
  /** SortId */
  sortId?: InputMaybe<Scalars['Int']['input']>;
  /** [ID] SubTaskId */
  subTaskId?: InputMaybe<Scalars['Int']['input']>;
  /** [NAVIGATION] Task */
  task?: InputMaybe<Club_WorldFamilyClub_GraduationApplicationTaskInput>;
  /** [NOT NULL] TaskId */
  taskId?: InputMaybe<Scalars['Int']['input']>;
};

/** GraduationApplicationSubTask */
export type Club_WorldFamilyClub_GraduationApplicationSubTaskSortInput = {
  /** SortId */
  sortId?: InputMaybe<SortEnumType>;
  /** [ID] SubTaskId */
  subTaskId?: InputMaybe<SortEnumType>;
  /** [NAVIGATION] Task */
  task?: InputMaybe<Club_WorldFamilyClub_GraduationApplicationTaskSortInput>;
  /** [NOT NULL] TaskId */
  taskId?: InputMaybe<SortEnumType>;
};

/** GraduationApplicationTask */
export type Club_WorldFamilyClub_GraduationApplicationTask = Node & {
  __typename?: 'Club_WorldFamilyClub_GraduationApplicationTask';
  /** [COLLECTION] GraduationApplicationSubTasks */
  graduationApplicationSubTasks?: Maybe<Array<Maybe<Club_WorldFamilyClub_GraduationApplicationSubTask>>>;
  /** [COLLECTION] GraduationApplications */
  graduationApplications?: Maybe<Array<Maybe<Club_WorldFamilyClub_GraduationApplication>>>;
  /** [COLLECTION] GraduationEvaluations */
  graduationEvaluations?: Maybe<Array<Maybe<Club_WorldFamilyClub_GraduationEvaluation>>>;
  /** [COLLECTION] GraduationTaskMarketDescriptions */
  graduationTaskMarketDescriptions?: Maybe<Array<Maybe<Club_WorldFamilyClub_GraduationTaskMarketDescription>>>;
  /** [ID] TaskId */
  id: Scalars['ID']['output'];
  /** [NOT NULL] MaxSubmissionCount */
  maxSubmissionCount?: Maybe<Scalars['Int']['output']>;
  /** [NOT NULL] MinSubmissionCount */
  minSubmissionCount?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_GraduationApplicationTaskConnection = {
  __typename?: 'Club_WorldFamilyClub_GraduationApplicationTaskConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_GraduationApplicationTaskEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_GraduationApplicationTask>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_GraduationApplicationTaskEdge = {
  __typename?: 'Club_WorldFamilyClub_GraduationApplicationTaskEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_GraduationApplicationTask;
};

/** GraduationApplicationTask */
export type Club_WorldFamilyClub_GraduationApplicationTaskFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_GraduationApplicationTaskFilterInput>>;
  /** [COLLECTION] GraduationApplicationSubTasks */
  graduationApplicationSubTasks?: InputMaybe<ListFilterInputTypeOfClub_WorldFamilyClub_GraduationApplicationSubTaskFilterInput>;
  /** [COLLECTION] GraduationApplications */
  graduationApplications?: InputMaybe<ListFilterInputTypeOfClub_WorldFamilyClub_GraduationApplicationFilterInput>;
  /** [COLLECTION] GraduationEvaluations */
  graduationEvaluations?: InputMaybe<ListFilterInputTypeOfClub_WorldFamilyClub_GraduationEvaluationFilterInput>;
  /** [COLLECTION] GraduationTaskMarketDescriptions */
  graduationTaskMarketDescriptions?: InputMaybe<ListFilterInputTypeOfClub_WorldFamilyClub_GraduationTaskMarketDescriptionFilterInput>;
  /** [NOT NULL] MaxSubmissionCount */
  maxSubmissionCount?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] MinSubmissionCount */
  minSubmissionCount?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_GraduationApplicationTaskFilterInput>>;
  /** [ID] TaskId */
  taskId?: InputMaybe<IntOperationFilterInput>;
};

/** GraduationApplicationTask */
export type Club_WorldFamilyClub_GraduationApplicationTaskInput = {
  /** [COLLECTION] GraduationApplicationSubTasks */
  graduationApplicationSubTasks?: InputMaybe<Array<InputMaybe<Club_WorldFamilyClub_GraduationApplicationSubTaskInput>>>;
  /** [COLLECTION] GraduationApplications */
  graduationApplications?: InputMaybe<Array<InputMaybe<Club_WorldFamilyClub_GraduationApplicationInput>>>;
  /** [COLLECTION] GraduationEvaluations */
  graduationEvaluations?: InputMaybe<Array<InputMaybe<Club_WorldFamilyClub_GraduationEvaluationInput>>>;
  /** [COLLECTION] GraduationTaskMarketDescriptions */
  graduationTaskMarketDescriptions?: InputMaybe<Array<InputMaybe<Club_WorldFamilyClub_GraduationTaskMarketDescriptionInput>>>;
  /** [NOT NULL] MaxSubmissionCount */
  maxSubmissionCount?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] MinSubmissionCount */
  minSubmissionCount?: InputMaybe<Scalars['Int']['input']>;
  /** [ID] TaskId */
  taskId?: InputMaybe<Scalars['Int']['input']>;
};

/** GraduationApplicationTask */
export type Club_WorldFamilyClub_GraduationApplicationTaskSortInput = {
  /** [NOT NULL] MaxSubmissionCount */
  maxSubmissionCount?: InputMaybe<SortEnumType>;
  /** [NOT NULL] MinSubmissionCount */
  minSubmissionCount?: InputMaybe<SortEnumType>;
  /** [ID] TaskId */
  taskId?: InputMaybe<SortEnumType>;
};

/** GraduationChild */
export type Club_WorldFamilyClub_GraduationChild = Node & {
  __typename?: 'Club_WorldFamilyClub_GraduationChild';
  /** [NOT NULL] ChildEnglishName */
  childEnglishName?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] ChildHeight */
  childHeight?: Maybe<Scalars['Int']['output']>;
  /** [NOT NULL] ChildName */
  childName?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] ChildNo */
  childNo?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] ChildPhotoFilename */
  childPhotoFilename?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] ChildWeight */
  childWeight?: Maybe<Scalars['Int']['output']>;
  /** [NOT NULL] ChildWillingEnglishSpeech */
  childWillingEnglishSpeech?: Maybe<Scalars['Boolean']['output']>;
  /** [NOT NULL] CreatedTime */
  createdTime?: Maybe<Scalars['DateTime']['output']>;
  /** [NOT NULL] Creator */
  creator?: Maybe<Scalars['String']['output']>;
  /** [ID] Seq */
  id: Scalars['ID']['output'];
  /** [NOT NULL] IsCambridge */
  isCambridge?: Maybe<Scalars['Boolean']['output']>;
  /** [NOT NULL] IsGraduate */
  isGraduate?: Maybe<Scalars['Boolean']['output']>;
  /** [NOT NULL] IsSubmittedFromApp */
  isSubmittedFromApp?: Maybe<Scalars['Boolean']['output']>;
  /** [NOT NULL] Market */
  market?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] MemberNo */
  memberNo?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] ParentWillingChineseSpeech */
  parentWillingChineseSpeech?: Maybe<Scalars['Boolean']['output']>;
  /** [NOT NULL] UpdatedTime */
  updatedTime?: Maybe<Scalars['DateTime']['output']>;
  /** [NOT NULL] Updater */
  updater?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Year */
  year?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_GraduationChildConnection = {
  __typename?: 'Club_WorldFamilyClub_GraduationChildConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_GraduationChildEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_GraduationChild>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_GraduationChildEdge = {
  __typename?: 'Club_WorldFamilyClub_GraduationChildEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_GraduationChild;
};

/** GraduationChild */
export type Club_WorldFamilyClub_GraduationChildFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_GraduationChildFilterInput>>;
  /** [NOT NULL] ChildEnglishName */
  childEnglishName?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] ChildHeight */
  childHeight?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] ChildName */
  childName?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] ChildNo */
  childNo?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] ChildPhotoFilename */
  childPhotoFilename?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] ChildWeight */
  childWeight?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] ChildWillingEnglishSpeech */
  childWillingEnglishSpeech?: InputMaybe<BooleanOperationFilterInput>;
  /** [NOT NULL] CreatedTime */
  createdTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** [NOT NULL] Creator */
  creator?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] IsCambridge */
  isCambridge?: InputMaybe<BooleanOperationFilterInput>;
  /** [NOT NULL] IsGraduate */
  isGraduate?: InputMaybe<BooleanOperationFilterInput>;
  /** [NOT NULL] IsSubmittedFromApp */
  isSubmittedFromApp?: InputMaybe<BooleanOperationFilterInput>;
  /** [NOT NULL] Market */
  market?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] MemberNo */
  memberNo?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_GraduationChildFilterInput>>;
  /** [NOT NULL] ParentWillingChineseSpeech */
  parentWillingChineseSpeech?: InputMaybe<BooleanOperationFilterInput>;
  /** [ID] Seq */
  seq?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] UpdatedTime */
  updatedTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** [NOT NULL] Updater */
  updater?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] Year */
  year?: InputMaybe<IntOperationFilterInput>;
};

/** GraduationChild */
export type Club_WorldFamilyClub_GraduationChildInput = {
  /** [NOT NULL] ChildEnglishName */
  childEnglishName?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] ChildHeight */
  childHeight?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] ChildName */
  childName?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] ChildNo */
  childNo?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] ChildPhotoFilename */
  childPhotoFilename?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] ChildWeight */
  childWeight?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] ChildWillingEnglishSpeech */
  childWillingEnglishSpeech?: InputMaybe<Scalars['Boolean']['input']>;
  /** [NOT NULL] CreatedTime */
  createdTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** [NOT NULL] Creator */
  creator?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] IsCambridge */
  isCambridge?: InputMaybe<Scalars['Boolean']['input']>;
  /** [NOT NULL] IsGraduate */
  isGraduate?: InputMaybe<Scalars['Boolean']['input']>;
  /** [NOT NULL] IsSubmittedFromApp */
  isSubmittedFromApp?: InputMaybe<Scalars['Boolean']['input']>;
  /** [NOT NULL] Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] MemberNo */
  memberNo?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] ParentWillingChineseSpeech */
  parentWillingChineseSpeech?: InputMaybe<Scalars['Boolean']['input']>;
  /** [ID] Seq */
  seq?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] UpdatedTime */
  updatedTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** [NOT NULL] Updater */
  updater?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Year */
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** GraduationChildSetting */
export type Club_WorldFamilyClub_GraduationChildSetting = Node & {
  __typename?: 'Club_WorldFamilyClub_GraduationChildSetting';
  /** [NOT NULL] Deadline */
  deadline?: Maybe<Scalars['DateTime']['output']>;
  /** [ID] Seq */
  id: Scalars['ID']['output'];
  /** [NOT NULL] Market */
  market?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] StartDate */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  /** [NOT NULL] Year */
  year?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_GraduationChildSettingConnection = {
  __typename?: 'Club_WorldFamilyClub_GraduationChildSettingConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_GraduationChildSettingEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_GraduationChildSetting>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_GraduationChildSettingEdge = {
  __typename?: 'Club_WorldFamilyClub_GraduationChildSettingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_GraduationChildSetting;
};

/** GraduationChildSetting */
export type Club_WorldFamilyClub_GraduationChildSettingFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_GraduationChildSettingFilterInput>>;
  /** [NOT NULL] Deadline */
  deadline?: InputMaybe<DateTimeOperationFilterInput>;
  /** [NOT NULL] Market */
  market?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_GraduationChildSettingFilterInput>>;
  /** [ID] Seq */
  seq?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] StartDate */
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** [NOT NULL] Year */
  year?: InputMaybe<IntOperationFilterInput>;
};

/** GraduationChildSetting */
export type Club_WorldFamilyClub_GraduationChildSettingInput = {
  /** [NOT NULL] Deadline */
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  /** [NOT NULL] Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** [ID] Seq */
  seq?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] StartDate */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** [NOT NULL] Year */
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** GraduationChildSetting */
export type Club_WorldFamilyClub_GraduationChildSettingSortInput = {
  /** [NOT NULL] Deadline */
  deadline?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Market */
  market?: InputMaybe<SortEnumType>;
  /** [ID] Seq */
  seq?: InputMaybe<SortEnumType>;
  /** [NOT NULL] StartDate */
  startDate?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Year */
  year?: InputMaybe<SortEnumType>;
};

/** GraduationChild */
export type Club_WorldFamilyClub_GraduationChildSortInput = {
  /** [NOT NULL] ChildEnglishName */
  childEnglishName?: InputMaybe<SortEnumType>;
  /** [NOT NULL] ChildHeight */
  childHeight?: InputMaybe<SortEnumType>;
  /** [NOT NULL] ChildName */
  childName?: InputMaybe<SortEnumType>;
  /** [NOT NULL] ChildNo */
  childNo?: InputMaybe<SortEnumType>;
  /** [NOT NULL] ChildPhotoFilename */
  childPhotoFilename?: InputMaybe<SortEnumType>;
  /** [NOT NULL] ChildWeight */
  childWeight?: InputMaybe<SortEnumType>;
  /** [NOT NULL] ChildWillingEnglishSpeech */
  childWillingEnglishSpeech?: InputMaybe<SortEnumType>;
  /** [NOT NULL] CreatedTime */
  createdTime?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Creator */
  creator?: InputMaybe<SortEnumType>;
  /** [NOT NULL] IsCambridge */
  isCambridge?: InputMaybe<SortEnumType>;
  /** [NOT NULL] IsGraduate */
  isGraduate?: InputMaybe<SortEnumType>;
  /** [NOT NULL] IsSubmittedFromApp */
  isSubmittedFromApp?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Market */
  market?: InputMaybe<SortEnumType>;
  /** [NOT NULL] MemberNo */
  memberNo?: InputMaybe<SortEnumType>;
  /** [NOT NULL] ParentWillingChineseSpeech */
  parentWillingChineseSpeech?: InputMaybe<SortEnumType>;
  /** [ID] Seq */
  seq?: InputMaybe<SortEnumType>;
  /** [NOT NULL] UpdatedTime */
  updatedTime?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Updater */
  updater?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Year */
  year?: InputMaybe<SortEnumType>;
};

/** GraduationEvaluation */
export type Club_WorldFamilyClub_GraduationEvaluation = Node & {
  __typename?: 'Club_WorldFamilyClub_GraduationEvaluation';
  /** Evaluation */
  evaluation?: Maybe<Scalars['String']['output']>;
  /** [COLLECTION] GraduationApplicationEvaluations */
  graduationApplicationEvaluations?: Maybe<Array<Maybe<Club_WorldFamilyClub_GraduationApplicationEvaluation>>>;
  /** [ID] EvaluationId */
  id: Scalars['ID']['output'];
  /** [NOT NULL] Market */
  market?: Maybe<Scalars['String']['output']>;
  /** [NAVIGATION] Task */
  task?: Maybe<Club_WorldFamilyClub_GraduationApplicationTask>;
  /** [NOT NULL] TaskId */
  taskId?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_GraduationEvaluationConnection = {
  __typename?: 'Club_WorldFamilyClub_GraduationEvaluationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_GraduationEvaluationEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_GraduationEvaluation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_GraduationEvaluationEdge = {
  __typename?: 'Club_WorldFamilyClub_GraduationEvaluationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_GraduationEvaluation;
};

/** GraduationEvaluation */
export type Club_WorldFamilyClub_GraduationEvaluationFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_GraduationEvaluationFilterInput>>;
  /** Evaluation */
  evaluation?: InputMaybe<StringOperationFilterInput>;
  /** [ID] EvaluationId */
  evaluationId?: InputMaybe<IntOperationFilterInput>;
  /** [COLLECTION] GraduationApplicationEvaluations */
  graduationApplicationEvaluations?: InputMaybe<ListFilterInputTypeOfClub_WorldFamilyClub_GraduationApplicationEvaluationFilterInput>;
  /** [NOT NULL] Market */
  market?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_GraduationEvaluationFilterInput>>;
  /** [NAVIGATION] Task */
  task?: InputMaybe<Club_WorldFamilyClub_GraduationApplicationTaskFilterInput>;
  /** [NOT NULL] TaskId */
  taskId?: InputMaybe<IntOperationFilterInput>;
};

/** GraduationEvaluation */
export type Club_WorldFamilyClub_GraduationEvaluationInput = {
  /** Evaluation */
  evaluation?: InputMaybe<Scalars['String']['input']>;
  /** [ID] EvaluationId */
  evaluationId?: InputMaybe<Scalars['Int']['input']>;
  /** [COLLECTION] GraduationApplicationEvaluations */
  graduationApplicationEvaluations?: InputMaybe<Array<InputMaybe<Club_WorldFamilyClub_GraduationApplicationEvaluationInput>>>;
  /** [NOT NULL] Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** [NAVIGATION] Task */
  task?: InputMaybe<Club_WorldFamilyClub_GraduationApplicationTaskInput>;
  /** [NOT NULL] TaskId */
  taskId?: InputMaybe<Scalars['Int']['input']>;
};

/** GraduationEvaluation */
export type Club_WorldFamilyClub_GraduationEvaluationSortInput = {
  /** Evaluation */
  evaluation?: InputMaybe<SortEnumType>;
  /** [ID] EvaluationId */
  evaluationId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Market */
  market?: InputMaybe<SortEnumType>;
  /** [NAVIGATION] Task */
  task?: InputMaybe<Club_WorldFamilyClub_GraduationApplicationTaskSortInput>;
  /** [NOT NULL] TaskId */
  taskId?: InputMaybe<SortEnumType>;
};

/** GraduationNotification */
export type Club_WorldFamilyClub_GraduationNotification = Node & {
  __typename?: 'Club_WorldFamilyClub_GraduationNotification';
  /** [NOT NULL] AfNotificationId */
  afNotificationId?: Maybe<Scalars['Int']['output']>;
  /** [NOT NULL] ChildNo */
  childNo?: Maybe<Scalars['String']['output']>;
  /** [ID] Seq */
  id: Scalars['ID']['output'];
  /** [NOT NULL] MemberNo */
  memberNo?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Message */
  message?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Title */
  title?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_GraduationNotificationConnection = {
  __typename?: 'Club_WorldFamilyClub_GraduationNotificationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_GraduationNotificationEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_GraduationNotification>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_GraduationNotificationEdge = {
  __typename?: 'Club_WorldFamilyClub_GraduationNotificationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_GraduationNotification;
};

/** GraduationNotification */
export type Club_WorldFamilyClub_GraduationNotificationFilterInput = {
  /** [NOT NULL] AfNotificationId */
  afNotificationId?: InputMaybe<IntOperationFilterInput>;
  and?: InputMaybe<Array<Club_WorldFamilyClub_GraduationNotificationFilterInput>>;
  /** [NOT NULL] ChildNo */
  childNo?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] MemberNo */
  memberNo?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] Message */
  message?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_GraduationNotificationFilterInput>>;
  /** [ID] Seq */
  seq?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] Title */
  title?: InputMaybe<StringOperationFilterInput>;
};

/** GraduationNotification */
export type Club_WorldFamilyClub_GraduationNotificationInput = {
  /** [NOT NULL] AfNotificationId */
  afNotificationId?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] ChildNo */
  childNo?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] MemberNo */
  memberNo?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Message */
  message?: InputMaybe<Scalars['String']['input']>;
  /** [ID] Seq */
  seq?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] Title */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** GraduationNotification */
export type Club_WorldFamilyClub_GraduationNotificationSortInput = {
  /** [NOT NULL] AfNotificationId */
  afNotificationId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] ChildNo */
  childNo?: InputMaybe<SortEnumType>;
  /** [NOT NULL] MemberNo */
  memberNo?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Message */
  message?: InputMaybe<SortEnumType>;
  /** [ID] Seq */
  seq?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Title */
  title?: InputMaybe<SortEnumType>;
};

/** GraduationSubApplication */
export type Club_WorldFamilyClub_GraduationSubApplication = Node & {
  __typename?: 'Club_WorldFamilyClub_GraduationSubApplication';
  /** [NAVIGATION] Application */
  application?: Maybe<Club_WorldFamilyClub_GraduationApplication>;
  /** [NOT NULL] ApplicationId */
  applicationId?: Maybe<Scalars['Int']['output']>;
  /** [ID] SubApplicationId */
  id: Scalars['ID']['output'];
  /** [NAVIGATION] SubTask */
  subTask?: Maybe<Club_WorldFamilyClub_GraduationApplicationSubTask>;
  /** [NOT NULL] SubTaskId */
  subTaskId?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_GraduationSubApplicationConnection = {
  __typename?: 'Club_WorldFamilyClub_GraduationSubApplicationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_GraduationSubApplicationEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_GraduationSubApplication>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_GraduationSubApplicationEdge = {
  __typename?: 'Club_WorldFamilyClub_GraduationSubApplicationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_GraduationSubApplication;
};

/** GraduationSubApplication */
export type Club_WorldFamilyClub_GraduationSubApplicationFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_GraduationSubApplicationFilterInput>>;
  /** [NAVIGATION] Application */
  application?: InputMaybe<Club_WorldFamilyClub_GraduationApplicationFilterInput>;
  /** [NOT NULL] ApplicationId */
  applicationId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_GraduationSubApplicationFilterInput>>;
  /** [ID] SubApplicationId */
  subApplicationId?: InputMaybe<IntOperationFilterInput>;
  /** [NAVIGATION] SubTask */
  subTask?: InputMaybe<Club_WorldFamilyClub_GraduationApplicationSubTaskFilterInput>;
  /** [NOT NULL] SubTaskId */
  subTaskId?: InputMaybe<IntOperationFilterInput>;
};

/** GraduationSubApplication */
export type Club_WorldFamilyClub_GraduationSubApplicationInput = {
  /** [NAVIGATION] Application */
  application?: InputMaybe<Club_WorldFamilyClub_GraduationApplicationInput>;
  /** [NOT NULL] ApplicationId */
  applicationId?: InputMaybe<Scalars['Int']['input']>;
  /** [ID] SubApplicationId */
  subApplicationId?: InputMaybe<Scalars['Int']['input']>;
  /** [NAVIGATION] SubTask */
  subTask?: InputMaybe<Club_WorldFamilyClub_GraduationApplicationSubTaskInput>;
  /** [NOT NULL] SubTaskId */
  subTaskId?: InputMaybe<Scalars['Int']['input']>;
};

/** GraduationSubApplication */
export type Club_WorldFamilyClub_GraduationSubApplicationSortInput = {
  /** [NAVIGATION] Application */
  application?: InputMaybe<Club_WorldFamilyClub_GraduationApplicationSortInput>;
  /** [NOT NULL] ApplicationId */
  applicationId?: InputMaybe<SortEnumType>;
  /** [ID] SubApplicationId */
  subApplicationId?: InputMaybe<SortEnumType>;
  /** [NAVIGATION] SubTask */
  subTask?: InputMaybe<Club_WorldFamilyClub_GraduationApplicationSubTaskSortInput>;
  /** [NOT NULL] SubTaskId */
  subTaskId?: InputMaybe<SortEnumType>;
};

/** GraduationSubTaskMarketDescription */
export type Club_WorldFamilyClub_GraduationSubTaskMarketDescription = Node & {
  __typename?: 'Club_WorldFamilyClub_GraduationSubTaskMarketDescription';
  /** [ID] SubTaskMarketId */
  id: Scalars['ID']['output'];
  /** Market */
  market?: Maybe<Scalars['String']['output']>;
  /** [NAVIGATION] SubTask */
  subTask?: Maybe<Club_WorldFamilyClub_GraduationApplicationSubTask>;
  /** [NOT NULL] SubTaskId */
  subTaskId?: Maybe<Scalars['Int']['output']>;
  /** SubTaskName */
  subTaskName?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_GraduationSubTaskMarketDescriptionConnection = {
  __typename?: 'Club_WorldFamilyClub_GraduationSubTaskMarketDescriptionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_GraduationSubTaskMarketDescriptionEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_GraduationSubTaskMarketDescription>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_GraduationSubTaskMarketDescriptionEdge = {
  __typename?: 'Club_WorldFamilyClub_GraduationSubTaskMarketDescriptionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_GraduationSubTaskMarketDescription;
};

/** GraduationSubTaskMarketDescription */
export type Club_WorldFamilyClub_GraduationSubTaskMarketDescriptionFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_GraduationSubTaskMarketDescriptionFilterInput>>;
  /** Market */
  market?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_GraduationSubTaskMarketDescriptionFilterInput>>;
  /** [NAVIGATION] SubTask */
  subTask?: InputMaybe<Club_WorldFamilyClub_GraduationApplicationSubTaskFilterInput>;
  /** [NOT NULL] SubTaskId */
  subTaskId?: InputMaybe<IntOperationFilterInput>;
  /** [ID] SubTaskMarketId */
  subTaskMarketId?: InputMaybe<IntOperationFilterInput>;
  /** SubTaskName */
  subTaskName?: InputMaybe<StringOperationFilterInput>;
};

/** GraduationSubTaskMarketDescription */
export type Club_WorldFamilyClub_GraduationSubTaskMarketDescriptionInput = {
  /** Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** [NAVIGATION] SubTask */
  subTask?: InputMaybe<Club_WorldFamilyClub_GraduationApplicationSubTaskInput>;
  /** [NOT NULL] SubTaskId */
  subTaskId?: InputMaybe<Scalars['Int']['input']>;
  /** [ID] SubTaskMarketId */
  subTaskMarketId?: InputMaybe<Scalars['Int']['input']>;
  /** SubTaskName */
  subTaskName?: InputMaybe<Scalars['String']['input']>;
};

/** GraduationSubTaskMarketDescription */
export type Club_WorldFamilyClub_GraduationSubTaskMarketDescriptionSortInput = {
  /** Market */
  market?: InputMaybe<SortEnumType>;
  /** [NAVIGATION] SubTask */
  subTask?: InputMaybe<Club_WorldFamilyClub_GraduationApplicationSubTaskSortInput>;
  /** [NOT NULL] SubTaskId */
  subTaskId?: InputMaybe<SortEnumType>;
  /** [ID] SubTaskMarketId */
  subTaskMarketId?: InputMaybe<SortEnumType>;
  /** SubTaskName */
  subTaskName?: InputMaybe<SortEnumType>;
};

/** GraduationTaskMarketDescription */
export type Club_WorldFamilyClub_GraduationTaskMarketDescription = Node & {
  __typename?: 'Club_WorldFamilyClub_GraduationTaskMarketDescription';
  /** [ID] TaskMarketId */
  id: Scalars['ID']['output'];
  /** [NOT NULL] Market */
  market?: Maybe<Scalars['String']['output']>;
  /** [NAVIGATION] Task */
  task?: Maybe<Club_WorldFamilyClub_GraduationApplicationTask>;
  /** TaskDescription */
  taskDescription?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] TaskId */
  taskId?: Maybe<Scalars['Int']['output']>;
  /** TaskName */
  taskName?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_GraduationTaskMarketDescriptionConnection = {
  __typename?: 'Club_WorldFamilyClub_GraduationTaskMarketDescriptionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_GraduationTaskMarketDescriptionEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_GraduationTaskMarketDescription>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_GraduationTaskMarketDescriptionEdge = {
  __typename?: 'Club_WorldFamilyClub_GraduationTaskMarketDescriptionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_GraduationTaskMarketDescription;
};

/** GraduationTaskMarketDescription */
export type Club_WorldFamilyClub_GraduationTaskMarketDescriptionFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_GraduationTaskMarketDescriptionFilterInput>>;
  /** [NOT NULL] Market */
  market?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_GraduationTaskMarketDescriptionFilterInput>>;
  /** [NAVIGATION] Task */
  task?: InputMaybe<Club_WorldFamilyClub_GraduationApplicationTaskFilterInput>;
  /** TaskDescription */
  taskDescription?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] TaskId */
  taskId?: InputMaybe<IntOperationFilterInput>;
  /** [ID] TaskMarketId */
  taskMarketId?: InputMaybe<IntOperationFilterInput>;
  /** TaskName */
  taskName?: InputMaybe<StringOperationFilterInput>;
};

/** GraduationTaskMarketDescription */
export type Club_WorldFamilyClub_GraduationTaskMarketDescriptionInput = {
  /** [NOT NULL] Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** [NAVIGATION] Task */
  task?: InputMaybe<Club_WorldFamilyClub_GraduationApplicationTaskInput>;
  /** TaskDescription */
  taskDescription?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] TaskId */
  taskId?: InputMaybe<Scalars['Int']['input']>;
  /** [ID] TaskMarketId */
  taskMarketId?: InputMaybe<Scalars['Int']['input']>;
  /** TaskName */
  taskName?: InputMaybe<Scalars['String']['input']>;
};

/** GraduationTaskMarketDescription */
export type Club_WorldFamilyClub_GraduationTaskMarketDescriptionSortInput = {
  /** [NOT NULL] Market */
  market?: InputMaybe<SortEnumType>;
  /** [NAVIGATION] Task */
  task?: InputMaybe<Club_WorldFamilyClub_GraduationApplicationTaskSortInput>;
  /** TaskDescription */
  taskDescription?: InputMaybe<SortEnumType>;
  /** [NOT NULL] TaskId */
  taskId?: InputMaybe<SortEnumType>;
  /** [ID] TaskMarketId */
  taskMarketId?: InputMaybe<SortEnumType>;
  /** TaskName */
  taskName?: InputMaybe<SortEnumType>;
};

/** GraphqlAccess */
export type Club_WorldFamilyClub_GraphqlAccess = Node & {
  __typename?: 'Club_WorldFamilyClub_GraphqlAccess';
  /** AccessSchema */
  accessSchema?: Maybe<Scalars['String']['output']>;
  /** AccessSchemaHash */
  accessSchemaHash?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Database */
  database?: Maybe<Scalars['String']['output']>;
  /** [NAVIGATION] GraphqlSchema */
  graphqlSchema?: Maybe<Club_WorldFamilyClub_GraphqlSchema>;
  /** [NOT NULL] GraphqlSchemaId */
  graphqlSchemaId?: Maybe<Scalars['UUID']['output']>;
  /** [ID] GraphqlAccessId */
  id: Scalars['ID']['output'];
  /** [NOT NULL] ProjectId */
  projectId?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Server */
  server?: Maybe<Scalars['String']['output']>;
  /** UpdateTime */
  updateTime?: Maybe<Scalars['DateTime']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_GraphqlAccessConnection = {
  __typename?: 'Club_WorldFamilyClub_GraphqlAccessConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_GraphqlAccessEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_GraphqlAccess>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_GraphqlAccessEdge = {
  __typename?: 'Club_WorldFamilyClub_GraphqlAccessEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_GraphqlAccess;
};

/** GraphqlAccess */
export type Club_WorldFamilyClub_GraphqlAccessFilterInput = {
  /** AccessSchema */
  accessSchema?: InputMaybe<StringOperationFilterInput>;
  /** AccessSchemaHash */
  accessSchemaHash?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<Club_WorldFamilyClub_GraphqlAccessFilterInput>>;
  /** [NOT NULL] Database */
  database?: InputMaybe<StringOperationFilterInput>;
  /** [ID] GraphqlAccessId */
  graphqlAccessId?: InputMaybe<UuidOperationFilterInput>;
  /** [NAVIGATION] GraphqlSchema */
  graphqlSchema?: InputMaybe<Club_WorldFamilyClub_GraphqlSchemaFilterInput>;
  /** [NOT NULL] GraphqlSchemaId */
  graphqlSchemaId?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_GraphqlAccessFilterInput>>;
  /** [NOT NULL] ProjectId */
  projectId?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] Server */
  server?: InputMaybe<StringOperationFilterInput>;
  /** UpdateTime */
  updateTime?: InputMaybe<DateTimeOperationFilterInput>;
};

/** GraphqlAccess */
export type Club_WorldFamilyClub_GraphqlAccessInput = {
  /** AccessSchema */
  accessSchema?: InputMaybe<Scalars['String']['input']>;
  /** AccessSchemaHash */
  accessSchemaHash?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Database */
  database?: InputMaybe<Scalars['String']['input']>;
  /** [ID] GraphqlAccessId */
  graphqlAccessId?: InputMaybe<Scalars['UUID']['input']>;
  /** [NAVIGATION] GraphqlSchema */
  graphqlSchema?: InputMaybe<Club_WorldFamilyClub_GraphqlSchemaInput>;
  /** [NOT NULL] GraphqlSchemaId */
  graphqlSchemaId?: InputMaybe<Scalars['UUID']['input']>;
  /** [NOT NULL] ProjectId */
  projectId?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Server */
  server?: InputMaybe<Scalars['String']['input']>;
  /** UpdateTime */
  updateTime?: InputMaybe<Scalars['DateTime']['input']>;
};

/** GraphqlAccess */
export type Club_WorldFamilyClub_GraphqlAccessSortInput = {
  /** AccessSchema */
  accessSchema?: InputMaybe<SortEnumType>;
  /** AccessSchemaHash */
  accessSchemaHash?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Database */
  database?: InputMaybe<SortEnumType>;
  /** [ID] GraphqlAccessId */
  graphqlAccessId?: InputMaybe<SortEnumType>;
  /** [NAVIGATION] GraphqlSchema */
  graphqlSchema?: InputMaybe<Club_WorldFamilyClub_GraphqlSchemaSortInput>;
  /** [NOT NULL] GraphqlSchemaId */
  graphqlSchemaId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] ProjectId */
  projectId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Server */
  server?: InputMaybe<SortEnumType>;
  /** UpdateTime */
  updateTime?: InputMaybe<SortEnumType>;
};

/** GraphqlSchema */
export type Club_WorldFamilyClub_GraphqlSchema = Node & {
  __typename?: 'Club_WorldFamilyClub_GraphqlSchema';
  /** [NOT NULL] Database */
  database?: Maybe<Scalars['String']['output']>;
  /** [COLLECTION] GraphqlAccesses */
  graphqlAccesses?: Maybe<Array<Maybe<Club_WorldFamilyClub_GraphqlAccess>>>;
  /** [ID] GraphqlSchemaId */
  id: Scalars['ID']['output'];
  /** Schema */
  schema?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Server */
  server?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_GraphqlSchemaConnection = {
  __typename?: 'Club_WorldFamilyClub_GraphqlSchemaConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_GraphqlSchemaEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_GraphqlSchema>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_GraphqlSchemaEdge = {
  __typename?: 'Club_WorldFamilyClub_GraphqlSchemaEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_GraphqlSchema;
};

/** GraphqlSchema */
export type Club_WorldFamilyClub_GraphqlSchemaFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_GraphqlSchemaFilterInput>>;
  /** [NOT NULL] Database */
  database?: InputMaybe<StringOperationFilterInput>;
  /** [COLLECTION] GraphqlAccesses */
  graphqlAccesses?: InputMaybe<ListFilterInputTypeOfClub_WorldFamilyClub_GraphqlAccessFilterInput>;
  /** [ID] GraphqlSchemaId */
  graphqlSchemaId?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_GraphqlSchemaFilterInput>>;
  /** Schema */
  schema?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] Server */
  server?: InputMaybe<StringOperationFilterInput>;
};

/** GraphqlSchema */
export type Club_WorldFamilyClub_GraphqlSchemaInput = {
  /** [NOT NULL] Database */
  database?: InputMaybe<Scalars['String']['input']>;
  /** [COLLECTION] GraphqlAccesses */
  graphqlAccesses?: InputMaybe<Array<InputMaybe<Club_WorldFamilyClub_GraphqlAccessInput>>>;
  /** [ID] GraphqlSchemaId */
  graphqlSchemaId?: InputMaybe<Scalars['UUID']['input']>;
  /** Schema */
  schema?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Server */
  server?: InputMaybe<Scalars['String']['input']>;
};

/** GraphqlSchema */
export type Club_WorldFamilyClub_GraphqlSchemaSortInput = {
  /** [NOT NULL] Database */
  database?: InputMaybe<SortEnumType>;
  /** [ID] GraphqlSchemaId */
  graphqlSchemaId?: InputMaybe<SortEnumType>;
  /** Schema */
  schema?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Server */
  server?: InputMaybe<SortEnumType>;
};

/** HolidayAudio */
export type Club_WorldFamilyClub_HolidayAudio = Node & {
  __typename?: 'Club_WorldFamilyClub_HolidayAudio';
  /** AudioFileName */
  audioFileName?: Maybe<Scalars['String']['output']>;
  /** AudioSubTitle */
  audioSubTitle?: Maybe<Scalars['String']['output']>;
  /** AudioTitle */
  audioTitle?: Maybe<Scalars['String']['output']>;
  /** [ID] AudioId */
  id: Scalars['ID']['output'];
  /** SortId */
  sortId?: Maybe<Scalars['Int']['output']>;
  /** [NOT NULL] VideoId */
  videoId?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_HolidayAudioConnection = {
  __typename?: 'Club_WorldFamilyClub_HolidayAudioConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_HolidayAudioEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_HolidayAudio>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_HolidayAudioEdge = {
  __typename?: 'Club_WorldFamilyClub_HolidayAudioEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_HolidayAudio;
};

/** HolidayAudio */
export type Club_WorldFamilyClub_HolidayAudioFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_HolidayAudioFilterInput>>;
  /** AudioFileName */
  audioFileName?: InputMaybe<StringOperationFilterInput>;
  /** [ID] AudioId */
  audioId?: InputMaybe<IntOperationFilterInput>;
  /** AudioSubTitle */
  audioSubTitle?: InputMaybe<StringOperationFilterInput>;
  /** AudioTitle */
  audioTitle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_HolidayAudioFilterInput>>;
  /** SortId */
  sortId?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] VideoId */
  videoId?: InputMaybe<StringOperationFilterInput>;
};

/** HolidayAudio */
export type Club_WorldFamilyClub_HolidayAudioInput = {
  /** AudioFileName */
  audioFileName?: InputMaybe<Scalars['String']['input']>;
  /** [ID] AudioId */
  audioId?: InputMaybe<Scalars['Int']['input']>;
  /** AudioSubTitle */
  audioSubTitle?: InputMaybe<Scalars['String']['input']>;
  /** AudioTitle */
  audioTitle?: InputMaybe<Scalars['String']['input']>;
  /** SortId */
  sortId?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] VideoId */
  videoId?: InputMaybe<Scalars['String']['input']>;
};

/** HolidayAudio */
export type Club_WorldFamilyClub_HolidayAudioSortInput = {
  /** AudioFileName */
  audioFileName?: InputMaybe<SortEnumType>;
  /** [ID] AudioId */
  audioId?: InputMaybe<SortEnumType>;
  /** AudioSubTitle */
  audioSubTitle?: InputMaybe<SortEnumType>;
  /** AudioTitle */
  audioTitle?: InputMaybe<SortEnumType>;
  /** SortId */
  sortId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] VideoId */
  videoId?: InputMaybe<SortEnumType>;
};

/** HolidaySetting */
export type Club_WorldFamilyClub_HolidaySetting = Node & {
  __typename?: 'Club_WorldFamilyClub_HolidaySetting';
  /** AfNotificationId */
  afNotificationId?: Maybe<Scalars['Int']['output']>;
  /** HolidayName */
  holidayName?: Maybe<Scalars['String']['output']>;
  /** [ID] HolidaySettingId */
  id: Scalars['ID']['output'];
  /** Market */
  market?: Maybe<Scalars['String']['output']>;
  /** PromotionMessage */
  promotionMessage?: Maybe<Scalars['String']['output']>;
  /** PromotionMessageEn */
  promotionMessageEn?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_HolidaySettingConnection = {
  __typename?: 'Club_WorldFamilyClub_HolidaySettingConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_HolidaySettingEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_HolidaySetting>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_HolidaySettingEdge = {
  __typename?: 'Club_WorldFamilyClub_HolidaySettingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_HolidaySetting;
};

/** HolidaySetting */
export type Club_WorldFamilyClub_HolidaySettingFilterInput = {
  /** AfNotificationId */
  afNotificationId?: InputMaybe<IntOperationFilterInput>;
  and?: InputMaybe<Array<Club_WorldFamilyClub_HolidaySettingFilterInput>>;
  /** HolidayName */
  holidayName?: InputMaybe<StringOperationFilterInput>;
  /** [ID] HolidaySettingId */
  holidaySettingId?: InputMaybe<IntOperationFilterInput>;
  /** Market */
  market?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_HolidaySettingFilterInput>>;
  /** PromotionMessage */
  promotionMessage?: InputMaybe<StringOperationFilterInput>;
  /** PromotionMessageEn */
  promotionMessageEn?: InputMaybe<StringOperationFilterInput>;
};

/** HolidaySetting */
export type Club_WorldFamilyClub_HolidaySettingInput = {
  /** AfNotificationId */
  afNotificationId?: InputMaybe<Scalars['Int']['input']>;
  /** HolidayName */
  holidayName?: InputMaybe<Scalars['String']['input']>;
  /** [ID] HolidaySettingId */
  holidaySettingId?: InputMaybe<Scalars['Int']['input']>;
  /** Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** PromotionMessage */
  promotionMessage?: InputMaybe<Scalars['String']['input']>;
  /** PromotionMessageEn */
  promotionMessageEn?: InputMaybe<Scalars['String']['input']>;
};

/** HolidaySetting */
export type Club_WorldFamilyClub_HolidaySettingSortInput = {
  /** AfNotificationId */
  afNotificationId?: InputMaybe<SortEnumType>;
  /** HolidayName */
  holidayName?: InputMaybe<SortEnumType>;
  /** [ID] HolidaySettingId */
  holidaySettingId?: InputMaybe<SortEnumType>;
  /** Market */
  market?: InputMaybe<SortEnumType>;
  /** PromotionMessage */
  promotionMessage?: InputMaybe<SortEnumType>;
  /** PromotionMessageEn */
  promotionMessageEn?: InputMaybe<SortEnumType>;
};

/** HolidayVideo */
export type Club_WorldFamilyClub_HolidayVideo = Node & {
  __typename?: 'Club_WorldFamilyClub_HolidayVideo';
  /** AlbumSeries */
  albumSeries?: Maybe<Scalars['String']['output']>;
  /** AudioCoverFileName */
  audioCoverFileName?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] HasAudio */
  hasAudio?: Maybe<Scalars['Boolean']['output']>;
  /** HasSubtitleFile */
  hasSubtitleFile?: Maybe<Scalars['Boolean']['output']>;
  /** [ID] VideoId */
  id: Scalars['ID']['output'];
  /** JapanContent */
  japanContent?: Maybe<Scalars['String']['output']>;
  /** PreviewVimeoId1 */
  previewVimeoId1?: Maybe<Scalars['String']['output']>;
  /** PreviewVimeoId2 */
  previewVimeoId2?: Maybe<Scalars['String']['output']>;
  /** PromotionImage */
  promotionImage?: Maybe<Scalars['String']['output']>;
  /** StayTunedThumbnail */
  stayTunedThumbnail?: Maybe<Scalars['String']['output']>;
  /** VideoIntro */
  videoIntro?: Maybe<Scalars['String']['output']>;
  /** VideoTitle */
  videoTitle?: Maybe<Scalars['String']['output']>;
  /** VideoVimeoId */
  videoVimeoId?: Maybe<Scalars['String']['output']>;
};

/** HolidayVideoBonusEntitlementTest */
export type Club_WorldFamilyClub_HolidayVideoBonusEntitlementTest = Node & {
  __typename?: 'Club_WorldFamilyClub_HolidayVideoBonusEntitlementTest';
  /** [NOT NULL] HolidayVideoContent */
  holidayVideoContent?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] HolidayVideoFrom */
  holidayVideoFrom?: Maybe<Scalars['DateTime']['output']>;
  /** [NOT NULL] HolidayVideoType */
  holidayVideoType?: Maybe<Scalars['String']['output']>;
  /** [ID] HolidayVideoBonusEntitlementTestId */
  id: Scalars['ID']['output'];
  /** [NOT NULL] MemberNumber */
  memberNumber?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_HolidayVideoBonusEntitlementTestConnection = {
  __typename?: 'Club_WorldFamilyClub_HolidayVideoBonusEntitlementTestConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_HolidayVideoBonusEntitlementTestEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_HolidayVideoBonusEntitlementTest>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_HolidayVideoBonusEntitlementTestEdge = {
  __typename?: 'Club_WorldFamilyClub_HolidayVideoBonusEntitlementTestEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_HolidayVideoBonusEntitlementTest;
};

/** HolidayVideoBonusEntitlementTest */
export type Club_WorldFamilyClub_HolidayVideoBonusEntitlementTestFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_HolidayVideoBonusEntitlementTestFilterInput>>;
  /** [ID] HolidayVideoBonusEntitlementTestId */
  holidayVideoBonusEntitlementTestId?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] HolidayVideoContent */
  holidayVideoContent?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] HolidayVideoFrom */
  holidayVideoFrom?: InputMaybe<DateTimeOperationFilterInput>;
  /** [NOT NULL] HolidayVideoType */
  holidayVideoType?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] MemberNumber */
  memberNumber?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_HolidayVideoBonusEntitlementTestFilterInput>>;
};

/** HolidayVideoBonusEntitlementTest */
export type Club_WorldFamilyClub_HolidayVideoBonusEntitlementTestInput = {
  /** [ID] HolidayVideoBonusEntitlementTestId */
  holidayVideoBonusEntitlementTestId?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] HolidayVideoContent */
  holidayVideoContent?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] HolidayVideoFrom */
  holidayVideoFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /** [NOT NULL] HolidayVideoType */
  holidayVideoType?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] MemberNumber */
  memberNumber?: InputMaybe<Scalars['String']['input']>;
};

/** HolidayVideoBonusEntitlementTest */
export type Club_WorldFamilyClub_HolidayVideoBonusEntitlementTestSortInput = {
  /** [ID] HolidayVideoBonusEntitlementTestId */
  holidayVideoBonusEntitlementTestId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] HolidayVideoContent */
  holidayVideoContent?: InputMaybe<SortEnumType>;
  /** [NOT NULL] HolidayVideoFrom */
  holidayVideoFrom?: InputMaybe<SortEnumType>;
  /** [NOT NULL] HolidayVideoType */
  holidayVideoType?: InputMaybe<SortEnumType>;
  /** [NOT NULL] MemberNumber */
  memberNumber?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_HolidayVideoConnection = {
  __typename?: 'Club_WorldFamilyClub_HolidayVideoConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_HolidayVideoEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_HolidayVideo>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_HolidayVideoEdge = {
  __typename?: 'Club_WorldFamilyClub_HolidayVideoEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_HolidayVideo;
};

/** HolidayVideo */
export type Club_WorldFamilyClub_HolidayVideoFilterInput = {
  /** AlbumSeries */
  albumSeries?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<Club_WorldFamilyClub_HolidayVideoFilterInput>>;
  /** AudioCoverFileName */
  audioCoverFileName?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] HasAudio */
  hasAudio?: InputMaybe<BooleanOperationFilterInput>;
  /** HasSubtitleFile */
  hasSubtitleFile?: InputMaybe<BooleanOperationFilterInput>;
  /** JapanContent */
  japanContent?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_HolidayVideoFilterInput>>;
  /** PreviewVimeoId1 */
  previewVimeoId1?: InputMaybe<StringOperationFilterInput>;
  /** PreviewVimeoId2 */
  previewVimeoId2?: InputMaybe<StringOperationFilterInput>;
  /** PromotionImage */
  promotionImage?: InputMaybe<StringOperationFilterInput>;
  /** StayTunedThumbnail */
  stayTunedThumbnail?: InputMaybe<StringOperationFilterInput>;
  /** [ID] VideoId */
  videoId?: InputMaybe<StringOperationFilterInput>;
  /** VideoIntro */
  videoIntro?: InputMaybe<StringOperationFilterInput>;
  /** VideoTitle */
  videoTitle?: InputMaybe<StringOperationFilterInput>;
  /** VideoVimeoId */
  videoVimeoId?: InputMaybe<StringOperationFilterInput>;
};

/** HolidayVideo */
export type Club_WorldFamilyClub_HolidayVideoInput = {
  /** AlbumSeries */
  albumSeries?: InputMaybe<Scalars['String']['input']>;
  /** AudioCoverFileName */
  audioCoverFileName?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] HasAudio */
  hasAudio?: InputMaybe<Scalars['Boolean']['input']>;
  /** HasSubtitleFile */
  hasSubtitleFile?: InputMaybe<Scalars['Boolean']['input']>;
  /** JapanContent */
  japanContent?: InputMaybe<Scalars['String']['input']>;
  /** PreviewVimeoId1 */
  previewVimeoId1?: InputMaybe<Scalars['String']['input']>;
  /** PreviewVimeoId2 */
  previewVimeoId2?: InputMaybe<Scalars['String']['input']>;
  /** PromotionImage */
  promotionImage?: InputMaybe<Scalars['String']['input']>;
  /** StayTunedThumbnail */
  stayTunedThumbnail?: InputMaybe<Scalars['String']['input']>;
  /** [ID] VideoId */
  videoId?: InputMaybe<Scalars['String']['input']>;
  /** VideoIntro */
  videoIntro?: InputMaybe<Scalars['String']['input']>;
  /** VideoTitle */
  videoTitle?: InputMaybe<Scalars['String']['input']>;
  /** VideoVimeoId */
  videoVimeoId?: InputMaybe<Scalars['String']['input']>;
};

/** HolidayVideoMarket */
export type Club_WorldFamilyClub_HolidayVideoMarket = Node & {
  __typename?: 'Club_WorldFamilyClub_HolidayVideoMarket';
  /** [ID] VideoMarketId */
  id: Scalars['ID']['output'];
  /** Market */
  market?: Maybe<Scalars['String']['output']>;
  /** VideoId */
  videoId?: Maybe<Scalars['String']['output']>;
  /** VideoIntro */
  videoIntro?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_HolidayVideoMarketConnection = {
  __typename?: 'Club_WorldFamilyClub_HolidayVideoMarketConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_HolidayVideoMarketEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_HolidayVideoMarket>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_HolidayVideoMarketEdge = {
  __typename?: 'Club_WorldFamilyClub_HolidayVideoMarketEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_HolidayVideoMarket;
};

/** HolidayVideoMarket */
export type Club_WorldFamilyClub_HolidayVideoMarketFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_HolidayVideoMarketFilterInput>>;
  /** Market */
  market?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_HolidayVideoMarketFilterInput>>;
  /** VideoId */
  videoId?: InputMaybe<StringOperationFilterInput>;
  /** VideoIntro */
  videoIntro?: InputMaybe<StringOperationFilterInput>;
  /** [ID] VideoMarketId */
  videoMarketId?: InputMaybe<IntOperationFilterInput>;
};

/** HolidayVideoMarket */
export type Club_WorldFamilyClub_HolidayVideoMarketInput = {
  /** Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** VideoId */
  videoId?: InputMaybe<Scalars['String']['input']>;
  /** VideoIntro */
  videoIntro?: InputMaybe<Scalars['String']['input']>;
  /** [ID] VideoMarketId */
  videoMarketId?: InputMaybe<Scalars['Int']['input']>;
};

/** HolidayVideoMarketSetting */
export type Club_WorldFamilyClub_HolidayVideoMarketSetting = Node & {
  __typename?: 'Club_WorldFamilyClub_HolidayVideoMarketSetting';
  /** [NOT NULL] FirstPromotionDate */
  firstPromotionDate?: Maybe<Scalars['DateTime']['output']>;
  /** HolidayDate */
  holidayDate?: Maybe<Scalars['DateTime']['output']>;
  /** HolidayName */
  holidayName?: Maybe<Scalars['String']['output']>;
  /** [ID] SettingId */
  id: Scalars['ID']['output'];
  /** Market */
  market?: Maybe<Scalars['String']['output']>;
  /** MemberJoinDateFrom */
  memberJoinDateFrom?: Maybe<Scalars['DateTime']['output']>;
  /** MemberJoinDateTo */
  memberJoinDateTo?: Maybe<Scalars['DateTime']['output']>;
  /** [NOT NULL] PromotionEndDate */
  promotionEndDate?: Maybe<Scalars['DateTime']['output']>;
  /** PromotionVideoId */
  promotionVideoId?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] SecondPromotionDate */
  secondPromotionDate?: Maybe<Scalars['DateTime']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_HolidayVideoMarketSettingConnection = {
  __typename?: 'Club_WorldFamilyClub_HolidayVideoMarketSettingConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_HolidayVideoMarketSettingEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_HolidayVideoMarketSetting>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_HolidayVideoMarketSettingEdge = {
  __typename?: 'Club_WorldFamilyClub_HolidayVideoMarketSettingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_HolidayVideoMarketSetting;
};

/** HolidayVideoMarketSetting */
export type Club_WorldFamilyClub_HolidayVideoMarketSettingFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_HolidayVideoMarketSettingFilterInput>>;
  /** [NOT NULL] FirstPromotionDate */
  firstPromotionDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** HolidayDate */
  holidayDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** HolidayName */
  holidayName?: InputMaybe<StringOperationFilterInput>;
  /** Market */
  market?: InputMaybe<StringOperationFilterInput>;
  /** MemberJoinDateFrom */
  memberJoinDateFrom?: InputMaybe<DateTimeOperationFilterInput>;
  /** MemberJoinDateTo */
  memberJoinDateTo?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_HolidayVideoMarketSettingFilterInput>>;
  /** [NOT NULL] PromotionEndDate */
  promotionEndDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** PromotionVideoId */
  promotionVideoId?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] SecondPromotionDate */
  secondPromotionDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** [ID] SettingId */
  settingId?: InputMaybe<IntOperationFilterInput>;
};

/** HolidayVideoMarketSetting */
export type Club_WorldFamilyClub_HolidayVideoMarketSettingInput = {
  /** [NOT NULL] FirstPromotionDate */
  firstPromotionDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** HolidayDate */
  holidayDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** HolidayName */
  holidayName?: InputMaybe<Scalars['String']['input']>;
  /** Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** MemberJoinDateFrom */
  memberJoinDateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /** MemberJoinDateTo */
  memberJoinDateTo?: InputMaybe<Scalars['DateTime']['input']>;
  /** [NOT NULL] PromotionEndDate */
  promotionEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** PromotionVideoId */
  promotionVideoId?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] SecondPromotionDate */
  secondPromotionDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** [ID] SettingId */
  settingId?: InputMaybe<Scalars['Int']['input']>;
};

/** HolidayVideoMarketSetting */
export type Club_WorldFamilyClub_HolidayVideoMarketSettingSortInput = {
  /** [NOT NULL] FirstPromotionDate */
  firstPromotionDate?: InputMaybe<SortEnumType>;
  /** HolidayDate */
  holidayDate?: InputMaybe<SortEnumType>;
  /** HolidayName */
  holidayName?: InputMaybe<SortEnumType>;
  /** Market */
  market?: InputMaybe<SortEnumType>;
  /** MemberJoinDateFrom */
  memberJoinDateFrom?: InputMaybe<SortEnumType>;
  /** MemberJoinDateTo */
  memberJoinDateTo?: InputMaybe<SortEnumType>;
  /** [NOT NULL] PromotionEndDate */
  promotionEndDate?: InputMaybe<SortEnumType>;
  /** PromotionVideoId */
  promotionVideoId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] SecondPromotionDate */
  secondPromotionDate?: InputMaybe<SortEnumType>;
  /** [ID] SettingId */
  settingId?: InputMaybe<SortEnumType>;
};

/** HolidayVideoMarket */
export type Club_WorldFamilyClub_HolidayVideoMarketSortInput = {
  /** Market */
  market?: InputMaybe<SortEnumType>;
  /** VideoId */
  videoId?: InputMaybe<SortEnumType>;
  /** VideoIntro */
  videoIntro?: InputMaybe<SortEnumType>;
  /** [ID] VideoMarketId */
  videoMarketId?: InputMaybe<SortEnumType>;
};

/** HolidayVideoMember */
export type Club_WorldFamilyClub_HolidayVideoMember = Node & {
  __typename?: 'Club_WorldFamilyClub_HolidayVideoMember';
  /** CreatedTime */
  createdTime?: Maybe<Scalars['DateTime']['output']>;
  /** [ID] Sid */
  id: Scalars['ID']['output'];
  /** Market */
  market?: Maybe<Scalars['String']['output']>;
  /** MemberNo */
  memberNo?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] SettingId */
  settingId?: Maybe<Scalars['Int']['output']>;
  /** VideoId */
  videoId?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_HolidayVideoMemberConnection = {
  __typename?: 'Club_WorldFamilyClub_HolidayVideoMemberConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_HolidayVideoMemberEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_HolidayVideoMember>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_HolidayVideoMemberEdge = {
  __typename?: 'Club_WorldFamilyClub_HolidayVideoMemberEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_HolidayVideoMember;
};

/** HolidayVideoMember */
export type Club_WorldFamilyClub_HolidayVideoMemberFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_HolidayVideoMemberFilterInput>>;
  /** CreatedTime */
  createdTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** Market */
  market?: InputMaybe<StringOperationFilterInput>;
  /** MemberNo */
  memberNo?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_HolidayVideoMemberFilterInput>>;
  /** [NOT NULL] SettingId */
  settingId?: InputMaybe<IntOperationFilterInput>;
  /** [ID] Sid */
  sid?: InputMaybe<IntOperationFilterInput>;
  /** VideoId */
  videoId?: InputMaybe<StringOperationFilterInput>;
};

/** HolidayVideoMember */
export type Club_WorldFamilyClub_HolidayVideoMemberInput = {
  /** CreatedTime */
  createdTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** MemberNo */
  memberNo?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] SettingId */
  settingId?: InputMaybe<Scalars['Int']['input']>;
  /** [ID] Sid */
  sid?: InputMaybe<Scalars['Int']['input']>;
  /** VideoId */
  videoId?: InputMaybe<Scalars['String']['input']>;
};

/** HolidayVideoMember */
export type Club_WorldFamilyClub_HolidayVideoMemberSortInput = {
  /** CreatedTime */
  createdTime?: InputMaybe<SortEnumType>;
  /** Market */
  market?: InputMaybe<SortEnumType>;
  /** MemberNo */
  memberNo?: InputMaybe<SortEnumType>;
  /** [NOT NULL] SettingId */
  settingId?: InputMaybe<SortEnumType>;
  /** [ID] Sid */
  sid?: InputMaybe<SortEnumType>;
  /** VideoId */
  videoId?: InputMaybe<SortEnumType>;
};

/** HolidayVideo */
export type Club_WorldFamilyClub_HolidayVideoSortInput = {
  /** AlbumSeries */
  albumSeries?: InputMaybe<SortEnumType>;
  /** AudioCoverFileName */
  audioCoverFileName?: InputMaybe<SortEnumType>;
  /** [NOT NULL] HasAudio */
  hasAudio?: InputMaybe<SortEnumType>;
  /** HasSubtitleFile */
  hasSubtitleFile?: InputMaybe<SortEnumType>;
  /** JapanContent */
  japanContent?: InputMaybe<SortEnumType>;
  /** PreviewVimeoId1 */
  previewVimeoId1?: InputMaybe<SortEnumType>;
  /** PreviewVimeoId2 */
  previewVimeoId2?: InputMaybe<SortEnumType>;
  /** PromotionImage */
  promotionImage?: InputMaybe<SortEnumType>;
  /** StayTunedThumbnail */
  stayTunedThumbnail?: InputMaybe<SortEnumType>;
  /** [ID] VideoId */
  videoId?: InputMaybe<SortEnumType>;
  /** VideoIntro */
  videoIntro?: InputMaybe<SortEnumType>;
  /** VideoTitle */
  videoTitle?: InputMaybe<SortEnumType>;
  /** VideoVimeoId */
  videoVimeoId?: InputMaybe<SortEnumType>;
};

/** KidsWorldVideo */
export type Club_WorldFamilyClub_KidsWorldVideo = Node & {
  __typename?: 'Club_WorldFamilyClub_KidsWorldVideo';
  /** CreatedTime */
  createdTime?: Maybe<Scalars['DateTime']['output']>;
  /** CreatedUser */
  createdUser?: Maybe<Scalars['String']['output']>;
  /** [ID] KidsWorldVideoId */
  id: Scalars['ID']['output'];
  /** ThumbnailUrl1 */
  thumbnailUrl1?: Maybe<Scalars['String']['output']>;
  /** ThumbnailUrl2 */
  thumbnailUrl2?: Maybe<Scalars['String']['output']>;
  /** ThumbnailUrl3 */
  thumbnailUrl3?: Maybe<Scalars['String']['output']>;
  /** ThumbnailUrl4 */
  thumbnailUrl4?: Maybe<Scalars['String']['output']>;
  /** ThumbnailUrl5 */
  thumbnailUrl5?: Maybe<Scalars['String']['output']>;
  /** Title1 */
  title1?: Maybe<Scalars['String']['output']>;
  /** Title2 */
  title2?: Maybe<Scalars['String']['output']>;
  /** Title3 */
  title3?: Maybe<Scalars['String']['output']>;
  /** Title4 */
  title4?: Maybe<Scalars['String']['output']>;
  /** Title5 */
  title5?: Maybe<Scalars['String']['output']>;
  /** UpdatedTime */
  updatedTime?: Maybe<Scalars['DateTime']['output']>;
  /** UpdatedUser */
  updatedUser?: Maybe<Scalars['String']['output']>;
  /** VimeoId1 */
  vimeoId1?: Maybe<Scalars['String']['output']>;
  /** VimeoId2 */
  vimeoId2?: Maybe<Scalars['String']['output']>;
  /** VimeoId3 */
  vimeoId3?: Maybe<Scalars['String']['output']>;
  /** VimeoId4 */
  vimeoId4?: Maybe<Scalars['String']['output']>;
  /** VimeoId5 */
  vimeoId5?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] YearAndMonth */
  yearAndMonth?: Maybe<Scalars['DateTime']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_KidsWorldVideoConnection = {
  __typename?: 'Club_WorldFamilyClub_KidsWorldVideoConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_KidsWorldVideoEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_KidsWorldVideo>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_KidsWorldVideoEdge = {
  __typename?: 'Club_WorldFamilyClub_KidsWorldVideoEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_KidsWorldVideo;
};

/** KidsWorldVideo */
export type Club_WorldFamilyClub_KidsWorldVideoFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_KidsWorldVideoFilterInput>>;
  /** CreatedTime */
  createdTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** CreatedUser */
  createdUser?: InputMaybe<StringOperationFilterInput>;
  /** [ID] KidsWorldVideoId */
  kidsWorldVideoId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_KidsWorldVideoFilterInput>>;
  /** ThumbnailUrl1 */
  thumbnailUrl1?: InputMaybe<StringOperationFilterInput>;
  /** ThumbnailUrl2 */
  thumbnailUrl2?: InputMaybe<StringOperationFilterInput>;
  /** ThumbnailUrl3 */
  thumbnailUrl3?: InputMaybe<StringOperationFilterInput>;
  /** ThumbnailUrl4 */
  thumbnailUrl4?: InputMaybe<StringOperationFilterInput>;
  /** ThumbnailUrl5 */
  thumbnailUrl5?: InputMaybe<StringOperationFilterInput>;
  /** Title1 */
  title1?: InputMaybe<StringOperationFilterInput>;
  /** Title2 */
  title2?: InputMaybe<StringOperationFilterInput>;
  /** Title3 */
  title3?: InputMaybe<StringOperationFilterInput>;
  /** Title4 */
  title4?: InputMaybe<StringOperationFilterInput>;
  /** Title5 */
  title5?: InputMaybe<StringOperationFilterInput>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** UpdatedUser */
  updatedUser?: InputMaybe<StringOperationFilterInput>;
  /** VimeoId1 */
  vimeoId1?: InputMaybe<StringOperationFilterInput>;
  /** VimeoId2 */
  vimeoId2?: InputMaybe<StringOperationFilterInput>;
  /** VimeoId3 */
  vimeoId3?: InputMaybe<StringOperationFilterInput>;
  /** VimeoId4 */
  vimeoId4?: InputMaybe<StringOperationFilterInput>;
  /** VimeoId5 */
  vimeoId5?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] YearAndMonth */
  yearAndMonth?: InputMaybe<DateTimeOperationFilterInput>;
};

/** KidsWorldVideo */
export type Club_WorldFamilyClub_KidsWorldVideoInput = {
  /** CreatedTime */
  createdTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** CreatedUser */
  createdUser?: InputMaybe<Scalars['String']['input']>;
  /** [ID] KidsWorldVideoId */
  kidsWorldVideoId?: InputMaybe<Scalars['Int']['input']>;
  /** ThumbnailUrl1 */
  thumbnailUrl1?: InputMaybe<Scalars['String']['input']>;
  /** ThumbnailUrl2 */
  thumbnailUrl2?: InputMaybe<Scalars['String']['input']>;
  /** ThumbnailUrl3 */
  thumbnailUrl3?: InputMaybe<Scalars['String']['input']>;
  /** ThumbnailUrl4 */
  thumbnailUrl4?: InputMaybe<Scalars['String']['input']>;
  /** ThumbnailUrl5 */
  thumbnailUrl5?: InputMaybe<Scalars['String']['input']>;
  /** Title1 */
  title1?: InputMaybe<Scalars['String']['input']>;
  /** Title2 */
  title2?: InputMaybe<Scalars['String']['input']>;
  /** Title3 */
  title3?: InputMaybe<Scalars['String']['input']>;
  /** Title4 */
  title4?: InputMaybe<Scalars['String']['input']>;
  /** Title5 */
  title5?: InputMaybe<Scalars['String']['input']>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** UpdatedUser */
  updatedUser?: InputMaybe<Scalars['String']['input']>;
  /** VimeoId1 */
  vimeoId1?: InputMaybe<Scalars['String']['input']>;
  /** VimeoId2 */
  vimeoId2?: InputMaybe<Scalars['String']['input']>;
  /** VimeoId3 */
  vimeoId3?: InputMaybe<Scalars['String']['input']>;
  /** VimeoId4 */
  vimeoId4?: InputMaybe<Scalars['String']['input']>;
  /** VimeoId5 */
  vimeoId5?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] YearAndMonth */
  yearAndMonth?: InputMaybe<Scalars['DateTime']['input']>;
};

/** KidsWorldVideo */
export type Club_WorldFamilyClub_KidsWorldVideoSortInput = {
  /** CreatedTime */
  createdTime?: InputMaybe<SortEnumType>;
  /** CreatedUser */
  createdUser?: InputMaybe<SortEnumType>;
  /** [ID] KidsWorldVideoId */
  kidsWorldVideoId?: InputMaybe<SortEnumType>;
  /** ThumbnailUrl1 */
  thumbnailUrl1?: InputMaybe<SortEnumType>;
  /** ThumbnailUrl2 */
  thumbnailUrl2?: InputMaybe<SortEnumType>;
  /** ThumbnailUrl3 */
  thumbnailUrl3?: InputMaybe<SortEnumType>;
  /** ThumbnailUrl4 */
  thumbnailUrl4?: InputMaybe<SortEnumType>;
  /** ThumbnailUrl5 */
  thumbnailUrl5?: InputMaybe<SortEnumType>;
  /** Title1 */
  title1?: InputMaybe<SortEnumType>;
  /** Title2 */
  title2?: InputMaybe<SortEnumType>;
  /** Title3 */
  title3?: InputMaybe<SortEnumType>;
  /** Title4 */
  title4?: InputMaybe<SortEnumType>;
  /** Title5 */
  title5?: InputMaybe<SortEnumType>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<SortEnumType>;
  /** UpdatedUser */
  updatedUser?: InputMaybe<SortEnumType>;
  /** VimeoId1 */
  vimeoId1?: InputMaybe<SortEnumType>;
  /** VimeoId2 */
  vimeoId2?: InputMaybe<SortEnumType>;
  /** VimeoId3 */
  vimeoId3?: InputMaybe<SortEnumType>;
  /** VimeoId4 */
  vimeoId4?: InputMaybe<SortEnumType>;
  /** VimeoId5 */
  vimeoId5?: InputMaybe<SortEnumType>;
  /** [NOT NULL] YearAndMonth */
  yearAndMonth?: InputMaybe<SortEnumType>;
};

/** MemberMessageSetting */
export type Club_WorldFamilyClub_MemberMessageSetting = Node & {
  __typename?: 'Club_WorldFamilyClub_MemberMessageSetting';
  /** CreatedTime */
  createdTime?: Maybe<Scalars['DateTime']['output']>;
  /** [ID] MemberMessageSettingId */
  id: Scalars['ID']['output'];
  /** Market */
  market?: Maybe<Scalars['String']['output']>;
  /** MessageType */
  messageType?: Maybe<Scalars['String']['output']>;
  /** NotificationId */
  notificationId?: Maybe<Scalars['Int']['output']>;
  /** PushMessage */
  pushMessage?: Maybe<Scalars['String']['output']>;
  /** SmsMessage */
  smsMessage?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_MemberMessageSettingConnection = {
  __typename?: 'Club_WorldFamilyClub_MemberMessageSettingConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_MemberMessageSettingEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_MemberMessageSetting>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_MemberMessageSettingEdge = {
  __typename?: 'Club_WorldFamilyClub_MemberMessageSettingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_MemberMessageSetting;
};

/** MemberMessageSetting */
export type Club_WorldFamilyClub_MemberMessageSettingFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_MemberMessageSettingFilterInput>>;
  /** CreatedTime */
  createdTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** Market */
  market?: InputMaybe<StringOperationFilterInput>;
  /** [ID] MemberMessageSettingId */
  memberMessageSettingId?: InputMaybe<IntOperationFilterInput>;
  /** MessageType */
  messageType?: InputMaybe<StringOperationFilterInput>;
  /** NotificationId */
  notificationId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_MemberMessageSettingFilterInput>>;
  /** PushMessage */
  pushMessage?: InputMaybe<StringOperationFilterInput>;
  /** SmsMessage */
  smsMessage?: InputMaybe<StringOperationFilterInput>;
};

/** MemberMessageSetting */
export type Club_WorldFamilyClub_MemberMessageSettingInput = {
  /** CreatedTime */
  createdTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** [ID] MemberMessageSettingId */
  memberMessageSettingId?: InputMaybe<Scalars['Int']['input']>;
  /** MessageType */
  messageType?: InputMaybe<Scalars['String']['input']>;
  /** NotificationId */
  notificationId?: InputMaybe<Scalars['Int']['input']>;
  /** PushMessage */
  pushMessage?: InputMaybe<Scalars['String']['input']>;
  /** SmsMessage */
  smsMessage?: InputMaybe<Scalars['String']['input']>;
};

/** MemberMessageSetting */
export type Club_WorldFamilyClub_MemberMessageSettingSortInput = {
  /** CreatedTime */
  createdTime?: InputMaybe<SortEnumType>;
  /** Market */
  market?: InputMaybe<SortEnumType>;
  /** [ID] MemberMessageSettingId */
  memberMessageSettingId?: InputMaybe<SortEnumType>;
  /** MessageType */
  messageType?: InputMaybe<SortEnumType>;
  /** NotificationId */
  notificationId?: InputMaybe<SortEnumType>;
  /** PushMessage */
  pushMessage?: InputMaybe<SortEnumType>;
  /** SmsMessage */
  smsMessage?: InputMaybe<SortEnumType>;
};

/** MemberMonthlyActiveSummary */
export type Club_WorldFamilyClub_MemberMonthlyActiveSummary = Node & {
  __typename?: 'Club_WorldFamilyClub_MemberMonthlyActiveSummary';
  /** FirstLoginAt */
  firstLoginAt?: Maybe<Scalars['DateTime']['output']>;
  /** [ID] ActiveYearMonth */
  id: Scalars['ID']['output'];
  /** InsertedAt */
  insertedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Market */
  market?: Maybe<Scalars['String']['output']>;
  /** MemberNumber */
  memberNumber?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_MemberMonthlyActiveSummaryConnection = {
  __typename?: 'Club_WorldFamilyClub_MemberMonthlyActiveSummaryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_MemberMonthlyActiveSummaryEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_MemberMonthlyActiveSummary>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_MemberMonthlyActiveSummaryEdge = {
  __typename?: 'Club_WorldFamilyClub_MemberMonthlyActiveSummaryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_MemberMonthlyActiveSummary;
};

/** MemberMonthlyActiveSummary */
export type Club_WorldFamilyClub_MemberMonthlyActiveSummaryFilterInput = {
  /** [ID] ActiveYearMonth */
  activeYearMonth?: InputMaybe<DateTimeOperationFilterInput>;
  and?: InputMaybe<Array<Club_WorldFamilyClub_MemberMonthlyActiveSummaryFilterInput>>;
  /** FirstLoginAt */
  firstLoginAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** InsertedAt */
  insertedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Market */
  market?: InputMaybe<StringOperationFilterInput>;
  /** MemberNumber */
  memberNumber?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_MemberMonthlyActiveSummaryFilterInput>>;
};

/** MemberMonthlyActiveSummary */
export type Club_WorldFamilyClub_MemberMonthlyActiveSummaryInput = {
  /** [ID] ActiveYearMonth */
  activeYearMonth: Scalars['DateTime']['input'];
  /** FirstLoginAt */
  firstLoginAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** InsertedAt */
  insertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** MemberNumber */
  memberNumber?: InputMaybe<Scalars['String']['input']>;
};

/** MemberMonthlyActiveSummary */
export type Club_WorldFamilyClub_MemberMonthlyActiveSummarySortInput = {
  /** [ID] ActiveYearMonth */
  activeYearMonth?: InputMaybe<SortEnumType>;
  /** FirstLoginAt */
  firstLoginAt?: InputMaybe<SortEnumType>;
  /** InsertedAt */
  insertedAt?: InputMaybe<SortEnumType>;
  /** Market */
  market?: InputMaybe<SortEnumType>;
  /** MemberNumber */
  memberNumber?: InputMaybe<SortEnumType>;
};

/** MemberUpgradePayment */
export type Club_WorldFamilyClub_MemberUpgradePayment = Node & {
  __typename?: 'Club_WorldFamilyClub_MemberUpgradePayment';
  /** [NOT NULL] AddBeamProjector */
  addBeamProjector?: Maybe<Scalars['Int']['output']>;
  /** [NOT NULL] AddDongle */
  addDongle?: Maybe<Scalars['Int']['output']>;
  /** Address */
  address?: Maybe<Scalars['String']['output']>;
  /** CanceledDate */
  canceledDate?: Maybe<Scalars['DateTime']['output']>;
  /** CreatedDate */
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  /** EasypayCno */
  easypayCno?: Maybe<Scalars['String']['output']>;
  /** [ID] UpgradePaymentId */
  id: Scalars['ID']['output'];
  /** IsChangeAddress */
  isChangeAddress?: Maybe<Scalars['Boolean']['output']>;
  /** Market */
  market?: Maybe<Scalars['String']['output']>;
  /** MemberNo */
  memberNo?: Maybe<Scalars['String']['output']>;
  /** OrderId */
  orderId?: Maybe<Scalars['String']['output']>;
  /** OriginalPackage */
  originalPackage?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] PaidAmount */
  paidAmount?: Maybe<Scalars['Int']['output']>;
  /** [NOT NULL] PaymentAmount */
  paymentAmount?: Maybe<Scalars['Int']['output']>;
  /** PaymentDate */
  paymentDate?: Maybe<Scalars['DateTime']['output']>;
  /** PaymentMethod */
  paymentMethod?: Maybe<Scalars['String']['output']>;
  /** PaymentStatus */
  paymentStatus?: Maybe<Scalars['String']['output']>;
  /** UpgradePackage */
  upgradePackage?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_MemberUpgradePaymentConnection = {
  __typename?: 'Club_WorldFamilyClub_MemberUpgradePaymentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_MemberUpgradePaymentEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_MemberUpgradePayment>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_MemberUpgradePaymentEdge = {
  __typename?: 'Club_WorldFamilyClub_MemberUpgradePaymentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_MemberUpgradePayment;
};

/** MemberUpgradePayment */
export type Club_WorldFamilyClub_MemberUpgradePaymentFilterInput = {
  /** [NOT NULL] AddBeamProjector */
  addBeamProjector?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] AddDongle */
  addDongle?: InputMaybe<IntOperationFilterInput>;
  /** Address */
  address?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<Club_WorldFamilyClub_MemberUpgradePaymentFilterInput>>;
  /** CanceledDate */
  canceledDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** CreatedDate */
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** EasypayCno */
  easypayCno?: InputMaybe<StringOperationFilterInput>;
  /** IsChangeAddress */
  isChangeAddress?: InputMaybe<BooleanOperationFilterInput>;
  /** Market */
  market?: InputMaybe<StringOperationFilterInput>;
  /** MemberNo */
  memberNo?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_MemberUpgradePaymentFilterInput>>;
  /** OrderId */
  orderId?: InputMaybe<StringOperationFilterInput>;
  /** OriginalPackage */
  originalPackage?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] PaidAmount */
  paidAmount?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] PaymentAmount */
  paymentAmount?: InputMaybe<IntOperationFilterInput>;
  /** PaymentDate */
  paymentDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** PaymentMethod */
  paymentMethod?: InputMaybe<StringOperationFilterInput>;
  /** PaymentStatus */
  paymentStatus?: InputMaybe<StringOperationFilterInput>;
  /** UpgradePackage */
  upgradePackage?: InputMaybe<StringOperationFilterInput>;
  /** [ID] UpgradePaymentId */
  upgradePaymentId?: InputMaybe<IntOperationFilterInput>;
};

/** MemberUpgradePayment */
export type Club_WorldFamilyClub_MemberUpgradePaymentInput = {
  /** [NOT NULL] AddBeamProjector */
  addBeamProjector?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] AddDongle */
  addDongle?: InputMaybe<Scalars['Int']['input']>;
  /** Address */
  address?: InputMaybe<Scalars['String']['input']>;
  /** CanceledDate */
  canceledDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** CreatedDate */
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** EasypayCno */
  easypayCno?: InputMaybe<Scalars['String']['input']>;
  /** IsChangeAddress */
  isChangeAddress?: InputMaybe<Scalars['Boolean']['input']>;
  /** Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** MemberNo */
  memberNo?: InputMaybe<Scalars['String']['input']>;
  /** OrderId */
  orderId?: InputMaybe<Scalars['String']['input']>;
  /** OriginalPackage */
  originalPackage?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] PaidAmount */
  paidAmount?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] PaymentAmount */
  paymentAmount?: InputMaybe<Scalars['Int']['input']>;
  /** PaymentDate */
  paymentDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** PaymentMethod */
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  /** PaymentStatus */
  paymentStatus?: InputMaybe<Scalars['String']['input']>;
  /** UpgradePackage */
  upgradePackage?: InputMaybe<Scalars['String']['input']>;
  /** [ID] UpgradePaymentId */
  upgradePaymentId?: InputMaybe<Scalars['Int']['input']>;
};

/** MemberUpgradePayment */
export type Club_WorldFamilyClub_MemberUpgradePaymentSortInput = {
  /** [NOT NULL] AddBeamProjector */
  addBeamProjector?: InputMaybe<SortEnumType>;
  /** [NOT NULL] AddDongle */
  addDongle?: InputMaybe<SortEnumType>;
  /** Address */
  address?: InputMaybe<SortEnumType>;
  /** CanceledDate */
  canceledDate?: InputMaybe<SortEnumType>;
  /** CreatedDate */
  createdDate?: InputMaybe<SortEnumType>;
  /** EasypayCno */
  easypayCno?: InputMaybe<SortEnumType>;
  /** IsChangeAddress */
  isChangeAddress?: InputMaybe<SortEnumType>;
  /** Market */
  market?: InputMaybe<SortEnumType>;
  /** MemberNo */
  memberNo?: InputMaybe<SortEnumType>;
  /** OrderId */
  orderId?: InputMaybe<SortEnumType>;
  /** OriginalPackage */
  originalPackage?: InputMaybe<SortEnumType>;
  /** [NOT NULL] PaidAmount */
  paidAmount?: InputMaybe<SortEnumType>;
  /** [NOT NULL] PaymentAmount */
  paymentAmount?: InputMaybe<SortEnumType>;
  /** PaymentDate */
  paymentDate?: InputMaybe<SortEnumType>;
  /** PaymentMethod */
  paymentMethod?: InputMaybe<SortEnumType>;
  /** PaymentStatus */
  paymentStatus?: InputMaybe<SortEnumType>;
  /** UpgradePackage */
  upgradePackage?: InputMaybe<SortEnumType>;
  /** [ID] UpgradePaymentId */
  upgradePaymentId?: InputMaybe<SortEnumType>;
};

export type Club_WorldFamilyClub_Mutation_Add = {
  __typename?: 'Club_WorldFamilyClub_Mutation_Add';
  appAuth?: Maybe<Club_WorldFamilyClub_AppAuth>;
  appBanner?: Maybe<Club_WorldFamilyClub_AppBanner>;
  appDigitalMagazine?: Maybe<Club_WorldFamilyClub_AppDigitalMagazine>;
  appMemberAuthorize?: Maybe<Club_WorldFamilyClub_AppMemberAuthorize>;
  appMemberAuthorizeLog?: Maybe<Club_WorldFamilyClub_AppMemberAuthorizeLog>;
  appMemberChild?: Maybe<Club_WorldFamilyClub_AppMemberChild>;
  appMemberDevice?: Maybe<Club_WorldFamilyClub_AppMemberDevice>;
  appMemberFirstLogin?: Maybe<Club_WorldFamilyClub_AppMemberFirstLogin>;
  appMemberNotification?: Maybe<Club_WorldFamilyClub_AppMemberNotification>;
  appMemberNotificationPushFirebase?: Maybe<Club_WorldFamilyClub_AppMemberNotificationPushFirebase>;
  appNotification?: Maybe<Club_WorldFamilyClub_AppNotification>;
  appNotificationMember?: Maybe<Club_WorldFamilyClub_AppNotificationMember>;
  appNotificationType?: Maybe<Club_WorldFamilyClub_AppNotificationType>;
  appNotificationTypeMarket?: Maybe<Club_WorldFamilyClub_AppNotificationTypeMarket>;
  appRegionEmergency?: Maybe<Club_WorldFamilyClub_AppRegionEmergency>;
  appRelease?: Maybe<Club_WorldFamilyClub_AppRelease>;
  appServiceRegionFestivalImage?: Maybe<Club_WorldFamilyClub_AppServiceRegionFestivalImage>;
  appServiceRegionImage?: Maybe<Club_WorldFamilyClub_AppServiceRegionImage>;
  appSurvey?: Maybe<Club_WorldFamilyClub_AppSurvey>;
  appSurveyMember?: Maybe<Club_WorldFamilyClub_AppSurveyMember>;
  appSurveyQa?: Maybe<Club_WorldFamilyClub_AppSurveyQa>;
  appSurveyReminder?: Maybe<Club_WorldFamilyClub_AppSurveyReminder>;
  azureFunction?: Maybe<Club_WorldFamilyClub_AzureFunction>;
  bankCode?: Maybe<Club_WorldFamilyClub_BankCode>;
  broadcastPromotion?: Maybe<Club_WorldFamilyClub_BroadcastPromotion>;
  capGuidePdf?: Maybe<Club_WorldFamilyClub_CapGuidePdf>;
  childGraduationApplication?: Maybe<Club_WorldFamilyClub_ChildGraduationApplication>;
  creditcardBankCode?: Maybe<Club_WorldFamilyClub_CreditcardBankCode>;
  dweProductPackage?: Maybe<Club_WorldFamilyClub_DweProductPackage>;
  dweProductSong?: Maybe<Club_WorldFamilyClub_DweProductSong>;
  dweProductSongTool?: Maybe<Club_WorldFamilyClub_DweProductSongTool>;
  dweProductTool?: Maybe<Club_WorldFamilyClub_DweProductTool>;
  easypayOrderLog?: Maybe<Club_WorldFamilyClub_EasypayOrderLog>;
  entryPackageOrder?: Maybe<Club_WorldFamilyClub_EntryPackageOrder>;
  entryPackageOrdersMemberPaymentInfo?: Maybe<Club_WorldFamilyClub_EntryPackageOrdersMemberPaymentInfo>;
  eventBanner?: Maybe<Club_WorldFamilyClub_EventBanner>;
  eventBannerRegion?: Maybe<Club_WorldFamilyClub_EventBannerRegion>;
  eventCheckInAuth?: Maybe<Club_WorldFamilyClub_EventCheckInAuth>;
  eventNotificationLog?: Maybe<Club_WorldFamilyClub_EventNotificationLog>;
  eventPromotion?: Maybe<Club_WorldFamilyClub_EventPromotion>;
  eventSeat?: Maybe<Club_WorldFamilyClub_EventSeat>;
  eventType?: Maybe<Club_WorldFamilyClub_EventType>;
  exchangeApplication?: Maybe<Club_WorldFamilyClub_ExchangeApplication>;
  exchangeApplicationItem?: Maybe<Club_WorldFamilyClub_ExchangeApplicationItem>;
  exchangeReason?: Maybe<Club_WorldFamilyClub_ExchangeReason>;
  exchangeReasonTranslation?: Maybe<Club_WorldFamilyClub_ExchangeReasonTranslation>;
  faceCallAndTelephoneEnglish?: Maybe<Club_WorldFamilyClub_FaceCallAndTelephoneEnglish>;
  faceCallForTrialmode?: Maybe<Club_WorldFamilyClub_FaceCallForTrialmode>;
  faceCallHist?: Maybe<Club_WorldFamilyClub_FaceCallHist>;
  faceCallHistCount?: Maybe<Club_WorldFamilyClub_FaceCallHistCount>;
  faceCallMonthlyRecommend?: Maybe<Club_WorldFamilyClub_FaceCallMonthlyRecommend>;
  faceCallPerformer?: Maybe<Club_WorldFamilyClub_FaceCallPerformer>;
  faceCallSeasonHoliday?: Maybe<Club_WorldFamilyClub_FaceCallSeasonHoliday>;
  faceCallSong?: Maybe<Club_WorldFamilyClub_FaceCallSong>;
  faceCallSongAndPerformer?: Maybe<Club_WorldFamilyClub_FaceCallSongAndPerformer>;
  faceCallSongPublic?: Maybe<Club_WorldFamilyClub_FaceCallSongPublic>;
  goGoLiveDesktopQrcode?: Maybe<Club_WorldFamilyClub_GoGoLiveDesktopQrcode>;
  goGoLiveLevel?: Maybe<Club_WorldFamilyClub_GoGoLiveLevel>;
  goGoLiveOpenDate?: Maybe<Club_WorldFamilyClub_GoGoLiveOpenDate>;
  goGoLiveParentGuide?: Maybe<Club_WorldFamilyClub_GoGoLiveParentGuide>;
  goGoLiveParentGuideLocale?: Maybe<Club_WorldFamilyClub_GoGoLiveParentGuideLocale>;
  goGoLiveParentGuideSession?: Maybe<Club_WorldFamilyClub_GoGoLiveParentGuideSession>;
  goGoLiveParentGuideSong?: Maybe<Club_WorldFamilyClub_GoGoLiveParentGuideSong>;
  goGoLiveParentGuideTac?: Maybe<Club_WorldFamilyClub_GoGoLiveParentGuideTac>;
  goGoLiveParentGuideToy?: Maybe<Club_WorldFamilyClub_GoGoLiveParentGuideToy>;
  goGoLivePromotion?: Maybe<Club_WorldFamilyClub_GoGoLivePromotion>;
  goGoLiveSession?: Maybe<Club_WorldFamilyClub_GoGoLiveSession>;
  goGoLiveSong?: Maybe<Club_WorldFamilyClub_GoGoLiveSong>;
  goGoLiveToy?: Maybe<Club_WorldFamilyClub_GoGoLiveToy>;
  graduationApplication?: Maybe<Club_WorldFamilyClub_GraduationApplication>;
  graduationApplicationEvaluation?: Maybe<Club_WorldFamilyClub_GraduationApplicationEvaluation>;
  graduationApplicationSubTask?: Maybe<Club_WorldFamilyClub_GraduationApplicationSubTask>;
  graduationApplicationTask?: Maybe<Club_WorldFamilyClub_GraduationApplicationTask>;
  graduationChild?: Maybe<Club_WorldFamilyClub_GraduationChild>;
  graduationChildSetting?: Maybe<Club_WorldFamilyClub_GraduationChildSetting>;
  graduationEvaluation?: Maybe<Club_WorldFamilyClub_GraduationEvaluation>;
  graduationNotification?: Maybe<Club_WorldFamilyClub_GraduationNotification>;
  graduationSubApplication?: Maybe<Club_WorldFamilyClub_GraduationSubApplication>;
  graduationSubTaskMarketDescription?: Maybe<Club_WorldFamilyClub_GraduationSubTaskMarketDescription>;
  graduationTaskMarketDescription?: Maybe<Club_WorldFamilyClub_GraduationTaskMarketDescription>;
  graphqlAccess?: Maybe<Club_WorldFamilyClub_GraphqlAccess>;
  graphqlSchema?: Maybe<Club_WorldFamilyClub_GraphqlSchema>;
  holidayAudio?: Maybe<Club_WorldFamilyClub_HolidayAudio>;
  holidaySetting?: Maybe<Club_WorldFamilyClub_HolidaySetting>;
  holidayVideo?: Maybe<Club_WorldFamilyClub_HolidayVideo>;
  holidayVideoBonusEntitlementTest?: Maybe<Club_WorldFamilyClub_HolidayVideoBonusEntitlementTest>;
  holidayVideoMarket?: Maybe<Club_WorldFamilyClub_HolidayVideoMarket>;
  holidayVideoMarketSetting?: Maybe<Club_WorldFamilyClub_HolidayVideoMarketSetting>;
  holidayVideoMember?: Maybe<Club_WorldFamilyClub_HolidayVideoMember>;
  kidsWorldVideo?: Maybe<Club_WorldFamilyClub_KidsWorldVideo>;
  memberMessageSetting?: Maybe<Club_WorldFamilyClub_MemberMessageSetting>;
  memberMonthlyActiveSummary?: Maybe<Club_WorldFamilyClub_MemberMonthlyActiveSummary>;
  memberUpgradePayment?: Maybe<Club_WorldFamilyClub_MemberUpgradePayment>;
  myFavoriteFaceCall?: Maybe<Club_WorldFamilyClub_MyFavoriteFaceCall>;
  myFavoriteFaceCallSong?: Maybe<Club_WorldFamilyClub_MyFavoriteFaceCallSong>;
  notification?: Maybe<Club_WorldFamilyClub_Notification>;
  notificationIcon?: Maybe<Club_WorldFamilyClub_NotificationIcon>;
  oneTimeToken?: Maybe<Club_WorldFamilyClub_OneTimeToken>;
  onlineEventLog?: Maybe<Club_WorldFamilyClub_OnlineEventLog>;
  onlineShow?: Maybe<Club_WorldFamilyClub_OnlineShow>;
  parameter?: Maybe<Club_WorldFamilyClub_Parameter>;
  product?: Maybe<Club_WorldFamilyClub_Product>;
  productCategory?: Maybe<Club_WorldFamilyClub_ProductCategory>;
  productCategoryTranslation?: Maybe<Club_WorldFamilyClub_ProductCategoryTranslation>;
  productSubCategory?: Maybe<Club_WorldFamilyClub_ProductSubCategory>;
  productSubCategoryExchangeReason?: Maybe<Club_WorldFamilyClub_ProductSubCategoryExchangeReason>;
  productSubCategoryTranslation?: Maybe<Club_WorldFamilyClub_ProductSubCategoryTranslation>;
  productTranslation?: Maybe<Club_WorldFamilyClub_ProductTranslation>;
  products1?: Maybe<Club_WorldFamilyClub_Products1>;
  regionBanner?: Maybe<Club_WorldFamilyClub_RegionBanner>;
  searchKeyword?: Maybe<Club_WorldFamilyClub_SearchKeyword>;
  service?: Maybe<Club_WorldFamilyClub_Service>;
  serviceBannerDefault?: Maybe<Club_WorldFamilyClub_ServiceBannerDefault>;
  serviceBannerScheduled?: Maybe<Club_WorldFamilyClub_ServiceBannerScheduled>;
  serviceOneTimeToken?: Maybe<Club_WorldFamilyClub_ServiceOneTimeToken>;
  serviceSearch?: Maybe<Club_WorldFamilyClub_ServiceSearch>;
  smsCertification?: Maybe<Club_WorldFamilyClub_SmsCertification>;
  smsCertificationLog?: Maybe<Club_WorldFamilyClub_SmsCertificationLog>;
  smsVerificationCode?: Maybe<Club_WorldFamilyClub_SmsVerificationCode>;
  surveyTypeForm?: Maybe<Club_WorldFamilyClub_SurveyTypeForm>;
  surveyTypeFormList?: Maybe<Club_WorldFamilyClub_SurveyTypeFormList>;
  talkAlongCard?: Maybe<Club_WorldFamilyClub_TalkAlongCard>;
  teSong?: Maybe<Club_WorldFamilyClub_TeSong>;
  teSongToy?: Maybe<Club_WorldFamilyClub_TeSongToy>;
  temp20240408Graduation?: Maybe<Club_WorldFamilyClub_Temp20240408Graduation>;
  temp20240408Graduation1?: Maybe<Club_WorldFamilyClub_Temp20240408Graduation1>;
  temp20251028ExchangeReason?: Maybe<Club_WorldFamilyClub_Temp20251028ExchangeReason>;
  temp20260310Product?: Maybe<Club_WorldFamilyClub_Temp20260310Product>;
  tempChildGraduationApplicationNew?: Maybe<Club_WorldFamilyClub_TempChildGraduationApplicationNew>;
  tempChildGraduationApplicationOld?: Maybe<Club_WorldFamilyClub_TempChildGraduationApplicationOld>;
  tempFaceCall?: Maybe<Club_WorldFamilyClub_TempFaceCall>;
  tempFaceCallHk?: Maybe<Club_WorldFamilyClub_TempFaceCallHk>;
  tempFaceCallKr?: Maybe<Club_WorldFamilyClub_TempFaceCallKr>;
  tempGoGoLiveSong?: Maybe<Club_WorldFamilyClub_TempGoGoLiveSong>;
  tempHkAppMyFavorite?: Maybe<Club_WorldFamilyClub_TempHkAppMyFavorite>;
  tempHkClubappsFacecallCrew?: Maybe<Club_WorldFamilyClub_TempHkClubappsFacecallCrew>;
  tempHkClubappsFacecallHistory?: Maybe<Club_WorldFamilyClub_TempHkClubappsFacecallHistory>;
  tempHkClubappsFacecallSong?: Maybe<Club_WorldFamilyClub_TempHkClubappsFacecallSong>;
  tempHkDmemChild?: Maybe<Club_WorldFamilyClub_TempHkDmemChild>;
  tempHkTeSong?: Maybe<Club_WorldFamilyClub_TempHkTeSong>;
  tempHkTematerial?: Maybe<Club_WorldFamilyClub_TempHkTematerial>;
  tempKrFaceCallHist?: Maybe<Club_WorldFamilyClub_TempKrFaceCallHist>;
  tempKrFcCrewM?: Maybe<Club_WorldFamilyClub_TempKrFcCrewM>;
  tempKrFcsongCrew?: Maybe<Club_WorldFamilyClub_TempKrFcsongCrew>;
  tempKrMyFavorite?: Maybe<Club_WorldFamilyClub_TempKrMyFavorite>;
  tempKrTeSong?: Maybe<Club_WorldFamilyClub_TempKrTeSong>;
  tempKrWfeClubMemberChild?: Maybe<Club_WorldFamilyClub_TempKrWfeClubMemberChild>;
  tempTalkAlongCard?: Maybe<Club_WorldFamilyClub_TempTalkAlongCard>;
  tempTwCambridge?: Maybe<Club_WorldFamilyClub_TempTwCambridge>;
  tempTwFaceCallHist?: Maybe<Club_WorldFamilyClub_TempTwFaceCallHist>;
  tempTwFcCrewM?: Maybe<Club_WorldFamilyClub_TempTwFcCrewM>;
  tempTwFcsongCrew?: Maybe<Club_WorldFamilyClub_TempTwFcsongCrew>;
  tempTwFcsongMonthlyRecommend?: Maybe<Club_WorldFamilyClub_TempTwFcsongMonthlyRecommend>;
  tempTwMyFavorite?: Maybe<Club_WorldFamilyClub_TempTwMyFavorite>;
  tempTwTeSong?: Maybe<Club_WorldFamilyClub_TempTwTeSong>;
  tempTwTeSongForCapLevel?: Maybe<Club_WorldFamilyClub_TempTwTeSongForCapLevel>;
  tempWfcGraC?: Maybe<Club_WorldFamilyClub_TempWfcGraC>;
  tempWfcGraCOrganized?: Maybe<Club_WorldFamilyClub_TempWfcGraCOrganized>;
  testUserAccount?: Maybe<Club_WorldFamilyClub_TestUserAccount>;
  testWater?: Maybe<Club_WorldFamilyClub_TestWater>;
  testWaterSub?: Maybe<Club_WorldFamilyClub_TestWaterSub>;
  tev2MonthlySong?: Maybe<Club_WorldFamilyClub_Tev2MonthlySong>;
  user?: Maybe<Club_WorldFamilyClub_User>;
  videoForTrialmode?: Maybe<Club_WorldFamilyClub_VideoForTrialmode>;
  wfcLibraryFaq?: Maybe<Club_WorldFamilyClub_WfcLibraryFaq>;
  wfcLibraryLog?: Maybe<Club_WorldFamilyClub_WfcLibraryLog>;
  wfcNowPageViewLog?: Maybe<Club_WorldFamilyClub_WfcNowPageViewLog>;
};

export type Club_WorldFamilyClub_Mutation_AddInput = {
  appAuth?: InputMaybe<Club_WorldFamilyClub_AppAuthInput>;
  appBanner?: InputMaybe<Club_WorldFamilyClub_AppBannerInput>;
  appDigitalMagazine?: InputMaybe<Club_WorldFamilyClub_AppDigitalMagazineInput>;
  appMemberAuthorize?: InputMaybe<Club_WorldFamilyClub_AppMemberAuthorizeInput>;
  appMemberAuthorizeLog?: InputMaybe<Club_WorldFamilyClub_AppMemberAuthorizeLogInput>;
  appMemberChild?: InputMaybe<Club_WorldFamilyClub_AppMemberChildInput>;
  appMemberDevice?: InputMaybe<Club_WorldFamilyClub_AppMemberDeviceInput>;
  appMemberFirstLogin?: InputMaybe<Club_WorldFamilyClub_AppMemberFirstLoginInput>;
  appMemberNotification?: InputMaybe<Club_WorldFamilyClub_AppMemberNotificationInput>;
  appMemberNotificationPushFirebase?: InputMaybe<Club_WorldFamilyClub_AppMemberNotificationPushFirebaseInput>;
  appNotification?: InputMaybe<Club_WorldFamilyClub_AppNotificationInput>;
  appNotificationMember?: InputMaybe<Club_WorldFamilyClub_AppNotificationMemberInput>;
  appNotificationType?: InputMaybe<Club_WorldFamilyClub_AppNotificationTypeInput>;
  appNotificationTypeMarket?: InputMaybe<Club_WorldFamilyClub_AppNotificationTypeMarketInput>;
  appRegionEmergency?: InputMaybe<Club_WorldFamilyClub_AppRegionEmergencyInput>;
  appRelease?: InputMaybe<Club_WorldFamilyClub_AppReleaseInput>;
  appServiceRegionFestivalImage?: InputMaybe<Club_WorldFamilyClub_AppServiceRegionFestivalImageInput>;
  appServiceRegionImage?: InputMaybe<Club_WorldFamilyClub_AppServiceRegionImageInput>;
  appSurvey?: InputMaybe<Club_WorldFamilyClub_AppSurveyInput>;
  appSurveyMember?: InputMaybe<Club_WorldFamilyClub_AppSurveyMemberInput>;
  appSurveyQa?: InputMaybe<Club_WorldFamilyClub_AppSurveyQaInput>;
  appSurveyReminder?: InputMaybe<Club_WorldFamilyClub_AppSurveyReminderInput>;
  azureFunction?: InputMaybe<Club_WorldFamilyClub_AzureFunctionInput>;
  bankCode?: InputMaybe<Club_WorldFamilyClub_BankCodeInput>;
  broadcastPromotion?: InputMaybe<Club_WorldFamilyClub_BroadcastPromotionInput>;
  capGuidePdf?: InputMaybe<Club_WorldFamilyClub_CapGuidePdfInput>;
  childGraduationApplication?: InputMaybe<Club_WorldFamilyClub_ChildGraduationApplicationInput>;
  creditcardBankCode?: InputMaybe<Club_WorldFamilyClub_CreditcardBankCodeInput>;
  dweProductPackage?: InputMaybe<Club_WorldFamilyClub_DweProductPackageInput>;
  dweProductSong?: InputMaybe<Club_WorldFamilyClub_DweProductSongInput>;
  dweProductSongTool?: InputMaybe<Club_WorldFamilyClub_DweProductSongToolInput>;
  dweProductTool?: InputMaybe<Club_WorldFamilyClub_DweProductToolInput>;
  easypayOrderLog?: InputMaybe<Club_WorldFamilyClub_EasypayOrderLogInput>;
  entryPackageOrder?: InputMaybe<Club_WorldFamilyClub_EntryPackageOrderInput>;
  entryPackageOrdersMemberPaymentInfo?: InputMaybe<Club_WorldFamilyClub_EntryPackageOrdersMemberPaymentInfoInput>;
  eventBanner?: InputMaybe<Club_WorldFamilyClub_EventBannerInput>;
  eventBannerRegion?: InputMaybe<Club_WorldFamilyClub_EventBannerRegionInput>;
  eventCheckInAuth?: InputMaybe<Club_WorldFamilyClub_EventCheckInAuthInput>;
  eventNotificationLog?: InputMaybe<Club_WorldFamilyClub_EventNotificationLogInput>;
  eventPromotion?: InputMaybe<Club_WorldFamilyClub_EventPromotionInput>;
  eventSeat?: InputMaybe<Club_WorldFamilyClub_EventSeatInput>;
  eventType?: InputMaybe<Club_WorldFamilyClub_EventTypeInput>;
  exchangeApplication?: InputMaybe<Club_WorldFamilyClub_ExchangeApplicationInput>;
  exchangeApplicationItem?: InputMaybe<Club_WorldFamilyClub_ExchangeApplicationItemInput>;
  exchangeReason?: InputMaybe<Club_WorldFamilyClub_ExchangeReasonInput>;
  exchangeReasonTranslation?: InputMaybe<Club_WorldFamilyClub_ExchangeReasonTranslationInput>;
  faceCallAndTelephoneEnglish?: InputMaybe<Club_WorldFamilyClub_FaceCallAndTelephoneEnglishInput>;
  faceCallForTrialmode?: InputMaybe<Club_WorldFamilyClub_FaceCallForTrialmodeInput>;
  faceCallHist?: InputMaybe<Club_WorldFamilyClub_FaceCallHistInput>;
  faceCallHistCount?: InputMaybe<Club_WorldFamilyClub_FaceCallHistCountInput>;
  faceCallMonthlyRecommend?: InputMaybe<Club_WorldFamilyClub_FaceCallMonthlyRecommendInput>;
  faceCallPerformer?: InputMaybe<Club_WorldFamilyClub_FaceCallPerformerInput>;
  faceCallSeasonHoliday?: InputMaybe<Club_WorldFamilyClub_FaceCallSeasonHolidayInput>;
  faceCallSong?: InputMaybe<Club_WorldFamilyClub_FaceCallSongInput>;
  faceCallSongAndPerformer?: InputMaybe<Club_WorldFamilyClub_FaceCallSongAndPerformerInput>;
  faceCallSongPublic?: InputMaybe<Club_WorldFamilyClub_FaceCallSongPublicInput>;
  goGoLiveDesktopQrcode?: InputMaybe<Club_WorldFamilyClub_GoGoLiveDesktopQrcodeInput>;
  goGoLiveLevel?: InputMaybe<Club_WorldFamilyClub_GoGoLiveLevelInput>;
  goGoLiveOpenDate?: InputMaybe<Club_WorldFamilyClub_GoGoLiveOpenDateInput>;
  goGoLiveParentGuide?: InputMaybe<Club_WorldFamilyClub_GoGoLiveParentGuideInput>;
  goGoLiveParentGuideLocale?: InputMaybe<Club_WorldFamilyClub_GoGoLiveParentGuideLocaleInput>;
  goGoLiveParentGuideSession?: InputMaybe<Club_WorldFamilyClub_GoGoLiveParentGuideSessionInput>;
  goGoLiveParentGuideSong?: InputMaybe<Club_WorldFamilyClub_GoGoLiveParentGuideSongInput>;
  goGoLiveParentGuideTac?: InputMaybe<Club_WorldFamilyClub_GoGoLiveParentGuideTacInput>;
  goGoLiveParentGuideToy?: InputMaybe<Club_WorldFamilyClub_GoGoLiveParentGuideToyInput>;
  goGoLivePromotion?: InputMaybe<Club_WorldFamilyClub_GoGoLivePromotionInput>;
  goGoLiveSession?: InputMaybe<Club_WorldFamilyClub_GoGoLiveSessionInput>;
  goGoLiveSong?: InputMaybe<Club_WorldFamilyClub_GoGoLiveSongInput>;
  goGoLiveToy?: InputMaybe<Club_WorldFamilyClub_GoGoLiveToyInput>;
  graduationApplication?: InputMaybe<Club_WorldFamilyClub_GraduationApplicationInput>;
  graduationApplicationEvaluation?: InputMaybe<Club_WorldFamilyClub_GraduationApplicationEvaluationInput>;
  graduationApplicationSubTask?: InputMaybe<Club_WorldFamilyClub_GraduationApplicationSubTaskInput>;
  graduationApplicationTask?: InputMaybe<Club_WorldFamilyClub_GraduationApplicationTaskInput>;
  graduationChild?: InputMaybe<Club_WorldFamilyClub_GraduationChildInput>;
  graduationChildSetting?: InputMaybe<Club_WorldFamilyClub_GraduationChildSettingInput>;
  graduationEvaluation?: InputMaybe<Club_WorldFamilyClub_GraduationEvaluationInput>;
  graduationNotification?: InputMaybe<Club_WorldFamilyClub_GraduationNotificationInput>;
  graduationSubApplication?: InputMaybe<Club_WorldFamilyClub_GraduationSubApplicationInput>;
  graduationSubTaskMarketDescription?: InputMaybe<Club_WorldFamilyClub_GraduationSubTaskMarketDescriptionInput>;
  graduationTaskMarketDescription?: InputMaybe<Club_WorldFamilyClub_GraduationTaskMarketDescriptionInput>;
  graphqlAccess?: InputMaybe<Club_WorldFamilyClub_GraphqlAccessInput>;
  graphqlSchema?: InputMaybe<Club_WorldFamilyClub_GraphqlSchemaInput>;
  holidayAudio?: InputMaybe<Club_WorldFamilyClub_HolidayAudioInput>;
  holidaySetting?: InputMaybe<Club_WorldFamilyClub_HolidaySettingInput>;
  holidayVideo?: InputMaybe<Club_WorldFamilyClub_HolidayVideoInput>;
  holidayVideoBonusEntitlementTest?: InputMaybe<Club_WorldFamilyClub_HolidayVideoBonusEntitlementTestInput>;
  holidayVideoMarket?: InputMaybe<Club_WorldFamilyClub_HolidayVideoMarketInput>;
  holidayVideoMarketSetting?: InputMaybe<Club_WorldFamilyClub_HolidayVideoMarketSettingInput>;
  holidayVideoMember?: InputMaybe<Club_WorldFamilyClub_HolidayVideoMemberInput>;
  kidsWorldVideo?: InputMaybe<Club_WorldFamilyClub_KidsWorldVideoInput>;
  memberMessageSetting?: InputMaybe<Club_WorldFamilyClub_MemberMessageSettingInput>;
  memberMonthlyActiveSummary?: InputMaybe<Club_WorldFamilyClub_MemberMonthlyActiveSummaryInput>;
  memberUpgradePayment?: InputMaybe<Club_WorldFamilyClub_MemberUpgradePaymentInput>;
  myFavoriteFaceCall?: InputMaybe<Club_WorldFamilyClub_MyFavoriteFaceCallInput>;
  myFavoriteFaceCallSong?: InputMaybe<Club_WorldFamilyClub_MyFavoriteFaceCallSongInput>;
  notification?: InputMaybe<Club_WorldFamilyClub_NotificationInput>;
  notificationIcon?: InputMaybe<Club_WorldFamilyClub_NotificationIconInput>;
  oneTimeToken?: InputMaybe<Club_WorldFamilyClub_OneTimeTokenInput>;
  onlineEventLog?: InputMaybe<Club_WorldFamilyClub_OnlineEventLogInput>;
  onlineShow?: InputMaybe<Club_WorldFamilyClub_OnlineShowInput>;
  parameter?: InputMaybe<Club_WorldFamilyClub_ParameterInput>;
  product?: InputMaybe<Club_WorldFamilyClub_ProductInput>;
  productCategory?: InputMaybe<Club_WorldFamilyClub_ProductCategoryInput>;
  productCategoryTranslation?: InputMaybe<Club_WorldFamilyClub_ProductCategoryTranslationInput>;
  productSubCategory?: InputMaybe<Club_WorldFamilyClub_ProductSubCategoryInput>;
  productSubCategoryExchangeReason?: InputMaybe<Club_WorldFamilyClub_ProductSubCategoryExchangeReasonInput>;
  productSubCategoryTranslation?: InputMaybe<Club_WorldFamilyClub_ProductSubCategoryTranslationInput>;
  productTranslation?: InputMaybe<Club_WorldFamilyClub_ProductTranslationInput>;
  products1?: InputMaybe<Club_WorldFamilyClub_Products1Input>;
  regionBanner?: InputMaybe<Club_WorldFamilyClub_RegionBannerInput>;
  searchKeyword?: InputMaybe<Club_WorldFamilyClub_SearchKeywordInput>;
  service?: InputMaybe<Club_WorldFamilyClub_ServiceInput>;
  serviceBannerDefault?: InputMaybe<Club_WorldFamilyClub_ServiceBannerDefaultInput>;
  serviceBannerScheduled?: InputMaybe<Club_WorldFamilyClub_ServiceBannerScheduledInput>;
  serviceOneTimeToken?: InputMaybe<Club_WorldFamilyClub_ServiceOneTimeTokenInput>;
  serviceSearch?: InputMaybe<Club_WorldFamilyClub_ServiceSearchInput>;
  smsCertification?: InputMaybe<Club_WorldFamilyClub_SmsCertificationInput>;
  smsCertificationLog?: InputMaybe<Club_WorldFamilyClub_SmsCertificationLogInput>;
  smsVerificationCode?: InputMaybe<Club_WorldFamilyClub_SmsVerificationCodeInput>;
  surveyTypeForm?: InputMaybe<Club_WorldFamilyClub_SurveyTypeFormInput>;
  surveyTypeFormList?: InputMaybe<Club_WorldFamilyClub_SurveyTypeFormListInput>;
  talkAlongCard?: InputMaybe<Club_WorldFamilyClub_TalkAlongCardInput>;
  teSong?: InputMaybe<Club_WorldFamilyClub_TeSongInput>;
  teSongToy?: InputMaybe<Club_WorldFamilyClub_TeSongToyInput>;
  temp20240408Graduation?: InputMaybe<Club_WorldFamilyClub_Temp20240408GraduationInput>;
  temp20240408Graduation1?: InputMaybe<Club_WorldFamilyClub_Temp20240408Graduation1Input>;
  temp20251028ExchangeReason?: InputMaybe<Club_WorldFamilyClub_Temp20251028ExchangeReasonInput>;
  temp20260310Product?: InputMaybe<Club_WorldFamilyClub_Temp20260310ProductInput>;
  tempChildGraduationApplicationNew?: InputMaybe<Club_WorldFamilyClub_TempChildGraduationApplicationNewInput>;
  tempChildGraduationApplicationOld?: InputMaybe<Club_WorldFamilyClub_TempChildGraduationApplicationOldInput>;
  tempFaceCall?: InputMaybe<Club_WorldFamilyClub_TempFaceCallInput>;
  tempFaceCallHk?: InputMaybe<Club_WorldFamilyClub_TempFaceCallHkInput>;
  tempFaceCallKr?: InputMaybe<Club_WorldFamilyClub_TempFaceCallKrInput>;
  tempGoGoLiveSong?: InputMaybe<Club_WorldFamilyClub_TempGoGoLiveSongInput>;
  tempHkAppMyFavorite?: InputMaybe<Club_WorldFamilyClub_TempHkAppMyFavoriteInput>;
  tempHkClubappsFacecallCrew?: InputMaybe<Club_WorldFamilyClub_TempHkClubappsFacecallCrewInput>;
  tempHkClubappsFacecallHistory?: InputMaybe<Club_WorldFamilyClub_TempHkClubappsFacecallHistoryInput>;
  tempHkClubappsFacecallSong?: InputMaybe<Club_WorldFamilyClub_TempHkClubappsFacecallSongInput>;
  tempHkDmemChild?: InputMaybe<Club_WorldFamilyClub_TempHkDmemChildInput>;
  tempHkTeSong?: InputMaybe<Club_WorldFamilyClub_TempHkTeSongInput>;
  tempHkTematerial?: InputMaybe<Club_WorldFamilyClub_TempHkTematerialInput>;
  tempKrFaceCallHist?: InputMaybe<Club_WorldFamilyClub_TempKrFaceCallHistInput>;
  tempKrFcCrewM?: InputMaybe<Club_WorldFamilyClub_TempKrFcCrewMInput>;
  tempKrFcsongCrew?: InputMaybe<Club_WorldFamilyClub_TempKrFcsongCrewInput>;
  tempKrMyFavorite?: InputMaybe<Club_WorldFamilyClub_TempKrMyFavoriteInput>;
  tempKrTeSong?: InputMaybe<Club_WorldFamilyClub_TempKrTeSongInput>;
  tempKrWfeClubMemberChild?: InputMaybe<Club_WorldFamilyClub_TempKrWfeClubMemberChildInput>;
  tempTalkAlongCard?: InputMaybe<Club_WorldFamilyClub_TempTalkAlongCardInput>;
  tempTwCambridge?: InputMaybe<Club_WorldFamilyClub_TempTwCambridgeInput>;
  tempTwFaceCallHist?: InputMaybe<Club_WorldFamilyClub_TempTwFaceCallHistInput>;
  tempTwFcCrewM?: InputMaybe<Club_WorldFamilyClub_TempTwFcCrewMInput>;
  tempTwFcsongCrew?: InputMaybe<Club_WorldFamilyClub_TempTwFcsongCrewInput>;
  tempTwFcsongMonthlyRecommend?: InputMaybe<Club_WorldFamilyClub_TempTwFcsongMonthlyRecommendInput>;
  tempTwMyFavorite?: InputMaybe<Club_WorldFamilyClub_TempTwMyFavoriteInput>;
  tempTwTeSong?: InputMaybe<Club_WorldFamilyClub_TempTwTeSongInput>;
  tempTwTeSongForCapLevel?: InputMaybe<Club_WorldFamilyClub_TempTwTeSongForCapLevelInput>;
  tempWfcGraC?: InputMaybe<Club_WorldFamilyClub_TempWfcGraCInput>;
  tempWfcGraCOrganized?: InputMaybe<Club_WorldFamilyClub_TempWfcGraCOrganizedInput>;
  testUserAccount?: InputMaybe<Club_WorldFamilyClub_TestUserAccountInput>;
  testWater?: InputMaybe<Club_WorldFamilyClub_TestWaterInput>;
  testWaterSub?: InputMaybe<Club_WorldFamilyClub_TestWaterSubInput>;
  tev2MonthlySong?: InputMaybe<Club_WorldFamilyClub_Tev2MonthlySongInput>;
  user?: InputMaybe<Club_WorldFamilyClub_UserInput>;
  videoForTrialmode?: InputMaybe<Club_WorldFamilyClub_VideoForTrialmodeInput>;
  wfcLibraryFaq?: InputMaybe<Club_WorldFamilyClub_WfcLibraryFaqInput>;
  wfcLibraryLog?: InputMaybe<Club_WorldFamilyClub_WfcLibraryLogInput>;
  wfcNowPageViewLog?: InputMaybe<Club_WorldFamilyClub_WfcNowPageViewLogInput>;
};

export type Club_WorldFamilyClub_Mutation_AddRange = {
  __typename?: 'Club_WorldFamilyClub_Mutation_AddRange';
  appAuths?: Maybe<Array<Club_WorldFamilyClub_AppAuth>>;
  appBanners?: Maybe<Array<Club_WorldFamilyClub_AppBanner>>;
  appDigitalMagazines?: Maybe<Array<Club_WorldFamilyClub_AppDigitalMagazine>>;
  appMemberAuthorizeLogs?: Maybe<Array<Club_WorldFamilyClub_AppMemberAuthorizeLog>>;
  appMemberAuthorizes?: Maybe<Array<Club_WorldFamilyClub_AppMemberAuthorize>>;
  appMemberChildren?: Maybe<Array<Club_WorldFamilyClub_AppMemberChild>>;
  appMemberDevices?: Maybe<Array<Club_WorldFamilyClub_AppMemberDevice>>;
  appMemberFirstLogins?: Maybe<Array<Club_WorldFamilyClub_AppMemberFirstLogin>>;
  appMemberNotificationPushFirebases?: Maybe<Array<Club_WorldFamilyClub_AppMemberNotificationPushFirebase>>;
  appMemberNotifications?: Maybe<Array<Club_WorldFamilyClub_AppMemberNotification>>;
  appNotificationMembers?: Maybe<Array<Club_WorldFamilyClub_AppNotificationMember>>;
  appNotificationTypeMarkets?: Maybe<Array<Club_WorldFamilyClub_AppNotificationTypeMarket>>;
  appNotificationTypes?: Maybe<Array<Club_WorldFamilyClub_AppNotificationType>>;
  appNotifications?: Maybe<Array<Club_WorldFamilyClub_AppNotification>>;
  appRegionEmergencies?: Maybe<Array<Club_WorldFamilyClub_AppRegionEmergency>>;
  appReleases?: Maybe<Array<Club_WorldFamilyClub_AppRelease>>;
  appServiceRegionFestivalImages?: Maybe<Array<Club_WorldFamilyClub_AppServiceRegionFestivalImage>>;
  appServiceRegionImages?: Maybe<Array<Club_WorldFamilyClub_AppServiceRegionImage>>;
  appSurveyMembers?: Maybe<Array<Club_WorldFamilyClub_AppSurveyMember>>;
  appSurveyQas?: Maybe<Array<Club_WorldFamilyClub_AppSurveyQa>>;
  appSurveyReminders?: Maybe<Array<Club_WorldFamilyClub_AppSurveyReminder>>;
  appSurveys?: Maybe<Array<Club_WorldFamilyClub_AppSurvey>>;
  azureFunctions?: Maybe<Array<Club_WorldFamilyClub_AzureFunction>>;
  bankCodes?: Maybe<Array<Club_WorldFamilyClub_BankCode>>;
  broadcastPromotions?: Maybe<Array<Club_WorldFamilyClub_BroadcastPromotion>>;
  capGuidePdfs?: Maybe<Array<Club_WorldFamilyClub_CapGuidePdf>>;
  childGraduationApplications?: Maybe<Array<Club_WorldFamilyClub_ChildGraduationApplication>>;
  creditcardBankCodes?: Maybe<Array<Club_WorldFamilyClub_CreditcardBankCode>>;
  dweProductPackages?: Maybe<Array<Club_WorldFamilyClub_DweProductPackage>>;
  dweProductSongTools?: Maybe<Array<Club_WorldFamilyClub_DweProductSongTool>>;
  dweProductSongs?: Maybe<Array<Club_WorldFamilyClub_DweProductSong>>;
  dweProductTools?: Maybe<Array<Club_WorldFamilyClub_DweProductTool>>;
  easypayOrderLogs?: Maybe<Array<Club_WorldFamilyClub_EasypayOrderLog>>;
  entryPackageOrders?: Maybe<Array<Club_WorldFamilyClub_EntryPackageOrder>>;
  entryPackageOrdersMemberPaymentInfos?: Maybe<Array<Club_WorldFamilyClub_EntryPackageOrdersMemberPaymentInfo>>;
  eventBannerRegions?: Maybe<Array<Club_WorldFamilyClub_EventBannerRegion>>;
  eventBanners?: Maybe<Array<Club_WorldFamilyClub_EventBanner>>;
  eventCheckInAuths?: Maybe<Array<Club_WorldFamilyClub_EventCheckInAuth>>;
  eventNotificationLogs?: Maybe<Array<Club_WorldFamilyClub_EventNotificationLog>>;
  eventPromotions?: Maybe<Array<Club_WorldFamilyClub_EventPromotion>>;
  eventSeats?: Maybe<Array<Club_WorldFamilyClub_EventSeat>>;
  eventTypes?: Maybe<Array<Club_WorldFamilyClub_EventType>>;
  exchangeApplicationItems?: Maybe<Array<Club_WorldFamilyClub_ExchangeApplicationItem>>;
  exchangeApplications?: Maybe<Array<Club_WorldFamilyClub_ExchangeApplication>>;
  exchangeReasonTranslations?: Maybe<Array<Club_WorldFamilyClub_ExchangeReasonTranslation>>;
  exchangeReasons?: Maybe<Array<Club_WorldFamilyClub_ExchangeReason>>;
  faceCallAndTelephoneEnglishes?: Maybe<Array<Club_WorldFamilyClub_FaceCallAndTelephoneEnglish>>;
  faceCallForTrialmodes?: Maybe<Array<Club_WorldFamilyClub_FaceCallForTrialmode>>;
  faceCallHistCounts?: Maybe<Array<Club_WorldFamilyClub_FaceCallHistCount>>;
  faceCallHists?: Maybe<Array<Club_WorldFamilyClub_FaceCallHist>>;
  faceCallMonthlyRecommends?: Maybe<Array<Club_WorldFamilyClub_FaceCallMonthlyRecommend>>;
  faceCallPerformers?: Maybe<Array<Club_WorldFamilyClub_FaceCallPerformer>>;
  faceCallSeasonHolidays?: Maybe<Array<Club_WorldFamilyClub_FaceCallSeasonHoliday>>;
  faceCallSongAndPerformers?: Maybe<Array<Club_WorldFamilyClub_FaceCallSongAndPerformer>>;
  faceCallSongPublics?: Maybe<Array<Club_WorldFamilyClub_FaceCallSongPublic>>;
  faceCallSongs?: Maybe<Array<Club_WorldFamilyClub_FaceCallSong>>;
  goGoLiveDesktopQrcodes?: Maybe<Array<Club_WorldFamilyClub_GoGoLiveDesktopQrcode>>;
  goGoLiveLevels?: Maybe<Array<Club_WorldFamilyClub_GoGoLiveLevel>>;
  goGoLiveOpenDates?: Maybe<Array<Club_WorldFamilyClub_GoGoLiveOpenDate>>;
  goGoLiveParentGuideLocales?: Maybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuideLocale>>;
  goGoLiveParentGuideSessions?: Maybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuideSession>>;
  goGoLiveParentGuideSongs?: Maybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuideSong>>;
  goGoLiveParentGuideTacs?: Maybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuideTac>>;
  goGoLiveParentGuideToys?: Maybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuideToy>>;
  goGoLiveParentGuides?: Maybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuide>>;
  goGoLivePromotions?: Maybe<Array<Club_WorldFamilyClub_GoGoLivePromotion>>;
  goGoLiveSessions?: Maybe<Array<Club_WorldFamilyClub_GoGoLiveSession>>;
  goGoLiveSongs?: Maybe<Array<Club_WorldFamilyClub_GoGoLiveSong>>;
  goGoLiveToys?: Maybe<Array<Club_WorldFamilyClub_GoGoLiveToy>>;
  graduationApplicationEvaluations?: Maybe<Array<Club_WorldFamilyClub_GraduationApplicationEvaluation>>;
  graduationApplicationSubTasks?: Maybe<Array<Club_WorldFamilyClub_GraduationApplicationSubTask>>;
  graduationApplicationTasks?: Maybe<Array<Club_WorldFamilyClub_GraduationApplicationTask>>;
  graduationApplications?: Maybe<Array<Club_WorldFamilyClub_GraduationApplication>>;
  graduationChildSettings?: Maybe<Array<Club_WorldFamilyClub_GraduationChildSetting>>;
  graduationChildren?: Maybe<Array<Club_WorldFamilyClub_GraduationChild>>;
  graduationEvaluations?: Maybe<Array<Club_WorldFamilyClub_GraduationEvaluation>>;
  graduationNotifications?: Maybe<Array<Club_WorldFamilyClub_GraduationNotification>>;
  graduationSubApplications?: Maybe<Array<Club_WorldFamilyClub_GraduationSubApplication>>;
  graduationSubTaskMarketDescriptions?: Maybe<Array<Club_WorldFamilyClub_GraduationSubTaskMarketDescription>>;
  graduationTaskMarketDescriptions?: Maybe<Array<Club_WorldFamilyClub_GraduationTaskMarketDescription>>;
  graphqlAccesses?: Maybe<Array<Club_WorldFamilyClub_GraphqlAccess>>;
  graphqlSchemas?: Maybe<Array<Club_WorldFamilyClub_GraphqlSchema>>;
  holidayAudios?: Maybe<Array<Club_WorldFamilyClub_HolidayAudio>>;
  holidaySettings?: Maybe<Array<Club_WorldFamilyClub_HolidaySetting>>;
  holidayVideoBonusEntitlementTests?: Maybe<Array<Club_WorldFamilyClub_HolidayVideoBonusEntitlementTest>>;
  holidayVideoMarketSettings?: Maybe<Array<Club_WorldFamilyClub_HolidayVideoMarketSetting>>;
  holidayVideoMarkets?: Maybe<Array<Club_WorldFamilyClub_HolidayVideoMarket>>;
  holidayVideoMembers?: Maybe<Array<Club_WorldFamilyClub_HolidayVideoMember>>;
  holidayVideos?: Maybe<Array<Club_WorldFamilyClub_HolidayVideo>>;
  kidsWorldVideos?: Maybe<Array<Club_WorldFamilyClub_KidsWorldVideo>>;
  memberMessageSettings?: Maybe<Array<Club_WorldFamilyClub_MemberMessageSetting>>;
  memberMonthlyActiveSummaries?: Maybe<Array<Club_WorldFamilyClub_MemberMonthlyActiveSummary>>;
  memberUpgradePayments?: Maybe<Array<Club_WorldFamilyClub_MemberUpgradePayment>>;
  myFavoriteFaceCallSongs?: Maybe<Array<Club_WorldFamilyClub_MyFavoriteFaceCallSong>>;
  myFavoriteFaceCalls?: Maybe<Array<Club_WorldFamilyClub_MyFavoriteFaceCall>>;
  notificationIcons?: Maybe<Array<Club_WorldFamilyClub_NotificationIcon>>;
  notifications?: Maybe<Array<Club_WorldFamilyClub_Notification>>;
  oneTimeTokens?: Maybe<Array<Club_WorldFamilyClub_OneTimeToken>>;
  onlineEventLogs?: Maybe<Array<Club_WorldFamilyClub_OnlineEventLog>>;
  onlineShows?: Maybe<Array<Club_WorldFamilyClub_OnlineShow>>;
  parameters?: Maybe<Array<Club_WorldFamilyClub_Parameter>>;
  productCategories?: Maybe<Array<Club_WorldFamilyClub_ProductCategory>>;
  productCategoryTranslations?: Maybe<Array<Club_WorldFamilyClub_ProductCategoryTranslation>>;
  productSubCategories?: Maybe<Array<Club_WorldFamilyClub_ProductSubCategory>>;
  productSubCategoryExchangeReasons?: Maybe<Array<Club_WorldFamilyClub_ProductSubCategoryExchangeReason>>;
  productSubCategoryTranslations?: Maybe<Array<Club_WorldFamilyClub_ProductSubCategoryTranslation>>;
  productTranslations?: Maybe<Array<Club_WorldFamilyClub_ProductTranslation>>;
  products?: Maybe<Array<Club_WorldFamilyClub_Product>>;
  products1s?: Maybe<Array<Club_WorldFamilyClub_Products1>>;
  regionBanners?: Maybe<Array<Club_WorldFamilyClub_RegionBanner>>;
  searchKeywords?: Maybe<Array<Club_WorldFamilyClub_SearchKeyword>>;
  serviceBannerDefaults?: Maybe<Array<Club_WorldFamilyClub_ServiceBannerDefault>>;
  serviceBannerScheduleds?: Maybe<Array<Club_WorldFamilyClub_ServiceBannerScheduled>>;
  serviceOneTimeTokens?: Maybe<Array<Club_WorldFamilyClub_ServiceOneTimeToken>>;
  serviceSearches?: Maybe<Array<Club_WorldFamilyClub_ServiceSearch>>;
  services?: Maybe<Array<Club_WorldFamilyClub_Service>>;
  smsCertificationLogs?: Maybe<Array<Club_WorldFamilyClub_SmsCertificationLog>>;
  smsCertifications?: Maybe<Array<Club_WorldFamilyClub_SmsCertification>>;
  smsVerificationCodes?: Maybe<Array<Club_WorldFamilyClub_SmsVerificationCode>>;
  surveyTypeFormLists?: Maybe<Array<Club_WorldFamilyClub_SurveyTypeFormList>>;
  surveyTypeForms?: Maybe<Array<Club_WorldFamilyClub_SurveyTypeForm>>;
  talkAlongCards?: Maybe<Array<Club_WorldFamilyClub_TalkAlongCard>>;
  teSongToys?: Maybe<Array<Club_WorldFamilyClub_TeSongToy>>;
  teSongs?: Maybe<Array<Club_WorldFamilyClub_TeSong>>;
  temp20240408Graduation1s?: Maybe<Array<Club_WorldFamilyClub_Temp20240408Graduation1>>;
  temp20240408Graduations?: Maybe<Array<Club_WorldFamilyClub_Temp20240408Graduation>>;
  temp20251028ExchangeReasons?: Maybe<Array<Club_WorldFamilyClub_Temp20251028ExchangeReason>>;
  temp20260310Products?: Maybe<Array<Club_WorldFamilyClub_Temp20260310Product>>;
  tempChildGraduationApplicationNews?: Maybe<Array<Club_WorldFamilyClub_TempChildGraduationApplicationNew>>;
  tempChildGraduationApplicationOlds?: Maybe<Array<Club_WorldFamilyClub_TempChildGraduationApplicationOld>>;
  tempFaceCallHks?: Maybe<Array<Club_WorldFamilyClub_TempFaceCallHk>>;
  tempFaceCallKrs?: Maybe<Array<Club_WorldFamilyClub_TempFaceCallKr>>;
  tempFaceCalls?: Maybe<Array<Club_WorldFamilyClub_TempFaceCall>>;
  tempGoGoLiveSongs?: Maybe<Array<Club_WorldFamilyClub_TempGoGoLiveSong>>;
  tempHkAppMyFavorites?: Maybe<Array<Club_WorldFamilyClub_TempHkAppMyFavorite>>;
  tempHkClubappsFacecallCrews?: Maybe<Array<Club_WorldFamilyClub_TempHkClubappsFacecallCrew>>;
  tempHkClubappsFacecallHistories?: Maybe<Array<Club_WorldFamilyClub_TempHkClubappsFacecallHistory>>;
  tempHkClubappsFacecallSongs?: Maybe<Array<Club_WorldFamilyClub_TempHkClubappsFacecallSong>>;
  tempHkDmemChildren?: Maybe<Array<Club_WorldFamilyClub_TempHkDmemChild>>;
  tempHkTeSongs?: Maybe<Array<Club_WorldFamilyClub_TempHkTeSong>>;
  tempHkTematerials?: Maybe<Array<Club_WorldFamilyClub_TempHkTematerial>>;
  tempKrFaceCallHists?: Maybe<Array<Club_WorldFamilyClub_TempKrFaceCallHist>>;
  tempKrFcCrewMs?: Maybe<Array<Club_WorldFamilyClub_TempKrFcCrewM>>;
  tempKrFcsongCrews?: Maybe<Array<Club_WorldFamilyClub_TempKrFcsongCrew>>;
  tempKrMyFavorites?: Maybe<Array<Club_WorldFamilyClub_TempKrMyFavorite>>;
  tempKrTeSongs?: Maybe<Array<Club_WorldFamilyClub_TempKrTeSong>>;
  tempKrWfeClubMemberChildren?: Maybe<Array<Club_WorldFamilyClub_TempKrWfeClubMemberChild>>;
  tempTalkAlongCards?: Maybe<Array<Club_WorldFamilyClub_TempTalkAlongCard>>;
  tempTwCambridges?: Maybe<Array<Club_WorldFamilyClub_TempTwCambridge>>;
  tempTwFaceCallHists?: Maybe<Array<Club_WorldFamilyClub_TempTwFaceCallHist>>;
  tempTwFcCrewMs?: Maybe<Array<Club_WorldFamilyClub_TempTwFcCrewM>>;
  tempTwFcsongCrews?: Maybe<Array<Club_WorldFamilyClub_TempTwFcsongCrew>>;
  tempTwFcsongMonthlyRecommends?: Maybe<Array<Club_WorldFamilyClub_TempTwFcsongMonthlyRecommend>>;
  tempTwMyFavorites?: Maybe<Array<Club_WorldFamilyClub_TempTwMyFavorite>>;
  tempTwTeSongForCapLevels?: Maybe<Array<Club_WorldFamilyClub_TempTwTeSongForCapLevel>>;
  tempTwTeSongs?: Maybe<Array<Club_WorldFamilyClub_TempTwTeSong>>;
  tempWfcGraCOrganizeds?: Maybe<Array<Club_WorldFamilyClub_TempWfcGraCOrganized>>;
  tempWfcGraCs?: Maybe<Array<Club_WorldFamilyClub_TempWfcGraC>>;
  testUserAccounts?: Maybe<Array<Club_WorldFamilyClub_TestUserAccount>>;
  testWaterSubs?: Maybe<Array<Club_WorldFamilyClub_TestWaterSub>>;
  testWaters?: Maybe<Array<Club_WorldFamilyClub_TestWater>>;
  tev2MonthlySongs?: Maybe<Array<Club_WorldFamilyClub_Tev2MonthlySong>>;
  users?: Maybe<Array<Club_WorldFamilyClub_User>>;
  videoForTrialmodes?: Maybe<Array<Club_WorldFamilyClub_VideoForTrialmode>>;
  wfcLibraryFaqs?: Maybe<Array<Club_WorldFamilyClub_WfcLibraryFaq>>;
  wfcLibraryLogs?: Maybe<Array<Club_WorldFamilyClub_WfcLibraryLog>>;
  wfcNowPageViewLogs?: Maybe<Array<Club_WorldFamilyClub_WfcNowPageViewLog>>;
};

export type Club_WorldFamilyClub_Mutation_AddRangeInput = {
  appAuths?: InputMaybe<Array<Club_WorldFamilyClub_AppAuthInput>>;
  appBanners?: InputMaybe<Array<Club_WorldFamilyClub_AppBannerInput>>;
  appDigitalMagazines?: InputMaybe<Array<Club_WorldFamilyClub_AppDigitalMagazineInput>>;
  appMemberAuthorizeLogs?: InputMaybe<Array<Club_WorldFamilyClub_AppMemberAuthorizeLogInput>>;
  appMemberAuthorizes?: InputMaybe<Array<Club_WorldFamilyClub_AppMemberAuthorizeInput>>;
  appMemberChildren?: InputMaybe<Array<Club_WorldFamilyClub_AppMemberChildInput>>;
  appMemberDevices?: InputMaybe<Array<Club_WorldFamilyClub_AppMemberDeviceInput>>;
  appMemberFirstLogins?: InputMaybe<Array<Club_WorldFamilyClub_AppMemberFirstLoginInput>>;
  appMemberNotificationPushFirebases?: InputMaybe<Array<Club_WorldFamilyClub_AppMemberNotificationPushFirebaseInput>>;
  appMemberNotifications?: InputMaybe<Array<Club_WorldFamilyClub_AppMemberNotificationInput>>;
  appNotificationMembers?: InputMaybe<Array<Club_WorldFamilyClub_AppNotificationMemberInput>>;
  appNotificationTypeMarkets?: InputMaybe<Array<Club_WorldFamilyClub_AppNotificationTypeMarketInput>>;
  appNotificationTypes?: InputMaybe<Array<Club_WorldFamilyClub_AppNotificationTypeInput>>;
  appNotifications?: InputMaybe<Array<Club_WorldFamilyClub_AppNotificationInput>>;
  appRegionEmergencies?: InputMaybe<Array<Club_WorldFamilyClub_AppRegionEmergencyInput>>;
  appReleases?: InputMaybe<Array<Club_WorldFamilyClub_AppReleaseInput>>;
  appServiceRegionFestivalImages?: InputMaybe<Array<Club_WorldFamilyClub_AppServiceRegionFestivalImageInput>>;
  appServiceRegionImages?: InputMaybe<Array<Club_WorldFamilyClub_AppServiceRegionImageInput>>;
  appSurveyMembers?: InputMaybe<Array<Club_WorldFamilyClub_AppSurveyMemberInput>>;
  appSurveyQas?: InputMaybe<Array<Club_WorldFamilyClub_AppSurveyQaInput>>;
  appSurveyReminders?: InputMaybe<Array<Club_WorldFamilyClub_AppSurveyReminderInput>>;
  appSurveys?: InputMaybe<Array<Club_WorldFamilyClub_AppSurveyInput>>;
  azureFunctions?: InputMaybe<Array<Club_WorldFamilyClub_AzureFunctionInput>>;
  bankCodes?: InputMaybe<Array<Club_WorldFamilyClub_BankCodeInput>>;
  broadcastPromotions?: InputMaybe<Array<Club_WorldFamilyClub_BroadcastPromotionInput>>;
  capGuidePdfs?: InputMaybe<Array<Club_WorldFamilyClub_CapGuidePdfInput>>;
  childGraduationApplications?: InputMaybe<Array<Club_WorldFamilyClub_ChildGraduationApplicationInput>>;
  creditcardBankCodes?: InputMaybe<Array<Club_WorldFamilyClub_CreditcardBankCodeInput>>;
  dweProductPackages?: InputMaybe<Array<Club_WorldFamilyClub_DweProductPackageInput>>;
  dweProductSongTools?: InputMaybe<Array<Club_WorldFamilyClub_DweProductSongToolInput>>;
  dweProductSongs?: InputMaybe<Array<Club_WorldFamilyClub_DweProductSongInput>>;
  dweProductTools?: InputMaybe<Array<Club_WorldFamilyClub_DweProductToolInput>>;
  easypayOrderLogs?: InputMaybe<Array<Club_WorldFamilyClub_EasypayOrderLogInput>>;
  entryPackageOrders?: InputMaybe<Array<Club_WorldFamilyClub_EntryPackageOrderInput>>;
  entryPackageOrdersMemberPaymentInfos?: InputMaybe<Array<Club_WorldFamilyClub_EntryPackageOrdersMemberPaymentInfoInput>>;
  eventBannerRegions?: InputMaybe<Array<Club_WorldFamilyClub_EventBannerRegionInput>>;
  eventBanners?: InputMaybe<Array<Club_WorldFamilyClub_EventBannerInput>>;
  eventCheckInAuths?: InputMaybe<Array<Club_WorldFamilyClub_EventCheckInAuthInput>>;
  eventNotificationLogs?: InputMaybe<Array<Club_WorldFamilyClub_EventNotificationLogInput>>;
  eventPromotions?: InputMaybe<Array<Club_WorldFamilyClub_EventPromotionInput>>;
  eventSeats?: InputMaybe<Array<Club_WorldFamilyClub_EventSeatInput>>;
  eventTypes?: InputMaybe<Array<Club_WorldFamilyClub_EventTypeInput>>;
  exchangeApplicationItems?: InputMaybe<Array<Club_WorldFamilyClub_ExchangeApplicationItemInput>>;
  exchangeApplications?: InputMaybe<Array<Club_WorldFamilyClub_ExchangeApplicationInput>>;
  exchangeReasonTranslations?: InputMaybe<Array<Club_WorldFamilyClub_ExchangeReasonTranslationInput>>;
  exchangeReasons?: InputMaybe<Array<Club_WorldFamilyClub_ExchangeReasonInput>>;
  faceCallAndTelephoneEnglishes?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallAndTelephoneEnglishInput>>;
  faceCallForTrialmodes?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallForTrialmodeInput>>;
  faceCallHistCounts?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallHistCountInput>>;
  faceCallHists?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallHistInput>>;
  faceCallMonthlyRecommends?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallMonthlyRecommendInput>>;
  faceCallPerformers?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallPerformerInput>>;
  faceCallSeasonHolidays?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallSeasonHolidayInput>>;
  faceCallSongAndPerformers?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallSongAndPerformerInput>>;
  faceCallSongPublics?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallSongPublicInput>>;
  faceCallSongs?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallSongInput>>;
  goGoLiveDesktopQrcodes?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveDesktopQrcodeInput>>;
  goGoLiveLevels?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveLevelInput>>;
  goGoLiveOpenDates?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveOpenDateInput>>;
  goGoLiveParentGuideLocales?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuideLocaleInput>>;
  goGoLiveParentGuideSessions?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuideSessionInput>>;
  goGoLiveParentGuideSongs?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuideSongInput>>;
  goGoLiveParentGuideTacs?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuideTacInput>>;
  goGoLiveParentGuideToys?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuideToyInput>>;
  goGoLiveParentGuides?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuideInput>>;
  goGoLivePromotions?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLivePromotionInput>>;
  goGoLiveSessions?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveSessionInput>>;
  goGoLiveSongs?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveSongInput>>;
  goGoLiveToys?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveToyInput>>;
  graduationApplicationEvaluations?: InputMaybe<Array<Club_WorldFamilyClub_GraduationApplicationEvaluationInput>>;
  graduationApplicationSubTasks?: InputMaybe<Array<Club_WorldFamilyClub_GraduationApplicationSubTaskInput>>;
  graduationApplicationTasks?: InputMaybe<Array<Club_WorldFamilyClub_GraduationApplicationTaskInput>>;
  graduationApplications?: InputMaybe<Array<Club_WorldFamilyClub_GraduationApplicationInput>>;
  graduationChildSettings?: InputMaybe<Array<Club_WorldFamilyClub_GraduationChildSettingInput>>;
  graduationChildren?: InputMaybe<Array<Club_WorldFamilyClub_GraduationChildInput>>;
  graduationEvaluations?: InputMaybe<Array<Club_WorldFamilyClub_GraduationEvaluationInput>>;
  graduationNotifications?: InputMaybe<Array<Club_WorldFamilyClub_GraduationNotificationInput>>;
  graduationSubApplications?: InputMaybe<Array<Club_WorldFamilyClub_GraduationSubApplicationInput>>;
  graduationSubTaskMarketDescriptions?: InputMaybe<Array<Club_WorldFamilyClub_GraduationSubTaskMarketDescriptionInput>>;
  graduationTaskMarketDescriptions?: InputMaybe<Array<Club_WorldFamilyClub_GraduationTaskMarketDescriptionInput>>;
  graphqlAccesses?: InputMaybe<Array<Club_WorldFamilyClub_GraphqlAccessInput>>;
  graphqlSchemas?: InputMaybe<Array<Club_WorldFamilyClub_GraphqlSchemaInput>>;
  holidayAudios?: InputMaybe<Array<Club_WorldFamilyClub_HolidayAudioInput>>;
  holidaySettings?: InputMaybe<Array<Club_WorldFamilyClub_HolidaySettingInput>>;
  holidayVideoBonusEntitlementTests?: InputMaybe<Array<Club_WorldFamilyClub_HolidayVideoBonusEntitlementTestInput>>;
  holidayVideoMarketSettings?: InputMaybe<Array<Club_WorldFamilyClub_HolidayVideoMarketSettingInput>>;
  holidayVideoMarkets?: InputMaybe<Array<Club_WorldFamilyClub_HolidayVideoMarketInput>>;
  holidayVideoMembers?: InputMaybe<Array<Club_WorldFamilyClub_HolidayVideoMemberInput>>;
  holidayVideos?: InputMaybe<Array<Club_WorldFamilyClub_HolidayVideoInput>>;
  kidsWorldVideos?: InputMaybe<Array<Club_WorldFamilyClub_KidsWorldVideoInput>>;
  memberMessageSettings?: InputMaybe<Array<Club_WorldFamilyClub_MemberMessageSettingInput>>;
  memberMonthlyActiveSummaries?: InputMaybe<Array<Club_WorldFamilyClub_MemberMonthlyActiveSummaryInput>>;
  memberUpgradePayments?: InputMaybe<Array<Club_WorldFamilyClub_MemberUpgradePaymentInput>>;
  myFavoriteFaceCallSongs?: InputMaybe<Array<Club_WorldFamilyClub_MyFavoriteFaceCallSongInput>>;
  myFavoriteFaceCalls?: InputMaybe<Array<Club_WorldFamilyClub_MyFavoriteFaceCallInput>>;
  notificationIcons?: InputMaybe<Array<Club_WorldFamilyClub_NotificationIconInput>>;
  notifications?: InputMaybe<Array<Club_WorldFamilyClub_NotificationInput>>;
  oneTimeTokens?: InputMaybe<Array<Club_WorldFamilyClub_OneTimeTokenInput>>;
  onlineEventLogs?: InputMaybe<Array<Club_WorldFamilyClub_OnlineEventLogInput>>;
  onlineShows?: InputMaybe<Array<Club_WorldFamilyClub_OnlineShowInput>>;
  parameters?: InputMaybe<Array<Club_WorldFamilyClub_ParameterInput>>;
  productCategories?: InputMaybe<Array<Club_WorldFamilyClub_ProductCategoryInput>>;
  productCategoryTranslations?: InputMaybe<Array<Club_WorldFamilyClub_ProductCategoryTranslationInput>>;
  productSubCategories?: InputMaybe<Array<Club_WorldFamilyClub_ProductSubCategoryInput>>;
  productSubCategoryExchangeReasons?: InputMaybe<Array<Club_WorldFamilyClub_ProductSubCategoryExchangeReasonInput>>;
  productSubCategoryTranslations?: InputMaybe<Array<Club_WorldFamilyClub_ProductSubCategoryTranslationInput>>;
  productTranslations?: InputMaybe<Array<Club_WorldFamilyClub_ProductTranslationInput>>;
  products?: InputMaybe<Array<Club_WorldFamilyClub_ProductInput>>;
  products1s?: InputMaybe<Array<Club_WorldFamilyClub_Products1Input>>;
  regionBanners?: InputMaybe<Array<Club_WorldFamilyClub_RegionBannerInput>>;
  searchKeywords?: InputMaybe<Array<Club_WorldFamilyClub_SearchKeywordInput>>;
  serviceBannerDefaults?: InputMaybe<Array<Club_WorldFamilyClub_ServiceBannerDefaultInput>>;
  serviceBannerScheduleds?: InputMaybe<Array<Club_WorldFamilyClub_ServiceBannerScheduledInput>>;
  serviceOneTimeTokens?: InputMaybe<Array<Club_WorldFamilyClub_ServiceOneTimeTokenInput>>;
  serviceSearches?: InputMaybe<Array<Club_WorldFamilyClub_ServiceSearchInput>>;
  services?: InputMaybe<Array<Club_WorldFamilyClub_ServiceInput>>;
  smsCertificationLogs?: InputMaybe<Array<Club_WorldFamilyClub_SmsCertificationLogInput>>;
  smsCertifications?: InputMaybe<Array<Club_WorldFamilyClub_SmsCertificationInput>>;
  smsVerificationCodes?: InputMaybe<Array<Club_WorldFamilyClub_SmsVerificationCodeInput>>;
  surveyTypeFormLists?: InputMaybe<Array<Club_WorldFamilyClub_SurveyTypeFormListInput>>;
  surveyTypeForms?: InputMaybe<Array<Club_WorldFamilyClub_SurveyTypeFormInput>>;
  talkAlongCards?: InputMaybe<Array<Club_WorldFamilyClub_TalkAlongCardInput>>;
  teSongToys?: InputMaybe<Array<Club_WorldFamilyClub_TeSongToyInput>>;
  teSongs?: InputMaybe<Array<Club_WorldFamilyClub_TeSongInput>>;
  temp20240408Graduation1s?: InputMaybe<Array<Club_WorldFamilyClub_Temp20240408Graduation1Input>>;
  temp20240408Graduations?: InputMaybe<Array<Club_WorldFamilyClub_Temp20240408GraduationInput>>;
  temp20251028ExchangeReasons?: InputMaybe<Array<Club_WorldFamilyClub_Temp20251028ExchangeReasonInput>>;
  temp20260310Products?: InputMaybe<Array<Club_WorldFamilyClub_Temp20260310ProductInput>>;
  tempChildGraduationApplicationNews?: InputMaybe<Array<Club_WorldFamilyClub_TempChildGraduationApplicationNewInput>>;
  tempChildGraduationApplicationOlds?: InputMaybe<Array<Club_WorldFamilyClub_TempChildGraduationApplicationOldInput>>;
  tempFaceCallHks?: InputMaybe<Array<Club_WorldFamilyClub_TempFaceCallHkInput>>;
  tempFaceCallKrs?: InputMaybe<Array<Club_WorldFamilyClub_TempFaceCallKrInput>>;
  tempFaceCalls?: InputMaybe<Array<Club_WorldFamilyClub_TempFaceCallInput>>;
  tempGoGoLiveSongs?: InputMaybe<Array<Club_WorldFamilyClub_TempGoGoLiveSongInput>>;
  tempHkAppMyFavorites?: InputMaybe<Array<Club_WorldFamilyClub_TempHkAppMyFavoriteInput>>;
  tempHkClubappsFacecallCrews?: InputMaybe<Array<Club_WorldFamilyClub_TempHkClubappsFacecallCrewInput>>;
  tempHkClubappsFacecallHistories?: InputMaybe<Array<Club_WorldFamilyClub_TempHkClubappsFacecallHistoryInput>>;
  tempHkClubappsFacecallSongs?: InputMaybe<Array<Club_WorldFamilyClub_TempHkClubappsFacecallSongInput>>;
  tempHkDmemChildren?: InputMaybe<Array<Club_WorldFamilyClub_TempHkDmemChildInput>>;
  tempHkTeSongs?: InputMaybe<Array<Club_WorldFamilyClub_TempHkTeSongInput>>;
  tempHkTematerials?: InputMaybe<Array<Club_WorldFamilyClub_TempHkTematerialInput>>;
  tempKrFaceCallHists?: InputMaybe<Array<Club_WorldFamilyClub_TempKrFaceCallHistInput>>;
  tempKrFcCrewMs?: InputMaybe<Array<Club_WorldFamilyClub_TempKrFcCrewMInput>>;
  tempKrFcsongCrews?: InputMaybe<Array<Club_WorldFamilyClub_TempKrFcsongCrewInput>>;
  tempKrMyFavorites?: InputMaybe<Array<Club_WorldFamilyClub_TempKrMyFavoriteInput>>;
  tempKrTeSongs?: InputMaybe<Array<Club_WorldFamilyClub_TempKrTeSongInput>>;
  tempKrWfeClubMemberChildren?: InputMaybe<Array<Club_WorldFamilyClub_TempKrWfeClubMemberChildInput>>;
  tempTalkAlongCards?: InputMaybe<Array<Club_WorldFamilyClub_TempTalkAlongCardInput>>;
  tempTwCambridges?: InputMaybe<Array<Club_WorldFamilyClub_TempTwCambridgeInput>>;
  tempTwFaceCallHists?: InputMaybe<Array<Club_WorldFamilyClub_TempTwFaceCallHistInput>>;
  tempTwFcCrewMs?: InputMaybe<Array<Club_WorldFamilyClub_TempTwFcCrewMInput>>;
  tempTwFcsongCrews?: InputMaybe<Array<Club_WorldFamilyClub_TempTwFcsongCrewInput>>;
  tempTwFcsongMonthlyRecommends?: InputMaybe<Array<Club_WorldFamilyClub_TempTwFcsongMonthlyRecommendInput>>;
  tempTwMyFavorites?: InputMaybe<Array<Club_WorldFamilyClub_TempTwMyFavoriteInput>>;
  tempTwTeSongForCapLevels?: InputMaybe<Array<Club_WorldFamilyClub_TempTwTeSongForCapLevelInput>>;
  tempTwTeSongs?: InputMaybe<Array<Club_WorldFamilyClub_TempTwTeSongInput>>;
  tempWfcGraCOrganizeds?: InputMaybe<Array<Club_WorldFamilyClub_TempWfcGraCOrganizedInput>>;
  tempWfcGraCs?: InputMaybe<Array<Club_WorldFamilyClub_TempWfcGraCInput>>;
  testUserAccounts?: InputMaybe<Array<Club_WorldFamilyClub_TestUserAccountInput>>;
  testWaterSubs?: InputMaybe<Array<Club_WorldFamilyClub_TestWaterSubInput>>;
  testWaters?: InputMaybe<Array<Club_WorldFamilyClub_TestWaterInput>>;
  tev2MonthlySongs?: InputMaybe<Array<Club_WorldFamilyClub_Tev2MonthlySongInput>>;
  users?: InputMaybe<Array<Club_WorldFamilyClub_UserInput>>;
  videoForTrialmodes?: InputMaybe<Array<Club_WorldFamilyClub_VideoForTrialmodeInput>>;
  wfcLibraryFaqs?: InputMaybe<Array<Club_WorldFamilyClub_WfcLibraryFaqInput>>;
  wfcLibraryLogs?: InputMaybe<Array<Club_WorldFamilyClub_WfcLibraryLogInput>>;
  wfcNowPageViewLogs?: InputMaybe<Array<Club_WorldFamilyClub_WfcNowPageViewLogInput>>;
};

export type Club_WorldFamilyClub_Mutation_Payload = {
  __typename?: 'Club_WorldFamilyClub_Mutation_Payload';
  addContext?: Maybe<Club_WorldFamilyClub_Mutation_Add>;
  addRangeContext?: Maybe<Club_WorldFamilyClub_Mutation_AddRange>;
  count: Scalars['Int']['output'];
  query: Query;
  updateContext?: Maybe<Club_WorldFamilyClub_Mutation_Update>;
  updateRangeContext?: Maybe<Club_WorldFamilyClub_Mutation_UpdateRange>;
};

export type Club_WorldFamilyClub_Mutation_RemoveInput = {
  appAuth?: InputMaybe<Club_WorldFamilyClub_AppAuthInput>;
  appBanner?: InputMaybe<Club_WorldFamilyClub_AppBannerInput>;
  appDigitalMagazine?: InputMaybe<Club_WorldFamilyClub_AppDigitalMagazineInput>;
  appMemberAuthorize?: InputMaybe<Club_WorldFamilyClub_AppMemberAuthorizeInput>;
  appMemberAuthorizeLog?: InputMaybe<Club_WorldFamilyClub_AppMemberAuthorizeLogInput>;
  appMemberChild?: InputMaybe<Club_WorldFamilyClub_AppMemberChildInput>;
  appMemberDevice?: InputMaybe<Club_WorldFamilyClub_AppMemberDeviceInput>;
  appMemberFirstLogin?: InputMaybe<Club_WorldFamilyClub_AppMemberFirstLoginInput>;
  appMemberNotification?: InputMaybe<Club_WorldFamilyClub_AppMemberNotificationInput>;
  appMemberNotificationPushFirebase?: InputMaybe<Club_WorldFamilyClub_AppMemberNotificationPushFirebaseInput>;
  appNotification?: InputMaybe<Club_WorldFamilyClub_AppNotificationInput>;
  appNotificationMember?: InputMaybe<Club_WorldFamilyClub_AppNotificationMemberInput>;
  appNotificationType?: InputMaybe<Club_WorldFamilyClub_AppNotificationTypeInput>;
  appNotificationTypeMarket?: InputMaybe<Club_WorldFamilyClub_AppNotificationTypeMarketInput>;
  appRegionEmergency?: InputMaybe<Club_WorldFamilyClub_AppRegionEmergencyInput>;
  appRelease?: InputMaybe<Club_WorldFamilyClub_AppReleaseInput>;
  appServiceRegionFestivalImage?: InputMaybe<Club_WorldFamilyClub_AppServiceRegionFestivalImageInput>;
  appServiceRegionImage?: InputMaybe<Club_WorldFamilyClub_AppServiceRegionImageInput>;
  appSurvey?: InputMaybe<Club_WorldFamilyClub_AppSurveyInput>;
  appSurveyMember?: InputMaybe<Club_WorldFamilyClub_AppSurveyMemberInput>;
  appSurveyQa?: InputMaybe<Club_WorldFamilyClub_AppSurveyQaInput>;
  appSurveyReminder?: InputMaybe<Club_WorldFamilyClub_AppSurveyReminderInput>;
  azureFunction?: InputMaybe<Club_WorldFamilyClub_AzureFunctionInput>;
  bankCode?: InputMaybe<Club_WorldFamilyClub_BankCodeInput>;
  broadcastPromotion?: InputMaybe<Club_WorldFamilyClub_BroadcastPromotionInput>;
  capGuidePdf?: InputMaybe<Club_WorldFamilyClub_CapGuidePdfInput>;
  childGraduationApplication?: InputMaybe<Club_WorldFamilyClub_ChildGraduationApplicationInput>;
  creditcardBankCode?: InputMaybe<Club_WorldFamilyClub_CreditcardBankCodeInput>;
  dweProductPackage?: InputMaybe<Club_WorldFamilyClub_DweProductPackageInput>;
  dweProductSong?: InputMaybe<Club_WorldFamilyClub_DweProductSongInput>;
  dweProductSongTool?: InputMaybe<Club_WorldFamilyClub_DweProductSongToolInput>;
  dweProductTool?: InputMaybe<Club_WorldFamilyClub_DweProductToolInput>;
  easypayOrderLog?: InputMaybe<Club_WorldFamilyClub_EasypayOrderLogInput>;
  entryPackageOrder?: InputMaybe<Club_WorldFamilyClub_EntryPackageOrderInput>;
  entryPackageOrdersMemberPaymentInfo?: InputMaybe<Club_WorldFamilyClub_EntryPackageOrdersMemberPaymentInfoInput>;
  eventBanner?: InputMaybe<Club_WorldFamilyClub_EventBannerInput>;
  eventBannerRegion?: InputMaybe<Club_WorldFamilyClub_EventBannerRegionInput>;
  eventCheckInAuth?: InputMaybe<Club_WorldFamilyClub_EventCheckInAuthInput>;
  eventNotificationLog?: InputMaybe<Club_WorldFamilyClub_EventNotificationLogInput>;
  eventPromotion?: InputMaybe<Club_WorldFamilyClub_EventPromotionInput>;
  eventSeat?: InputMaybe<Club_WorldFamilyClub_EventSeatInput>;
  eventType?: InputMaybe<Club_WorldFamilyClub_EventTypeInput>;
  exchangeApplication?: InputMaybe<Club_WorldFamilyClub_ExchangeApplicationInput>;
  exchangeApplicationItem?: InputMaybe<Club_WorldFamilyClub_ExchangeApplicationItemInput>;
  exchangeReason?: InputMaybe<Club_WorldFamilyClub_ExchangeReasonInput>;
  exchangeReasonTranslation?: InputMaybe<Club_WorldFamilyClub_ExchangeReasonTranslationInput>;
  faceCallAndTelephoneEnglish?: InputMaybe<Club_WorldFamilyClub_FaceCallAndTelephoneEnglishInput>;
  faceCallForTrialmode?: InputMaybe<Club_WorldFamilyClub_FaceCallForTrialmodeInput>;
  faceCallHist?: InputMaybe<Club_WorldFamilyClub_FaceCallHistInput>;
  faceCallHistCount?: InputMaybe<Club_WorldFamilyClub_FaceCallHistCountInput>;
  faceCallMonthlyRecommend?: InputMaybe<Club_WorldFamilyClub_FaceCallMonthlyRecommendInput>;
  faceCallPerformer?: InputMaybe<Club_WorldFamilyClub_FaceCallPerformerInput>;
  faceCallSeasonHoliday?: InputMaybe<Club_WorldFamilyClub_FaceCallSeasonHolidayInput>;
  faceCallSong?: InputMaybe<Club_WorldFamilyClub_FaceCallSongInput>;
  faceCallSongAndPerformer?: InputMaybe<Club_WorldFamilyClub_FaceCallSongAndPerformerInput>;
  faceCallSongPublic?: InputMaybe<Club_WorldFamilyClub_FaceCallSongPublicInput>;
  goGoLiveDesktopQrcode?: InputMaybe<Club_WorldFamilyClub_GoGoLiveDesktopQrcodeInput>;
  goGoLiveLevel?: InputMaybe<Club_WorldFamilyClub_GoGoLiveLevelInput>;
  goGoLiveOpenDate?: InputMaybe<Club_WorldFamilyClub_GoGoLiveOpenDateInput>;
  goGoLiveParentGuide?: InputMaybe<Club_WorldFamilyClub_GoGoLiveParentGuideInput>;
  goGoLiveParentGuideLocale?: InputMaybe<Club_WorldFamilyClub_GoGoLiveParentGuideLocaleInput>;
  goGoLiveParentGuideSession?: InputMaybe<Club_WorldFamilyClub_GoGoLiveParentGuideSessionInput>;
  goGoLiveParentGuideSong?: InputMaybe<Club_WorldFamilyClub_GoGoLiveParentGuideSongInput>;
  goGoLiveParentGuideTac?: InputMaybe<Club_WorldFamilyClub_GoGoLiveParentGuideTacInput>;
  goGoLiveParentGuideToy?: InputMaybe<Club_WorldFamilyClub_GoGoLiveParentGuideToyInput>;
  goGoLivePromotion?: InputMaybe<Club_WorldFamilyClub_GoGoLivePromotionInput>;
  goGoLiveSession?: InputMaybe<Club_WorldFamilyClub_GoGoLiveSessionInput>;
  goGoLiveSong?: InputMaybe<Club_WorldFamilyClub_GoGoLiveSongInput>;
  goGoLiveToy?: InputMaybe<Club_WorldFamilyClub_GoGoLiveToyInput>;
  graduationApplication?: InputMaybe<Club_WorldFamilyClub_GraduationApplicationInput>;
  graduationApplicationEvaluation?: InputMaybe<Club_WorldFamilyClub_GraduationApplicationEvaluationInput>;
  graduationApplicationSubTask?: InputMaybe<Club_WorldFamilyClub_GraduationApplicationSubTaskInput>;
  graduationApplicationTask?: InputMaybe<Club_WorldFamilyClub_GraduationApplicationTaskInput>;
  graduationChild?: InputMaybe<Club_WorldFamilyClub_GraduationChildInput>;
  graduationChildSetting?: InputMaybe<Club_WorldFamilyClub_GraduationChildSettingInput>;
  graduationEvaluation?: InputMaybe<Club_WorldFamilyClub_GraduationEvaluationInput>;
  graduationNotification?: InputMaybe<Club_WorldFamilyClub_GraduationNotificationInput>;
  graduationSubApplication?: InputMaybe<Club_WorldFamilyClub_GraduationSubApplicationInput>;
  graduationSubTaskMarketDescription?: InputMaybe<Club_WorldFamilyClub_GraduationSubTaskMarketDescriptionInput>;
  graduationTaskMarketDescription?: InputMaybe<Club_WorldFamilyClub_GraduationTaskMarketDescriptionInput>;
  graphqlAccess?: InputMaybe<Club_WorldFamilyClub_GraphqlAccessInput>;
  graphqlSchema?: InputMaybe<Club_WorldFamilyClub_GraphqlSchemaInput>;
  holidayAudio?: InputMaybe<Club_WorldFamilyClub_HolidayAudioInput>;
  holidaySetting?: InputMaybe<Club_WorldFamilyClub_HolidaySettingInput>;
  holidayVideo?: InputMaybe<Club_WorldFamilyClub_HolidayVideoInput>;
  holidayVideoBonusEntitlementTest?: InputMaybe<Club_WorldFamilyClub_HolidayVideoBonusEntitlementTestInput>;
  holidayVideoMarket?: InputMaybe<Club_WorldFamilyClub_HolidayVideoMarketInput>;
  holidayVideoMarketSetting?: InputMaybe<Club_WorldFamilyClub_HolidayVideoMarketSettingInput>;
  holidayVideoMember?: InputMaybe<Club_WorldFamilyClub_HolidayVideoMemberInput>;
  kidsWorldVideo?: InputMaybe<Club_WorldFamilyClub_KidsWorldVideoInput>;
  memberMessageSetting?: InputMaybe<Club_WorldFamilyClub_MemberMessageSettingInput>;
  memberMonthlyActiveSummary?: InputMaybe<Club_WorldFamilyClub_MemberMonthlyActiveSummaryInput>;
  memberUpgradePayment?: InputMaybe<Club_WorldFamilyClub_MemberUpgradePaymentInput>;
  myFavoriteFaceCall?: InputMaybe<Club_WorldFamilyClub_MyFavoriteFaceCallInput>;
  myFavoriteFaceCallSong?: InputMaybe<Club_WorldFamilyClub_MyFavoriteFaceCallSongInput>;
  notification?: InputMaybe<Club_WorldFamilyClub_NotificationInput>;
  notificationIcon?: InputMaybe<Club_WorldFamilyClub_NotificationIconInput>;
  oneTimeToken?: InputMaybe<Club_WorldFamilyClub_OneTimeTokenInput>;
  onlineEventLog?: InputMaybe<Club_WorldFamilyClub_OnlineEventLogInput>;
  onlineShow?: InputMaybe<Club_WorldFamilyClub_OnlineShowInput>;
  parameter?: InputMaybe<Club_WorldFamilyClub_ParameterInput>;
  product?: InputMaybe<Club_WorldFamilyClub_ProductInput>;
  productCategory?: InputMaybe<Club_WorldFamilyClub_ProductCategoryInput>;
  productCategoryTranslation?: InputMaybe<Club_WorldFamilyClub_ProductCategoryTranslationInput>;
  productSubCategory?: InputMaybe<Club_WorldFamilyClub_ProductSubCategoryInput>;
  productSubCategoryExchangeReason?: InputMaybe<Club_WorldFamilyClub_ProductSubCategoryExchangeReasonInput>;
  productSubCategoryTranslation?: InputMaybe<Club_WorldFamilyClub_ProductSubCategoryTranslationInput>;
  productTranslation?: InputMaybe<Club_WorldFamilyClub_ProductTranslationInput>;
  products1?: InputMaybe<Club_WorldFamilyClub_Products1Input>;
  regionBanner?: InputMaybe<Club_WorldFamilyClub_RegionBannerInput>;
  searchKeyword?: InputMaybe<Club_WorldFamilyClub_SearchKeywordInput>;
  service?: InputMaybe<Club_WorldFamilyClub_ServiceInput>;
  serviceBannerDefault?: InputMaybe<Club_WorldFamilyClub_ServiceBannerDefaultInput>;
  serviceBannerScheduled?: InputMaybe<Club_WorldFamilyClub_ServiceBannerScheduledInput>;
  serviceOneTimeToken?: InputMaybe<Club_WorldFamilyClub_ServiceOneTimeTokenInput>;
  serviceSearch?: InputMaybe<Club_WorldFamilyClub_ServiceSearchInput>;
  smsCertification?: InputMaybe<Club_WorldFamilyClub_SmsCertificationInput>;
  smsCertificationLog?: InputMaybe<Club_WorldFamilyClub_SmsCertificationLogInput>;
  smsVerificationCode?: InputMaybe<Club_WorldFamilyClub_SmsVerificationCodeInput>;
  surveyTypeForm?: InputMaybe<Club_WorldFamilyClub_SurveyTypeFormInput>;
  surveyTypeFormList?: InputMaybe<Club_WorldFamilyClub_SurveyTypeFormListInput>;
  talkAlongCard?: InputMaybe<Club_WorldFamilyClub_TalkAlongCardInput>;
  teSong?: InputMaybe<Club_WorldFamilyClub_TeSongInput>;
  teSongToy?: InputMaybe<Club_WorldFamilyClub_TeSongToyInput>;
  temp20240408Graduation?: InputMaybe<Club_WorldFamilyClub_Temp20240408GraduationInput>;
  temp20240408Graduation1?: InputMaybe<Club_WorldFamilyClub_Temp20240408Graduation1Input>;
  temp20251028ExchangeReason?: InputMaybe<Club_WorldFamilyClub_Temp20251028ExchangeReasonInput>;
  temp20260310Product?: InputMaybe<Club_WorldFamilyClub_Temp20260310ProductInput>;
  tempChildGraduationApplicationNew?: InputMaybe<Club_WorldFamilyClub_TempChildGraduationApplicationNewInput>;
  tempChildGraduationApplicationOld?: InputMaybe<Club_WorldFamilyClub_TempChildGraduationApplicationOldInput>;
  tempFaceCall?: InputMaybe<Club_WorldFamilyClub_TempFaceCallInput>;
  tempFaceCallHk?: InputMaybe<Club_WorldFamilyClub_TempFaceCallHkInput>;
  tempFaceCallKr?: InputMaybe<Club_WorldFamilyClub_TempFaceCallKrInput>;
  tempGoGoLiveSong?: InputMaybe<Club_WorldFamilyClub_TempGoGoLiveSongInput>;
  tempHkAppMyFavorite?: InputMaybe<Club_WorldFamilyClub_TempHkAppMyFavoriteInput>;
  tempHkClubappsFacecallCrew?: InputMaybe<Club_WorldFamilyClub_TempHkClubappsFacecallCrewInput>;
  tempHkClubappsFacecallHistory?: InputMaybe<Club_WorldFamilyClub_TempHkClubappsFacecallHistoryInput>;
  tempHkClubappsFacecallSong?: InputMaybe<Club_WorldFamilyClub_TempHkClubappsFacecallSongInput>;
  tempHkDmemChild?: InputMaybe<Club_WorldFamilyClub_TempHkDmemChildInput>;
  tempHkTeSong?: InputMaybe<Club_WorldFamilyClub_TempHkTeSongInput>;
  tempHkTematerial?: InputMaybe<Club_WorldFamilyClub_TempHkTematerialInput>;
  tempKrFaceCallHist?: InputMaybe<Club_WorldFamilyClub_TempKrFaceCallHistInput>;
  tempKrFcCrewM?: InputMaybe<Club_WorldFamilyClub_TempKrFcCrewMInput>;
  tempKrFcsongCrew?: InputMaybe<Club_WorldFamilyClub_TempKrFcsongCrewInput>;
  tempKrMyFavorite?: InputMaybe<Club_WorldFamilyClub_TempKrMyFavoriteInput>;
  tempKrTeSong?: InputMaybe<Club_WorldFamilyClub_TempKrTeSongInput>;
  tempKrWfeClubMemberChild?: InputMaybe<Club_WorldFamilyClub_TempKrWfeClubMemberChildInput>;
  tempTalkAlongCard?: InputMaybe<Club_WorldFamilyClub_TempTalkAlongCardInput>;
  tempTwCambridge?: InputMaybe<Club_WorldFamilyClub_TempTwCambridgeInput>;
  tempTwFaceCallHist?: InputMaybe<Club_WorldFamilyClub_TempTwFaceCallHistInput>;
  tempTwFcCrewM?: InputMaybe<Club_WorldFamilyClub_TempTwFcCrewMInput>;
  tempTwFcsongCrew?: InputMaybe<Club_WorldFamilyClub_TempTwFcsongCrewInput>;
  tempTwFcsongMonthlyRecommend?: InputMaybe<Club_WorldFamilyClub_TempTwFcsongMonthlyRecommendInput>;
  tempTwMyFavorite?: InputMaybe<Club_WorldFamilyClub_TempTwMyFavoriteInput>;
  tempTwTeSong?: InputMaybe<Club_WorldFamilyClub_TempTwTeSongInput>;
  tempTwTeSongForCapLevel?: InputMaybe<Club_WorldFamilyClub_TempTwTeSongForCapLevelInput>;
  tempWfcGraC?: InputMaybe<Club_WorldFamilyClub_TempWfcGraCInput>;
  tempWfcGraCOrganized?: InputMaybe<Club_WorldFamilyClub_TempWfcGraCOrganizedInput>;
  testUserAccount?: InputMaybe<Club_WorldFamilyClub_TestUserAccountInput>;
  testWater?: InputMaybe<Club_WorldFamilyClub_TestWaterInput>;
  testWaterSub?: InputMaybe<Club_WorldFamilyClub_TestWaterSubInput>;
  tev2MonthlySong?: InputMaybe<Club_WorldFamilyClub_Tev2MonthlySongInput>;
  user?: InputMaybe<Club_WorldFamilyClub_UserInput>;
  videoForTrialmode?: InputMaybe<Club_WorldFamilyClub_VideoForTrialmodeInput>;
  wfcLibraryFaq?: InputMaybe<Club_WorldFamilyClub_WfcLibraryFaqInput>;
  wfcLibraryLog?: InputMaybe<Club_WorldFamilyClub_WfcLibraryLogInput>;
  wfcNowPageViewLog?: InputMaybe<Club_WorldFamilyClub_WfcNowPageViewLogInput>;
};

export type Club_WorldFamilyClub_Mutation_RemoveRangeInput = {
  appAuths?: InputMaybe<Array<Club_WorldFamilyClub_AppAuthInput>>;
  appBanners?: InputMaybe<Array<Club_WorldFamilyClub_AppBannerInput>>;
  appDigitalMagazines?: InputMaybe<Array<Club_WorldFamilyClub_AppDigitalMagazineInput>>;
  appMemberAuthorizeLogs?: InputMaybe<Array<Club_WorldFamilyClub_AppMemberAuthorizeLogInput>>;
  appMemberAuthorizes?: InputMaybe<Array<Club_WorldFamilyClub_AppMemberAuthorizeInput>>;
  appMemberChildren?: InputMaybe<Array<Club_WorldFamilyClub_AppMemberChildInput>>;
  appMemberDevices?: InputMaybe<Array<Club_WorldFamilyClub_AppMemberDeviceInput>>;
  appMemberFirstLogins?: InputMaybe<Array<Club_WorldFamilyClub_AppMemberFirstLoginInput>>;
  appMemberNotificationPushFirebases?: InputMaybe<Array<Club_WorldFamilyClub_AppMemberNotificationPushFirebaseInput>>;
  appMemberNotifications?: InputMaybe<Array<Club_WorldFamilyClub_AppMemberNotificationInput>>;
  appNotificationMembers?: InputMaybe<Array<Club_WorldFamilyClub_AppNotificationMemberInput>>;
  appNotificationTypeMarkets?: InputMaybe<Array<Club_WorldFamilyClub_AppNotificationTypeMarketInput>>;
  appNotificationTypes?: InputMaybe<Array<Club_WorldFamilyClub_AppNotificationTypeInput>>;
  appNotifications?: InputMaybe<Array<Club_WorldFamilyClub_AppNotificationInput>>;
  appRegionEmergencies?: InputMaybe<Array<Club_WorldFamilyClub_AppRegionEmergencyInput>>;
  appReleases?: InputMaybe<Array<Club_WorldFamilyClub_AppReleaseInput>>;
  appServiceRegionFestivalImages?: InputMaybe<Array<Club_WorldFamilyClub_AppServiceRegionFestivalImageInput>>;
  appServiceRegionImages?: InputMaybe<Array<Club_WorldFamilyClub_AppServiceRegionImageInput>>;
  appSurveyMembers?: InputMaybe<Array<Club_WorldFamilyClub_AppSurveyMemberInput>>;
  appSurveyQas?: InputMaybe<Array<Club_WorldFamilyClub_AppSurveyQaInput>>;
  appSurveyReminders?: InputMaybe<Array<Club_WorldFamilyClub_AppSurveyReminderInput>>;
  appSurveys?: InputMaybe<Array<Club_WorldFamilyClub_AppSurveyInput>>;
  azureFunctions?: InputMaybe<Array<Club_WorldFamilyClub_AzureFunctionInput>>;
  bankCodes?: InputMaybe<Array<Club_WorldFamilyClub_BankCodeInput>>;
  broadcastPromotions?: InputMaybe<Array<Club_WorldFamilyClub_BroadcastPromotionInput>>;
  capGuidePdfs?: InputMaybe<Array<Club_WorldFamilyClub_CapGuidePdfInput>>;
  childGraduationApplications?: InputMaybe<Array<Club_WorldFamilyClub_ChildGraduationApplicationInput>>;
  creditcardBankCodes?: InputMaybe<Array<Club_WorldFamilyClub_CreditcardBankCodeInput>>;
  dweProductPackages?: InputMaybe<Array<Club_WorldFamilyClub_DweProductPackageInput>>;
  dweProductSongTools?: InputMaybe<Array<Club_WorldFamilyClub_DweProductSongToolInput>>;
  dweProductSongs?: InputMaybe<Array<Club_WorldFamilyClub_DweProductSongInput>>;
  dweProductTools?: InputMaybe<Array<Club_WorldFamilyClub_DweProductToolInput>>;
  easypayOrderLogs?: InputMaybe<Array<Club_WorldFamilyClub_EasypayOrderLogInput>>;
  entryPackageOrders?: InputMaybe<Array<Club_WorldFamilyClub_EntryPackageOrderInput>>;
  entryPackageOrdersMemberPaymentInfos?: InputMaybe<Array<Club_WorldFamilyClub_EntryPackageOrdersMemberPaymentInfoInput>>;
  eventBannerRegions?: InputMaybe<Array<Club_WorldFamilyClub_EventBannerRegionInput>>;
  eventBanners?: InputMaybe<Array<Club_WorldFamilyClub_EventBannerInput>>;
  eventCheckInAuths?: InputMaybe<Array<Club_WorldFamilyClub_EventCheckInAuthInput>>;
  eventNotificationLogs?: InputMaybe<Array<Club_WorldFamilyClub_EventNotificationLogInput>>;
  eventPromotions?: InputMaybe<Array<Club_WorldFamilyClub_EventPromotionInput>>;
  eventSeats?: InputMaybe<Array<Club_WorldFamilyClub_EventSeatInput>>;
  eventTypes?: InputMaybe<Array<Club_WorldFamilyClub_EventTypeInput>>;
  exchangeApplicationItems?: InputMaybe<Array<Club_WorldFamilyClub_ExchangeApplicationItemInput>>;
  exchangeApplications?: InputMaybe<Array<Club_WorldFamilyClub_ExchangeApplicationInput>>;
  exchangeReasonTranslations?: InputMaybe<Array<Club_WorldFamilyClub_ExchangeReasonTranslationInput>>;
  exchangeReasons?: InputMaybe<Array<Club_WorldFamilyClub_ExchangeReasonInput>>;
  faceCallAndTelephoneEnglishes?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallAndTelephoneEnglishInput>>;
  faceCallForTrialmodes?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallForTrialmodeInput>>;
  faceCallHistCounts?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallHistCountInput>>;
  faceCallHists?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallHistInput>>;
  faceCallMonthlyRecommends?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallMonthlyRecommendInput>>;
  faceCallPerformers?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallPerformerInput>>;
  faceCallSeasonHolidays?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallSeasonHolidayInput>>;
  faceCallSongAndPerformers?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallSongAndPerformerInput>>;
  faceCallSongPublics?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallSongPublicInput>>;
  faceCallSongs?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallSongInput>>;
  goGoLiveDesktopQrcodes?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveDesktopQrcodeInput>>;
  goGoLiveLevels?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveLevelInput>>;
  goGoLiveOpenDates?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveOpenDateInput>>;
  goGoLiveParentGuideLocales?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuideLocaleInput>>;
  goGoLiveParentGuideSessions?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuideSessionInput>>;
  goGoLiveParentGuideSongs?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuideSongInput>>;
  goGoLiveParentGuideTacs?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuideTacInput>>;
  goGoLiveParentGuideToys?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuideToyInput>>;
  goGoLiveParentGuides?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuideInput>>;
  goGoLivePromotions?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLivePromotionInput>>;
  goGoLiveSessions?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveSessionInput>>;
  goGoLiveSongs?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveSongInput>>;
  goGoLiveToys?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveToyInput>>;
  graduationApplicationEvaluations?: InputMaybe<Array<Club_WorldFamilyClub_GraduationApplicationEvaluationInput>>;
  graduationApplicationSubTasks?: InputMaybe<Array<Club_WorldFamilyClub_GraduationApplicationSubTaskInput>>;
  graduationApplicationTasks?: InputMaybe<Array<Club_WorldFamilyClub_GraduationApplicationTaskInput>>;
  graduationApplications?: InputMaybe<Array<Club_WorldFamilyClub_GraduationApplicationInput>>;
  graduationChildSettings?: InputMaybe<Array<Club_WorldFamilyClub_GraduationChildSettingInput>>;
  graduationChildren?: InputMaybe<Array<Club_WorldFamilyClub_GraduationChildInput>>;
  graduationEvaluations?: InputMaybe<Array<Club_WorldFamilyClub_GraduationEvaluationInput>>;
  graduationNotifications?: InputMaybe<Array<Club_WorldFamilyClub_GraduationNotificationInput>>;
  graduationSubApplications?: InputMaybe<Array<Club_WorldFamilyClub_GraduationSubApplicationInput>>;
  graduationSubTaskMarketDescriptions?: InputMaybe<Array<Club_WorldFamilyClub_GraduationSubTaskMarketDescriptionInput>>;
  graduationTaskMarketDescriptions?: InputMaybe<Array<Club_WorldFamilyClub_GraduationTaskMarketDescriptionInput>>;
  graphqlAccesses?: InputMaybe<Array<Club_WorldFamilyClub_GraphqlAccessInput>>;
  graphqlSchemas?: InputMaybe<Array<Club_WorldFamilyClub_GraphqlSchemaInput>>;
  holidayAudios?: InputMaybe<Array<Club_WorldFamilyClub_HolidayAudioInput>>;
  holidaySettings?: InputMaybe<Array<Club_WorldFamilyClub_HolidaySettingInput>>;
  holidayVideoBonusEntitlementTests?: InputMaybe<Array<Club_WorldFamilyClub_HolidayVideoBonusEntitlementTestInput>>;
  holidayVideoMarketSettings?: InputMaybe<Array<Club_WorldFamilyClub_HolidayVideoMarketSettingInput>>;
  holidayVideoMarkets?: InputMaybe<Array<Club_WorldFamilyClub_HolidayVideoMarketInput>>;
  holidayVideoMembers?: InputMaybe<Array<Club_WorldFamilyClub_HolidayVideoMemberInput>>;
  holidayVideos?: InputMaybe<Array<Club_WorldFamilyClub_HolidayVideoInput>>;
  kidsWorldVideos?: InputMaybe<Array<Club_WorldFamilyClub_KidsWorldVideoInput>>;
  memberMessageSettings?: InputMaybe<Array<Club_WorldFamilyClub_MemberMessageSettingInput>>;
  memberMonthlyActiveSummaries?: InputMaybe<Array<Club_WorldFamilyClub_MemberMonthlyActiveSummaryInput>>;
  memberUpgradePayments?: InputMaybe<Array<Club_WorldFamilyClub_MemberUpgradePaymentInput>>;
  myFavoriteFaceCallSongs?: InputMaybe<Array<Club_WorldFamilyClub_MyFavoriteFaceCallSongInput>>;
  myFavoriteFaceCalls?: InputMaybe<Array<Club_WorldFamilyClub_MyFavoriteFaceCallInput>>;
  notificationIcons?: InputMaybe<Array<Club_WorldFamilyClub_NotificationIconInput>>;
  notifications?: InputMaybe<Array<Club_WorldFamilyClub_NotificationInput>>;
  oneTimeTokens?: InputMaybe<Array<Club_WorldFamilyClub_OneTimeTokenInput>>;
  onlineEventLogs?: InputMaybe<Array<Club_WorldFamilyClub_OnlineEventLogInput>>;
  onlineShows?: InputMaybe<Array<Club_WorldFamilyClub_OnlineShowInput>>;
  parameters?: InputMaybe<Array<Club_WorldFamilyClub_ParameterInput>>;
  productCategories?: InputMaybe<Array<Club_WorldFamilyClub_ProductCategoryInput>>;
  productCategoryTranslations?: InputMaybe<Array<Club_WorldFamilyClub_ProductCategoryTranslationInput>>;
  productSubCategories?: InputMaybe<Array<Club_WorldFamilyClub_ProductSubCategoryInput>>;
  productSubCategoryExchangeReasons?: InputMaybe<Array<Club_WorldFamilyClub_ProductSubCategoryExchangeReasonInput>>;
  productSubCategoryTranslations?: InputMaybe<Array<Club_WorldFamilyClub_ProductSubCategoryTranslationInput>>;
  productTranslations?: InputMaybe<Array<Club_WorldFamilyClub_ProductTranslationInput>>;
  products?: InputMaybe<Array<Club_WorldFamilyClub_ProductInput>>;
  products1s?: InputMaybe<Array<Club_WorldFamilyClub_Products1Input>>;
  regionBanners?: InputMaybe<Array<Club_WorldFamilyClub_RegionBannerInput>>;
  searchKeywords?: InputMaybe<Array<Club_WorldFamilyClub_SearchKeywordInput>>;
  serviceBannerDefaults?: InputMaybe<Array<Club_WorldFamilyClub_ServiceBannerDefaultInput>>;
  serviceBannerScheduleds?: InputMaybe<Array<Club_WorldFamilyClub_ServiceBannerScheduledInput>>;
  serviceOneTimeTokens?: InputMaybe<Array<Club_WorldFamilyClub_ServiceOneTimeTokenInput>>;
  serviceSearches?: InputMaybe<Array<Club_WorldFamilyClub_ServiceSearchInput>>;
  services?: InputMaybe<Array<Club_WorldFamilyClub_ServiceInput>>;
  smsCertificationLogs?: InputMaybe<Array<Club_WorldFamilyClub_SmsCertificationLogInput>>;
  smsCertifications?: InputMaybe<Array<Club_WorldFamilyClub_SmsCertificationInput>>;
  smsVerificationCodes?: InputMaybe<Array<Club_WorldFamilyClub_SmsVerificationCodeInput>>;
  surveyTypeFormLists?: InputMaybe<Array<Club_WorldFamilyClub_SurveyTypeFormListInput>>;
  surveyTypeForms?: InputMaybe<Array<Club_WorldFamilyClub_SurveyTypeFormInput>>;
  talkAlongCards?: InputMaybe<Array<Club_WorldFamilyClub_TalkAlongCardInput>>;
  teSongToys?: InputMaybe<Array<Club_WorldFamilyClub_TeSongToyInput>>;
  teSongs?: InputMaybe<Array<Club_WorldFamilyClub_TeSongInput>>;
  temp20240408Graduation1s?: InputMaybe<Array<Club_WorldFamilyClub_Temp20240408Graduation1Input>>;
  temp20240408Graduations?: InputMaybe<Array<Club_WorldFamilyClub_Temp20240408GraduationInput>>;
  temp20251028ExchangeReasons?: InputMaybe<Array<Club_WorldFamilyClub_Temp20251028ExchangeReasonInput>>;
  temp20260310Products?: InputMaybe<Array<Club_WorldFamilyClub_Temp20260310ProductInput>>;
  tempChildGraduationApplicationNews?: InputMaybe<Array<Club_WorldFamilyClub_TempChildGraduationApplicationNewInput>>;
  tempChildGraduationApplicationOlds?: InputMaybe<Array<Club_WorldFamilyClub_TempChildGraduationApplicationOldInput>>;
  tempFaceCallHks?: InputMaybe<Array<Club_WorldFamilyClub_TempFaceCallHkInput>>;
  tempFaceCallKrs?: InputMaybe<Array<Club_WorldFamilyClub_TempFaceCallKrInput>>;
  tempFaceCalls?: InputMaybe<Array<Club_WorldFamilyClub_TempFaceCallInput>>;
  tempGoGoLiveSongs?: InputMaybe<Array<Club_WorldFamilyClub_TempGoGoLiveSongInput>>;
  tempHkAppMyFavorites?: InputMaybe<Array<Club_WorldFamilyClub_TempHkAppMyFavoriteInput>>;
  tempHkClubappsFacecallCrews?: InputMaybe<Array<Club_WorldFamilyClub_TempHkClubappsFacecallCrewInput>>;
  tempHkClubappsFacecallHistories?: InputMaybe<Array<Club_WorldFamilyClub_TempHkClubappsFacecallHistoryInput>>;
  tempHkClubappsFacecallSongs?: InputMaybe<Array<Club_WorldFamilyClub_TempHkClubappsFacecallSongInput>>;
  tempHkDmemChildren?: InputMaybe<Array<Club_WorldFamilyClub_TempHkDmemChildInput>>;
  tempHkTeSongs?: InputMaybe<Array<Club_WorldFamilyClub_TempHkTeSongInput>>;
  tempHkTematerials?: InputMaybe<Array<Club_WorldFamilyClub_TempHkTematerialInput>>;
  tempKrFaceCallHists?: InputMaybe<Array<Club_WorldFamilyClub_TempKrFaceCallHistInput>>;
  tempKrFcCrewMs?: InputMaybe<Array<Club_WorldFamilyClub_TempKrFcCrewMInput>>;
  tempKrFcsongCrews?: InputMaybe<Array<Club_WorldFamilyClub_TempKrFcsongCrewInput>>;
  tempKrMyFavorites?: InputMaybe<Array<Club_WorldFamilyClub_TempKrMyFavoriteInput>>;
  tempKrTeSongs?: InputMaybe<Array<Club_WorldFamilyClub_TempKrTeSongInput>>;
  tempKrWfeClubMemberChildren?: InputMaybe<Array<Club_WorldFamilyClub_TempKrWfeClubMemberChildInput>>;
  tempTalkAlongCards?: InputMaybe<Array<Club_WorldFamilyClub_TempTalkAlongCardInput>>;
  tempTwCambridges?: InputMaybe<Array<Club_WorldFamilyClub_TempTwCambridgeInput>>;
  tempTwFaceCallHists?: InputMaybe<Array<Club_WorldFamilyClub_TempTwFaceCallHistInput>>;
  tempTwFcCrewMs?: InputMaybe<Array<Club_WorldFamilyClub_TempTwFcCrewMInput>>;
  tempTwFcsongCrews?: InputMaybe<Array<Club_WorldFamilyClub_TempTwFcsongCrewInput>>;
  tempTwFcsongMonthlyRecommends?: InputMaybe<Array<Club_WorldFamilyClub_TempTwFcsongMonthlyRecommendInput>>;
  tempTwMyFavorites?: InputMaybe<Array<Club_WorldFamilyClub_TempTwMyFavoriteInput>>;
  tempTwTeSongForCapLevels?: InputMaybe<Array<Club_WorldFamilyClub_TempTwTeSongForCapLevelInput>>;
  tempTwTeSongs?: InputMaybe<Array<Club_WorldFamilyClub_TempTwTeSongInput>>;
  tempWfcGraCOrganizeds?: InputMaybe<Array<Club_WorldFamilyClub_TempWfcGraCOrganizedInput>>;
  tempWfcGraCs?: InputMaybe<Array<Club_WorldFamilyClub_TempWfcGraCInput>>;
  testUserAccounts?: InputMaybe<Array<Club_WorldFamilyClub_TestUserAccountInput>>;
  testWaterSubs?: InputMaybe<Array<Club_WorldFamilyClub_TestWaterSubInput>>;
  testWaters?: InputMaybe<Array<Club_WorldFamilyClub_TestWaterInput>>;
  tev2MonthlySongs?: InputMaybe<Array<Club_WorldFamilyClub_Tev2MonthlySongInput>>;
  users?: InputMaybe<Array<Club_WorldFamilyClub_UserInput>>;
  videoForTrialmodes?: InputMaybe<Array<Club_WorldFamilyClub_VideoForTrialmodeInput>>;
  wfcLibraryFaqs?: InputMaybe<Array<Club_WorldFamilyClub_WfcLibraryFaqInput>>;
  wfcLibraryLogs?: InputMaybe<Array<Club_WorldFamilyClub_WfcLibraryLogInput>>;
  wfcNowPageViewLogs?: InputMaybe<Array<Club_WorldFamilyClub_WfcNowPageViewLogInput>>;
};

export type Club_WorldFamilyClub_Mutation_Update = {
  __typename?: 'Club_WorldFamilyClub_Mutation_Update';
  appAuth?: Maybe<Club_WorldFamilyClub_AppAuth>;
  appBanner?: Maybe<Club_WorldFamilyClub_AppBanner>;
  appDigitalMagazine?: Maybe<Club_WorldFamilyClub_AppDigitalMagazine>;
  appMemberAuthorize?: Maybe<Club_WorldFamilyClub_AppMemberAuthorize>;
  appMemberAuthorizeLog?: Maybe<Club_WorldFamilyClub_AppMemberAuthorizeLog>;
  appMemberChild?: Maybe<Club_WorldFamilyClub_AppMemberChild>;
  appMemberDevice?: Maybe<Club_WorldFamilyClub_AppMemberDevice>;
  appMemberFirstLogin?: Maybe<Club_WorldFamilyClub_AppMemberFirstLogin>;
  appMemberNotification?: Maybe<Club_WorldFamilyClub_AppMemberNotification>;
  appMemberNotificationPushFirebase?: Maybe<Club_WorldFamilyClub_AppMemberNotificationPushFirebase>;
  appNotification?: Maybe<Club_WorldFamilyClub_AppNotification>;
  appNotificationMember?: Maybe<Club_WorldFamilyClub_AppNotificationMember>;
  appNotificationType?: Maybe<Club_WorldFamilyClub_AppNotificationType>;
  appNotificationTypeMarket?: Maybe<Club_WorldFamilyClub_AppNotificationTypeMarket>;
  appRegionEmergency?: Maybe<Club_WorldFamilyClub_AppRegionEmergency>;
  appRelease?: Maybe<Club_WorldFamilyClub_AppRelease>;
  appServiceRegionFestivalImage?: Maybe<Club_WorldFamilyClub_AppServiceRegionFestivalImage>;
  appServiceRegionImage?: Maybe<Club_WorldFamilyClub_AppServiceRegionImage>;
  appSurvey?: Maybe<Club_WorldFamilyClub_AppSurvey>;
  appSurveyMember?: Maybe<Club_WorldFamilyClub_AppSurveyMember>;
  appSurveyQa?: Maybe<Club_WorldFamilyClub_AppSurveyQa>;
  appSurveyReminder?: Maybe<Club_WorldFamilyClub_AppSurveyReminder>;
  azureFunction?: Maybe<Club_WorldFamilyClub_AzureFunction>;
  bankCode?: Maybe<Club_WorldFamilyClub_BankCode>;
  broadcastPromotion?: Maybe<Club_WorldFamilyClub_BroadcastPromotion>;
  capGuidePdf?: Maybe<Club_WorldFamilyClub_CapGuidePdf>;
  childGraduationApplication?: Maybe<Club_WorldFamilyClub_ChildGraduationApplication>;
  creditcardBankCode?: Maybe<Club_WorldFamilyClub_CreditcardBankCode>;
  dweProductPackage?: Maybe<Club_WorldFamilyClub_DweProductPackage>;
  dweProductSong?: Maybe<Club_WorldFamilyClub_DweProductSong>;
  dweProductSongTool?: Maybe<Club_WorldFamilyClub_DweProductSongTool>;
  dweProductTool?: Maybe<Club_WorldFamilyClub_DweProductTool>;
  easypayOrderLog?: Maybe<Club_WorldFamilyClub_EasypayOrderLog>;
  entryPackageOrder?: Maybe<Club_WorldFamilyClub_EntryPackageOrder>;
  entryPackageOrdersMemberPaymentInfo?: Maybe<Club_WorldFamilyClub_EntryPackageOrdersMemberPaymentInfo>;
  eventBanner?: Maybe<Club_WorldFamilyClub_EventBanner>;
  eventBannerRegion?: Maybe<Club_WorldFamilyClub_EventBannerRegion>;
  eventCheckInAuth?: Maybe<Club_WorldFamilyClub_EventCheckInAuth>;
  eventNotificationLog?: Maybe<Club_WorldFamilyClub_EventNotificationLog>;
  eventPromotion?: Maybe<Club_WorldFamilyClub_EventPromotion>;
  eventSeat?: Maybe<Club_WorldFamilyClub_EventSeat>;
  eventType?: Maybe<Club_WorldFamilyClub_EventType>;
  exchangeApplication?: Maybe<Club_WorldFamilyClub_ExchangeApplication>;
  exchangeApplicationItem?: Maybe<Club_WorldFamilyClub_ExchangeApplicationItem>;
  exchangeReason?: Maybe<Club_WorldFamilyClub_ExchangeReason>;
  exchangeReasonTranslation?: Maybe<Club_WorldFamilyClub_ExchangeReasonTranslation>;
  faceCallAndTelephoneEnglish?: Maybe<Club_WorldFamilyClub_FaceCallAndTelephoneEnglish>;
  faceCallForTrialmode?: Maybe<Club_WorldFamilyClub_FaceCallForTrialmode>;
  faceCallHist?: Maybe<Club_WorldFamilyClub_FaceCallHist>;
  faceCallHistCount?: Maybe<Club_WorldFamilyClub_FaceCallHistCount>;
  faceCallMonthlyRecommend?: Maybe<Club_WorldFamilyClub_FaceCallMonthlyRecommend>;
  faceCallPerformer?: Maybe<Club_WorldFamilyClub_FaceCallPerformer>;
  faceCallSeasonHoliday?: Maybe<Club_WorldFamilyClub_FaceCallSeasonHoliday>;
  faceCallSong?: Maybe<Club_WorldFamilyClub_FaceCallSong>;
  faceCallSongAndPerformer?: Maybe<Club_WorldFamilyClub_FaceCallSongAndPerformer>;
  faceCallSongPublic?: Maybe<Club_WorldFamilyClub_FaceCallSongPublic>;
  goGoLiveDesktopQrcode?: Maybe<Club_WorldFamilyClub_GoGoLiveDesktopQrcode>;
  goGoLiveLevel?: Maybe<Club_WorldFamilyClub_GoGoLiveLevel>;
  goGoLiveOpenDate?: Maybe<Club_WorldFamilyClub_GoGoLiveOpenDate>;
  goGoLiveParentGuide?: Maybe<Club_WorldFamilyClub_GoGoLiveParentGuide>;
  goGoLiveParentGuideLocale?: Maybe<Club_WorldFamilyClub_GoGoLiveParentGuideLocale>;
  goGoLiveParentGuideSession?: Maybe<Club_WorldFamilyClub_GoGoLiveParentGuideSession>;
  goGoLiveParentGuideSong?: Maybe<Club_WorldFamilyClub_GoGoLiveParentGuideSong>;
  goGoLiveParentGuideTac?: Maybe<Club_WorldFamilyClub_GoGoLiveParentGuideTac>;
  goGoLiveParentGuideToy?: Maybe<Club_WorldFamilyClub_GoGoLiveParentGuideToy>;
  goGoLivePromotion?: Maybe<Club_WorldFamilyClub_GoGoLivePromotion>;
  goGoLiveSession?: Maybe<Club_WorldFamilyClub_GoGoLiveSession>;
  goGoLiveSong?: Maybe<Club_WorldFamilyClub_GoGoLiveSong>;
  goGoLiveToy?: Maybe<Club_WorldFamilyClub_GoGoLiveToy>;
  graduationApplication?: Maybe<Club_WorldFamilyClub_GraduationApplication>;
  graduationApplicationEvaluation?: Maybe<Club_WorldFamilyClub_GraduationApplicationEvaluation>;
  graduationApplicationSubTask?: Maybe<Club_WorldFamilyClub_GraduationApplicationSubTask>;
  graduationApplicationTask?: Maybe<Club_WorldFamilyClub_GraduationApplicationTask>;
  graduationChild?: Maybe<Club_WorldFamilyClub_GraduationChild>;
  graduationChildSetting?: Maybe<Club_WorldFamilyClub_GraduationChildSetting>;
  graduationEvaluation?: Maybe<Club_WorldFamilyClub_GraduationEvaluation>;
  graduationNotification?: Maybe<Club_WorldFamilyClub_GraduationNotification>;
  graduationSubApplication?: Maybe<Club_WorldFamilyClub_GraduationSubApplication>;
  graduationSubTaskMarketDescription?: Maybe<Club_WorldFamilyClub_GraduationSubTaskMarketDescription>;
  graduationTaskMarketDescription?: Maybe<Club_WorldFamilyClub_GraduationTaskMarketDescription>;
  graphqlAccess?: Maybe<Club_WorldFamilyClub_GraphqlAccess>;
  graphqlSchema?: Maybe<Club_WorldFamilyClub_GraphqlSchema>;
  holidayAudio?: Maybe<Club_WorldFamilyClub_HolidayAudio>;
  holidaySetting?: Maybe<Club_WorldFamilyClub_HolidaySetting>;
  holidayVideo?: Maybe<Club_WorldFamilyClub_HolidayVideo>;
  holidayVideoBonusEntitlementTest?: Maybe<Club_WorldFamilyClub_HolidayVideoBonusEntitlementTest>;
  holidayVideoMarket?: Maybe<Club_WorldFamilyClub_HolidayVideoMarket>;
  holidayVideoMarketSetting?: Maybe<Club_WorldFamilyClub_HolidayVideoMarketSetting>;
  holidayVideoMember?: Maybe<Club_WorldFamilyClub_HolidayVideoMember>;
  kidsWorldVideo?: Maybe<Club_WorldFamilyClub_KidsWorldVideo>;
  memberMessageSetting?: Maybe<Club_WorldFamilyClub_MemberMessageSetting>;
  memberMonthlyActiveSummary?: Maybe<Club_WorldFamilyClub_MemberMonthlyActiveSummary>;
  memberUpgradePayment?: Maybe<Club_WorldFamilyClub_MemberUpgradePayment>;
  myFavoriteFaceCall?: Maybe<Club_WorldFamilyClub_MyFavoriteFaceCall>;
  myFavoriteFaceCallSong?: Maybe<Club_WorldFamilyClub_MyFavoriteFaceCallSong>;
  notification?: Maybe<Club_WorldFamilyClub_Notification>;
  notificationIcon?: Maybe<Club_WorldFamilyClub_NotificationIcon>;
  oneTimeToken?: Maybe<Club_WorldFamilyClub_OneTimeToken>;
  onlineEventLog?: Maybe<Club_WorldFamilyClub_OnlineEventLog>;
  onlineShow?: Maybe<Club_WorldFamilyClub_OnlineShow>;
  parameter?: Maybe<Club_WorldFamilyClub_Parameter>;
  product?: Maybe<Club_WorldFamilyClub_Product>;
  productCategory?: Maybe<Club_WorldFamilyClub_ProductCategory>;
  productCategoryTranslation?: Maybe<Club_WorldFamilyClub_ProductCategoryTranslation>;
  productSubCategory?: Maybe<Club_WorldFamilyClub_ProductSubCategory>;
  productSubCategoryExchangeReason?: Maybe<Club_WorldFamilyClub_ProductSubCategoryExchangeReason>;
  productSubCategoryTranslation?: Maybe<Club_WorldFamilyClub_ProductSubCategoryTranslation>;
  productTranslation?: Maybe<Club_WorldFamilyClub_ProductTranslation>;
  products1?: Maybe<Club_WorldFamilyClub_Products1>;
  regionBanner?: Maybe<Club_WorldFamilyClub_RegionBanner>;
  searchKeyword?: Maybe<Club_WorldFamilyClub_SearchKeyword>;
  service?: Maybe<Club_WorldFamilyClub_Service>;
  serviceBannerDefault?: Maybe<Club_WorldFamilyClub_ServiceBannerDefault>;
  serviceBannerScheduled?: Maybe<Club_WorldFamilyClub_ServiceBannerScheduled>;
  serviceOneTimeToken?: Maybe<Club_WorldFamilyClub_ServiceOneTimeToken>;
  serviceSearch?: Maybe<Club_WorldFamilyClub_ServiceSearch>;
  smsCertification?: Maybe<Club_WorldFamilyClub_SmsCertification>;
  smsCertificationLog?: Maybe<Club_WorldFamilyClub_SmsCertificationLog>;
  smsVerificationCode?: Maybe<Club_WorldFamilyClub_SmsVerificationCode>;
  surveyTypeForm?: Maybe<Club_WorldFamilyClub_SurveyTypeForm>;
  surveyTypeFormList?: Maybe<Club_WorldFamilyClub_SurveyTypeFormList>;
  talkAlongCard?: Maybe<Club_WorldFamilyClub_TalkAlongCard>;
  teSong?: Maybe<Club_WorldFamilyClub_TeSong>;
  teSongToy?: Maybe<Club_WorldFamilyClub_TeSongToy>;
  temp20240408Graduation?: Maybe<Club_WorldFamilyClub_Temp20240408Graduation>;
  temp20240408Graduation1?: Maybe<Club_WorldFamilyClub_Temp20240408Graduation1>;
  temp20251028ExchangeReason?: Maybe<Club_WorldFamilyClub_Temp20251028ExchangeReason>;
  temp20260310Product?: Maybe<Club_WorldFamilyClub_Temp20260310Product>;
  tempChildGraduationApplicationNew?: Maybe<Club_WorldFamilyClub_TempChildGraduationApplicationNew>;
  tempChildGraduationApplicationOld?: Maybe<Club_WorldFamilyClub_TempChildGraduationApplicationOld>;
  tempFaceCall?: Maybe<Club_WorldFamilyClub_TempFaceCall>;
  tempFaceCallHk?: Maybe<Club_WorldFamilyClub_TempFaceCallHk>;
  tempFaceCallKr?: Maybe<Club_WorldFamilyClub_TempFaceCallKr>;
  tempGoGoLiveSong?: Maybe<Club_WorldFamilyClub_TempGoGoLiveSong>;
  tempHkAppMyFavorite?: Maybe<Club_WorldFamilyClub_TempHkAppMyFavorite>;
  tempHkClubappsFacecallCrew?: Maybe<Club_WorldFamilyClub_TempHkClubappsFacecallCrew>;
  tempHkClubappsFacecallHistory?: Maybe<Club_WorldFamilyClub_TempHkClubappsFacecallHistory>;
  tempHkClubappsFacecallSong?: Maybe<Club_WorldFamilyClub_TempHkClubappsFacecallSong>;
  tempHkDmemChild?: Maybe<Club_WorldFamilyClub_TempHkDmemChild>;
  tempHkTeSong?: Maybe<Club_WorldFamilyClub_TempHkTeSong>;
  tempHkTematerial?: Maybe<Club_WorldFamilyClub_TempHkTematerial>;
  tempKrFaceCallHist?: Maybe<Club_WorldFamilyClub_TempKrFaceCallHist>;
  tempKrFcCrewM?: Maybe<Club_WorldFamilyClub_TempKrFcCrewM>;
  tempKrFcsongCrew?: Maybe<Club_WorldFamilyClub_TempKrFcsongCrew>;
  tempKrMyFavorite?: Maybe<Club_WorldFamilyClub_TempKrMyFavorite>;
  tempKrTeSong?: Maybe<Club_WorldFamilyClub_TempKrTeSong>;
  tempKrWfeClubMemberChild?: Maybe<Club_WorldFamilyClub_TempKrWfeClubMemberChild>;
  tempTalkAlongCard?: Maybe<Club_WorldFamilyClub_TempTalkAlongCard>;
  tempTwCambridge?: Maybe<Club_WorldFamilyClub_TempTwCambridge>;
  tempTwFaceCallHist?: Maybe<Club_WorldFamilyClub_TempTwFaceCallHist>;
  tempTwFcCrewM?: Maybe<Club_WorldFamilyClub_TempTwFcCrewM>;
  tempTwFcsongCrew?: Maybe<Club_WorldFamilyClub_TempTwFcsongCrew>;
  tempTwFcsongMonthlyRecommend?: Maybe<Club_WorldFamilyClub_TempTwFcsongMonthlyRecommend>;
  tempTwMyFavorite?: Maybe<Club_WorldFamilyClub_TempTwMyFavorite>;
  tempTwTeSong?: Maybe<Club_WorldFamilyClub_TempTwTeSong>;
  tempTwTeSongForCapLevel?: Maybe<Club_WorldFamilyClub_TempTwTeSongForCapLevel>;
  tempWfcGraC?: Maybe<Club_WorldFamilyClub_TempWfcGraC>;
  tempWfcGraCOrganized?: Maybe<Club_WorldFamilyClub_TempWfcGraCOrganized>;
  testUserAccount?: Maybe<Club_WorldFamilyClub_TestUserAccount>;
  testWater?: Maybe<Club_WorldFamilyClub_TestWater>;
  testWaterSub?: Maybe<Club_WorldFamilyClub_TestWaterSub>;
  tev2MonthlySong?: Maybe<Club_WorldFamilyClub_Tev2MonthlySong>;
  user?: Maybe<Club_WorldFamilyClub_User>;
  videoForTrialmode?: Maybe<Club_WorldFamilyClub_VideoForTrialmode>;
  wfcLibraryFaq?: Maybe<Club_WorldFamilyClub_WfcLibraryFaq>;
  wfcLibraryLog?: Maybe<Club_WorldFamilyClub_WfcLibraryLog>;
  wfcNowPageViewLog?: Maybe<Club_WorldFamilyClub_WfcNowPageViewLog>;
};

export type Club_WorldFamilyClub_Mutation_UpdateInput = {
  appAuth?: InputMaybe<Club_WorldFamilyClub_AppAuthInput>;
  appBanner?: InputMaybe<Club_WorldFamilyClub_AppBannerInput>;
  appDigitalMagazine?: InputMaybe<Club_WorldFamilyClub_AppDigitalMagazineInput>;
  appMemberAuthorize?: InputMaybe<Club_WorldFamilyClub_AppMemberAuthorizeInput>;
  appMemberAuthorizeLog?: InputMaybe<Club_WorldFamilyClub_AppMemberAuthorizeLogInput>;
  appMemberChild?: InputMaybe<Club_WorldFamilyClub_AppMemberChildInput>;
  appMemberDevice?: InputMaybe<Club_WorldFamilyClub_AppMemberDeviceInput>;
  appMemberFirstLogin?: InputMaybe<Club_WorldFamilyClub_AppMemberFirstLoginInput>;
  appMemberNotification?: InputMaybe<Club_WorldFamilyClub_AppMemberNotificationInput>;
  appMemberNotificationPushFirebase?: InputMaybe<Club_WorldFamilyClub_AppMemberNotificationPushFirebaseInput>;
  appNotification?: InputMaybe<Club_WorldFamilyClub_AppNotificationInput>;
  appNotificationMember?: InputMaybe<Club_WorldFamilyClub_AppNotificationMemberInput>;
  appNotificationType?: InputMaybe<Club_WorldFamilyClub_AppNotificationTypeInput>;
  appNotificationTypeMarket?: InputMaybe<Club_WorldFamilyClub_AppNotificationTypeMarketInput>;
  appRegionEmergency?: InputMaybe<Club_WorldFamilyClub_AppRegionEmergencyInput>;
  appRelease?: InputMaybe<Club_WorldFamilyClub_AppReleaseInput>;
  appServiceRegionFestivalImage?: InputMaybe<Club_WorldFamilyClub_AppServiceRegionFestivalImageInput>;
  appServiceRegionImage?: InputMaybe<Club_WorldFamilyClub_AppServiceRegionImageInput>;
  appSurvey?: InputMaybe<Club_WorldFamilyClub_AppSurveyInput>;
  appSurveyMember?: InputMaybe<Club_WorldFamilyClub_AppSurveyMemberInput>;
  appSurveyQa?: InputMaybe<Club_WorldFamilyClub_AppSurveyQaInput>;
  appSurveyReminder?: InputMaybe<Club_WorldFamilyClub_AppSurveyReminderInput>;
  azureFunction?: InputMaybe<Club_WorldFamilyClub_AzureFunctionInput>;
  bankCode?: InputMaybe<Club_WorldFamilyClub_BankCodeInput>;
  broadcastPromotion?: InputMaybe<Club_WorldFamilyClub_BroadcastPromotionInput>;
  capGuidePdf?: InputMaybe<Club_WorldFamilyClub_CapGuidePdfInput>;
  childGraduationApplication?: InputMaybe<Club_WorldFamilyClub_ChildGraduationApplicationInput>;
  creditcardBankCode?: InputMaybe<Club_WorldFamilyClub_CreditcardBankCodeInput>;
  dweProductPackage?: InputMaybe<Club_WorldFamilyClub_DweProductPackageInput>;
  dweProductSong?: InputMaybe<Club_WorldFamilyClub_DweProductSongInput>;
  dweProductSongTool?: InputMaybe<Club_WorldFamilyClub_DweProductSongToolInput>;
  dweProductTool?: InputMaybe<Club_WorldFamilyClub_DweProductToolInput>;
  easypayOrderLog?: InputMaybe<Club_WorldFamilyClub_EasypayOrderLogInput>;
  entryPackageOrder?: InputMaybe<Club_WorldFamilyClub_EntryPackageOrderInput>;
  entryPackageOrdersMemberPaymentInfo?: InputMaybe<Club_WorldFamilyClub_EntryPackageOrdersMemberPaymentInfoInput>;
  eventBanner?: InputMaybe<Club_WorldFamilyClub_EventBannerInput>;
  eventBannerRegion?: InputMaybe<Club_WorldFamilyClub_EventBannerRegionInput>;
  eventCheckInAuth?: InputMaybe<Club_WorldFamilyClub_EventCheckInAuthInput>;
  eventNotificationLog?: InputMaybe<Club_WorldFamilyClub_EventNotificationLogInput>;
  eventPromotion?: InputMaybe<Club_WorldFamilyClub_EventPromotionInput>;
  eventSeat?: InputMaybe<Club_WorldFamilyClub_EventSeatInput>;
  eventType?: InputMaybe<Club_WorldFamilyClub_EventTypeInput>;
  exchangeApplication?: InputMaybe<Club_WorldFamilyClub_ExchangeApplicationInput>;
  exchangeApplicationItem?: InputMaybe<Club_WorldFamilyClub_ExchangeApplicationItemInput>;
  exchangeReason?: InputMaybe<Club_WorldFamilyClub_ExchangeReasonInput>;
  exchangeReasonTranslation?: InputMaybe<Club_WorldFamilyClub_ExchangeReasonTranslationInput>;
  faceCallAndTelephoneEnglish?: InputMaybe<Club_WorldFamilyClub_FaceCallAndTelephoneEnglishInput>;
  faceCallForTrialmode?: InputMaybe<Club_WorldFamilyClub_FaceCallForTrialmodeInput>;
  faceCallHist?: InputMaybe<Club_WorldFamilyClub_FaceCallHistInput>;
  faceCallHistCount?: InputMaybe<Club_WorldFamilyClub_FaceCallHistCountInput>;
  faceCallMonthlyRecommend?: InputMaybe<Club_WorldFamilyClub_FaceCallMonthlyRecommendInput>;
  faceCallPerformer?: InputMaybe<Club_WorldFamilyClub_FaceCallPerformerInput>;
  faceCallSeasonHoliday?: InputMaybe<Club_WorldFamilyClub_FaceCallSeasonHolidayInput>;
  faceCallSong?: InputMaybe<Club_WorldFamilyClub_FaceCallSongInput>;
  faceCallSongAndPerformer?: InputMaybe<Club_WorldFamilyClub_FaceCallSongAndPerformerInput>;
  faceCallSongPublic?: InputMaybe<Club_WorldFamilyClub_FaceCallSongPublicInput>;
  goGoLiveDesktopQrcode?: InputMaybe<Club_WorldFamilyClub_GoGoLiveDesktopQrcodeInput>;
  goGoLiveLevel?: InputMaybe<Club_WorldFamilyClub_GoGoLiveLevelInput>;
  goGoLiveOpenDate?: InputMaybe<Club_WorldFamilyClub_GoGoLiveOpenDateInput>;
  goGoLiveParentGuide?: InputMaybe<Club_WorldFamilyClub_GoGoLiveParentGuideInput>;
  goGoLiveParentGuideLocale?: InputMaybe<Club_WorldFamilyClub_GoGoLiveParentGuideLocaleInput>;
  goGoLiveParentGuideSession?: InputMaybe<Club_WorldFamilyClub_GoGoLiveParentGuideSessionInput>;
  goGoLiveParentGuideSong?: InputMaybe<Club_WorldFamilyClub_GoGoLiveParentGuideSongInput>;
  goGoLiveParentGuideTac?: InputMaybe<Club_WorldFamilyClub_GoGoLiveParentGuideTacInput>;
  goGoLiveParentGuideToy?: InputMaybe<Club_WorldFamilyClub_GoGoLiveParentGuideToyInput>;
  goGoLivePromotion?: InputMaybe<Club_WorldFamilyClub_GoGoLivePromotionInput>;
  goGoLiveSession?: InputMaybe<Club_WorldFamilyClub_GoGoLiveSessionInput>;
  goGoLiveSong?: InputMaybe<Club_WorldFamilyClub_GoGoLiveSongInput>;
  goGoLiveToy?: InputMaybe<Club_WorldFamilyClub_GoGoLiveToyInput>;
  graduationApplication?: InputMaybe<Club_WorldFamilyClub_GraduationApplicationInput>;
  graduationApplicationEvaluation?: InputMaybe<Club_WorldFamilyClub_GraduationApplicationEvaluationInput>;
  graduationApplicationSubTask?: InputMaybe<Club_WorldFamilyClub_GraduationApplicationSubTaskInput>;
  graduationApplicationTask?: InputMaybe<Club_WorldFamilyClub_GraduationApplicationTaskInput>;
  graduationChild?: InputMaybe<Club_WorldFamilyClub_GraduationChildInput>;
  graduationChildSetting?: InputMaybe<Club_WorldFamilyClub_GraduationChildSettingInput>;
  graduationEvaluation?: InputMaybe<Club_WorldFamilyClub_GraduationEvaluationInput>;
  graduationNotification?: InputMaybe<Club_WorldFamilyClub_GraduationNotificationInput>;
  graduationSubApplication?: InputMaybe<Club_WorldFamilyClub_GraduationSubApplicationInput>;
  graduationSubTaskMarketDescription?: InputMaybe<Club_WorldFamilyClub_GraduationSubTaskMarketDescriptionInput>;
  graduationTaskMarketDescription?: InputMaybe<Club_WorldFamilyClub_GraduationTaskMarketDescriptionInput>;
  graphqlAccess?: InputMaybe<Club_WorldFamilyClub_GraphqlAccessInput>;
  graphqlSchema?: InputMaybe<Club_WorldFamilyClub_GraphqlSchemaInput>;
  holidayAudio?: InputMaybe<Club_WorldFamilyClub_HolidayAudioInput>;
  holidaySetting?: InputMaybe<Club_WorldFamilyClub_HolidaySettingInput>;
  holidayVideo?: InputMaybe<Club_WorldFamilyClub_HolidayVideoInput>;
  holidayVideoBonusEntitlementTest?: InputMaybe<Club_WorldFamilyClub_HolidayVideoBonusEntitlementTestInput>;
  holidayVideoMarket?: InputMaybe<Club_WorldFamilyClub_HolidayVideoMarketInput>;
  holidayVideoMarketSetting?: InputMaybe<Club_WorldFamilyClub_HolidayVideoMarketSettingInput>;
  holidayVideoMember?: InputMaybe<Club_WorldFamilyClub_HolidayVideoMemberInput>;
  kidsWorldVideo?: InputMaybe<Club_WorldFamilyClub_KidsWorldVideoInput>;
  memberMessageSetting?: InputMaybe<Club_WorldFamilyClub_MemberMessageSettingInput>;
  memberMonthlyActiveSummary?: InputMaybe<Club_WorldFamilyClub_MemberMonthlyActiveSummaryInput>;
  memberUpgradePayment?: InputMaybe<Club_WorldFamilyClub_MemberUpgradePaymentInput>;
  myFavoriteFaceCall?: InputMaybe<Club_WorldFamilyClub_MyFavoriteFaceCallInput>;
  myFavoriteFaceCallSong?: InputMaybe<Club_WorldFamilyClub_MyFavoriteFaceCallSongInput>;
  notification?: InputMaybe<Club_WorldFamilyClub_NotificationInput>;
  notificationIcon?: InputMaybe<Club_WorldFamilyClub_NotificationIconInput>;
  oneTimeToken?: InputMaybe<Club_WorldFamilyClub_OneTimeTokenInput>;
  onlineEventLog?: InputMaybe<Club_WorldFamilyClub_OnlineEventLogInput>;
  onlineShow?: InputMaybe<Club_WorldFamilyClub_OnlineShowInput>;
  parameter?: InputMaybe<Club_WorldFamilyClub_ParameterInput>;
  product?: InputMaybe<Club_WorldFamilyClub_ProductInput>;
  productCategory?: InputMaybe<Club_WorldFamilyClub_ProductCategoryInput>;
  productCategoryTranslation?: InputMaybe<Club_WorldFamilyClub_ProductCategoryTranslationInput>;
  productSubCategory?: InputMaybe<Club_WorldFamilyClub_ProductSubCategoryInput>;
  productSubCategoryExchangeReason?: InputMaybe<Club_WorldFamilyClub_ProductSubCategoryExchangeReasonInput>;
  productSubCategoryTranslation?: InputMaybe<Club_WorldFamilyClub_ProductSubCategoryTranslationInput>;
  productTranslation?: InputMaybe<Club_WorldFamilyClub_ProductTranslationInput>;
  products1?: InputMaybe<Club_WorldFamilyClub_Products1Input>;
  regionBanner?: InputMaybe<Club_WorldFamilyClub_RegionBannerInput>;
  searchKeyword?: InputMaybe<Club_WorldFamilyClub_SearchKeywordInput>;
  service?: InputMaybe<Club_WorldFamilyClub_ServiceInput>;
  serviceBannerDefault?: InputMaybe<Club_WorldFamilyClub_ServiceBannerDefaultInput>;
  serviceBannerScheduled?: InputMaybe<Club_WorldFamilyClub_ServiceBannerScheduledInput>;
  serviceOneTimeToken?: InputMaybe<Club_WorldFamilyClub_ServiceOneTimeTokenInput>;
  serviceSearch?: InputMaybe<Club_WorldFamilyClub_ServiceSearchInput>;
  smsCertification?: InputMaybe<Club_WorldFamilyClub_SmsCertificationInput>;
  smsCertificationLog?: InputMaybe<Club_WorldFamilyClub_SmsCertificationLogInput>;
  smsVerificationCode?: InputMaybe<Club_WorldFamilyClub_SmsVerificationCodeInput>;
  surveyTypeForm?: InputMaybe<Club_WorldFamilyClub_SurveyTypeFormInput>;
  surveyTypeFormList?: InputMaybe<Club_WorldFamilyClub_SurveyTypeFormListInput>;
  talkAlongCard?: InputMaybe<Club_WorldFamilyClub_TalkAlongCardInput>;
  teSong?: InputMaybe<Club_WorldFamilyClub_TeSongInput>;
  teSongToy?: InputMaybe<Club_WorldFamilyClub_TeSongToyInput>;
  temp20240408Graduation?: InputMaybe<Club_WorldFamilyClub_Temp20240408GraduationInput>;
  temp20240408Graduation1?: InputMaybe<Club_WorldFamilyClub_Temp20240408Graduation1Input>;
  temp20251028ExchangeReason?: InputMaybe<Club_WorldFamilyClub_Temp20251028ExchangeReasonInput>;
  temp20260310Product?: InputMaybe<Club_WorldFamilyClub_Temp20260310ProductInput>;
  tempChildGraduationApplicationNew?: InputMaybe<Club_WorldFamilyClub_TempChildGraduationApplicationNewInput>;
  tempChildGraduationApplicationOld?: InputMaybe<Club_WorldFamilyClub_TempChildGraduationApplicationOldInput>;
  tempFaceCall?: InputMaybe<Club_WorldFamilyClub_TempFaceCallInput>;
  tempFaceCallHk?: InputMaybe<Club_WorldFamilyClub_TempFaceCallHkInput>;
  tempFaceCallKr?: InputMaybe<Club_WorldFamilyClub_TempFaceCallKrInput>;
  tempGoGoLiveSong?: InputMaybe<Club_WorldFamilyClub_TempGoGoLiveSongInput>;
  tempHkAppMyFavorite?: InputMaybe<Club_WorldFamilyClub_TempHkAppMyFavoriteInput>;
  tempHkClubappsFacecallCrew?: InputMaybe<Club_WorldFamilyClub_TempHkClubappsFacecallCrewInput>;
  tempHkClubappsFacecallHistory?: InputMaybe<Club_WorldFamilyClub_TempHkClubappsFacecallHistoryInput>;
  tempHkClubappsFacecallSong?: InputMaybe<Club_WorldFamilyClub_TempHkClubappsFacecallSongInput>;
  tempHkDmemChild?: InputMaybe<Club_WorldFamilyClub_TempHkDmemChildInput>;
  tempHkTeSong?: InputMaybe<Club_WorldFamilyClub_TempHkTeSongInput>;
  tempHkTematerial?: InputMaybe<Club_WorldFamilyClub_TempHkTematerialInput>;
  tempKrFaceCallHist?: InputMaybe<Club_WorldFamilyClub_TempKrFaceCallHistInput>;
  tempKrFcCrewM?: InputMaybe<Club_WorldFamilyClub_TempKrFcCrewMInput>;
  tempKrFcsongCrew?: InputMaybe<Club_WorldFamilyClub_TempKrFcsongCrewInput>;
  tempKrMyFavorite?: InputMaybe<Club_WorldFamilyClub_TempKrMyFavoriteInput>;
  tempKrTeSong?: InputMaybe<Club_WorldFamilyClub_TempKrTeSongInput>;
  tempKrWfeClubMemberChild?: InputMaybe<Club_WorldFamilyClub_TempKrWfeClubMemberChildInput>;
  tempTalkAlongCard?: InputMaybe<Club_WorldFamilyClub_TempTalkAlongCardInput>;
  tempTwCambridge?: InputMaybe<Club_WorldFamilyClub_TempTwCambridgeInput>;
  tempTwFaceCallHist?: InputMaybe<Club_WorldFamilyClub_TempTwFaceCallHistInput>;
  tempTwFcCrewM?: InputMaybe<Club_WorldFamilyClub_TempTwFcCrewMInput>;
  tempTwFcsongCrew?: InputMaybe<Club_WorldFamilyClub_TempTwFcsongCrewInput>;
  tempTwFcsongMonthlyRecommend?: InputMaybe<Club_WorldFamilyClub_TempTwFcsongMonthlyRecommendInput>;
  tempTwMyFavorite?: InputMaybe<Club_WorldFamilyClub_TempTwMyFavoriteInput>;
  tempTwTeSong?: InputMaybe<Club_WorldFamilyClub_TempTwTeSongInput>;
  tempTwTeSongForCapLevel?: InputMaybe<Club_WorldFamilyClub_TempTwTeSongForCapLevelInput>;
  tempWfcGraC?: InputMaybe<Club_WorldFamilyClub_TempWfcGraCInput>;
  tempWfcGraCOrganized?: InputMaybe<Club_WorldFamilyClub_TempWfcGraCOrganizedInput>;
  testUserAccount?: InputMaybe<Club_WorldFamilyClub_TestUserAccountInput>;
  testWater?: InputMaybe<Club_WorldFamilyClub_TestWaterInput>;
  testWaterSub?: InputMaybe<Club_WorldFamilyClub_TestWaterSubInput>;
  tev2MonthlySong?: InputMaybe<Club_WorldFamilyClub_Tev2MonthlySongInput>;
  user?: InputMaybe<Club_WorldFamilyClub_UserInput>;
  videoForTrialmode?: InputMaybe<Club_WorldFamilyClub_VideoForTrialmodeInput>;
  wfcLibraryFaq?: InputMaybe<Club_WorldFamilyClub_WfcLibraryFaqInput>;
  wfcLibraryLog?: InputMaybe<Club_WorldFamilyClub_WfcLibraryLogInput>;
  wfcNowPageViewLog?: InputMaybe<Club_WorldFamilyClub_WfcNowPageViewLogInput>;
};

export type Club_WorldFamilyClub_Mutation_UpdateRange = {
  __typename?: 'Club_WorldFamilyClub_Mutation_UpdateRange';
  appAuths?: Maybe<Array<Club_WorldFamilyClub_AppAuth>>;
  appBanners?: Maybe<Array<Club_WorldFamilyClub_AppBanner>>;
  appDigitalMagazines?: Maybe<Array<Club_WorldFamilyClub_AppDigitalMagazine>>;
  appMemberAuthorizeLogs?: Maybe<Array<Club_WorldFamilyClub_AppMemberAuthorizeLog>>;
  appMemberAuthorizes?: Maybe<Array<Club_WorldFamilyClub_AppMemberAuthorize>>;
  appMemberChildren?: Maybe<Array<Club_WorldFamilyClub_AppMemberChild>>;
  appMemberDevices?: Maybe<Array<Club_WorldFamilyClub_AppMemberDevice>>;
  appMemberFirstLogins?: Maybe<Array<Club_WorldFamilyClub_AppMemberFirstLogin>>;
  appMemberNotificationPushFirebases?: Maybe<Array<Club_WorldFamilyClub_AppMemberNotificationPushFirebase>>;
  appMemberNotifications?: Maybe<Array<Club_WorldFamilyClub_AppMemberNotification>>;
  appNotificationMembers?: Maybe<Array<Club_WorldFamilyClub_AppNotificationMember>>;
  appNotificationTypeMarkets?: Maybe<Array<Club_WorldFamilyClub_AppNotificationTypeMarket>>;
  appNotificationTypes?: Maybe<Array<Club_WorldFamilyClub_AppNotificationType>>;
  appNotifications?: Maybe<Array<Club_WorldFamilyClub_AppNotification>>;
  appRegionEmergencies?: Maybe<Array<Club_WorldFamilyClub_AppRegionEmergency>>;
  appReleases?: Maybe<Array<Club_WorldFamilyClub_AppRelease>>;
  appServiceRegionFestivalImages?: Maybe<Array<Club_WorldFamilyClub_AppServiceRegionFestivalImage>>;
  appServiceRegionImages?: Maybe<Array<Club_WorldFamilyClub_AppServiceRegionImage>>;
  appSurveyMembers?: Maybe<Array<Club_WorldFamilyClub_AppSurveyMember>>;
  appSurveyQas?: Maybe<Array<Club_WorldFamilyClub_AppSurveyQa>>;
  appSurveyReminders?: Maybe<Array<Club_WorldFamilyClub_AppSurveyReminder>>;
  appSurveys?: Maybe<Array<Club_WorldFamilyClub_AppSurvey>>;
  azureFunctions?: Maybe<Array<Club_WorldFamilyClub_AzureFunction>>;
  bankCodes?: Maybe<Array<Club_WorldFamilyClub_BankCode>>;
  broadcastPromotions?: Maybe<Array<Club_WorldFamilyClub_BroadcastPromotion>>;
  capGuidePdfs?: Maybe<Array<Club_WorldFamilyClub_CapGuidePdf>>;
  childGraduationApplications?: Maybe<Array<Club_WorldFamilyClub_ChildGraduationApplication>>;
  creditcardBankCodes?: Maybe<Array<Club_WorldFamilyClub_CreditcardBankCode>>;
  dweProductPackages?: Maybe<Array<Club_WorldFamilyClub_DweProductPackage>>;
  dweProductSongTools?: Maybe<Array<Club_WorldFamilyClub_DweProductSongTool>>;
  dweProductSongs?: Maybe<Array<Club_WorldFamilyClub_DweProductSong>>;
  dweProductTools?: Maybe<Array<Club_WorldFamilyClub_DweProductTool>>;
  easypayOrderLogs?: Maybe<Array<Club_WorldFamilyClub_EasypayOrderLog>>;
  entryPackageOrders?: Maybe<Array<Club_WorldFamilyClub_EntryPackageOrder>>;
  entryPackageOrdersMemberPaymentInfos?: Maybe<Array<Club_WorldFamilyClub_EntryPackageOrdersMemberPaymentInfo>>;
  eventBannerRegions?: Maybe<Array<Club_WorldFamilyClub_EventBannerRegion>>;
  eventBanners?: Maybe<Array<Club_WorldFamilyClub_EventBanner>>;
  eventCheckInAuths?: Maybe<Array<Club_WorldFamilyClub_EventCheckInAuth>>;
  eventNotificationLogs?: Maybe<Array<Club_WorldFamilyClub_EventNotificationLog>>;
  eventPromotions?: Maybe<Array<Club_WorldFamilyClub_EventPromotion>>;
  eventSeats?: Maybe<Array<Club_WorldFamilyClub_EventSeat>>;
  eventTypes?: Maybe<Array<Club_WorldFamilyClub_EventType>>;
  exchangeApplicationItems?: Maybe<Array<Club_WorldFamilyClub_ExchangeApplicationItem>>;
  exchangeApplications?: Maybe<Array<Club_WorldFamilyClub_ExchangeApplication>>;
  exchangeReasonTranslations?: Maybe<Array<Club_WorldFamilyClub_ExchangeReasonTranslation>>;
  exchangeReasons?: Maybe<Array<Club_WorldFamilyClub_ExchangeReason>>;
  faceCallAndTelephoneEnglishes?: Maybe<Array<Club_WorldFamilyClub_FaceCallAndTelephoneEnglish>>;
  faceCallForTrialmodes?: Maybe<Array<Club_WorldFamilyClub_FaceCallForTrialmode>>;
  faceCallHistCounts?: Maybe<Array<Club_WorldFamilyClub_FaceCallHistCount>>;
  faceCallHists?: Maybe<Array<Club_WorldFamilyClub_FaceCallHist>>;
  faceCallMonthlyRecommends?: Maybe<Array<Club_WorldFamilyClub_FaceCallMonthlyRecommend>>;
  faceCallPerformers?: Maybe<Array<Club_WorldFamilyClub_FaceCallPerformer>>;
  faceCallSeasonHolidays?: Maybe<Array<Club_WorldFamilyClub_FaceCallSeasonHoliday>>;
  faceCallSongAndPerformers?: Maybe<Array<Club_WorldFamilyClub_FaceCallSongAndPerformer>>;
  faceCallSongPublics?: Maybe<Array<Club_WorldFamilyClub_FaceCallSongPublic>>;
  faceCallSongs?: Maybe<Array<Club_WorldFamilyClub_FaceCallSong>>;
  goGoLiveDesktopQrcodes?: Maybe<Array<Club_WorldFamilyClub_GoGoLiveDesktopQrcode>>;
  goGoLiveLevels?: Maybe<Array<Club_WorldFamilyClub_GoGoLiveLevel>>;
  goGoLiveOpenDates?: Maybe<Array<Club_WorldFamilyClub_GoGoLiveOpenDate>>;
  goGoLiveParentGuideLocales?: Maybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuideLocale>>;
  goGoLiveParentGuideSessions?: Maybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuideSession>>;
  goGoLiveParentGuideSongs?: Maybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuideSong>>;
  goGoLiveParentGuideTacs?: Maybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuideTac>>;
  goGoLiveParentGuideToys?: Maybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuideToy>>;
  goGoLiveParentGuides?: Maybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuide>>;
  goGoLivePromotions?: Maybe<Array<Club_WorldFamilyClub_GoGoLivePromotion>>;
  goGoLiveSessions?: Maybe<Array<Club_WorldFamilyClub_GoGoLiveSession>>;
  goGoLiveSongs?: Maybe<Array<Club_WorldFamilyClub_GoGoLiveSong>>;
  goGoLiveToys?: Maybe<Array<Club_WorldFamilyClub_GoGoLiveToy>>;
  graduationApplicationEvaluations?: Maybe<Array<Club_WorldFamilyClub_GraduationApplicationEvaluation>>;
  graduationApplicationSubTasks?: Maybe<Array<Club_WorldFamilyClub_GraduationApplicationSubTask>>;
  graduationApplicationTasks?: Maybe<Array<Club_WorldFamilyClub_GraduationApplicationTask>>;
  graduationApplications?: Maybe<Array<Club_WorldFamilyClub_GraduationApplication>>;
  graduationChildSettings?: Maybe<Array<Club_WorldFamilyClub_GraduationChildSetting>>;
  graduationChildren?: Maybe<Array<Club_WorldFamilyClub_GraduationChild>>;
  graduationEvaluations?: Maybe<Array<Club_WorldFamilyClub_GraduationEvaluation>>;
  graduationNotifications?: Maybe<Array<Club_WorldFamilyClub_GraduationNotification>>;
  graduationSubApplications?: Maybe<Array<Club_WorldFamilyClub_GraduationSubApplication>>;
  graduationSubTaskMarketDescriptions?: Maybe<Array<Club_WorldFamilyClub_GraduationSubTaskMarketDescription>>;
  graduationTaskMarketDescriptions?: Maybe<Array<Club_WorldFamilyClub_GraduationTaskMarketDescription>>;
  graphqlAccesses?: Maybe<Array<Club_WorldFamilyClub_GraphqlAccess>>;
  graphqlSchemas?: Maybe<Array<Club_WorldFamilyClub_GraphqlSchema>>;
  holidayAudios?: Maybe<Array<Club_WorldFamilyClub_HolidayAudio>>;
  holidaySettings?: Maybe<Array<Club_WorldFamilyClub_HolidaySetting>>;
  holidayVideoBonusEntitlementTests?: Maybe<Array<Club_WorldFamilyClub_HolidayVideoBonusEntitlementTest>>;
  holidayVideoMarketSettings?: Maybe<Array<Club_WorldFamilyClub_HolidayVideoMarketSetting>>;
  holidayVideoMarkets?: Maybe<Array<Club_WorldFamilyClub_HolidayVideoMarket>>;
  holidayVideoMembers?: Maybe<Array<Club_WorldFamilyClub_HolidayVideoMember>>;
  holidayVideos?: Maybe<Array<Club_WorldFamilyClub_HolidayVideo>>;
  kidsWorldVideos?: Maybe<Array<Club_WorldFamilyClub_KidsWorldVideo>>;
  memberMessageSettings?: Maybe<Array<Club_WorldFamilyClub_MemberMessageSetting>>;
  memberMonthlyActiveSummaries?: Maybe<Array<Club_WorldFamilyClub_MemberMonthlyActiveSummary>>;
  memberUpgradePayments?: Maybe<Array<Club_WorldFamilyClub_MemberUpgradePayment>>;
  myFavoriteFaceCallSongs?: Maybe<Array<Club_WorldFamilyClub_MyFavoriteFaceCallSong>>;
  myFavoriteFaceCalls?: Maybe<Array<Club_WorldFamilyClub_MyFavoriteFaceCall>>;
  notificationIcons?: Maybe<Array<Club_WorldFamilyClub_NotificationIcon>>;
  notifications?: Maybe<Array<Club_WorldFamilyClub_Notification>>;
  oneTimeTokens?: Maybe<Array<Club_WorldFamilyClub_OneTimeToken>>;
  onlineEventLogs?: Maybe<Array<Club_WorldFamilyClub_OnlineEventLog>>;
  onlineShows?: Maybe<Array<Club_WorldFamilyClub_OnlineShow>>;
  parameters?: Maybe<Array<Club_WorldFamilyClub_Parameter>>;
  productCategories?: Maybe<Array<Club_WorldFamilyClub_ProductCategory>>;
  productCategoryTranslations?: Maybe<Array<Club_WorldFamilyClub_ProductCategoryTranslation>>;
  productSubCategories?: Maybe<Array<Club_WorldFamilyClub_ProductSubCategory>>;
  productSubCategoryExchangeReasons?: Maybe<Array<Club_WorldFamilyClub_ProductSubCategoryExchangeReason>>;
  productSubCategoryTranslations?: Maybe<Array<Club_WorldFamilyClub_ProductSubCategoryTranslation>>;
  productTranslations?: Maybe<Array<Club_WorldFamilyClub_ProductTranslation>>;
  products?: Maybe<Array<Club_WorldFamilyClub_Product>>;
  products1s?: Maybe<Array<Club_WorldFamilyClub_Products1>>;
  regionBanners?: Maybe<Array<Club_WorldFamilyClub_RegionBanner>>;
  searchKeywords?: Maybe<Array<Club_WorldFamilyClub_SearchKeyword>>;
  serviceBannerDefaults?: Maybe<Array<Club_WorldFamilyClub_ServiceBannerDefault>>;
  serviceBannerScheduleds?: Maybe<Array<Club_WorldFamilyClub_ServiceBannerScheduled>>;
  serviceOneTimeTokens?: Maybe<Array<Club_WorldFamilyClub_ServiceOneTimeToken>>;
  serviceSearches?: Maybe<Array<Club_WorldFamilyClub_ServiceSearch>>;
  services?: Maybe<Array<Club_WorldFamilyClub_Service>>;
  smsCertificationLogs?: Maybe<Array<Club_WorldFamilyClub_SmsCertificationLog>>;
  smsCertifications?: Maybe<Array<Club_WorldFamilyClub_SmsCertification>>;
  smsVerificationCodes?: Maybe<Array<Club_WorldFamilyClub_SmsVerificationCode>>;
  surveyTypeFormLists?: Maybe<Array<Club_WorldFamilyClub_SurveyTypeFormList>>;
  surveyTypeForms?: Maybe<Array<Club_WorldFamilyClub_SurveyTypeForm>>;
  talkAlongCards?: Maybe<Array<Club_WorldFamilyClub_TalkAlongCard>>;
  teSongToys?: Maybe<Array<Club_WorldFamilyClub_TeSongToy>>;
  teSongs?: Maybe<Array<Club_WorldFamilyClub_TeSong>>;
  temp20240408Graduation1s?: Maybe<Array<Club_WorldFamilyClub_Temp20240408Graduation1>>;
  temp20240408Graduations?: Maybe<Array<Club_WorldFamilyClub_Temp20240408Graduation>>;
  temp20251028ExchangeReasons?: Maybe<Array<Club_WorldFamilyClub_Temp20251028ExchangeReason>>;
  temp20260310Products?: Maybe<Array<Club_WorldFamilyClub_Temp20260310Product>>;
  tempChildGraduationApplicationNews?: Maybe<Array<Club_WorldFamilyClub_TempChildGraduationApplicationNew>>;
  tempChildGraduationApplicationOlds?: Maybe<Array<Club_WorldFamilyClub_TempChildGraduationApplicationOld>>;
  tempFaceCallHks?: Maybe<Array<Club_WorldFamilyClub_TempFaceCallHk>>;
  tempFaceCallKrs?: Maybe<Array<Club_WorldFamilyClub_TempFaceCallKr>>;
  tempFaceCalls?: Maybe<Array<Club_WorldFamilyClub_TempFaceCall>>;
  tempGoGoLiveSongs?: Maybe<Array<Club_WorldFamilyClub_TempGoGoLiveSong>>;
  tempHkAppMyFavorites?: Maybe<Array<Club_WorldFamilyClub_TempHkAppMyFavorite>>;
  tempHkClubappsFacecallCrews?: Maybe<Array<Club_WorldFamilyClub_TempHkClubappsFacecallCrew>>;
  tempHkClubappsFacecallHistories?: Maybe<Array<Club_WorldFamilyClub_TempHkClubappsFacecallHistory>>;
  tempHkClubappsFacecallSongs?: Maybe<Array<Club_WorldFamilyClub_TempHkClubappsFacecallSong>>;
  tempHkDmemChildren?: Maybe<Array<Club_WorldFamilyClub_TempHkDmemChild>>;
  tempHkTeSongs?: Maybe<Array<Club_WorldFamilyClub_TempHkTeSong>>;
  tempHkTematerials?: Maybe<Array<Club_WorldFamilyClub_TempHkTematerial>>;
  tempKrFaceCallHists?: Maybe<Array<Club_WorldFamilyClub_TempKrFaceCallHist>>;
  tempKrFcCrewMs?: Maybe<Array<Club_WorldFamilyClub_TempKrFcCrewM>>;
  tempKrFcsongCrews?: Maybe<Array<Club_WorldFamilyClub_TempKrFcsongCrew>>;
  tempKrMyFavorites?: Maybe<Array<Club_WorldFamilyClub_TempKrMyFavorite>>;
  tempKrTeSongs?: Maybe<Array<Club_WorldFamilyClub_TempKrTeSong>>;
  tempKrWfeClubMemberChildren?: Maybe<Array<Club_WorldFamilyClub_TempKrWfeClubMemberChild>>;
  tempTalkAlongCards?: Maybe<Array<Club_WorldFamilyClub_TempTalkAlongCard>>;
  tempTwCambridges?: Maybe<Array<Club_WorldFamilyClub_TempTwCambridge>>;
  tempTwFaceCallHists?: Maybe<Array<Club_WorldFamilyClub_TempTwFaceCallHist>>;
  tempTwFcCrewMs?: Maybe<Array<Club_WorldFamilyClub_TempTwFcCrewM>>;
  tempTwFcsongCrews?: Maybe<Array<Club_WorldFamilyClub_TempTwFcsongCrew>>;
  tempTwFcsongMonthlyRecommends?: Maybe<Array<Club_WorldFamilyClub_TempTwFcsongMonthlyRecommend>>;
  tempTwMyFavorites?: Maybe<Array<Club_WorldFamilyClub_TempTwMyFavorite>>;
  tempTwTeSongForCapLevels?: Maybe<Array<Club_WorldFamilyClub_TempTwTeSongForCapLevel>>;
  tempTwTeSongs?: Maybe<Array<Club_WorldFamilyClub_TempTwTeSong>>;
  tempWfcGraCOrganizeds?: Maybe<Array<Club_WorldFamilyClub_TempWfcGraCOrganized>>;
  tempWfcGraCs?: Maybe<Array<Club_WorldFamilyClub_TempWfcGraC>>;
  testUserAccounts?: Maybe<Array<Club_WorldFamilyClub_TestUserAccount>>;
  testWaterSubs?: Maybe<Array<Club_WorldFamilyClub_TestWaterSub>>;
  testWaters?: Maybe<Array<Club_WorldFamilyClub_TestWater>>;
  tev2MonthlySongs?: Maybe<Array<Club_WorldFamilyClub_Tev2MonthlySong>>;
  users?: Maybe<Array<Club_WorldFamilyClub_User>>;
  videoForTrialmodes?: Maybe<Array<Club_WorldFamilyClub_VideoForTrialmode>>;
  wfcLibraryFaqs?: Maybe<Array<Club_WorldFamilyClub_WfcLibraryFaq>>;
  wfcLibraryLogs?: Maybe<Array<Club_WorldFamilyClub_WfcLibraryLog>>;
  wfcNowPageViewLogs?: Maybe<Array<Club_WorldFamilyClub_WfcNowPageViewLog>>;
};

export type Club_WorldFamilyClub_Mutation_UpdateRangeInput = {
  appAuths?: InputMaybe<Array<Club_WorldFamilyClub_AppAuthInput>>;
  appBanners?: InputMaybe<Array<Club_WorldFamilyClub_AppBannerInput>>;
  appDigitalMagazines?: InputMaybe<Array<Club_WorldFamilyClub_AppDigitalMagazineInput>>;
  appMemberAuthorizeLogs?: InputMaybe<Array<Club_WorldFamilyClub_AppMemberAuthorizeLogInput>>;
  appMemberAuthorizes?: InputMaybe<Array<Club_WorldFamilyClub_AppMemberAuthorizeInput>>;
  appMemberChildren?: InputMaybe<Array<Club_WorldFamilyClub_AppMemberChildInput>>;
  appMemberDevices?: InputMaybe<Array<Club_WorldFamilyClub_AppMemberDeviceInput>>;
  appMemberFirstLogins?: InputMaybe<Array<Club_WorldFamilyClub_AppMemberFirstLoginInput>>;
  appMemberNotificationPushFirebases?: InputMaybe<Array<Club_WorldFamilyClub_AppMemberNotificationPushFirebaseInput>>;
  appMemberNotifications?: InputMaybe<Array<Club_WorldFamilyClub_AppMemberNotificationInput>>;
  appNotificationMembers?: InputMaybe<Array<Club_WorldFamilyClub_AppNotificationMemberInput>>;
  appNotificationTypeMarkets?: InputMaybe<Array<Club_WorldFamilyClub_AppNotificationTypeMarketInput>>;
  appNotificationTypes?: InputMaybe<Array<Club_WorldFamilyClub_AppNotificationTypeInput>>;
  appNotifications?: InputMaybe<Array<Club_WorldFamilyClub_AppNotificationInput>>;
  appRegionEmergencies?: InputMaybe<Array<Club_WorldFamilyClub_AppRegionEmergencyInput>>;
  appReleases?: InputMaybe<Array<Club_WorldFamilyClub_AppReleaseInput>>;
  appServiceRegionFestivalImages?: InputMaybe<Array<Club_WorldFamilyClub_AppServiceRegionFestivalImageInput>>;
  appServiceRegionImages?: InputMaybe<Array<Club_WorldFamilyClub_AppServiceRegionImageInput>>;
  appSurveyMembers?: InputMaybe<Array<Club_WorldFamilyClub_AppSurveyMemberInput>>;
  appSurveyQas?: InputMaybe<Array<Club_WorldFamilyClub_AppSurveyQaInput>>;
  appSurveyReminders?: InputMaybe<Array<Club_WorldFamilyClub_AppSurveyReminderInput>>;
  appSurveys?: InputMaybe<Array<Club_WorldFamilyClub_AppSurveyInput>>;
  azureFunctions?: InputMaybe<Array<Club_WorldFamilyClub_AzureFunctionInput>>;
  bankCodes?: InputMaybe<Array<Club_WorldFamilyClub_BankCodeInput>>;
  broadcastPromotions?: InputMaybe<Array<Club_WorldFamilyClub_BroadcastPromotionInput>>;
  capGuidePdfs?: InputMaybe<Array<Club_WorldFamilyClub_CapGuidePdfInput>>;
  childGraduationApplications?: InputMaybe<Array<Club_WorldFamilyClub_ChildGraduationApplicationInput>>;
  creditcardBankCodes?: InputMaybe<Array<Club_WorldFamilyClub_CreditcardBankCodeInput>>;
  dweProductPackages?: InputMaybe<Array<Club_WorldFamilyClub_DweProductPackageInput>>;
  dweProductSongTools?: InputMaybe<Array<Club_WorldFamilyClub_DweProductSongToolInput>>;
  dweProductSongs?: InputMaybe<Array<Club_WorldFamilyClub_DweProductSongInput>>;
  dweProductTools?: InputMaybe<Array<Club_WorldFamilyClub_DweProductToolInput>>;
  easypayOrderLogs?: InputMaybe<Array<Club_WorldFamilyClub_EasypayOrderLogInput>>;
  entryPackageOrders?: InputMaybe<Array<Club_WorldFamilyClub_EntryPackageOrderInput>>;
  entryPackageOrdersMemberPaymentInfos?: InputMaybe<Array<Club_WorldFamilyClub_EntryPackageOrdersMemberPaymentInfoInput>>;
  eventBannerRegions?: InputMaybe<Array<Club_WorldFamilyClub_EventBannerRegionInput>>;
  eventBanners?: InputMaybe<Array<Club_WorldFamilyClub_EventBannerInput>>;
  eventCheckInAuths?: InputMaybe<Array<Club_WorldFamilyClub_EventCheckInAuthInput>>;
  eventNotificationLogs?: InputMaybe<Array<Club_WorldFamilyClub_EventNotificationLogInput>>;
  eventPromotions?: InputMaybe<Array<Club_WorldFamilyClub_EventPromotionInput>>;
  eventSeats?: InputMaybe<Array<Club_WorldFamilyClub_EventSeatInput>>;
  eventTypes?: InputMaybe<Array<Club_WorldFamilyClub_EventTypeInput>>;
  exchangeApplicationItems?: InputMaybe<Array<Club_WorldFamilyClub_ExchangeApplicationItemInput>>;
  exchangeApplications?: InputMaybe<Array<Club_WorldFamilyClub_ExchangeApplicationInput>>;
  exchangeReasonTranslations?: InputMaybe<Array<Club_WorldFamilyClub_ExchangeReasonTranslationInput>>;
  exchangeReasons?: InputMaybe<Array<Club_WorldFamilyClub_ExchangeReasonInput>>;
  faceCallAndTelephoneEnglishes?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallAndTelephoneEnglishInput>>;
  faceCallForTrialmodes?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallForTrialmodeInput>>;
  faceCallHistCounts?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallHistCountInput>>;
  faceCallHists?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallHistInput>>;
  faceCallMonthlyRecommends?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallMonthlyRecommendInput>>;
  faceCallPerformers?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallPerformerInput>>;
  faceCallSeasonHolidays?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallSeasonHolidayInput>>;
  faceCallSongAndPerformers?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallSongAndPerformerInput>>;
  faceCallSongPublics?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallSongPublicInput>>;
  faceCallSongs?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallSongInput>>;
  goGoLiveDesktopQrcodes?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveDesktopQrcodeInput>>;
  goGoLiveLevels?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveLevelInput>>;
  goGoLiveOpenDates?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveOpenDateInput>>;
  goGoLiveParentGuideLocales?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuideLocaleInput>>;
  goGoLiveParentGuideSessions?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuideSessionInput>>;
  goGoLiveParentGuideSongs?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuideSongInput>>;
  goGoLiveParentGuideTacs?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuideTacInput>>;
  goGoLiveParentGuideToys?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuideToyInput>>;
  goGoLiveParentGuides?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuideInput>>;
  goGoLivePromotions?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLivePromotionInput>>;
  goGoLiveSessions?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveSessionInput>>;
  goGoLiveSongs?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveSongInput>>;
  goGoLiveToys?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveToyInput>>;
  graduationApplicationEvaluations?: InputMaybe<Array<Club_WorldFamilyClub_GraduationApplicationEvaluationInput>>;
  graduationApplicationSubTasks?: InputMaybe<Array<Club_WorldFamilyClub_GraduationApplicationSubTaskInput>>;
  graduationApplicationTasks?: InputMaybe<Array<Club_WorldFamilyClub_GraduationApplicationTaskInput>>;
  graduationApplications?: InputMaybe<Array<Club_WorldFamilyClub_GraduationApplicationInput>>;
  graduationChildSettings?: InputMaybe<Array<Club_WorldFamilyClub_GraduationChildSettingInput>>;
  graduationChildren?: InputMaybe<Array<Club_WorldFamilyClub_GraduationChildInput>>;
  graduationEvaluations?: InputMaybe<Array<Club_WorldFamilyClub_GraduationEvaluationInput>>;
  graduationNotifications?: InputMaybe<Array<Club_WorldFamilyClub_GraduationNotificationInput>>;
  graduationSubApplications?: InputMaybe<Array<Club_WorldFamilyClub_GraduationSubApplicationInput>>;
  graduationSubTaskMarketDescriptions?: InputMaybe<Array<Club_WorldFamilyClub_GraduationSubTaskMarketDescriptionInput>>;
  graduationTaskMarketDescriptions?: InputMaybe<Array<Club_WorldFamilyClub_GraduationTaskMarketDescriptionInput>>;
  graphqlAccesses?: InputMaybe<Array<Club_WorldFamilyClub_GraphqlAccessInput>>;
  graphqlSchemas?: InputMaybe<Array<Club_WorldFamilyClub_GraphqlSchemaInput>>;
  holidayAudios?: InputMaybe<Array<Club_WorldFamilyClub_HolidayAudioInput>>;
  holidaySettings?: InputMaybe<Array<Club_WorldFamilyClub_HolidaySettingInput>>;
  holidayVideoBonusEntitlementTests?: InputMaybe<Array<Club_WorldFamilyClub_HolidayVideoBonusEntitlementTestInput>>;
  holidayVideoMarketSettings?: InputMaybe<Array<Club_WorldFamilyClub_HolidayVideoMarketSettingInput>>;
  holidayVideoMarkets?: InputMaybe<Array<Club_WorldFamilyClub_HolidayVideoMarketInput>>;
  holidayVideoMembers?: InputMaybe<Array<Club_WorldFamilyClub_HolidayVideoMemberInput>>;
  holidayVideos?: InputMaybe<Array<Club_WorldFamilyClub_HolidayVideoInput>>;
  kidsWorldVideos?: InputMaybe<Array<Club_WorldFamilyClub_KidsWorldVideoInput>>;
  memberMessageSettings?: InputMaybe<Array<Club_WorldFamilyClub_MemberMessageSettingInput>>;
  memberMonthlyActiveSummaries?: InputMaybe<Array<Club_WorldFamilyClub_MemberMonthlyActiveSummaryInput>>;
  memberUpgradePayments?: InputMaybe<Array<Club_WorldFamilyClub_MemberUpgradePaymentInput>>;
  myFavoriteFaceCallSongs?: InputMaybe<Array<Club_WorldFamilyClub_MyFavoriteFaceCallSongInput>>;
  myFavoriteFaceCalls?: InputMaybe<Array<Club_WorldFamilyClub_MyFavoriteFaceCallInput>>;
  notificationIcons?: InputMaybe<Array<Club_WorldFamilyClub_NotificationIconInput>>;
  notifications?: InputMaybe<Array<Club_WorldFamilyClub_NotificationInput>>;
  oneTimeTokens?: InputMaybe<Array<Club_WorldFamilyClub_OneTimeTokenInput>>;
  onlineEventLogs?: InputMaybe<Array<Club_WorldFamilyClub_OnlineEventLogInput>>;
  onlineShows?: InputMaybe<Array<Club_WorldFamilyClub_OnlineShowInput>>;
  parameters?: InputMaybe<Array<Club_WorldFamilyClub_ParameterInput>>;
  productCategories?: InputMaybe<Array<Club_WorldFamilyClub_ProductCategoryInput>>;
  productCategoryTranslations?: InputMaybe<Array<Club_WorldFamilyClub_ProductCategoryTranslationInput>>;
  productSubCategories?: InputMaybe<Array<Club_WorldFamilyClub_ProductSubCategoryInput>>;
  productSubCategoryExchangeReasons?: InputMaybe<Array<Club_WorldFamilyClub_ProductSubCategoryExchangeReasonInput>>;
  productSubCategoryTranslations?: InputMaybe<Array<Club_WorldFamilyClub_ProductSubCategoryTranslationInput>>;
  productTranslations?: InputMaybe<Array<Club_WorldFamilyClub_ProductTranslationInput>>;
  products?: InputMaybe<Array<Club_WorldFamilyClub_ProductInput>>;
  products1s?: InputMaybe<Array<Club_WorldFamilyClub_Products1Input>>;
  regionBanners?: InputMaybe<Array<Club_WorldFamilyClub_RegionBannerInput>>;
  searchKeywords?: InputMaybe<Array<Club_WorldFamilyClub_SearchKeywordInput>>;
  serviceBannerDefaults?: InputMaybe<Array<Club_WorldFamilyClub_ServiceBannerDefaultInput>>;
  serviceBannerScheduleds?: InputMaybe<Array<Club_WorldFamilyClub_ServiceBannerScheduledInput>>;
  serviceOneTimeTokens?: InputMaybe<Array<Club_WorldFamilyClub_ServiceOneTimeTokenInput>>;
  serviceSearches?: InputMaybe<Array<Club_WorldFamilyClub_ServiceSearchInput>>;
  services?: InputMaybe<Array<Club_WorldFamilyClub_ServiceInput>>;
  smsCertificationLogs?: InputMaybe<Array<Club_WorldFamilyClub_SmsCertificationLogInput>>;
  smsCertifications?: InputMaybe<Array<Club_WorldFamilyClub_SmsCertificationInput>>;
  smsVerificationCodes?: InputMaybe<Array<Club_WorldFamilyClub_SmsVerificationCodeInput>>;
  surveyTypeFormLists?: InputMaybe<Array<Club_WorldFamilyClub_SurveyTypeFormListInput>>;
  surveyTypeForms?: InputMaybe<Array<Club_WorldFamilyClub_SurveyTypeFormInput>>;
  talkAlongCards?: InputMaybe<Array<Club_WorldFamilyClub_TalkAlongCardInput>>;
  teSongToys?: InputMaybe<Array<Club_WorldFamilyClub_TeSongToyInput>>;
  teSongs?: InputMaybe<Array<Club_WorldFamilyClub_TeSongInput>>;
  temp20240408Graduation1s?: InputMaybe<Array<Club_WorldFamilyClub_Temp20240408Graduation1Input>>;
  temp20240408Graduations?: InputMaybe<Array<Club_WorldFamilyClub_Temp20240408GraduationInput>>;
  temp20251028ExchangeReasons?: InputMaybe<Array<Club_WorldFamilyClub_Temp20251028ExchangeReasonInput>>;
  temp20260310Products?: InputMaybe<Array<Club_WorldFamilyClub_Temp20260310ProductInput>>;
  tempChildGraduationApplicationNews?: InputMaybe<Array<Club_WorldFamilyClub_TempChildGraduationApplicationNewInput>>;
  tempChildGraduationApplicationOlds?: InputMaybe<Array<Club_WorldFamilyClub_TempChildGraduationApplicationOldInput>>;
  tempFaceCallHks?: InputMaybe<Array<Club_WorldFamilyClub_TempFaceCallHkInput>>;
  tempFaceCallKrs?: InputMaybe<Array<Club_WorldFamilyClub_TempFaceCallKrInput>>;
  tempFaceCalls?: InputMaybe<Array<Club_WorldFamilyClub_TempFaceCallInput>>;
  tempGoGoLiveSongs?: InputMaybe<Array<Club_WorldFamilyClub_TempGoGoLiveSongInput>>;
  tempHkAppMyFavorites?: InputMaybe<Array<Club_WorldFamilyClub_TempHkAppMyFavoriteInput>>;
  tempHkClubappsFacecallCrews?: InputMaybe<Array<Club_WorldFamilyClub_TempHkClubappsFacecallCrewInput>>;
  tempHkClubappsFacecallHistories?: InputMaybe<Array<Club_WorldFamilyClub_TempHkClubappsFacecallHistoryInput>>;
  tempHkClubappsFacecallSongs?: InputMaybe<Array<Club_WorldFamilyClub_TempHkClubappsFacecallSongInput>>;
  tempHkDmemChildren?: InputMaybe<Array<Club_WorldFamilyClub_TempHkDmemChildInput>>;
  tempHkTeSongs?: InputMaybe<Array<Club_WorldFamilyClub_TempHkTeSongInput>>;
  tempHkTematerials?: InputMaybe<Array<Club_WorldFamilyClub_TempHkTematerialInput>>;
  tempKrFaceCallHists?: InputMaybe<Array<Club_WorldFamilyClub_TempKrFaceCallHistInput>>;
  tempKrFcCrewMs?: InputMaybe<Array<Club_WorldFamilyClub_TempKrFcCrewMInput>>;
  tempKrFcsongCrews?: InputMaybe<Array<Club_WorldFamilyClub_TempKrFcsongCrewInput>>;
  tempKrMyFavorites?: InputMaybe<Array<Club_WorldFamilyClub_TempKrMyFavoriteInput>>;
  tempKrTeSongs?: InputMaybe<Array<Club_WorldFamilyClub_TempKrTeSongInput>>;
  tempKrWfeClubMemberChildren?: InputMaybe<Array<Club_WorldFamilyClub_TempKrWfeClubMemberChildInput>>;
  tempTalkAlongCards?: InputMaybe<Array<Club_WorldFamilyClub_TempTalkAlongCardInput>>;
  tempTwCambridges?: InputMaybe<Array<Club_WorldFamilyClub_TempTwCambridgeInput>>;
  tempTwFaceCallHists?: InputMaybe<Array<Club_WorldFamilyClub_TempTwFaceCallHistInput>>;
  tempTwFcCrewMs?: InputMaybe<Array<Club_WorldFamilyClub_TempTwFcCrewMInput>>;
  tempTwFcsongCrews?: InputMaybe<Array<Club_WorldFamilyClub_TempTwFcsongCrewInput>>;
  tempTwFcsongMonthlyRecommends?: InputMaybe<Array<Club_WorldFamilyClub_TempTwFcsongMonthlyRecommendInput>>;
  tempTwMyFavorites?: InputMaybe<Array<Club_WorldFamilyClub_TempTwMyFavoriteInput>>;
  tempTwTeSongForCapLevels?: InputMaybe<Array<Club_WorldFamilyClub_TempTwTeSongForCapLevelInput>>;
  tempTwTeSongs?: InputMaybe<Array<Club_WorldFamilyClub_TempTwTeSongInput>>;
  tempWfcGraCOrganizeds?: InputMaybe<Array<Club_WorldFamilyClub_TempWfcGraCOrganizedInput>>;
  tempWfcGraCs?: InputMaybe<Array<Club_WorldFamilyClub_TempWfcGraCInput>>;
  testUserAccounts?: InputMaybe<Array<Club_WorldFamilyClub_TestUserAccountInput>>;
  testWaterSubs?: InputMaybe<Array<Club_WorldFamilyClub_TestWaterSubInput>>;
  testWaters?: InputMaybe<Array<Club_WorldFamilyClub_TestWaterInput>>;
  tev2MonthlySongs?: InputMaybe<Array<Club_WorldFamilyClub_Tev2MonthlySongInput>>;
  users?: InputMaybe<Array<Club_WorldFamilyClub_UserInput>>;
  videoForTrialmodes?: InputMaybe<Array<Club_WorldFamilyClub_VideoForTrialmodeInput>>;
  wfcLibraryFaqs?: InputMaybe<Array<Club_WorldFamilyClub_WfcLibraryFaqInput>>;
  wfcLibraryLogs?: InputMaybe<Array<Club_WorldFamilyClub_WfcLibraryLogInput>>;
  wfcNowPageViewLogs?: InputMaybe<Array<Club_WorldFamilyClub_WfcNowPageViewLogInput>>;
};

/** MyFavoriteFaceCall */
export type Club_WorldFamilyClub_MyFavoriteFaceCall = Node & {
  __typename?: 'Club_WorldFamilyClub_MyFavoriteFaceCall';
  /** [NOT NULL] CreatedTime */
  createdTime?: Maybe<Scalars['DateTime']['output']>;
  /** [NAVIGATION] FaceCallSong */
  faceCallSong?: Maybe<Club_WorldFamilyClub_FaceCallSong>;
  /** [NOT NULL] FaceCallSongId */
  faceCallSongId?: Maybe<Scalars['Int']['output']>;
  /** [NAVIGATION] FaceCallSongPublic */
  faceCallSongPublic?: Maybe<Club_WorldFamilyClub_FaceCallSongPublic>;
  /** [NOT NULL] FaceCallSongPublicId */
  faceCallSongPublicId?: Maybe<Scalars['Int']['output']>;
  /** [ID] MyFavoriteFaceCallId */
  id: Scalars['ID']['output'];
  /** [NOT NULL] MemberNumber */
  memberNumber?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_MyFavoriteFaceCallConnection = {
  __typename?: 'Club_WorldFamilyClub_MyFavoriteFaceCallConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_MyFavoriteFaceCallEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_MyFavoriteFaceCall>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_MyFavoriteFaceCallEdge = {
  __typename?: 'Club_WorldFamilyClub_MyFavoriteFaceCallEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_MyFavoriteFaceCall;
};

/** MyFavoriteFaceCall */
export type Club_WorldFamilyClub_MyFavoriteFaceCallFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_MyFavoriteFaceCallFilterInput>>;
  /** [NOT NULL] CreatedTime */
  createdTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** [NAVIGATION] FaceCallSong */
  faceCallSong?: InputMaybe<Club_WorldFamilyClub_FaceCallSongFilterInput>;
  /** [NOT NULL] FaceCallSongId */
  faceCallSongId?: InputMaybe<IntOperationFilterInput>;
  /** [NAVIGATION] FaceCallSongPublic */
  faceCallSongPublic?: InputMaybe<Club_WorldFamilyClub_FaceCallSongPublicFilterInput>;
  /** [NOT NULL] FaceCallSongPublicId */
  faceCallSongPublicId?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] MemberNumber */
  memberNumber?: InputMaybe<StringOperationFilterInput>;
  /** [ID] MyFavoriteFaceCallId */
  myFavoriteFaceCallId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_MyFavoriteFaceCallFilterInput>>;
};

/** MyFavoriteFaceCall */
export type Club_WorldFamilyClub_MyFavoriteFaceCallInput = {
  /** [NOT NULL] CreatedTime */
  createdTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** [NAVIGATION] FaceCallSong */
  faceCallSong?: InputMaybe<Club_WorldFamilyClub_FaceCallSongInput>;
  /** [NOT NULL] FaceCallSongId */
  faceCallSongId?: InputMaybe<Scalars['Int']['input']>;
  /** [NAVIGATION] FaceCallSongPublic */
  faceCallSongPublic?: InputMaybe<Club_WorldFamilyClub_FaceCallSongPublicInput>;
  /** [NOT NULL] FaceCallSongPublicId */
  faceCallSongPublicId?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] MemberNumber */
  memberNumber?: InputMaybe<Scalars['String']['input']>;
  /** [ID] MyFavoriteFaceCallId */
  myFavoriteFaceCallId?: InputMaybe<Scalars['Long']['input']>;
};

/** MyFavoriteFaceCallSong */
export type Club_WorldFamilyClub_MyFavoriteFaceCallSong = Node & {
  __typename?: 'Club_WorldFamilyClub_MyFavoriteFaceCallSong';
  /** [NOT NULL] CreatedTime */
  createdTime?: Maybe<Scalars['DateTime']['output']>;
  /** [ID] MyFavoriteFaceCallSongId */
  id: Scalars['ID']['output'];
  /** [NOT NULL] MemberNumber */
  memberNumber?: Maybe<Scalars['String']['output']>;
  /** [NAVIGATION] TeSong */
  teSong?: Maybe<Club_WorldFamilyClub_TeSong>;
  /** [NOT NULL] TeSongId */
  teSongId?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_MyFavoriteFaceCallSongConnection = {
  __typename?: 'Club_WorldFamilyClub_MyFavoriteFaceCallSongConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_MyFavoriteFaceCallSongEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_MyFavoriteFaceCallSong>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_MyFavoriteFaceCallSongEdge = {
  __typename?: 'Club_WorldFamilyClub_MyFavoriteFaceCallSongEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_MyFavoriteFaceCallSong;
};

/** MyFavoriteFaceCallSong */
export type Club_WorldFamilyClub_MyFavoriteFaceCallSongFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_MyFavoriteFaceCallSongFilterInput>>;
  /** [NOT NULL] CreatedTime */
  createdTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** [NOT NULL] MemberNumber */
  memberNumber?: InputMaybe<StringOperationFilterInput>;
  /** [ID] MyFavoriteFaceCallSongId */
  myFavoriteFaceCallSongId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_MyFavoriteFaceCallSongFilterInput>>;
  /** [NAVIGATION] TeSong */
  teSong?: InputMaybe<Club_WorldFamilyClub_TeSongFilterInput>;
  /** [NOT NULL] TeSongId */
  teSongId?: InputMaybe<IntOperationFilterInput>;
};

/** MyFavoriteFaceCallSong */
export type Club_WorldFamilyClub_MyFavoriteFaceCallSongInput = {
  /** [NOT NULL] CreatedTime */
  createdTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** [NOT NULL] MemberNumber */
  memberNumber?: InputMaybe<Scalars['String']['input']>;
  /** [ID] MyFavoriteFaceCallSongId */
  myFavoriteFaceCallSongId?: InputMaybe<Scalars['Long']['input']>;
  /** [NAVIGATION] TeSong */
  teSong?: InputMaybe<Club_WorldFamilyClub_TeSongInput>;
  /** [NOT NULL] TeSongId */
  teSongId?: InputMaybe<Scalars['Int']['input']>;
};

/** MyFavoriteFaceCallSong */
export type Club_WorldFamilyClub_MyFavoriteFaceCallSongSortInput = {
  /** [NOT NULL] CreatedTime */
  createdTime?: InputMaybe<SortEnumType>;
  /** [NOT NULL] MemberNumber */
  memberNumber?: InputMaybe<SortEnumType>;
  /** [ID] MyFavoriteFaceCallSongId */
  myFavoriteFaceCallSongId?: InputMaybe<SortEnumType>;
  /** [NAVIGATION] TeSong */
  teSong?: InputMaybe<Club_WorldFamilyClub_TeSongSortInput>;
  /** [NOT NULL] TeSongId */
  teSongId?: InputMaybe<SortEnumType>;
};

/** MyFavoriteFaceCall */
export type Club_WorldFamilyClub_MyFavoriteFaceCallSortInput = {
  /** [NOT NULL] CreatedTime */
  createdTime?: InputMaybe<SortEnumType>;
  /** [NAVIGATION] FaceCallSong */
  faceCallSong?: InputMaybe<Club_WorldFamilyClub_FaceCallSongSortInput>;
  /** [NOT NULL] FaceCallSongId */
  faceCallSongId?: InputMaybe<SortEnumType>;
  /** [NAVIGATION] FaceCallSongPublic */
  faceCallSongPublic?: InputMaybe<Club_WorldFamilyClub_FaceCallSongPublicSortInput>;
  /** [NOT NULL] FaceCallSongPublicId */
  faceCallSongPublicId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] MemberNumber */
  memberNumber?: InputMaybe<SortEnumType>;
  /** [ID] MyFavoriteFaceCallId */
  myFavoriteFaceCallId?: InputMaybe<SortEnumType>;
};

/** Notification */
export type Club_WorldFamilyClub_Notification = Node & {
  __typename?: 'Club_WorldFamilyClub_Notification';
  /** ConditionNo */
  conditionNo?: Maybe<Scalars['String']['output']>;
  /** CreateTimeUtc */
  createTimeUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Creater */
  creater?: Maybe<Scalars['String']['output']>;
  /** Editor */
  editor?: Maybe<Scalars['String']['output']>;
  /** [ID] Seq */
  id: Scalars['ID']['output'];
  /** ImageName */
  imageName?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] IsSmsonly */
  isSmsonly?: Maybe<Scalars['Boolean']['output']>;
  /** KindNo */
  kindNo?: Maybe<Scalars['String']['output']>;
  /** LinkApp */
  linkApp?: Maybe<Scalars['String']['output']>;
  /** LinkWebUrl */
  linkWebUrl?: Maybe<Scalars['String']['output']>;
  /** Message */
  message?: Maybe<Scalars['String']['output']>;
  /** RecipientNo */
  recipientNo?: Maybe<Scalars['String']['output']>;
  /** Region */
  region?: Maybe<Scalars['String']['output']>;
  /** ScheduleTimeLocal */
  scheduleTimeLocal?: Maybe<Scalars['DateTime']['output']>;
  /** SentDateLocal */
  sentDateLocal?: Maybe<Scalars['DateTime']['output']>;
  /** Subject */
  subject?: Maybe<Scalars['String']['output']>;
  /** TypeNo */
  typeNo?: Maybe<Scalars['String']['output']>;
  /** UpdateTimeUtc */
  updateTimeUtc?: Maybe<Scalars['DateTime']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_NotificationConnection = {
  __typename?: 'Club_WorldFamilyClub_NotificationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_NotificationEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_Notification>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_NotificationEdge = {
  __typename?: 'Club_WorldFamilyClub_NotificationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_Notification;
};

/** Notification */
export type Club_WorldFamilyClub_NotificationFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_NotificationFilterInput>>;
  /** ConditionNo */
  conditionNo?: InputMaybe<StringOperationFilterInput>;
  /** CreateTimeUtc */
  createTimeUtc?: InputMaybe<DateTimeOperationFilterInput>;
  /** Creater */
  creater?: InputMaybe<StringOperationFilterInput>;
  /** Editor */
  editor?: InputMaybe<StringOperationFilterInput>;
  /** ImageName */
  imageName?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] IsSmsonly */
  isSmsonly?: InputMaybe<BooleanOperationFilterInput>;
  /** KindNo */
  kindNo?: InputMaybe<StringOperationFilterInput>;
  /** LinkApp */
  linkApp?: InputMaybe<StringOperationFilterInput>;
  /** LinkWebUrl */
  linkWebUrl?: InputMaybe<StringOperationFilterInput>;
  /** Message */
  message?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_NotificationFilterInput>>;
  /** RecipientNo */
  recipientNo?: InputMaybe<StringOperationFilterInput>;
  /** Region */
  region?: InputMaybe<StringOperationFilterInput>;
  /** ScheduleTimeLocal */
  scheduleTimeLocal?: InputMaybe<DateTimeOperationFilterInput>;
  /** SentDateLocal */
  sentDateLocal?: InputMaybe<DateTimeOperationFilterInput>;
  /** [ID] Seq */
  seq?: InputMaybe<IntOperationFilterInput>;
  /** Subject */
  subject?: InputMaybe<StringOperationFilterInput>;
  /** TypeNo */
  typeNo?: InputMaybe<StringOperationFilterInput>;
  /** UpdateTimeUtc */
  updateTimeUtc?: InputMaybe<DateTimeOperationFilterInput>;
};

/** NotificationIcon */
export type Club_WorldFamilyClub_NotificationIcon = Node & {
  __typename?: 'Club_WorldFamilyClub_NotificationIcon';
  /** IconKey */
  iconKey?: Maybe<Scalars['String']['output']>;
  /** [ID] NotificationIconId */
  id: Scalars['ID']['output'];
  /** Market */
  market?: Maybe<Scalars['String']['output']>;
  /** TagEnglishName */
  tagEnglishName?: Maybe<Scalars['String']['output']>;
  /** TagName */
  tagName?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_NotificationIconConnection = {
  __typename?: 'Club_WorldFamilyClub_NotificationIconConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_NotificationIconEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_NotificationIcon>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_NotificationIconEdge = {
  __typename?: 'Club_WorldFamilyClub_NotificationIconEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_NotificationIcon;
};

/** NotificationIcon */
export type Club_WorldFamilyClub_NotificationIconFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_NotificationIconFilterInput>>;
  /** IconKey */
  iconKey?: InputMaybe<StringOperationFilterInput>;
  /** Market */
  market?: InputMaybe<StringOperationFilterInput>;
  /** [ID] NotificationIconId */
  notificationIconId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_NotificationIconFilterInput>>;
  /** TagEnglishName */
  tagEnglishName?: InputMaybe<StringOperationFilterInput>;
  /** TagName */
  tagName?: InputMaybe<StringOperationFilterInput>;
};

/** NotificationIcon */
export type Club_WorldFamilyClub_NotificationIconInput = {
  /** IconKey */
  iconKey?: InputMaybe<Scalars['String']['input']>;
  /** Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** [ID] NotificationIconId */
  notificationIconId?: InputMaybe<Scalars['Int']['input']>;
  /** TagEnglishName */
  tagEnglishName?: InputMaybe<Scalars['String']['input']>;
  /** TagName */
  tagName?: InputMaybe<Scalars['String']['input']>;
};

/** NotificationIcon */
export type Club_WorldFamilyClub_NotificationIconSortInput = {
  /** IconKey */
  iconKey?: InputMaybe<SortEnumType>;
  /** Market */
  market?: InputMaybe<SortEnumType>;
  /** [ID] NotificationIconId */
  notificationIconId?: InputMaybe<SortEnumType>;
  /** TagEnglishName */
  tagEnglishName?: InputMaybe<SortEnumType>;
  /** TagName */
  tagName?: InputMaybe<SortEnumType>;
};

/** Notification */
export type Club_WorldFamilyClub_NotificationInput = {
  /** ConditionNo */
  conditionNo?: InputMaybe<Scalars['String']['input']>;
  /** CreateTimeUtc */
  createTimeUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** Creater */
  creater?: InputMaybe<Scalars['String']['input']>;
  /** Editor */
  editor?: InputMaybe<Scalars['String']['input']>;
  /** ImageName */
  imageName?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] IsSmsonly */
  isSmsonly?: InputMaybe<Scalars['Boolean']['input']>;
  /** KindNo */
  kindNo?: InputMaybe<Scalars['String']['input']>;
  /** LinkApp */
  linkApp?: InputMaybe<Scalars['String']['input']>;
  /** LinkWebUrl */
  linkWebUrl?: InputMaybe<Scalars['String']['input']>;
  /** Message */
  message?: InputMaybe<Scalars['String']['input']>;
  /** RecipientNo */
  recipientNo?: InputMaybe<Scalars['String']['input']>;
  /** Region */
  region?: InputMaybe<Scalars['String']['input']>;
  /** ScheduleTimeLocal */
  scheduleTimeLocal?: InputMaybe<Scalars['DateTime']['input']>;
  /** SentDateLocal */
  sentDateLocal?: InputMaybe<Scalars['DateTime']['input']>;
  /** [ID] Seq */
  seq?: InputMaybe<Scalars['Int']['input']>;
  /** Subject */
  subject?: InputMaybe<Scalars['String']['input']>;
  /** TypeNo */
  typeNo?: InputMaybe<Scalars['String']['input']>;
  /** UpdateTimeUtc */
  updateTimeUtc?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Notification */
export type Club_WorldFamilyClub_NotificationSortInput = {
  /** ConditionNo */
  conditionNo?: InputMaybe<SortEnumType>;
  /** CreateTimeUtc */
  createTimeUtc?: InputMaybe<SortEnumType>;
  /** Creater */
  creater?: InputMaybe<SortEnumType>;
  /** Editor */
  editor?: InputMaybe<SortEnumType>;
  /** ImageName */
  imageName?: InputMaybe<SortEnumType>;
  /** [NOT NULL] IsSmsonly */
  isSmsonly?: InputMaybe<SortEnumType>;
  /** KindNo */
  kindNo?: InputMaybe<SortEnumType>;
  /** LinkApp */
  linkApp?: InputMaybe<SortEnumType>;
  /** LinkWebUrl */
  linkWebUrl?: InputMaybe<SortEnumType>;
  /** Message */
  message?: InputMaybe<SortEnumType>;
  /** RecipientNo */
  recipientNo?: InputMaybe<SortEnumType>;
  /** Region */
  region?: InputMaybe<SortEnumType>;
  /** ScheduleTimeLocal */
  scheduleTimeLocal?: InputMaybe<SortEnumType>;
  /** SentDateLocal */
  sentDateLocal?: InputMaybe<SortEnumType>;
  /** [ID] Seq */
  seq?: InputMaybe<SortEnumType>;
  /** Subject */
  subject?: InputMaybe<SortEnumType>;
  /** TypeNo */
  typeNo?: InputMaybe<SortEnumType>;
  /** UpdateTimeUtc */
  updateTimeUtc?: InputMaybe<SortEnumType>;
};

/** OneTimeToken */
export type Club_WorldFamilyClub_OneTimeToken = Node & {
  __typename?: 'Club_WorldFamilyClub_OneTimeToken';
  /** CreateTime */
  createTime?: Maybe<Scalars['DateTime']['output']>;
  /** [NOT NULL] DeviceId */
  deviceId?: Maybe<Scalars['String']['output']>;
  /** [ID] Token */
  id: Scalars['ID']['output'];
  /** [NOT NULL] MemberNo */
  memberNo?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Seq */
  seq?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_OneTimeTokenConnection = {
  __typename?: 'Club_WorldFamilyClub_OneTimeTokenConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_OneTimeTokenEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_OneTimeToken>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_OneTimeTokenEdge = {
  __typename?: 'Club_WorldFamilyClub_OneTimeTokenEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_OneTimeToken;
};

/** OneTimeToken */
export type Club_WorldFamilyClub_OneTimeTokenFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_OneTimeTokenFilterInput>>;
  /** CreateTime */
  createTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** [NOT NULL] DeviceId */
  deviceId?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] MemberNo */
  memberNo?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_OneTimeTokenFilterInput>>;
  /** [NOT NULL] Seq */
  seq?: InputMaybe<IntOperationFilterInput>;
  /** [ID] Token */
  token?: InputMaybe<UuidOperationFilterInput>;
};

/** OneTimeToken */
export type Club_WorldFamilyClub_OneTimeTokenInput = {
  /** CreateTime */
  createTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** [NOT NULL] DeviceId */
  deviceId?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] MemberNo */
  memberNo?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Seq */
  seq?: InputMaybe<Scalars['Int']['input']>;
  /** [ID] Token */
  token?: InputMaybe<Scalars['UUID']['input']>;
};

/** OneTimeToken */
export type Club_WorldFamilyClub_OneTimeTokenSortInput = {
  /** CreateTime */
  createTime?: InputMaybe<SortEnumType>;
  /** [NOT NULL] DeviceId */
  deviceId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] MemberNo */
  memberNo?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Seq */
  seq?: InputMaybe<SortEnumType>;
  /** [ID] Token */
  token?: InputMaybe<SortEnumType>;
};

/** OnlineEventLog */
export type Club_WorldFamilyClub_OnlineEventLog = Node & {
  __typename?: 'Club_WorldFamilyClub_OnlineEventLog';
  /** Clicktime */
  clicktime?: Maybe<Scalars['DateTime']['output']>;
  /** [ID] Seq */
  id: Scalars['ID']['output'];
  /** Memno */
  memno?: Maybe<Scalars['String']['output']>;
  /** VideoSeq */
  videoSeq?: Maybe<Scalars['Short']['output']>;
  /** VideoType */
  videoType?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_OnlineEventLogConnection = {
  __typename?: 'Club_WorldFamilyClub_OnlineEventLogConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_OnlineEventLogEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_OnlineEventLog>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_OnlineEventLogEdge = {
  __typename?: 'Club_WorldFamilyClub_OnlineEventLogEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_OnlineEventLog;
};

/** OnlineEventLog */
export type Club_WorldFamilyClub_OnlineEventLogFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_OnlineEventLogFilterInput>>;
  /** Clicktime */
  clicktime?: InputMaybe<DateTimeOperationFilterInput>;
  /** Memno */
  memno?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_OnlineEventLogFilterInput>>;
  /** [ID] Seq */
  seq?: InputMaybe<IntOperationFilterInput>;
  /** VideoSeq */
  videoSeq?: InputMaybe<ShortOperationFilterInput>;
  /** VideoType */
  videoType?: InputMaybe<StringOperationFilterInput>;
};

/** OnlineEventLog */
export type Club_WorldFamilyClub_OnlineEventLogInput = {
  /** Clicktime */
  clicktime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Memno */
  memno?: InputMaybe<Scalars['String']['input']>;
  /** [ID] Seq */
  seq?: InputMaybe<Scalars['Int']['input']>;
  /** VideoSeq */
  videoSeq?: InputMaybe<Scalars['Short']['input']>;
  /** VideoType */
  videoType?: InputMaybe<Scalars['String']['input']>;
};

/** OnlineEventLog */
export type Club_WorldFamilyClub_OnlineEventLogSortInput = {
  /** Clicktime */
  clicktime?: InputMaybe<SortEnumType>;
  /** Memno */
  memno?: InputMaybe<SortEnumType>;
  /** [ID] Seq */
  seq?: InputMaybe<SortEnumType>;
  /** VideoSeq */
  videoSeq?: InputMaybe<SortEnumType>;
  /** VideoType */
  videoType?: InputMaybe<SortEnumType>;
};

/** OnlineShow */
export type Club_WorldFamilyClub_OnlineShow = Node & {
  __typename?: 'Club_WorldFamilyClub_OnlineShow';
  /** Category */
  category?: Maybe<Scalars['String']['output']>;
  /** Cdt */
  cdt?: Maybe<Scalars['DateTime']['output']>;
  /** [ID] Seq */
  id: Scalars['ID']['output'];
  /** [NOT NULL] Library */
  library?: Maybe<Scalars['String']['output']>;
  /** Opendate */
  opendate?: Maybe<Scalars['String']['output']>;
  /** PicName */
  picName?: Maybe<Scalars['String']['output']>;
  /** PushMsg */
  pushMsg?: Maybe<Scalars['String']['output']>;
  /** SmsMsg */
  smsMsg?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Sort */
  sort?: Maybe<Scalars['Int']['output']>;
  /** [NOT NULL] Status */
  status?: Maybe<Scalars['Int']['output']>;
  /** TitleEn */
  titleEn?: Maybe<Scalars['String']['output']>;
  /** TitleJp */
  titleJp?: Maybe<Scalars['String']['output']>;
  /** TitleTw */
  titleTw?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] TypeId */
  typeId?: Maybe<Scalars['String']['output']>;
  /** Url */
  url?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_OnlineShowConnection = {
  __typename?: 'Club_WorldFamilyClub_OnlineShowConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_OnlineShowEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_OnlineShow>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_OnlineShowEdge = {
  __typename?: 'Club_WorldFamilyClub_OnlineShowEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_OnlineShow;
};

/** OnlineShow */
export type Club_WorldFamilyClub_OnlineShowFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_OnlineShowFilterInput>>;
  /** Category */
  category?: InputMaybe<StringOperationFilterInput>;
  /** Cdt */
  cdt?: InputMaybe<DateTimeOperationFilterInput>;
  /** [NOT NULL] Library */
  library?: InputMaybe<StringOperationFilterInput>;
  /** Opendate */
  opendate?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_OnlineShowFilterInput>>;
  /** PicName */
  picName?: InputMaybe<StringOperationFilterInput>;
  /** PushMsg */
  pushMsg?: InputMaybe<StringOperationFilterInput>;
  /** [ID] Seq */
  seq?: InputMaybe<IntOperationFilterInput>;
  /** SmsMsg */
  smsMsg?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] Sort */
  sort?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] Status */
  status?: InputMaybe<IntOperationFilterInput>;
  /** TitleEn */
  titleEn?: InputMaybe<StringOperationFilterInput>;
  /** TitleJp */
  titleJp?: InputMaybe<StringOperationFilterInput>;
  /** TitleTw */
  titleTw?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] TypeId */
  typeId?: InputMaybe<StringOperationFilterInput>;
  /** Url */
  url?: InputMaybe<StringOperationFilterInput>;
};

/** OnlineShow */
export type Club_WorldFamilyClub_OnlineShowInput = {
  /** Category */
  category?: InputMaybe<Scalars['String']['input']>;
  /** Cdt */
  cdt?: InputMaybe<Scalars['DateTime']['input']>;
  /** [NOT NULL] Library */
  library?: InputMaybe<Scalars['String']['input']>;
  /** Opendate */
  opendate?: InputMaybe<Scalars['String']['input']>;
  /** PicName */
  picName?: InputMaybe<Scalars['String']['input']>;
  /** PushMsg */
  pushMsg?: InputMaybe<Scalars['String']['input']>;
  /** [ID] Seq */
  seq?: InputMaybe<Scalars['Int']['input']>;
  /** SmsMsg */
  smsMsg?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Sort */
  sort?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] Status */
  status?: InputMaybe<Scalars['Int']['input']>;
  /** TitleEn */
  titleEn?: InputMaybe<Scalars['String']['input']>;
  /** TitleJp */
  titleJp?: InputMaybe<Scalars['String']['input']>;
  /** TitleTw */
  titleTw?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] TypeId */
  typeId?: InputMaybe<Scalars['String']['input']>;
  /** Url */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** OnlineShow */
export type Club_WorldFamilyClub_OnlineShowSortInput = {
  /** Category */
  category?: InputMaybe<SortEnumType>;
  /** Cdt */
  cdt?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Library */
  library?: InputMaybe<SortEnumType>;
  /** Opendate */
  opendate?: InputMaybe<SortEnumType>;
  /** PicName */
  picName?: InputMaybe<SortEnumType>;
  /** PushMsg */
  pushMsg?: InputMaybe<SortEnumType>;
  /** [ID] Seq */
  seq?: InputMaybe<SortEnumType>;
  /** SmsMsg */
  smsMsg?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Sort */
  sort?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Status */
  status?: InputMaybe<SortEnumType>;
  /** TitleEn */
  titleEn?: InputMaybe<SortEnumType>;
  /** TitleJp */
  titleJp?: InputMaybe<SortEnumType>;
  /** TitleTw */
  titleTw?: InputMaybe<SortEnumType>;
  /** [NOT NULL] TypeId */
  typeId?: InputMaybe<SortEnumType>;
  /** Url */
  url?: InputMaybe<SortEnumType>;
};

/** Parameter */
export type Club_WorldFamilyClub_Parameter = Node & {
  __typename?: 'Club_WorldFamilyClub_Parameter';
  /** [ID] ParmGroup */
  id: Scalars['ID']['output'];
  /** ParmDescription */
  parmDescription?: Maybe<Scalars['String']['output']>;
  /** ParmId */
  parmId?: Maybe<Scalars['String']['output']>;
  /** ParmSort */
  parmSort?: Maybe<Scalars['String']['output']>;
  /** ParmValue */
  parmValue?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_ParameterConnection = {
  __typename?: 'Club_WorldFamilyClub_ParameterConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_ParameterEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_Parameter>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_ParameterEdge = {
  __typename?: 'Club_WorldFamilyClub_ParameterEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_Parameter;
};

/** Parameter */
export type Club_WorldFamilyClub_ParameterFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_ParameterFilterInput>>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_ParameterFilterInput>>;
  /** ParmDescription */
  parmDescription?: InputMaybe<StringOperationFilterInput>;
  /** [ID] ParmGroup */
  parmGroup?: InputMaybe<StringOperationFilterInput>;
  /** ParmId */
  parmId?: InputMaybe<StringOperationFilterInput>;
  /** ParmSort */
  parmSort?: InputMaybe<StringOperationFilterInput>;
  /** ParmValue */
  parmValue?: InputMaybe<StringOperationFilterInput>;
};

/** Parameter */
export type Club_WorldFamilyClub_ParameterInput = {
  /** ParmDescription */
  parmDescription?: InputMaybe<Scalars['String']['input']>;
  /** [ID] ParmGroup */
  parmGroup?: InputMaybe<Scalars['String']['input']>;
  /** ParmId */
  parmId?: InputMaybe<Scalars['String']['input']>;
  /** ParmSort */
  parmSort?: InputMaybe<Scalars['String']['input']>;
  /** ParmValue */
  parmValue?: InputMaybe<Scalars['String']['input']>;
};

/** Parameter */
export type Club_WorldFamilyClub_ParameterSortInput = {
  /** ParmDescription */
  parmDescription?: InputMaybe<SortEnumType>;
  /** [ID] ParmGroup */
  parmGroup?: InputMaybe<SortEnumType>;
  /** ParmId */
  parmId?: InputMaybe<SortEnumType>;
  /** ParmSort */
  parmSort?: InputMaybe<SortEnumType>;
  /** ParmValue */
  parmValue?: InputMaybe<SortEnumType>;
};

/** Product */
export type Club_WorldFamilyClub_Product = Node & {
  __typename?: 'Club_WorldFamilyClub_Product';
  /** CardCategory */
  cardCategory?: Maybe<Scalars['String']['output']>;
  /** HasDiscVersion */
  hasDiscVersion?: Maybe<Scalars['Boolean']['output']>;
  /** HasEtabVersion */
  hasEtabVersion?: Maybe<Scalars['Boolean']['output']>;
  /** [ID] ProductId */
  id: Scalars['ID']['output'];
  /** IsActive */
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /** IsExchangeable */
  isExchangeable?: Maybe<Scalars['Boolean']['output']>;
  /** ProductDisplayCode */
  productDisplayCode?: Maybe<Scalars['String']['output']>;
  /** ProductName */
  productName?: Maybe<Scalars['String']['output']>;
  /** ProductThumbnail */
  productThumbnail?: Maybe<Scalars['String']['output']>;
  /** ProductTypeCode */
  productTypeCode?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] SortOrder */
  sortOrder?: Maybe<Scalars['Int']['output']>;
  /** SubCategoryId */
  subCategoryId?: Maybe<Scalars['String']['output']>;
};

/** ProductCategory */
export type Club_WorldFamilyClub_ProductCategory = Node & {
  __typename?: 'Club_WorldFamilyClub_ProductCategory';
  /** CategoryName */
  categoryName?: Maybe<Scalars['String']['output']>;
  /** CategoryThumbnail */
  categoryThumbnail?: Maybe<Scalars['String']['output']>;
  /** HasDiscVersion */
  hasDiscVersion?: Maybe<Scalars['Boolean']['output']>;
  /** HasEtabVersion */
  hasEtabVersion?: Maybe<Scalars['Boolean']['output']>;
  /** [ID] CategoryId */
  id: Scalars['ID']['output'];
  /** IsActive */
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /** PackageNo */
  packageNo?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] SortOrder */
  sortOrder?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_ProductCategoryConnection = {
  __typename?: 'Club_WorldFamilyClub_ProductCategoryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_ProductCategoryEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_ProductCategory>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_ProductCategoryEdge = {
  __typename?: 'Club_WorldFamilyClub_ProductCategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_ProductCategory;
};

/** ProductCategory */
export type Club_WorldFamilyClub_ProductCategoryFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_ProductCategoryFilterInput>>;
  /** [ID] CategoryId */
  categoryId?: InputMaybe<StringOperationFilterInput>;
  /** CategoryName */
  categoryName?: InputMaybe<StringOperationFilterInput>;
  /** CategoryThumbnail */
  categoryThumbnail?: InputMaybe<StringOperationFilterInput>;
  /** HasDiscVersion */
  hasDiscVersion?: InputMaybe<BooleanOperationFilterInput>;
  /** HasEtabVersion */
  hasEtabVersion?: InputMaybe<BooleanOperationFilterInput>;
  /** IsActive */
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_ProductCategoryFilterInput>>;
  /** PackageNo */
  packageNo?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] SortOrder */
  sortOrder?: InputMaybe<IntOperationFilterInput>;
};

/** ProductCategory */
export type Club_WorldFamilyClub_ProductCategoryInput = {
  /** [ID] CategoryId */
  categoryId?: InputMaybe<Scalars['String']['input']>;
  /** CategoryName */
  categoryName?: InputMaybe<Scalars['String']['input']>;
  /** CategoryThumbnail */
  categoryThumbnail?: InputMaybe<Scalars['String']['input']>;
  /** HasDiscVersion */
  hasDiscVersion?: InputMaybe<Scalars['Boolean']['input']>;
  /** HasEtabVersion */
  hasEtabVersion?: InputMaybe<Scalars['Boolean']['input']>;
  /** IsActive */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** PackageNo */
  packageNo?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] SortOrder */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/** ProductCategory */
export type Club_WorldFamilyClub_ProductCategorySortInput = {
  /** [ID] CategoryId */
  categoryId?: InputMaybe<SortEnumType>;
  /** CategoryName */
  categoryName?: InputMaybe<SortEnumType>;
  /** CategoryThumbnail */
  categoryThumbnail?: InputMaybe<SortEnumType>;
  /** HasDiscVersion */
  hasDiscVersion?: InputMaybe<SortEnumType>;
  /** HasEtabVersion */
  hasEtabVersion?: InputMaybe<SortEnumType>;
  /** IsActive */
  isActive?: InputMaybe<SortEnumType>;
  /** PackageNo */
  packageNo?: InputMaybe<SortEnumType>;
  /** [NOT NULL] SortOrder */
  sortOrder?: InputMaybe<SortEnumType>;
};

/** ProductCategoryTranslation */
export type Club_WorldFamilyClub_ProductCategoryTranslation = Node & {
  __typename?: 'Club_WorldFamilyClub_ProductCategoryTranslation';
  /** [NOT NULL] CategoryId */
  categoryId?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] CategoryName */
  categoryName?: Maybe<Scalars['String']['output']>;
  /** [ID] CategoryTranslationId */
  id: Scalars['ID']['output'];
  /** [NOT NULL] Market */
  market?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_ProductCategoryTranslationConnection = {
  __typename?: 'Club_WorldFamilyClub_ProductCategoryTranslationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_ProductCategoryTranslationEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_ProductCategoryTranslation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_ProductCategoryTranslationEdge = {
  __typename?: 'Club_WorldFamilyClub_ProductCategoryTranslationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_ProductCategoryTranslation;
};

/** ProductCategoryTranslation */
export type Club_WorldFamilyClub_ProductCategoryTranslationFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_ProductCategoryTranslationFilterInput>>;
  /** [NOT NULL] CategoryId */
  categoryId?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] CategoryName */
  categoryName?: InputMaybe<StringOperationFilterInput>;
  /** [ID] CategoryTranslationId */
  categoryTranslationId?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] Market */
  market?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_ProductCategoryTranslationFilterInput>>;
};

/** ProductCategoryTranslation */
export type Club_WorldFamilyClub_ProductCategoryTranslationInput = {
  /** [NOT NULL] CategoryId */
  categoryId?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] CategoryName */
  categoryName?: InputMaybe<Scalars['String']['input']>;
  /** [ID] CategoryTranslationId */
  categoryTranslationId?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] Market */
  market?: InputMaybe<Scalars['String']['input']>;
};

/** ProductCategoryTranslation */
export type Club_WorldFamilyClub_ProductCategoryTranslationSortInput = {
  /** [NOT NULL] CategoryId */
  categoryId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] CategoryName */
  categoryName?: InputMaybe<SortEnumType>;
  /** [ID] CategoryTranslationId */
  categoryTranslationId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Market */
  market?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_ProductConnection = {
  __typename?: 'Club_WorldFamilyClub_ProductConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_ProductEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_Product>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_ProductEdge = {
  __typename?: 'Club_WorldFamilyClub_ProductEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_Product;
};

/** Product */
export type Club_WorldFamilyClub_ProductFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_ProductFilterInput>>;
  /** CardCategory */
  cardCategory?: InputMaybe<StringOperationFilterInput>;
  /** HasDiscVersion */
  hasDiscVersion?: InputMaybe<BooleanOperationFilterInput>;
  /** HasEtabVersion */
  hasEtabVersion?: InputMaybe<BooleanOperationFilterInput>;
  /** IsActive */
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  /** IsExchangeable */
  isExchangeable?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_ProductFilterInput>>;
  /** ProductDisplayCode */
  productDisplayCode?: InputMaybe<StringOperationFilterInput>;
  /** [ID] ProductId */
  productId?: InputMaybe<StringOperationFilterInput>;
  /** ProductName */
  productName?: InputMaybe<StringOperationFilterInput>;
  /** ProductThumbnail */
  productThumbnail?: InputMaybe<StringOperationFilterInput>;
  /** ProductTypeCode */
  productTypeCode?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] SortOrder */
  sortOrder?: InputMaybe<IntOperationFilterInput>;
  /** SubCategoryId */
  subCategoryId?: InputMaybe<StringOperationFilterInput>;
};

/** Product */
export type Club_WorldFamilyClub_ProductInput = {
  /** CardCategory */
  cardCategory?: InputMaybe<Scalars['String']['input']>;
  /** HasDiscVersion */
  hasDiscVersion?: InputMaybe<Scalars['Boolean']['input']>;
  /** HasEtabVersion */
  hasEtabVersion?: InputMaybe<Scalars['Boolean']['input']>;
  /** IsActive */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** IsExchangeable */
  isExchangeable?: InputMaybe<Scalars['Boolean']['input']>;
  /** ProductDisplayCode */
  productDisplayCode?: InputMaybe<Scalars['String']['input']>;
  /** [ID] ProductId */
  productId?: InputMaybe<Scalars['String']['input']>;
  /** ProductName */
  productName?: InputMaybe<Scalars['String']['input']>;
  /** ProductThumbnail */
  productThumbnail?: InputMaybe<Scalars['String']['input']>;
  /** ProductTypeCode */
  productTypeCode?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] SortOrder */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  /** SubCategoryId */
  subCategoryId?: InputMaybe<Scalars['String']['input']>;
};

/** Product */
export type Club_WorldFamilyClub_ProductSortInput = {
  /** CardCategory */
  cardCategory?: InputMaybe<SortEnumType>;
  /** HasDiscVersion */
  hasDiscVersion?: InputMaybe<SortEnumType>;
  /** HasEtabVersion */
  hasEtabVersion?: InputMaybe<SortEnumType>;
  /** IsActive */
  isActive?: InputMaybe<SortEnumType>;
  /** IsExchangeable */
  isExchangeable?: InputMaybe<SortEnumType>;
  /** ProductDisplayCode */
  productDisplayCode?: InputMaybe<SortEnumType>;
  /** [ID] ProductId */
  productId?: InputMaybe<SortEnumType>;
  /** ProductName */
  productName?: InputMaybe<SortEnumType>;
  /** ProductThumbnail */
  productThumbnail?: InputMaybe<SortEnumType>;
  /** ProductTypeCode */
  productTypeCode?: InputMaybe<SortEnumType>;
  /** [NOT NULL] SortOrder */
  sortOrder?: InputMaybe<SortEnumType>;
  /** SubCategoryId */
  subCategoryId?: InputMaybe<SortEnumType>;
};

/** ProductSubCategory */
export type Club_WorldFamilyClub_ProductSubCategory = Node & {
  __typename?: 'Club_WorldFamilyClub_ProductSubCategory';
  /** CategoryId */
  categoryId?: Maybe<Scalars['String']['output']>;
  /** HasDiscVersion */
  hasDiscVersion?: Maybe<Scalars['Boolean']['output']>;
  /** HasEtabVersion */
  hasEtabVersion?: Maybe<Scalars['Boolean']['output']>;
  /** [NOT NULL] HasProductThumbnail */
  hasProductThumbnail?: Maybe<Scalars['Boolean']['output']>;
  /** [ID] SubCategoryId */
  id: Scalars['ID']['output'];
  /** IsActive */
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /** IsExchangeable */
  isExchangeable?: Maybe<Scalars['Boolean']['output']>;
  /** [NOT NULL] SortOrder */
  sortOrder?: Maybe<Scalars['Int']['output']>;
  /** SubCategoryName */
  subCategoryName?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_ProductSubCategoryConnection = {
  __typename?: 'Club_WorldFamilyClub_ProductSubCategoryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_ProductSubCategoryEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_ProductSubCategory>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_ProductSubCategoryEdge = {
  __typename?: 'Club_WorldFamilyClub_ProductSubCategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_ProductSubCategory;
};

/** ProductSubCategoryExchangeReason */
export type Club_WorldFamilyClub_ProductSubCategoryExchangeReason = Node & {
  __typename?: 'Club_WorldFamilyClub_ProductSubCategoryExchangeReason';
  /** [ID] SubCategoryId */
  id: Scalars['ID']['output'];
  /** [NOT NULL] ReasonId */
  reasonId?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_ProductSubCategoryExchangeReasonConnection = {
  __typename?: 'Club_WorldFamilyClub_ProductSubCategoryExchangeReasonConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_ProductSubCategoryExchangeReasonEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_ProductSubCategoryExchangeReason>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_ProductSubCategoryExchangeReasonEdge = {
  __typename?: 'Club_WorldFamilyClub_ProductSubCategoryExchangeReasonEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_ProductSubCategoryExchangeReason;
};

/** ProductSubCategoryExchangeReason */
export type Club_WorldFamilyClub_ProductSubCategoryExchangeReasonFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_ProductSubCategoryExchangeReasonFilterInput>>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_ProductSubCategoryExchangeReasonFilterInput>>;
  /** [NOT NULL] ReasonId */
  reasonId?: InputMaybe<StringOperationFilterInput>;
  /** [ID] SubCategoryId */
  subCategoryId?: InputMaybe<StringOperationFilterInput>;
};

/** ProductSubCategoryExchangeReason */
export type Club_WorldFamilyClub_ProductSubCategoryExchangeReasonInput = {
  /** [NOT NULL] ReasonId */
  reasonId?: InputMaybe<Scalars['String']['input']>;
  /** [ID] SubCategoryId */
  subCategoryId?: InputMaybe<Scalars['String']['input']>;
};

/** ProductSubCategoryExchangeReason */
export type Club_WorldFamilyClub_ProductSubCategoryExchangeReasonSortInput = {
  /** [NOT NULL] ReasonId */
  reasonId?: InputMaybe<SortEnumType>;
  /** [ID] SubCategoryId */
  subCategoryId?: InputMaybe<SortEnumType>;
};

/** ProductSubCategory */
export type Club_WorldFamilyClub_ProductSubCategoryFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_ProductSubCategoryFilterInput>>;
  /** CategoryId */
  categoryId?: InputMaybe<StringOperationFilterInput>;
  /** HasDiscVersion */
  hasDiscVersion?: InputMaybe<BooleanOperationFilterInput>;
  /** HasEtabVersion */
  hasEtabVersion?: InputMaybe<BooleanOperationFilterInput>;
  /** [NOT NULL] HasProductThumbnail */
  hasProductThumbnail?: InputMaybe<BooleanOperationFilterInput>;
  /** IsActive */
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  /** IsExchangeable */
  isExchangeable?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_ProductSubCategoryFilterInput>>;
  /** [NOT NULL] SortOrder */
  sortOrder?: InputMaybe<IntOperationFilterInput>;
  /** [ID] SubCategoryId */
  subCategoryId?: InputMaybe<StringOperationFilterInput>;
  /** SubCategoryName */
  subCategoryName?: InputMaybe<StringOperationFilterInput>;
};

/** ProductSubCategory */
export type Club_WorldFamilyClub_ProductSubCategoryInput = {
  /** CategoryId */
  categoryId?: InputMaybe<Scalars['String']['input']>;
  /** HasDiscVersion */
  hasDiscVersion?: InputMaybe<Scalars['Boolean']['input']>;
  /** HasEtabVersion */
  hasEtabVersion?: InputMaybe<Scalars['Boolean']['input']>;
  /** [NOT NULL] HasProductThumbnail */
  hasProductThumbnail?: InputMaybe<Scalars['Boolean']['input']>;
  /** IsActive */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** IsExchangeable */
  isExchangeable?: InputMaybe<Scalars['Boolean']['input']>;
  /** [NOT NULL] SortOrder */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  /** [ID] SubCategoryId */
  subCategoryId?: InputMaybe<Scalars['String']['input']>;
  /** SubCategoryName */
  subCategoryName?: InputMaybe<Scalars['String']['input']>;
};

/** ProductSubCategory */
export type Club_WorldFamilyClub_ProductSubCategorySortInput = {
  /** CategoryId */
  categoryId?: InputMaybe<SortEnumType>;
  /** HasDiscVersion */
  hasDiscVersion?: InputMaybe<SortEnumType>;
  /** HasEtabVersion */
  hasEtabVersion?: InputMaybe<SortEnumType>;
  /** [NOT NULL] HasProductThumbnail */
  hasProductThumbnail?: InputMaybe<SortEnumType>;
  /** IsActive */
  isActive?: InputMaybe<SortEnumType>;
  /** IsExchangeable */
  isExchangeable?: InputMaybe<SortEnumType>;
  /** [NOT NULL] SortOrder */
  sortOrder?: InputMaybe<SortEnumType>;
  /** [ID] SubCategoryId */
  subCategoryId?: InputMaybe<SortEnumType>;
  /** SubCategoryName */
  subCategoryName?: InputMaybe<SortEnumType>;
};

/** ProductSubCategoryTranslation */
export type Club_WorldFamilyClub_ProductSubCategoryTranslation = Node & {
  __typename?: 'Club_WorldFamilyClub_ProductSubCategoryTranslation';
  /** [ID] SubCategoryTranslationId */
  id: Scalars['ID']['output'];
  /** Market */
  market?: Maybe<Scalars['String']['output']>;
  /** SubCategoryId */
  subCategoryId?: Maybe<Scalars['String']['output']>;
  /** SubCategoryName */
  subCategoryName?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_ProductSubCategoryTranslationConnection = {
  __typename?: 'Club_WorldFamilyClub_ProductSubCategoryTranslationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_ProductSubCategoryTranslationEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_ProductSubCategoryTranslation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_ProductSubCategoryTranslationEdge = {
  __typename?: 'Club_WorldFamilyClub_ProductSubCategoryTranslationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_ProductSubCategoryTranslation;
};

/** ProductSubCategoryTranslation */
export type Club_WorldFamilyClub_ProductSubCategoryTranslationFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_ProductSubCategoryTranslationFilterInput>>;
  /** Market */
  market?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_ProductSubCategoryTranslationFilterInput>>;
  /** SubCategoryId */
  subCategoryId?: InputMaybe<StringOperationFilterInput>;
  /** SubCategoryName */
  subCategoryName?: InputMaybe<StringOperationFilterInput>;
  /** [ID] SubCategoryTranslationId */
  subCategoryTranslationId?: InputMaybe<IntOperationFilterInput>;
};

/** ProductSubCategoryTranslation */
export type Club_WorldFamilyClub_ProductSubCategoryTranslationInput = {
  /** Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** SubCategoryId */
  subCategoryId?: InputMaybe<Scalars['String']['input']>;
  /** SubCategoryName */
  subCategoryName?: InputMaybe<Scalars['String']['input']>;
  /** [ID] SubCategoryTranslationId */
  subCategoryTranslationId?: InputMaybe<Scalars['Int']['input']>;
};

/** ProductSubCategoryTranslation */
export type Club_WorldFamilyClub_ProductSubCategoryTranslationSortInput = {
  /** Market */
  market?: InputMaybe<SortEnumType>;
  /** SubCategoryId */
  subCategoryId?: InputMaybe<SortEnumType>;
  /** SubCategoryName */
  subCategoryName?: InputMaybe<SortEnumType>;
  /** [ID] SubCategoryTranslationId */
  subCategoryTranslationId?: InputMaybe<SortEnumType>;
};

/** ProductTranslation */
export type Club_WorldFamilyClub_ProductTranslation = Node & {
  __typename?: 'Club_WorldFamilyClub_ProductTranslation';
  /** [ID] ProductTranslationId */
  id: Scalars['ID']['output'];
  /** Market */
  market?: Maybe<Scalars['String']['output']>;
  /** ProductDisplayCode */
  productDisplayCode?: Maybe<Scalars['String']['output']>;
  /** ProductId */
  productId?: Maybe<Scalars['String']['output']>;
  /** ProductName */
  productName?: Maybe<Scalars['String']['output']>;
  /** Sku */
  sku?: Maybe<Scalars['String']['output']>;
  /** Zcode */
  zcode?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_ProductTranslationConnection = {
  __typename?: 'Club_WorldFamilyClub_ProductTranslationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_ProductTranslationEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_ProductTranslation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_ProductTranslationEdge = {
  __typename?: 'Club_WorldFamilyClub_ProductTranslationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_ProductTranslation;
};

/** ProductTranslation */
export type Club_WorldFamilyClub_ProductTranslationFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_ProductTranslationFilterInput>>;
  /** Market */
  market?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_ProductTranslationFilterInput>>;
  /** ProductDisplayCode */
  productDisplayCode?: InputMaybe<StringOperationFilterInput>;
  /** ProductId */
  productId?: InputMaybe<StringOperationFilterInput>;
  /** ProductName */
  productName?: InputMaybe<StringOperationFilterInput>;
  /** [ID] ProductTranslationId */
  productTranslationId?: InputMaybe<IntOperationFilterInput>;
  /** Sku */
  sku?: InputMaybe<StringOperationFilterInput>;
  /** Zcode */
  zcode?: InputMaybe<StringOperationFilterInput>;
};

/** ProductTranslation */
export type Club_WorldFamilyClub_ProductTranslationInput = {
  /** Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** ProductDisplayCode */
  productDisplayCode?: InputMaybe<Scalars['String']['input']>;
  /** ProductId */
  productId?: InputMaybe<Scalars['String']['input']>;
  /** ProductName */
  productName?: InputMaybe<Scalars['String']['input']>;
  /** [ID] ProductTranslationId */
  productTranslationId?: InputMaybe<Scalars['Int']['input']>;
  /** Sku */
  sku?: InputMaybe<Scalars['String']['input']>;
  /** Zcode */
  zcode?: InputMaybe<Scalars['String']['input']>;
};

/** ProductTranslation */
export type Club_WorldFamilyClub_ProductTranslationSortInput = {
  /** Market */
  market?: InputMaybe<SortEnumType>;
  /** ProductDisplayCode */
  productDisplayCode?: InputMaybe<SortEnumType>;
  /** ProductId */
  productId?: InputMaybe<SortEnumType>;
  /** ProductName */
  productName?: InputMaybe<SortEnumType>;
  /** [ID] ProductTranslationId */
  productTranslationId?: InputMaybe<SortEnumType>;
  /** Sku */
  sku?: InputMaybe<SortEnumType>;
  /** Zcode */
  zcode?: InputMaybe<SortEnumType>;
};

/** Products1 */
export type Club_WorldFamilyClub_Products1 = Node & {
  __typename?: 'Club_WorldFamilyClub_Products1';
  /** CategoryName */
  categoryName?: Maybe<Scalars['String']['output']>;
  /** Display */
  display?: Maybe<Scalars['String']['output']>;
  /** [ID] CategorySort1 */
  id: Scalars['ID']['output'];
  /** Image */
  image?: Maybe<Scalars['String']['output']>;
  /** PackageNo */
  packageNo?: Maybe<Scalars['String']['output']>;
  /** ProductName */
  productName?: Maybe<Scalars['String']['output']>;
  /** ProductSort3 */
  productSort3?: Maybe<Scalars['Float']['output']>;
  /** ProductTypeCode */
  productTypeCode?: Maybe<Scalars['String']['output']>;
  /** Sku */
  sku?: Maybe<Scalars['Float']['output']>;
  /** SubCategoryName */
  subCategoryName?: Maybe<Scalars['String']['output']>;
  /** SubCategorySort2 */
  subCategorySort2?: Maybe<Scalars['Float']['output']>;
  /** Zcode */
  zcode?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_Products1Connection = {
  __typename?: 'Club_WorldFamilyClub_Products1Connection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_Products1Edge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_Products1>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_Products1Edge = {
  __typename?: 'Club_WorldFamilyClub_Products1Edge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_Products1;
};

/** Products1 */
export type Club_WorldFamilyClub_Products1FilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_Products1FilterInput>>;
  /** CategoryName */
  categoryName?: InputMaybe<StringOperationFilterInput>;
  /** [ID] CategorySort1 */
  categorySort1?: InputMaybe<FloatOperationFilterInput>;
  /** Display */
  display?: InputMaybe<StringOperationFilterInput>;
  /** Image */
  image?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_Products1FilterInput>>;
  /** PackageNo */
  packageNo?: InputMaybe<StringOperationFilterInput>;
  /** ProductName */
  productName?: InputMaybe<StringOperationFilterInput>;
  /** ProductSort3 */
  productSort3?: InputMaybe<FloatOperationFilterInput>;
  /** ProductTypeCode */
  productTypeCode?: InputMaybe<StringOperationFilterInput>;
  /** Sku */
  sku?: InputMaybe<FloatOperationFilterInput>;
  /** SubCategoryName */
  subCategoryName?: InputMaybe<StringOperationFilterInput>;
  /** SubCategorySort2 */
  subCategorySort2?: InputMaybe<FloatOperationFilterInput>;
  /** Zcode */
  zcode?: InputMaybe<StringOperationFilterInput>;
};

/** Products1 */
export type Club_WorldFamilyClub_Products1Input = {
  /** CategoryName */
  categoryName?: InputMaybe<Scalars['String']['input']>;
  /** [ID] CategorySort1 */
  categorySort1: Scalars['Float']['input'];
  /** Display */
  display?: InputMaybe<Scalars['String']['input']>;
  /** Image */
  image?: InputMaybe<Scalars['String']['input']>;
  /** PackageNo */
  packageNo?: InputMaybe<Scalars['String']['input']>;
  /** ProductName */
  productName?: InputMaybe<Scalars['String']['input']>;
  /** ProductSort3 */
  productSort3?: InputMaybe<Scalars['Float']['input']>;
  /** ProductTypeCode */
  productTypeCode?: InputMaybe<Scalars['String']['input']>;
  /** Sku */
  sku?: InputMaybe<Scalars['Float']['input']>;
  /** SubCategoryName */
  subCategoryName?: InputMaybe<Scalars['String']['input']>;
  /** SubCategorySort2 */
  subCategorySort2?: InputMaybe<Scalars['Float']['input']>;
  /** Zcode */
  zcode?: InputMaybe<Scalars['String']['input']>;
};

/** Products1 */
export type Club_WorldFamilyClub_Products1SortInput = {
  /** CategoryName */
  categoryName?: InputMaybe<SortEnumType>;
  /** [ID] CategorySort1 */
  categorySort1?: InputMaybe<SortEnumType>;
  /** Display */
  display?: InputMaybe<SortEnumType>;
  /** Image */
  image?: InputMaybe<SortEnumType>;
  /** PackageNo */
  packageNo?: InputMaybe<SortEnumType>;
  /** ProductName */
  productName?: InputMaybe<SortEnumType>;
  /** ProductSort3 */
  productSort3?: InputMaybe<SortEnumType>;
  /** ProductTypeCode */
  productTypeCode?: InputMaybe<SortEnumType>;
  /** Sku */
  sku?: InputMaybe<SortEnumType>;
  /** SubCategoryName */
  subCategoryName?: InputMaybe<SortEnumType>;
  /** SubCategorySort2 */
  subCategorySort2?: InputMaybe<SortEnumType>;
  /** Zcode */
  zcode?: InputMaybe<SortEnumType>;
};

/** RegionBanner */
export type Club_WorldFamilyClub_RegionBanner = Node & {
  __typename?: 'Club_WorldFamilyClub_RegionBanner';
  /** [NOT NULL] BannerSeq */
  bannerSeq?: Maybe<Scalars['Short']['output']>;
  /** Cdt */
  cdt?: Maybe<Scalars['DateTime']['output']>;
  /** [ID] Region */
  id: Scalars['ID']['output'];
  /** Udt */
  udt?: Maybe<Scalars['DateTime']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_RegionBannerConnection = {
  __typename?: 'Club_WorldFamilyClub_RegionBannerConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_RegionBannerEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_RegionBanner>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_RegionBannerEdge = {
  __typename?: 'Club_WorldFamilyClub_RegionBannerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_RegionBanner;
};

/** RegionBanner */
export type Club_WorldFamilyClub_RegionBannerFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_RegionBannerFilterInput>>;
  /** [NOT NULL] BannerSeq */
  bannerSeq?: InputMaybe<ShortOperationFilterInput>;
  /** Cdt */
  cdt?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_RegionBannerFilterInput>>;
  /** [ID] Region */
  region?: InputMaybe<StringOperationFilterInput>;
  /** Udt */
  udt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** RegionBanner */
export type Club_WorldFamilyClub_RegionBannerInput = {
  /** [NOT NULL] BannerSeq */
  bannerSeq?: InputMaybe<Scalars['Short']['input']>;
  /** Cdt */
  cdt?: InputMaybe<Scalars['DateTime']['input']>;
  /** [ID] Region */
  region?: InputMaybe<Scalars['String']['input']>;
  /** Udt */
  udt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** RegionBanner */
export type Club_WorldFamilyClub_RegionBannerSortInput = {
  /** [NOT NULL] BannerSeq */
  bannerSeq?: InputMaybe<SortEnumType>;
  /** Cdt */
  cdt?: InputMaybe<SortEnumType>;
  /** [ID] Region */
  region?: InputMaybe<SortEnumType>;
  /** Udt */
  udt?: InputMaybe<SortEnumType>;
};

/** SearchKeyword */
export type Club_WorldFamilyClub_SearchKeyword = Node & {
  __typename?: 'Club_WorldFamilyClub_SearchKeyword';
  /** [ID] Seq */
  id: Scalars['ID']['output'];
  /** KeyWord */
  keyWord?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_SearchKeywordConnection = {
  __typename?: 'Club_WorldFamilyClub_SearchKeywordConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_SearchKeywordEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_SearchKeyword>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_SearchKeywordEdge = {
  __typename?: 'Club_WorldFamilyClub_SearchKeywordEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_SearchKeyword;
};

/** SearchKeyword */
export type Club_WorldFamilyClub_SearchKeywordFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_SearchKeywordFilterInput>>;
  /** KeyWord */
  keyWord?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_SearchKeywordFilterInput>>;
  /** [ID] Seq */
  seq?: InputMaybe<ShortOperationFilterInput>;
};

/** SearchKeyword */
export type Club_WorldFamilyClub_SearchKeywordInput = {
  /** KeyWord */
  keyWord?: InputMaybe<Scalars['String']['input']>;
  /** [ID] Seq */
  seq: Scalars['Short']['input'];
};

/** SearchKeyword */
export type Club_WorldFamilyClub_SearchKeywordSortInput = {
  /** KeyWord */
  keyWord?: InputMaybe<SortEnumType>;
  /** [ID] Seq */
  seq?: InputMaybe<SortEnumType>;
};

/** Service */
export type Club_WorldFamilyClub_Service = Node & {
  __typename?: 'Club_WorldFamilyClub_Service';
  /** [ID] ServiceType */
  id: Scalars['ID']['output'];
  /** ServiceName */
  serviceName?: Maybe<Scalars['String']['output']>;
};

/** ServiceBannerDefault */
export type Club_WorldFamilyClub_ServiceBannerDefault = Node & {
  __typename?: 'Club_WorldFamilyClub_ServiceBannerDefault';
  /** [ID] Seq */
  id: Scalars['ID']['output'];
  /** ImageFilename */
  imageFilename?: Maybe<Scalars['String']['output']>;
  /** Market */
  market?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] PublishTime */
  publishTime?: Maybe<Scalars['DateTime']['output']>;
  /** Service */
  service?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] StopTime */
  stopTime?: Maybe<Scalars['DateTime']['output']>;
  /** Theme */
  theme?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_ServiceBannerDefaultConnection = {
  __typename?: 'Club_WorldFamilyClub_ServiceBannerDefaultConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_ServiceBannerDefaultEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_ServiceBannerDefault>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_ServiceBannerDefaultEdge = {
  __typename?: 'Club_WorldFamilyClub_ServiceBannerDefaultEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_ServiceBannerDefault;
};

/** ServiceBannerDefault */
export type Club_WorldFamilyClub_ServiceBannerDefaultFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_ServiceBannerDefaultFilterInput>>;
  /** ImageFilename */
  imageFilename?: InputMaybe<StringOperationFilterInput>;
  /** Market */
  market?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_ServiceBannerDefaultFilterInput>>;
  /** [NOT NULL] PublishTime */
  publishTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** [ID] Seq */
  seq?: InputMaybe<IntOperationFilterInput>;
  /** Service */
  service?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] StopTime */
  stopTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** Theme */
  theme?: InputMaybe<StringOperationFilterInput>;
};

/** ServiceBannerDefault */
export type Club_WorldFamilyClub_ServiceBannerDefaultInput = {
  /** ImageFilename */
  imageFilename?: InputMaybe<Scalars['String']['input']>;
  /** Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] PublishTime */
  publishTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** [ID] Seq */
  seq?: InputMaybe<Scalars['Int']['input']>;
  /** Service */
  service?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] StopTime */
  stopTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Theme */
  theme?: InputMaybe<Scalars['String']['input']>;
};

/** ServiceBannerDefault */
export type Club_WorldFamilyClub_ServiceBannerDefaultSortInput = {
  /** ImageFilename */
  imageFilename?: InputMaybe<SortEnumType>;
  /** Market */
  market?: InputMaybe<SortEnumType>;
  /** [NOT NULL] PublishTime */
  publishTime?: InputMaybe<SortEnumType>;
  /** [ID] Seq */
  seq?: InputMaybe<SortEnumType>;
  /** Service */
  service?: InputMaybe<SortEnumType>;
  /** [NOT NULL] StopTime */
  stopTime?: InputMaybe<SortEnumType>;
  /** Theme */
  theme?: InputMaybe<SortEnumType>;
};

/** ServiceBannerScheduled */
export type Club_WorldFamilyClub_ServiceBannerScheduled = Node & {
  __typename?: 'Club_WorldFamilyClub_ServiceBannerScheduled';
  /** [ID] Seq */
  id: Scalars['ID']['output'];
  /** ImageFilename */
  imageFilename?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] IsHolidaySurpriseBanner */
  isHolidaySurpriseBanner?: Maybe<Scalars['Boolean']['output']>;
  /** Market */
  market?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] PublishTime */
  publishTime?: Maybe<Scalars['DateTime']['output']>;
  /** Service */
  service?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] StopTime */
  stopTime?: Maybe<Scalars['DateTime']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_ServiceBannerScheduledConnection = {
  __typename?: 'Club_WorldFamilyClub_ServiceBannerScheduledConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_ServiceBannerScheduledEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_ServiceBannerScheduled>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_ServiceBannerScheduledEdge = {
  __typename?: 'Club_WorldFamilyClub_ServiceBannerScheduledEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_ServiceBannerScheduled;
};

/** ServiceBannerScheduled */
export type Club_WorldFamilyClub_ServiceBannerScheduledFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_ServiceBannerScheduledFilterInput>>;
  /** ImageFilename */
  imageFilename?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] IsHolidaySurpriseBanner */
  isHolidaySurpriseBanner?: InputMaybe<BooleanOperationFilterInput>;
  /** Market */
  market?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_ServiceBannerScheduledFilterInput>>;
  /** [NOT NULL] PublishTime */
  publishTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** [ID] Seq */
  seq?: InputMaybe<IntOperationFilterInput>;
  /** Service */
  service?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] StopTime */
  stopTime?: InputMaybe<DateTimeOperationFilterInput>;
};

/** ServiceBannerScheduled */
export type Club_WorldFamilyClub_ServiceBannerScheduledInput = {
  /** ImageFilename */
  imageFilename?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] IsHolidaySurpriseBanner */
  isHolidaySurpriseBanner?: InputMaybe<Scalars['Boolean']['input']>;
  /** Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] PublishTime */
  publishTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** [ID] Seq */
  seq?: InputMaybe<Scalars['Int']['input']>;
  /** Service */
  service?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] StopTime */
  stopTime?: InputMaybe<Scalars['DateTime']['input']>;
};

/** ServiceBannerScheduled */
export type Club_WorldFamilyClub_ServiceBannerScheduledSortInput = {
  /** ImageFilename */
  imageFilename?: InputMaybe<SortEnumType>;
  /** [NOT NULL] IsHolidaySurpriseBanner */
  isHolidaySurpriseBanner?: InputMaybe<SortEnumType>;
  /** Market */
  market?: InputMaybe<SortEnumType>;
  /** [NOT NULL] PublishTime */
  publishTime?: InputMaybe<SortEnumType>;
  /** [ID] Seq */
  seq?: InputMaybe<SortEnumType>;
  /** Service */
  service?: InputMaybe<SortEnumType>;
  /** [NOT NULL] StopTime */
  stopTime?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_ServiceConnection = {
  __typename?: 'Club_WorldFamilyClub_ServiceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_ServiceEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_Service>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_ServiceEdge = {
  __typename?: 'Club_WorldFamilyClub_ServiceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_Service;
};

/** Service */
export type Club_WorldFamilyClub_ServiceFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_ServiceFilterInput>>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_ServiceFilterInput>>;
  /** ServiceName */
  serviceName?: InputMaybe<StringOperationFilterInput>;
  /** [ID] ServiceType */
  serviceType?: InputMaybe<StringOperationFilterInput>;
};

/** Service */
export type Club_WorldFamilyClub_ServiceInput = {
  /** ServiceName */
  serviceName?: InputMaybe<Scalars['String']['input']>;
  /** [ID] ServiceType */
  serviceType?: InputMaybe<Scalars['String']['input']>;
};

/** ServiceOneTimeToken */
export type Club_WorldFamilyClub_ServiceOneTimeToken = Node & {
  __typename?: 'Club_WorldFamilyClub_ServiceOneTimeToken';
  /** [NOT NULL] CreatedTime */
  createdTime?: Maybe<Scalars['DateTime']['output']>;
  /** [ID] TokenId */
  id: Scalars['ID']['output'];
  /** [NOT NULL] ServiceType */
  serviceType?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] TokenData */
  tokenData?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_ServiceOneTimeTokenConnection = {
  __typename?: 'Club_WorldFamilyClub_ServiceOneTimeTokenConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_ServiceOneTimeTokenEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_ServiceOneTimeToken>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_ServiceOneTimeTokenEdge = {
  __typename?: 'Club_WorldFamilyClub_ServiceOneTimeTokenEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_ServiceOneTimeToken;
};

/** ServiceOneTimeToken */
export type Club_WorldFamilyClub_ServiceOneTimeTokenFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_ServiceOneTimeTokenFilterInput>>;
  /** [NOT NULL] CreatedTime */
  createdTime?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_ServiceOneTimeTokenFilterInput>>;
  /** [NOT NULL] ServiceType */
  serviceType?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] TokenData */
  tokenData?: InputMaybe<StringOperationFilterInput>;
  /** [ID] TokenId */
  tokenId?: InputMaybe<UuidOperationFilterInput>;
};

/** ServiceOneTimeToken */
export type Club_WorldFamilyClub_ServiceOneTimeTokenInput = {
  /** [NOT NULL] CreatedTime */
  createdTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** [NOT NULL] ServiceType */
  serviceType?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] TokenData */
  tokenData?: InputMaybe<Scalars['String']['input']>;
  /** [ID] TokenId */
  tokenId?: InputMaybe<Scalars['UUID']['input']>;
};

/** ServiceOneTimeToken */
export type Club_WorldFamilyClub_ServiceOneTimeTokenSortInput = {
  /** [NOT NULL] CreatedTime */
  createdTime?: InputMaybe<SortEnumType>;
  /** [NOT NULL] ServiceType */
  serviceType?: InputMaybe<SortEnumType>;
  /** [NOT NULL] TokenData */
  tokenData?: InputMaybe<SortEnumType>;
  /** [ID] TokenId */
  tokenId?: InputMaybe<SortEnumType>;
};

/** ServiceSearch */
export type Club_WorldFamilyClub_ServiceSearch = Node & {
  __typename?: 'Club_WorldFamilyClub_ServiceSearch';
  /** [ID] Seq */
  id: Scalars['ID']['output'];
  /** MemberNo */
  memberNo?: Maybe<Scalars['String']['output']>;
  /** SearchDate */
  searchDate?: Maybe<Scalars['DateTime']['output']>;
  /** SearchText */
  searchText?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_ServiceSearchConnection = {
  __typename?: 'Club_WorldFamilyClub_ServiceSearchConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_ServiceSearchEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_ServiceSearch>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_ServiceSearchEdge = {
  __typename?: 'Club_WorldFamilyClub_ServiceSearchEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_ServiceSearch;
};

/** ServiceSearch */
export type Club_WorldFamilyClub_ServiceSearchFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_ServiceSearchFilterInput>>;
  /** MemberNo */
  memberNo?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_ServiceSearchFilterInput>>;
  /** SearchDate */
  searchDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** SearchText */
  searchText?: InputMaybe<StringOperationFilterInput>;
  /** [ID] Seq */
  seq?: InputMaybe<ShortOperationFilterInput>;
};

/** ServiceSearch */
export type Club_WorldFamilyClub_ServiceSearchInput = {
  /** MemberNo */
  memberNo?: InputMaybe<Scalars['String']['input']>;
  /** SearchDate */
  searchDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** SearchText */
  searchText?: InputMaybe<Scalars['String']['input']>;
  /** [ID] Seq */
  seq: Scalars['Short']['input'];
};

/** ServiceSearch */
export type Club_WorldFamilyClub_ServiceSearchSortInput = {
  /** MemberNo */
  memberNo?: InputMaybe<SortEnumType>;
  /** SearchDate */
  searchDate?: InputMaybe<SortEnumType>;
  /** SearchText */
  searchText?: InputMaybe<SortEnumType>;
  /** [ID] Seq */
  seq?: InputMaybe<SortEnumType>;
};

/** Service */
export type Club_WorldFamilyClub_ServiceSortInput = {
  /** ServiceName */
  serviceName?: InputMaybe<SortEnumType>;
  /** [ID] ServiceType */
  serviceType?: InputMaybe<SortEnumType>;
};

/** SmsCertification */
export type Club_WorldFamilyClub_SmsCertification = Node & {
  __typename?: 'Club_WorldFamilyClub_SmsCertification';
  /** CreationDate */
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  /** [NOT NULL] ExpireDate */
  expireDate?: Maybe<Scalars['DateTime']['output']>;
  /** [ID] No */
  id: Scalars['ID']['output'];
  /** MemberNo */
  memberNo?: Maybe<Scalars['String']['output']>;
  /** Number */
  number?: Maybe<Scalars['String']['output']>;
  /** SmsType */
  smsType?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_SmsCertificationConnection = {
  __typename?: 'Club_WorldFamilyClub_SmsCertificationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_SmsCertificationEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_SmsCertification>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_SmsCertificationEdge = {
  __typename?: 'Club_WorldFamilyClub_SmsCertificationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_SmsCertification;
};

/** SmsCertification */
export type Club_WorldFamilyClub_SmsCertificationFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_SmsCertificationFilterInput>>;
  /** CreationDate */
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** [NOT NULL] ExpireDate */
  expireDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** MemberNo */
  memberNo?: InputMaybe<StringOperationFilterInput>;
  /** [ID] No */
  no?: InputMaybe<IntOperationFilterInput>;
  /** Number */
  number?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_SmsCertificationFilterInput>>;
  /** SmsType */
  smsType?: InputMaybe<StringOperationFilterInput>;
};

/** SmsCertification */
export type Club_WorldFamilyClub_SmsCertificationInput = {
  /** CreationDate */
  creationDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** [NOT NULL] ExpireDate */
  expireDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** MemberNo */
  memberNo?: InputMaybe<Scalars['String']['input']>;
  /** [ID] No */
  no?: InputMaybe<Scalars['Int']['input']>;
  /** Number */
  number?: InputMaybe<Scalars['String']['input']>;
  /** SmsType */
  smsType?: InputMaybe<Scalars['String']['input']>;
};

/** SmsCertificationLog */
export type Club_WorldFamilyClub_SmsCertificationLog = Node & {
  __typename?: 'Club_WorldFamilyClub_SmsCertificationLog';
  /** CreationDate */
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  /** [NOT NULL] ExpireDate */
  expireDate?: Maybe<Scalars['DateTime']['output']>;
  /** [ID] Seq */
  id: Scalars['ID']['output'];
  /** MemberNo */
  memberNo?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] No */
  no?: Maybe<Scalars['Int']['output']>;
  /** Number */
  number?: Maybe<Scalars['String']['output']>;
  /** SmsType */
  smsType?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_SmsCertificationLogConnection = {
  __typename?: 'Club_WorldFamilyClub_SmsCertificationLogConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_SmsCertificationLogEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_SmsCertificationLog>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_SmsCertificationLogEdge = {
  __typename?: 'Club_WorldFamilyClub_SmsCertificationLogEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_SmsCertificationLog;
};

/** SmsCertificationLog */
export type Club_WorldFamilyClub_SmsCertificationLogFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_SmsCertificationLogFilterInput>>;
  /** CreationDate */
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** [NOT NULL] ExpireDate */
  expireDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** MemberNo */
  memberNo?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] No */
  no?: InputMaybe<IntOperationFilterInput>;
  /** Number */
  number?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_SmsCertificationLogFilterInput>>;
  /** [ID] Seq */
  seq?: InputMaybe<LongOperationFilterInput>;
  /** SmsType */
  smsType?: InputMaybe<StringOperationFilterInput>;
};

/** SmsCertificationLog */
export type Club_WorldFamilyClub_SmsCertificationLogInput = {
  /** CreationDate */
  creationDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** [NOT NULL] ExpireDate */
  expireDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** MemberNo */
  memberNo?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] No */
  no?: InputMaybe<Scalars['Int']['input']>;
  /** Number */
  number?: InputMaybe<Scalars['String']['input']>;
  /** [ID] Seq */
  seq?: InputMaybe<Scalars['Long']['input']>;
  /** SmsType */
  smsType?: InputMaybe<Scalars['String']['input']>;
};

/** SmsCertificationLog */
export type Club_WorldFamilyClub_SmsCertificationLogSortInput = {
  /** CreationDate */
  creationDate?: InputMaybe<SortEnumType>;
  /** [NOT NULL] ExpireDate */
  expireDate?: InputMaybe<SortEnumType>;
  /** MemberNo */
  memberNo?: InputMaybe<SortEnumType>;
  /** [NOT NULL] No */
  no?: InputMaybe<SortEnumType>;
  /** Number */
  number?: InputMaybe<SortEnumType>;
  /** [ID] Seq */
  seq?: InputMaybe<SortEnumType>;
  /** SmsType */
  smsType?: InputMaybe<SortEnumType>;
};

/** SmsCertification */
export type Club_WorldFamilyClub_SmsCertificationSortInput = {
  /** CreationDate */
  creationDate?: InputMaybe<SortEnumType>;
  /** [NOT NULL] ExpireDate */
  expireDate?: InputMaybe<SortEnumType>;
  /** MemberNo */
  memberNo?: InputMaybe<SortEnumType>;
  /** [ID] No */
  no?: InputMaybe<SortEnumType>;
  /** Number */
  number?: InputMaybe<SortEnumType>;
  /** SmsType */
  smsType?: InputMaybe<SortEnumType>;
};

/** SmsVerificationCode */
export type Club_WorldFamilyClub_SmsVerificationCode = Node & {
  __typename?: 'Club_WorldFamilyClub_SmsVerificationCode';
  /** [NOT NULL] CreateTime */
  createTime?: Maybe<Scalars['DateTime']['output']>;
  /** [NOT NULL] ExpireTime */
  expireTime?: Maybe<Scalars['DateTime']['output']>;
  /** [ID] Seq */
  id: Scalars['ID']['output'];
  /** [NOT NULL] IsUsed */
  isUsed?: Maybe<Scalars['Boolean']['output']>;
  /** [NOT NULL] MemberNumber */
  memberNumber?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] PhoneNumber */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] VerificationCode */
  verificationCode?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] VerificationCodeType */
  verificationCodeType?: Maybe<Scalars['Byte']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_SmsVerificationCodeConnection = {
  __typename?: 'Club_WorldFamilyClub_SmsVerificationCodeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_SmsVerificationCodeEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_SmsVerificationCode>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_SmsVerificationCodeEdge = {
  __typename?: 'Club_WorldFamilyClub_SmsVerificationCodeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_SmsVerificationCode;
};

/** SmsVerificationCode */
export type Club_WorldFamilyClub_SmsVerificationCodeFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_SmsVerificationCodeFilterInput>>;
  /** [NOT NULL] CreateTime */
  createTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** [NOT NULL] ExpireTime */
  expireTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** [NOT NULL] IsUsed */
  isUsed?: InputMaybe<BooleanOperationFilterInput>;
  /** [NOT NULL] MemberNumber */
  memberNumber?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_SmsVerificationCodeFilterInput>>;
  /** [NOT NULL] PhoneNumber */
  phoneNumber?: InputMaybe<StringOperationFilterInput>;
  /** [ID] Seq */
  seq?: InputMaybe<LongOperationFilterInput>;
  /** [NOT NULL] VerificationCode */
  verificationCode?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] VerificationCodeType */
  verificationCodeType?: InputMaybe<ByteOperationFilterInput>;
};

/** SmsVerificationCode */
export type Club_WorldFamilyClub_SmsVerificationCodeInput = {
  /** [NOT NULL] CreateTime */
  createTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** [NOT NULL] ExpireTime */
  expireTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** [NOT NULL] IsUsed */
  isUsed?: InputMaybe<Scalars['Boolean']['input']>;
  /** [NOT NULL] MemberNumber */
  memberNumber?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] PhoneNumber */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** [ID] Seq */
  seq?: InputMaybe<Scalars['Long']['input']>;
  /** [NOT NULL] VerificationCode */
  verificationCode?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] VerificationCodeType */
  verificationCodeType?: InputMaybe<Scalars['Byte']['input']>;
};

/** SmsVerificationCode */
export type Club_WorldFamilyClub_SmsVerificationCodeSortInput = {
  /** [NOT NULL] CreateTime */
  createTime?: InputMaybe<SortEnumType>;
  /** [NOT NULL] ExpireTime */
  expireTime?: InputMaybe<SortEnumType>;
  /** [NOT NULL] IsUsed */
  isUsed?: InputMaybe<SortEnumType>;
  /** [NOT NULL] MemberNumber */
  memberNumber?: InputMaybe<SortEnumType>;
  /** [NOT NULL] PhoneNumber */
  phoneNumber?: InputMaybe<SortEnumType>;
  /** [ID] Seq */
  seq?: InputMaybe<SortEnumType>;
  /** [NOT NULL] VerificationCode */
  verificationCode?: InputMaybe<SortEnumType>;
  /** [NOT NULL] VerificationCodeType */
  verificationCodeType?: InputMaybe<SortEnumType>;
};

/** SurveyTypeForm */
export type Club_WorldFamilyClub_SurveyTypeForm = Node & {
  __typename?: 'Club_WorldFamilyClub_SurveyTypeForm';
  /** Cdt */
  cdt?: Maybe<Scalars['DateTime']['output']>;
  /** DeadlineHtml */
  deadlineHtml?: Maybe<Scalars['String']['output']>;
  /** FormTitle */
  formTitle?: Maybe<Scalars['String']['output']>;
  /** [ID] FormId */
  id: Scalars['ID']['output'];
  /** PointsTypeNo */
  pointsTypeNo?: Maybe<Scalars['String']['output']>;
  /** Region */
  region?: Maybe<Scalars['String']['output']>;
  /** ResultHtml */
  resultHtml?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] RewardPoints */
  rewardPoints?: Maybe<Scalars['Int']['output']>;
  /** SurveyDeadline */
  surveyDeadline?: Maybe<Scalars['DateTime']['output']>;
  /** SurveyHtml */
  surveyHtml?: Maybe<Scalars['String']['output']>;
  /** SurveyType */
  surveyType?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_SurveyTypeFormConnection = {
  __typename?: 'Club_WorldFamilyClub_SurveyTypeFormConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_SurveyTypeFormEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_SurveyTypeForm>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_SurveyTypeFormEdge = {
  __typename?: 'Club_WorldFamilyClub_SurveyTypeFormEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_SurveyTypeForm;
};

/** SurveyTypeForm */
export type Club_WorldFamilyClub_SurveyTypeFormFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_SurveyTypeFormFilterInput>>;
  /** Cdt */
  cdt?: InputMaybe<DateTimeOperationFilterInput>;
  /** DeadlineHtml */
  deadlineHtml?: InputMaybe<StringOperationFilterInput>;
  /** [ID] FormId */
  formId?: InputMaybe<StringOperationFilterInput>;
  /** FormTitle */
  formTitle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_SurveyTypeFormFilterInput>>;
  /** PointsTypeNo */
  pointsTypeNo?: InputMaybe<StringOperationFilterInput>;
  /** Region */
  region?: InputMaybe<StringOperationFilterInput>;
  /** ResultHtml */
  resultHtml?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] RewardPoints */
  rewardPoints?: InputMaybe<IntOperationFilterInput>;
  /** SurveyDeadline */
  surveyDeadline?: InputMaybe<DateTimeOperationFilterInput>;
  /** SurveyHtml */
  surveyHtml?: InputMaybe<StringOperationFilterInput>;
  /** SurveyType */
  surveyType?: InputMaybe<StringOperationFilterInput>;
};

/** SurveyTypeForm */
export type Club_WorldFamilyClub_SurveyTypeFormInput = {
  /** Cdt */
  cdt?: InputMaybe<Scalars['DateTime']['input']>;
  /** DeadlineHtml */
  deadlineHtml?: InputMaybe<Scalars['String']['input']>;
  /** [ID] FormId */
  formId?: InputMaybe<Scalars['String']['input']>;
  /** FormTitle */
  formTitle?: InputMaybe<Scalars['String']['input']>;
  /** PointsTypeNo */
  pointsTypeNo?: InputMaybe<Scalars['String']['input']>;
  /** Region */
  region?: InputMaybe<Scalars['String']['input']>;
  /** ResultHtml */
  resultHtml?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] RewardPoints */
  rewardPoints?: InputMaybe<Scalars['Int']['input']>;
  /** SurveyDeadline */
  surveyDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  /** SurveyHtml */
  surveyHtml?: InputMaybe<Scalars['String']['input']>;
  /** SurveyType */
  surveyType?: InputMaybe<Scalars['String']['input']>;
};

/** SurveyTypeFormList */
export type Club_WorldFamilyClub_SurveyTypeFormList = Node & {
  __typename?: 'Club_WorldFamilyClub_SurveyTypeFormList';
  /** ActionDate */
  actionDate?: Maybe<Scalars['String']['output']>;
  /** Cdt */
  cdt?: Maybe<Scalars['DateTime']['output']>;
  /** ChildNumber */
  childNumber?: Maybe<Scalars['String']['output']>;
  /** Deadline */
  deadline?: Maybe<Scalars['DateTime']['output']>;
  /** FormId */
  formId?: Maybe<Scalars['String']['output']>;
  /** [ID] Seq */
  id: Scalars['ID']['output'];
  /** LandedAtUtc */
  landedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** MemberNo */
  memberNo?: Maybe<Scalars['String']['output']>;
  /** RandomType */
  randomType?: Maybe<Scalars['String']['output']>;
  /** Region */
  region?: Maybe<Scalars['String']['output']>;
  /** ResponseToken */
  responseToken?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] RewardFlag */
  rewardFlag?: Maybe<Scalars['Boolean']['output']>;
  /** SubmittedAtUtc */
  submittedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** UniqueId */
  uniqueId?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_SurveyTypeFormListConnection = {
  __typename?: 'Club_WorldFamilyClub_SurveyTypeFormListConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_SurveyTypeFormListEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_SurveyTypeFormList>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_SurveyTypeFormListEdge = {
  __typename?: 'Club_WorldFamilyClub_SurveyTypeFormListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_SurveyTypeFormList;
};

/** SurveyTypeFormList */
export type Club_WorldFamilyClub_SurveyTypeFormListFilterInput = {
  /** ActionDate */
  actionDate?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<Club_WorldFamilyClub_SurveyTypeFormListFilterInput>>;
  /** Cdt */
  cdt?: InputMaybe<DateTimeOperationFilterInput>;
  /** ChildNumber */
  childNumber?: InputMaybe<StringOperationFilterInput>;
  /** Deadline */
  deadline?: InputMaybe<DateTimeOperationFilterInput>;
  /** FormId */
  formId?: InputMaybe<StringOperationFilterInput>;
  /** LandedAtUtc */
  landedAtUtc?: InputMaybe<DateTimeOperationFilterInput>;
  /** MemberNo */
  memberNo?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_SurveyTypeFormListFilterInput>>;
  /** RandomType */
  randomType?: InputMaybe<StringOperationFilterInput>;
  /** Region */
  region?: InputMaybe<StringOperationFilterInput>;
  /** ResponseToken */
  responseToken?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] RewardFlag */
  rewardFlag?: InputMaybe<BooleanOperationFilterInput>;
  /** [ID] Seq */
  seq?: InputMaybe<LongOperationFilterInput>;
  /** SubmittedAtUtc */
  submittedAtUtc?: InputMaybe<DateTimeOperationFilterInput>;
  /** UniqueId */
  uniqueId?: InputMaybe<StringOperationFilterInput>;
};

/** SurveyTypeFormList */
export type Club_WorldFamilyClub_SurveyTypeFormListInput = {
  /** ActionDate */
  actionDate?: InputMaybe<Scalars['String']['input']>;
  /** Cdt */
  cdt?: InputMaybe<Scalars['DateTime']['input']>;
  /** ChildNumber */
  childNumber?: InputMaybe<Scalars['String']['input']>;
  /** Deadline */
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  /** FormId */
  formId?: InputMaybe<Scalars['String']['input']>;
  /** LandedAtUtc */
  landedAtUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** MemberNo */
  memberNo?: InputMaybe<Scalars['String']['input']>;
  /** RandomType */
  randomType?: InputMaybe<Scalars['String']['input']>;
  /** Region */
  region?: InputMaybe<Scalars['String']['input']>;
  /** ResponseToken */
  responseToken?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] RewardFlag */
  rewardFlag?: InputMaybe<Scalars['Boolean']['input']>;
  /** [ID] Seq */
  seq?: InputMaybe<Scalars['Long']['input']>;
  /** SubmittedAtUtc */
  submittedAtUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** UniqueId */
  uniqueId?: InputMaybe<Scalars['String']['input']>;
};

/** SurveyTypeFormList */
export type Club_WorldFamilyClub_SurveyTypeFormListSortInput = {
  /** ActionDate */
  actionDate?: InputMaybe<SortEnumType>;
  /** Cdt */
  cdt?: InputMaybe<SortEnumType>;
  /** ChildNumber */
  childNumber?: InputMaybe<SortEnumType>;
  /** Deadline */
  deadline?: InputMaybe<SortEnumType>;
  /** FormId */
  formId?: InputMaybe<SortEnumType>;
  /** LandedAtUtc */
  landedAtUtc?: InputMaybe<SortEnumType>;
  /** MemberNo */
  memberNo?: InputMaybe<SortEnumType>;
  /** RandomType */
  randomType?: InputMaybe<SortEnumType>;
  /** Region */
  region?: InputMaybe<SortEnumType>;
  /** ResponseToken */
  responseToken?: InputMaybe<SortEnumType>;
  /** [NOT NULL] RewardFlag */
  rewardFlag?: InputMaybe<SortEnumType>;
  /** [ID] Seq */
  seq?: InputMaybe<SortEnumType>;
  /** SubmittedAtUtc */
  submittedAtUtc?: InputMaybe<SortEnumType>;
  /** UniqueId */
  uniqueId?: InputMaybe<SortEnumType>;
};

/** SurveyTypeForm */
export type Club_WorldFamilyClub_SurveyTypeFormSortInput = {
  /** Cdt */
  cdt?: InputMaybe<SortEnumType>;
  /** DeadlineHtml */
  deadlineHtml?: InputMaybe<SortEnumType>;
  /** [ID] FormId */
  formId?: InputMaybe<SortEnumType>;
  /** FormTitle */
  formTitle?: InputMaybe<SortEnumType>;
  /** PointsTypeNo */
  pointsTypeNo?: InputMaybe<SortEnumType>;
  /** Region */
  region?: InputMaybe<SortEnumType>;
  /** ResultHtml */
  resultHtml?: InputMaybe<SortEnumType>;
  /** [NOT NULL] RewardPoints */
  rewardPoints?: InputMaybe<SortEnumType>;
  /** SurveyDeadline */
  surveyDeadline?: InputMaybe<SortEnumType>;
  /** SurveyHtml */
  surveyHtml?: InputMaybe<SortEnumType>;
  /** SurveyType */
  surveyType?: InputMaybe<SortEnumType>;
};

/** TalkAlongCard */
export type Club_WorldFamilyClub_TalkAlongCard = Node & {
  __typename?: 'Club_WorldFamilyClub_TalkAlongCard';
  /** [NOT NULL] CardNumber */
  cardNumber?: Maybe<Scalars['Int']['output']>;
  /** [ID] TalkAlongCardId */
  id: Scalars['ID']['output'];
  /** Word */
  word?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_TalkAlongCardConnection = {
  __typename?: 'Club_WorldFamilyClub_TalkAlongCardConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_TalkAlongCardEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_TalkAlongCard>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_TalkAlongCardEdge = {
  __typename?: 'Club_WorldFamilyClub_TalkAlongCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_TalkAlongCard;
};

/** TalkAlongCard */
export type Club_WorldFamilyClub_TalkAlongCardFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_TalkAlongCardFilterInput>>;
  /** [NOT NULL] CardNumber */
  cardNumber?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_TalkAlongCardFilterInput>>;
  /** [ID] TalkAlongCardId */
  talkAlongCardId?: InputMaybe<IntOperationFilterInput>;
  /** Word */
  word?: InputMaybe<StringOperationFilterInput>;
};

/** TalkAlongCard */
export type Club_WorldFamilyClub_TalkAlongCardInput = {
  /** [NOT NULL] CardNumber */
  cardNumber?: InputMaybe<Scalars['Int']['input']>;
  /** [ID] TalkAlongCardId */
  talkAlongCardId?: InputMaybe<Scalars['Int']['input']>;
  /** Word */
  word?: InputMaybe<Scalars['String']['input']>;
};

/** TalkAlongCard */
export type Club_WorldFamilyClub_TalkAlongCardSortInput = {
  /** [NOT NULL] CardNumber */
  cardNumber?: InputMaybe<SortEnumType>;
  /** [ID] TalkAlongCardId */
  talkAlongCardId?: InputMaybe<SortEnumType>;
  /** Word */
  word?: InputMaybe<SortEnumType>;
};

/** TeSong */
export type Club_WorldFamilyClub_TeSong = Node & {
  __typename?: 'Club_WorldFamilyClub_TeSong';
  /** CapLevel */
  capLevel?: Maybe<Scalars['String']['output']>;
  /** [COLLECTION] FaceCallSongPublics */
  faceCallSongPublics?: Maybe<Array<Maybe<Club_WorldFamilyClub_FaceCallSongPublic>>>;
  /** [COLLECTION] FaceCallSongs */
  faceCallSongs?: Maybe<Array<Maybe<Club_WorldFamilyClub_FaceCallSong>>>;
  /** HkTeSongNumber */
  hkTeSongNumber?: Maybe<Scalars['String']['output']>;
  /** [ID] TeSongId */
  id: Scalars['ID']['output'];
  /** KrTeSongNumber */
  krTeSongNumber?: Maybe<Scalars['String']['output']>;
  /** [COLLECTION] MyFavoriteFaceCallSongs */
  myFavoriteFaceCallSongs?: Maybe<Array<Maybe<Club_WorldFamilyClub_MyFavoriteFaceCallSong>>>;
  /** [NOT NULL] Product */
  product?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] PublishdSongs */
  publishdSongs?: Maybe<Scalars['Int']['output']>;
  /** [NOT NULL] SongName */
  songName?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] TeSongNumber */
  teSongNumber?: Maybe<Scalars['String']['output']>;
  /** [COLLECTION] TeSongToys */
  teSongToys?: Maybe<Array<Maybe<Club_WorldFamilyClub_TeSongToy>>>;
  /** TwTeSongNumber */
  twTeSongNumber?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_TeSongConnection = {
  __typename?: 'Club_WorldFamilyClub_TeSongConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_TeSongEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_TeSong>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_TeSongEdge = {
  __typename?: 'Club_WorldFamilyClub_TeSongEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_TeSong;
};

/** TeSong */
export type Club_WorldFamilyClub_TeSongFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_TeSongFilterInput>>;
  /** CapLevel */
  capLevel?: InputMaybe<StringOperationFilterInput>;
  /** [COLLECTION] FaceCallSongPublics */
  faceCallSongPublics?: InputMaybe<ListFilterInputTypeOfClub_WorldFamilyClub_FaceCallSongPublicFilterInput>;
  /** [COLLECTION] FaceCallSongs */
  faceCallSongs?: InputMaybe<ListFilterInputTypeOfClub_WorldFamilyClub_FaceCallSongFilterInput>;
  /** HkTeSongNumber */
  hkTeSongNumber?: InputMaybe<StringOperationFilterInput>;
  /** KrTeSongNumber */
  krTeSongNumber?: InputMaybe<StringOperationFilterInput>;
  /** [COLLECTION] MyFavoriteFaceCallSongs */
  myFavoriteFaceCallSongs?: InputMaybe<ListFilterInputTypeOfClub_WorldFamilyClub_MyFavoriteFaceCallSongFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_TeSongFilterInput>>;
  /** [NOT NULL] Product */
  product?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] PublishdSongs */
  publishdSongs?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] SongName */
  songName?: InputMaybe<StringOperationFilterInput>;
  /** [ID] TeSongId */
  teSongId?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] TeSongNumber */
  teSongNumber?: InputMaybe<StringOperationFilterInput>;
  /** [COLLECTION] TeSongToys */
  teSongToys?: InputMaybe<ListFilterInputTypeOfClub_WorldFamilyClub_TeSongToyFilterInput>;
  /** TwTeSongNumber */
  twTeSongNumber?: InputMaybe<StringOperationFilterInput>;
};

/** TeSong */
export type Club_WorldFamilyClub_TeSongInput = {
  /** CapLevel */
  capLevel?: InputMaybe<Scalars['String']['input']>;
  /** [COLLECTION] FaceCallSongPublics */
  faceCallSongPublics?: InputMaybe<Array<InputMaybe<Club_WorldFamilyClub_FaceCallSongPublicInput>>>;
  /** [COLLECTION] FaceCallSongs */
  faceCallSongs?: InputMaybe<Array<InputMaybe<Club_WorldFamilyClub_FaceCallSongInput>>>;
  /** HkTeSongNumber */
  hkTeSongNumber?: InputMaybe<Scalars['String']['input']>;
  /** KrTeSongNumber */
  krTeSongNumber?: InputMaybe<Scalars['String']['input']>;
  /** [COLLECTION] MyFavoriteFaceCallSongs */
  myFavoriteFaceCallSongs?: InputMaybe<Array<InputMaybe<Club_WorldFamilyClub_MyFavoriteFaceCallSongInput>>>;
  /** [NOT NULL] Product */
  product?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] PublishdSongs */
  publishdSongs?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] SongName */
  songName?: InputMaybe<Scalars['String']['input']>;
  /** [ID] TeSongId */
  teSongId?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] TeSongNumber */
  teSongNumber?: InputMaybe<Scalars['String']['input']>;
  /** [COLLECTION] TeSongToys */
  teSongToys?: InputMaybe<Array<InputMaybe<Club_WorldFamilyClub_TeSongToyInput>>>;
  /** TwTeSongNumber */
  twTeSongNumber?: InputMaybe<Scalars['String']['input']>;
};

/** TeSong */
export type Club_WorldFamilyClub_TeSongSortInput = {
  /** CapLevel */
  capLevel?: InputMaybe<SortEnumType>;
  /** HkTeSongNumber */
  hkTeSongNumber?: InputMaybe<SortEnumType>;
  /** KrTeSongNumber */
  krTeSongNumber?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Product */
  product?: InputMaybe<SortEnumType>;
  /** [NOT NULL] PublishdSongs */
  publishdSongs?: InputMaybe<SortEnumType>;
  /** [NOT NULL] SongName */
  songName?: InputMaybe<SortEnumType>;
  /** [ID] TeSongId */
  teSongId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] TeSongNumber */
  teSongNumber?: InputMaybe<SortEnumType>;
  /** TwTeSongNumber */
  twTeSongNumber?: InputMaybe<SortEnumType>;
};

/** TeSongToy */
export type Club_WorldFamilyClub_TeSongToy = Node & {
  __typename?: 'Club_WorldFamilyClub_TeSongToy';
  /** [ID] TeSongToysId */
  id: Scalars['ID']['output'];
  /** [NAVIGATION] TeSong */
  teSong?: Maybe<Club_WorldFamilyClub_TeSong>;
  /** [NOT NULL] TeSongId */
  teSongId?: Maybe<Scalars['Int']['output']>;
  /** [NOT NULL] ToyImage */
  toyImage?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_TeSongToyConnection = {
  __typename?: 'Club_WorldFamilyClub_TeSongToyConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_TeSongToyEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_TeSongToy>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_TeSongToyEdge = {
  __typename?: 'Club_WorldFamilyClub_TeSongToyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_TeSongToy;
};

/** TeSongToy */
export type Club_WorldFamilyClub_TeSongToyFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_TeSongToyFilterInput>>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_TeSongToyFilterInput>>;
  /** [NAVIGATION] TeSong */
  teSong?: InputMaybe<Club_WorldFamilyClub_TeSongFilterInput>;
  /** [NOT NULL] TeSongId */
  teSongId?: InputMaybe<IntOperationFilterInput>;
  /** [ID] TeSongToysId */
  teSongToysId?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] ToyImage */
  toyImage?: InputMaybe<StringOperationFilterInput>;
};

/** TeSongToy */
export type Club_WorldFamilyClub_TeSongToyInput = {
  /** [NAVIGATION] TeSong */
  teSong?: InputMaybe<Club_WorldFamilyClub_TeSongInput>;
  /** [NOT NULL] TeSongId */
  teSongId?: InputMaybe<Scalars['Int']['input']>;
  /** [ID] TeSongToysId */
  teSongToysId?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] ToyImage */
  toyImage?: InputMaybe<Scalars['String']['input']>;
};

/** TeSongToy */
export type Club_WorldFamilyClub_TeSongToySortInput = {
  /** [NAVIGATION] TeSong */
  teSong?: InputMaybe<Club_WorldFamilyClub_TeSongSortInput>;
  /** [NOT NULL] TeSongId */
  teSongId?: InputMaybe<SortEnumType>;
  /** [ID] TeSongToysId */
  teSongToysId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] ToyImage */
  toyImage?: InputMaybe<SortEnumType>;
};

/** Temp20240408Graduation */
export type Club_WorldFamilyClub_Temp20240408Graduation = Node & {
  __typename?: 'Club_WorldFamilyClub_Temp20240408Graduation';
  /** Age */
  age?: Maybe<Scalars['String']['output']>;
  /** ChildEnglishName */
  childEnglishName?: Maybe<Scalars['String']['output']>;
  /** ChildId */
  childId?: Maybe<Scalars['String']['output']>;
  /** ChildName */
  childName?: Maybe<Scalars['String']['output']>;
  /** Excellent */
  excellent?: Maybe<Scalars['String']['output']>;
  /** [ID] Seq */
  id: Scalars['ID']['output'];
  /** MemNo */
  memNo?: Maybe<Scalars['String']['output']>;
  /** PassDate */
  passDate?: Maybe<Scalars['DateTime']['output']>;
  /** RegDate */
  regDate?: Maybe<Scalars['DateTime']['output']>;
  /** Result */
  result?: Maybe<Scalars['String']['output']>;
  /** Task1 */
  task1?: Maybe<Scalars['String']['output']>;
  /** Task2 */
  task2?: Maybe<Scalars['String']['output']>;
  /** Task3 */
  task3?: Maybe<Scalars['String']['output']>;
  /** Task4 */
  task4?: Maybe<Scalars['String']['output']>;
  /** Task5 */
  task5?: Maybe<Scalars['String']['output']>;
  /** Task6 */
  task6?: Maybe<Scalars['String']['output']>;
  /** Task7 */
  task7?: Maybe<Scalars['String']['output']>;
  /** Task8 */
  task8?: Maybe<Scalars['String']['output']>;
};

/** Temp20240408Graduation1 */
export type Club_WorldFamilyClub_Temp20240408Graduation1 = Node & {
  __typename?: 'Club_WorldFamilyClub_Temp20240408Graduation1';
  /** [NOT NULL] Age */
  age?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] ChildEnglishName */
  childEnglishName?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] ChildName */
  childName?: Maybe<Scalars['String']['output']>;
  /** ChildSeq */
  childSeq?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Excellent */
  excellent?: Maybe<Scalars['String']['output']>;
  /** [ID] MemNo */
  id: Scalars['ID']['output'];
  /** PassDate */
  passDate?: Maybe<Scalars['String']['output']>;
  /** RegDate */
  regDate?: Maybe<Scalars['String']['output']>;
  /** Result */
  result?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Task1 */
  task1?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Task2 */
  task2?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Task3 */
  task3?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Task4 */
  task4?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Task5 */
  task5?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Task6 */
  task6?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Task7 */
  task7?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Task8 */
  task8?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_Temp20240408Graduation1Connection = {
  __typename?: 'Club_WorldFamilyClub_Temp20240408Graduation1Connection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_Temp20240408Graduation1Edge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_Temp20240408Graduation1>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_Temp20240408Graduation1Edge = {
  __typename?: 'Club_WorldFamilyClub_Temp20240408Graduation1Edge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_Temp20240408Graduation1;
};

/** Temp20240408Graduation1 */
export type Club_WorldFamilyClub_Temp20240408Graduation1FilterInput = {
  /** [NOT NULL] Age */
  age?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<Club_WorldFamilyClub_Temp20240408Graduation1FilterInput>>;
  /** [NOT NULL] ChildEnglishName */
  childEnglishName?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] ChildName */
  childName?: InputMaybe<StringOperationFilterInput>;
  /** ChildSeq */
  childSeq?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] Excellent */
  excellent?: InputMaybe<StringOperationFilterInput>;
  /** [ID] MemNo */
  memNo?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_Temp20240408Graduation1FilterInput>>;
  /** PassDate */
  passDate?: InputMaybe<StringOperationFilterInput>;
  /** RegDate */
  regDate?: InputMaybe<StringOperationFilterInput>;
  /** Result */
  result?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] Task1 */
  task1?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] Task2 */
  task2?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] Task3 */
  task3?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] Task4 */
  task4?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] Task5 */
  task5?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] Task6 */
  task6?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] Task7 */
  task7?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] Task8 */
  task8?: InputMaybe<StringOperationFilterInput>;
};

/** Temp20240408Graduation1 */
export type Club_WorldFamilyClub_Temp20240408Graduation1Input = {
  /** [NOT NULL] Age */
  age?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] ChildEnglishName */
  childEnglishName?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] ChildName */
  childName?: InputMaybe<Scalars['String']['input']>;
  /** ChildSeq */
  childSeq?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Excellent */
  excellent?: InputMaybe<Scalars['String']['input']>;
  /** [ID] MemNo */
  memNo: Scalars['String']['input'];
  /** PassDate */
  passDate?: InputMaybe<Scalars['String']['input']>;
  /** RegDate */
  regDate?: InputMaybe<Scalars['String']['input']>;
  /** Result */
  result?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Task1 */
  task1?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Task2 */
  task2?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Task3 */
  task3?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Task4 */
  task4?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Task5 */
  task5?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Task6 */
  task6?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Task7 */
  task7?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Task8 */
  task8?: InputMaybe<Scalars['String']['input']>;
};

/** Temp20240408Graduation1 */
export type Club_WorldFamilyClub_Temp20240408Graduation1SortInput = {
  /** [NOT NULL] Age */
  age?: InputMaybe<SortEnumType>;
  /** [NOT NULL] ChildEnglishName */
  childEnglishName?: InputMaybe<SortEnumType>;
  /** [NOT NULL] ChildName */
  childName?: InputMaybe<SortEnumType>;
  /** ChildSeq */
  childSeq?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Excellent */
  excellent?: InputMaybe<SortEnumType>;
  /** [ID] MemNo */
  memNo?: InputMaybe<SortEnumType>;
  /** PassDate */
  passDate?: InputMaybe<SortEnumType>;
  /** RegDate */
  regDate?: InputMaybe<SortEnumType>;
  /** Result */
  result?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Task1 */
  task1?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Task2 */
  task2?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Task3 */
  task3?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Task4 */
  task4?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Task5 */
  task5?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Task6 */
  task6?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Task7 */
  task7?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Task8 */
  task8?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_Temp20240408GraduationConnection = {
  __typename?: 'Club_WorldFamilyClub_Temp20240408GraduationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_Temp20240408GraduationEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_Temp20240408Graduation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_Temp20240408GraduationEdge = {
  __typename?: 'Club_WorldFamilyClub_Temp20240408GraduationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_Temp20240408Graduation;
};

/** Temp20240408Graduation */
export type Club_WorldFamilyClub_Temp20240408GraduationFilterInput = {
  /** Age */
  age?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<Club_WorldFamilyClub_Temp20240408GraduationFilterInput>>;
  /** ChildEnglishName */
  childEnglishName?: InputMaybe<StringOperationFilterInput>;
  /** ChildId */
  childId?: InputMaybe<StringOperationFilterInput>;
  /** ChildName */
  childName?: InputMaybe<StringOperationFilterInput>;
  /** Excellent */
  excellent?: InputMaybe<StringOperationFilterInput>;
  /** MemNo */
  memNo?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_Temp20240408GraduationFilterInput>>;
  /** PassDate */
  passDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** RegDate */
  regDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Result */
  result?: InputMaybe<StringOperationFilterInput>;
  /** [ID] Seq */
  seq?: InputMaybe<StringOperationFilterInput>;
  /** Task1 */
  task1?: InputMaybe<StringOperationFilterInput>;
  /** Task2 */
  task2?: InputMaybe<StringOperationFilterInput>;
  /** Task3 */
  task3?: InputMaybe<StringOperationFilterInput>;
  /** Task4 */
  task4?: InputMaybe<StringOperationFilterInput>;
  /** Task5 */
  task5?: InputMaybe<StringOperationFilterInput>;
  /** Task6 */
  task6?: InputMaybe<StringOperationFilterInput>;
  /** Task7 */
  task7?: InputMaybe<StringOperationFilterInput>;
  /** Task8 */
  task8?: InputMaybe<StringOperationFilterInput>;
};

/** Temp20240408Graduation */
export type Club_WorldFamilyClub_Temp20240408GraduationInput = {
  /** Age */
  age?: InputMaybe<Scalars['String']['input']>;
  /** ChildEnglishName */
  childEnglishName?: InputMaybe<Scalars['String']['input']>;
  /** ChildId */
  childId?: InputMaybe<Scalars['String']['input']>;
  /** ChildName */
  childName?: InputMaybe<Scalars['String']['input']>;
  /** Excellent */
  excellent?: InputMaybe<Scalars['String']['input']>;
  /** MemNo */
  memNo?: InputMaybe<Scalars['String']['input']>;
  /** PassDate */
  passDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** RegDate */
  regDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Result */
  result?: InputMaybe<Scalars['String']['input']>;
  /** [ID] Seq */
  seq: Scalars['String']['input'];
  /** Task1 */
  task1?: InputMaybe<Scalars['String']['input']>;
  /** Task2 */
  task2?: InputMaybe<Scalars['String']['input']>;
  /** Task3 */
  task3?: InputMaybe<Scalars['String']['input']>;
  /** Task4 */
  task4?: InputMaybe<Scalars['String']['input']>;
  /** Task5 */
  task5?: InputMaybe<Scalars['String']['input']>;
  /** Task6 */
  task6?: InputMaybe<Scalars['String']['input']>;
  /** Task7 */
  task7?: InputMaybe<Scalars['String']['input']>;
  /** Task8 */
  task8?: InputMaybe<Scalars['String']['input']>;
};

/** Temp20240408Graduation */
export type Club_WorldFamilyClub_Temp20240408GraduationSortInput = {
  /** Age */
  age?: InputMaybe<SortEnumType>;
  /** ChildEnglishName */
  childEnglishName?: InputMaybe<SortEnumType>;
  /** ChildId */
  childId?: InputMaybe<SortEnumType>;
  /** ChildName */
  childName?: InputMaybe<SortEnumType>;
  /** Excellent */
  excellent?: InputMaybe<SortEnumType>;
  /** MemNo */
  memNo?: InputMaybe<SortEnumType>;
  /** PassDate */
  passDate?: InputMaybe<SortEnumType>;
  /** RegDate */
  regDate?: InputMaybe<SortEnumType>;
  /** Result */
  result?: InputMaybe<SortEnumType>;
  /** [ID] Seq */
  seq?: InputMaybe<SortEnumType>;
  /** Task1 */
  task1?: InputMaybe<SortEnumType>;
  /** Task2 */
  task2?: InputMaybe<SortEnumType>;
  /** Task3 */
  task3?: InputMaybe<SortEnumType>;
  /** Task4 */
  task4?: InputMaybe<SortEnumType>;
  /** Task5 */
  task5?: InputMaybe<SortEnumType>;
  /** Task6 */
  task6?: InputMaybe<SortEnumType>;
  /** Task7 */
  task7?: InputMaybe<SortEnumType>;
  /** Task8 */
  task8?: InputMaybe<SortEnumType>;
};

/** Temp20251028ExchangeReason */
export type Club_WorldFamilyClub_Temp20251028ExchangeReason = Node & {
  __typename?: 'Club_WorldFamilyClub_Temp20251028ExchangeReason';
  /** Display */
  display?: Maybe<Scalars['String']['output']>;
  /** [ID] WfePadUid */
  id: Scalars['ID']['output'];
  /** PadClass */
  padClass?: Maybe<Scalars['String']['output']>;
  /** PadCode */
  padCode?: Maybe<Scalars['String']['output']>;
  /** PadStatement */
  padStatement?: Maybe<Scalars['String']['output']>;
  /** PadStatementEng */
  padStatementEng?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_Temp20251028ExchangeReasonConnection = {
  __typename?: 'Club_WorldFamilyClub_Temp20251028ExchangeReasonConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_Temp20251028ExchangeReasonEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_Temp20251028ExchangeReason>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_Temp20251028ExchangeReasonEdge = {
  __typename?: 'Club_WorldFamilyClub_Temp20251028ExchangeReasonEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_Temp20251028ExchangeReason;
};

/** Temp20251028ExchangeReason */
export type Club_WorldFamilyClub_Temp20251028ExchangeReasonFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_Temp20251028ExchangeReasonFilterInput>>;
  /** Display */
  display?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_Temp20251028ExchangeReasonFilterInput>>;
  /** PadClass */
  padClass?: InputMaybe<StringOperationFilterInput>;
  /** PadCode */
  padCode?: InputMaybe<StringOperationFilterInput>;
  /** PadStatement */
  padStatement?: InputMaybe<StringOperationFilterInput>;
  /** PadStatementEng */
  padStatementEng?: InputMaybe<StringOperationFilterInput>;
  /** [ID] WfePadUid */
  wfePadUid?: InputMaybe<StringOperationFilterInput>;
};

/** Temp20251028ExchangeReason */
export type Club_WorldFamilyClub_Temp20251028ExchangeReasonInput = {
  /** Display */
  display?: InputMaybe<Scalars['String']['input']>;
  /** PadClass */
  padClass?: InputMaybe<Scalars['String']['input']>;
  /** PadCode */
  padCode?: InputMaybe<Scalars['String']['input']>;
  /** PadStatement */
  padStatement?: InputMaybe<Scalars['String']['input']>;
  /** PadStatementEng */
  padStatementEng?: InputMaybe<Scalars['String']['input']>;
  /** [ID] WfePadUid */
  wfePadUid: Scalars['String']['input'];
};

/** Temp20251028ExchangeReason */
export type Club_WorldFamilyClub_Temp20251028ExchangeReasonSortInput = {
  /** Display */
  display?: InputMaybe<SortEnumType>;
  /** PadClass */
  padClass?: InputMaybe<SortEnumType>;
  /** PadCode */
  padCode?: InputMaybe<SortEnumType>;
  /** PadStatement */
  padStatement?: InputMaybe<SortEnumType>;
  /** PadStatementEng */
  padStatementEng?: InputMaybe<SortEnumType>;
  /** [ID] WfePadUid */
  wfePadUid?: InputMaybe<SortEnumType>;
};

/** Temp20260310Product */
export type Club_WorldFamilyClub_Temp20260310Product = Node & {
  __typename?: 'Club_WorldFamilyClub_Temp20260310Product';
  /** [ID] SubCategorySortId */
  id: Scalars['ID']['output'];
  /** ProductId */
  productId?: Maybe<Scalars['String']['output']>;
  /** ProductName */
  productName?: Maybe<Scalars['String']['output']>;
  /** Sku */
  sku?: Maybe<Scalars['Float']['output']>;
  /** SortId */
  sortId?: Maybe<Scalars['Float']['output']>;
  /** SubCategoryName */
  subCategoryName?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_Temp20260310ProductConnection = {
  __typename?: 'Club_WorldFamilyClub_Temp20260310ProductConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_Temp20260310ProductEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_Temp20260310Product>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_Temp20260310ProductEdge = {
  __typename?: 'Club_WorldFamilyClub_Temp20260310ProductEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_Temp20260310Product;
};

/** Temp20260310Product */
export type Club_WorldFamilyClub_Temp20260310ProductFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_Temp20260310ProductFilterInput>>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_Temp20260310ProductFilterInput>>;
  /** ProductId */
  productId?: InputMaybe<StringOperationFilterInput>;
  /** ProductName */
  productName?: InputMaybe<StringOperationFilterInput>;
  /** Sku */
  sku?: InputMaybe<FloatOperationFilterInput>;
  /** SortId */
  sortId?: InputMaybe<FloatOperationFilterInput>;
  /** SubCategoryName */
  subCategoryName?: InputMaybe<StringOperationFilterInput>;
  /** [ID] SubCategorySortId */
  subCategorySortId?: InputMaybe<FloatOperationFilterInput>;
};

/** Temp20260310Product */
export type Club_WorldFamilyClub_Temp20260310ProductInput = {
  /** ProductId */
  productId?: InputMaybe<Scalars['String']['input']>;
  /** ProductName */
  productName?: InputMaybe<Scalars['String']['input']>;
  /** Sku */
  sku?: InputMaybe<Scalars['Float']['input']>;
  /** SortId */
  sortId?: InputMaybe<Scalars['Float']['input']>;
  /** SubCategoryName */
  subCategoryName?: InputMaybe<Scalars['String']['input']>;
  /** [ID] SubCategorySortId */
  subCategorySortId: Scalars['Float']['input'];
};

/** Temp20260310Product */
export type Club_WorldFamilyClub_Temp20260310ProductSortInput = {
  /** ProductId */
  productId?: InputMaybe<SortEnumType>;
  /** ProductName */
  productName?: InputMaybe<SortEnumType>;
  /** Sku */
  sku?: InputMaybe<SortEnumType>;
  /** SortId */
  sortId?: InputMaybe<SortEnumType>;
  /** SubCategoryName */
  subCategoryName?: InputMaybe<SortEnumType>;
  /** [ID] SubCategorySortId */
  subCategorySortId?: InputMaybe<SortEnumType>;
};

/** TempChildGraduationApplicationNew */
export type Club_WorldFamilyClub_TempChildGraduationApplicationNew = Node & {
  __typename?: 'Club_WorldFamilyClub_TempChildGraduationApplicationNew';
  /** ApplicationCount */
  applicationCount?: Maybe<Scalars['Int']['output']>;
  /** [NOT NULL] ApplicationYear */
  applicationYear?: Maybe<Scalars['Int']['output']>;
  /** ApprovedCount */
  approvedCount?: Maybe<Scalars['Int']['output']>;
  /** [NOT NULL] ChildNo */
  childNo?: Maybe<Scalars['String']['output']>;
  /** GraduationDate */
  graduationDate?: Maybe<Scalars['DateTime']['output']>;
  /** [ID] Market */
  id: Scalars['ID']['output'];
  /** IsExcellent */
  isExcellent?: Maybe<Scalars['Int']['output']>;
  /** LastApprovalDate */
  lastApprovalDate?: Maybe<Scalars['DateTime']['output']>;
  /** [NOT NULL] MemberNo */
  memberNo?: Maybe<Scalars['String']['output']>;
  /** RejectedCount */
  rejectedCount?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_TempChildGraduationApplicationNewConnection = {
  __typename?: 'Club_WorldFamilyClub_TempChildGraduationApplicationNewConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_TempChildGraduationApplicationNewEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_TempChildGraduationApplicationNew>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_TempChildGraduationApplicationNewEdge = {
  __typename?: 'Club_WorldFamilyClub_TempChildGraduationApplicationNewEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_TempChildGraduationApplicationNew;
};

/** TempChildGraduationApplicationNew */
export type Club_WorldFamilyClub_TempChildGraduationApplicationNewFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_TempChildGraduationApplicationNewFilterInput>>;
  /** ApplicationCount */
  applicationCount?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] ApplicationYear */
  applicationYear?: InputMaybe<IntOperationFilterInput>;
  /** ApprovedCount */
  approvedCount?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] ChildNo */
  childNo?: InputMaybe<StringOperationFilterInput>;
  /** GraduationDate */
  graduationDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** IsExcellent */
  isExcellent?: InputMaybe<IntOperationFilterInput>;
  /** LastApprovalDate */
  lastApprovalDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** [ID] Market */
  market?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] MemberNo */
  memberNo?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_TempChildGraduationApplicationNewFilterInput>>;
  /** RejectedCount */
  rejectedCount?: InputMaybe<IntOperationFilterInput>;
};

/** TempChildGraduationApplicationNew */
export type Club_WorldFamilyClub_TempChildGraduationApplicationNewInput = {
  /** ApplicationCount */
  applicationCount?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] ApplicationYear */
  applicationYear?: InputMaybe<Scalars['Int']['input']>;
  /** ApprovedCount */
  approvedCount?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] ChildNo */
  childNo?: InputMaybe<Scalars['String']['input']>;
  /** GraduationDate */
  graduationDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** IsExcellent */
  isExcellent?: InputMaybe<Scalars['Int']['input']>;
  /** LastApprovalDate */
  lastApprovalDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** [ID] Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] MemberNo */
  memberNo?: InputMaybe<Scalars['String']['input']>;
  /** RejectedCount */
  rejectedCount?: InputMaybe<Scalars['Int']['input']>;
};

/** TempChildGraduationApplicationNew */
export type Club_WorldFamilyClub_TempChildGraduationApplicationNewSortInput = {
  /** ApplicationCount */
  applicationCount?: InputMaybe<SortEnumType>;
  /** [NOT NULL] ApplicationYear */
  applicationYear?: InputMaybe<SortEnumType>;
  /** ApprovedCount */
  approvedCount?: InputMaybe<SortEnumType>;
  /** [NOT NULL] ChildNo */
  childNo?: InputMaybe<SortEnumType>;
  /** GraduationDate */
  graduationDate?: InputMaybe<SortEnumType>;
  /** IsExcellent */
  isExcellent?: InputMaybe<SortEnumType>;
  /** LastApprovalDate */
  lastApprovalDate?: InputMaybe<SortEnumType>;
  /** [ID] Market */
  market?: InputMaybe<SortEnumType>;
  /** [NOT NULL] MemberNo */
  memberNo?: InputMaybe<SortEnumType>;
  /** RejectedCount */
  rejectedCount?: InputMaybe<SortEnumType>;
};

/** TempChildGraduationApplicationOld */
export type Club_WorldFamilyClub_TempChildGraduationApplicationOld = Node & {
  __typename?: 'Club_WorldFamilyClub_TempChildGraduationApplicationOld';
  /** [NOT NULL] ApplicationCount */
  applicationCount?: Maybe<Scalars['Int']['output']>;
  /** [NOT NULL] ApplicationYear */
  applicationYear?: Maybe<Scalars['Int']['output']>;
  /** [NOT NULL] ApprovedCount */
  approvedCount?: Maybe<Scalars['Int']['output']>;
  /** [NOT NULL] ChildNo */
  childNo?: Maybe<Scalars['String']['output']>;
  /** GraduationDate */
  graduationDate?: Maybe<Scalars['DateTime']['output']>;
  /** [ID] ChildApplicationId */
  id: Scalars['ID']['output'];
  /** IsExcellent */
  isExcellent?: Maybe<Scalars['Boolean']['output']>;
  /** LastApprovalDate */
  lastApprovalDate?: Maybe<Scalars['DateTime']['output']>;
  /** [NOT NULL] Market */
  market?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] MemberNo */
  memberNo?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] RejectedCount */
  rejectedCount?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_TempChildGraduationApplicationOldConnection = {
  __typename?: 'Club_WorldFamilyClub_TempChildGraduationApplicationOldConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_TempChildGraduationApplicationOldEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_TempChildGraduationApplicationOld>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_TempChildGraduationApplicationOldEdge = {
  __typename?: 'Club_WorldFamilyClub_TempChildGraduationApplicationOldEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_TempChildGraduationApplicationOld;
};

/** TempChildGraduationApplicationOld */
export type Club_WorldFamilyClub_TempChildGraduationApplicationOldFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_TempChildGraduationApplicationOldFilterInput>>;
  /** [NOT NULL] ApplicationCount */
  applicationCount?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] ApplicationYear */
  applicationYear?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] ApprovedCount */
  approvedCount?: InputMaybe<IntOperationFilterInput>;
  /** [ID] ChildApplicationId */
  childApplicationId?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] ChildNo */
  childNo?: InputMaybe<StringOperationFilterInput>;
  /** GraduationDate */
  graduationDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** IsExcellent */
  isExcellent?: InputMaybe<BooleanOperationFilterInput>;
  /** LastApprovalDate */
  lastApprovalDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** [NOT NULL] Market */
  market?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] MemberNo */
  memberNo?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_TempChildGraduationApplicationOldFilterInput>>;
  /** [NOT NULL] RejectedCount */
  rejectedCount?: InputMaybe<IntOperationFilterInput>;
};

/** TempChildGraduationApplicationOld */
export type Club_WorldFamilyClub_TempChildGraduationApplicationOldInput = {
  /** [NOT NULL] ApplicationCount */
  applicationCount?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] ApplicationYear */
  applicationYear?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] ApprovedCount */
  approvedCount?: InputMaybe<Scalars['Int']['input']>;
  /** [ID] ChildApplicationId */
  childApplicationId?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] ChildNo */
  childNo?: InputMaybe<Scalars['String']['input']>;
  /** GraduationDate */
  graduationDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** IsExcellent */
  isExcellent?: InputMaybe<Scalars['Boolean']['input']>;
  /** LastApprovalDate */
  lastApprovalDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** [NOT NULL] Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] MemberNo */
  memberNo?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] RejectedCount */
  rejectedCount?: InputMaybe<Scalars['Int']['input']>;
};

/** TempChildGraduationApplicationOld */
export type Club_WorldFamilyClub_TempChildGraduationApplicationOldSortInput = {
  /** [NOT NULL] ApplicationCount */
  applicationCount?: InputMaybe<SortEnumType>;
  /** [NOT NULL] ApplicationYear */
  applicationYear?: InputMaybe<SortEnumType>;
  /** [NOT NULL] ApprovedCount */
  approvedCount?: InputMaybe<SortEnumType>;
  /** [ID] ChildApplicationId */
  childApplicationId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] ChildNo */
  childNo?: InputMaybe<SortEnumType>;
  /** GraduationDate */
  graduationDate?: InputMaybe<SortEnumType>;
  /** IsExcellent */
  isExcellent?: InputMaybe<SortEnumType>;
  /** LastApprovalDate */
  lastApprovalDate?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Market */
  market?: InputMaybe<SortEnumType>;
  /** [NOT NULL] MemberNo */
  memberNo?: InputMaybe<SortEnumType>;
  /** [NOT NULL] RejectedCount */
  rejectedCount?: InputMaybe<SortEnumType>;
};

/** TempFaceCall */
export type Club_WorldFamilyClub_TempFaceCall = Node & {
  __typename?: 'Club_WorldFamilyClub_TempFaceCall';
  /** CreatedDate */
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  /** [ID] Seq */
  id: Scalars['ID']['output'];
  /** PerformerName */
  performerName?: Maybe<Scalars['String']['output']>;
  /** SongName */
  songName?: Maybe<Scalars['String']['output']>;
  /** Theme */
  theme?: Maybe<Scalars['String']['output']>;
  /** VimeoIdJp */
  vimeoIdJp?: Maybe<Scalars['String']['output']>;
  /** VimeoIdTw */
  vimeoIdTw?: Maybe<Scalars['String']['output']>;
  /** VimeoLink */
  vimeoLink?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_TempFaceCallConnection = {
  __typename?: 'Club_WorldFamilyClub_TempFaceCallConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_TempFaceCallEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_TempFaceCall>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_TempFaceCallEdge = {
  __typename?: 'Club_WorldFamilyClub_TempFaceCallEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_TempFaceCall;
};

/** TempFaceCall */
export type Club_WorldFamilyClub_TempFaceCallFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_TempFaceCallFilterInput>>;
  /** CreatedDate */
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_TempFaceCallFilterInput>>;
  /** PerformerName */
  performerName?: InputMaybe<StringOperationFilterInput>;
  /** [ID] Seq */
  seq?: InputMaybe<FloatOperationFilterInput>;
  /** SongName */
  songName?: InputMaybe<StringOperationFilterInput>;
  /** Theme */
  theme?: InputMaybe<StringOperationFilterInput>;
  /** VimeoIdJp */
  vimeoIdJp?: InputMaybe<StringOperationFilterInput>;
  /** VimeoIdTw */
  vimeoIdTw?: InputMaybe<StringOperationFilterInput>;
  /** VimeoLink */
  vimeoLink?: InputMaybe<StringOperationFilterInput>;
};

/** TempFaceCallHk */
export type Club_WorldFamilyClub_TempFaceCallHk = Node & {
  __typename?: 'Club_WorldFamilyClub_TempFaceCallHk';
  /** CreatedDate */
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  /** [ID] Seq */
  id: Scalars['ID']['output'];
  /** PerformerName */
  performerName?: Maybe<Scalars['String']['output']>;
  /** SongName */
  songName?: Maybe<Scalars['String']['output']>;
  /** Theme */
  theme?: Maybe<Scalars['String']['output']>;
  /** VimeoIdJp */
  vimeoIdJp?: Maybe<Scalars['String']['output']>;
  /** VimeoIdTw */
  vimeoIdTw?: Maybe<Scalars['String']['output']>;
  /** VimeoLink */
  vimeoLink?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_TempFaceCallHkConnection = {
  __typename?: 'Club_WorldFamilyClub_TempFaceCallHkConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_TempFaceCallHkEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_TempFaceCallHk>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_TempFaceCallHkEdge = {
  __typename?: 'Club_WorldFamilyClub_TempFaceCallHkEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_TempFaceCallHk;
};

/** TempFaceCallHk */
export type Club_WorldFamilyClub_TempFaceCallHkFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_TempFaceCallHkFilterInput>>;
  /** CreatedDate */
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_TempFaceCallHkFilterInput>>;
  /** PerformerName */
  performerName?: InputMaybe<StringOperationFilterInput>;
  /** [ID] Seq */
  seq?: InputMaybe<FloatOperationFilterInput>;
  /** SongName */
  songName?: InputMaybe<StringOperationFilterInput>;
  /** Theme */
  theme?: InputMaybe<StringOperationFilterInput>;
  /** VimeoIdJp */
  vimeoIdJp?: InputMaybe<StringOperationFilterInput>;
  /** VimeoIdTw */
  vimeoIdTw?: InputMaybe<StringOperationFilterInput>;
  /** VimeoLink */
  vimeoLink?: InputMaybe<StringOperationFilterInput>;
};

/** TempFaceCallHk */
export type Club_WorldFamilyClub_TempFaceCallHkInput = {
  /** CreatedDate */
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** PerformerName */
  performerName?: InputMaybe<Scalars['String']['input']>;
  /** [ID] Seq */
  seq: Scalars['Float']['input'];
  /** SongName */
  songName?: InputMaybe<Scalars['String']['input']>;
  /** Theme */
  theme?: InputMaybe<Scalars['String']['input']>;
  /** VimeoIdJp */
  vimeoIdJp?: InputMaybe<Scalars['String']['input']>;
  /** VimeoIdTw */
  vimeoIdTw?: InputMaybe<Scalars['String']['input']>;
  /** VimeoLink */
  vimeoLink?: InputMaybe<Scalars['String']['input']>;
};

/** TempFaceCallHk */
export type Club_WorldFamilyClub_TempFaceCallHkSortInput = {
  /** CreatedDate */
  createdDate?: InputMaybe<SortEnumType>;
  /** PerformerName */
  performerName?: InputMaybe<SortEnumType>;
  /** [ID] Seq */
  seq?: InputMaybe<SortEnumType>;
  /** SongName */
  songName?: InputMaybe<SortEnumType>;
  /** Theme */
  theme?: InputMaybe<SortEnumType>;
  /** VimeoIdJp */
  vimeoIdJp?: InputMaybe<SortEnumType>;
  /** VimeoIdTw */
  vimeoIdTw?: InputMaybe<SortEnumType>;
  /** VimeoLink */
  vimeoLink?: InputMaybe<SortEnumType>;
};

/** TempFaceCall */
export type Club_WorldFamilyClub_TempFaceCallInput = {
  /** CreatedDate */
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** PerformerName */
  performerName?: InputMaybe<Scalars['String']['input']>;
  /** [ID] Seq */
  seq: Scalars['Float']['input'];
  /** SongName */
  songName?: InputMaybe<Scalars['String']['input']>;
  /** Theme */
  theme?: InputMaybe<Scalars['String']['input']>;
  /** VimeoIdJp */
  vimeoIdJp?: InputMaybe<Scalars['String']['input']>;
  /** VimeoIdTw */
  vimeoIdTw?: InputMaybe<Scalars['String']['input']>;
  /** VimeoLink */
  vimeoLink?: InputMaybe<Scalars['String']['input']>;
};

/** TempFaceCallKr */
export type Club_WorldFamilyClub_TempFaceCallKr = Node & {
  __typename?: 'Club_WorldFamilyClub_TempFaceCallKr';
  /** CreatedDate */
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  /** [ID] Seq */
  id: Scalars['ID']['output'];
  /** PerformerName */
  performerName?: Maybe<Scalars['String']['output']>;
  /** SongName */
  songName?: Maybe<Scalars['String']['output']>;
  /** Theme */
  theme?: Maybe<Scalars['String']['output']>;
  /** VimeoIdJp */
  vimeoIdJp?: Maybe<Scalars['String']['output']>;
  /** VimeoIdTw */
  vimeoIdTw?: Maybe<Scalars['String']['output']>;
  /** VimeoLink */
  vimeoLink?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_TempFaceCallKrConnection = {
  __typename?: 'Club_WorldFamilyClub_TempFaceCallKrConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_TempFaceCallKrEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_TempFaceCallKr>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_TempFaceCallKrEdge = {
  __typename?: 'Club_WorldFamilyClub_TempFaceCallKrEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_TempFaceCallKr;
};

/** TempFaceCallKr */
export type Club_WorldFamilyClub_TempFaceCallKrFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_TempFaceCallKrFilterInput>>;
  /** CreatedDate */
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_TempFaceCallKrFilterInput>>;
  /** PerformerName */
  performerName?: InputMaybe<StringOperationFilterInput>;
  /** [ID] Seq */
  seq?: InputMaybe<FloatOperationFilterInput>;
  /** SongName */
  songName?: InputMaybe<StringOperationFilterInput>;
  /** Theme */
  theme?: InputMaybe<StringOperationFilterInput>;
  /** VimeoIdJp */
  vimeoIdJp?: InputMaybe<StringOperationFilterInput>;
  /** VimeoIdTw */
  vimeoIdTw?: InputMaybe<StringOperationFilterInput>;
  /** VimeoLink */
  vimeoLink?: InputMaybe<StringOperationFilterInput>;
};

/** TempFaceCallKr */
export type Club_WorldFamilyClub_TempFaceCallKrInput = {
  /** CreatedDate */
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** PerformerName */
  performerName?: InputMaybe<Scalars['String']['input']>;
  /** [ID] Seq */
  seq: Scalars['Float']['input'];
  /** SongName */
  songName?: InputMaybe<Scalars['String']['input']>;
  /** Theme */
  theme?: InputMaybe<Scalars['String']['input']>;
  /** VimeoIdJp */
  vimeoIdJp?: InputMaybe<Scalars['String']['input']>;
  /** VimeoIdTw */
  vimeoIdTw?: InputMaybe<Scalars['String']['input']>;
  /** VimeoLink */
  vimeoLink?: InputMaybe<Scalars['String']['input']>;
};

/** TempFaceCallKr */
export type Club_WorldFamilyClub_TempFaceCallKrSortInput = {
  /** CreatedDate */
  createdDate?: InputMaybe<SortEnumType>;
  /** PerformerName */
  performerName?: InputMaybe<SortEnumType>;
  /** [ID] Seq */
  seq?: InputMaybe<SortEnumType>;
  /** SongName */
  songName?: InputMaybe<SortEnumType>;
  /** Theme */
  theme?: InputMaybe<SortEnumType>;
  /** VimeoIdJp */
  vimeoIdJp?: InputMaybe<SortEnumType>;
  /** VimeoIdTw */
  vimeoIdTw?: InputMaybe<SortEnumType>;
  /** VimeoLink */
  vimeoLink?: InputMaybe<SortEnumType>;
};

/** TempFaceCall */
export type Club_WorldFamilyClub_TempFaceCallSortInput = {
  /** CreatedDate */
  createdDate?: InputMaybe<SortEnumType>;
  /** PerformerName */
  performerName?: InputMaybe<SortEnumType>;
  /** [ID] Seq */
  seq?: InputMaybe<SortEnumType>;
  /** SongName */
  songName?: InputMaybe<SortEnumType>;
  /** Theme */
  theme?: InputMaybe<SortEnumType>;
  /** VimeoIdJp */
  vimeoIdJp?: InputMaybe<SortEnumType>;
  /** VimeoIdTw */
  vimeoIdTw?: InputMaybe<SortEnumType>;
  /** VimeoLink */
  vimeoLink?: InputMaybe<SortEnumType>;
};

/** TempGoGoLiveSong */
export type Club_WorldFamilyClub_TempGoGoLiveSong = Node & {
  __typename?: 'Club_WorldFamilyClub_TempGoGoLiveSong';
  /** F4 */
  f4?: Maybe<Scalars['String']['output']>;
  /** F5 */
  f5?: Maybe<Scalars['String']['output']>;
  /** [ID] GoGoLiveSongId */
  id: Scalars['ID']['output'];
  /** SongName */
  songName?: Maybe<Scalars['String']['output']>;
  /** SongNumber */
  songNumber?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_TempGoGoLiveSongConnection = {
  __typename?: 'Club_WorldFamilyClub_TempGoGoLiveSongConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_TempGoGoLiveSongEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_TempGoGoLiveSong>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_TempGoGoLiveSongEdge = {
  __typename?: 'Club_WorldFamilyClub_TempGoGoLiveSongEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_TempGoGoLiveSong;
};

/** TempGoGoLiveSong */
export type Club_WorldFamilyClub_TempGoGoLiveSongFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_TempGoGoLiveSongFilterInput>>;
  /** F4 */
  f4?: InputMaybe<StringOperationFilterInput>;
  /** F5 */
  f5?: InputMaybe<StringOperationFilterInput>;
  /** [ID] GoGoLiveSongId */
  goGoLiveSongId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_TempGoGoLiveSongFilterInput>>;
  /** SongName */
  songName?: InputMaybe<StringOperationFilterInput>;
  /** SongNumber */
  songNumber?: InputMaybe<StringOperationFilterInput>;
};

/** TempGoGoLiveSong */
export type Club_WorldFamilyClub_TempGoGoLiveSongInput = {
  /** F4 */
  f4?: InputMaybe<Scalars['String']['input']>;
  /** F5 */
  f5?: InputMaybe<Scalars['String']['input']>;
  /** [ID] GoGoLiveSongId */
  goGoLiveSongId: Scalars['String']['input'];
  /** SongName */
  songName?: InputMaybe<Scalars['String']['input']>;
  /** SongNumber */
  songNumber?: InputMaybe<Scalars['String']['input']>;
};

/** TempGoGoLiveSong */
export type Club_WorldFamilyClub_TempGoGoLiveSongSortInput = {
  /** F4 */
  f4?: InputMaybe<SortEnumType>;
  /** F5 */
  f5?: InputMaybe<SortEnumType>;
  /** [ID] GoGoLiveSongId */
  goGoLiveSongId?: InputMaybe<SortEnumType>;
  /** SongName */
  songName?: InputMaybe<SortEnumType>;
  /** SongNumber */
  songNumber?: InputMaybe<SortEnumType>;
};

/** TempHkAppMyFavorite */
export type Club_WorldFamilyClub_TempHkAppMyFavorite = Node & {
  __typename?: 'Club_WorldFamilyClub_TempHkAppMyFavorite';
  /** Cdt */
  cdt?: Maybe<Scalars['DateTime']['output']>;
  /** FavouriteType */
  favouriteType?: Maybe<Scalars['String']['output']>;
  /** [ID] Seq */
  id: Scalars['ID']['output'];
  /** LinkNo */
  linkNo?: Maybe<Scalars['String']['output']>;
  /** MemberNo */
  memberNo?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_TempHkAppMyFavoriteConnection = {
  __typename?: 'Club_WorldFamilyClub_TempHkAppMyFavoriteConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_TempHkAppMyFavoriteEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_TempHkAppMyFavorite>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_TempHkAppMyFavoriteEdge = {
  __typename?: 'Club_WorldFamilyClub_TempHkAppMyFavoriteEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_TempHkAppMyFavorite;
};

/** TempHkAppMyFavorite */
export type Club_WorldFamilyClub_TempHkAppMyFavoriteFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_TempHkAppMyFavoriteFilterInput>>;
  /** Cdt */
  cdt?: InputMaybe<DateTimeOperationFilterInput>;
  /** FavouriteType */
  favouriteType?: InputMaybe<StringOperationFilterInput>;
  /** LinkNo */
  linkNo?: InputMaybe<StringOperationFilterInput>;
  /** MemberNo */
  memberNo?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_TempHkAppMyFavoriteFilterInput>>;
  /** [ID] Seq */
  seq?: InputMaybe<IntOperationFilterInput>;
};

/** TempHkAppMyFavorite */
export type Club_WorldFamilyClub_TempHkAppMyFavoriteInput = {
  /** Cdt */
  cdt?: InputMaybe<Scalars['DateTime']['input']>;
  /** FavouriteType */
  favouriteType?: InputMaybe<Scalars['String']['input']>;
  /** LinkNo */
  linkNo?: InputMaybe<Scalars['String']['input']>;
  /** MemberNo */
  memberNo?: InputMaybe<Scalars['String']['input']>;
  /** [ID] Seq */
  seq?: InputMaybe<Scalars['Int']['input']>;
};

/** TempHkAppMyFavorite */
export type Club_WorldFamilyClub_TempHkAppMyFavoriteSortInput = {
  /** Cdt */
  cdt?: InputMaybe<SortEnumType>;
  /** FavouriteType */
  favouriteType?: InputMaybe<SortEnumType>;
  /** LinkNo */
  linkNo?: InputMaybe<SortEnumType>;
  /** MemberNo */
  memberNo?: InputMaybe<SortEnumType>;
  /** [ID] Seq */
  seq?: InputMaybe<SortEnumType>;
};

/** TempHkClubappsFacecallCrew */
export type Club_WorldFamilyClub_TempHkClubappsFacecallCrew = Node & {
  __typename?: 'Club_WorldFamilyClub_TempHkClubappsFacecallCrew';
  /** Cdt */
  cdt?: Maybe<Scalars['DateTime']['output']>;
  /** CrewName */
  crewName?: Maybe<Scalars['String']['output']>;
  /** CrewPhoto */
  crewPhoto?: Maybe<Scalars['String']['output']>;
  /** CrewPhotoC */
  crewPhotoC?: Maybe<Scalars['String']['output']>;
  /** CrewPhotoR */
  crewPhotoR?: Maybe<Scalars['String']['output']>;
  /** CrewShowName */
  crewShowName?: Maybe<Scalars['String']['output']>;
  /** Enable */
  enable?: Maybe<Scalars['Int']['output']>;
  /** [ID] Rid */
  id: Scalars['ID']['output'];
  /** Udt */
  udt?: Maybe<Scalars['DateTime']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_TempHkClubappsFacecallCrewConnection = {
  __typename?: 'Club_WorldFamilyClub_TempHkClubappsFacecallCrewConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_TempHkClubappsFacecallCrewEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_TempHkClubappsFacecallCrew>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_TempHkClubappsFacecallCrewEdge = {
  __typename?: 'Club_WorldFamilyClub_TempHkClubappsFacecallCrewEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_TempHkClubappsFacecallCrew;
};

/** TempHkClubappsFacecallCrew */
export type Club_WorldFamilyClub_TempHkClubappsFacecallCrewFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_TempHkClubappsFacecallCrewFilterInput>>;
  /** Cdt */
  cdt?: InputMaybe<DateTimeOperationFilterInput>;
  /** CrewName */
  crewName?: InputMaybe<StringOperationFilterInput>;
  /** CrewPhoto */
  crewPhoto?: InputMaybe<StringOperationFilterInput>;
  /** CrewPhotoC */
  crewPhotoC?: InputMaybe<StringOperationFilterInput>;
  /** CrewPhotoR */
  crewPhotoR?: InputMaybe<StringOperationFilterInput>;
  /** CrewShowName */
  crewShowName?: InputMaybe<StringOperationFilterInput>;
  /** Enable */
  enable?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_TempHkClubappsFacecallCrewFilterInput>>;
  /** [ID] Rid */
  rid?: InputMaybe<IntOperationFilterInput>;
  /** Udt */
  udt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** TempHkClubappsFacecallCrew */
export type Club_WorldFamilyClub_TempHkClubappsFacecallCrewInput = {
  /** Cdt */
  cdt?: InputMaybe<Scalars['DateTime']['input']>;
  /** CrewName */
  crewName?: InputMaybe<Scalars['String']['input']>;
  /** CrewPhoto */
  crewPhoto?: InputMaybe<Scalars['String']['input']>;
  /** CrewPhotoC */
  crewPhotoC?: InputMaybe<Scalars['String']['input']>;
  /** CrewPhotoR */
  crewPhotoR?: InputMaybe<Scalars['String']['input']>;
  /** CrewShowName */
  crewShowName?: InputMaybe<Scalars['String']['input']>;
  /** Enable */
  enable?: InputMaybe<Scalars['Int']['input']>;
  /** [ID] Rid */
  rid?: InputMaybe<Scalars['Int']['input']>;
  /** Udt */
  udt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** TempHkClubappsFacecallCrew */
export type Club_WorldFamilyClub_TempHkClubappsFacecallCrewSortInput = {
  /** Cdt */
  cdt?: InputMaybe<SortEnumType>;
  /** CrewName */
  crewName?: InputMaybe<SortEnumType>;
  /** CrewPhoto */
  crewPhoto?: InputMaybe<SortEnumType>;
  /** CrewPhotoC */
  crewPhotoC?: InputMaybe<SortEnumType>;
  /** CrewPhotoR */
  crewPhotoR?: InputMaybe<SortEnumType>;
  /** CrewShowName */
  crewShowName?: InputMaybe<SortEnumType>;
  /** Enable */
  enable?: InputMaybe<SortEnumType>;
  /** [ID] Rid */
  rid?: InputMaybe<SortEnumType>;
  /** Udt */
  udt?: InputMaybe<SortEnumType>;
};

/** TempHkClubappsFacecallHistory */
export type Club_WorldFamilyClub_TempHkClubappsFacecallHistory = Node & {
  __typename?: 'Club_WorldFamilyClub_TempHkClubappsFacecallHistory';
  /** Cdt */
  cdt?: Maybe<Scalars['DateTime']['output']>;
  /** CrewName */
  crewName?: Maybe<Scalars['String']['output']>;
  /** [ID] Rid */
  id: Scalars['ID']['output'];
  /** Memno */
  memno?: Maybe<Scalars['String']['output']>;
  /** SongName */
  songName?: Maybe<Scalars['String']['output']>;
  /** SongRid */
  songRid?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_TempHkClubappsFacecallHistoryConnection = {
  __typename?: 'Club_WorldFamilyClub_TempHkClubappsFacecallHistoryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_TempHkClubappsFacecallHistoryEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_TempHkClubappsFacecallHistory>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_TempHkClubappsFacecallHistoryEdge = {
  __typename?: 'Club_WorldFamilyClub_TempHkClubappsFacecallHistoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_TempHkClubappsFacecallHistory;
};

/** TempHkClubappsFacecallHistory */
export type Club_WorldFamilyClub_TempHkClubappsFacecallHistoryFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_TempHkClubappsFacecallHistoryFilterInput>>;
  /** Cdt */
  cdt?: InputMaybe<DateTimeOperationFilterInput>;
  /** CrewName */
  crewName?: InputMaybe<StringOperationFilterInput>;
  /** Memno */
  memno?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_TempHkClubappsFacecallHistoryFilterInput>>;
  /** [ID] Rid */
  rid?: InputMaybe<IntOperationFilterInput>;
  /** SongName */
  songName?: InputMaybe<StringOperationFilterInput>;
  /** SongRid */
  songRid?: InputMaybe<IntOperationFilterInput>;
};

/** TempHkClubappsFacecallHistory */
export type Club_WorldFamilyClub_TempHkClubappsFacecallHistoryInput = {
  /** Cdt */
  cdt?: InputMaybe<Scalars['DateTime']['input']>;
  /** CrewName */
  crewName?: InputMaybe<Scalars['String']['input']>;
  /** Memno */
  memno?: InputMaybe<Scalars['String']['input']>;
  /** [ID] Rid */
  rid?: InputMaybe<Scalars['Int']['input']>;
  /** SongName */
  songName?: InputMaybe<Scalars['String']['input']>;
  /** SongRid */
  songRid?: InputMaybe<Scalars['Int']['input']>;
};

/** TempHkClubappsFacecallHistory */
export type Club_WorldFamilyClub_TempHkClubappsFacecallHistorySortInput = {
  /** Cdt */
  cdt?: InputMaybe<SortEnumType>;
  /** CrewName */
  crewName?: InputMaybe<SortEnumType>;
  /** Memno */
  memno?: InputMaybe<SortEnumType>;
  /** [ID] Rid */
  rid?: InputMaybe<SortEnumType>;
  /** SongName */
  songName?: InputMaybe<SortEnumType>;
  /** SongRid */
  songRid?: InputMaybe<SortEnumType>;
};

/** TempHkClubappsFacecallSong */
export type Club_WorldFamilyClub_TempHkClubappsFacecallSong = Node & {
  __typename?: 'Club_WorldFamilyClub_TempHkClubappsFacecallSong';
  /** Cdt */
  cdt?: Maybe<Scalars['DateTime']['output']>;
  /** CrewName */
  crewName?: Maybe<Scalars['String']['output']>;
  /** Cuser */
  cuser?: Maybe<Scalars['String']['output']>;
  /** [ID] Rid */
  id: Scalars['ID']['output'];
  /** Seasonholiday */
  seasonholiday?: Maybe<Scalars['String']['output']>;
  /** ShowDate */
  showDate?: Maybe<Scalars['String']['output']>;
  /** SongFrom */
  songFrom?: Maybe<Scalars['String']['output']>;
  /** SongName */
  songName?: Maybe<Scalars['String']['output']>;
  /** SongNo */
  songNo?: Maybe<Scalars['String']['output']>;
  /** TematerialCode */
  tematerialCode?: Maybe<Scalars['String']['output']>;
  /** Udt */
  udt?: Maybe<Scalars['DateTime']['output']>;
  /** Uuser */
  uuser?: Maybe<Scalars['String']['output']>;
  /** VideoLink */
  videoLink?: Maybe<Scalars['String']['output']>;
  /** VimeoId */
  vimeoId?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_TempHkClubappsFacecallSongConnection = {
  __typename?: 'Club_WorldFamilyClub_TempHkClubappsFacecallSongConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_TempHkClubappsFacecallSongEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_TempHkClubappsFacecallSong>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_TempHkClubappsFacecallSongEdge = {
  __typename?: 'Club_WorldFamilyClub_TempHkClubappsFacecallSongEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_TempHkClubappsFacecallSong;
};

/** TempHkClubappsFacecallSong */
export type Club_WorldFamilyClub_TempHkClubappsFacecallSongFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_TempHkClubappsFacecallSongFilterInput>>;
  /** Cdt */
  cdt?: InputMaybe<DateTimeOperationFilterInput>;
  /** CrewName */
  crewName?: InputMaybe<StringOperationFilterInput>;
  /** Cuser */
  cuser?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_TempHkClubappsFacecallSongFilterInput>>;
  /** [ID] Rid */
  rid?: InputMaybe<IntOperationFilterInput>;
  /** Seasonholiday */
  seasonholiday?: InputMaybe<StringOperationFilterInput>;
  /** ShowDate */
  showDate?: InputMaybe<StringOperationFilterInput>;
  /** SongFrom */
  songFrom?: InputMaybe<StringOperationFilterInput>;
  /** SongName */
  songName?: InputMaybe<StringOperationFilterInput>;
  /** SongNo */
  songNo?: InputMaybe<StringOperationFilterInput>;
  /** TematerialCode */
  tematerialCode?: InputMaybe<StringOperationFilterInput>;
  /** Udt */
  udt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Uuser */
  uuser?: InputMaybe<StringOperationFilterInput>;
  /** VideoLink */
  videoLink?: InputMaybe<StringOperationFilterInput>;
  /** VimeoId */
  vimeoId?: InputMaybe<StringOperationFilterInput>;
};

/** TempHkClubappsFacecallSong */
export type Club_WorldFamilyClub_TempHkClubappsFacecallSongInput = {
  /** Cdt */
  cdt?: InputMaybe<Scalars['DateTime']['input']>;
  /** CrewName */
  crewName?: InputMaybe<Scalars['String']['input']>;
  /** Cuser */
  cuser?: InputMaybe<Scalars['String']['input']>;
  /** [ID] Rid */
  rid?: InputMaybe<Scalars['Int']['input']>;
  /** Seasonholiday */
  seasonholiday?: InputMaybe<Scalars['String']['input']>;
  /** ShowDate */
  showDate?: InputMaybe<Scalars['String']['input']>;
  /** SongFrom */
  songFrom?: InputMaybe<Scalars['String']['input']>;
  /** SongName */
  songName?: InputMaybe<Scalars['String']['input']>;
  /** SongNo */
  songNo?: InputMaybe<Scalars['String']['input']>;
  /** TematerialCode */
  tematerialCode?: InputMaybe<Scalars['String']['input']>;
  /** Udt */
  udt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Uuser */
  uuser?: InputMaybe<Scalars['String']['input']>;
  /** VideoLink */
  videoLink?: InputMaybe<Scalars['String']['input']>;
  /** VimeoId */
  vimeoId?: InputMaybe<Scalars['String']['input']>;
};

/** TempHkClubappsFacecallSong */
export type Club_WorldFamilyClub_TempHkClubappsFacecallSongSortInput = {
  /** Cdt */
  cdt?: InputMaybe<SortEnumType>;
  /** CrewName */
  crewName?: InputMaybe<SortEnumType>;
  /** Cuser */
  cuser?: InputMaybe<SortEnumType>;
  /** [ID] Rid */
  rid?: InputMaybe<SortEnumType>;
  /** Seasonholiday */
  seasonholiday?: InputMaybe<SortEnumType>;
  /** ShowDate */
  showDate?: InputMaybe<SortEnumType>;
  /** SongFrom */
  songFrom?: InputMaybe<SortEnumType>;
  /** SongName */
  songName?: InputMaybe<SortEnumType>;
  /** SongNo */
  songNo?: InputMaybe<SortEnumType>;
  /** TematerialCode */
  tematerialCode?: InputMaybe<SortEnumType>;
  /** Udt */
  udt?: InputMaybe<SortEnumType>;
  /** Uuser */
  uuser?: InputMaybe<SortEnumType>;
  /** VideoLink */
  videoLink?: InputMaybe<SortEnumType>;
  /** VimeoId */
  vimeoId?: InputMaybe<SortEnumType>;
};

/** TempHkDmemChild */
export type Club_WorldFamilyClub_TempHkDmemChild = Node & {
  __typename?: 'Club_WorldFamilyClub_TempHkDmemChild';
  /** Achievement */
  achievement?: Maybe<Scalars['String']['output']>;
  /** ActDtl1 */
  actDtl1?: Maybe<Scalars['String']['output']>;
  /** ActDtl2 */
  actDtl2?: Maybe<Scalars['String']['output']>;
  /** ActDtl3 */
  actDtl3?: Maybe<Scalars['String']['output']>;
  /** Birthday */
  birthday?: Maybe<Scalars['String']['output']>;
  /** CapLvl */
  capLvl?: Maybe<Scalars['String']['output']>;
  /** CapPf */
  capPf?: Maybe<Scalars['Int']['output']>;
  /** CardMadeDt */
  cardMadeDt?: Maybe<Scalars['DateTime']['output']>;
  /** CardPhoto */
  cardPhoto?: Maybe<Scalars['String']['output']>;
  /** CardPrint */
  cardPrint?: Maybe<Scalars['Int']['output']>;
  /** Cdt */
  cdt?: Maybe<Scalars['DateTime']['output']>;
  /** CompRec */
  compRec?: Maybe<Scalars['String']['output']>;
  /** CompRecDtl */
  compRecDtl?: Maybe<Scalars['String']['output']>;
  /** EmpNameO */
  empNameO?: Maybe<Scalars['String']['output']>;
  /** EmpNameR */
  empNameR?: Maybe<Scalars['String']['output']>;
  /** Gender */
  gender?: Maybe<Scalars['String']['output']>;
  /** GradP */
  gradP?: Maybe<Scalars['Int']['output']>;
  /** GradTkDt */
  gradTkDt?: Maybe<Scalars['String']['output']>;
  /** GraduationDate */
  graduationDate?: Maybe<Scalars['String']['output']>;
  /** Guest */
  guest?: Maybe<Scalars['String']['output']>;
  /** [ID] SeqNo */
  id: Scalars['ID']['output'];
  /** Interest */
  interest?: Maybe<Scalars['String']['output']>;
  /** KinSch */
  kinSch?: Maybe<Scalars['String']['output']>;
  /** MemNo */
  memNo?: Maybe<Scalars['String']['output']>;
  /** MorePhoto */
  morePhoto?: Maybe<Scalars['String']['output']>;
  /** MorePhotoCdt */
  morePhotoCdt?: Maybe<Scalars['DateTime']['output']>;
  /** NameC */
  nameC?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] NameE */
  nameE?: Maybe<Scalars['String']['output']>;
  /** Organizer */
  organizer?: Maybe<Scalars['String']['output']>;
  /** Photo */
  photo?: Maybe<Scalars['String']['output']>;
  /** PriSch */
  priSch?: Maybe<Scalars['String']['output']>;
  /** Reviser */
  reviser?: Maybe<Scalars['String']['output']>;
  /** SecSch */
  secSch?: Maybe<Scalars['String']['output']>;
  /** ShowDtl1 */
  showDtl1?: Maybe<Scalars['String']['output']>;
  /** ShowDtl2 */
  showDtl2?: Maybe<Scalars['String']['output']>;
  /** ShowDtl3 */
  showDtl3?: Maybe<Scalars['String']['output']>;
  /** Strength */
  strength?: Maybe<Scalars['String']['output']>;
  /** Udt */
  udt?: Maybe<Scalars['DateTime']['output']>;
  /** WfLibraryInuse */
  wfLibraryInuse?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_TempHkDmemChildConnection = {
  __typename?: 'Club_WorldFamilyClub_TempHkDmemChildConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_TempHkDmemChildEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_TempHkDmemChild>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_TempHkDmemChildEdge = {
  __typename?: 'Club_WorldFamilyClub_TempHkDmemChildEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_TempHkDmemChild;
};

/** TempHkDmemChild */
export type Club_WorldFamilyClub_TempHkDmemChildFilterInput = {
  /** Achievement */
  achievement?: InputMaybe<StringOperationFilterInput>;
  /** ActDtl1 */
  actDtl1?: InputMaybe<StringOperationFilterInput>;
  /** ActDtl2 */
  actDtl2?: InputMaybe<StringOperationFilterInput>;
  /** ActDtl3 */
  actDtl3?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<Club_WorldFamilyClub_TempHkDmemChildFilterInput>>;
  /** Birthday */
  birthday?: InputMaybe<StringOperationFilterInput>;
  /** CapLvl */
  capLvl?: InputMaybe<StringOperationFilterInput>;
  /** CapPf */
  capPf?: InputMaybe<IntOperationFilterInput>;
  /** CardMadeDt */
  cardMadeDt?: InputMaybe<DateTimeOperationFilterInput>;
  /** CardPhoto */
  cardPhoto?: InputMaybe<StringOperationFilterInput>;
  /** CardPrint */
  cardPrint?: InputMaybe<IntOperationFilterInput>;
  /** Cdt */
  cdt?: InputMaybe<DateTimeOperationFilterInput>;
  /** CompRec */
  compRec?: InputMaybe<StringOperationFilterInput>;
  /** CompRecDtl */
  compRecDtl?: InputMaybe<StringOperationFilterInput>;
  /** EmpNameO */
  empNameO?: InputMaybe<StringOperationFilterInput>;
  /** EmpNameR */
  empNameR?: InputMaybe<StringOperationFilterInput>;
  /** Gender */
  gender?: InputMaybe<StringOperationFilterInput>;
  /** GradP */
  gradP?: InputMaybe<IntOperationFilterInput>;
  /** GradTkDt */
  gradTkDt?: InputMaybe<StringOperationFilterInput>;
  /** GraduationDate */
  graduationDate?: InputMaybe<StringOperationFilterInput>;
  /** Guest */
  guest?: InputMaybe<StringOperationFilterInput>;
  /** Interest */
  interest?: InputMaybe<StringOperationFilterInput>;
  /** KinSch */
  kinSch?: InputMaybe<StringOperationFilterInput>;
  /** MemNo */
  memNo?: InputMaybe<StringOperationFilterInput>;
  /** MorePhoto */
  morePhoto?: InputMaybe<StringOperationFilterInput>;
  /** MorePhotoCdt */
  morePhotoCdt?: InputMaybe<DateTimeOperationFilterInput>;
  /** NameC */
  nameC?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] NameE */
  nameE?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_TempHkDmemChildFilterInput>>;
  /** Organizer */
  organizer?: InputMaybe<StringOperationFilterInput>;
  /** Photo */
  photo?: InputMaybe<StringOperationFilterInput>;
  /** PriSch */
  priSch?: InputMaybe<StringOperationFilterInput>;
  /** Reviser */
  reviser?: InputMaybe<StringOperationFilterInput>;
  /** SecSch */
  secSch?: InputMaybe<StringOperationFilterInput>;
  /** [ID] SeqNo */
  seqNo?: InputMaybe<DecimalOperationFilterInput>;
  /** ShowDtl1 */
  showDtl1?: InputMaybe<StringOperationFilterInput>;
  /** ShowDtl2 */
  showDtl2?: InputMaybe<StringOperationFilterInput>;
  /** ShowDtl3 */
  showDtl3?: InputMaybe<StringOperationFilterInput>;
  /** Strength */
  strength?: InputMaybe<StringOperationFilterInput>;
  /** Udt */
  udt?: InputMaybe<DateTimeOperationFilterInput>;
  /** WfLibraryInuse */
  wfLibraryInuse?: InputMaybe<StringOperationFilterInput>;
};

/** TempHkDmemChild */
export type Club_WorldFamilyClub_TempHkDmemChildInput = {
  /** Achievement */
  achievement?: InputMaybe<Scalars['String']['input']>;
  /** ActDtl1 */
  actDtl1?: InputMaybe<Scalars['String']['input']>;
  /** ActDtl2 */
  actDtl2?: InputMaybe<Scalars['String']['input']>;
  /** ActDtl3 */
  actDtl3?: InputMaybe<Scalars['String']['input']>;
  /** Birthday */
  birthday?: InputMaybe<Scalars['String']['input']>;
  /** CapLvl */
  capLvl?: InputMaybe<Scalars['String']['input']>;
  /** CapPf */
  capPf?: InputMaybe<Scalars['Int']['input']>;
  /** CardMadeDt */
  cardMadeDt?: InputMaybe<Scalars['DateTime']['input']>;
  /** CardPhoto */
  cardPhoto?: InputMaybe<Scalars['String']['input']>;
  /** CardPrint */
  cardPrint?: InputMaybe<Scalars['Int']['input']>;
  /** Cdt */
  cdt?: InputMaybe<Scalars['DateTime']['input']>;
  /** CompRec */
  compRec?: InputMaybe<Scalars['String']['input']>;
  /** CompRecDtl */
  compRecDtl?: InputMaybe<Scalars['String']['input']>;
  /** EmpNameO */
  empNameO?: InputMaybe<Scalars['String']['input']>;
  /** EmpNameR */
  empNameR?: InputMaybe<Scalars['String']['input']>;
  /** Gender */
  gender?: InputMaybe<Scalars['String']['input']>;
  /** GradP */
  gradP?: InputMaybe<Scalars['Int']['input']>;
  /** GradTkDt */
  gradTkDt?: InputMaybe<Scalars['String']['input']>;
  /** GraduationDate */
  graduationDate?: InputMaybe<Scalars['String']['input']>;
  /** Guest */
  guest?: InputMaybe<Scalars['String']['input']>;
  /** Interest */
  interest?: InputMaybe<Scalars['String']['input']>;
  /** KinSch */
  kinSch?: InputMaybe<Scalars['String']['input']>;
  /** MemNo */
  memNo?: InputMaybe<Scalars['String']['input']>;
  /** MorePhoto */
  morePhoto?: InputMaybe<Scalars['String']['input']>;
  /** MorePhotoCdt */
  morePhotoCdt?: InputMaybe<Scalars['DateTime']['input']>;
  /** NameC */
  nameC?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] NameE */
  nameE?: InputMaybe<Scalars['String']['input']>;
  /** Organizer */
  organizer?: InputMaybe<Scalars['String']['input']>;
  /** Photo */
  photo?: InputMaybe<Scalars['String']['input']>;
  /** PriSch */
  priSch?: InputMaybe<Scalars['String']['input']>;
  /** Reviser */
  reviser?: InputMaybe<Scalars['String']['input']>;
  /** SecSch */
  secSch?: InputMaybe<Scalars['String']['input']>;
  /** [ID] SeqNo */
  seqNo: Scalars['Decimal']['input'];
  /** ShowDtl1 */
  showDtl1?: InputMaybe<Scalars['String']['input']>;
  /** ShowDtl2 */
  showDtl2?: InputMaybe<Scalars['String']['input']>;
  /** ShowDtl3 */
  showDtl3?: InputMaybe<Scalars['String']['input']>;
  /** Strength */
  strength?: InputMaybe<Scalars['String']['input']>;
  /** Udt */
  udt?: InputMaybe<Scalars['DateTime']['input']>;
  /** WfLibraryInuse */
  wfLibraryInuse?: InputMaybe<Scalars['String']['input']>;
};

/** TempHkDmemChild */
export type Club_WorldFamilyClub_TempHkDmemChildSortInput = {
  /** Achievement */
  achievement?: InputMaybe<SortEnumType>;
  /** ActDtl1 */
  actDtl1?: InputMaybe<SortEnumType>;
  /** ActDtl2 */
  actDtl2?: InputMaybe<SortEnumType>;
  /** ActDtl3 */
  actDtl3?: InputMaybe<SortEnumType>;
  /** Birthday */
  birthday?: InputMaybe<SortEnumType>;
  /** CapLvl */
  capLvl?: InputMaybe<SortEnumType>;
  /** CapPf */
  capPf?: InputMaybe<SortEnumType>;
  /** CardMadeDt */
  cardMadeDt?: InputMaybe<SortEnumType>;
  /** CardPhoto */
  cardPhoto?: InputMaybe<SortEnumType>;
  /** CardPrint */
  cardPrint?: InputMaybe<SortEnumType>;
  /** Cdt */
  cdt?: InputMaybe<SortEnumType>;
  /** CompRec */
  compRec?: InputMaybe<SortEnumType>;
  /** CompRecDtl */
  compRecDtl?: InputMaybe<SortEnumType>;
  /** EmpNameO */
  empNameO?: InputMaybe<SortEnumType>;
  /** EmpNameR */
  empNameR?: InputMaybe<SortEnumType>;
  /** Gender */
  gender?: InputMaybe<SortEnumType>;
  /** GradP */
  gradP?: InputMaybe<SortEnumType>;
  /** GradTkDt */
  gradTkDt?: InputMaybe<SortEnumType>;
  /** GraduationDate */
  graduationDate?: InputMaybe<SortEnumType>;
  /** Guest */
  guest?: InputMaybe<SortEnumType>;
  /** Interest */
  interest?: InputMaybe<SortEnumType>;
  /** KinSch */
  kinSch?: InputMaybe<SortEnumType>;
  /** MemNo */
  memNo?: InputMaybe<SortEnumType>;
  /** MorePhoto */
  morePhoto?: InputMaybe<SortEnumType>;
  /** MorePhotoCdt */
  morePhotoCdt?: InputMaybe<SortEnumType>;
  /** NameC */
  nameC?: InputMaybe<SortEnumType>;
  /** [NOT NULL] NameE */
  nameE?: InputMaybe<SortEnumType>;
  /** Organizer */
  organizer?: InputMaybe<SortEnumType>;
  /** Photo */
  photo?: InputMaybe<SortEnumType>;
  /** PriSch */
  priSch?: InputMaybe<SortEnumType>;
  /** Reviser */
  reviser?: InputMaybe<SortEnumType>;
  /** SecSch */
  secSch?: InputMaybe<SortEnumType>;
  /** [ID] SeqNo */
  seqNo?: InputMaybe<SortEnumType>;
  /** ShowDtl1 */
  showDtl1?: InputMaybe<SortEnumType>;
  /** ShowDtl2 */
  showDtl2?: InputMaybe<SortEnumType>;
  /** ShowDtl3 */
  showDtl3?: InputMaybe<SortEnumType>;
  /** Strength */
  strength?: InputMaybe<SortEnumType>;
  /** Udt */
  udt?: InputMaybe<SortEnumType>;
  /** WfLibraryInuse */
  wfLibraryInuse?: InputMaybe<SortEnumType>;
};

/** TempHkTeSong */
export type Club_WorldFamilyClub_TempHkTeSong = Node & {
  __typename?: 'Club_WorldFamilyClub_TempHkTeSong';
  /** CapDataNo */
  capDataNo?: Maybe<Scalars['String']['output']>;
  /** CapItemNo */
  capItemNo?: Maybe<Scalars['String']['output']>;
  /** Cdt */
  cdt?: Maybe<Scalars['DateTime']['output']>;
  /** Color */
  color?: Maybe<Scalars['String']['output']>;
  /** Content */
  content?: Maybe<Scalars['String']['output']>;
  /** ContentNew */
  contentNew?: Maybe<Scalars['String']['output']>;
  /** Ctifg */
  ctifg?: Maybe<Scalars['Boolean']['output']>;
  /** [ID] Sno */
  id: Scalars['ID']['output'];
  /** Mp3File */
  mp3File?: Maybe<Scalars['String']['output']>;
  /** Organizer */
  organizer?: Maybe<Scalars['String']['output']>;
  /** Product */
  product?: Maybe<Scalars['String']['output']>;
  /** Reviser */
  reviser?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Seq */
  seq?: Maybe<Scalars['Int']['output']>;
  /** Sname */
  sname?: Maybe<Scalars['String']['output']>;
  /** StopFg */
  stopFg?: Maybe<Scalars['String']['output']>;
  /** Tecategory */
  tecategory?: Maybe<Scalars['String']['output']>;
  /** TmpName */
  tmpName?: Maybe<Scalars['String']['output']>;
  /** Topic */
  topic?: Maybe<Scalars['String']['output']>;
  /** Type */
  type?: Maybe<Scalars['String']['output']>;
  /** TypeId */
  typeId?: Maybe<Scalars['String']['output']>;
  /** TypeValue */
  typeValue?: Maybe<Scalars['String']['output']>;
  /** TypeValue1 */
  typeValue1?: Maybe<Scalars['String']['output']>;
  /** Udt */
  udt?: Maybe<Scalars['DateTime']['output']>;
  /** UseFg */
  useFg?: Maybe<Scalars['Boolean']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_TempHkTeSongConnection = {
  __typename?: 'Club_WorldFamilyClub_TempHkTeSongConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_TempHkTeSongEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_TempHkTeSong>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_TempHkTeSongEdge = {
  __typename?: 'Club_WorldFamilyClub_TempHkTeSongEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_TempHkTeSong;
};

/** TempHkTeSong */
export type Club_WorldFamilyClub_TempHkTeSongFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_TempHkTeSongFilterInput>>;
  /** CapDataNo */
  capDataNo?: InputMaybe<StringOperationFilterInput>;
  /** CapItemNo */
  capItemNo?: InputMaybe<StringOperationFilterInput>;
  /** Cdt */
  cdt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Color */
  color?: InputMaybe<StringOperationFilterInput>;
  /** Content */
  content?: InputMaybe<StringOperationFilterInput>;
  /** ContentNew */
  contentNew?: InputMaybe<StringOperationFilterInput>;
  /** Ctifg */
  ctifg?: InputMaybe<BooleanOperationFilterInput>;
  /** Mp3File */
  mp3File?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_TempHkTeSongFilterInput>>;
  /** Organizer */
  organizer?: InputMaybe<StringOperationFilterInput>;
  /** Product */
  product?: InputMaybe<StringOperationFilterInput>;
  /** Reviser */
  reviser?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] Seq */
  seq?: InputMaybe<IntOperationFilterInput>;
  /** Sname */
  sname?: InputMaybe<StringOperationFilterInput>;
  /** [ID] Sno */
  sno?: InputMaybe<StringOperationFilterInput>;
  /** StopFg */
  stopFg?: InputMaybe<StringOperationFilterInput>;
  /** Tecategory */
  tecategory?: InputMaybe<StringOperationFilterInput>;
  /** TmpName */
  tmpName?: InputMaybe<StringOperationFilterInput>;
  /** Topic */
  topic?: InputMaybe<StringOperationFilterInput>;
  /** Type */
  type?: InputMaybe<StringOperationFilterInput>;
  /** TypeId */
  typeId?: InputMaybe<StringOperationFilterInput>;
  /** TypeValue */
  typeValue?: InputMaybe<StringOperationFilterInput>;
  /** TypeValue1 */
  typeValue1?: InputMaybe<StringOperationFilterInput>;
  /** Udt */
  udt?: InputMaybe<DateTimeOperationFilterInput>;
  /** UseFg */
  useFg?: InputMaybe<BooleanOperationFilterInput>;
};

/** TempHkTeSong */
export type Club_WorldFamilyClub_TempHkTeSongInput = {
  /** CapDataNo */
  capDataNo?: InputMaybe<Scalars['String']['input']>;
  /** CapItemNo */
  capItemNo?: InputMaybe<Scalars['String']['input']>;
  /** Cdt */
  cdt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Color */
  color?: InputMaybe<Scalars['String']['input']>;
  /** Content */
  content?: InputMaybe<Scalars['String']['input']>;
  /** ContentNew */
  contentNew?: InputMaybe<Scalars['String']['input']>;
  /** Ctifg */
  ctifg?: InputMaybe<Scalars['Boolean']['input']>;
  /** Mp3File */
  mp3File?: InputMaybe<Scalars['String']['input']>;
  /** Organizer */
  organizer?: InputMaybe<Scalars['String']['input']>;
  /** Product */
  product?: InputMaybe<Scalars['String']['input']>;
  /** Reviser */
  reviser?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Seq */
  seq?: InputMaybe<Scalars['Int']['input']>;
  /** Sname */
  sname?: InputMaybe<Scalars['String']['input']>;
  /** [ID] Sno */
  sno?: InputMaybe<Scalars['String']['input']>;
  /** StopFg */
  stopFg?: InputMaybe<Scalars['String']['input']>;
  /** Tecategory */
  tecategory?: InputMaybe<Scalars['String']['input']>;
  /** TmpName */
  tmpName?: InputMaybe<Scalars['String']['input']>;
  /** Topic */
  topic?: InputMaybe<Scalars['String']['input']>;
  /** Type */
  type?: InputMaybe<Scalars['String']['input']>;
  /** TypeId */
  typeId?: InputMaybe<Scalars['String']['input']>;
  /** TypeValue */
  typeValue?: InputMaybe<Scalars['String']['input']>;
  /** TypeValue1 */
  typeValue1?: InputMaybe<Scalars['String']['input']>;
  /** Udt */
  udt?: InputMaybe<Scalars['DateTime']['input']>;
  /** UseFg */
  useFg?: InputMaybe<Scalars['Boolean']['input']>;
};

/** TempHkTeSong */
export type Club_WorldFamilyClub_TempHkTeSongSortInput = {
  /** CapDataNo */
  capDataNo?: InputMaybe<SortEnumType>;
  /** CapItemNo */
  capItemNo?: InputMaybe<SortEnumType>;
  /** Cdt */
  cdt?: InputMaybe<SortEnumType>;
  /** Color */
  color?: InputMaybe<SortEnumType>;
  /** Content */
  content?: InputMaybe<SortEnumType>;
  /** ContentNew */
  contentNew?: InputMaybe<SortEnumType>;
  /** Ctifg */
  ctifg?: InputMaybe<SortEnumType>;
  /** Mp3File */
  mp3File?: InputMaybe<SortEnumType>;
  /** Organizer */
  organizer?: InputMaybe<SortEnumType>;
  /** Product */
  product?: InputMaybe<SortEnumType>;
  /** Reviser */
  reviser?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Seq */
  seq?: InputMaybe<SortEnumType>;
  /** Sname */
  sname?: InputMaybe<SortEnumType>;
  /** [ID] Sno */
  sno?: InputMaybe<SortEnumType>;
  /** StopFg */
  stopFg?: InputMaybe<SortEnumType>;
  /** Tecategory */
  tecategory?: InputMaybe<SortEnumType>;
  /** TmpName */
  tmpName?: InputMaybe<SortEnumType>;
  /** Topic */
  topic?: InputMaybe<SortEnumType>;
  /** Type */
  type?: InputMaybe<SortEnumType>;
  /** TypeId */
  typeId?: InputMaybe<SortEnumType>;
  /** TypeValue */
  typeValue?: InputMaybe<SortEnumType>;
  /** TypeValue1 */
  typeValue1?: InputMaybe<SortEnumType>;
  /** Udt */
  udt?: InputMaybe<SortEnumType>;
  /** UseFg */
  useFg?: InputMaybe<SortEnumType>;
};

/** TempHkTematerial */
export type Club_WorldFamilyClub_TempHkTematerial = Node & {
  __typename?: 'Club_WorldFamilyClub_TempHkTematerial';
  /** CapItemCode */
  capItemCode?: Maybe<Scalars['String']['output']>;
  /** Code */
  code?: Maybe<Scalars['String']['output']>;
  /** Color */
  color?: Maybe<Scalars['String']['output']>;
  /** DisplayName */
  displayName?: Maybe<Scalars['String']['output']>;
  /** [ID] Name */
  id: Scalars['ID']['output'];
  /** InUse */
  inUse?: Maybe<Scalars['String']['output']>;
  /** IsPdf */
  isPdf?: Maybe<Scalars['Int']['output']>;
  /** Lyric */
  lyric?: Maybe<Scalars['String']['output']>;
  /** Product */
  product?: Maybe<Scalars['String']['output']>;
  /** Tecategory */
  tecategory?: Maybe<Scalars['String']['output']>;
  /** Tetype */
  tetype?: Maybe<Scalars['String']['output']>;
  /** Udt */
  udt?: Maybe<Scalars['DateTime']['output']>;
  /** Userid */
  userid?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_TempHkTematerialConnection = {
  __typename?: 'Club_WorldFamilyClub_TempHkTematerialConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_TempHkTematerialEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_TempHkTematerial>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_TempHkTematerialEdge = {
  __typename?: 'Club_WorldFamilyClub_TempHkTematerialEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_TempHkTematerial;
};

/** TempHkTematerial */
export type Club_WorldFamilyClub_TempHkTematerialFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_TempHkTematerialFilterInput>>;
  /** CapItemCode */
  capItemCode?: InputMaybe<StringOperationFilterInput>;
  /** Code */
  code?: InputMaybe<StringOperationFilterInput>;
  /** Color */
  color?: InputMaybe<StringOperationFilterInput>;
  /** DisplayName */
  displayName?: InputMaybe<StringOperationFilterInput>;
  /** InUse */
  inUse?: InputMaybe<StringOperationFilterInput>;
  /** IsPdf */
  isPdf?: InputMaybe<IntOperationFilterInput>;
  /** Lyric */
  lyric?: InputMaybe<StringOperationFilterInput>;
  /** [ID] Name */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_TempHkTematerialFilterInput>>;
  /** Product */
  product?: InputMaybe<StringOperationFilterInput>;
  /** Tecategory */
  tecategory?: InputMaybe<StringOperationFilterInput>;
  /** Tetype */
  tetype?: InputMaybe<StringOperationFilterInput>;
  /** Udt */
  udt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Userid */
  userid?: InputMaybe<StringOperationFilterInput>;
};

/** TempHkTematerial */
export type Club_WorldFamilyClub_TempHkTematerialInput = {
  /** CapItemCode */
  capItemCode?: InputMaybe<Scalars['String']['input']>;
  /** Code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Color */
  color?: InputMaybe<Scalars['String']['input']>;
  /** DisplayName */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** InUse */
  inUse?: InputMaybe<Scalars['String']['input']>;
  /** IsPdf */
  isPdf?: InputMaybe<Scalars['Int']['input']>;
  /** Lyric */
  lyric?: InputMaybe<Scalars['String']['input']>;
  /** [ID] Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Product */
  product?: InputMaybe<Scalars['String']['input']>;
  /** Tecategory */
  tecategory?: InputMaybe<Scalars['String']['input']>;
  /** Tetype */
  tetype?: InputMaybe<Scalars['String']['input']>;
  /** Udt */
  udt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Userid */
  userid?: InputMaybe<Scalars['String']['input']>;
};

/** TempHkTematerial */
export type Club_WorldFamilyClub_TempHkTematerialSortInput = {
  /** CapItemCode */
  capItemCode?: InputMaybe<SortEnumType>;
  /** Code */
  code?: InputMaybe<SortEnumType>;
  /** Color */
  color?: InputMaybe<SortEnumType>;
  /** DisplayName */
  displayName?: InputMaybe<SortEnumType>;
  /** InUse */
  inUse?: InputMaybe<SortEnumType>;
  /** IsPdf */
  isPdf?: InputMaybe<SortEnumType>;
  /** Lyric */
  lyric?: InputMaybe<SortEnumType>;
  /** [ID] Name */
  name?: InputMaybe<SortEnumType>;
  /** Product */
  product?: InputMaybe<SortEnumType>;
  /** Tecategory */
  tecategory?: InputMaybe<SortEnumType>;
  /** Tetype */
  tetype?: InputMaybe<SortEnumType>;
  /** Udt */
  udt?: InputMaybe<SortEnumType>;
  /** Userid */
  userid?: InputMaybe<SortEnumType>;
};

/** TempKrFaceCallHist */
export type Club_WorldFamilyClub_TempKrFaceCallHist = Node & {
  __typename?: 'Club_WorldFamilyClub_TempKrFaceCallHist';
  /** [NOT NULL] Cdt */
  cdt?: Maybe<Scalars['DateTime']['output']>;
  /** [ID] Seq */
  id: Scalars['ID']['output'];
  /** [NOT NULL] MemNo */
  memNo?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] SeqD */
  seqD?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_TempKrFaceCallHistConnection = {
  __typename?: 'Club_WorldFamilyClub_TempKrFaceCallHistConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_TempKrFaceCallHistEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_TempKrFaceCallHist>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_TempKrFaceCallHistEdge = {
  __typename?: 'Club_WorldFamilyClub_TempKrFaceCallHistEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_TempKrFaceCallHist;
};

/** TempKrFaceCallHist */
export type Club_WorldFamilyClub_TempKrFaceCallHistFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_TempKrFaceCallHistFilterInput>>;
  /** [NOT NULL] Cdt */
  cdt?: InputMaybe<DateTimeOperationFilterInput>;
  /** [NOT NULL] MemNo */
  memNo?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_TempKrFaceCallHistFilterInput>>;
  /** [ID] Seq */
  seq?: InputMaybe<DecimalOperationFilterInput>;
  /** [NOT NULL] SeqD */
  seqD?: InputMaybe<IntOperationFilterInput>;
};

/** TempKrFaceCallHist */
export type Club_WorldFamilyClub_TempKrFaceCallHistInput = {
  /** [NOT NULL] Cdt */
  cdt?: InputMaybe<Scalars['DateTime']['input']>;
  /** [NOT NULL] MemNo */
  memNo?: InputMaybe<Scalars['String']['input']>;
  /** [ID] Seq */
  seq: Scalars['Decimal']['input'];
  /** [NOT NULL] SeqD */
  seqD?: InputMaybe<Scalars['Int']['input']>;
};

/** TempKrFaceCallHist */
export type Club_WorldFamilyClub_TempKrFaceCallHistSortInput = {
  /** [NOT NULL] Cdt */
  cdt?: InputMaybe<SortEnumType>;
  /** [NOT NULL] MemNo */
  memNo?: InputMaybe<SortEnumType>;
  /** [ID] Seq */
  seq?: InputMaybe<SortEnumType>;
  /** [NOT NULL] SeqD */
  seqD?: InputMaybe<SortEnumType>;
};

/** TempKrFcCrewM */
export type Club_WorldFamilyClub_TempKrFcCrewM = Node & {
  __typename?: 'Club_WorldFamilyClub_TempKrFcCrewM';
  /** Cdt */
  cdt?: Maybe<Scalars['DateTime']['output']>;
  /** CrewName */
  crewName?: Maybe<Scalars['String']['output']>;
  /** DataFrom */
  dataFrom?: Maybe<Scalars['String']['output']>;
  /** EndDt */
  endDt?: Maybe<Scalars['String']['output']>;
  /** [ID] SeqM */
  id: Scalars['ID']['output'];
  /** Organizer */
  organizer?: Maybe<Scalars['String']['output']>;
  /** Photo */
  photo?: Maybe<Scalars['String']['output']>;
  /** Reviser */
  reviser?: Maybe<Scalars['String']['output']>;
  /** StartDt */
  startDt?: Maybe<Scalars['String']['output']>;
  /** TopDt */
  topDt?: Maybe<Scalars['String']['output']>;
  /** Udt */
  udt?: Maybe<Scalars['DateTime']['output']>;
  /** UseFg */
  useFg?: Maybe<Scalars['String']['output']>;
  /** ZippyFlg */
  zippyFlg?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_TempKrFcCrewMConnection = {
  __typename?: 'Club_WorldFamilyClub_TempKrFcCrewMConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_TempKrFcCrewMEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_TempKrFcCrewM>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_TempKrFcCrewMEdge = {
  __typename?: 'Club_WorldFamilyClub_TempKrFcCrewMEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_TempKrFcCrewM;
};

/** TempKrFcCrewM */
export type Club_WorldFamilyClub_TempKrFcCrewMFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_TempKrFcCrewMFilterInput>>;
  /** Cdt */
  cdt?: InputMaybe<DateTimeOperationFilterInput>;
  /** CrewName */
  crewName?: InputMaybe<StringOperationFilterInput>;
  /** DataFrom */
  dataFrom?: InputMaybe<StringOperationFilterInput>;
  /** EndDt */
  endDt?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_TempKrFcCrewMFilterInput>>;
  /** Organizer */
  organizer?: InputMaybe<StringOperationFilterInput>;
  /** Photo */
  photo?: InputMaybe<StringOperationFilterInput>;
  /** Reviser */
  reviser?: InputMaybe<StringOperationFilterInput>;
  /** [ID] SeqM */
  seqM?: InputMaybe<IntOperationFilterInput>;
  /** StartDt */
  startDt?: InputMaybe<StringOperationFilterInput>;
  /** TopDt */
  topDt?: InputMaybe<StringOperationFilterInput>;
  /** Udt */
  udt?: InputMaybe<DateTimeOperationFilterInput>;
  /** UseFg */
  useFg?: InputMaybe<StringOperationFilterInput>;
  /** ZippyFlg */
  zippyFlg?: InputMaybe<StringOperationFilterInput>;
};

/** TempKrFcCrewM */
export type Club_WorldFamilyClub_TempKrFcCrewMInput = {
  /** Cdt */
  cdt?: InputMaybe<Scalars['DateTime']['input']>;
  /** CrewName */
  crewName?: InputMaybe<Scalars['String']['input']>;
  /** DataFrom */
  dataFrom?: InputMaybe<Scalars['String']['input']>;
  /** EndDt */
  endDt?: InputMaybe<Scalars['String']['input']>;
  /** Organizer */
  organizer?: InputMaybe<Scalars['String']['input']>;
  /** Photo */
  photo?: InputMaybe<Scalars['String']['input']>;
  /** Reviser */
  reviser?: InputMaybe<Scalars['String']['input']>;
  /** [ID] SeqM */
  seqM?: InputMaybe<Scalars['Int']['input']>;
  /** StartDt */
  startDt?: InputMaybe<Scalars['String']['input']>;
  /** TopDt */
  topDt?: InputMaybe<Scalars['String']['input']>;
  /** Udt */
  udt?: InputMaybe<Scalars['DateTime']['input']>;
  /** UseFg */
  useFg?: InputMaybe<Scalars['String']['input']>;
  /** ZippyFlg */
  zippyFlg?: InputMaybe<Scalars['String']['input']>;
};

/** TempKrFcCrewM */
export type Club_WorldFamilyClub_TempKrFcCrewMSortInput = {
  /** Cdt */
  cdt?: InputMaybe<SortEnumType>;
  /** CrewName */
  crewName?: InputMaybe<SortEnumType>;
  /** DataFrom */
  dataFrom?: InputMaybe<SortEnumType>;
  /** EndDt */
  endDt?: InputMaybe<SortEnumType>;
  /** Organizer */
  organizer?: InputMaybe<SortEnumType>;
  /** Photo */
  photo?: InputMaybe<SortEnumType>;
  /** Reviser */
  reviser?: InputMaybe<SortEnumType>;
  /** [ID] SeqM */
  seqM?: InputMaybe<SortEnumType>;
  /** StartDt */
  startDt?: InputMaybe<SortEnumType>;
  /** TopDt */
  topDt?: InputMaybe<SortEnumType>;
  /** Udt */
  udt?: InputMaybe<SortEnumType>;
  /** UseFg */
  useFg?: InputMaybe<SortEnumType>;
  /** ZippyFlg */
  zippyFlg?: InputMaybe<SortEnumType>;
};

/** TempKrFcsongCrew */
export type Club_WorldFamilyClub_TempKrFcsongCrew = Node & {
  __typename?: 'Club_WorldFamilyClub_TempKrFcsongCrew';
  /** Cdt */
  cdt?: Maybe<Scalars['DateTime']['output']>;
  /** Christmas */
  christmas?: Maybe<Scalars['String']['output']>;
  /** CrewName */
  crewName?: Maybe<Scalars['String']['output']>;
  /** EndDt */
  endDt?: Maybe<Scalars['String']['output']>;
  /** [ID] Seq */
  id: Scalars['ID']['output'];
  /** Organizer */
  organizer?: Maybe<Scalars['String']['output']>;
  /** Pumpkin */
  pumpkin?: Maybe<Scalars['String']['output']>;
  /** Reviser */
  reviser?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] SeqM */
  seqM?: Maybe<Scalars['Int']['output']>;
  /** Sno */
  sno?: Maybe<Scalars['String']['output']>;
  /** StartDt */
  startDt?: Maybe<Scalars['String']['output']>;
  /** Udt */
  udt?: Maybe<Scalars['DateTime']['output']>;
  /** Url */
  url?: Maybe<Scalars['String']['output']>;
  /** UrlAnd */
  urlAnd?: Maybe<Scalars['String']['output']>;
  /** UrlOld */
  urlOld?: Maybe<Scalars['String']['output']>;
  /** UseFg */
  useFg?: Maybe<Scalars['String']['output']>;
  /** VideoLink */
  videoLink?: Maybe<Scalars['String']['output']>;
  /** VideoNo */
  videoNo?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_TempKrFcsongCrewConnection = {
  __typename?: 'Club_WorldFamilyClub_TempKrFcsongCrewConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_TempKrFcsongCrewEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_TempKrFcsongCrew>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_TempKrFcsongCrewEdge = {
  __typename?: 'Club_WorldFamilyClub_TempKrFcsongCrewEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_TempKrFcsongCrew;
};

/** TempKrFcsongCrew */
export type Club_WorldFamilyClub_TempKrFcsongCrewFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_TempKrFcsongCrewFilterInput>>;
  /** Cdt */
  cdt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Christmas */
  christmas?: InputMaybe<StringOperationFilterInput>;
  /** CrewName */
  crewName?: InputMaybe<StringOperationFilterInput>;
  /** EndDt */
  endDt?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_TempKrFcsongCrewFilterInput>>;
  /** Organizer */
  organizer?: InputMaybe<StringOperationFilterInput>;
  /** Pumpkin */
  pumpkin?: InputMaybe<StringOperationFilterInput>;
  /** Reviser */
  reviser?: InputMaybe<StringOperationFilterInput>;
  /** [ID] Seq */
  seq?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] SeqM */
  seqM?: InputMaybe<IntOperationFilterInput>;
  /** Sno */
  sno?: InputMaybe<StringOperationFilterInput>;
  /** StartDt */
  startDt?: InputMaybe<StringOperationFilterInput>;
  /** Udt */
  udt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Url */
  url?: InputMaybe<StringOperationFilterInput>;
  /** UrlAnd */
  urlAnd?: InputMaybe<StringOperationFilterInput>;
  /** UrlOld */
  urlOld?: InputMaybe<StringOperationFilterInput>;
  /** UseFg */
  useFg?: InputMaybe<StringOperationFilterInput>;
  /** VideoLink */
  videoLink?: InputMaybe<StringOperationFilterInput>;
  /** VideoNo */
  videoNo?: InputMaybe<StringOperationFilterInput>;
};

/** TempKrFcsongCrew */
export type Club_WorldFamilyClub_TempKrFcsongCrewInput = {
  /** Cdt */
  cdt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Christmas */
  christmas?: InputMaybe<Scalars['String']['input']>;
  /** CrewName */
  crewName?: InputMaybe<Scalars['String']['input']>;
  /** EndDt */
  endDt?: InputMaybe<Scalars['String']['input']>;
  /** Organizer */
  organizer?: InputMaybe<Scalars['String']['input']>;
  /** Pumpkin */
  pumpkin?: InputMaybe<Scalars['String']['input']>;
  /** Reviser */
  reviser?: InputMaybe<Scalars['String']['input']>;
  /** [ID] Seq */
  seq?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] SeqM */
  seqM?: InputMaybe<Scalars['Int']['input']>;
  /** Sno */
  sno?: InputMaybe<Scalars['String']['input']>;
  /** StartDt */
  startDt?: InputMaybe<Scalars['String']['input']>;
  /** Udt */
  udt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Url */
  url?: InputMaybe<Scalars['String']['input']>;
  /** UrlAnd */
  urlAnd?: InputMaybe<Scalars['String']['input']>;
  /** UrlOld */
  urlOld?: InputMaybe<Scalars['String']['input']>;
  /** UseFg */
  useFg?: InputMaybe<Scalars['String']['input']>;
  /** VideoLink */
  videoLink?: InputMaybe<Scalars['String']['input']>;
  /** VideoNo */
  videoNo?: InputMaybe<Scalars['String']['input']>;
};

/** TempKrFcsongCrew */
export type Club_WorldFamilyClub_TempKrFcsongCrewSortInput = {
  /** Cdt */
  cdt?: InputMaybe<SortEnumType>;
  /** Christmas */
  christmas?: InputMaybe<SortEnumType>;
  /** CrewName */
  crewName?: InputMaybe<SortEnumType>;
  /** EndDt */
  endDt?: InputMaybe<SortEnumType>;
  /** Organizer */
  organizer?: InputMaybe<SortEnumType>;
  /** Pumpkin */
  pumpkin?: InputMaybe<SortEnumType>;
  /** Reviser */
  reviser?: InputMaybe<SortEnumType>;
  /** [ID] Seq */
  seq?: InputMaybe<SortEnumType>;
  /** [NOT NULL] SeqM */
  seqM?: InputMaybe<SortEnumType>;
  /** Sno */
  sno?: InputMaybe<SortEnumType>;
  /** StartDt */
  startDt?: InputMaybe<SortEnumType>;
  /** Udt */
  udt?: InputMaybe<SortEnumType>;
  /** Url */
  url?: InputMaybe<SortEnumType>;
  /** UrlAnd */
  urlAnd?: InputMaybe<SortEnumType>;
  /** UrlOld */
  urlOld?: InputMaybe<SortEnumType>;
  /** UseFg */
  useFg?: InputMaybe<SortEnumType>;
  /** VideoLink */
  videoLink?: InputMaybe<SortEnumType>;
  /** VideoNo */
  videoNo?: InputMaybe<SortEnumType>;
};

/** TempKrMyFavorite */
export type Club_WorldFamilyClub_TempKrMyFavorite = Node & {
  __typename?: 'Club_WorldFamilyClub_TempKrMyFavorite';
  /** Cdt */
  cdt?: Maybe<Scalars['DateTime']['output']>;
  /** FavoriteType */
  favoriteType?: Maybe<Scalars['String']['output']>;
  /** [ID] Seq */
  id: Scalars['ID']['output'];
  /** LinkNo */
  linkNo?: Maybe<Scalars['String']['output']>;
  /** MemberNo */
  memberNo?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_TempKrMyFavoriteConnection = {
  __typename?: 'Club_WorldFamilyClub_TempKrMyFavoriteConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_TempKrMyFavoriteEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_TempKrMyFavorite>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_TempKrMyFavoriteEdge = {
  __typename?: 'Club_WorldFamilyClub_TempKrMyFavoriteEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_TempKrMyFavorite;
};

/** TempKrMyFavorite */
export type Club_WorldFamilyClub_TempKrMyFavoriteFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_TempKrMyFavoriteFilterInput>>;
  /** Cdt */
  cdt?: InputMaybe<DateTimeOperationFilterInput>;
  /** FavoriteType */
  favoriteType?: InputMaybe<StringOperationFilterInput>;
  /** LinkNo */
  linkNo?: InputMaybe<StringOperationFilterInput>;
  /** MemberNo */
  memberNo?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_TempKrMyFavoriteFilterInput>>;
  /** [ID] Seq */
  seq?: InputMaybe<IntOperationFilterInput>;
};

/** TempKrMyFavorite */
export type Club_WorldFamilyClub_TempKrMyFavoriteInput = {
  /** Cdt */
  cdt?: InputMaybe<Scalars['DateTime']['input']>;
  /** FavoriteType */
  favoriteType?: InputMaybe<Scalars['String']['input']>;
  /** LinkNo */
  linkNo?: InputMaybe<Scalars['String']['input']>;
  /** MemberNo */
  memberNo?: InputMaybe<Scalars['String']['input']>;
  /** [ID] Seq */
  seq?: InputMaybe<Scalars['Int']['input']>;
};

/** TempKrMyFavorite */
export type Club_WorldFamilyClub_TempKrMyFavoriteSortInput = {
  /** Cdt */
  cdt?: InputMaybe<SortEnumType>;
  /** FavoriteType */
  favoriteType?: InputMaybe<SortEnumType>;
  /** LinkNo */
  linkNo?: InputMaybe<SortEnumType>;
  /** MemberNo */
  memberNo?: InputMaybe<SortEnumType>;
  /** [ID] Seq */
  seq?: InputMaybe<SortEnumType>;
};

/** TempKrTeSong */
export type Club_WorldFamilyClub_TempKrTeSong = Node & {
  __typename?: 'Club_WorldFamilyClub_TempKrTeSong';
  /** CdNo */
  cdNo?: Maybe<Scalars['String']['output']>;
  /** Cdt */
  cdt?: Maybe<Scalars['DateTime']['output']>;
  /** Color */
  color?: Maybe<Scalars['String']['output']>;
  /** Content */
  content?: Maybe<Scalars['String']['output']>;
  /** ContentMain */
  contentMain?: Maybe<Scalars['String']['output']>;
  /** ContentNew */
  contentNew?: Maybe<Scalars['String']['output']>;
  /** [ID] Sno */
  id: Scalars['ID']['output'];
  /** Mp3File */
  mp3File?: Maybe<Scalars['String']['output']>;
  /** Organizer */
  organizer?: Maybe<Scalars['String']['output']>;
  /** Product */
  product?: Maybe<Scalars['String']['output']>;
  /** Reviser */
  reviser?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Seq */
  seq?: Maybe<Scalars['Int']['output']>;
  /** Sname */
  sname?: Maybe<Scalars['String']['output']>;
  /** Sno1 */
  sno1?: Maybe<Scalars['String']['output']>;
  /** StopFg */
  stopFg?: Maybe<Scalars['String']['output']>;
  /** Tecategory */
  tecategory?: Maybe<Scalars['String']['output']>;
  /** Topic */
  topic?: Maybe<Scalars['String']['output']>;
  /** Type */
  type?: Maybe<Scalars['String']['output']>;
  /** TypeId */
  typeId?: Maybe<Scalars['String']['output']>;
  /** TypeValue */
  typeValue?: Maybe<Scalars['String']['output']>;
  /** TypeValue1 */
  typeValue1?: Maybe<Scalars['String']['output']>;
  /** Udt */
  udt?: Maybe<Scalars['DateTime']['output']>;
  /** UseFg */
  useFg?: Maybe<Scalars['Boolean']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_TempKrTeSongConnection = {
  __typename?: 'Club_WorldFamilyClub_TempKrTeSongConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_TempKrTeSongEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_TempKrTeSong>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_TempKrTeSongEdge = {
  __typename?: 'Club_WorldFamilyClub_TempKrTeSongEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_TempKrTeSong;
};

/** TempKrTeSong */
export type Club_WorldFamilyClub_TempKrTeSongFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_TempKrTeSongFilterInput>>;
  /** CdNo */
  cdNo?: InputMaybe<StringOperationFilterInput>;
  /** Cdt */
  cdt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Color */
  color?: InputMaybe<StringOperationFilterInput>;
  /** Content */
  content?: InputMaybe<StringOperationFilterInput>;
  /** ContentMain */
  contentMain?: InputMaybe<StringOperationFilterInput>;
  /** ContentNew */
  contentNew?: InputMaybe<StringOperationFilterInput>;
  /** Mp3File */
  mp3File?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_TempKrTeSongFilterInput>>;
  /** Organizer */
  organizer?: InputMaybe<StringOperationFilterInput>;
  /** Product */
  product?: InputMaybe<StringOperationFilterInput>;
  /** Reviser */
  reviser?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] Seq */
  seq?: InputMaybe<IntOperationFilterInput>;
  /** Sname */
  sname?: InputMaybe<StringOperationFilterInput>;
  /** [ID] Sno */
  sno?: InputMaybe<StringOperationFilterInput>;
  /** Sno1 */
  sno1?: InputMaybe<StringOperationFilterInput>;
  /** StopFg */
  stopFg?: InputMaybe<StringOperationFilterInput>;
  /** Tecategory */
  tecategory?: InputMaybe<StringOperationFilterInput>;
  /** Topic */
  topic?: InputMaybe<StringOperationFilterInput>;
  /** Type */
  type?: InputMaybe<StringOperationFilterInput>;
  /** TypeId */
  typeId?: InputMaybe<StringOperationFilterInput>;
  /** TypeValue */
  typeValue?: InputMaybe<StringOperationFilterInput>;
  /** TypeValue1 */
  typeValue1?: InputMaybe<StringOperationFilterInput>;
  /** Udt */
  udt?: InputMaybe<DateTimeOperationFilterInput>;
  /** UseFg */
  useFg?: InputMaybe<BooleanOperationFilterInput>;
};

/** TempKrTeSong */
export type Club_WorldFamilyClub_TempKrTeSongInput = {
  /** CdNo */
  cdNo?: InputMaybe<Scalars['String']['input']>;
  /** Cdt */
  cdt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Color */
  color?: InputMaybe<Scalars['String']['input']>;
  /** Content */
  content?: InputMaybe<Scalars['String']['input']>;
  /** ContentMain */
  contentMain?: InputMaybe<Scalars['String']['input']>;
  /** ContentNew */
  contentNew?: InputMaybe<Scalars['String']['input']>;
  /** Mp3File */
  mp3File?: InputMaybe<Scalars['String']['input']>;
  /** Organizer */
  organizer?: InputMaybe<Scalars['String']['input']>;
  /** Product */
  product?: InputMaybe<Scalars['String']['input']>;
  /** Reviser */
  reviser?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Seq */
  seq?: InputMaybe<Scalars['Int']['input']>;
  /** Sname */
  sname?: InputMaybe<Scalars['String']['input']>;
  /** [ID] Sno */
  sno?: InputMaybe<Scalars['String']['input']>;
  /** Sno1 */
  sno1?: InputMaybe<Scalars['String']['input']>;
  /** StopFg */
  stopFg?: InputMaybe<Scalars['String']['input']>;
  /** Tecategory */
  tecategory?: InputMaybe<Scalars['String']['input']>;
  /** Topic */
  topic?: InputMaybe<Scalars['String']['input']>;
  /** Type */
  type?: InputMaybe<Scalars['String']['input']>;
  /** TypeId */
  typeId?: InputMaybe<Scalars['String']['input']>;
  /** TypeValue */
  typeValue?: InputMaybe<Scalars['String']['input']>;
  /** TypeValue1 */
  typeValue1?: InputMaybe<Scalars['String']['input']>;
  /** Udt */
  udt?: InputMaybe<Scalars['DateTime']['input']>;
  /** UseFg */
  useFg?: InputMaybe<Scalars['Boolean']['input']>;
};

/** TempKrTeSong */
export type Club_WorldFamilyClub_TempKrTeSongSortInput = {
  /** CdNo */
  cdNo?: InputMaybe<SortEnumType>;
  /** Cdt */
  cdt?: InputMaybe<SortEnumType>;
  /** Color */
  color?: InputMaybe<SortEnumType>;
  /** Content */
  content?: InputMaybe<SortEnumType>;
  /** ContentMain */
  contentMain?: InputMaybe<SortEnumType>;
  /** ContentNew */
  contentNew?: InputMaybe<SortEnumType>;
  /** Mp3File */
  mp3File?: InputMaybe<SortEnumType>;
  /** Organizer */
  organizer?: InputMaybe<SortEnumType>;
  /** Product */
  product?: InputMaybe<SortEnumType>;
  /** Reviser */
  reviser?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Seq */
  seq?: InputMaybe<SortEnumType>;
  /** Sname */
  sname?: InputMaybe<SortEnumType>;
  /** [ID] Sno */
  sno?: InputMaybe<SortEnumType>;
  /** Sno1 */
  sno1?: InputMaybe<SortEnumType>;
  /** StopFg */
  stopFg?: InputMaybe<SortEnumType>;
  /** Tecategory */
  tecategory?: InputMaybe<SortEnumType>;
  /** Topic */
  topic?: InputMaybe<SortEnumType>;
  /** Type */
  type?: InputMaybe<SortEnumType>;
  /** TypeId */
  typeId?: InputMaybe<SortEnumType>;
  /** TypeValue */
  typeValue?: InputMaybe<SortEnumType>;
  /** TypeValue1 */
  typeValue1?: InputMaybe<SortEnumType>;
  /** Udt */
  udt?: InputMaybe<SortEnumType>;
  /** UseFg */
  useFg?: InputMaybe<SortEnumType>;
};

/** TempKrWfeClubMemberChild */
export type Club_WorldFamilyClub_TempKrWfeClubMemberChild = Node & {
  __typename?: 'Club_WorldFamilyClub_TempKrWfeClubMemberChild';
  /** [NOT NULL] Birthday */
  birthday?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Cap */
  cap?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Childname */
  childname?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] FamilyName */
  familyName?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Height */
  height?: Maybe<Scalars['Decimal']['output']>;
  /** [ID] Uid */
  id: Scalars['ID']['output'];
  /** [NOT NULL] MemNo */
  memNo?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] MemberUid */
  memberUid?: Maybe<Scalars['Int']['output']>;
  /** [NOT NULL] NameEng */
  nameEng?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] PhotoName */
  photoName?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Regdatetab */
  regdatetab?: Maybe<Scalars['DateTime']['output']>;
  /** [NOT NULL] Sex */
  sex?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Weight */
  weight?: Maybe<Scalars['Decimal']['output']>;
  /** [NOT NULL] YearGraduated */
  yearGraduated?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_TempKrWfeClubMemberChildConnection = {
  __typename?: 'Club_WorldFamilyClub_TempKrWfeClubMemberChildConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_TempKrWfeClubMemberChildEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_TempKrWfeClubMemberChild>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_TempKrWfeClubMemberChildEdge = {
  __typename?: 'Club_WorldFamilyClub_TempKrWfeClubMemberChildEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_TempKrWfeClubMemberChild;
};

/** TempKrWfeClubMemberChild */
export type Club_WorldFamilyClub_TempKrWfeClubMemberChildFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_TempKrWfeClubMemberChildFilterInput>>;
  /** [NOT NULL] Birthday */
  birthday?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] Cap */
  cap?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] Childname */
  childname?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] FamilyName */
  familyName?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] Height */
  height?: InputMaybe<DecimalOperationFilterInput>;
  /** [NOT NULL] MemNo */
  memNo?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] MemberUid */
  memberUid?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] NameEng */
  nameEng?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_TempKrWfeClubMemberChildFilterInput>>;
  /** [NOT NULL] PhotoName */
  photoName?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] Regdatetab */
  regdatetab?: InputMaybe<DateTimeOperationFilterInput>;
  /** [NOT NULL] Sex */
  sex?: InputMaybe<StringOperationFilterInput>;
  /** [ID] Uid */
  uid?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] Weight */
  weight?: InputMaybe<DecimalOperationFilterInput>;
  /** [NOT NULL] YearGraduated */
  yearGraduated?: InputMaybe<StringOperationFilterInput>;
};

/** TempKrWfeClubMemberChild */
export type Club_WorldFamilyClub_TempKrWfeClubMemberChildInput = {
  /** [NOT NULL] Birthday */
  birthday?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Cap */
  cap?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Childname */
  childname?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] FamilyName */
  familyName?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Height */
  height?: InputMaybe<Scalars['Decimal']['input']>;
  /** [NOT NULL] MemNo */
  memNo?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] MemberUid */
  memberUid?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] NameEng */
  nameEng?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] PhotoName */
  photoName?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Regdatetab */
  regdatetab?: InputMaybe<Scalars['DateTime']['input']>;
  /** [NOT NULL] Sex */
  sex?: InputMaybe<Scalars['String']['input']>;
  /** [ID] Uid */
  uid?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] Weight */
  weight?: InputMaybe<Scalars['Decimal']['input']>;
  /** [NOT NULL] YearGraduated */
  yearGraduated?: InputMaybe<Scalars['String']['input']>;
};

/** TempKrWfeClubMemberChild */
export type Club_WorldFamilyClub_TempKrWfeClubMemberChildSortInput = {
  /** [NOT NULL] Birthday */
  birthday?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Cap */
  cap?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Childname */
  childname?: InputMaybe<SortEnumType>;
  /** [NOT NULL] FamilyName */
  familyName?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Height */
  height?: InputMaybe<SortEnumType>;
  /** [NOT NULL] MemNo */
  memNo?: InputMaybe<SortEnumType>;
  /** [NOT NULL] MemberUid */
  memberUid?: InputMaybe<SortEnumType>;
  /** [NOT NULL] NameEng */
  nameEng?: InputMaybe<SortEnumType>;
  /** [NOT NULL] PhotoName */
  photoName?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Regdatetab */
  regdatetab?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Sex */
  sex?: InputMaybe<SortEnumType>;
  /** [ID] Uid */
  uid?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Weight */
  weight?: InputMaybe<SortEnumType>;
  /** [NOT NULL] YearGraduated */
  yearGraduated?: InputMaybe<SortEnumType>;
};

/** TempTalkAlongCard */
export type Club_WorldFamilyClub_TempTalkAlongCard = Node & {
  __typename?: 'Club_WorldFamilyClub_TempTalkAlongCard';
  /** CardNumber */
  cardNumber?: Maybe<Scalars['Float']['output']>;
  /** F4 */
  f4?: Maybe<Scalars['String']['output']>;
  /** F5 */
  f5?: Maybe<Scalars['String']['output']>;
  /** F6 */
  f6?: Maybe<Scalars['String']['output']>;
  /** [ID] TalkAlongCardId */
  id: Scalars['ID']['output'];
  /** Word */
  word?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_TempTalkAlongCardConnection = {
  __typename?: 'Club_WorldFamilyClub_TempTalkAlongCardConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_TempTalkAlongCardEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_TempTalkAlongCard>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_TempTalkAlongCardEdge = {
  __typename?: 'Club_WorldFamilyClub_TempTalkAlongCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_TempTalkAlongCard;
};

/** TempTalkAlongCard */
export type Club_WorldFamilyClub_TempTalkAlongCardFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_TempTalkAlongCardFilterInput>>;
  /** CardNumber */
  cardNumber?: InputMaybe<FloatOperationFilterInput>;
  /** F4 */
  f4?: InputMaybe<StringOperationFilterInput>;
  /** F5 */
  f5?: InputMaybe<StringOperationFilterInput>;
  /** F6 */
  f6?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_TempTalkAlongCardFilterInput>>;
  /** [ID] TalkAlongCardId */
  talkAlongCardId?: InputMaybe<StringOperationFilterInput>;
  /** Word */
  word?: InputMaybe<StringOperationFilterInput>;
};

/** TempTalkAlongCard */
export type Club_WorldFamilyClub_TempTalkAlongCardInput = {
  /** CardNumber */
  cardNumber?: InputMaybe<Scalars['Float']['input']>;
  /** F4 */
  f4?: InputMaybe<Scalars['String']['input']>;
  /** F5 */
  f5?: InputMaybe<Scalars['String']['input']>;
  /** F6 */
  f6?: InputMaybe<Scalars['String']['input']>;
  /** [ID] TalkAlongCardId */
  talkAlongCardId: Scalars['String']['input'];
  /** Word */
  word?: InputMaybe<Scalars['String']['input']>;
};

/** TempTalkAlongCard */
export type Club_WorldFamilyClub_TempTalkAlongCardSortInput = {
  /** CardNumber */
  cardNumber?: InputMaybe<SortEnumType>;
  /** F4 */
  f4?: InputMaybe<SortEnumType>;
  /** F5 */
  f5?: InputMaybe<SortEnumType>;
  /** F6 */
  f6?: InputMaybe<SortEnumType>;
  /** [ID] TalkAlongCardId */
  talkAlongCardId?: InputMaybe<SortEnumType>;
  /** Word */
  word?: InputMaybe<SortEnumType>;
};

/** TempTwCambridge */
export type Club_WorldFamilyClub_TempTwCambridge = Node & {
  __typename?: 'Club_WorldFamilyClub_TempTwCambridge';
  /** [NOT NULL] ChildSeq */
  childSeq?: Maybe<Scalars['Short']['output']>;
  /** [NOT NULL] Height */
  height?: Maybe<Scalars['String']['output']>;
  /** [ID] Year */
  id: Scalars['ID']['output'];
  /** [NOT NULL] MemberNo */
  memberNo?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Weight */
  weight?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_TempTwCambridgeConnection = {
  __typename?: 'Club_WorldFamilyClub_TempTwCambridgeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_TempTwCambridgeEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_TempTwCambridge>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_TempTwCambridgeEdge = {
  __typename?: 'Club_WorldFamilyClub_TempTwCambridgeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_TempTwCambridge;
};

/** TempTwCambridge */
export type Club_WorldFamilyClub_TempTwCambridgeFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_TempTwCambridgeFilterInput>>;
  /** [NOT NULL] ChildSeq */
  childSeq?: InputMaybe<ShortOperationFilterInput>;
  /** [NOT NULL] Height */
  height?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] MemberNo */
  memberNo?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_TempTwCambridgeFilterInput>>;
  /** [NOT NULL] Weight */
  weight?: InputMaybe<StringOperationFilterInput>;
  /** [ID] Year */
  year?: InputMaybe<ShortOperationFilterInput>;
};

/** TempTwCambridge */
export type Club_WorldFamilyClub_TempTwCambridgeInput = {
  /** [NOT NULL] ChildSeq */
  childSeq?: InputMaybe<Scalars['Short']['input']>;
  /** [NOT NULL] Height */
  height?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] MemberNo */
  memberNo?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Weight */
  weight?: InputMaybe<Scalars['String']['input']>;
  /** [ID] Year */
  year: Scalars['Short']['input'];
};

/** TempTwCambridge */
export type Club_WorldFamilyClub_TempTwCambridgeSortInput = {
  /** [NOT NULL] ChildSeq */
  childSeq?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Height */
  height?: InputMaybe<SortEnumType>;
  /** [NOT NULL] MemberNo */
  memberNo?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Weight */
  weight?: InputMaybe<SortEnumType>;
  /** [ID] Year */
  year?: InputMaybe<SortEnumType>;
};

/** TempTwFaceCallHist */
export type Club_WorldFamilyClub_TempTwFaceCallHist = Node & {
  __typename?: 'Club_WorldFamilyClub_TempTwFaceCallHist';
  /** [NOT NULL] Cdt */
  cdt?: Maybe<Scalars['DateTime']['output']>;
  /** [ID] Seq */
  id: Scalars['ID']['output'];
  /** [NOT NULL] MemNo */
  memNo?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] SeqD */
  seqD?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_TempTwFaceCallHistConnection = {
  __typename?: 'Club_WorldFamilyClub_TempTwFaceCallHistConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_TempTwFaceCallHistEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_TempTwFaceCallHist>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_TempTwFaceCallHistEdge = {
  __typename?: 'Club_WorldFamilyClub_TempTwFaceCallHistEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_TempTwFaceCallHist;
};

/** TempTwFaceCallHist */
export type Club_WorldFamilyClub_TempTwFaceCallHistFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_TempTwFaceCallHistFilterInput>>;
  /** [NOT NULL] Cdt */
  cdt?: InputMaybe<DateTimeOperationFilterInput>;
  /** [NOT NULL] MemNo */
  memNo?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_TempTwFaceCallHistFilterInput>>;
  /** [ID] Seq */
  seq?: InputMaybe<DecimalOperationFilterInput>;
  /** [NOT NULL] SeqD */
  seqD?: InputMaybe<IntOperationFilterInput>;
};

/** TempTwFaceCallHist */
export type Club_WorldFamilyClub_TempTwFaceCallHistInput = {
  /** [NOT NULL] Cdt */
  cdt?: InputMaybe<Scalars['DateTime']['input']>;
  /** [NOT NULL] MemNo */
  memNo?: InputMaybe<Scalars['String']['input']>;
  /** [ID] Seq */
  seq: Scalars['Decimal']['input'];
  /** [NOT NULL] SeqD */
  seqD?: InputMaybe<Scalars['Int']['input']>;
};

/** TempTwFaceCallHist */
export type Club_WorldFamilyClub_TempTwFaceCallHistSortInput = {
  /** [NOT NULL] Cdt */
  cdt?: InputMaybe<SortEnumType>;
  /** [NOT NULL] MemNo */
  memNo?: InputMaybe<SortEnumType>;
  /** [ID] Seq */
  seq?: InputMaybe<SortEnumType>;
  /** [NOT NULL] SeqD */
  seqD?: InputMaybe<SortEnumType>;
};

/** TempTwFcCrewM */
export type Club_WorldFamilyClub_TempTwFcCrewM = Node & {
  __typename?: 'Club_WorldFamilyClub_TempTwFcCrewM';
  /** Cdt */
  cdt?: Maybe<Scalars['DateTime']['output']>;
  /** [NOT NULL] Christmas */
  christmas?: Maybe<Scalars['Boolean']['output']>;
  /** CrewName */
  crewName?: Maybe<Scalars['String']['output']>;
  /** DataFrom */
  dataFrom?: Maybe<Scalars['String']['output']>;
  /** EndDt */
  endDt?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Halloween */
  halloween?: Maybe<Scalars['Boolean']['output']>;
  /** [ID] SeqM */
  id: Scalars['ID']['output'];
  /** Organizer */
  organizer?: Maybe<Scalars['String']['output']>;
  /** Photo */
  photo?: Maybe<Scalars['String']['output']>;
  /** Reviser */
  reviser?: Maybe<Scalars['String']['output']>;
  /** StartDt */
  startDt?: Maybe<Scalars['String']['output']>;
  /** TopDt */
  topDt?: Maybe<Scalars['String']['output']>;
  /** Udt */
  udt?: Maybe<Scalars['DateTime']['output']>;
  /** UseFg */
  useFg?: Maybe<Scalars['String']['output']>;
  /** ZippyFlg */
  zippyFlg?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_TempTwFcCrewMConnection = {
  __typename?: 'Club_WorldFamilyClub_TempTwFcCrewMConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_TempTwFcCrewMEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_TempTwFcCrewM>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_TempTwFcCrewMEdge = {
  __typename?: 'Club_WorldFamilyClub_TempTwFcCrewMEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_TempTwFcCrewM;
};

/** TempTwFcCrewM */
export type Club_WorldFamilyClub_TempTwFcCrewMFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_TempTwFcCrewMFilterInput>>;
  /** Cdt */
  cdt?: InputMaybe<DateTimeOperationFilterInput>;
  /** [NOT NULL] Christmas */
  christmas?: InputMaybe<BooleanOperationFilterInput>;
  /** CrewName */
  crewName?: InputMaybe<StringOperationFilterInput>;
  /** DataFrom */
  dataFrom?: InputMaybe<StringOperationFilterInput>;
  /** EndDt */
  endDt?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] Halloween */
  halloween?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_TempTwFcCrewMFilterInput>>;
  /** Organizer */
  organizer?: InputMaybe<StringOperationFilterInput>;
  /** Photo */
  photo?: InputMaybe<StringOperationFilterInput>;
  /** Reviser */
  reviser?: InputMaybe<StringOperationFilterInput>;
  /** [ID] SeqM */
  seqM?: InputMaybe<IntOperationFilterInput>;
  /** StartDt */
  startDt?: InputMaybe<StringOperationFilterInput>;
  /** TopDt */
  topDt?: InputMaybe<StringOperationFilterInput>;
  /** Udt */
  udt?: InputMaybe<DateTimeOperationFilterInput>;
  /** UseFg */
  useFg?: InputMaybe<StringOperationFilterInput>;
  /** ZippyFlg */
  zippyFlg?: InputMaybe<StringOperationFilterInput>;
};

/** TempTwFcCrewM */
export type Club_WorldFamilyClub_TempTwFcCrewMInput = {
  /** Cdt */
  cdt?: InputMaybe<Scalars['DateTime']['input']>;
  /** [NOT NULL] Christmas */
  christmas?: InputMaybe<Scalars['Boolean']['input']>;
  /** CrewName */
  crewName?: InputMaybe<Scalars['String']['input']>;
  /** DataFrom */
  dataFrom?: InputMaybe<Scalars['String']['input']>;
  /** EndDt */
  endDt?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Halloween */
  halloween?: InputMaybe<Scalars['Boolean']['input']>;
  /** Organizer */
  organizer?: InputMaybe<Scalars['String']['input']>;
  /** Photo */
  photo?: InputMaybe<Scalars['String']['input']>;
  /** Reviser */
  reviser?: InputMaybe<Scalars['String']['input']>;
  /** [ID] SeqM */
  seqM?: InputMaybe<Scalars['Int']['input']>;
  /** StartDt */
  startDt?: InputMaybe<Scalars['String']['input']>;
  /** TopDt */
  topDt?: InputMaybe<Scalars['String']['input']>;
  /** Udt */
  udt?: InputMaybe<Scalars['DateTime']['input']>;
  /** UseFg */
  useFg?: InputMaybe<Scalars['String']['input']>;
  /** ZippyFlg */
  zippyFlg?: InputMaybe<Scalars['String']['input']>;
};

/** TempTwFcCrewM */
export type Club_WorldFamilyClub_TempTwFcCrewMSortInput = {
  /** Cdt */
  cdt?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Christmas */
  christmas?: InputMaybe<SortEnumType>;
  /** CrewName */
  crewName?: InputMaybe<SortEnumType>;
  /** DataFrom */
  dataFrom?: InputMaybe<SortEnumType>;
  /** EndDt */
  endDt?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Halloween */
  halloween?: InputMaybe<SortEnumType>;
  /** Organizer */
  organizer?: InputMaybe<SortEnumType>;
  /** Photo */
  photo?: InputMaybe<SortEnumType>;
  /** Reviser */
  reviser?: InputMaybe<SortEnumType>;
  /** [ID] SeqM */
  seqM?: InputMaybe<SortEnumType>;
  /** StartDt */
  startDt?: InputMaybe<SortEnumType>;
  /** TopDt */
  topDt?: InputMaybe<SortEnumType>;
  /** Udt */
  udt?: InputMaybe<SortEnumType>;
  /** UseFg */
  useFg?: InputMaybe<SortEnumType>;
  /** ZippyFlg */
  zippyFlg?: InputMaybe<SortEnumType>;
};

/** TempTwFcsongCrew */
export type Club_WorldFamilyClub_TempTwFcsongCrew = Node & {
  __typename?: 'Club_WorldFamilyClub_TempTwFcsongCrew';
  /** Cdt */
  cdt?: Maybe<Scalars['DateTime']['output']>;
  /** CrewName */
  crewName?: Maybe<Scalars['String']['output']>;
  /** EndDt */
  endDt?: Maybe<Scalars['String']['output']>;
  /** [ID] Seq */
  id: Scalars['ID']['output'];
  /** MonthlyRecommend */
  monthlyRecommend?: Maybe<Scalars['String']['output']>;
  /** Organizer */
  organizer?: Maybe<Scalars['String']['output']>;
  /** Reviser */
  reviser?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] SeqM */
  seqM?: Maybe<Scalars['Int']['output']>;
  /** Sno */
  sno?: Maybe<Scalars['String']['output']>;
  /** StartDt */
  startDt?: Maybe<Scalars['String']['output']>;
  /** Udt */
  udt?: Maybe<Scalars['DateTime']['output']>;
  /** Url */
  url?: Maybe<Scalars['String']['output']>;
  /** UrlAnd */
  urlAnd?: Maybe<Scalars['String']['output']>;
  /** UseFg */
  useFg?: Maybe<Scalars['String']['output']>;
  /** Version */
  version?: Maybe<Scalars['String']['output']>;
  /** VideoLink */
  videoLink?: Maybe<Scalars['String']['output']>;
  /** VideoNo */
  videoNo?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_TempTwFcsongCrewConnection = {
  __typename?: 'Club_WorldFamilyClub_TempTwFcsongCrewConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_TempTwFcsongCrewEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_TempTwFcsongCrew>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_TempTwFcsongCrewEdge = {
  __typename?: 'Club_WorldFamilyClub_TempTwFcsongCrewEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_TempTwFcsongCrew;
};

/** TempTwFcsongCrew */
export type Club_WorldFamilyClub_TempTwFcsongCrewFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_TempTwFcsongCrewFilterInput>>;
  /** Cdt */
  cdt?: InputMaybe<DateTimeOperationFilterInput>;
  /** CrewName */
  crewName?: InputMaybe<StringOperationFilterInput>;
  /** EndDt */
  endDt?: InputMaybe<StringOperationFilterInput>;
  /** MonthlyRecommend */
  monthlyRecommend?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_TempTwFcsongCrewFilterInput>>;
  /** Organizer */
  organizer?: InputMaybe<StringOperationFilterInput>;
  /** Reviser */
  reviser?: InputMaybe<StringOperationFilterInput>;
  /** [ID] Seq */
  seq?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] SeqM */
  seqM?: InputMaybe<IntOperationFilterInput>;
  /** Sno */
  sno?: InputMaybe<StringOperationFilterInput>;
  /** StartDt */
  startDt?: InputMaybe<StringOperationFilterInput>;
  /** Udt */
  udt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Url */
  url?: InputMaybe<StringOperationFilterInput>;
  /** UrlAnd */
  urlAnd?: InputMaybe<StringOperationFilterInput>;
  /** UseFg */
  useFg?: InputMaybe<StringOperationFilterInput>;
  /** Version */
  version?: InputMaybe<StringOperationFilterInput>;
  /** VideoLink */
  videoLink?: InputMaybe<StringOperationFilterInput>;
  /** VideoNo */
  videoNo?: InputMaybe<StringOperationFilterInput>;
};

/** TempTwFcsongCrew */
export type Club_WorldFamilyClub_TempTwFcsongCrewInput = {
  /** Cdt */
  cdt?: InputMaybe<Scalars['DateTime']['input']>;
  /** CrewName */
  crewName?: InputMaybe<Scalars['String']['input']>;
  /** EndDt */
  endDt?: InputMaybe<Scalars['String']['input']>;
  /** MonthlyRecommend */
  monthlyRecommend?: InputMaybe<Scalars['String']['input']>;
  /** Organizer */
  organizer?: InputMaybe<Scalars['String']['input']>;
  /** Reviser */
  reviser?: InputMaybe<Scalars['String']['input']>;
  /** [ID] Seq */
  seq?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] SeqM */
  seqM?: InputMaybe<Scalars['Int']['input']>;
  /** Sno */
  sno?: InputMaybe<Scalars['String']['input']>;
  /** StartDt */
  startDt?: InputMaybe<Scalars['String']['input']>;
  /** Udt */
  udt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Url */
  url?: InputMaybe<Scalars['String']['input']>;
  /** UrlAnd */
  urlAnd?: InputMaybe<Scalars['String']['input']>;
  /** UseFg */
  useFg?: InputMaybe<Scalars['String']['input']>;
  /** Version */
  version?: InputMaybe<Scalars['String']['input']>;
  /** VideoLink */
  videoLink?: InputMaybe<Scalars['String']['input']>;
  /** VideoNo */
  videoNo?: InputMaybe<Scalars['String']['input']>;
};

/** TempTwFcsongCrew */
export type Club_WorldFamilyClub_TempTwFcsongCrewSortInput = {
  /** Cdt */
  cdt?: InputMaybe<SortEnumType>;
  /** CrewName */
  crewName?: InputMaybe<SortEnumType>;
  /** EndDt */
  endDt?: InputMaybe<SortEnumType>;
  /** MonthlyRecommend */
  monthlyRecommend?: InputMaybe<SortEnumType>;
  /** Organizer */
  organizer?: InputMaybe<SortEnumType>;
  /** Reviser */
  reviser?: InputMaybe<SortEnumType>;
  /** [ID] Seq */
  seq?: InputMaybe<SortEnumType>;
  /** [NOT NULL] SeqM */
  seqM?: InputMaybe<SortEnumType>;
  /** Sno */
  sno?: InputMaybe<SortEnumType>;
  /** StartDt */
  startDt?: InputMaybe<SortEnumType>;
  /** Udt */
  udt?: InputMaybe<SortEnumType>;
  /** Url */
  url?: InputMaybe<SortEnumType>;
  /** UrlAnd */
  urlAnd?: InputMaybe<SortEnumType>;
  /** UseFg */
  useFg?: InputMaybe<SortEnumType>;
  /** Version */
  version?: InputMaybe<SortEnumType>;
  /** VideoLink */
  videoLink?: InputMaybe<SortEnumType>;
  /** VideoNo */
  videoNo?: InputMaybe<SortEnumType>;
};

/** TempTwFcsongMonthlyRecommend */
export type Club_WorldFamilyClub_TempTwFcsongMonthlyRecommend = Node & {
  __typename?: 'Club_WorldFamilyClub_TempTwFcsongMonthlyRecommend';
  /** [NOT NULL] CreateDate */
  createDate?: Maybe<Scalars['DateTime']['output']>;
  /** [NOT NULL] FcSongSeq */
  fcSongSeq?: Maybe<Scalars['Int']['output']>;
  /** [ID] Seq */
  id: Scalars['ID']['output'];
  /** [NOT NULL] Month */
  month?: Maybe<Scalars['Byte']['output']>;
  /** [NOT NULL] OrganizerCode */
  organizerCode?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] ReviserCode */
  reviserCode?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] UpdateDate */
  updateDate?: Maybe<Scalars['DateTime']['output']>;
  /** [NOT NULL] Year */
  year?: Maybe<Scalars['Short']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_TempTwFcsongMonthlyRecommendConnection = {
  __typename?: 'Club_WorldFamilyClub_TempTwFcsongMonthlyRecommendConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_TempTwFcsongMonthlyRecommendEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_TempTwFcsongMonthlyRecommend>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_TempTwFcsongMonthlyRecommendEdge = {
  __typename?: 'Club_WorldFamilyClub_TempTwFcsongMonthlyRecommendEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_TempTwFcsongMonthlyRecommend;
};

/** TempTwFcsongMonthlyRecommend */
export type Club_WorldFamilyClub_TempTwFcsongMonthlyRecommendFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_TempTwFcsongMonthlyRecommendFilterInput>>;
  /** [NOT NULL] CreateDate */
  createDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** [NOT NULL] FcSongSeq */
  fcSongSeq?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] Month */
  month?: InputMaybe<ByteOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_TempTwFcsongMonthlyRecommendFilterInput>>;
  /** [NOT NULL] OrganizerCode */
  organizerCode?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] ReviserCode */
  reviserCode?: InputMaybe<StringOperationFilterInput>;
  /** [ID] Seq */
  seq?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] UpdateDate */
  updateDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** [NOT NULL] Year */
  year?: InputMaybe<ShortOperationFilterInput>;
};

/** TempTwFcsongMonthlyRecommend */
export type Club_WorldFamilyClub_TempTwFcsongMonthlyRecommendInput = {
  /** [NOT NULL] CreateDate */
  createDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** [NOT NULL] FcSongSeq */
  fcSongSeq?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] Month */
  month?: InputMaybe<Scalars['Byte']['input']>;
  /** [NOT NULL] OrganizerCode */
  organizerCode?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] ReviserCode */
  reviserCode?: InputMaybe<Scalars['String']['input']>;
  /** [ID] Seq */
  seq?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] UpdateDate */
  updateDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** [NOT NULL] Year */
  year?: InputMaybe<Scalars['Short']['input']>;
};

/** TempTwFcsongMonthlyRecommend */
export type Club_WorldFamilyClub_TempTwFcsongMonthlyRecommendSortInput = {
  /** [NOT NULL] CreateDate */
  createDate?: InputMaybe<SortEnumType>;
  /** [NOT NULL] FcSongSeq */
  fcSongSeq?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Month */
  month?: InputMaybe<SortEnumType>;
  /** [NOT NULL] OrganizerCode */
  organizerCode?: InputMaybe<SortEnumType>;
  /** [NOT NULL] ReviserCode */
  reviserCode?: InputMaybe<SortEnumType>;
  /** [ID] Seq */
  seq?: InputMaybe<SortEnumType>;
  /** [NOT NULL] UpdateDate */
  updateDate?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Year */
  year?: InputMaybe<SortEnumType>;
};

/** TempTwMyFavorite */
export type Club_WorldFamilyClub_TempTwMyFavorite = Node & {
  __typename?: 'Club_WorldFamilyClub_TempTwMyFavorite';
  /** Cdt */
  cdt?: Maybe<Scalars['DateTime']['output']>;
  /** FavoriteType */
  favoriteType?: Maybe<Scalars['String']['output']>;
  /** [ID] Seq */
  id: Scalars['ID']['output'];
  /** LinkNo */
  linkNo?: Maybe<Scalars['String']['output']>;
  /** MemberNo */
  memberNo?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_TempTwMyFavoriteConnection = {
  __typename?: 'Club_WorldFamilyClub_TempTwMyFavoriteConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_TempTwMyFavoriteEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_TempTwMyFavorite>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_TempTwMyFavoriteEdge = {
  __typename?: 'Club_WorldFamilyClub_TempTwMyFavoriteEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_TempTwMyFavorite;
};

/** TempTwMyFavorite */
export type Club_WorldFamilyClub_TempTwMyFavoriteFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_TempTwMyFavoriteFilterInput>>;
  /** Cdt */
  cdt?: InputMaybe<DateTimeOperationFilterInput>;
  /** FavoriteType */
  favoriteType?: InputMaybe<StringOperationFilterInput>;
  /** LinkNo */
  linkNo?: InputMaybe<StringOperationFilterInput>;
  /** MemberNo */
  memberNo?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_TempTwMyFavoriteFilterInput>>;
  /** [ID] Seq */
  seq?: InputMaybe<IntOperationFilterInput>;
};

/** TempTwMyFavorite */
export type Club_WorldFamilyClub_TempTwMyFavoriteInput = {
  /** Cdt */
  cdt?: InputMaybe<Scalars['DateTime']['input']>;
  /** FavoriteType */
  favoriteType?: InputMaybe<Scalars['String']['input']>;
  /** LinkNo */
  linkNo?: InputMaybe<Scalars['String']['input']>;
  /** MemberNo */
  memberNo?: InputMaybe<Scalars['String']['input']>;
  /** [ID] Seq */
  seq?: InputMaybe<Scalars['Int']['input']>;
};

/** TempTwMyFavorite */
export type Club_WorldFamilyClub_TempTwMyFavoriteSortInput = {
  /** Cdt */
  cdt?: InputMaybe<SortEnumType>;
  /** FavoriteType */
  favoriteType?: InputMaybe<SortEnumType>;
  /** LinkNo */
  linkNo?: InputMaybe<SortEnumType>;
  /** MemberNo */
  memberNo?: InputMaybe<SortEnumType>;
  /** [ID] Seq */
  seq?: InputMaybe<SortEnumType>;
};

/** TempTwTeSong */
export type Club_WorldFamilyClub_TempTwTeSong = Node & {
  __typename?: 'Club_WorldFamilyClub_TempTwTeSong';
  /** CapDataNo */
  capDataNo?: Maybe<Scalars['String']['output']>;
  /** CapItemNo */
  capItemNo?: Maybe<Scalars['String']['output']>;
  /** Cdt */
  cdt?: Maybe<Scalars['DateTime']['output']>;
  /** Color */
  color?: Maybe<Scalars['String']['output']>;
  /** Content */
  content?: Maybe<Scalars['String']['output']>;
  /** ContentNew */
  contentNew?: Maybe<Scalars['String']['output']>;
  /** Ctifg */
  ctifg?: Maybe<Scalars['Boolean']['output']>;
  /** [ID] Sno */
  id: Scalars['ID']['output'];
  /** Mp3File */
  mp3File?: Maybe<Scalars['String']['output']>;
  /** Organizer */
  organizer?: Maybe<Scalars['String']['output']>;
  /** Product */
  product?: Maybe<Scalars['String']['output']>;
  /** Reviser */
  reviser?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Seq */
  seq?: Maybe<Scalars['Int']['output']>;
  /** Sname */
  sname?: Maybe<Scalars['String']['output']>;
  /** StopFg */
  stopFg?: Maybe<Scalars['String']['output']>;
  /** Tecategory */
  tecategory?: Maybe<Scalars['String']['output']>;
  /** Topic */
  topic?: Maybe<Scalars['String']['output']>;
  /** Type */
  type?: Maybe<Scalars['String']['output']>;
  /** TypeId */
  typeId?: Maybe<Scalars['String']['output']>;
  /** TypeValue */
  typeValue?: Maybe<Scalars['String']['output']>;
  /** TypeValue1 */
  typeValue1?: Maybe<Scalars['String']['output']>;
  /** Udt */
  udt?: Maybe<Scalars['DateTime']['output']>;
  /** UseFg */
  useFg?: Maybe<Scalars['Boolean']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_TempTwTeSongConnection = {
  __typename?: 'Club_WorldFamilyClub_TempTwTeSongConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_TempTwTeSongEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_TempTwTeSong>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_TempTwTeSongEdge = {
  __typename?: 'Club_WorldFamilyClub_TempTwTeSongEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_TempTwTeSong;
};

/** TempTwTeSong */
export type Club_WorldFamilyClub_TempTwTeSongFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_TempTwTeSongFilterInput>>;
  /** CapDataNo */
  capDataNo?: InputMaybe<StringOperationFilterInput>;
  /** CapItemNo */
  capItemNo?: InputMaybe<StringOperationFilterInput>;
  /** Cdt */
  cdt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Color */
  color?: InputMaybe<StringOperationFilterInput>;
  /** Content */
  content?: InputMaybe<StringOperationFilterInput>;
  /** ContentNew */
  contentNew?: InputMaybe<StringOperationFilterInput>;
  /** Ctifg */
  ctifg?: InputMaybe<BooleanOperationFilterInput>;
  /** Mp3File */
  mp3File?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_TempTwTeSongFilterInput>>;
  /** Organizer */
  organizer?: InputMaybe<StringOperationFilterInput>;
  /** Product */
  product?: InputMaybe<StringOperationFilterInput>;
  /** Reviser */
  reviser?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] Seq */
  seq?: InputMaybe<IntOperationFilterInput>;
  /** Sname */
  sname?: InputMaybe<StringOperationFilterInput>;
  /** [ID] Sno */
  sno?: InputMaybe<StringOperationFilterInput>;
  /** StopFg */
  stopFg?: InputMaybe<StringOperationFilterInput>;
  /** Tecategory */
  tecategory?: InputMaybe<StringOperationFilterInput>;
  /** Topic */
  topic?: InputMaybe<StringOperationFilterInput>;
  /** Type */
  type?: InputMaybe<StringOperationFilterInput>;
  /** TypeId */
  typeId?: InputMaybe<StringOperationFilterInput>;
  /** TypeValue */
  typeValue?: InputMaybe<StringOperationFilterInput>;
  /** TypeValue1 */
  typeValue1?: InputMaybe<StringOperationFilterInput>;
  /** Udt */
  udt?: InputMaybe<DateTimeOperationFilterInput>;
  /** UseFg */
  useFg?: InputMaybe<BooleanOperationFilterInput>;
};

/** TempTwTeSongForCapLevel */
export type Club_WorldFamilyClub_TempTwTeSongForCapLevel = Node & {
  __typename?: 'Club_WorldFamilyClub_TempTwTeSongForCapLevel';
  /** [NOT NULL] CapDataNo */
  capDataNo?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] CapItemNo */
  capItemNo?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Cdt */
  cdt?: Maybe<Scalars['DateTime']['output']>;
  /** [NOT NULL] Color */
  color?: Maybe<Scalars['String']['output']>;
  /** Content */
  content?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] ContentNew */
  contentNew?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Ctifg */
  ctifg?: Maybe<Scalars['Boolean']['output']>;
  /** [ID] Sno */
  id: Scalars['ID']['output'];
  /** [NOT NULL] Mp3File */
  mp3File?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Organizer */
  organizer?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Product */
  product?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Reviser */
  reviser?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Seq */
  seq?: Maybe<Scalars['Int']['output']>;
  /** Sname */
  sname?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] StopFg */
  stopFg?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Tecategory */
  tecategory?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Topic */
  topic?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Type */
  type?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] TypeId */
  typeId?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] TypeValue */
  typeValue?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] TypeValue1 */
  typeValue1?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Udt */
  udt?: Maybe<Scalars['DateTime']['output']>;
  /** [NOT NULL] UseFg */
  useFg?: Maybe<Scalars['Boolean']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_TempTwTeSongForCapLevelConnection = {
  __typename?: 'Club_WorldFamilyClub_TempTwTeSongForCapLevelConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_TempTwTeSongForCapLevelEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_TempTwTeSongForCapLevel>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_TempTwTeSongForCapLevelEdge = {
  __typename?: 'Club_WorldFamilyClub_TempTwTeSongForCapLevelEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_TempTwTeSongForCapLevel;
};

/** TempTwTeSongForCapLevel */
export type Club_WorldFamilyClub_TempTwTeSongForCapLevelFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_TempTwTeSongForCapLevelFilterInput>>;
  /** [NOT NULL] CapDataNo */
  capDataNo?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] CapItemNo */
  capItemNo?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] Cdt */
  cdt?: InputMaybe<DateTimeOperationFilterInput>;
  /** [NOT NULL] Color */
  color?: InputMaybe<StringOperationFilterInput>;
  /** Content */
  content?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] ContentNew */
  contentNew?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] Ctifg */
  ctifg?: InputMaybe<BooleanOperationFilterInput>;
  /** [NOT NULL] Mp3File */
  mp3File?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_TempTwTeSongForCapLevelFilterInput>>;
  /** [NOT NULL] Organizer */
  organizer?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] Product */
  product?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] Reviser */
  reviser?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] Seq */
  seq?: InputMaybe<IntOperationFilterInput>;
  /** Sname */
  sname?: InputMaybe<StringOperationFilterInput>;
  /** [ID] Sno */
  sno?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] StopFg */
  stopFg?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] Tecategory */
  tecategory?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] Topic */
  topic?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] Type */
  type?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] TypeId */
  typeId?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] TypeValue */
  typeValue?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] TypeValue1 */
  typeValue1?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] Udt */
  udt?: InputMaybe<DateTimeOperationFilterInput>;
  /** [NOT NULL] UseFg */
  useFg?: InputMaybe<BooleanOperationFilterInput>;
};

/** TempTwTeSongForCapLevel */
export type Club_WorldFamilyClub_TempTwTeSongForCapLevelInput = {
  /** [NOT NULL] CapDataNo */
  capDataNo?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] CapItemNo */
  capItemNo?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Cdt */
  cdt?: InputMaybe<Scalars['DateTime']['input']>;
  /** [NOT NULL] Color */
  color?: InputMaybe<Scalars['String']['input']>;
  /** Content */
  content?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] ContentNew */
  contentNew?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Ctifg */
  ctifg?: InputMaybe<Scalars['Boolean']['input']>;
  /** [NOT NULL] Mp3File */
  mp3File?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Organizer */
  organizer?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Product */
  product?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Reviser */
  reviser?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Seq */
  seq?: InputMaybe<Scalars['Int']['input']>;
  /** Sname */
  sname?: InputMaybe<Scalars['String']['input']>;
  /** [ID] Sno */
  sno?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] StopFg */
  stopFg?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Tecategory */
  tecategory?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Topic */
  topic?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Type */
  type?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] TypeId */
  typeId?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] TypeValue */
  typeValue?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] TypeValue1 */
  typeValue1?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Udt */
  udt?: InputMaybe<Scalars['DateTime']['input']>;
  /** [NOT NULL] UseFg */
  useFg?: InputMaybe<Scalars['Boolean']['input']>;
};

/** TempTwTeSongForCapLevel */
export type Club_WorldFamilyClub_TempTwTeSongForCapLevelSortInput = {
  /** [NOT NULL] CapDataNo */
  capDataNo?: InputMaybe<SortEnumType>;
  /** [NOT NULL] CapItemNo */
  capItemNo?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Cdt */
  cdt?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Color */
  color?: InputMaybe<SortEnumType>;
  /** Content */
  content?: InputMaybe<SortEnumType>;
  /** [NOT NULL] ContentNew */
  contentNew?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Ctifg */
  ctifg?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Mp3File */
  mp3File?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Organizer */
  organizer?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Product */
  product?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Reviser */
  reviser?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Seq */
  seq?: InputMaybe<SortEnumType>;
  /** Sname */
  sname?: InputMaybe<SortEnumType>;
  /** [ID] Sno */
  sno?: InputMaybe<SortEnumType>;
  /** [NOT NULL] StopFg */
  stopFg?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Tecategory */
  tecategory?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Topic */
  topic?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Type */
  type?: InputMaybe<SortEnumType>;
  /** [NOT NULL] TypeId */
  typeId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] TypeValue */
  typeValue?: InputMaybe<SortEnumType>;
  /** [NOT NULL] TypeValue1 */
  typeValue1?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Udt */
  udt?: InputMaybe<SortEnumType>;
  /** [NOT NULL] UseFg */
  useFg?: InputMaybe<SortEnumType>;
};

/** TempTwTeSong */
export type Club_WorldFamilyClub_TempTwTeSongInput = {
  /** CapDataNo */
  capDataNo?: InputMaybe<Scalars['String']['input']>;
  /** CapItemNo */
  capItemNo?: InputMaybe<Scalars['String']['input']>;
  /** Cdt */
  cdt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Color */
  color?: InputMaybe<Scalars['String']['input']>;
  /** Content */
  content?: InputMaybe<Scalars['String']['input']>;
  /** ContentNew */
  contentNew?: InputMaybe<Scalars['String']['input']>;
  /** Ctifg */
  ctifg?: InputMaybe<Scalars['Boolean']['input']>;
  /** Mp3File */
  mp3File?: InputMaybe<Scalars['String']['input']>;
  /** Organizer */
  organizer?: InputMaybe<Scalars['String']['input']>;
  /** Product */
  product?: InputMaybe<Scalars['String']['input']>;
  /** Reviser */
  reviser?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Seq */
  seq?: InputMaybe<Scalars['Int']['input']>;
  /** Sname */
  sname?: InputMaybe<Scalars['String']['input']>;
  /** [ID] Sno */
  sno?: InputMaybe<Scalars['String']['input']>;
  /** StopFg */
  stopFg?: InputMaybe<Scalars['String']['input']>;
  /** Tecategory */
  tecategory?: InputMaybe<Scalars['String']['input']>;
  /** Topic */
  topic?: InputMaybe<Scalars['String']['input']>;
  /** Type */
  type?: InputMaybe<Scalars['String']['input']>;
  /** TypeId */
  typeId?: InputMaybe<Scalars['String']['input']>;
  /** TypeValue */
  typeValue?: InputMaybe<Scalars['String']['input']>;
  /** TypeValue1 */
  typeValue1?: InputMaybe<Scalars['String']['input']>;
  /** Udt */
  udt?: InputMaybe<Scalars['DateTime']['input']>;
  /** UseFg */
  useFg?: InputMaybe<Scalars['Boolean']['input']>;
};

/** TempTwTeSong */
export type Club_WorldFamilyClub_TempTwTeSongSortInput = {
  /** CapDataNo */
  capDataNo?: InputMaybe<SortEnumType>;
  /** CapItemNo */
  capItemNo?: InputMaybe<SortEnumType>;
  /** Cdt */
  cdt?: InputMaybe<SortEnumType>;
  /** Color */
  color?: InputMaybe<SortEnumType>;
  /** Content */
  content?: InputMaybe<SortEnumType>;
  /** ContentNew */
  contentNew?: InputMaybe<SortEnumType>;
  /** Ctifg */
  ctifg?: InputMaybe<SortEnumType>;
  /** Mp3File */
  mp3File?: InputMaybe<SortEnumType>;
  /** Organizer */
  organizer?: InputMaybe<SortEnumType>;
  /** Product */
  product?: InputMaybe<SortEnumType>;
  /** Reviser */
  reviser?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Seq */
  seq?: InputMaybe<SortEnumType>;
  /** Sname */
  sname?: InputMaybe<SortEnumType>;
  /** [ID] Sno */
  sno?: InputMaybe<SortEnumType>;
  /** StopFg */
  stopFg?: InputMaybe<SortEnumType>;
  /** Tecategory */
  tecategory?: InputMaybe<SortEnumType>;
  /** Topic */
  topic?: InputMaybe<SortEnumType>;
  /** Type */
  type?: InputMaybe<SortEnumType>;
  /** TypeId */
  typeId?: InputMaybe<SortEnumType>;
  /** TypeValue */
  typeValue?: InputMaybe<SortEnumType>;
  /** TypeValue1 */
  typeValue1?: InputMaybe<SortEnumType>;
  /** Udt */
  udt?: InputMaybe<SortEnumType>;
  /** UseFg */
  useFg?: InputMaybe<SortEnumType>;
};

/** TempWfcGraC */
export type Club_WorldFamilyClub_TempWfcGraC = Node & {
  __typename?: 'Club_WorldFamilyClub_TempWfcGraC';
  /** [NOT NULL] Cdt */
  cdt?: Maybe<Scalars['DateTime']['output']>;
  /** ChildEnglishName */
  childEnglishName?: Maybe<Scalars['String']['output']>;
  /** ChildName */
  childName?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] ChildNo */
  childNo?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] GiftNo */
  giftNo?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Height */
  height?: Maybe<Scalars['String']['output']>;
  /** [ID] SeqNo */
  id: Scalars['ID']['output'];
  /** [NOT NULL] MemNo */
  memNo?: Maybe<Scalars['String']['output']>;
  /** Org */
  org?: Maybe<Scalars['String']['output']>;
  /** PassDate */
  passDate?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] ProdYear */
  prodYear?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] RegAge */
  regAge?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] RegAge1 */
  regAge1?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] RegDate */
  regDate?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] RegType */
  regType?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Remark */
  remark?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Result */
  result?: Maybe<Scalars['String']['output']>;
  /** Rev */
  rev?: Maybe<Scalars['String']['output']>;
  /** Udt */
  udt?: Maybe<Scalars['DateTime']['output']>;
  /** [NOT NULL] Weight */
  weight?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_TempWfcGraCConnection = {
  __typename?: 'Club_WorldFamilyClub_TempWfcGraCConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_TempWfcGraCEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_TempWfcGraC>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_TempWfcGraCEdge = {
  __typename?: 'Club_WorldFamilyClub_TempWfcGraCEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_TempWfcGraC;
};

/** TempWfcGraC */
export type Club_WorldFamilyClub_TempWfcGraCFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_TempWfcGraCFilterInput>>;
  /** [NOT NULL] Cdt */
  cdt?: InputMaybe<DateTimeOperationFilterInput>;
  /** ChildEnglishName */
  childEnglishName?: InputMaybe<StringOperationFilterInput>;
  /** ChildName */
  childName?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] ChildNo */
  childNo?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] GiftNo */
  giftNo?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] Height */
  height?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] MemNo */
  memNo?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_TempWfcGraCFilterInput>>;
  /** Org */
  org?: InputMaybe<StringOperationFilterInput>;
  /** PassDate */
  passDate?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] ProdYear */
  prodYear?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] RegAge */
  regAge?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] RegAge1 */
  regAge1?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] RegDate */
  regDate?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] RegType */
  regType?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] Remark */
  remark?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] Result */
  result?: InputMaybe<StringOperationFilterInput>;
  /** Rev */
  rev?: InputMaybe<StringOperationFilterInput>;
  /** [ID] SeqNo */
  seqNo?: InputMaybe<DecimalOperationFilterInput>;
  /** Udt */
  udt?: InputMaybe<DateTimeOperationFilterInput>;
  /** [NOT NULL] Weight */
  weight?: InputMaybe<StringOperationFilterInput>;
};

/** TempWfcGraC */
export type Club_WorldFamilyClub_TempWfcGraCInput = {
  /** [NOT NULL] Cdt */
  cdt?: InputMaybe<Scalars['DateTime']['input']>;
  /** ChildEnglishName */
  childEnglishName?: InputMaybe<Scalars['String']['input']>;
  /** ChildName */
  childName?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] ChildNo */
  childNo?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] GiftNo */
  giftNo?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Height */
  height?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] MemNo */
  memNo?: InputMaybe<Scalars['String']['input']>;
  /** Org */
  org?: InputMaybe<Scalars['String']['input']>;
  /** PassDate */
  passDate?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] ProdYear */
  prodYear?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] RegAge */
  regAge?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] RegAge1 */
  regAge1?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] RegDate */
  regDate?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] RegType */
  regType?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Remark */
  remark?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Result */
  result?: InputMaybe<Scalars['String']['input']>;
  /** Rev */
  rev?: InputMaybe<Scalars['String']['input']>;
  /** [ID] SeqNo */
  seqNo: Scalars['Decimal']['input'];
  /** Udt */
  udt?: InputMaybe<Scalars['DateTime']['input']>;
  /** [NOT NULL] Weight */
  weight?: InputMaybe<Scalars['String']['input']>;
};

/** TempWfcGraCOrganized */
export type Club_WorldFamilyClub_TempWfcGraCOrganized = Node & {
  __typename?: 'Club_WorldFamilyClub_TempWfcGraCOrganized';
  /** [NOT NULL] Cdt */
  cdt?: Maybe<Scalars['DateTime']['output']>;
  /** ChildEnglishName */
  childEnglishName?: Maybe<Scalars['String']['output']>;
  /** ChildName */
  childName?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] ChildNo */
  childNo?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] GiftNo */
  giftNo?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Height */
  height?: Maybe<Scalars['String']['output']>;
  /** [ID] SeqNo */
  id: Scalars['ID']['output'];
  /** [NOT NULL] MemNo */
  memNo?: Maybe<Scalars['String']['output']>;
  /** Org */
  org?: Maybe<Scalars['String']['output']>;
  /** PassDate */
  passDate?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] ProdYear */
  prodYear?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] RegAge */
  regAge?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] RegAge1 */
  regAge1?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] RegDate */
  regDate?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] RegType */
  regType?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Remark */
  remark?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Result */
  result?: Maybe<Scalars['String']['output']>;
  /** Rev */
  rev?: Maybe<Scalars['String']['output']>;
  /** Udt */
  udt?: Maybe<Scalars['DateTime']['output']>;
  /** [NOT NULL] Weight */
  weight?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_TempWfcGraCOrganizedConnection = {
  __typename?: 'Club_WorldFamilyClub_TempWfcGraCOrganizedConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_TempWfcGraCOrganizedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_TempWfcGraCOrganized>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_TempWfcGraCOrganizedEdge = {
  __typename?: 'Club_WorldFamilyClub_TempWfcGraCOrganizedEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_TempWfcGraCOrganized;
};

/** TempWfcGraCOrganized */
export type Club_WorldFamilyClub_TempWfcGraCOrganizedFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_TempWfcGraCOrganizedFilterInput>>;
  /** [NOT NULL] Cdt */
  cdt?: InputMaybe<DateTimeOperationFilterInput>;
  /** ChildEnglishName */
  childEnglishName?: InputMaybe<StringOperationFilterInput>;
  /** ChildName */
  childName?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] ChildNo */
  childNo?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] GiftNo */
  giftNo?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] Height */
  height?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] MemNo */
  memNo?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_TempWfcGraCOrganizedFilterInput>>;
  /** Org */
  org?: InputMaybe<StringOperationFilterInput>;
  /** PassDate */
  passDate?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] ProdYear */
  prodYear?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] RegAge */
  regAge?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] RegAge1 */
  regAge1?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] RegDate */
  regDate?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] RegType */
  regType?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] Remark */
  remark?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] Result */
  result?: InputMaybe<StringOperationFilterInput>;
  /** Rev */
  rev?: InputMaybe<StringOperationFilterInput>;
  /** [ID] SeqNo */
  seqNo?: InputMaybe<DecimalOperationFilterInput>;
  /** Udt */
  udt?: InputMaybe<DateTimeOperationFilterInput>;
  /** [NOT NULL] Weight */
  weight?: InputMaybe<StringOperationFilterInput>;
};

/** TempWfcGraCOrganized */
export type Club_WorldFamilyClub_TempWfcGraCOrganizedInput = {
  /** [NOT NULL] Cdt */
  cdt?: InputMaybe<Scalars['DateTime']['input']>;
  /** ChildEnglishName */
  childEnglishName?: InputMaybe<Scalars['String']['input']>;
  /** ChildName */
  childName?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] ChildNo */
  childNo?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] GiftNo */
  giftNo?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Height */
  height?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] MemNo */
  memNo?: InputMaybe<Scalars['String']['input']>;
  /** Org */
  org?: InputMaybe<Scalars['String']['input']>;
  /** PassDate */
  passDate?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] ProdYear */
  prodYear?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] RegAge */
  regAge?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] RegAge1 */
  regAge1?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] RegDate */
  regDate?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] RegType */
  regType?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Remark */
  remark?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Result */
  result?: InputMaybe<Scalars['String']['input']>;
  /** Rev */
  rev?: InputMaybe<Scalars['String']['input']>;
  /** [ID] SeqNo */
  seqNo: Scalars['Decimal']['input'];
  /** Udt */
  udt?: InputMaybe<Scalars['DateTime']['input']>;
  /** [NOT NULL] Weight */
  weight?: InputMaybe<Scalars['String']['input']>;
};

/** TempWfcGraCOrganized */
export type Club_WorldFamilyClub_TempWfcGraCOrganizedSortInput = {
  /** [NOT NULL] Cdt */
  cdt?: InputMaybe<SortEnumType>;
  /** ChildEnglishName */
  childEnglishName?: InputMaybe<SortEnumType>;
  /** ChildName */
  childName?: InputMaybe<SortEnumType>;
  /** [NOT NULL] ChildNo */
  childNo?: InputMaybe<SortEnumType>;
  /** [NOT NULL] GiftNo */
  giftNo?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Height */
  height?: InputMaybe<SortEnumType>;
  /** [NOT NULL] MemNo */
  memNo?: InputMaybe<SortEnumType>;
  /** Org */
  org?: InputMaybe<SortEnumType>;
  /** PassDate */
  passDate?: InputMaybe<SortEnumType>;
  /** [NOT NULL] ProdYear */
  prodYear?: InputMaybe<SortEnumType>;
  /** [NOT NULL] RegAge */
  regAge?: InputMaybe<SortEnumType>;
  /** [NOT NULL] RegAge1 */
  regAge1?: InputMaybe<SortEnumType>;
  /** [NOT NULL] RegDate */
  regDate?: InputMaybe<SortEnumType>;
  /** [NOT NULL] RegType */
  regType?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Remark */
  remark?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Result */
  result?: InputMaybe<SortEnumType>;
  /** Rev */
  rev?: InputMaybe<SortEnumType>;
  /** [ID] SeqNo */
  seqNo?: InputMaybe<SortEnumType>;
  /** Udt */
  udt?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Weight */
  weight?: InputMaybe<SortEnumType>;
};

/** TempWfcGraC */
export type Club_WorldFamilyClub_TempWfcGraCSortInput = {
  /** [NOT NULL] Cdt */
  cdt?: InputMaybe<SortEnumType>;
  /** ChildEnglishName */
  childEnglishName?: InputMaybe<SortEnumType>;
  /** ChildName */
  childName?: InputMaybe<SortEnumType>;
  /** [NOT NULL] ChildNo */
  childNo?: InputMaybe<SortEnumType>;
  /** [NOT NULL] GiftNo */
  giftNo?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Height */
  height?: InputMaybe<SortEnumType>;
  /** [NOT NULL] MemNo */
  memNo?: InputMaybe<SortEnumType>;
  /** Org */
  org?: InputMaybe<SortEnumType>;
  /** PassDate */
  passDate?: InputMaybe<SortEnumType>;
  /** [NOT NULL] ProdYear */
  prodYear?: InputMaybe<SortEnumType>;
  /** [NOT NULL] RegAge */
  regAge?: InputMaybe<SortEnumType>;
  /** [NOT NULL] RegAge1 */
  regAge1?: InputMaybe<SortEnumType>;
  /** [NOT NULL] RegDate */
  regDate?: InputMaybe<SortEnumType>;
  /** [NOT NULL] RegType */
  regType?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Remark */
  remark?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Result */
  result?: InputMaybe<SortEnumType>;
  /** Rev */
  rev?: InputMaybe<SortEnumType>;
  /** [ID] SeqNo */
  seqNo?: InputMaybe<SortEnumType>;
  /** Udt */
  udt?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Weight */
  weight?: InputMaybe<SortEnumType>;
};

/** TestUserAccount */
export type Club_WorldFamilyClub_TestUserAccount = Node & {
  __typename?: 'Club_WorldFamilyClub_TestUserAccount';
  /** Email */
  email?: Maybe<Scalars['String']['output']>;
  /** [ID] ProjectName */
  id: Scalars['ID']['output'];
  /** MobilePhone */
  mobilePhone?: Maybe<Scalars['String']['output']>;
  /** SmsCode */
  smsCode?: Maybe<Scalars['String']['output']>;
  /** UserId */
  userId?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_TestUserAccountConnection = {
  __typename?: 'Club_WorldFamilyClub_TestUserAccountConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_TestUserAccountEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_TestUserAccount>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_TestUserAccountEdge = {
  __typename?: 'Club_WorldFamilyClub_TestUserAccountEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_TestUserAccount;
};

/** TestUserAccount */
export type Club_WorldFamilyClub_TestUserAccountFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_TestUserAccountFilterInput>>;
  /** Email */
  email?: InputMaybe<StringOperationFilterInput>;
  /** MobilePhone */
  mobilePhone?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_TestUserAccountFilterInput>>;
  /** [ID] ProjectName */
  projectName?: InputMaybe<StringOperationFilterInput>;
  /** SmsCode */
  smsCode?: InputMaybe<StringOperationFilterInput>;
  /** UserId */
  userId?: InputMaybe<StringOperationFilterInput>;
};

/** TestUserAccount */
export type Club_WorldFamilyClub_TestUserAccountInput = {
  /** Email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** MobilePhone */
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  /** [ID] ProjectName */
  projectName?: InputMaybe<Scalars['String']['input']>;
  /** SmsCode */
  smsCode?: InputMaybe<Scalars['String']['input']>;
  /** UserId */
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** TestUserAccount */
export type Club_WorldFamilyClub_TestUserAccountSortInput = {
  /** Email */
  email?: InputMaybe<SortEnumType>;
  /** MobilePhone */
  mobilePhone?: InputMaybe<SortEnumType>;
  /** [ID] ProjectName */
  projectName?: InputMaybe<SortEnumType>;
  /** SmsCode */
  smsCode?: InputMaybe<SortEnumType>;
  /** UserId */
  userId?: InputMaybe<SortEnumType>;
};

/** TestWater */
export type Club_WorldFamilyClub_TestWater = Node & {
  __typename?: 'Club_WorldFamilyClub_TestWater';
  /** A */
  a?: Maybe<Scalars['String']['output']>;
  /** B */
  b?: Maybe<Scalars['String']['output']>;
  /** Create */
  create?: Maybe<Scalars['DateTime']['output']>;
  /** [ID] Id */
  id: Scalars['ID']['output'];
  /** [COLLECTION] TestWaterSubs */
  testWaterSubs?: Maybe<Array<Maybe<Club_WorldFamilyClub_TestWaterSub>>>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_TestWaterConnection = {
  __typename?: 'Club_WorldFamilyClub_TestWaterConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_TestWaterEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_TestWater>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_TestWaterEdge = {
  __typename?: 'Club_WorldFamilyClub_TestWaterEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_TestWater;
};

/** TestWater */
export type Club_WorldFamilyClub_TestWaterFilterInput = {
  /** A */
  a?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<Club_WorldFamilyClub_TestWaterFilterInput>>;
  /** B */
  b?: InputMaybe<StringOperationFilterInput>;
  /** Create */
  create?: InputMaybe<DateTimeOperationFilterInput>;
  /** [ID] Id */
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_TestWaterFilterInput>>;
  /** [COLLECTION] TestWaterSubs */
  testWaterSubs?: InputMaybe<ListFilterInputTypeOfClub_WorldFamilyClub_TestWaterSubFilterInput>;
};

/** TestWater */
export type Club_WorldFamilyClub_TestWaterInput = {
  /** A */
  a?: InputMaybe<Scalars['String']['input']>;
  /** B */
  b?: InputMaybe<Scalars['String']['input']>;
  /** Create */
  create?: InputMaybe<Scalars['DateTime']['input']>;
  /** [ID] Id */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** [COLLECTION] TestWaterSubs */
  testWaterSubs?: InputMaybe<Array<InputMaybe<Club_WorldFamilyClub_TestWaterSubInput>>>;
};

/** TestWater */
export type Club_WorldFamilyClub_TestWaterSortInput = {
  /** A */
  a?: InputMaybe<SortEnumType>;
  /** B */
  b?: InputMaybe<SortEnumType>;
  /** Create */
  create?: InputMaybe<SortEnumType>;
  /** [ID] Id */
  id?: InputMaybe<SortEnumType>;
};

/** TestWaterSub */
export type Club_WorldFamilyClub_TestWaterSub = Node & {
  __typename?: 'Club_WorldFamilyClub_TestWaterSub';
  /** [ID] SubId */
  id: Scalars['ID']['output'];
  /** [NAVIGATION] IdNavigation */
  idNavigation?: Maybe<Club_WorldFamilyClub_TestWater>;
  /** SubA */
  subA?: Maybe<Scalars['String']['output']>;
  /** SubB */
  subB?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_TestWaterSubConnection = {
  __typename?: 'Club_WorldFamilyClub_TestWaterSubConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_TestWaterSubEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_TestWaterSub>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_TestWaterSubEdge = {
  __typename?: 'Club_WorldFamilyClub_TestWaterSubEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_TestWaterSub;
};

/** TestWaterSub */
export type Club_WorldFamilyClub_TestWaterSubFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_TestWaterSubFilterInput>>;
  /** [NOT NULL] Id */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** [NAVIGATION] IdNavigation */
  idNavigation?: InputMaybe<Club_WorldFamilyClub_TestWaterFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_TestWaterSubFilterInput>>;
  /** SubA */
  subA?: InputMaybe<StringOperationFilterInput>;
  /** SubB */
  subB?: InputMaybe<StringOperationFilterInput>;
  /** [ID] SubId */
  subId?: InputMaybe<UuidOperationFilterInput>;
};

/** TestWaterSub */
export type Club_WorldFamilyClub_TestWaterSubInput = {
  /** [NOT NULL] Id */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** [NAVIGATION] IdNavigation */
  idNavigation?: InputMaybe<Club_WorldFamilyClub_TestWaterInput>;
  /** SubA */
  subA?: InputMaybe<Scalars['String']['input']>;
  /** SubB */
  subB?: InputMaybe<Scalars['String']['input']>;
  /** [ID] SubId */
  subId?: InputMaybe<Scalars['UUID']['input']>;
};

/** TestWaterSub */
export type Club_WorldFamilyClub_TestWaterSubSortInput = {
  /** [NOT NULL] Id */
  id?: InputMaybe<SortEnumType>;
  /** [NAVIGATION] IdNavigation */
  idNavigation?: InputMaybe<Club_WorldFamilyClub_TestWaterSortInput>;
  /** SubA */
  subA?: InputMaybe<SortEnumType>;
  /** SubB */
  subB?: InputMaybe<SortEnumType>;
  /** [ID] SubId */
  subId?: InputMaybe<SortEnumType>;
};

/** Tev2MonthlySong */
export type Club_WorldFamilyClub_Tev2MonthlySong = Node & {
  __typename?: 'Club_WorldFamilyClub_Tev2MonthlySong';
  /** [ID] Seq */
  id: Scalars['ID']['output'];
  /** [NOT NULL] IntroductionBanner */
  introductionBanner?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Month */
  month?: Maybe<Scalars['Int']['output']>;
  /** [NOT NULL] Tev2Banner */
  tev2Banner?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Tev2SongId */
  tev2SongId?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] VimeoUrl */
  vimeoUrl?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Year */
  year?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_Tev2MonthlySongConnection = {
  __typename?: 'Club_WorldFamilyClub_Tev2MonthlySongConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_Tev2MonthlySongEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_Tev2MonthlySong>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_Tev2MonthlySongEdge = {
  __typename?: 'Club_WorldFamilyClub_Tev2MonthlySongEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_Tev2MonthlySong;
};

/** Tev2MonthlySong */
export type Club_WorldFamilyClub_Tev2MonthlySongFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_Tev2MonthlySongFilterInput>>;
  /** [NOT NULL] IntroductionBanner */
  introductionBanner?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] Month */
  month?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_Tev2MonthlySongFilterInput>>;
  /** [ID] Seq */
  seq?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] Tev2Banner */
  tev2Banner?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] Tev2SongId */
  tev2SongId?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] VimeoUrl */
  vimeoUrl?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] Year */
  year?: InputMaybe<IntOperationFilterInput>;
};

/** Tev2MonthlySong */
export type Club_WorldFamilyClub_Tev2MonthlySongInput = {
  /** [NOT NULL] IntroductionBanner */
  introductionBanner?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Month */
  month?: InputMaybe<Scalars['Int']['input']>;
  /** [ID] Seq */
  seq?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] Tev2Banner */
  tev2Banner?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Tev2SongId */
  tev2SongId?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] VimeoUrl */
  vimeoUrl?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Year */
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** Tev2MonthlySong */
export type Club_WorldFamilyClub_Tev2MonthlySongSortInput = {
  /** [NOT NULL] IntroductionBanner */
  introductionBanner?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Month */
  month?: InputMaybe<SortEnumType>;
  /** [ID] Seq */
  seq?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Tev2Banner */
  tev2Banner?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Tev2SongId */
  tev2SongId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] VimeoUrl */
  vimeoUrl?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Year */
  year?: InputMaybe<SortEnumType>;
};

/** User */
export type Club_WorldFamilyClub_User = Node & {
  __typename?: 'Club_WorldFamilyClub_User';
  /** Email */
  email?: Maybe<Scalars['String']['output']>;
  /** [ID] UserId */
  id: Scalars['ID']['output'];
  /** UserName */
  userName?: Maybe<Scalars['String']['output']>;
  /** UtcCdt */
  utcCdt?: Maybe<Scalars['DateTime']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_UserConnection = {
  __typename?: 'Club_WorldFamilyClub_UserConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_UserEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_User>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_UserEdge = {
  __typename?: 'Club_WorldFamilyClub_UserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_User;
};

/** User */
export type Club_WorldFamilyClub_UserFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_UserFilterInput>>;
  /** Email */
  email?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_UserFilterInput>>;
  /** [ID] UserId */
  userId?: InputMaybe<StringOperationFilterInput>;
  /** UserName */
  userName?: InputMaybe<StringOperationFilterInput>;
  /** UtcCdt */
  utcCdt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** User */
export type Club_WorldFamilyClub_UserInput = {
  /** Email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** [ID] UserId */
  userId?: InputMaybe<Scalars['String']['input']>;
  /** UserName */
  userName?: InputMaybe<Scalars['String']['input']>;
  /** UtcCdt */
  utcCdt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** User */
export type Club_WorldFamilyClub_UserSortInput = {
  /** Email */
  email?: InputMaybe<SortEnumType>;
  /** [ID] UserId */
  userId?: InputMaybe<SortEnumType>;
  /** UserName */
  userName?: InputMaybe<SortEnumType>;
  /** UtcCdt */
  utcCdt?: InputMaybe<SortEnumType>;
};

/** VideoForTrialmode */
export type Club_WorldFamilyClub_VideoForTrialmode = Node & {
  __typename?: 'Club_WorldFamilyClub_VideoForTrialmode';
  /** [ID] VideoForTrialmodeId */
  id: Scalars['ID']['output'];
  /** ImageUrl */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Market */
  market?: Maybe<Scalars['String']['output']>;
  /** Segmentation */
  segmentation?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] VideoId */
  videoId?: Maybe<Scalars['Int']['output']>;
  /** VideoTitle */
  videoTitle?: Maybe<Scalars['String']['output']>;
  /** VimeoId */
  vimeoId?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_VideoForTrialmodeConnection = {
  __typename?: 'Club_WorldFamilyClub_VideoForTrialmodeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_VideoForTrialmodeEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_VideoForTrialmode>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_VideoForTrialmodeEdge = {
  __typename?: 'Club_WorldFamilyClub_VideoForTrialmodeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_VideoForTrialmode;
};

/** VideoForTrialmode */
export type Club_WorldFamilyClub_VideoForTrialmodeFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_VideoForTrialmodeFilterInput>>;
  /** ImageUrl */
  imageUrl?: InputMaybe<StringOperationFilterInput>;
  /** Market */
  market?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_VideoForTrialmodeFilterInput>>;
  /** Segmentation */
  segmentation?: InputMaybe<StringOperationFilterInput>;
  /** [ID] VideoForTrialmodeId */
  videoForTrialmodeId?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] VideoId */
  videoId?: InputMaybe<IntOperationFilterInput>;
  /** VideoTitle */
  videoTitle?: InputMaybe<StringOperationFilterInput>;
  /** VimeoId */
  vimeoId?: InputMaybe<StringOperationFilterInput>;
};

/** VideoForTrialmode */
export type Club_WorldFamilyClub_VideoForTrialmodeInput = {
  /** ImageUrl */
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  /** Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** Segmentation */
  segmentation?: InputMaybe<Scalars['String']['input']>;
  /** [ID] VideoForTrialmodeId */
  videoForTrialmodeId?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] VideoId */
  videoId?: InputMaybe<Scalars['Int']['input']>;
  /** VideoTitle */
  videoTitle?: InputMaybe<Scalars['String']['input']>;
  /** VimeoId */
  vimeoId?: InputMaybe<Scalars['String']['input']>;
};

/** VideoForTrialmode */
export type Club_WorldFamilyClub_VideoForTrialmodeSortInput = {
  /** ImageUrl */
  imageUrl?: InputMaybe<SortEnumType>;
  /** Market */
  market?: InputMaybe<SortEnumType>;
  /** Segmentation */
  segmentation?: InputMaybe<SortEnumType>;
  /** [ID] VideoForTrialmodeId */
  videoForTrialmodeId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] VideoId */
  videoId?: InputMaybe<SortEnumType>;
  /** VideoTitle */
  videoTitle?: InputMaybe<SortEnumType>;
  /** VimeoId */
  vimeoId?: InputMaybe<SortEnumType>;
};

/** WfcLibraryFaq */
export type Club_WorldFamilyClub_WfcLibraryFaq = Node & {
  __typename?: 'Club_WorldFamilyClub_WfcLibraryFaq';
  /** [NOT NULL] Answer */
  answer?: Maybe<Scalars['String']['output']>;
  /** [ID] FaqId */
  id: Scalars['ID']['output'];
  /** [NOT NULL] Market */
  market?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Question */
  question?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] SortOrder */
  sortOrder?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_WfcLibraryFaqConnection = {
  __typename?: 'Club_WorldFamilyClub_WfcLibraryFaqConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_WfcLibraryFaqEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_WfcLibraryFaq>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_WfcLibraryFaqEdge = {
  __typename?: 'Club_WorldFamilyClub_WfcLibraryFaqEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_WfcLibraryFaq;
};

/** WfcLibraryFaq */
export type Club_WorldFamilyClub_WfcLibraryFaqFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_WfcLibraryFaqFilterInput>>;
  /** [NOT NULL] Answer */
  answer?: InputMaybe<StringOperationFilterInput>;
  /** [ID] FaqId */
  faqId?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] Market */
  market?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_WfcLibraryFaqFilterInput>>;
  /** [NOT NULL] Question */
  question?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] SortOrder */
  sortOrder?: InputMaybe<IntOperationFilterInput>;
};

/** WfcLibraryFaq */
export type Club_WorldFamilyClub_WfcLibraryFaqInput = {
  /** [NOT NULL] Answer */
  answer?: InputMaybe<Scalars['String']['input']>;
  /** [ID] FaqId */
  faqId?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Question */
  question?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] SortOrder */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/** WfcLibraryFaq */
export type Club_WorldFamilyClub_WfcLibraryFaqSortInput = {
  /** [NOT NULL] Answer */
  answer?: InputMaybe<SortEnumType>;
  /** [ID] FaqId */
  faqId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Market */
  market?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Question */
  question?: InputMaybe<SortEnumType>;
  /** [NOT NULL] SortOrder */
  sortOrder?: InputMaybe<SortEnumType>;
};

/** WfcLibraryLog */
export type Club_WorldFamilyClub_WfcLibraryLog = Node & {
  __typename?: 'Club_WorldFamilyClub_WfcLibraryLog';
  /** [NOT NULL] CreatedTime */
  createdTime?: Maybe<Scalars['DateTime']['output']>;
  /** [NOT NULL] DeviceId */
  deviceId?: Maybe<Scalars['String']['output']>;
  /** [ID] Seq */
  id: Scalars['ID']['output'];
  /** [NOT NULL] Market */
  market?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] MemberNumber */
  memberNumber?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_WfcLibraryLogConnection = {
  __typename?: 'Club_WorldFamilyClub_WfcLibraryLogConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_WfcLibraryLogEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_WfcLibraryLog>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_WfcLibraryLogEdge = {
  __typename?: 'Club_WorldFamilyClub_WfcLibraryLogEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_WfcLibraryLog;
};

/** WfcLibraryLog */
export type Club_WorldFamilyClub_WfcLibraryLogFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_WfcLibraryLogFilterInput>>;
  /** [NOT NULL] CreatedTime */
  createdTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** [NOT NULL] DeviceId */
  deviceId?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] Market */
  market?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] MemberNumber */
  memberNumber?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_WfcLibraryLogFilterInput>>;
  /** [ID] Seq */
  seq?: InputMaybe<LongOperationFilterInput>;
};

/** WfcLibraryLog */
export type Club_WorldFamilyClub_WfcLibraryLogInput = {
  /** [NOT NULL] CreatedTime */
  createdTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** [NOT NULL] DeviceId */
  deviceId?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] MemberNumber */
  memberNumber?: InputMaybe<Scalars['String']['input']>;
  /** [ID] Seq */
  seq?: InputMaybe<Scalars['Long']['input']>;
};

/** WfcLibraryLog */
export type Club_WorldFamilyClub_WfcLibraryLogSortInput = {
  /** [NOT NULL] CreatedTime */
  createdTime?: InputMaybe<SortEnumType>;
  /** [NOT NULL] DeviceId */
  deviceId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Market */
  market?: InputMaybe<SortEnumType>;
  /** [NOT NULL] MemberNumber */
  memberNumber?: InputMaybe<SortEnumType>;
  /** [ID] Seq */
  seq?: InputMaybe<SortEnumType>;
};

/** WfcNowPageViewLog */
export type Club_WorldFamilyClub_WfcNowPageViewLog = Node & {
  __typename?: 'Club_WorldFamilyClub_WfcNowPageViewLog';
  /** [NOT NULL] ClientType */
  clientType?: Maybe<Scalars['String']['output']>;
  /** CreatedTime */
  createdTime?: Maybe<Scalars['DateTime']['output']>;
  /** [NOT NULL] DeviceId */
  deviceId?: Maybe<Scalars['String']['output']>;
  /** [ID] WfcNowPageViewLogId */
  id: Scalars['ID']['output'];
  /** [NOT NULL] MemberNumber */
  memberNumber?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] PageId */
  pageId?: Maybe<Scalars['Int']['output']>;
  /** [NOT NULL] PageUrl */
  pageUrl?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Club_WorldFamilyClub_WfcNowPageViewLogConnection = {
  __typename?: 'Club_WorldFamilyClub_WfcNowPageViewLogConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Club_WorldFamilyClub_WfcNowPageViewLogEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Club_WorldFamilyClub_WfcNowPageViewLog>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Club_WorldFamilyClub_WfcNowPageViewLogEdge = {
  __typename?: 'Club_WorldFamilyClub_WfcNowPageViewLogEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Club_WorldFamilyClub_WfcNowPageViewLog;
};

/** WfcNowPageViewLog */
export type Club_WorldFamilyClub_WfcNowPageViewLogFilterInput = {
  and?: InputMaybe<Array<Club_WorldFamilyClub_WfcNowPageViewLogFilterInput>>;
  /** [NOT NULL] ClientType */
  clientType?: InputMaybe<StringOperationFilterInput>;
  /** CreatedTime */
  createdTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** [NOT NULL] DeviceId */
  deviceId?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] MemberNumber */
  memberNumber?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Club_WorldFamilyClub_WfcNowPageViewLogFilterInput>>;
  /** [NOT NULL] PageId */
  pageId?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] PageUrl */
  pageUrl?: InputMaybe<StringOperationFilterInput>;
  /** [ID] WfcNowPageViewLogId */
  wfcNowPageViewLogId?: InputMaybe<LongOperationFilterInput>;
};

/** WfcNowPageViewLog */
export type Club_WorldFamilyClub_WfcNowPageViewLogInput = {
  /** [NOT NULL] ClientType */
  clientType?: InputMaybe<Scalars['String']['input']>;
  /** CreatedTime */
  createdTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** [NOT NULL] DeviceId */
  deviceId?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] MemberNumber */
  memberNumber?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] PageId */
  pageId?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] PageUrl */
  pageUrl?: InputMaybe<Scalars['String']['input']>;
  /** [ID] WfcNowPageViewLogId */
  wfcNowPageViewLogId?: InputMaybe<Scalars['Long']['input']>;
};

/** WfcNowPageViewLog */
export type Club_WorldFamilyClub_WfcNowPageViewLogSortInput = {
  /** [NOT NULL] ClientType */
  clientType?: InputMaybe<SortEnumType>;
  /** CreatedTime */
  createdTime?: InputMaybe<SortEnumType>;
  /** [NOT NULL] DeviceId */
  deviceId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] MemberNumber */
  memberNumber?: InputMaybe<SortEnumType>;
  /** [NOT NULL] PageId */
  pageId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] PageUrl */
  pageUrl?: InputMaybe<SortEnumType>;
  /** [ID] WfcNowPageViewLogId */
  wfcNowPageViewLogId?: InputMaybe<SortEnumType>;
};

export type DateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  neq?: InputMaybe<Scalars['DateTime']['input']>;
  ngt?: InputMaybe<Scalars['DateTime']['input']>;
  ngte?: InputMaybe<Scalars['DateTime']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  nlt?: InputMaybe<Scalars['DateTime']['input']>;
  nlte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DecimalOperationFilterInput = {
  eq?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Decimal']['input']>>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  neq?: InputMaybe<Scalars['Decimal']['input']>;
  ngt?: InputMaybe<Scalars['Decimal']['input']>;
  ngte?: InputMaybe<Scalars['Decimal']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Decimal']['input']>>>;
  nlt?: InputMaybe<Scalars['Decimal']['input']>;
  nlte?: InputMaybe<Scalars['Decimal']['input']>;
};

export type DefaultServiceBannerInfo = {
  __typename?: 'DefaultServiceBannerInfo';
  image: Scalars['String']['output'];
  market: Scalars['String']['output'];
  publishDate: Scalars['String']['output'];
  seq: Scalars['Int']['output'];
  service: Scalars['String']['output'];
  stopDate: Scalars['String']['output'];
  theme: Scalars['String']['output'];
};

export type DefaultServiceBannerInfoFilterInput = {
  and?: InputMaybe<Array<DefaultServiceBannerInfoFilterInput>>;
  image?: InputMaybe<StringOperationFilterInput>;
  market?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DefaultServiceBannerInfoFilterInput>>;
  publishDate?: InputMaybe<StringOperationFilterInput>;
  seq?: InputMaybe<IntOperationFilterInput>;
  service?: InputMaybe<StringOperationFilterInput>;
  stopDate?: InputMaybe<StringOperationFilterInput>;
  theme?: InputMaybe<StringOperationFilterInput>;
};

export type DefaultServiceBannerInfoSortInput = {
  image?: InputMaybe<SortEnumType>;
  market?: InputMaybe<SortEnumType>;
  publishDate?: InputMaybe<SortEnumType>;
  seq?: InputMaybe<SortEnumType>;
  service?: InputMaybe<SortEnumType>;
  stopDate?: InputMaybe<SortEnumType>;
  theme?: InputMaybe<SortEnumType>;
};

export type DefaultServiceBannerParameterInput = {
  image: Scalars['String']['input'];
  seq: Scalars['Int']['input'];
};

export type EntryPackageOrderListParameterInput = {
  customerName?: InputMaybe<Scalars['String']['input']>;
  market: Scalars['String']['input'];
  orderEndDate?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  /** Order Start Date (yyyy-MM-dd) */
  orderStartDate?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type EntryPackageOrderListResult = {
  __typename?: 'EntryPackageOrderListResult';
  buldNo?: Maybe<Scalars['String']['output']>;
  canceledDate?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customerName: Scalars['String']['output'];
  easyPayCno: Scalars['String']['output'];
  email: Scalars['String']['output'];
  emdCd?: Maybe<Scalars['String']['output']>;
  fullAddress?: Maybe<Scalars['String']['output']>;
  /** 是否同意接收廣告性資訊 (true or false) */
  isAdvertisingInfoAgreed: Scalars['Boolean']['output'];
  /** 是否同意為行銷及廣告目的收集個人資訊 (true or false) */
  isMarketingInfoCollectionAgreed: Scalars['Boolean']['output'];
  memberNo?: Maybe<Scalars['String']['output']>;
  memberPaymentInfo: EntryPackageOrdersMemberPaymentInfoResult;
  orderId: Scalars['String']['output'];
  packageNo: Scalars['String']['output'];
  paidAmount: Scalars['Int']['output'];
  paymentAmount: Scalars['Int']['output'];
  paymentDate?: Maybe<Scalars['DateTime']['output']>;
  paymentMethod: Scalars['String']['output'];
  paymentStatus: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  productCode: Scalars['String']['output'];
  roadCd?: Maybe<Scalars['String']['output']>;
  sggCd?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type EntryPackageOrderListResultFilterInput = {
  and?: InputMaybe<Array<EntryPackageOrderListResultFilterInput>>;
  buldNo?: InputMaybe<StringOperationFilterInput>;
  canceledDate?: InputMaybe<DateTimeOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  customerName?: InputMaybe<StringOperationFilterInput>;
  easyPayCno?: InputMaybe<StringOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  emdCd?: InputMaybe<StringOperationFilterInput>;
  fullAddress?: InputMaybe<StringOperationFilterInput>;
  /** 是否同意接收廣告性資訊 (true or false) */
  isAdvertisingInfoAgreed?: InputMaybe<BooleanOperationFilterInput>;
  /** 是否同意為行銷及廣告目的收集個人資訊 (true or false) */
  isMarketingInfoCollectionAgreed?: InputMaybe<BooleanOperationFilterInput>;
  memberNo?: InputMaybe<StringOperationFilterInput>;
  memberPaymentInfo?: InputMaybe<EntryPackageOrdersMemberPaymentInfoResultFilterInput>;
  or?: InputMaybe<Array<EntryPackageOrderListResultFilterInput>>;
  orderId?: InputMaybe<StringOperationFilterInput>;
  packageNo?: InputMaybe<StringOperationFilterInput>;
  paidAmount?: InputMaybe<IntOperationFilterInput>;
  paymentAmount?: InputMaybe<IntOperationFilterInput>;
  paymentDate?: InputMaybe<DateTimeOperationFilterInput>;
  paymentMethod?: InputMaybe<StringOperationFilterInput>;
  paymentStatus?: InputMaybe<StringOperationFilterInput>;
  phoneNumber?: InputMaybe<StringOperationFilterInput>;
  productCode?: InputMaybe<StringOperationFilterInput>;
  roadCd?: InputMaybe<StringOperationFilterInput>;
  sggCd?: InputMaybe<StringOperationFilterInput>;
  zipCode?: InputMaybe<StringOperationFilterInput>;
};

export type EntryPackageOrderListResultSortInput = {
  buldNo?: InputMaybe<SortEnumType>;
  canceledDate?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  customerName?: InputMaybe<SortEnumType>;
  easyPayCno?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  emdCd?: InputMaybe<SortEnumType>;
  fullAddress?: InputMaybe<SortEnumType>;
  /** 是否同意接收廣告性資訊 (true or false) */
  isAdvertisingInfoAgreed?: InputMaybe<SortEnumType>;
  /** 是否同意為行銷及廣告目的收集個人資訊 (true or false) */
  isMarketingInfoCollectionAgreed?: InputMaybe<SortEnumType>;
  memberNo?: InputMaybe<SortEnumType>;
  memberPaymentInfo?: InputMaybe<EntryPackageOrdersMemberPaymentInfoResultSortInput>;
  orderId?: InputMaybe<SortEnumType>;
  packageNo?: InputMaybe<SortEnumType>;
  paidAmount?: InputMaybe<SortEnumType>;
  paymentAmount?: InputMaybe<SortEnumType>;
  paymentDate?: InputMaybe<SortEnumType>;
  paymentMethod?: InputMaybe<SortEnumType>;
  paymentStatus?: InputMaybe<SortEnumType>;
  phoneNumber?: InputMaybe<SortEnumType>;
  productCode?: InputMaybe<SortEnumType>;
  roadCd?: InputMaybe<SortEnumType>;
  sggCd?: InputMaybe<SortEnumType>;
  zipCode?: InputMaybe<SortEnumType>;
};

export type EntryPackageOrdersMemberPaymentInfoResult = {
  __typename?: 'EntryPackageOrdersMemberPaymentInfoResult';
  accountHolderName: Scalars['String']['output'];
  bankCode: Scalars['String']['output'];
  bankName: Scalars['String']['output'];
  birthDate: Scalars['String']['output'];
  creditCardBankCode: Scalars['String']['output'];
  creditCardBankName: Scalars['String']['output'];
  displayMask: Scalars['String']['output'];
  expiryMonth?: Maybe<Scalars['String']['output']>;
  expiryYear?: Maybe<Scalars['String']['output']>;
  paymentInfoId: Scalars['Int']['output'];
  paymentNumber: Scalars['String']['output'];
  paymentNumberEncrypted: Scalars['String']['output'];
  paymentType: Scalars['Byte']['output'];
};

export type EntryPackageOrdersMemberPaymentInfoResultFilterInput = {
  accountHolderName?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<EntryPackageOrdersMemberPaymentInfoResultFilterInput>>;
  bankCode?: InputMaybe<StringOperationFilterInput>;
  bankName?: InputMaybe<StringOperationFilterInput>;
  birthDate?: InputMaybe<StringOperationFilterInput>;
  creditCardBankCode?: InputMaybe<StringOperationFilterInput>;
  creditCardBankName?: InputMaybe<StringOperationFilterInput>;
  displayMask?: InputMaybe<StringOperationFilterInput>;
  expiryMonth?: InputMaybe<StringOperationFilterInput>;
  expiryYear?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EntryPackageOrdersMemberPaymentInfoResultFilterInput>>;
  paymentInfoId?: InputMaybe<IntOperationFilterInput>;
  paymentNumber?: InputMaybe<StringOperationFilterInput>;
  paymentNumberEncrypted?: InputMaybe<StringOperationFilterInput>;
  paymentType?: InputMaybe<ByteOperationFilterInput>;
};

export type EntryPackageOrdersMemberPaymentInfoResultSortInput = {
  accountHolderName?: InputMaybe<SortEnumType>;
  bankCode?: InputMaybe<SortEnumType>;
  bankName?: InputMaybe<SortEnumType>;
  birthDate?: InputMaybe<SortEnumType>;
  creditCardBankCode?: InputMaybe<SortEnumType>;
  creditCardBankName?: InputMaybe<SortEnumType>;
  displayMask?: InputMaybe<SortEnumType>;
  expiryMonth?: InputMaybe<SortEnumType>;
  expiryYear?: InputMaybe<SortEnumType>;
  paymentInfoId?: InputMaybe<SortEnumType>;
  paymentNumber?: InputMaybe<SortEnumType>;
  paymentNumberEncrypted?: InputMaybe<SortEnumType>;
  paymentType?: InputMaybe<SortEnumType>;
};

export enum Error {
  AddFailed = 'ADD_FAILED',
  DeleteFailed = 'DELETE_FAILED',
  Sented = 'SENTED',
  UpdateFailed = 'UPDATE_FAILED'
}

export type FloatOperationFilterInput = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  neq?: InputMaybe<Scalars['Float']['input']>;
  ngt?: InputMaybe<Scalars['Float']['input']>;
  ngte?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  nlt?: InputMaybe<Scalars['Float']['input']>;
  nlte?: InputMaybe<Scalars['Float']['input']>;
};

export type GetLeadsReplySourceInformationRequestInput = {
  leadsNumber: Scalars['String']['input'];
  sourceCode: Scalars['String']['input'];
};

export type GetLeadsReplySourceInformationResponse = {
  __typename?: 'GetLeadsReplySourceInformationResponse';
  /** Assign date */
  assignDate: Scalars['String']['output'];
  /** Assign end date */
  assignEndDate: Scalars['String']['output'];
  /** Assign id */
  assignId: Scalars['Int']['output'];
  /** Father name */
  father: Scalars['String']['output'];
  /** Key in date */
  keyinDate: Scalars['String']['output'];
  /** Leads no */
  leadsNumber: Scalars['String']['output'];
  /** Mother name */
  mother: Scalars['String']['output'];
  /** Promoter */
  promoter: Scalars['String']['output'];
  /** Sale code */
  salesCode: Scalars['String']['output'];
  /** Source code */
  sourceCode: Scalars['String']['output'];
  /** Source id */
  sourceId: Scalars['Int']['output'];
};

export type GetUpgradePaymentListParameterInput = {
  market: Scalars['String']['input'];
  memberNumber?: InputMaybe<Scalars['String']['input']>;
  paymentEndDate?: InputMaybe<Scalars['String']['input']>;
  paymentStartDate?: InputMaybe<Scalars['String']['input']>;
};

export type GoGoLiveLevelInfo = {
  __typename?: 'GoGoLiveLevelInfo';
  levelId: Scalars['String']['output'];
  levelName: Scalars['String']['output'];
};

export type GoGoLiveLevelInfoFilterInput = {
  and?: InputMaybe<Array<GoGoLiveLevelInfoFilterInput>>;
  levelId?: InputMaybe<StringOperationFilterInput>;
  levelName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<GoGoLiveLevelInfoFilterInput>>;
};

export type GoGoLiveLevelInfoSortInput = {
  levelId?: InputMaybe<SortEnumType>;
  levelName?: InputMaybe<SortEnumType>;
};

export type GoGoLiveParentGuideDetailInfo = {
  __typename?: 'GoGoLiveParentGuideDetailInfo';
  bookPage: Scalars['String']['output'];
  goGoLiveParentGuideId: Scalars['Int']['output'];
  introduction: Scalars['String']['output'];
  languagePoint: Scalars['String']['output'];
  learningGoals: Array<Scalars['String']['output']>;
  lessonTitle: Scalars['String']['output'];
  levelId: Scalars['String']['output'];
  levelName: Scalars['String']['output'];
  previewVideoCoverImageFileName: Scalars['String']['output'];
  previewVideoVimeoId: Scalars['String']['output'];
  printableSheet: Scalars['String']['output'];
  sessions: Array<GoGoLiveSessionInfo>;
  showAndTell: Scalars['String']['output'];
  songList: Array<GoGoLiveParentGuideSongInfo>;
  toys: Array<GoGoLiveToyInfo>;
  wordList: Array<TalkAlongCardInfo>;
  yearAndMonth: Scalars['String']['output'];
};

export type GoGoLiveParentGuideDetailInfoFilterInput = {
  and?: InputMaybe<Array<GoGoLiveParentGuideDetailInfoFilterInput>>;
  bookPage?: InputMaybe<StringOperationFilterInput>;
  goGoLiveParentGuideId?: InputMaybe<IntOperationFilterInput>;
  introduction?: InputMaybe<StringOperationFilterInput>;
  languagePoint?: InputMaybe<StringOperationFilterInput>;
  learningGoals?: InputMaybe<ListStringOperationFilterInput>;
  lessonTitle?: InputMaybe<StringOperationFilterInput>;
  levelId?: InputMaybe<StringOperationFilterInput>;
  levelName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<GoGoLiveParentGuideDetailInfoFilterInput>>;
  previewVideoCoverImageFileName?: InputMaybe<StringOperationFilterInput>;
  previewVideoVimeoId?: InputMaybe<StringOperationFilterInput>;
  printableSheet?: InputMaybe<StringOperationFilterInput>;
  sessions?: InputMaybe<ListFilterInputTypeOfGoGoLiveSessionInfoFilterInput>;
  showAndTell?: InputMaybe<StringOperationFilterInput>;
  songList?: InputMaybe<ListFilterInputTypeOfGoGoLiveParentGuideSongInfoFilterInput>;
  toys?: InputMaybe<ListFilterInputTypeOfGoGoLiveToyInfoFilterInput>;
  wordList?: InputMaybe<ListFilterInputTypeOfTalkAlongCardInfoFilterInput>;
  yearAndMonth?: InputMaybe<StringOperationFilterInput>;
};

export type GoGoLiveParentGuideDetailInfoSortInput = {
  bookPage?: InputMaybe<SortEnumType>;
  goGoLiveParentGuideId?: InputMaybe<SortEnumType>;
  introduction?: InputMaybe<SortEnumType>;
  languagePoint?: InputMaybe<SortEnumType>;
  lessonTitle?: InputMaybe<SortEnumType>;
  levelId?: InputMaybe<SortEnumType>;
  levelName?: InputMaybe<SortEnumType>;
  previewVideoCoverImageFileName?: InputMaybe<SortEnumType>;
  previewVideoVimeoId?: InputMaybe<SortEnumType>;
  printableSheet?: InputMaybe<SortEnumType>;
  showAndTell?: InputMaybe<SortEnumType>;
  yearAndMonth?: InputMaybe<SortEnumType>;
};

export type GoGoLiveParentGuideInfo = {
  __typename?: 'GoGoLiveParentGuideInfo';
  goGoLiveParentGuideId: Scalars['Int']['output'];
  levelName: Scalars['String']['output'];
  previewVideoUrl: Scalars['String']['output'];
  previewVideoVimeoId: Scalars['String']['output'];
  yearAndMonth: Scalars['String']['output'];
};

export type GoGoLiveParentGuideInfoFilterInput = {
  and?: InputMaybe<Array<GoGoLiveParentGuideInfoFilterInput>>;
  goGoLiveParentGuideId?: InputMaybe<IntOperationFilterInput>;
  levelName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<GoGoLiveParentGuideInfoFilterInput>>;
  previewVideoUrl?: InputMaybe<StringOperationFilterInput>;
  previewVideoVimeoId?: InputMaybe<StringOperationFilterInput>;
  yearAndMonth?: InputMaybe<StringOperationFilterInput>;
};

export type GoGoLiveParentGuideInfoSortInput = {
  goGoLiveParentGuideId?: InputMaybe<SortEnumType>;
  levelName?: InputMaybe<SortEnumType>;
  previewVideoUrl?: InputMaybe<SortEnumType>;
  previewVideoVimeoId?: InputMaybe<SortEnumType>;
  yearAndMonth?: InputMaybe<SortEnumType>;
};

export type GoGoLiveParentGuideLocaleInfo = {
  __typename?: 'GoGoLiveParentGuideLocaleInfo';
  goGoLiveParentGuideId: Scalars['Int']['output'];
  goGoLiveParentGuideLocaleId: Scalars['Int']['output'];
  introduction: Scalars['String']['output'];
  learningGoals: Scalars['String']['output'];
  market: Scalars['String']['output'];
  showAndTell: Scalars['String']['output'];
};

export type GoGoLiveParentGuideLocaleInfoFilterInput = {
  and?: InputMaybe<Array<GoGoLiveParentGuideLocaleInfoFilterInput>>;
  goGoLiveParentGuideId?: InputMaybe<IntOperationFilterInput>;
  goGoLiveParentGuideLocaleId?: InputMaybe<IntOperationFilterInput>;
  introduction?: InputMaybe<StringOperationFilterInput>;
  learningGoals?: InputMaybe<StringOperationFilterInput>;
  market?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<GoGoLiveParentGuideLocaleInfoFilterInput>>;
  showAndTell?: InputMaybe<StringOperationFilterInput>;
};

export type GoGoLiveParentGuideLocaleInfoSortInput = {
  goGoLiveParentGuideId?: InputMaybe<SortEnumType>;
  goGoLiveParentGuideLocaleId?: InputMaybe<SortEnumType>;
  introduction?: InputMaybe<SortEnumType>;
  learningGoals?: InputMaybe<SortEnumType>;
  market?: InputMaybe<SortEnumType>;
  showAndTell?: InputMaybe<SortEnumType>;
};

export type GoGoLiveParentGuideSongInfo = {
  __typename?: 'GoGoLiveParentGuideSongInfo';
  discCode: Scalars['String']['output'];
  eTabCode: Scalars['String']['output'];
  songs: Array<GoGoLiveSongInfo>;
};

export type GoGoLiveParentGuideSongInfoFilterInput = {
  and?: InputMaybe<Array<GoGoLiveParentGuideSongInfoFilterInput>>;
  discCode?: InputMaybe<StringOperationFilterInput>;
  eTabCode?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<GoGoLiveParentGuideSongInfoFilterInput>>;
  songs?: InputMaybe<ListFilterInputTypeOfGoGoLiveSongInfoFilterInput>;
};

export type GoGoLiveParentGuideSongInfoInput = {
  discCode: Scalars['String']['input'];
  eTabCode: Scalars['String']['input'];
  songs: Array<GoGoLiveSongInfoInput>;
};

export type GoGoLiveSessionInfo = {
  __typename?: 'GoGoLiveSessionInfo';
  sessionId: Scalars['Int']['output'];
  sessionName?: Maybe<Scalars['String']['output']>;
};

export type GoGoLiveSessionInfoFilterInput = {
  and?: InputMaybe<Array<GoGoLiveSessionInfoFilterInput>>;
  or?: InputMaybe<Array<GoGoLiveSessionInfoFilterInput>>;
  sessionId?: InputMaybe<IntOperationFilterInput>;
  sessionName?: InputMaybe<StringOperationFilterInput>;
};

export type GoGoLiveSessionInfoInput = {
  sessionId: Scalars['Int']['input'];
  sessionName?: InputMaybe<Scalars['String']['input']>;
};

export type GoGoLiveSessionInfoSortInput = {
  sessionId?: InputMaybe<SortEnumType>;
  sessionName?: InputMaybe<SortEnumType>;
};

export type GoGoLiveSongInfo = {
  __typename?: 'GoGoLiveSongInfo';
  songId: Scalars['Int']['output'];
  songName?: Maybe<Scalars['String']['output']>;
};

export type GoGoLiveSongInfoFilterInput = {
  and?: InputMaybe<Array<GoGoLiveSongInfoFilterInput>>;
  or?: InputMaybe<Array<GoGoLiveSongInfoFilterInput>>;
  songId?: InputMaybe<IntOperationFilterInput>;
  songName?: InputMaybe<StringOperationFilterInput>;
};

export type GoGoLiveSongInfoInput = {
  songId: Scalars['Int']['input'];
  songName?: InputMaybe<Scalars['String']['input']>;
};

export type GoGoLiveSongInfoSortInput = {
  songId?: InputMaybe<SortEnumType>;
  songName?: InputMaybe<SortEnumType>;
};

export type GoGoLiveToyInfo = {
  __typename?: 'GoGoLiveToyInfo';
  toyId: Scalars['Int']['output'];
  toyImageFile?: Maybe<Scalars['String']['output']>;
  toyName?: Maybe<Scalars['String']['output']>;
};

export type GoGoLiveToyInfoFilterInput = {
  and?: InputMaybe<Array<GoGoLiveToyInfoFilterInput>>;
  or?: InputMaybe<Array<GoGoLiveToyInfoFilterInput>>;
  toyId?: InputMaybe<IntOperationFilterInput>;
  toyImageFile?: InputMaybe<StringOperationFilterInput>;
  toyName?: InputMaybe<StringOperationFilterInput>;
};

export type GoGoLiveToyInfoInput = {
  toyId: Scalars['Int']['input'];
  toyImageFile?: InputMaybe<Scalars['String']['input']>;
  toyName?: InputMaybe<Scalars['String']['input']>;
};

export type GoGoLiveToyInfoSortInput = {
  toyId?: InputMaybe<SortEnumType>;
  toyImageFile?: InputMaybe<SortEnumType>;
  toyName?: InputMaybe<SortEnumType>;
};

export type IntOperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  neq?: InputMaybe<Scalars['Int']['input']>;
  ngt?: InputMaybe<Scalars['Int']['input']>;
  ngte?: InputMaybe<Scalars['Int']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  nlt?: InputMaybe<Scalars['Int']['input']>;
  nlte?: InputMaybe<Scalars['Int']['input']>;
};

export type KidsWorldVideoAddParameterInput = {
  adminFirstUser: Scalars['String']['input'];
  vimeoId1: Scalars['String']['input'];
  vimeoId2?: InputMaybe<Scalars['String']['input']>;
  vimeoId3?: InputMaybe<Scalars['String']['input']>;
  vimeoId4?: InputMaybe<Scalars['String']['input']>;
  vimeoId5?: InputMaybe<Scalars['String']['input']>;
  yearAndMonth: Scalars['String']['input'];
};

export type KidsWorldVideoInfoResult = {
  __typename?: 'KidsWorldVideoInfoResult';
  kidsWorldVideoId: Scalars['Int']['output'];
  thumbnailUrl1: Scalars['String']['output'];
  thumbnailUrl2: Scalars['String']['output'];
  thumbnailUrl3: Scalars['String']['output'];
  thumbnailUrl4: Scalars['String']['output'];
  thumbnailUrl5: Scalars['String']['output'];
  title1: Scalars['String']['output'];
  title2: Scalars['String']['output'];
  title3: Scalars['String']['output'];
  title4: Scalars['String']['output'];
  title5: Scalars['String']['output'];
  vimeoId1: Scalars['String']['output'];
  vimeoId2: Scalars['String']['output'];
  vimeoId3: Scalars['String']['output'];
  vimeoId4: Scalars['String']['output'];
  vimeoId5: Scalars['String']['output'];
  vimeoVideoUrl1: Scalars['String']['output'];
  vimeoVideoUrl2: Scalars['String']['output'];
  vimeoVideoUrl3: Scalars['String']['output'];
  vimeoVideoUrl4: Scalars['String']['output'];
  vimeoVideoUrl5: Scalars['String']['output'];
  yearAndMonth: Scalars['String']['output'];
};

export type KidsWorldVideoInfoResultFilterInput = {
  and?: InputMaybe<Array<KidsWorldVideoInfoResultFilterInput>>;
  kidsWorldVideoId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<KidsWorldVideoInfoResultFilterInput>>;
  thumbnailUrl1?: InputMaybe<StringOperationFilterInput>;
  thumbnailUrl2?: InputMaybe<StringOperationFilterInput>;
  thumbnailUrl3?: InputMaybe<StringOperationFilterInput>;
  thumbnailUrl4?: InputMaybe<StringOperationFilterInput>;
  thumbnailUrl5?: InputMaybe<StringOperationFilterInput>;
  title1?: InputMaybe<StringOperationFilterInput>;
  title2?: InputMaybe<StringOperationFilterInput>;
  title3?: InputMaybe<StringOperationFilterInput>;
  title4?: InputMaybe<StringOperationFilterInput>;
  title5?: InputMaybe<StringOperationFilterInput>;
  vimeoId1?: InputMaybe<StringOperationFilterInput>;
  vimeoId2?: InputMaybe<StringOperationFilterInput>;
  vimeoId3?: InputMaybe<StringOperationFilterInput>;
  vimeoId4?: InputMaybe<StringOperationFilterInput>;
  vimeoId5?: InputMaybe<StringOperationFilterInput>;
  vimeoVideoUrl1?: InputMaybe<StringOperationFilterInput>;
  vimeoVideoUrl2?: InputMaybe<StringOperationFilterInput>;
  vimeoVideoUrl3?: InputMaybe<StringOperationFilterInput>;
  vimeoVideoUrl4?: InputMaybe<StringOperationFilterInput>;
  vimeoVideoUrl5?: InputMaybe<StringOperationFilterInput>;
  yearAndMonth?: InputMaybe<StringOperationFilterInput>;
};

export type KidsWorldVideoInfoResultSortInput = {
  kidsWorldVideoId?: InputMaybe<SortEnumType>;
  thumbnailUrl1?: InputMaybe<SortEnumType>;
  thumbnailUrl2?: InputMaybe<SortEnumType>;
  thumbnailUrl3?: InputMaybe<SortEnumType>;
  thumbnailUrl4?: InputMaybe<SortEnumType>;
  thumbnailUrl5?: InputMaybe<SortEnumType>;
  title1?: InputMaybe<SortEnumType>;
  title2?: InputMaybe<SortEnumType>;
  title3?: InputMaybe<SortEnumType>;
  title4?: InputMaybe<SortEnumType>;
  title5?: InputMaybe<SortEnumType>;
  vimeoId1?: InputMaybe<SortEnumType>;
  vimeoId2?: InputMaybe<SortEnumType>;
  vimeoId3?: InputMaybe<SortEnumType>;
  vimeoId4?: InputMaybe<SortEnumType>;
  vimeoId5?: InputMaybe<SortEnumType>;
  vimeoVideoUrl1?: InputMaybe<SortEnumType>;
  vimeoVideoUrl2?: InputMaybe<SortEnumType>;
  vimeoVideoUrl3?: InputMaybe<SortEnumType>;
  vimeoVideoUrl4?: InputMaybe<SortEnumType>;
  vimeoVideoUrl5?: InputMaybe<SortEnumType>;
  yearAndMonth?: InputMaybe<SortEnumType>;
};

export type KidsWorldVideoUpdateParameterInput = {
  adminFirstUser: Scalars['String']['input'];
  kidsWorldVideoId: Scalars['Int']['input'];
  vimeoId1: Scalars['String']['input'];
  vimeoId2?: InputMaybe<Scalars['String']['input']>;
  vimeoId3?: InputMaybe<Scalars['String']['input']>;
  vimeoId4?: InputMaybe<Scalars['String']['input']>;
  vimeoId5?: InputMaybe<Scalars['String']['input']>;
  yearAndMonth: Scalars['String']['input'];
};

export type ListFilterInputTypeOfClub_WorldFamilyClub_DweProductSongFilterInput = {
  all?: InputMaybe<Club_WorldFamilyClub_DweProductSongFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Club_WorldFamilyClub_DweProductSongFilterInput>;
  some?: InputMaybe<Club_WorldFamilyClub_DweProductSongFilterInput>;
};

export type ListFilterInputTypeOfClub_WorldFamilyClub_DweProductSongToolFilterInput = {
  all?: InputMaybe<Club_WorldFamilyClub_DweProductSongToolFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Club_WorldFamilyClub_DweProductSongToolFilterInput>;
  some?: InputMaybe<Club_WorldFamilyClub_DweProductSongToolFilterInput>;
};

export type ListFilterInputTypeOfClub_WorldFamilyClub_FaceCallHistFilterInput = {
  all?: InputMaybe<Club_WorldFamilyClub_FaceCallHistFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Club_WorldFamilyClub_FaceCallHistFilterInput>;
  some?: InputMaybe<Club_WorldFamilyClub_FaceCallHistFilterInput>;
};

export type ListFilterInputTypeOfClub_WorldFamilyClub_FaceCallMonthlyRecommendFilterInput = {
  all?: InputMaybe<Club_WorldFamilyClub_FaceCallMonthlyRecommendFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Club_WorldFamilyClub_FaceCallMonthlyRecommendFilterInput>;
  some?: InputMaybe<Club_WorldFamilyClub_FaceCallMonthlyRecommendFilterInput>;
};

export type ListFilterInputTypeOfClub_WorldFamilyClub_FaceCallSongAndPerformerFilterInput = {
  all?: InputMaybe<Club_WorldFamilyClub_FaceCallSongAndPerformerFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Club_WorldFamilyClub_FaceCallSongAndPerformerFilterInput>;
  some?: InputMaybe<Club_WorldFamilyClub_FaceCallSongAndPerformerFilterInput>;
};

export type ListFilterInputTypeOfClub_WorldFamilyClub_FaceCallSongFilterInput = {
  all?: InputMaybe<Club_WorldFamilyClub_FaceCallSongFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Club_WorldFamilyClub_FaceCallSongFilterInput>;
  some?: InputMaybe<Club_WorldFamilyClub_FaceCallSongFilterInput>;
};

export type ListFilterInputTypeOfClub_WorldFamilyClub_FaceCallSongPublicFilterInput = {
  all?: InputMaybe<Club_WorldFamilyClub_FaceCallSongPublicFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Club_WorldFamilyClub_FaceCallSongPublicFilterInput>;
  some?: InputMaybe<Club_WorldFamilyClub_FaceCallSongPublicFilterInput>;
};

export type ListFilterInputTypeOfClub_WorldFamilyClub_GraduationApplicationEvaluationFilterInput = {
  all?: InputMaybe<Club_WorldFamilyClub_GraduationApplicationEvaluationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Club_WorldFamilyClub_GraduationApplicationEvaluationFilterInput>;
  some?: InputMaybe<Club_WorldFamilyClub_GraduationApplicationEvaluationFilterInput>;
};

export type ListFilterInputTypeOfClub_WorldFamilyClub_GraduationApplicationFilterInput = {
  all?: InputMaybe<Club_WorldFamilyClub_GraduationApplicationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Club_WorldFamilyClub_GraduationApplicationFilterInput>;
  some?: InputMaybe<Club_WorldFamilyClub_GraduationApplicationFilterInput>;
};

export type ListFilterInputTypeOfClub_WorldFamilyClub_GraduationApplicationSubTaskFilterInput = {
  all?: InputMaybe<Club_WorldFamilyClub_GraduationApplicationSubTaskFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Club_WorldFamilyClub_GraduationApplicationSubTaskFilterInput>;
  some?: InputMaybe<Club_WorldFamilyClub_GraduationApplicationSubTaskFilterInput>;
};

export type ListFilterInputTypeOfClub_WorldFamilyClub_GraduationEvaluationFilterInput = {
  all?: InputMaybe<Club_WorldFamilyClub_GraduationEvaluationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Club_WorldFamilyClub_GraduationEvaluationFilterInput>;
  some?: InputMaybe<Club_WorldFamilyClub_GraduationEvaluationFilterInput>;
};

export type ListFilterInputTypeOfClub_WorldFamilyClub_GraduationSubApplicationFilterInput = {
  all?: InputMaybe<Club_WorldFamilyClub_GraduationSubApplicationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Club_WorldFamilyClub_GraduationSubApplicationFilterInput>;
  some?: InputMaybe<Club_WorldFamilyClub_GraduationSubApplicationFilterInput>;
};

export type ListFilterInputTypeOfClub_WorldFamilyClub_GraduationSubTaskMarketDescriptionFilterInput = {
  all?: InputMaybe<Club_WorldFamilyClub_GraduationSubTaskMarketDescriptionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Club_WorldFamilyClub_GraduationSubTaskMarketDescriptionFilterInput>;
  some?: InputMaybe<Club_WorldFamilyClub_GraduationSubTaskMarketDescriptionFilterInput>;
};

export type ListFilterInputTypeOfClub_WorldFamilyClub_GraduationTaskMarketDescriptionFilterInput = {
  all?: InputMaybe<Club_WorldFamilyClub_GraduationTaskMarketDescriptionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Club_WorldFamilyClub_GraduationTaskMarketDescriptionFilterInput>;
  some?: InputMaybe<Club_WorldFamilyClub_GraduationTaskMarketDescriptionFilterInput>;
};

export type ListFilterInputTypeOfClub_WorldFamilyClub_GraphqlAccessFilterInput = {
  all?: InputMaybe<Club_WorldFamilyClub_GraphqlAccessFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Club_WorldFamilyClub_GraphqlAccessFilterInput>;
  some?: InputMaybe<Club_WorldFamilyClub_GraphqlAccessFilterInput>;
};

export type ListFilterInputTypeOfClub_WorldFamilyClub_MyFavoriteFaceCallFilterInput = {
  all?: InputMaybe<Club_WorldFamilyClub_MyFavoriteFaceCallFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Club_WorldFamilyClub_MyFavoriteFaceCallFilterInput>;
  some?: InputMaybe<Club_WorldFamilyClub_MyFavoriteFaceCallFilterInput>;
};

export type ListFilterInputTypeOfClub_WorldFamilyClub_MyFavoriteFaceCallSongFilterInput = {
  all?: InputMaybe<Club_WorldFamilyClub_MyFavoriteFaceCallSongFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Club_WorldFamilyClub_MyFavoriteFaceCallSongFilterInput>;
  some?: InputMaybe<Club_WorldFamilyClub_MyFavoriteFaceCallSongFilterInput>;
};

export type ListFilterInputTypeOfClub_WorldFamilyClub_TeSongToyFilterInput = {
  all?: InputMaybe<Club_WorldFamilyClub_TeSongToyFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Club_WorldFamilyClub_TeSongToyFilterInput>;
  some?: InputMaybe<Club_WorldFamilyClub_TeSongToyFilterInput>;
};

export type ListFilterInputTypeOfClub_WorldFamilyClub_TestWaterSubFilterInput = {
  all?: InputMaybe<Club_WorldFamilyClub_TestWaterSubFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Club_WorldFamilyClub_TestWaterSubFilterInput>;
  some?: InputMaybe<Club_WorldFamilyClub_TestWaterSubFilterInput>;
};

export type ListFilterInputTypeOfGoGoLiveParentGuideSongInfoFilterInput = {
  all?: InputMaybe<GoGoLiveParentGuideSongInfoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<GoGoLiveParentGuideSongInfoFilterInput>;
  some?: InputMaybe<GoGoLiveParentGuideSongInfoFilterInput>;
};

export type ListFilterInputTypeOfGoGoLiveSessionInfoFilterInput = {
  all?: InputMaybe<GoGoLiveSessionInfoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<GoGoLiveSessionInfoFilterInput>;
  some?: InputMaybe<GoGoLiveSessionInfoFilterInput>;
};

export type ListFilterInputTypeOfGoGoLiveSongInfoFilterInput = {
  all?: InputMaybe<GoGoLiveSongInfoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<GoGoLiveSongInfoFilterInput>;
  some?: InputMaybe<GoGoLiveSongInfoFilterInput>;
};

export type ListFilterInputTypeOfGoGoLiveToyInfoFilterInput = {
  all?: InputMaybe<GoGoLiveToyInfoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<GoGoLiveToyInfoFilterInput>;
  some?: InputMaybe<GoGoLiveToyInfoFilterInput>;
};

export type ListFilterInputTypeOfTalkAlongCardInfoFilterInput = {
  all?: InputMaybe<TalkAlongCardInfoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<TalkAlongCardInfoFilterInput>;
  some?: InputMaybe<TalkAlongCardInfoFilterInput>;
};

export type ListFilterInputTypeOfTestimonialInfoTagResponseFilterInput = {
  all?: InputMaybe<TestimonialInfoTagResponseFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<TestimonialInfoTagResponseFilterInput>;
  some?: InputMaybe<TestimonialInfoTagResponseFilterInput>;
};

export type ListFilterInputTypeOfWf_AdminFirst_AbFilterInput = {
  all?: InputMaybe<Wf_AdminFirst_AbFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Wf_AdminFirst_AbFilterInput>;
  some?: InputMaybe<Wf_AdminFirst_AbFilterInput>;
};

export type ListFilterInputTypeOfWf_AdminFirst_AfNotificationMemberLogFilterInput = {
  all?: InputMaybe<Wf_AdminFirst_AfNotificationMemberLogFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Wf_AdminFirst_AfNotificationMemberLogFilterInput>;
  some?: InputMaybe<Wf_AdminFirst_AfNotificationMemberLogFilterInput>;
};

export type ListFilterInputTypeOfWf_AdminFirst_AfProgramFilterInput = {
  all?: InputMaybe<Wf_AdminFirst_AfProgramFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Wf_AdminFirst_AfProgramFilterInput>;
  some?: InputMaybe<Wf_AdminFirst_AfProgramFilterInput>;
};

export type ListFilterInputTypeOfWf_AdminFirst_AfUserMarketFilterInput = {
  all?: InputMaybe<Wf_AdminFirst_AfUserMarketFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Wf_AdminFirst_AfUserMarketFilterInput>;
  some?: InputMaybe<Wf_AdminFirst_AfUserMarketFilterInput>;
};

export type ListFilterInputTypeOfWf_AdminFirst_AfUserProgramFilterInput = {
  all?: InputMaybe<Wf_AdminFirst_AfUserProgramFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Wf_AdminFirst_AfUserProgramFilterInput>;
  some?: InputMaybe<Wf_AdminFirst_AfUserProgramFilterInput>;
};

export type ListFilterInputTypeOfWf_AdminFirst_AfUserServiceFilterInput = {
  all?: InputMaybe<Wf_AdminFirst_AfUserServiceFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Wf_AdminFirst_AfUserServiceFilterInput>;
  some?: InputMaybe<Wf_AdminFirst_AfUserServiceFilterInput>;
};

export type ListFilterInputTypeOfWf_AdminFirst_GraphqlAccessFilterInput = {
  all?: InputMaybe<Wf_AdminFirst_GraphqlAccessFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Wf_AdminFirst_GraphqlAccessFilterInput>;
  some?: InputMaybe<Wf_AdminFirst_GraphqlAccessFilterInput>;
};

export type ListFilterInputTypeOfWf_AdminFirst_TepsDailyHourFilterInput = {
  all?: InputMaybe<Wf_AdminFirst_TepsDailyHourFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Wf_AdminFirst_TepsDailyHourFilterInput>;
  some?: InputMaybe<Wf_AdminFirst_TepsDailyHourFilterInput>;
};

export type ListFilterInputTypeOfWf_AdminFirst_TepsProjectFilterInput = {
  all?: InputMaybe<Wf_AdminFirst_TepsProjectFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Wf_AdminFirst_TepsProjectFilterInput>;
  some?: InputMaybe<Wf_AdminFirst_TepsProjectFilterInput>;
};

export type ListFilterInputTypeOfWf_AdminFirst_TepsProjectTypeFilterInput = {
  all?: InputMaybe<Wf_AdminFirst_TepsProjectTypeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Wf_AdminFirst_TepsProjectTypeFilterInput>;
  some?: InputMaybe<Wf_AdminFirst_TepsProjectTypeFilterInput>;
};

export type ListFilterInputTypeOfWf_AdminFirst_TepsProjectionFilterInput = {
  all?: InputMaybe<Wf_AdminFirst_TepsProjectionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Wf_AdminFirst_TepsProjectionFilterInput>;
  some?: InputMaybe<Wf_AdminFirst_TepsProjectionFilterInput>;
};

export type ListFilterInputTypeOfWf_AdminFirst_TepsUserProjectFilterInput = {
  all?: InputMaybe<Wf_AdminFirst_TepsUserProjectFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Wf_AdminFirst_TepsUserProjectFilterInput>;
  some?: InputMaybe<Wf_AdminFirst_TepsUserProjectFilterInput>;
};

export type ListFilterInputTypeOfWf_TrialModeLeads_CallToActionContentFilterInput = {
  all?: InputMaybe<Wf_TrialModeLeads_CallToActionContentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Wf_TrialModeLeads_CallToActionContentFilterInput>;
  some?: InputMaybe<Wf_TrialModeLeads_CallToActionContentFilterInput>;
};

export type ListFilterInputTypeOfWf_TrialModeLeads_CallToActionFilterInput = {
  all?: InputMaybe<Wf_TrialModeLeads_CallToActionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Wf_TrialModeLeads_CallToActionFilterInput>;
  some?: InputMaybe<Wf_TrialModeLeads_CallToActionFilterInput>;
};

export type ListFilterInputTypeOfWf_TrialModeLeads_GraphqlAccessFilterInput = {
  all?: InputMaybe<Wf_TrialModeLeads_GraphqlAccessFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Wf_TrialModeLeads_GraphqlAccessFilterInput>;
  some?: InputMaybe<Wf_TrialModeLeads_GraphqlAccessFilterInput>;
};

export type ListFilterInputTypeOfWf_TrialModeLeads_JourneyCardFilterInput = {
  all?: InputMaybe<Wf_TrialModeLeads_JourneyCardFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Wf_TrialModeLeads_JourneyCardFilterInput>;
  some?: InputMaybe<Wf_TrialModeLeads_JourneyCardFilterInput>;
};

export type ListFilterInputTypeOfWf_TrialModeLeads_NotificationFilterInput = {
  all?: InputMaybe<Wf_TrialModeLeads_NotificationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Wf_TrialModeLeads_NotificationFilterInput>;
  some?: InputMaybe<Wf_TrialModeLeads_NotificationFilterInput>;
};

export type ListFilterInputTypeOfWf_TrialModeLeads_NotificationToChildAgeFilterInput = {
  all?: InputMaybe<Wf_TrialModeLeads_NotificationToChildAgeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Wf_TrialModeLeads_NotificationToChildAgeFilterInput>;
  some?: InputMaybe<Wf_TrialModeLeads_NotificationToChildAgeFilterInput>;
};

export type ListFilterInputTypeOfWf_TrialModeLeads_NotificationToSegmentationFilterInput = {
  all?: InputMaybe<Wf_TrialModeLeads_NotificationToSegmentationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Wf_TrialModeLeads_NotificationToSegmentationFilterInput>;
  some?: InputMaybe<Wf_TrialModeLeads_NotificationToSegmentationFilterInput>;
};

export type ListFilterInputTypeOfWf_TrialModeLeads_ProductSongAndMarketFilterInput = {
  all?: InputMaybe<Wf_TrialModeLeads_ProductSongAndMarketFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Wf_TrialModeLeads_ProductSongAndMarketFilterInput>;
  some?: InputMaybe<Wf_TrialModeLeads_ProductSongAndMarketFilterInput>;
};

export type ListFilterInputTypeOfWf_TrialModeLeads_ProductSongFilterInput = {
  all?: InputMaybe<Wf_TrialModeLeads_ProductSongFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Wf_TrialModeLeads_ProductSongFilterInput>;
  some?: InputMaybe<Wf_TrialModeLeads_ProductSongFilterInput>;
};

export type ListFilterInputTypeOfWf_TrialModeLeads_ProductVideoAndMarketFilterInput = {
  all?: InputMaybe<Wf_TrialModeLeads_ProductVideoAndMarketFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Wf_TrialModeLeads_ProductVideoAndMarketFilterInput>;
  some?: InputMaybe<Wf_TrialModeLeads_ProductVideoAndMarketFilterInput>;
};

export type ListFilterInputTypeOfWf_TrialModeLeads_ProductVideoFilterInput = {
  all?: InputMaybe<Wf_TrialModeLeads_ProductVideoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Wf_TrialModeLeads_ProductVideoFilterInput>;
  some?: InputMaybe<Wf_TrialModeLeads_ProductVideoFilterInput>;
};

export type ListFilterInputTypeOfWf_TrialModeLeads_TestimonialTagMappingFilterInput = {
  all?: InputMaybe<Wf_TrialModeLeads_TestimonialTagMappingFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Wf_TrialModeLeads_TestimonialTagMappingFilterInput>;
  some?: InputMaybe<Wf_TrialModeLeads_TestimonialTagMappingFilterInput>;
};

export type ListFilterInputTypeOfWf_TrialModeLeads_TrialTokenFilterInput = {
  all?: InputMaybe<Wf_TrialModeLeads_TrialTokenFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Wf_TrialModeLeads_TrialTokenFilterInput>;
  some?: InputMaybe<Wf_TrialModeLeads_TrialTokenFilterInput>;
};

export type ListFilterInputTypeOfWf_TrialModeLeads_TrialUserNotificationFilterInput = {
  all?: InputMaybe<Wf_TrialModeLeads_TrialUserNotificationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Wf_TrialModeLeads_TrialUserNotificationFilterInput>;
  some?: InputMaybe<Wf_TrialModeLeads_TrialUserNotificationFilterInput>;
};

export type ListFilterInputTypeOfWf_TrialModeLeads_TrialUserSegmentationLogFilterInput = {
  all?: InputMaybe<Wf_TrialModeLeads_TrialUserSegmentationLogFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Wf_TrialModeLeads_TrialUserSegmentationLogFilterInput>;
  some?: InputMaybe<Wf_TrialModeLeads_TrialUserSegmentationLogFilterInput>;
};

export type ListIntOperationFilterInput = {
  all?: InputMaybe<IntOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<IntOperationFilterInput>;
  some?: InputMaybe<IntOperationFilterInput>;
};

export type ListStringOperationFilterInput = {
  all?: InputMaybe<StringOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<StringOperationFilterInput>;
  some?: InputMaybe<StringOperationFilterInput>;
};

export type LongOperationFilterInput = {
  eq?: InputMaybe<Scalars['Long']['input']>;
  gt?: InputMaybe<Scalars['Long']['input']>;
  gte?: InputMaybe<Scalars['Long']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  lt?: InputMaybe<Scalars['Long']['input']>;
  lte?: InputMaybe<Scalars['Long']['input']>;
  neq?: InputMaybe<Scalars['Long']['input']>;
  ngt?: InputMaybe<Scalars['Long']['input']>;
  ngte?: InputMaybe<Scalars['Long']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  nlt?: InputMaybe<Scalars['Long']['input']>;
  nlte?: InputMaybe<Scalars['Long']['input']>;
};

export enum Market {
  HongKong = 'HONG_KONG',
  Japan = 'JAPAN',
  Korea = 'KOREA',
  Taiwan = 'TAIWAN'
}

export type MemberUpgradePaymentResponse = {
  __typename?: 'MemberUpgradePaymentResponse';
  addBeamProjector: Scalars['Int']['output'];
  addDongle: Scalars['Int']['output'];
  canceledDate?: Maybe<Scalars['DateTime']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  isChangeAddress?: Maybe<Scalars['Boolean']['output']>;
  memberName: Scalars['String']['output'];
  memberNo: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  originalPackage: Scalars['String']['output'];
  paidAmount: Scalars['Int']['output'];
  paymentAmount: Scalars['Int']['output'];
  paymentDate?: Maybe<Scalars['DateTime']['output']>;
  paymentStatus: Scalars['String']['output'];
  upgradePackage: Scalars['String']['output'];
};

export type MemberUpgradePaymentResponseFilterInput = {
  addBeamProjector?: InputMaybe<IntOperationFilterInput>;
  addDongle?: InputMaybe<IntOperationFilterInput>;
  and?: InputMaybe<Array<MemberUpgradePaymentResponseFilterInput>>;
  canceledDate?: InputMaybe<DateTimeOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  isChangeAddress?: InputMaybe<BooleanOperationFilterInput>;
  memberName?: InputMaybe<StringOperationFilterInput>;
  memberNo?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MemberUpgradePaymentResponseFilterInput>>;
  orderId?: InputMaybe<StringOperationFilterInput>;
  originalPackage?: InputMaybe<StringOperationFilterInput>;
  paidAmount?: InputMaybe<IntOperationFilterInput>;
  paymentAmount?: InputMaybe<IntOperationFilterInput>;
  paymentDate?: InputMaybe<DateTimeOperationFilterInput>;
  paymentStatus?: InputMaybe<StringOperationFilterInput>;
  upgradePackage?: InputMaybe<StringOperationFilterInput>;
};

export type MemberUpgradePaymentResponseSortInput = {
  addBeamProjector?: InputMaybe<SortEnumType>;
  addDongle?: InputMaybe<SortEnumType>;
  canceledDate?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  isChangeAddress?: InputMaybe<SortEnumType>;
  memberName?: InputMaybe<SortEnumType>;
  memberNo?: InputMaybe<SortEnumType>;
  orderId?: InputMaybe<SortEnumType>;
  originalPackage?: InputMaybe<SortEnumType>;
  paidAmount?: InputMaybe<SortEnumType>;
  paymentAmount?: InputMaybe<SortEnumType>;
  paymentDate?: InputMaybe<SortEnumType>;
  paymentStatus?: InputMaybe<SortEnumType>;
  upgradePackage?: InputMaybe<SortEnumType>;
};

export type MergeLeadsReplyDataRequestInput = {
  /** The Leads Number to be merged */
  mergedLeadsNumber: Scalars['String']['input'];
  /** The Leads Number to be retained */
  retainedLeadsNumber: Scalars['String']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Add GoGoLive Parent Guide */
  addGoGoLiveParentGuide: ResultResponse;
  /** Add GoGoLive Parent Guide Locale */
  addGoGoLiveParentGuideLocale: ResultResponse;
  /** Add Kid's World Video */
  addKidsWorldVideo: ResultResponse;
  addSalesNotification: Payload;
  /** Add new Sales profile information */
  addSalesProfileInfo: ResultResponse;
  /** Add Scheduled Service Banner */
  addScheduledServiceBanner: Payload;
  /** Add TEV2 Monthly Song */
  addTev2MonthlySong: Payload;
  /** Add Trial Mode - App Announcement Bar */
  addTrialModeAppAnnouncementBar: Payload;
  addTrialModeNotification: Payload;
  afAddNotification: Payload;
  afRemoveNotification: Payload;
  afUpdateChildGraduationOfHongKong: Payload;
  afUpdateChildGraduationOfKorea: Payload;
  afUpdateChildGraduationOfTaiwan: Payload;
  afUpdateGraduationChild: Payload;
  afUpload: UploadPayload;
  club_worldFamilyClub: Club_WorldFamilyClub_Mutation_Payload;
  /** Create Testimonial */
  createTestimonial: ResultResponse;
  /** Create TestimonialTag */
  createTestimonialTag: ResultResponse;
  /** Delete GoGoLive Parent Guide */
  deleteGoGoLiveParentGuide: ResultResponse;
  /** Delete Kid's World Video */
  deleteKidsWorldVideo: ResultResponse;
  /** Delete Sales profile information */
  deleteSalesProfileInfo: ResultResponse;
  /** Delete Scheduled Service Banner */
  deleteScheduledServiceBanner: Payload;
  /** Delete Testimonial */
  deleteTestimonial: ResultResponse;
  /** Delete TestimonialTag */
  deleteTestimonialTag: ResultResponse;
  /** Delete Trial Mode - App Announcement Bar */
  deleteTrialModeAppAnnouncementBar: Payload;
  /** Delete TEV2 Monthly Song */
  delteTev2MonthlySong: Payload;
  /** Merge reply data of Leads */
  mergeLeadsReplyData: ResultResponse;
  removeGraduationApplication: Payload;
  removeSalesNotification: Payload;
  removeTrialModeNotification: Payload;
  /** Update Default Service Banner */
  updateDefaultServiceBanner: Payload;
  /** Update GoGoLive Parent Guide */
  updateGoGoLiveParentGuide: ResultResponse;
  /** Update GoGoLive Parent Guide Locale */
  updateGoGoLiveParentGuideLocale: ResultResponse;
  /** Update internet cost */
  updateInternetCost: ResultResponse;
  /** Update Kid's World Video */
  updateKidsWorldVideo: ResultResponse;
  /** Update leads reply source information */
  updateLeadsReplySourceInformation: ResultResponse;
  updateSales188Release: Payload;
  /** Update Sales profile information */
  updateSalesProfileInfo: ResultResponse;
  /** Update Scheduled Service Banner */
  updateScheduledServiceBanner: Payload;
  /** Update Testimonial */
  updateTestimonial?: Maybe<ResultResponse>;
  /** Update Testimonial SortOrder (Provide testimonialIds according to the sorting order) */
  updateTestimonialSortOrder: ResultResponse;
  /** Update TestimonialTag */
  updateTestimonialTag: ResultResponse;
  /** Update TestimonialTag SortOrder (Provide tagIds according to the sorting order) */
  updateTestimonialTagSortOrder: ResultResponse;
  /** Update TEV2 Monthly Song */
  updateTev2MonthlySong: Payload;
  /** Update Trial Mode - App Announcement Bar */
  updateTrialModeAppAnnouncementBar: Payload;
  /** Update Warranty Status */
  updateWarrantyStatus: ResultResponse;
  wf_adminFirst: Wf_AdminFirst_Mutation_Payload;
  wf_trialModeLeads: Wf_TrialModeLeads_Mutation_Payload;
};


export type MutationAddGoGoLiveParentGuideArgs = {
  request: AddGoGoLiveParentGuideRequestInput;
};


export type MutationAddGoGoLiveParentGuideLocaleArgs = {
  request: AddGoGoLiveParentGuideLocaleRequestInput;
};


export type MutationAddKidsWorldVideoArgs = {
  parameter: KidsWorldVideoAddParameterInput;
};


export type MutationAddSalesNotificationArgs = {
  sales188Notification: Sales188NotificationInput;
  testEmployeeCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationAddSalesProfileInfoArgs = {
  parameter: SalesProfileInformationInput;
};


export type MutationAddScheduledServiceBannerArgs = {
  parameter: ScheduledServiceBannerParameterInput;
};


export type MutationAddTev2MonthlySongArgs = {
  parameter: Tev2MonthlySongInfoInput;
};


export type MutationAddTrialModeAppAnnouncementBarArgs = {
  parameter: TrialModeAppAnnouncementBarAddParameterInput;
};


export type MutationAddTrialModeNotificationArgs = {
  childAge?: InputMaybe<Array<Scalars['String']['input']>>;
  members?: InputMaybe<Array<TrialModeMemberInput>>;
  notification: TrialModeNotificationInput;
  segmentations?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationAfAddNotificationArgs = {
  excelFileName?: InputMaybe<Scalars['String']['input']>;
  isAllMembers?: Scalars['Boolean']['input'];
  isTestNotification?: InputMaybe<Scalars['Boolean']['input']>;
  members?: InputMaybe<Array<AfMemberInput>>;
  notification: AfNotificationInput;
  recipientSourceType?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAfRemoveNotificationArgs = {
  notification: AfNotificationInput;
};


export type MutationAfUpdateChildGraduationOfHongKongArgs = {
  graduationOfHongKong: AfUpdateChildGraduationOfHongKongInput;
};


export type MutationAfUpdateChildGraduationOfKoreaArgs = {
  graduationOfKorea: AfUpdateChildGraduationOfKoreaInput;
};


export type MutationAfUpdateChildGraduationOfTaiwanArgs = {
  graduationOfTaiwan: AfUpdateChildGraduationOfTaiwanInput;
};


export type MutationAfUpdateGraduationChildArgs = {
  childEnglishName?: InputMaybe<Scalars['String']['input']>;
  childHeight?: InputMaybe<Scalars['Int']['input']>;
  childPhotoFilename?: InputMaybe<Scalars['String']['input']>;
  childWeight?: InputMaybe<Scalars['Int']['input']>;
  childWillingEnglishSpeech?: InputMaybe<Scalars['Boolean']['input']>;
  parentWillingChineseSpeech?: InputMaybe<Scalars['Boolean']['input']>;
  seq: Scalars['Int']['input'];
  updatedTime?: InputMaybe<Scalars['DateTime']['input']>;
  updater?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAfUploadArgs = {
  blobs: Array<BlobOfAfBlobPathInput>;
};


export type MutationClub_WorldFamilyClubArgs = {
  add?: InputMaybe<Club_WorldFamilyClub_Mutation_AddInput>;
  addRange?: InputMaybe<Club_WorldFamilyClub_Mutation_AddRangeInput>;
  remove?: InputMaybe<Club_WorldFamilyClub_Mutation_RemoveInput>;
  removeRange?: InputMaybe<Club_WorldFamilyClub_Mutation_RemoveRangeInput>;
  update?: InputMaybe<Club_WorldFamilyClub_Mutation_UpdateInput>;
  updateRange?: InputMaybe<Club_WorldFamilyClub_Mutation_UpdateRangeInput>;
};


export type MutationCreateTestimonialArgs = {
  request: TestimonialRequestInput;
};


export type MutationCreateTestimonialTagArgs = {
  request: TagRequestInput;
};


export type MutationDeleteGoGoLiveParentGuideArgs = {
  goGoLiveParentGuideId: Scalars['Int']['input'];
};


export type MutationDeleteKidsWorldVideoArgs = {
  kidsWorldVideoId: Scalars['Int']['input'];
};


export type MutationDeleteSalesProfileInfoArgs = {
  employeeId: Scalars['String']['input'];
};


export type MutationDeleteScheduledServiceBannerArgs = {
  seqs: Array<Scalars['Int']['input']>;
};


export type MutationDeleteTestimonialArgs = {
  testimonialId: Scalars['Int']['input'];
};


export type MutationDeleteTestimonialTagArgs = {
  tagId: Scalars['Int']['input'];
};


export type MutationDeleteTrialModeAppAnnouncementBarArgs = {
  appAnnouncementBarId: Scalars['Int']['input'];
};


export type MutationDelteTev2MonthlySongArgs = {
  seq: Scalars['Int']['input'];
};


export type MutationMergeLeadsReplyDataArgs = {
  parameter: MergeLeadsReplyDataRequestInput;
};


export type MutationRemoveGraduationApplicationArgs = {
  applicationId: Scalars['Int']['input'];
};


export type MutationRemoveSalesNotificationArgs = {
  notificationId: Scalars['Int']['input'];
};


export type MutationRemoveTrialModeNotificationArgs = {
  modeNotification: TrialModeNotificationInput;
};


export type MutationUpdateDefaultServiceBannerArgs = {
  parameter: DefaultServiceBannerParameterInput;
};


export type MutationUpdateGoGoLiveParentGuideArgs = {
  request: UpdateGoGoLiveParentGuideRequestInput;
};


export type MutationUpdateGoGoLiveParentGuideLocaleArgs = {
  request: UpdateGoGoLiveParentGuideLocaleRequestInput;
};


export type MutationUpdateInternetCostArgs = {
  file: Scalars['Upload']['input'];
  yyyymm: Scalars['String']['input'];
};


export type MutationUpdateKidsWorldVideoArgs = {
  parameter: KidsWorldVideoUpdateParameterInput;
};


export type MutationUpdateLeadsReplySourceInformationArgs = {
  parameter: UpdateLeadsReplySourceInformationRequestInput;
};


export type MutationUpdateSales188ReleaseArgs = {
  appVersion?: InputMaybe<Scalars['String']['input']>;
  appstore?: InputMaybe<Scalars['String']['input']>;
  osVersion?: InputMaybe<Scalars['String']['input']>;
  releaseTime?: InputMaybe<Scalars['DateTime']['input']>;
  seq: Scalars['Short']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateSalesProfileInfoArgs = {
  parameter: SalesProfileInformationInput;
};


export type MutationUpdateScheduledServiceBannerArgs = {
  parameter: ScheduledServiceBannerParameterInput;
};


export type MutationUpdateTestimonialArgs = {
  request: TestimonialRequestInput;
};


export type MutationUpdateTestimonialSortOrderArgs = {
  testimonialIds: Array<Scalars['Int']['input']>;
};


export type MutationUpdateTestimonialTagArgs = {
  request: TagRequestInput;
};


export type MutationUpdateTestimonialTagSortOrderArgs = {
  tagIds: Array<Scalars['Int']['input']>;
};


export type MutationUpdateTev2MonthlySongArgs = {
  parameter: Tev2MonthlySongInfoInput;
};


export type MutationUpdateTrialModeAppAnnouncementBarArgs = {
  parameter: TrialModeAppAnnouncementBarUpdateParameterInput;
};


export type MutationUpdateWarrantyStatusArgs = {
  parameter: WarrantyStatusInput;
};


export type MutationWf_AdminFirstArgs = {
  add?: InputMaybe<Wf_AdminFirst_Mutation_AddInput>;
  addRange?: InputMaybe<Wf_AdminFirst_Mutation_AddRangeInput>;
  remove?: InputMaybe<Wf_AdminFirst_Mutation_RemoveInput>;
  removeRange?: InputMaybe<Wf_AdminFirst_Mutation_RemoveRangeInput>;
  update?: InputMaybe<Wf_AdminFirst_Mutation_UpdateInput>;
  updateRange?: InputMaybe<Wf_AdminFirst_Mutation_UpdateRangeInput>;
};


export type MutationWf_TrialModeLeadsArgs = {
  add?: InputMaybe<Wf_TrialModeLeads_Mutation_AddInput>;
  addRange?: InputMaybe<Wf_TrialModeLeads_Mutation_AddRangeInput>;
  remove?: InputMaybe<Wf_TrialModeLeads_Mutation_RemoveInput>;
  removeRange?: InputMaybe<Wf_TrialModeLeads_Mutation_RemoveRangeInput>;
  update?: InputMaybe<Wf_TrialModeLeads_Mutation_UpdateInput>;
  updateRange?: InputMaybe<Wf_TrialModeLeads_Mutation_UpdateRangeInput>;
};

/** The node interface is implemented by entities that have a global unique identifier. */
export type Node = {
  id: Scalars['ID']['output'];
};

export type NullableOfMarketOperationFilterInput = {
  eq?: InputMaybe<Market>;
  in?: InputMaybe<Array<InputMaybe<Market>>>;
  neq?: InputMaybe<Market>;
  nin?: InputMaybe<Array<InputMaybe<Market>>>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** Indicates whether more edges exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean']['output'];
  /** Indicates whether more edges exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type Payload = {
  __typename?: 'Payload';
  count: Scalars['Int']['output'];
  error?: Maybe<Error>;
  query: Query;
};

export type ProductGroup = {
  __typename?: 'ProductGroup';
  categoryName: Scalars['String']['output'];
  productId: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  reasonMemo: Scalars['String']['output'];
  reasonText: Scalars['String']['output'];
  subCategoryName: Scalars['String']['output'];
};

export type PushNotificationButtonLinkResult = {
  __typename?: 'PushNotificationButtonLinkResult';
  buttonLinkId: Scalars['String']['output'];
  buttonLinkName: Scalars['String']['output'];
};

export type PushNotificationButtonLinkResultFilterInput = {
  and?: InputMaybe<Array<PushNotificationButtonLinkResultFilterInput>>;
  buttonLinkId?: InputMaybe<StringOperationFilterInput>;
  buttonLinkName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PushNotificationButtonLinkResultFilterInput>>;
};

export type PushNotificationButtonLinkResultSortInput = {
  buttonLinkId?: InputMaybe<SortEnumType>;
  buttonLinkName?: InputMaybe<SortEnumType>;
};

export type PushNotificationServiceTypeResult = {
  __typename?: 'PushNotificationServiceTypeResult';
  serviceTypeId: Scalars['String']['output'];
  serviceTypeName: Scalars['String']['output'];
};

export type PushNotificationServiceTypeResultFilterInput = {
  and?: InputMaybe<Array<PushNotificationServiceTypeResultFilterInput>>;
  or?: InputMaybe<Array<PushNotificationServiceTypeResultFilterInput>>;
  serviceTypeId?: InputMaybe<StringOperationFilterInput>;
  serviceTypeName?: InputMaybe<StringOperationFilterInput>;
};

export type PushNotificationServiceTypeResultSortInput = {
  serviceTypeId?: InputMaybe<SortEnumType>;
  serviceTypeName?: InputMaybe<SortEnumType>;
};

export type Query = {
  __typename?: 'Query';
  afBlobContainerSignature: Array<BlobContainerSignatureOfAfBlobPath>;
  afChildGraduationApplication: Array<Club_WorldFamilyClub_ChildGraduationApplication>;
  afFaceCallPerformer: Array<Club_WorldFamilyClub_FaceCallPerformer>;
  afFaceCallSong: Array<Club_WorldFamilyClub_FaceCallSong>;
  afGraduationApplication: Array<Club_WorldFamilyClub_GraduationApplication>;
  afGraduationChild: Array<AfGraduationChild>;
  afMember?: Maybe<AfMemberConnection>;
  afTeSong: Array<Club_WorldFamilyClub_TeSong>;
  club_worldFamilyClub_appAuth?: Maybe<Club_WorldFamilyClub_AppAuthConnection>;
  club_worldFamilyClub_appBanner?: Maybe<Club_WorldFamilyClub_AppBannerConnection>;
  club_worldFamilyClub_appDigitalMagazine?: Maybe<Club_WorldFamilyClub_AppDigitalMagazineConnection>;
  club_worldFamilyClub_appMemberAuthorize?: Maybe<Club_WorldFamilyClub_AppMemberAuthorizeConnection>;
  club_worldFamilyClub_appMemberAuthorizeLog?: Maybe<Club_WorldFamilyClub_AppMemberAuthorizeLogConnection>;
  club_worldFamilyClub_appMemberChild?: Maybe<Club_WorldFamilyClub_AppMemberChildConnection>;
  club_worldFamilyClub_appMemberDevice?: Maybe<Club_WorldFamilyClub_AppMemberDeviceConnection>;
  club_worldFamilyClub_appMemberFirstLogin?: Maybe<Club_WorldFamilyClub_AppMemberFirstLoginConnection>;
  club_worldFamilyClub_appMemberNotification?: Maybe<Club_WorldFamilyClub_AppMemberNotificationConnection>;
  club_worldFamilyClub_appMemberNotificationPushFirebase?: Maybe<Club_WorldFamilyClub_AppMemberNotificationPushFirebaseConnection>;
  club_worldFamilyClub_appNotification?: Maybe<Club_WorldFamilyClub_AppNotificationConnection>;
  club_worldFamilyClub_appNotificationMember?: Maybe<Club_WorldFamilyClub_AppNotificationMemberConnection>;
  club_worldFamilyClub_appNotificationType?: Maybe<Club_WorldFamilyClub_AppNotificationTypeConnection>;
  club_worldFamilyClub_appNotificationTypeMarket?: Maybe<Club_WorldFamilyClub_AppNotificationTypeMarketConnection>;
  club_worldFamilyClub_appRegionEmergency?: Maybe<Club_WorldFamilyClub_AppRegionEmergencyConnection>;
  club_worldFamilyClub_appRelease?: Maybe<Club_WorldFamilyClub_AppReleaseConnection>;
  club_worldFamilyClub_appServiceRegionFestivalImage?: Maybe<Club_WorldFamilyClub_AppServiceRegionFestivalImageConnection>;
  club_worldFamilyClub_appServiceRegionImage?: Maybe<Club_WorldFamilyClub_AppServiceRegionImageConnection>;
  club_worldFamilyClub_appSurvey?: Maybe<Club_WorldFamilyClub_AppSurveyConnection>;
  club_worldFamilyClub_appSurveyMember?: Maybe<Club_WorldFamilyClub_AppSurveyMemberConnection>;
  club_worldFamilyClub_appSurveyQa?: Maybe<Club_WorldFamilyClub_AppSurveyQaConnection>;
  club_worldFamilyClub_appSurveyReminder?: Maybe<Club_WorldFamilyClub_AppSurveyReminderConnection>;
  club_worldFamilyClub_azureFunction?: Maybe<Club_WorldFamilyClub_AzureFunctionConnection>;
  club_worldFamilyClub_bankCode?: Maybe<Club_WorldFamilyClub_BankCodeConnection>;
  club_worldFamilyClub_broadcastPromotion?: Maybe<Club_WorldFamilyClub_BroadcastPromotionConnection>;
  club_worldFamilyClub_capGuidePdf?: Maybe<Club_WorldFamilyClub_CapGuidePdfConnection>;
  club_worldFamilyClub_childGraduationApplication?: Maybe<Club_WorldFamilyClub_ChildGraduationApplicationConnection>;
  club_worldFamilyClub_creditcardBankCode?: Maybe<Club_WorldFamilyClub_CreditcardBankCodeConnection>;
  club_worldFamilyClub_dweProductPackage?: Maybe<Club_WorldFamilyClub_DweProductPackageConnection>;
  club_worldFamilyClub_dweProductSong?: Maybe<Club_WorldFamilyClub_DweProductSongConnection>;
  club_worldFamilyClub_dweProductSongTool?: Maybe<Club_WorldFamilyClub_DweProductSongToolConnection>;
  club_worldFamilyClub_dweProductTool?: Maybe<Club_WorldFamilyClub_DweProductToolConnection>;
  club_worldFamilyClub_easypayOrderLog?: Maybe<Club_WorldFamilyClub_EasypayOrderLogConnection>;
  club_worldFamilyClub_entryPackageOrder?: Maybe<Club_WorldFamilyClub_EntryPackageOrderConnection>;
  club_worldFamilyClub_entryPackageOrdersMemberPaymentInfo?: Maybe<Club_WorldFamilyClub_EntryPackageOrdersMemberPaymentInfoConnection>;
  club_worldFamilyClub_eventBanner?: Maybe<Club_WorldFamilyClub_EventBannerConnection>;
  club_worldFamilyClub_eventBannerRegion?: Maybe<Club_WorldFamilyClub_EventBannerRegionConnection>;
  club_worldFamilyClub_eventCheckInAuth?: Maybe<Club_WorldFamilyClub_EventCheckInAuthConnection>;
  club_worldFamilyClub_eventNotificationLog?: Maybe<Club_WorldFamilyClub_EventNotificationLogConnection>;
  club_worldFamilyClub_eventPromotion?: Maybe<Club_WorldFamilyClub_EventPromotionConnection>;
  club_worldFamilyClub_eventSeat?: Maybe<Club_WorldFamilyClub_EventSeatConnection>;
  club_worldFamilyClub_eventType?: Maybe<Club_WorldFamilyClub_EventTypeConnection>;
  club_worldFamilyClub_exchangeApplication?: Maybe<Club_WorldFamilyClub_ExchangeApplicationConnection>;
  club_worldFamilyClub_exchangeApplicationItem?: Maybe<Club_WorldFamilyClub_ExchangeApplicationItemConnection>;
  club_worldFamilyClub_exchangeReason?: Maybe<Club_WorldFamilyClub_ExchangeReasonConnection>;
  club_worldFamilyClub_exchangeReasonTranslation?: Maybe<Club_WorldFamilyClub_ExchangeReasonTranslationConnection>;
  club_worldFamilyClub_faceCallAndTelephoneEnglish?: Maybe<Club_WorldFamilyClub_FaceCallAndTelephoneEnglishConnection>;
  club_worldFamilyClub_faceCallForTrialmode?: Maybe<Club_WorldFamilyClub_FaceCallForTrialmodeConnection>;
  club_worldFamilyClub_faceCallHist?: Maybe<Club_WorldFamilyClub_FaceCallHistConnection>;
  club_worldFamilyClub_faceCallHistCount?: Maybe<Club_WorldFamilyClub_FaceCallHistCountConnection>;
  club_worldFamilyClub_faceCallMonthlyRecommend?: Maybe<Club_WorldFamilyClub_FaceCallMonthlyRecommendConnection>;
  club_worldFamilyClub_faceCallPerformer?: Maybe<Club_WorldFamilyClub_FaceCallPerformerConnection>;
  club_worldFamilyClub_faceCallSeasonHoliday?: Maybe<Club_WorldFamilyClub_FaceCallSeasonHolidayConnection>;
  club_worldFamilyClub_faceCallSong?: Maybe<Club_WorldFamilyClub_FaceCallSongConnection>;
  club_worldFamilyClub_faceCallSongAndPerformer?: Maybe<Club_WorldFamilyClub_FaceCallSongAndPerformerConnection>;
  club_worldFamilyClub_faceCallSongPublic?: Maybe<Club_WorldFamilyClub_FaceCallSongPublicConnection>;
  club_worldFamilyClub_goGoLiveDesktopQrcode?: Maybe<Club_WorldFamilyClub_GoGoLiveDesktopQrcodeConnection>;
  club_worldFamilyClub_goGoLiveLevel?: Maybe<Club_WorldFamilyClub_GoGoLiveLevelConnection>;
  club_worldFamilyClub_goGoLiveOpenDate?: Maybe<Club_WorldFamilyClub_GoGoLiveOpenDateConnection>;
  club_worldFamilyClub_goGoLiveParentGuide?: Maybe<Club_WorldFamilyClub_GoGoLiveParentGuideConnection>;
  club_worldFamilyClub_goGoLiveParentGuideLocale?: Maybe<Club_WorldFamilyClub_GoGoLiveParentGuideLocaleConnection>;
  club_worldFamilyClub_goGoLiveParentGuideSession?: Maybe<Club_WorldFamilyClub_GoGoLiveParentGuideSessionConnection>;
  club_worldFamilyClub_goGoLiveParentGuideSong?: Maybe<Club_WorldFamilyClub_GoGoLiveParentGuideSongConnection>;
  club_worldFamilyClub_goGoLiveParentGuideTac?: Maybe<Club_WorldFamilyClub_GoGoLiveParentGuideTacConnection>;
  club_worldFamilyClub_goGoLiveParentGuideToy?: Maybe<Club_WorldFamilyClub_GoGoLiveParentGuideToyConnection>;
  club_worldFamilyClub_goGoLivePromotion?: Maybe<Club_WorldFamilyClub_GoGoLivePromotionConnection>;
  club_worldFamilyClub_goGoLiveSession?: Maybe<Club_WorldFamilyClub_GoGoLiveSessionConnection>;
  club_worldFamilyClub_goGoLiveSong?: Maybe<Club_WorldFamilyClub_GoGoLiveSongConnection>;
  club_worldFamilyClub_goGoLiveToy?: Maybe<Club_WorldFamilyClub_GoGoLiveToyConnection>;
  club_worldFamilyClub_graduationApplication?: Maybe<Club_WorldFamilyClub_GraduationApplicationConnection>;
  club_worldFamilyClub_graduationApplicationEvaluation?: Maybe<Club_WorldFamilyClub_GraduationApplicationEvaluationConnection>;
  club_worldFamilyClub_graduationApplicationSubTask?: Maybe<Club_WorldFamilyClub_GraduationApplicationSubTaskConnection>;
  club_worldFamilyClub_graduationApplicationTask?: Maybe<Club_WorldFamilyClub_GraduationApplicationTaskConnection>;
  club_worldFamilyClub_graduationChild?: Maybe<Club_WorldFamilyClub_GraduationChildConnection>;
  club_worldFamilyClub_graduationChildSetting?: Maybe<Club_WorldFamilyClub_GraduationChildSettingConnection>;
  club_worldFamilyClub_graduationEvaluation?: Maybe<Club_WorldFamilyClub_GraduationEvaluationConnection>;
  club_worldFamilyClub_graduationNotification?: Maybe<Club_WorldFamilyClub_GraduationNotificationConnection>;
  club_worldFamilyClub_graduationSubApplication?: Maybe<Club_WorldFamilyClub_GraduationSubApplicationConnection>;
  club_worldFamilyClub_graduationSubTaskMarketDescription?: Maybe<Club_WorldFamilyClub_GraduationSubTaskMarketDescriptionConnection>;
  club_worldFamilyClub_graduationTaskMarketDescription?: Maybe<Club_WorldFamilyClub_GraduationTaskMarketDescriptionConnection>;
  club_worldFamilyClub_graphqlAccess?: Maybe<Club_WorldFamilyClub_GraphqlAccessConnection>;
  club_worldFamilyClub_graphqlSchema?: Maybe<Club_WorldFamilyClub_GraphqlSchemaConnection>;
  club_worldFamilyClub_holidayAudio?: Maybe<Club_WorldFamilyClub_HolidayAudioConnection>;
  club_worldFamilyClub_holidaySetting?: Maybe<Club_WorldFamilyClub_HolidaySettingConnection>;
  club_worldFamilyClub_holidayVideo?: Maybe<Club_WorldFamilyClub_HolidayVideoConnection>;
  club_worldFamilyClub_holidayVideoBonusEntitlementTest?: Maybe<Club_WorldFamilyClub_HolidayVideoBonusEntitlementTestConnection>;
  club_worldFamilyClub_holidayVideoMarket?: Maybe<Club_WorldFamilyClub_HolidayVideoMarketConnection>;
  club_worldFamilyClub_holidayVideoMarketSetting?: Maybe<Club_WorldFamilyClub_HolidayVideoMarketSettingConnection>;
  club_worldFamilyClub_holidayVideoMember?: Maybe<Club_WorldFamilyClub_HolidayVideoMemberConnection>;
  club_worldFamilyClub_kidsWorldVideo?: Maybe<Club_WorldFamilyClub_KidsWorldVideoConnection>;
  club_worldFamilyClub_memberMessageSetting?: Maybe<Club_WorldFamilyClub_MemberMessageSettingConnection>;
  club_worldFamilyClub_memberMonthlyActiveSummary?: Maybe<Club_WorldFamilyClub_MemberMonthlyActiveSummaryConnection>;
  club_worldFamilyClub_memberUpgradePayment?: Maybe<Club_WorldFamilyClub_MemberUpgradePaymentConnection>;
  club_worldFamilyClub_myFavoriteFaceCall?: Maybe<Club_WorldFamilyClub_MyFavoriteFaceCallConnection>;
  club_worldFamilyClub_myFavoriteFaceCallSong?: Maybe<Club_WorldFamilyClub_MyFavoriteFaceCallSongConnection>;
  club_worldFamilyClub_notification?: Maybe<Club_WorldFamilyClub_NotificationConnection>;
  club_worldFamilyClub_notificationIcon?: Maybe<Club_WorldFamilyClub_NotificationIconConnection>;
  club_worldFamilyClub_oneTimeToken?: Maybe<Club_WorldFamilyClub_OneTimeTokenConnection>;
  club_worldFamilyClub_onlineEventLog?: Maybe<Club_WorldFamilyClub_OnlineEventLogConnection>;
  club_worldFamilyClub_onlineShow?: Maybe<Club_WorldFamilyClub_OnlineShowConnection>;
  club_worldFamilyClub_parameter?: Maybe<Club_WorldFamilyClub_ParameterConnection>;
  club_worldFamilyClub_product?: Maybe<Club_WorldFamilyClub_ProductConnection>;
  club_worldFamilyClub_productCategory?: Maybe<Club_WorldFamilyClub_ProductCategoryConnection>;
  club_worldFamilyClub_productCategoryTranslation?: Maybe<Club_WorldFamilyClub_ProductCategoryTranslationConnection>;
  club_worldFamilyClub_productSubCategory?: Maybe<Club_WorldFamilyClub_ProductSubCategoryConnection>;
  club_worldFamilyClub_productSubCategoryExchangeReason?: Maybe<Club_WorldFamilyClub_ProductSubCategoryExchangeReasonConnection>;
  club_worldFamilyClub_productSubCategoryTranslation?: Maybe<Club_WorldFamilyClub_ProductSubCategoryTranslationConnection>;
  club_worldFamilyClub_productTranslation?: Maybe<Club_WorldFamilyClub_ProductTranslationConnection>;
  club_worldFamilyClub_products1?: Maybe<Club_WorldFamilyClub_Products1Connection>;
  club_worldFamilyClub_regionBanner?: Maybe<Club_WorldFamilyClub_RegionBannerConnection>;
  club_worldFamilyClub_searchKeyword?: Maybe<Club_WorldFamilyClub_SearchKeywordConnection>;
  club_worldFamilyClub_service?: Maybe<Club_WorldFamilyClub_ServiceConnection>;
  club_worldFamilyClub_serviceBannerDefault?: Maybe<Club_WorldFamilyClub_ServiceBannerDefaultConnection>;
  club_worldFamilyClub_serviceBannerScheduled?: Maybe<Club_WorldFamilyClub_ServiceBannerScheduledConnection>;
  club_worldFamilyClub_serviceOneTimeToken?: Maybe<Club_WorldFamilyClub_ServiceOneTimeTokenConnection>;
  club_worldFamilyClub_serviceSearch?: Maybe<Club_WorldFamilyClub_ServiceSearchConnection>;
  club_worldFamilyClub_smsCertification?: Maybe<Club_WorldFamilyClub_SmsCertificationConnection>;
  club_worldFamilyClub_smsCertificationLog?: Maybe<Club_WorldFamilyClub_SmsCertificationLogConnection>;
  club_worldFamilyClub_smsVerificationCode?: Maybe<Club_WorldFamilyClub_SmsVerificationCodeConnection>;
  club_worldFamilyClub_surveyTypeForm?: Maybe<Club_WorldFamilyClub_SurveyTypeFormConnection>;
  club_worldFamilyClub_surveyTypeFormList?: Maybe<Club_WorldFamilyClub_SurveyTypeFormListConnection>;
  club_worldFamilyClub_talkAlongCard?: Maybe<Club_WorldFamilyClub_TalkAlongCardConnection>;
  club_worldFamilyClub_teSong?: Maybe<Club_WorldFamilyClub_TeSongConnection>;
  club_worldFamilyClub_teSongToy?: Maybe<Club_WorldFamilyClub_TeSongToyConnection>;
  club_worldFamilyClub_temp20240408Graduation?: Maybe<Club_WorldFamilyClub_Temp20240408GraduationConnection>;
  club_worldFamilyClub_temp20240408Graduation1?: Maybe<Club_WorldFamilyClub_Temp20240408Graduation1Connection>;
  club_worldFamilyClub_temp20251028ExchangeReason?: Maybe<Club_WorldFamilyClub_Temp20251028ExchangeReasonConnection>;
  club_worldFamilyClub_temp20260310Product?: Maybe<Club_WorldFamilyClub_Temp20260310ProductConnection>;
  club_worldFamilyClub_tempChildGraduationApplicationNew?: Maybe<Club_WorldFamilyClub_TempChildGraduationApplicationNewConnection>;
  club_worldFamilyClub_tempChildGraduationApplicationOld?: Maybe<Club_WorldFamilyClub_TempChildGraduationApplicationOldConnection>;
  club_worldFamilyClub_tempFaceCall?: Maybe<Club_WorldFamilyClub_TempFaceCallConnection>;
  club_worldFamilyClub_tempFaceCallHk?: Maybe<Club_WorldFamilyClub_TempFaceCallHkConnection>;
  club_worldFamilyClub_tempFaceCallKr?: Maybe<Club_WorldFamilyClub_TempFaceCallKrConnection>;
  club_worldFamilyClub_tempGoGoLiveSong?: Maybe<Club_WorldFamilyClub_TempGoGoLiveSongConnection>;
  club_worldFamilyClub_tempHkAppMyFavorite?: Maybe<Club_WorldFamilyClub_TempHkAppMyFavoriteConnection>;
  club_worldFamilyClub_tempHkClubappsFacecallCrew?: Maybe<Club_WorldFamilyClub_TempHkClubappsFacecallCrewConnection>;
  club_worldFamilyClub_tempHkClubappsFacecallHistory?: Maybe<Club_WorldFamilyClub_TempHkClubappsFacecallHistoryConnection>;
  club_worldFamilyClub_tempHkClubappsFacecallSong?: Maybe<Club_WorldFamilyClub_TempHkClubappsFacecallSongConnection>;
  club_worldFamilyClub_tempHkDmemChild?: Maybe<Club_WorldFamilyClub_TempHkDmemChildConnection>;
  club_worldFamilyClub_tempHkTeSong?: Maybe<Club_WorldFamilyClub_TempHkTeSongConnection>;
  club_worldFamilyClub_tempHkTematerial?: Maybe<Club_WorldFamilyClub_TempHkTematerialConnection>;
  club_worldFamilyClub_tempKrFaceCallHist?: Maybe<Club_WorldFamilyClub_TempKrFaceCallHistConnection>;
  club_worldFamilyClub_tempKrFcCrewM?: Maybe<Club_WorldFamilyClub_TempKrFcCrewMConnection>;
  club_worldFamilyClub_tempKrFcsongCrew?: Maybe<Club_WorldFamilyClub_TempKrFcsongCrewConnection>;
  club_worldFamilyClub_tempKrMyFavorite?: Maybe<Club_WorldFamilyClub_TempKrMyFavoriteConnection>;
  club_worldFamilyClub_tempKrTeSong?: Maybe<Club_WorldFamilyClub_TempKrTeSongConnection>;
  club_worldFamilyClub_tempKrWfeClubMemberChild?: Maybe<Club_WorldFamilyClub_TempKrWfeClubMemberChildConnection>;
  club_worldFamilyClub_tempTalkAlongCard?: Maybe<Club_WorldFamilyClub_TempTalkAlongCardConnection>;
  club_worldFamilyClub_tempTwCambridge?: Maybe<Club_WorldFamilyClub_TempTwCambridgeConnection>;
  club_worldFamilyClub_tempTwFaceCallHist?: Maybe<Club_WorldFamilyClub_TempTwFaceCallHistConnection>;
  club_worldFamilyClub_tempTwFcCrewM?: Maybe<Club_WorldFamilyClub_TempTwFcCrewMConnection>;
  club_worldFamilyClub_tempTwFcsongCrew?: Maybe<Club_WorldFamilyClub_TempTwFcsongCrewConnection>;
  club_worldFamilyClub_tempTwFcsongMonthlyRecommend?: Maybe<Club_WorldFamilyClub_TempTwFcsongMonthlyRecommendConnection>;
  club_worldFamilyClub_tempTwMyFavorite?: Maybe<Club_WorldFamilyClub_TempTwMyFavoriteConnection>;
  club_worldFamilyClub_tempTwTeSong?: Maybe<Club_WorldFamilyClub_TempTwTeSongConnection>;
  club_worldFamilyClub_tempTwTeSongForCapLevel?: Maybe<Club_WorldFamilyClub_TempTwTeSongForCapLevelConnection>;
  club_worldFamilyClub_tempWfcGraC?: Maybe<Club_WorldFamilyClub_TempWfcGraCConnection>;
  club_worldFamilyClub_tempWfcGraCOrganized?: Maybe<Club_WorldFamilyClub_TempWfcGraCOrganizedConnection>;
  club_worldFamilyClub_testUserAccount?: Maybe<Club_WorldFamilyClub_TestUserAccountConnection>;
  club_worldFamilyClub_testWater?: Maybe<Club_WorldFamilyClub_TestWaterConnection>;
  club_worldFamilyClub_testWaterSub?: Maybe<Club_WorldFamilyClub_TestWaterSubConnection>;
  club_worldFamilyClub_tev2MonthlySong?: Maybe<Club_WorldFamilyClub_Tev2MonthlySongConnection>;
  club_worldFamilyClub_user?: Maybe<Club_WorldFamilyClub_UserConnection>;
  club_worldFamilyClub_videoForTrialmode?: Maybe<Club_WorldFamilyClub_VideoForTrialmodeConnection>;
  club_worldFamilyClub_wfcLibraryFaq?: Maybe<Club_WorldFamilyClub_WfcLibraryFaqConnection>;
  club_worldFamilyClub_wfcLibraryLog?: Maybe<Club_WorldFamilyClub_WfcLibraryLogConnection>;
  club_worldFamilyClub_wfcNowPageViewLog?: Maybe<Club_WorldFamilyClub_WfcNowPageViewLogConnection>;
  /** Get Default Service Banner List */
  defaultServiceBannerList: Array<DefaultServiceBannerInfo>;
  /** Get Entry Package Order List */
  entryPackageOrderList: Array<EntryPackageOrderListResult>;
  /** Get GoGoLive Level List */
  goGoLiveLevelList: Array<GoGoLiveLevelInfo>;
  /** Get GoGoLive Parent Guide Info */
  goGoLiveParentGuideInfo: Array<GoGoLiveParentGuideDetailInfo>;
  /** Get GoGoLive Parent Guide List */
  goGoLiveParentGuideList: Array<GoGoLiveParentGuideInfo>;
  /** Get GoGoLive Parent Guide Locale List */
  goGoLiveParentGuideLocaleList: Array<GoGoLiveParentGuideLocaleInfo>;
  /** Get GoGoLive Session List */
  goGoLiveSessionList: Array<GoGoLiveSessionInfo>;
  /** Get GoGoLive Song List */
  goGoLiveSongList: Array<GoGoLiveSongInfo>;
  /** Get GoGoLive TalkAlong Card List */
  goGoLiveTalkAlongCardList: Array<TalkAlongCardInfo>;
  /** Get GoGoLive Toy List */
  goGoLiveToyList: Array<GoGoLiveToyInfo>;
  /** Get Kid's World Video Info */
  kidsWorldVideo: Array<KidsWorldVideoInfoResult>;
  /** Get Kid's World Video List */
  kidsWorldVideoList: Array<KidsWorldVideoInfoResult>;
  /** Get list lead reply source infomation */
  leadsReplySourceInformation: ApiResponseOfGetLeadsReplySourceInformationResponse;
  /** Get Market List of Default Banner */
  marketListOfDefaultBanner: Array<BannerMarketInfo>;
  /** Fetches an object given its ID. */
  node?: Maybe<Node>;
  /** Lookup nodes by a list of IDs. */
  nodes: Array<Maybe<Node>>;
  /** Retrieves the list of Button Links for push notifications */
  pushNotificationButtonLinkList: Array<PushNotificationButtonLinkResult>;
  /** Retrieves the list of Service Types for push notifications */
  pushNotificationServiceTypeList: Array<PushNotificationServiceTypeResult>;
  sales188Notification: Array<Sales188Notification>;
  sales188Release: Array<Sales188Release>;
  /** Get sales profile information list */
  salesProfileList: Array<SalesProfileInformation>;
  /** Get Scheduled Service Banner List */
  scheduledServiceBannerList: Array<ScheduledServiceBannerInfo>;
  /** Get Service List of Default Banner */
  serviceListOfDefaultBanner: Array<BannerServiceInfo>;
  /** Get Testimonial Info */
  testimonialInfo: Array<TestimonialInfoResponse>;
  /** Get Testimonial List */
  testimonialList: Array<TestimonialResponse>;
  /** Get tag info */
  testimonialTagInfo: Array<TagResponse>;
  /** Get tag list */
  testimonialTagList: Array<TagResponse>;
  /** Get TEV2 Monthly Song By seq */
  tev2MonthlySongInfo: Array<Tev2MonthlySongInfo>;
  /** Get TEV2 Monthly Song List */
  tev2MonthlySongList: Array<Tev2MonthlySongInfo>;
  trialCampaignChannel: Array<TrialCampaignChannel>;
  trialCampaignChannelUrl: Array<TrialCampaignChannelUrl>;
  /** Get TrialMode - App Announcement Bar (Single) */
  trialModeAppAnnouncementBar: Array<TrialModeAppAnnouncementBarResult>;
  /** Get TrialMode - App Announcement Bar List */
  trialModeAppAnnouncementBarList: Array<TrialModeAppAnnouncementBarResult>;
  trialModeLeadsNotification: Array<Wf_TrialModeLeads_Notification>;
  /** Get order version up list by market */
  upgradePaymentList: Array<MemberUpgradePaymentResponse>;
  /** Get Warranty Info List */
  warrantyInfoList: Array<WarrantyInfoResponse>;
  /** Get Warranty List */
  warrantyList: Array<WarrantyListResponse>;
  wf_adminFirst_a?: Maybe<Wf_AdminFirst_AConnection>;
  wf_adminFirst_ab?: Maybe<Wf_AdminFirst_AbConnection>;
  wf_adminFirst_afNotification?: Maybe<Wf_AdminFirst_AfNotificationConnection>;
  wf_adminFirst_afNotificationButtonLink?: Maybe<Wf_AdminFirst_AfNotificationButtonLinkConnection>;
  wf_adminFirst_afNotificationButtonLinkMarket?: Maybe<Wf_AdminFirst_AfNotificationButtonLinkMarketConnection>;
  wf_adminFirst_afNotificationMember?: Maybe<Wf_AdminFirst_AfNotificationMemberConnection>;
  wf_adminFirst_afNotificationMemberLog?: Maybe<Wf_AdminFirst_AfNotificationMemberLogConnection>;
  wf_adminFirst_afNotificationServiceType?: Maybe<Wf_AdminFirst_AfNotificationServiceTypeConnection>;
  wf_adminFirst_afNotificationServiceTypeMarket?: Maybe<Wf_AdminFirst_AfNotificationServiceTypeMarketConnection>;
  wf_adminFirst_afProgram?: Maybe<Wf_AdminFirst_AfProgramConnection>;
  wf_adminFirst_afService?: Maybe<Wf_AdminFirst_AfServiceConnection>;
  wf_adminFirst_afUser?: Maybe<Wf_AdminFirst_AfUserConnection>;
  wf_adminFirst_afUserMarket?: Maybe<Wf_AdminFirst_AfUserMarketConnection>;
  wf_adminFirst_afUserProgram?: Maybe<Wf_AdminFirst_AfUserProgramConnection>;
  wf_adminFirst_afUserService?: Maybe<Wf_AdminFirst_AfUserServiceConnection>;
  wf_adminFirst_childGraduationApplication?: Maybe<Wf_AdminFirst_ChildGraduationApplicationConnection>;
  wf_adminFirst_graduationApplication?: Maybe<Wf_AdminFirst_GraduationApplicationConnection>;
  wf_adminFirst_graphqlAccess?: Maybe<Wf_AdminFirst_GraphqlAccessConnection>;
  wf_adminFirst_graphqlSchema?: Maybe<Wf_AdminFirst_GraphqlSchemaConnection>;
  wf_adminFirst_teamSetting?: Maybe<Wf_AdminFirst_TeamSettingConnection>;
  wf_adminFirst_tempFaceCall?: Maybe<Wf_AdminFirst_TempFaceCallConnection>;
  wf_adminFirst_tempPrepaidMembershipFee?: Maybe<Wf_AdminFirst_TempPrepaidMembershipFeeConnection>;
  wf_adminFirst_tepsDailyHour?: Maybe<Wf_AdminFirst_TepsDailyHourConnection>;
  wf_adminFirst_tepsDailyHourLocationType?: Maybe<Wf_AdminFirst_TepsDailyHourLocationTypeConnection>;
  wf_adminFirst_tepsDailyHourType?: Maybe<Wf_AdminFirst_TepsDailyHourTypeConnection>;
  wf_adminFirst_tepsProject?: Maybe<Wf_AdminFirst_TepsProjectConnection>;
  wf_adminFirst_tepsProjectAllocatedType?: Maybe<Wf_AdminFirst_TepsProjectAllocatedTypeConnection>;
  wf_adminFirst_tepsProjectType?: Maybe<Wf_AdminFirst_TepsProjectTypeConnection>;
  wf_adminFirst_tepsProjection?: Maybe<Wf_AdminFirst_TepsProjectionConnection>;
  wf_adminFirst_tepsUser?: Maybe<Wf_AdminFirst_TepsUserConnection>;
  wf_adminFirst_tepsUserProject?: Maybe<Wf_AdminFirst_TepsUserProjectConnection>;
  wf_trialModeLeads_allParentTip?: Maybe<Wf_TrialModeLeads_AllParentTipConnection>;
  wf_trialModeLeads_appAnnouncementBar?: Maybe<Wf_TrialModeLeads_AppAnnouncementBarConnection>;
  wf_trialModeLeads_appAnnouncementBarMarket?: Maybe<Wf_TrialModeLeads_AppAnnouncementBarMarketConnection>;
  wf_trialModeLeads_autoMail?: Maybe<Wf_TrialModeLeads_AutoMailConnection>;
  wf_trialModeLeads_callToAction?: Maybe<Wf_TrialModeLeads_CallToActionConnection>;
  wf_trialModeLeads_callToActionContent?: Maybe<Wf_TrialModeLeads_CallToActionContentConnection>;
  wf_trialModeLeads_callToActionExperienceType?: Maybe<Wf_TrialModeLeads_CallToActionExperienceTypeConnection>;
  wf_trialModeLeads_designImage?: Maybe<Wf_TrialModeLeads_DesignImageConnection>;
  wf_trialModeLeads_featuredEvent?: Maybe<Wf_TrialModeLeads_FeaturedEventConnection>;
  wf_trialModeLeads_graphqlAccess?: Maybe<Wf_TrialModeLeads_GraphqlAccessConnection>;
  wf_trialModeLeads_graphqlSchema?: Maybe<Wf_TrialModeLeads_GraphqlSchemaConnection>;
  wf_trialModeLeads_installation?: Maybe<Wf_TrialModeLeads_InstallationConnection>;
  wf_trialModeLeads_installationLog?: Maybe<Wf_TrialModeLeads_InstallationLogConnection>;
  wf_trialModeLeads_journeyCard?: Maybe<Wf_TrialModeLeads_JourneyCardConnection>;
  wf_trialModeLeads_journeyExperienceType?: Maybe<Wf_TrialModeLeads_JourneyExperienceTypeConnection>;
  wf_trialModeLeads_notification?: Maybe<Wf_TrialModeLeads_NotificationConnection>;
  wf_trialModeLeads_notificationChild?: Maybe<Wf_TrialModeLeads_NotificationChildConnection>;
  wf_trialModeLeads_notificationMember?: Maybe<Wf_TrialModeLeads_NotificationMemberConnection>;
  wf_trialModeLeads_notificationToChildAge?: Maybe<Wf_TrialModeLeads_NotificationToChildAgeConnection>;
  wf_trialModeLeads_notificationToSegmentation?: Maybe<Wf_TrialModeLeads_NotificationToSegmentationConnection>;
  wf_trialModeLeads_notificationType?: Maybe<Wf_TrialModeLeads_NotificationTypeConnection>;
  wf_trialModeLeads_parentTip?: Maybe<Wf_TrialModeLeads_ParentTipConnection>;
  wf_trialModeLeads_productCategory?: Maybe<Wf_TrialModeLeads_ProductCategoryConnection>;
  wf_trialModeLeads_productSong?: Maybe<Wf_TrialModeLeads_ProductSongConnection>;
  wf_trialModeLeads_productSongAndMarket?: Maybe<Wf_TrialModeLeads_ProductSongAndMarketConnection>;
  wf_trialModeLeads_productVideo?: Maybe<Wf_TrialModeLeads_ProductVideoConnection>;
  wf_trialModeLeads_productVideoAndMarket?: Maybe<Wf_TrialModeLeads_ProductVideoAndMarketConnection>;
  wf_trialModeLeads_regularEvent?: Maybe<Wf_TrialModeLeads_RegularEventConnection>;
  wf_trialModeLeads_tacoTest?: Maybe<Wf_TrialModeLeads_TacoTestConnection>;
  wf_trialModeLeads_tempProductVideo?: Maybe<Wf_TrialModeLeads_TempProductVideoConnection>;
  wf_trialModeLeads_testimonial?: Maybe<Wf_TrialModeLeads_TestimonialConnection>;
  wf_trialModeLeads_testimonialTag?: Maybe<Wf_TrialModeLeads_TestimonialTagConnection>;
  wf_trialModeLeads_testimonialTagMapping?: Maybe<Wf_TrialModeLeads_TestimonialTagMappingConnection>;
  wf_trialModeLeads_tip?: Maybe<Wf_TrialModeLeads_TipConnection>;
  wf_trialModeLeads_trialCampaignUrl?: Maybe<Wf_TrialModeLeads_TrialCampaignUrlConnection>;
  wf_trialModeLeads_trialMailLog?: Maybe<Wf_TrialModeLeads_TrialMailLogConnection>;
  wf_trialModeLeads_trialMailSetting?: Maybe<Wf_TrialModeLeads_TrialMailSettingConnection>;
  wf_trialModeLeads_trialMessageSetting?: Maybe<Wf_TrialModeLeads_TrialMessageSettingConnection>;
  wf_trialModeLeads_trialOneTimeToken?: Maybe<Wf_TrialModeLeads_TrialOneTimeTokenConnection>;
  wf_trialModeLeads_trialPushType?: Maybe<Wf_TrialModeLeads_TrialPushTypeConnection>;
  wf_trialModeLeads_trialSegmentation?: Maybe<Wf_TrialModeLeads_TrialSegmentationConnection>;
  wf_trialModeLeads_trialSetting?: Maybe<Wf_TrialModeLeads_TrialSettingConnection>;
  wf_trialModeLeads_trialTestPhone?: Maybe<Wf_TrialModeLeads_TrialTestPhoneConnection>;
  wf_trialModeLeads_trialToken?: Maybe<Wf_TrialModeLeads_TrialTokenConnection>;
  wf_trialModeLeads_trialTrackingLog?: Maybe<Wf_TrialModeLeads_TrialTrackingLogConnection>;
  wf_trialModeLeads_trialUser?: Maybe<Wf_TrialModeLeads_TrialUserConnection>;
  wf_trialModeLeads_trialUserMessageLog?: Maybe<Wf_TrialModeLeads_TrialUserMessageLogConnection>;
  wf_trialModeLeads_trialUserNotification?: Maybe<Wf_TrialModeLeads_TrialUserNotificationConnection>;
  wf_trialModeLeads_trialUserSegmentationLog?: Maybe<Wf_TrialModeLeads_TrialUserSegmentationLogConnection>;
};


export type QueryAfChildGraduationApplicationArgs = {
  filter?: InputMaybe<Club_WorldFamilyClub_ChildGraduationApplicationFilterInput>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_ChildGraduationApplicationSortInput>>;
};


export type QueryAfFaceCallPerformerArgs = {
  filter?: InputMaybe<Club_WorldFamilyClub_FaceCallPerformerFilterInput>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallPerformerSortInput>>;
};


export type QueryAfFaceCallSongArgs = {
  filter?: InputMaybe<Club_WorldFamilyClub_FaceCallSongFilterInput>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallSongSortInput>>;
};


export type QueryAfGraduationApplicationArgs = {
  filter?: InputMaybe<Club_WorldFamilyClub_GraduationApplicationFilterInput>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_GraduationApplicationSortInput>>;
};


export type QueryAfGraduationChildArgs = {
  filter?: InputMaybe<AfGraduationChildFilterInput>;
  graduationYear: Scalars['Int']['input'];
  isSubmittedFromApp: Scalars['Boolean']['input'];
  market?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<AfGraduationChildSortInput>>;
  seq?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAfMemberArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AfMemberFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  market: Market;
  order?: InputMaybe<Array<AfMemberSortInput>>;
  searchText?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAfTeSongArgs = {
  filter?: InputMaybe<Club_WorldFamilyClub_TeSongFilterInput>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_TeSongSortInput>>;
};


export type QueryClub_WorldFamilyClub_AppAuthArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_AppAuthFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_AppAuthSortInput>>;
};


export type QueryClub_WorldFamilyClub_AppBannerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_AppBannerFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_AppBannerSortInput>>;
};


export type QueryClub_WorldFamilyClub_AppDigitalMagazineArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_AppDigitalMagazineFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_AppDigitalMagazineSortInput>>;
};


export type QueryClub_WorldFamilyClub_AppMemberAuthorizeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_AppMemberAuthorizeFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_AppMemberAuthorizeSortInput>>;
};


export type QueryClub_WorldFamilyClub_AppMemberAuthorizeLogArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_AppMemberAuthorizeLogFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_AppMemberAuthorizeLogSortInput>>;
};


export type QueryClub_WorldFamilyClub_AppMemberChildArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_AppMemberChildFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_AppMemberChildSortInput>>;
};


export type QueryClub_WorldFamilyClub_AppMemberDeviceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_AppMemberDeviceFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_AppMemberDeviceSortInput>>;
};


export type QueryClub_WorldFamilyClub_AppMemberFirstLoginArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_AppMemberFirstLoginFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_AppMemberFirstLoginSortInput>>;
};


export type QueryClub_WorldFamilyClub_AppMemberNotificationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_AppMemberNotificationFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_AppMemberNotificationSortInput>>;
};


export type QueryClub_WorldFamilyClub_AppMemberNotificationPushFirebaseArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_AppMemberNotificationPushFirebaseFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_AppMemberNotificationPushFirebaseSortInput>>;
};


export type QueryClub_WorldFamilyClub_AppNotificationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_AppNotificationFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_AppNotificationSortInput>>;
};


export type QueryClub_WorldFamilyClub_AppNotificationMemberArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_AppNotificationMemberFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_AppNotificationMemberSortInput>>;
};


export type QueryClub_WorldFamilyClub_AppNotificationTypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_AppNotificationTypeFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_AppNotificationTypeSortInput>>;
};


export type QueryClub_WorldFamilyClub_AppNotificationTypeMarketArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_AppNotificationTypeMarketFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_AppNotificationTypeMarketSortInput>>;
};


export type QueryClub_WorldFamilyClub_AppRegionEmergencyArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_AppRegionEmergencyFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_AppRegionEmergencySortInput>>;
};


export type QueryClub_WorldFamilyClub_AppReleaseArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_AppReleaseFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_AppReleaseSortInput>>;
};


export type QueryClub_WorldFamilyClub_AppServiceRegionFestivalImageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_AppServiceRegionFestivalImageFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_AppServiceRegionFestivalImageSortInput>>;
};


export type QueryClub_WorldFamilyClub_AppServiceRegionImageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_AppServiceRegionImageFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_AppServiceRegionImageSortInput>>;
};


export type QueryClub_WorldFamilyClub_AppSurveyArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_AppSurveyFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_AppSurveySortInput>>;
};


export type QueryClub_WorldFamilyClub_AppSurveyMemberArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_AppSurveyMemberFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_AppSurveyMemberSortInput>>;
};


export type QueryClub_WorldFamilyClub_AppSurveyQaArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_AppSurveyQaFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_AppSurveyQaSortInput>>;
};


export type QueryClub_WorldFamilyClub_AppSurveyReminderArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_AppSurveyReminderFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_AppSurveyReminderSortInput>>;
};


export type QueryClub_WorldFamilyClub_AzureFunctionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_AzureFunctionFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_AzureFunctionSortInput>>;
};


export type QueryClub_WorldFamilyClub_BankCodeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_BankCodeFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_BankCodeSortInput>>;
};


export type QueryClub_WorldFamilyClub_BroadcastPromotionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_BroadcastPromotionFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_BroadcastPromotionSortInput>>;
};


export type QueryClub_WorldFamilyClub_CapGuidePdfArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_CapGuidePdfFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_CapGuidePdfSortInput>>;
};


export type QueryClub_WorldFamilyClub_ChildGraduationApplicationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_ChildGraduationApplicationFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_ChildGraduationApplicationSortInput>>;
};


export type QueryClub_WorldFamilyClub_CreditcardBankCodeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_CreditcardBankCodeFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_CreditcardBankCodeSortInput>>;
};


export type QueryClub_WorldFamilyClub_DweProductPackageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_DweProductPackageFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_DweProductPackageSortInput>>;
};


export type QueryClub_WorldFamilyClub_DweProductSongArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_DweProductSongFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_DweProductSongSortInput>>;
};


export type QueryClub_WorldFamilyClub_DweProductSongToolArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_DweProductSongToolFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_DweProductSongToolSortInput>>;
};


export type QueryClub_WorldFamilyClub_DweProductToolArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_DweProductToolFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_DweProductToolSortInput>>;
};


export type QueryClub_WorldFamilyClub_EasypayOrderLogArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_EasypayOrderLogFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_EasypayOrderLogSortInput>>;
};


export type QueryClub_WorldFamilyClub_EntryPackageOrderArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_EntryPackageOrderFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_EntryPackageOrderSortInput>>;
};


export type QueryClub_WorldFamilyClub_EntryPackageOrdersMemberPaymentInfoArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_EntryPackageOrdersMemberPaymentInfoFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_EntryPackageOrdersMemberPaymentInfoSortInput>>;
};


export type QueryClub_WorldFamilyClub_EventBannerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_EventBannerFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_EventBannerSortInput>>;
};


export type QueryClub_WorldFamilyClub_EventBannerRegionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_EventBannerRegionFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_EventBannerRegionSortInput>>;
};


export type QueryClub_WorldFamilyClub_EventCheckInAuthArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_EventCheckInAuthFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_EventCheckInAuthSortInput>>;
};


export type QueryClub_WorldFamilyClub_EventNotificationLogArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_EventNotificationLogFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_EventNotificationLogSortInput>>;
};


export type QueryClub_WorldFamilyClub_EventPromotionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_EventPromotionFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_EventPromotionSortInput>>;
};


export type QueryClub_WorldFamilyClub_EventSeatArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_EventSeatFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_EventSeatSortInput>>;
};


export type QueryClub_WorldFamilyClub_EventTypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_EventTypeFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_EventTypeSortInput>>;
};


export type QueryClub_WorldFamilyClub_ExchangeApplicationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_ExchangeApplicationFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_ExchangeApplicationSortInput>>;
};


export type QueryClub_WorldFamilyClub_ExchangeApplicationItemArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_ExchangeApplicationItemFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_ExchangeApplicationItemSortInput>>;
};


export type QueryClub_WorldFamilyClub_ExchangeReasonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_ExchangeReasonFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_ExchangeReasonSortInput>>;
};


export type QueryClub_WorldFamilyClub_ExchangeReasonTranslationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_ExchangeReasonTranslationFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_ExchangeReasonTranslationSortInput>>;
};


export type QueryClub_WorldFamilyClub_FaceCallAndTelephoneEnglishArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_FaceCallAndTelephoneEnglishFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallAndTelephoneEnglishSortInput>>;
};


export type QueryClub_WorldFamilyClub_FaceCallForTrialmodeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_FaceCallForTrialmodeFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallForTrialmodeSortInput>>;
};


export type QueryClub_WorldFamilyClub_FaceCallHistArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_FaceCallHistFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallHistSortInput>>;
};


export type QueryClub_WorldFamilyClub_FaceCallHistCountArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_FaceCallHistCountFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallHistCountSortInput>>;
};


export type QueryClub_WorldFamilyClub_FaceCallMonthlyRecommendArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_FaceCallMonthlyRecommendFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallMonthlyRecommendSortInput>>;
};


export type QueryClub_WorldFamilyClub_FaceCallPerformerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_FaceCallPerformerFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallPerformerSortInput>>;
};


export type QueryClub_WorldFamilyClub_FaceCallSeasonHolidayArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_FaceCallSeasonHolidayFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallSeasonHolidaySortInput>>;
};


export type QueryClub_WorldFamilyClub_FaceCallSongArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_FaceCallSongFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallSongSortInput>>;
};


export type QueryClub_WorldFamilyClub_FaceCallSongAndPerformerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_FaceCallSongAndPerformerFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallSongAndPerformerSortInput>>;
};


export type QueryClub_WorldFamilyClub_FaceCallSongPublicArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_FaceCallSongPublicFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_FaceCallSongPublicSortInput>>;
};


export type QueryClub_WorldFamilyClub_GoGoLiveDesktopQrcodeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_GoGoLiveDesktopQrcodeFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveDesktopQrcodeSortInput>>;
};


export type QueryClub_WorldFamilyClub_GoGoLiveLevelArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_GoGoLiveLevelFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveLevelSortInput>>;
};


export type QueryClub_WorldFamilyClub_GoGoLiveOpenDateArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_GoGoLiveOpenDateFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveOpenDateSortInput>>;
};


export type QueryClub_WorldFamilyClub_GoGoLiveParentGuideArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_GoGoLiveParentGuideFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuideSortInput>>;
};


export type QueryClub_WorldFamilyClub_GoGoLiveParentGuideLocaleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_GoGoLiveParentGuideLocaleFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuideLocaleSortInput>>;
};


export type QueryClub_WorldFamilyClub_GoGoLiveParentGuideSessionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_GoGoLiveParentGuideSessionFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuideSessionSortInput>>;
};


export type QueryClub_WorldFamilyClub_GoGoLiveParentGuideSongArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_GoGoLiveParentGuideSongFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuideSongSortInput>>;
};


export type QueryClub_WorldFamilyClub_GoGoLiveParentGuideTacArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_GoGoLiveParentGuideTacFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuideTacSortInput>>;
};


export type QueryClub_WorldFamilyClub_GoGoLiveParentGuideToyArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_GoGoLiveParentGuideToyFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveParentGuideToySortInput>>;
};


export type QueryClub_WorldFamilyClub_GoGoLivePromotionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_GoGoLivePromotionFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLivePromotionSortInput>>;
};


export type QueryClub_WorldFamilyClub_GoGoLiveSessionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_GoGoLiveSessionFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveSessionSortInput>>;
};


export type QueryClub_WorldFamilyClub_GoGoLiveSongArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_GoGoLiveSongFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveSongSortInput>>;
};


export type QueryClub_WorldFamilyClub_GoGoLiveToyArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_GoGoLiveToyFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_GoGoLiveToySortInput>>;
};


export type QueryClub_WorldFamilyClub_GraduationApplicationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_GraduationApplicationFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_GraduationApplicationSortInput>>;
};


export type QueryClub_WorldFamilyClub_GraduationApplicationEvaluationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_GraduationApplicationEvaluationFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_GraduationApplicationEvaluationSortInput>>;
};


export type QueryClub_WorldFamilyClub_GraduationApplicationSubTaskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_GraduationApplicationSubTaskFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_GraduationApplicationSubTaskSortInput>>;
};


export type QueryClub_WorldFamilyClub_GraduationApplicationTaskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_GraduationApplicationTaskFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_GraduationApplicationTaskSortInput>>;
};


export type QueryClub_WorldFamilyClub_GraduationChildArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_GraduationChildFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_GraduationChildSortInput>>;
};


export type QueryClub_WorldFamilyClub_GraduationChildSettingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_GraduationChildSettingFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_GraduationChildSettingSortInput>>;
};


export type QueryClub_WorldFamilyClub_GraduationEvaluationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_GraduationEvaluationFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_GraduationEvaluationSortInput>>;
};


export type QueryClub_WorldFamilyClub_GraduationNotificationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_GraduationNotificationFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_GraduationNotificationSortInput>>;
};


export type QueryClub_WorldFamilyClub_GraduationSubApplicationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_GraduationSubApplicationFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_GraduationSubApplicationSortInput>>;
};


export type QueryClub_WorldFamilyClub_GraduationSubTaskMarketDescriptionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_GraduationSubTaskMarketDescriptionFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_GraduationSubTaskMarketDescriptionSortInput>>;
};


export type QueryClub_WorldFamilyClub_GraduationTaskMarketDescriptionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_GraduationTaskMarketDescriptionFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_GraduationTaskMarketDescriptionSortInput>>;
};


export type QueryClub_WorldFamilyClub_GraphqlAccessArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_GraphqlAccessFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_GraphqlAccessSortInput>>;
};


export type QueryClub_WorldFamilyClub_GraphqlSchemaArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_GraphqlSchemaFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_GraphqlSchemaSortInput>>;
};


export type QueryClub_WorldFamilyClub_HolidayAudioArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_HolidayAudioFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_HolidayAudioSortInput>>;
};


export type QueryClub_WorldFamilyClub_HolidaySettingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_HolidaySettingFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_HolidaySettingSortInput>>;
};


export type QueryClub_WorldFamilyClub_HolidayVideoArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_HolidayVideoFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_HolidayVideoSortInput>>;
};


export type QueryClub_WorldFamilyClub_HolidayVideoBonusEntitlementTestArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_HolidayVideoBonusEntitlementTestFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_HolidayVideoBonusEntitlementTestSortInput>>;
};


export type QueryClub_WorldFamilyClub_HolidayVideoMarketArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_HolidayVideoMarketFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_HolidayVideoMarketSortInput>>;
};


export type QueryClub_WorldFamilyClub_HolidayVideoMarketSettingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_HolidayVideoMarketSettingFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_HolidayVideoMarketSettingSortInput>>;
};


export type QueryClub_WorldFamilyClub_HolidayVideoMemberArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_HolidayVideoMemberFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_HolidayVideoMemberSortInput>>;
};


export type QueryClub_WorldFamilyClub_KidsWorldVideoArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_KidsWorldVideoFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_KidsWorldVideoSortInput>>;
};


export type QueryClub_WorldFamilyClub_MemberMessageSettingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_MemberMessageSettingFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_MemberMessageSettingSortInput>>;
};


export type QueryClub_WorldFamilyClub_MemberMonthlyActiveSummaryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_MemberMonthlyActiveSummaryFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_MemberMonthlyActiveSummarySortInput>>;
};


export type QueryClub_WorldFamilyClub_MemberUpgradePaymentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_MemberUpgradePaymentFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_MemberUpgradePaymentSortInput>>;
};


export type QueryClub_WorldFamilyClub_MyFavoriteFaceCallArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_MyFavoriteFaceCallFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_MyFavoriteFaceCallSortInput>>;
};


export type QueryClub_WorldFamilyClub_MyFavoriteFaceCallSongArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_MyFavoriteFaceCallSongFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_MyFavoriteFaceCallSongSortInput>>;
};


export type QueryClub_WorldFamilyClub_NotificationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_NotificationFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_NotificationSortInput>>;
};


export type QueryClub_WorldFamilyClub_NotificationIconArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_NotificationIconFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_NotificationIconSortInput>>;
};


export type QueryClub_WorldFamilyClub_OneTimeTokenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_OneTimeTokenFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_OneTimeTokenSortInput>>;
};


export type QueryClub_WorldFamilyClub_OnlineEventLogArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_OnlineEventLogFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_OnlineEventLogSortInput>>;
};


export type QueryClub_WorldFamilyClub_OnlineShowArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_OnlineShowFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_OnlineShowSortInput>>;
};


export type QueryClub_WorldFamilyClub_ParameterArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_ParameterFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_ParameterSortInput>>;
};


export type QueryClub_WorldFamilyClub_ProductArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_ProductFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_ProductSortInput>>;
};


export type QueryClub_WorldFamilyClub_ProductCategoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_ProductCategoryFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_ProductCategorySortInput>>;
};


export type QueryClub_WorldFamilyClub_ProductCategoryTranslationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_ProductCategoryTranslationFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_ProductCategoryTranslationSortInput>>;
};


export type QueryClub_WorldFamilyClub_ProductSubCategoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_ProductSubCategoryFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_ProductSubCategorySortInput>>;
};


export type QueryClub_WorldFamilyClub_ProductSubCategoryExchangeReasonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_ProductSubCategoryExchangeReasonFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_ProductSubCategoryExchangeReasonSortInput>>;
};


export type QueryClub_WorldFamilyClub_ProductSubCategoryTranslationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_ProductSubCategoryTranslationFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_ProductSubCategoryTranslationSortInput>>;
};


export type QueryClub_WorldFamilyClub_ProductTranslationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_ProductTranslationFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_ProductTranslationSortInput>>;
};


export type QueryClub_WorldFamilyClub_Products1Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_Products1FilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_Products1SortInput>>;
};


export type QueryClub_WorldFamilyClub_RegionBannerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_RegionBannerFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_RegionBannerSortInput>>;
};


export type QueryClub_WorldFamilyClub_SearchKeywordArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_SearchKeywordFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_SearchKeywordSortInput>>;
};


export type QueryClub_WorldFamilyClub_ServiceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_ServiceFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_ServiceSortInput>>;
};


export type QueryClub_WorldFamilyClub_ServiceBannerDefaultArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_ServiceBannerDefaultFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_ServiceBannerDefaultSortInput>>;
};


export type QueryClub_WorldFamilyClub_ServiceBannerScheduledArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_ServiceBannerScheduledFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_ServiceBannerScheduledSortInput>>;
};


export type QueryClub_WorldFamilyClub_ServiceOneTimeTokenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_ServiceOneTimeTokenFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_ServiceOneTimeTokenSortInput>>;
};


export type QueryClub_WorldFamilyClub_ServiceSearchArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_ServiceSearchFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_ServiceSearchSortInput>>;
};


export type QueryClub_WorldFamilyClub_SmsCertificationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_SmsCertificationFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_SmsCertificationSortInput>>;
};


export type QueryClub_WorldFamilyClub_SmsCertificationLogArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_SmsCertificationLogFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_SmsCertificationLogSortInput>>;
};


export type QueryClub_WorldFamilyClub_SmsVerificationCodeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_SmsVerificationCodeFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_SmsVerificationCodeSortInput>>;
};


export type QueryClub_WorldFamilyClub_SurveyTypeFormArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_SurveyTypeFormFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_SurveyTypeFormSortInput>>;
};


export type QueryClub_WorldFamilyClub_SurveyTypeFormListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_SurveyTypeFormListFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_SurveyTypeFormListSortInput>>;
};


export type QueryClub_WorldFamilyClub_TalkAlongCardArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_TalkAlongCardFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_TalkAlongCardSortInput>>;
};


export type QueryClub_WorldFamilyClub_TeSongArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_TeSongFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_TeSongSortInput>>;
};


export type QueryClub_WorldFamilyClub_TeSongToyArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_TeSongToyFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_TeSongToySortInput>>;
};


export type QueryClub_WorldFamilyClub_Temp20240408GraduationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_Temp20240408GraduationFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_Temp20240408GraduationSortInput>>;
};


export type QueryClub_WorldFamilyClub_Temp20240408Graduation1Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_Temp20240408Graduation1FilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_Temp20240408Graduation1SortInput>>;
};


export type QueryClub_WorldFamilyClub_Temp20251028ExchangeReasonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_Temp20251028ExchangeReasonFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_Temp20251028ExchangeReasonSortInput>>;
};


export type QueryClub_WorldFamilyClub_Temp20260310ProductArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_Temp20260310ProductFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_Temp20260310ProductSortInput>>;
};


export type QueryClub_WorldFamilyClub_TempChildGraduationApplicationNewArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_TempChildGraduationApplicationNewFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_TempChildGraduationApplicationNewSortInput>>;
};


export type QueryClub_WorldFamilyClub_TempChildGraduationApplicationOldArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_TempChildGraduationApplicationOldFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_TempChildGraduationApplicationOldSortInput>>;
};


export type QueryClub_WorldFamilyClub_TempFaceCallArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_TempFaceCallFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_TempFaceCallSortInput>>;
};


export type QueryClub_WorldFamilyClub_TempFaceCallHkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_TempFaceCallHkFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_TempFaceCallHkSortInput>>;
};


export type QueryClub_WorldFamilyClub_TempFaceCallKrArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_TempFaceCallKrFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_TempFaceCallKrSortInput>>;
};


export type QueryClub_WorldFamilyClub_TempGoGoLiveSongArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_TempGoGoLiveSongFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_TempGoGoLiveSongSortInput>>;
};


export type QueryClub_WorldFamilyClub_TempHkAppMyFavoriteArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_TempHkAppMyFavoriteFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_TempHkAppMyFavoriteSortInput>>;
};


export type QueryClub_WorldFamilyClub_TempHkClubappsFacecallCrewArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_TempHkClubappsFacecallCrewFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_TempHkClubappsFacecallCrewSortInput>>;
};


export type QueryClub_WorldFamilyClub_TempHkClubappsFacecallHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_TempHkClubappsFacecallHistoryFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_TempHkClubappsFacecallHistorySortInput>>;
};


export type QueryClub_WorldFamilyClub_TempHkClubappsFacecallSongArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_TempHkClubappsFacecallSongFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_TempHkClubappsFacecallSongSortInput>>;
};


export type QueryClub_WorldFamilyClub_TempHkDmemChildArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_TempHkDmemChildFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_TempHkDmemChildSortInput>>;
};


export type QueryClub_WorldFamilyClub_TempHkTeSongArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_TempHkTeSongFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_TempHkTeSongSortInput>>;
};


export type QueryClub_WorldFamilyClub_TempHkTematerialArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_TempHkTematerialFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_TempHkTematerialSortInput>>;
};


export type QueryClub_WorldFamilyClub_TempKrFaceCallHistArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_TempKrFaceCallHistFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_TempKrFaceCallHistSortInput>>;
};


export type QueryClub_WorldFamilyClub_TempKrFcCrewMArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_TempKrFcCrewMFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_TempKrFcCrewMSortInput>>;
};


export type QueryClub_WorldFamilyClub_TempKrFcsongCrewArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_TempKrFcsongCrewFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_TempKrFcsongCrewSortInput>>;
};


export type QueryClub_WorldFamilyClub_TempKrMyFavoriteArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_TempKrMyFavoriteFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_TempKrMyFavoriteSortInput>>;
};


export type QueryClub_WorldFamilyClub_TempKrTeSongArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_TempKrTeSongFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_TempKrTeSongSortInput>>;
};


export type QueryClub_WorldFamilyClub_TempKrWfeClubMemberChildArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_TempKrWfeClubMemberChildFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_TempKrWfeClubMemberChildSortInput>>;
};


export type QueryClub_WorldFamilyClub_TempTalkAlongCardArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_TempTalkAlongCardFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_TempTalkAlongCardSortInput>>;
};


export type QueryClub_WorldFamilyClub_TempTwCambridgeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_TempTwCambridgeFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_TempTwCambridgeSortInput>>;
};


export type QueryClub_WorldFamilyClub_TempTwFaceCallHistArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_TempTwFaceCallHistFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_TempTwFaceCallHistSortInput>>;
};


export type QueryClub_WorldFamilyClub_TempTwFcCrewMArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_TempTwFcCrewMFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_TempTwFcCrewMSortInput>>;
};


export type QueryClub_WorldFamilyClub_TempTwFcsongCrewArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_TempTwFcsongCrewFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_TempTwFcsongCrewSortInput>>;
};


export type QueryClub_WorldFamilyClub_TempTwFcsongMonthlyRecommendArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_TempTwFcsongMonthlyRecommendFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_TempTwFcsongMonthlyRecommendSortInput>>;
};


export type QueryClub_WorldFamilyClub_TempTwMyFavoriteArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_TempTwMyFavoriteFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_TempTwMyFavoriteSortInput>>;
};


export type QueryClub_WorldFamilyClub_TempTwTeSongArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_TempTwTeSongFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_TempTwTeSongSortInput>>;
};


export type QueryClub_WorldFamilyClub_TempTwTeSongForCapLevelArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_TempTwTeSongForCapLevelFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_TempTwTeSongForCapLevelSortInput>>;
};


export type QueryClub_WorldFamilyClub_TempWfcGraCArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_TempWfcGraCFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_TempWfcGraCSortInput>>;
};


export type QueryClub_WorldFamilyClub_TempWfcGraCOrganizedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_TempWfcGraCOrganizedFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_TempWfcGraCOrganizedSortInput>>;
};


export type QueryClub_WorldFamilyClub_TestUserAccountArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_TestUserAccountFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_TestUserAccountSortInput>>;
};


export type QueryClub_WorldFamilyClub_TestWaterArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_TestWaterFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_TestWaterSortInput>>;
};


export type QueryClub_WorldFamilyClub_TestWaterSubArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_TestWaterSubFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_TestWaterSubSortInput>>;
};


export type QueryClub_WorldFamilyClub_Tev2MonthlySongArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_Tev2MonthlySongFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_Tev2MonthlySongSortInput>>;
};


export type QueryClub_WorldFamilyClub_UserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_UserFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_UserSortInput>>;
};


export type QueryClub_WorldFamilyClub_VideoForTrialmodeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_VideoForTrialmodeFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_VideoForTrialmodeSortInput>>;
};


export type QueryClub_WorldFamilyClub_WfcLibraryFaqArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_WfcLibraryFaqFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_WfcLibraryFaqSortInput>>;
};


export type QueryClub_WorldFamilyClub_WfcLibraryLogArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_WfcLibraryLogFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_WfcLibraryLogSortInput>>;
};


export type QueryClub_WorldFamilyClub_WfcNowPageViewLogArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Club_WorldFamilyClub_WfcNowPageViewLogFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Club_WorldFamilyClub_WfcNowPageViewLogSortInput>>;
};


export type QueryDefaultServiceBannerListArgs = {
  filter?: InputMaybe<DefaultServiceBannerInfoFilterInput>;
  order?: InputMaybe<Array<DefaultServiceBannerInfoSortInput>>;
};


export type QueryEntryPackageOrderListArgs = {
  filter?: InputMaybe<EntryPackageOrderListResultFilterInput>;
  order?: InputMaybe<Array<EntryPackageOrderListResultSortInput>>;
  parameter: EntryPackageOrderListParameterInput;
};


export type QueryGoGoLiveLevelListArgs = {
  filter?: InputMaybe<GoGoLiveLevelInfoFilterInput>;
  order?: InputMaybe<Array<GoGoLiveLevelInfoSortInput>>;
};


export type QueryGoGoLiveParentGuideInfoArgs = {
  filter?: InputMaybe<GoGoLiveParentGuideDetailInfoFilterInput>;
  goGoLiveParentGuideId: Scalars['Int']['input'];
  order?: InputMaybe<Array<GoGoLiveParentGuideDetailInfoSortInput>>;
};


export type QueryGoGoLiveParentGuideListArgs = {
  filter?: InputMaybe<GoGoLiveParentGuideInfoFilterInput>;
  order?: InputMaybe<Array<GoGoLiveParentGuideInfoSortInput>>;
};


export type QueryGoGoLiveParentGuideLocaleListArgs = {
  filter?: InputMaybe<GoGoLiveParentGuideLocaleInfoFilterInput>;
  goGoLiveParentGuideId: Scalars['Int']['input'];
  order?: InputMaybe<Array<GoGoLiveParentGuideLocaleInfoSortInput>>;
};


export type QueryGoGoLiveSessionListArgs = {
  filter?: InputMaybe<GoGoLiveSessionInfoFilterInput>;
  order?: InputMaybe<Array<GoGoLiveSessionInfoSortInput>>;
};


export type QueryGoGoLiveSongListArgs = {
  filter?: InputMaybe<GoGoLiveSongInfoFilterInput>;
  order?: InputMaybe<Array<GoGoLiveSongInfoSortInput>>;
};


export type QueryGoGoLiveTalkAlongCardListArgs = {
  filter?: InputMaybe<TalkAlongCardInfoFilterInput>;
  order?: InputMaybe<Array<TalkAlongCardInfoSortInput>>;
};


export type QueryGoGoLiveToyListArgs = {
  filter?: InputMaybe<GoGoLiveToyInfoFilterInput>;
  order?: InputMaybe<Array<GoGoLiveToyInfoSortInput>>;
};


export type QueryKidsWorldVideoArgs = {
  filter?: InputMaybe<KidsWorldVideoInfoResultFilterInput>;
  kidsWorldVideoId: Scalars['Int']['input'];
  order?: InputMaybe<Array<KidsWorldVideoInfoResultSortInput>>;
};


export type QueryKidsWorldVideoListArgs = {
  filter?: InputMaybe<KidsWorldVideoInfoResultFilterInput>;
  order?: InputMaybe<Array<KidsWorldVideoInfoResultSortInput>>;
};


export type QueryLeadsReplySourceInformationArgs = {
  parameter: GetLeadsReplySourceInformationRequestInput;
};


export type QueryMarketListOfDefaultBannerArgs = {
  filter?: InputMaybe<BannerMarketInfoFilterInput>;
  order?: InputMaybe<Array<BannerMarketInfoSortInput>>;
};


export type QueryNodeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryPushNotificationButtonLinkListArgs = {
  filter?: InputMaybe<PushNotificationButtonLinkResultFilterInput>;
  market: Scalars['String']['input'];
  order?: InputMaybe<Array<PushNotificationButtonLinkResultSortInput>>;
};


export type QueryPushNotificationServiceTypeListArgs = {
  filter?: InputMaybe<PushNotificationServiceTypeResultFilterInput>;
  market: Scalars['String']['input'];
  order?: InputMaybe<Array<PushNotificationServiceTypeResultSortInput>>;
};


export type QuerySales188NotificationArgs = {
  filter?: InputMaybe<Sales188NotificationFilterInput>;
  order?: InputMaybe<Array<Sales188NotificationSortInput>>;
};


export type QuerySales188ReleaseArgs = {
  filter?: InputMaybe<Sales188ReleaseFilterInput>;
  order?: InputMaybe<Array<Sales188ReleaseSortInput>>;
};


export type QuerySalesProfileListArgs = {
  employeeId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SalesProfileInformationFilterInput>;
  order?: InputMaybe<Array<SalesProfileInformationSortInput>>;
};


export type QueryScheduledServiceBannerListArgs = {
  filter?: InputMaybe<ScheduledServiceBannerInfoFilterInput>;
  order?: InputMaybe<Array<ScheduledServiceBannerInfoSortInput>>;
};


export type QueryServiceListOfDefaultBannerArgs = {
  filter?: InputMaybe<BannerServiceInfoFilterInput>;
  order?: InputMaybe<Array<BannerServiceInfoSortInput>>;
};


export type QueryTestimonialInfoArgs = {
  filter?: InputMaybe<TestimonialInfoResponseFilterInput>;
  order?: InputMaybe<Array<TestimonialInfoResponseSortInput>>;
  testimonialId: Scalars['Int']['input'];
};


export type QueryTestimonialListArgs = {
  filter?: InputMaybe<TestimonialResponseFilterInput>;
  market: Scalars['String']['input'];
  order?: InputMaybe<Array<TestimonialResponseSortInput>>;
};


export type QueryTestimonialTagInfoArgs = {
  tagId: Scalars['Int']['input'];
};


export type QueryTestimonialTagListArgs = {
  filter?: InputMaybe<TagResponseFilterInput>;
  market: Scalars['String']['input'];
  order?: InputMaybe<Array<TagResponseSortInput>>;
};


export type QueryTev2MonthlySongInfoArgs = {
  filter?: InputMaybe<Tev2MonthlySongInfoFilterInput>;
  order?: InputMaybe<Array<Tev2MonthlySongInfoSortInput>>;
  seq: Scalars['Int']['input'];
};


export type QueryTev2MonthlySongListArgs = {
  filter?: InputMaybe<Tev2MonthlySongInfoFilterInput>;
  order?: InputMaybe<Array<Tev2MonthlySongInfoSortInput>>;
};


export type QueryTrialCampaignChannelArgs = {
  filter?: InputMaybe<TrialCampaignChannelFilterInput>;
  order?: InputMaybe<Array<TrialCampaignChannelSortInput>>;
};


export type QueryTrialCampaignChannelUrlArgs = {
  channel: Scalars['String']['input'];
  device: Scalars['String']['input'];
  filter?: InputMaybe<TrialCampaignChannelUrlFilterInput>;
  market: Scalars['String']['input'];
  order?: InputMaybe<Array<TrialCampaignChannelUrlSortInput>>;
};


export type QueryTrialModeAppAnnouncementBarArgs = {
  appAnnouncementBarId: Scalars['Int']['input'];
  filter?: InputMaybe<TrialModeAppAnnouncementBarResultFilterInput>;
  order?: InputMaybe<Array<TrialModeAppAnnouncementBarResultSortInput>>;
};


export type QueryTrialModeAppAnnouncementBarListArgs = {
  filter?: InputMaybe<TrialModeAppAnnouncementBarResultFilterInput>;
  order?: InputMaybe<Array<TrialModeAppAnnouncementBarResultSortInput>>;
};


export type QueryTrialModeLeadsNotificationArgs = {
  filter?: InputMaybe<Wf_TrialModeLeads_NotificationFilterInput>;
  order?: InputMaybe<Array<Wf_TrialModeLeads_NotificationSortInput>>;
};


export type QueryUpgradePaymentListArgs = {
  filter?: InputMaybe<MemberUpgradePaymentResponseFilterInput>;
  order?: InputMaybe<Array<MemberUpgradePaymentResponseSortInput>>;
  parameter: GetUpgradePaymentListParameterInput;
};


export type QueryWarrantyInfoListArgs = {
  parameter: WarrantyInfoListParameterInput;
};


export type QueryWarrantyListArgs = {
  parameter: WarrantyListParameterInput;
};


export type QueryWf_AdminFirst_AArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_AdminFirst_AFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_AdminFirst_ASortInput>>;
};


export type QueryWf_AdminFirst_AbArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_AdminFirst_AbFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_AdminFirst_AbSortInput>>;
};


export type QueryWf_AdminFirst_AfNotificationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_AdminFirst_AfNotificationFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_AdminFirst_AfNotificationSortInput>>;
};


export type QueryWf_AdminFirst_AfNotificationButtonLinkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_AdminFirst_AfNotificationButtonLinkFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_AdminFirst_AfNotificationButtonLinkSortInput>>;
};


export type QueryWf_AdminFirst_AfNotificationButtonLinkMarketArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_AdminFirst_AfNotificationButtonLinkMarketFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_AdminFirst_AfNotificationButtonLinkMarketSortInput>>;
};


export type QueryWf_AdminFirst_AfNotificationMemberArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_AdminFirst_AfNotificationMemberFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_AdminFirst_AfNotificationMemberSortInput>>;
};


export type QueryWf_AdminFirst_AfNotificationMemberLogArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_AdminFirst_AfNotificationMemberLogFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_AdminFirst_AfNotificationMemberLogSortInput>>;
};


export type QueryWf_AdminFirst_AfNotificationServiceTypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_AdminFirst_AfNotificationServiceTypeFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_AdminFirst_AfNotificationServiceTypeSortInput>>;
};


export type QueryWf_AdminFirst_AfNotificationServiceTypeMarketArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_AdminFirst_AfNotificationServiceTypeMarketFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_AdminFirst_AfNotificationServiceTypeMarketSortInput>>;
};


export type QueryWf_AdminFirst_AfProgramArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_AdminFirst_AfProgramFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_AdminFirst_AfProgramSortInput>>;
};


export type QueryWf_AdminFirst_AfServiceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_AdminFirst_AfServiceFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_AdminFirst_AfServiceSortInput>>;
};


export type QueryWf_AdminFirst_AfUserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_AdminFirst_AfUserFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_AdminFirst_AfUserSortInput>>;
};


export type QueryWf_AdminFirst_AfUserMarketArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_AdminFirst_AfUserMarketFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_AdminFirst_AfUserMarketSortInput>>;
};


export type QueryWf_AdminFirst_AfUserProgramArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_AdminFirst_AfUserProgramFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_AdminFirst_AfUserProgramSortInput>>;
};


export type QueryWf_AdminFirst_AfUserServiceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_AdminFirst_AfUserServiceFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_AdminFirst_AfUserServiceSortInput>>;
};


export type QueryWf_AdminFirst_ChildGraduationApplicationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_AdminFirst_ChildGraduationApplicationFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_AdminFirst_ChildGraduationApplicationSortInput>>;
};


export type QueryWf_AdminFirst_GraduationApplicationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_AdminFirst_GraduationApplicationFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_AdminFirst_GraduationApplicationSortInput>>;
};


export type QueryWf_AdminFirst_GraphqlAccessArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_AdminFirst_GraphqlAccessFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_AdminFirst_GraphqlAccessSortInput>>;
};


export type QueryWf_AdminFirst_GraphqlSchemaArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_AdminFirst_GraphqlSchemaFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_AdminFirst_GraphqlSchemaSortInput>>;
};


export type QueryWf_AdminFirst_TeamSettingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_AdminFirst_TeamSettingFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_AdminFirst_TeamSettingSortInput>>;
};


export type QueryWf_AdminFirst_TempFaceCallArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_AdminFirst_TempFaceCallFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_AdminFirst_TempFaceCallSortInput>>;
};


export type QueryWf_AdminFirst_TempPrepaidMembershipFeeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_AdminFirst_TempPrepaidMembershipFeeFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_AdminFirst_TempPrepaidMembershipFeeSortInput>>;
};


export type QueryWf_AdminFirst_TepsDailyHourArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_AdminFirst_TepsDailyHourFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_AdminFirst_TepsDailyHourSortInput>>;
};


export type QueryWf_AdminFirst_TepsDailyHourLocationTypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_AdminFirst_TepsDailyHourLocationTypeFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_AdminFirst_TepsDailyHourLocationTypeSortInput>>;
};


export type QueryWf_AdminFirst_TepsDailyHourTypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_AdminFirst_TepsDailyHourTypeFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_AdminFirst_TepsDailyHourTypeSortInput>>;
};


export type QueryWf_AdminFirst_TepsProjectArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_AdminFirst_TepsProjectFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_AdminFirst_TepsProjectSortInput>>;
};


export type QueryWf_AdminFirst_TepsProjectAllocatedTypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_AdminFirst_TepsProjectAllocatedTypeFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_AdminFirst_TepsProjectAllocatedTypeSortInput>>;
};


export type QueryWf_AdminFirst_TepsProjectTypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_AdminFirst_TepsProjectTypeFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_AdminFirst_TepsProjectTypeSortInput>>;
};


export type QueryWf_AdminFirst_TepsProjectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_AdminFirst_TepsProjectionFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_AdminFirst_TepsProjectionSortInput>>;
};


export type QueryWf_AdminFirst_TepsUserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_AdminFirst_TepsUserFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_AdminFirst_TepsUserSortInput>>;
};


export type QueryWf_AdminFirst_TepsUserProjectArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_AdminFirst_TepsUserProjectFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_AdminFirst_TepsUserProjectSortInput>>;
};


export type QueryWf_TrialModeLeads_AllParentTipArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_TrialModeLeads_AllParentTipFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_TrialModeLeads_AllParentTipSortInput>>;
};


export type QueryWf_TrialModeLeads_AppAnnouncementBarArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_TrialModeLeads_AppAnnouncementBarFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_TrialModeLeads_AppAnnouncementBarSortInput>>;
};


export type QueryWf_TrialModeLeads_AppAnnouncementBarMarketArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_TrialModeLeads_AppAnnouncementBarMarketFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_TrialModeLeads_AppAnnouncementBarMarketSortInput>>;
};


export type QueryWf_TrialModeLeads_AutoMailArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_TrialModeLeads_AutoMailFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_TrialModeLeads_AutoMailSortInput>>;
};


export type QueryWf_TrialModeLeads_CallToActionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_TrialModeLeads_CallToActionFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_TrialModeLeads_CallToActionSortInput>>;
};


export type QueryWf_TrialModeLeads_CallToActionContentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_TrialModeLeads_CallToActionContentFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_TrialModeLeads_CallToActionContentSortInput>>;
};


export type QueryWf_TrialModeLeads_CallToActionExperienceTypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_TrialModeLeads_CallToActionExperienceTypeFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_TrialModeLeads_CallToActionExperienceTypeSortInput>>;
};


export type QueryWf_TrialModeLeads_DesignImageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_TrialModeLeads_DesignImageFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_TrialModeLeads_DesignImageSortInput>>;
};


export type QueryWf_TrialModeLeads_FeaturedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_TrialModeLeads_FeaturedEventFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_TrialModeLeads_FeaturedEventSortInput>>;
};


export type QueryWf_TrialModeLeads_GraphqlAccessArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_TrialModeLeads_GraphqlAccessFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_TrialModeLeads_GraphqlAccessSortInput>>;
};


export type QueryWf_TrialModeLeads_GraphqlSchemaArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_TrialModeLeads_GraphqlSchemaFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_TrialModeLeads_GraphqlSchemaSortInput>>;
};


export type QueryWf_TrialModeLeads_InstallationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_TrialModeLeads_InstallationFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_TrialModeLeads_InstallationSortInput>>;
};


export type QueryWf_TrialModeLeads_InstallationLogArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_TrialModeLeads_InstallationLogFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_TrialModeLeads_InstallationLogSortInput>>;
};


export type QueryWf_TrialModeLeads_JourneyCardArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_TrialModeLeads_JourneyCardFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_TrialModeLeads_JourneyCardSortInput>>;
};


export type QueryWf_TrialModeLeads_JourneyExperienceTypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_TrialModeLeads_JourneyExperienceTypeFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_TrialModeLeads_JourneyExperienceTypeSortInput>>;
};


export type QueryWf_TrialModeLeads_NotificationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_TrialModeLeads_NotificationFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_TrialModeLeads_NotificationSortInput>>;
};


export type QueryWf_TrialModeLeads_NotificationChildArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_TrialModeLeads_NotificationChildFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_TrialModeLeads_NotificationChildSortInput>>;
};


export type QueryWf_TrialModeLeads_NotificationMemberArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_TrialModeLeads_NotificationMemberFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_TrialModeLeads_NotificationMemberSortInput>>;
};


export type QueryWf_TrialModeLeads_NotificationToChildAgeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_TrialModeLeads_NotificationToChildAgeFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_TrialModeLeads_NotificationToChildAgeSortInput>>;
};


export type QueryWf_TrialModeLeads_NotificationToSegmentationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_TrialModeLeads_NotificationToSegmentationFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_TrialModeLeads_NotificationToSegmentationSortInput>>;
};


export type QueryWf_TrialModeLeads_NotificationTypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_TrialModeLeads_NotificationTypeFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_TrialModeLeads_NotificationTypeSortInput>>;
};


export type QueryWf_TrialModeLeads_ParentTipArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_TrialModeLeads_ParentTipFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_TrialModeLeads_ParentTipSortInput>>;
};


export type QueryWf_TrialModeLeads_ProductCategoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_TrialModeLeads_ProductCategoryFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_TrialModeLeads_ProductCategorySortInput>>;
};


export type QueryWf_TrialModeLeads_ProductSongArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_TrialModeLeads_ProductSongFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_TrialModeLeads_ProductSongSortInput>>;
};


export type QueryWf_TrialModeLeads_ProductSongAndMarketArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_TrialModeLeads_ProductSongAndMarketFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_TrialModeLeads_ProductSongAndMarketSortInput>>;
};


export type QueryWf_TrialModeLeads_ProductVideoArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_TrialModeLeads_ProductVideoFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_TrialModeLeads_ProductVideoSortInput>>;
};


export type QueryWf_TrialModeLeads_ProductVideoAndMarketArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_TrialModeLeads_ProductVideoAndMarketFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_TrialModeLeads_ProductVideoAndMarketSortInput>>;
};


export type QueryWf_TrialModeLeads_RegularEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_TrialModeLeads_RegularEventFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_TrialModeLeads_RegularEventSortInput>>;
};


export type QueryWf_TrialModeLeads_TacoTestArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_TrialModeLeads_TacoTestFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_TrialModeLeads_TacoTestSortInput>>;
};


export type QueryWf_TrialModeLeads_TempProductVideoArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_TrialModeLeads_TempProductVideoFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_TrialModeLeads_TempProductVideoSortInput>>;
};


export type QueryWf_TrialModeLeads_TestimonialArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_TrialModeLeads_TestimonialFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_TrialModeLeads_TestimonialSortInput>>;
};


export type QueryWf_TrialModeLeads_TestimonialTagArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_TrialModeLeads_TestimonialTagFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_TrialModeLeads_TestimonialTagSortInput>>;
};


export type QueryWf_TrialModeLeads_TestimonialTagMappingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_TrialModeLeads_TestimonialTagMappingFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_TrialModeLeads_TestimonialTagMappingSortInput>>;
};


export type QueryWf_TrialModeLeads_TipArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_TrialModeLeads_TipFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_TrialModeLeads_TipSortInput>>;
};


export type QueryWf_TrialModeLeads_TrialCampaignUrlArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_TrialModeLeads_TrialCampaignUrlFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_TrialModeLeads_TrialCampaignUrlSortInput>>;
};


export type QueryWf_TrialModeLeads_TrialMailLogArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_TrialModeLeads_TrialMailLogFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_TrialModeLeads_TrialMailLogSortInput>>;
};


export type QueryWf_TrialModeLeads_TrialMailSettingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_TrialModeLeads_TrialMailSettingFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_TrialModeLeads_TrialMailSettingSortInput>>;
};


export type QueryWf_TrialModeLeads_TrialMessageSettingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_TrialModeLeads_TrialMessageSettingFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_TrialModeLeads_TrialMessageSettingSortInput>>;
};


export type QueryWf_TrialModeLeads_TrialOneTimeTokenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_TrialModeLeads_TrialOneTimeTokenFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_TrialModeLeads_TrialOneTimeTokenSortInput>>;
};


export type QueryWf_TrialModeLeads_TrialPushTypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_TrialModeLeads_TrialPushTypeFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_TrialModeLeads_TrialPushTypeSortInput>>;
};


export type QueryWf_TrialModeLeads_TrialSegmentationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_TrialModeLeads_TrialSegmentationFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_TrialModeLeads_TrialSegmentationSortInput>>;
};


export type QueryWf_TrialModeLeads_TrialSettingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_TrialModeLeads_TrialSettingFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_TrialModeLeads_TrialSettingSortInput>>;
};


export type QueryWf_TrialModeLeads_TrialTestPhoneArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_TrialModeLeads_TrialTestPhoneFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_TrialModeLeads_TrialTestPhoneSortInput>>;
};


export type QueryWf_TrialModeLeads_TrialTokenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_TrialModeLeads_TrialTokenFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_TrialModeLeads_TrialTokenSortInput>>;
};


export type QueryWf_TrialModeLeads_TrialTrackingLogArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_TrialModeLeads_TrialTrackingLogFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_TrialModeLeads_TrialTrackingLogSortInput>>;
};


export type QueryWf_TrialModeLeads_TrialUserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_TrialModeLeads_TrialUserFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_TrialModeLeads_TrialUserSortInput>>;
};


export type QueryWf_TrialModeLeads_TrialUserMessageLogArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_TrialModeLeads_TrialUserMessageLogFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_TrialModeLeads_TrialUserMessageLogSortInput>>;
};


export type QueryWf_TrialModeLeads_TrialUserNotificationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_TrialModeLeads_TrialUserNotificationFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_TrialModeLeads_TrialUserNotificationSortInput>>;
};


export type QueryWf_TrialModeLeads_TrialUserSegmentationLogArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Wf_TrialModeLeads_TrialUserSegmentationLogFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<Wf_TrialModeLeads_TrialUserSegmentationLogSortInput>>;
};

export type ResultResponse = {
  __typename?: 'ResultResponse';
  count: Scalars['Int']['output'];
  error?: Maybe<Scalars['String']['output']>;
};

export type Sales188Notification = {
  __typename?: 'Sales188Notification';
  createdTime: Scalars['DateTime']['output'];
  creator?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  jobStatus?: Maybe<Scalars['String']['output']>;
  market?: Maybe<Scalars['String']['output']>;
  mutationOperation?: Maybe<Scalars['String']['output']>;
  notificationId?: Maybe<Scalars['Int']['output']>;
  removeNotificationId?: Maybe<Scalars['Int']['output']>;
  scheduleTime?: Maybe<Scalars['DateTime']['output']>;
  sendingDepartment?: Maybe<Scalars['String']['output']>;
  target?: Maybe<Scalars['String']['output']>;
  templateMessage?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type Sales188NotificationFilterInput = {
  and?: InputMaybe<Array<Sales188NotificationFilterInput>>;
  createdTime?: InputMaybe<DateTimeOperationFilterInput>;
  creator?: InputMaybe<StringOperationFilterInput>;
  error?: InputMaybe<StringOperationFilterInput>;
  jobStatus?: InputMaybe<StringOperationFilterInput>;
  market?: InputMaybe<StringOperationFilterInput>;
  mutationOperation?: InputMaybe<StringOperationFilterInput>;
  notificationId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<Sales188NotificationFilterInput>>;
  removeNotificationId?: InputMaybe<IntOperationFilterInput>;
  scheduleTime?: InputMaybe<DateTimeOperationFilterInput>;
  sendingDepartment?: InputMaybe<StringOperationFilterInput>;
  target?: InputMaybe<StringOperationFilterInput>;
  templateMessage?: InputMaybe<StringOperationFilterInput>;
  title?: InputMaybe<StringOperationFilterInput>;
};

export type Sales188NotificationInput = {
  createdTime: Scalars['DateTime']['input'];
  creator?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  jobStatus?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Scalars['String']['input']>;
  mutationOperation?: InputMaybe<Scalars['String']['input']>;
  notificationId?: InputMaybe<Scalars['Int']['input']>;
  removeNotificationId?: InputMaybe<Scalars['Int']['input']>;
  scheduleTime?: InputMaybe<Scalars['DateTime']['input']>;
  sendingDepartment?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<Scalars['String']['input']>;
  templateMessage?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Sales188NotificationSortInput = {
  createdTime?: InputMaybe<SortEnumType>;
  creator?: InputMaybe<SortEnumType>;
  error?: InputMaybe<SortEnumType>;
  jobStatus?: InputMaybe<SortEnumType>;
  market?: InputMaybe<SortEnumType>;
  mutationOperation?: InputMaybe<SortEnumType>;
  notificationId?: InputMaybe<SortEnumType>;
  removeNotificationId?: InputMaybe<SortEnumType>;
  scheduleTime?: InputMaybe<SortEnumType>;
  sendingDepartment?: InputMaybe<SortEnumType>;
  target?: InputMaybe<SortEnumType>;
  templateMessage?: InputMaybe<SortEnumType>;
  title?: InputMaybe<SortEnumType>;
};

export type Sales188Release = {
  __typename?: 'Sales188Release';
  appVersion?: Maybe<Scalars['String']['output']>;
  appstore?: Maybe<Scalars['String']['output']>;
  osVersion?: Maybe<Scalars['String']['output']>;
  releaseTime: Scalars['DateTime']['output'];
  seq: Scalars['Short']['output'];
  version?: Maybe<Scalars['String']['output']>;
};

export type Sales188ReleaseFilterInput = {
  and?: InputMaybe<Array<Sales188ReleaseFilterInput>>;
  appVersion?: InputMaybe<StringOperationFilterInput>;
  appstore?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Sales188ReleaseFilterInput>>;
  osVersion?: InputMaybe<StringOperationFilterInput>;
  releaseTime?: InputMaybe<DateTimeOperationFilterInput>;
  seq?: InputMaybe<ShortOperationFilterInput>;
  version?: InputMaybe<StringOperationFilterInput>;
};

export type Sales188ReleaseSortInput = {
  appVersion?: InputMaybe<SortEnumType>;
  appstore?: InputMaybe<SortEnumType>;
  osVersion?: InputMaybe<SortEnumType>;
  releaseTime?: InputMaybe<SortEnumType>;
  seq?: InputMaybe<SortEnumType>;
  version?: InputMaybe<SortEnumType>;
};

export type SalesProfileInformation = {
  __typename?: 'SalesProfileInformation';
  /** Employee id */
  employeeId: Scalars['String']['output'];
  /** HQLM url */
  hqlmUrl: Scalars['String']['output'];
  /** I talk extension */
  iTalkExtension: Scalars['String']['output'];
};

export type SalesProfileInformationFilterInput = {
  and?: InputMaybe<Array<SalesProfileInformationFilterInput>>;
  /** Employee id */
  employeeId?: InputMaybe<StringOperationFilterInput>;
  /** HQLM url */
  hqlmUrl?: InputMaybe<StringOperationFilterInput>;
  /** I talk extension */
  iTalkExtension?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SalesProfileInformationFilterInput>>;
};

export type SalesProfileInformationInput = {
  /** Employee id */
  employeeId: Scalars['String']['input'];
  /** HQLM url */
  hqlmUrl: Scalars['String']['input'];
  /** I talk extension */
  iTalkExtension: Scalars['String']['input'];
};

export type SalesProfileInformationSortInput = {
  /** Employee id */
  employeeId?: InputMaybe<SortEnumType>;
  /** HQLM url */
  hqlmUrl?: InputMaybe<SortEnumType>;
  /** I talk extension */
  iTalkExtension?: InputMaybe<SortEnumType>;
};

export type ScheduledServiceBannerInfo = {
  __typename?: 'ScheduledServiceBannerInfo';
  image: Scalars['String']['output'];
  /** Is Holiday Surprise Banner */
  isHolidaySurpriseBanner: Scalars['Boolean']['output'];
  markets: Array<Scalars['String']['output']>;
  /** yyyy-MM-dd */
  publishDate?: Maybe<Scalars['String']['output']>;
  seqs: Array<Scalars['Int']['output']>;
  service: Scalars['String']['output'];
  /** In use / Not in use */
  status: Scalars['String']['output'];
  /** yyyy-MM-dd */
  stopDate?: Maybe<Scalars['String']['output']>;
};

export type ScheduledServiceBannerInfoFilterInput = {
  and?: InputMaybe<Array<ScheduledServiceBannerInfoFilterInput>>;
  image?: InputMaybe<StringOperationFilterInput>;
  /** Is Holiday Surprise Banner */
  isHolidaySurpriseBanner?: InputMaybe<BooleanOperationFilterInput>;
  markets?: InputMaybe<ListStringOperationFilterInput>;
  or?: InputMaybe<Array<ScheduledServiceBannerInfoFilterInput>>;
  /** yyyy-MM-dd */
  publishDate?: InputMaybe<StringOperationFilterInput>;
  seqs?: InputMaybe<ListIntOperationFilterInput>;
  service?: InputMaybe<StringOperationFilterInput>;
  /** In use / Not in use */
  status?: InputMaybe<StringOperationFilterInput>;
  /** yyyy-MM-dd */
  stopDate?: InputMaybe<StringOperationFilterInput>;
};

export type ScheduledServiceBannerInfoSortInput = {
  image?: InputMaybe<SortEnumType>;
  /** Is Holiday Surprise Banner */
  isHolidaySurpriseBanner?: InputMaybe<SortEnumType>;
  /** yyyy-MM-dd */
  publishDate?: InputMaybe<SortEnumType>;
  service?: InputMaybe<SortEnumType>;
  /** In use / Not in use */
  status?: InputMaybe<SortEnumType>;
  /** yyyy-MM-dd */
  stopDate?: InputMaybe<SortEnumType>;
};

export type ScheduledServiceBannerParameterInput = {
  image: Scalars['String']['input'];
  /** Is Holiday Surprise Banner */
  isHolidaySurpriseBanner: Scalars['Boolean']['input'];
  markets: Array<Scalars['String']['input']>;
  /** yyyy-MM-dd */
  publishDate?: InputMaybe<Scalars['String']['input']>;
  seqs?: InputMaybe<Array<Scalars['Int']['input']>>;
  service: Scalars['String']['input'];
  /** yyyy-MM-dd */
  stopDate?: InputMaybe<Scalars['String']['input']>;
};

export type ShortOperationFilterInput = {
  eq?: InputMaybe<Scalars['Short']['input']>;
  gt?: InputMaybe<Scalars['Short']['input']>;
  gte?: InputMaybe<Scalars['Short']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Short']['input']>>>;
  lt?: InputMaybe<Scalars['Short']['input']>;
  lte?: InputMaybe<Scalars['Short']['input']>;
  neq?: InputMaybe<Scalars['Short']['input']>;
  ngt?: InputMaybe<Scalars['Short']['input']>;
  ngte?: InputMaybe<Scalars['Short']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Short']['input']>>>;
  nlt?: InputMaybe<Scalars['Short']['input']>;
  nlte?: InputMaybe<Scalars['Short']['input']>;
};

export enum SortEnumType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StringOperationFilterInput = {
  and?: InputMaybe<Array<StringOperationFilterInput>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ncontains?: InputMaybe<Scalars['String']['input']>;
  nendsWith?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nstartsWith?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<StringOperationFilterInput>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type TagRequestInput = {
  isUsed?: InputMaybe<Scalars['Boolean']['input']>;
  market: Scalars['String']['input'];
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  tagId?: InputMaybe<Scalars['Int']['input']>;
  tagName: Scalars['String']['input'];
};

export type TagResponse = {
  __typename?: 'TagResponse';
  isUsed: Scalars['Boolean']['output'];
  market: Scalars['String']['output'];
  numberOfVideos: Scalars['Int']['output'];
  sortOrder: Scalars['Int']['output'];
  tagId: Scalars['Int']['output'];
  tagName: Scalars['String']['output'];
};

export type TagResponseFilterInput = {
  and?: InputMaybe<Array<TagResponseFilterInput>>;
  isUsed?: InputMaybe<BooleanOperationFilterInput>;
  market?: InputMaybe<StringOperationFilterInput>;
  numberOfVideos?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<TagResponseFilterInput>>;
  sortOrder?: InputMaybe<IntOperationFilterInput>;
  tagId?: InputMaybe<IntOperationFilterInput>;
  tagName?: InputMaybe<StringOperationFilterInput>;
};

export type TagResponseSortInput = {
  isUsed?: InputMaybe<SortEnumType>;
  market?: InputMaybe<SortEnumType>;
  numberOfVideos?: InputMaybe<SortEnumType>;
  sortOrder?: InputMaybe<SortEnumType>;
  tagId?: InputMaybe<SortEnumType>;
  tagName?: InputMaybe<SortEnumType>;
};

export type TalkAlongCardInfo = {
  __typename?: 'TalkAlongCardInfo';
  cardNumber?: Maybe<Scalars['String']['output']>;
  talkAlongCardId: Scalars['Int']['output'];
  word?: Maybe<Scalars['String']['output']>;
};

export type TalkAlongCardInfoFilterInput = {
  and?: InputMaybe<Array<TalkAlongCardInfoFilterInput>>;
  cardNumber?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TalkAlongCardInfoFilterInput>>;
  talkAlongCardId?: InputMaybe<IntOperationFilterInput>;
  word?: InputMaybe<StringOperationFilterInput>;
};

export type TalkAlongCardInfoInput = {
  cardNumber?: InputMaybe<Scalars['String']['input']>;
  talkAlongCardId: Scalars['Int']['input'];
  word?: InputMaybe<Scalars['String']['input']>;
};

export type TalkAlongCardInfoSortInput = {
  cardNumber?: InputMaybe<SortEnumType>;
  talkAlongCardId?: InputMaybe<SortEnumType>;
  word?: InputMaybe<SortEnumType>;
};

export type TestimonialInfoResponse = {
  __typename?: 'TestimonialInfoResponse';
  createdBy: Scalars['String']['output'];
  market: Scalars['String']['output'];
  publishDate?: Maybe<Scalars['String']['output']>;
  stopDate?: Maybe<Scalars['String']['output']>;
  tags: Array<TestimonialInfoTagResponse>;
  testimonialId?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
  updatedBy: Scalars['String']['output'];
  videoFileName: Scalars['String']['output'];
  videoThumbnailFileName: Scalars['String']['output'];
};

export type TestimonialInfoResponseFilterInput = {
  and?: InputMaybe<Array<TestimonialInfoResponseFilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  market?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TestimonialInfoResponseFilterInput>>;
  publishDate?: InputMaybe<StringOperationFilterInput>;
  stopDate?: InputMaybe<StringOperationFilterInput>;
  tags?: InputMaybe<ListFilterInputTypeOfTestimonialInfoTagResponseFilterInput>;
  testimonialId?: InputMaybe<IntOperationFilterInput>;
  title?: InputMaybe<StringOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
  videoFileName?: InputMaybe<StringOperationFilterInput>;
  videoThumbnailFileName?: InputMaybe<StringOperationFilterInput>;
};

export type TestimonialInfoResponseSortInput = {
  createdBy?: InputMaybe<SortEnumType>;
  market?: InputMaybe<SortEnumType>;
  publishDate?: InputMaybe<SortEnumType>;
  stopDate?: InputMaybe<SortEnumType>;
  testimonialId?: InputMaybe<SortEnumType>;
  title?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
  videoFileName?: InputMaybe<SortEnumType>;
  videoThumbnailFileName?: InputMaybe<SortEnumType>;
};

export type TestimonialInfoTagResponse = {
  __typename?: 'TestimonialInfoTagResponse';
  tagId: Scalars['Int']['output'];
  tagName: Scalars['String']['output'];
};

export type TestimonialInfoTagResponseFilterInput = {
  and?: InputMaybe<Array<TestimonialInfoTagResponseFilterInput>>;
  or?: InputMaybe<Array<TestimonialInfoTagResponseFilterInput>>;
  tagId?: InputMaybe<IntOperationFilterInput>;
  tagName?: InputMaybe<StringOperationFilterInput>;
};

export type TestimonialRequestInput = {
  createdBy?: InputMaybe<Scalars['String']['input']>;
  market: Scalars['String']['input'];
  pubshingDate?: InputMaybe<Scalars['String']['input']>;
  stopDate?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['Int']['input']>>;
  testimonialId?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  videoFileName: Scalars['String']['input'];
  videoThumbnailFileName: Scalars['String']['input'];
};

export type TestimonialResponse = {
  __typename?: 'TestimonialResponse';
  createdBy: Scalars['String']['output'];
  isInUse: Scalars['Boolean']['output'];
  market: Scalars['String']['output'];
  publishDate?: Maybe<Scalars['String']['output']>;
  stopDate?: Maybe<Scalars['String']['output']>;
  tags: Scalars['String']['output'];
  testimonialId?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
  updatedBy: Scalars['String']['output'];
  videoFileName: Scalars['String']['output'];
  videoThumbnailFileName: Scalars['String']['output'];
};

export type TestimonialResponseFilterInput = {
  and?: InputMaybe<Array<TestimonialResponseFilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  isInUse?: InputMaybe<BooleanOperationFilterInput>;
  market?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TestimonialResponseFilterInput>>;
  publishDate?: InputMaybe<StringOperationFilterInput>;
  stopDate?: InputMaybe<StringOperationFilterInput>;
  tags?: InputMaybe<StringOperationFilterInput>;
  testimonialId?: InputMaybe<IntOperationFilterInput>;
  title?: InputMaybe<StringOperationFilterInput>;
  updatedBy?: InputMaybe<StringOperationFilterInput>;
  videoFileName?: InputMaybe<StringOperationFilterInput>;
  videoThumbnailFileName?: InputMaybe<StringOperationFilterInput>;
};

export type TestimonialResponseSortInput = {
  createdBy?: InputMaybe<SortEnumType>;
  isInUse?: InputMaybe<SortEnumType>;
  market?: InputMaybe<SortEnumType>;
  publishDate?: InputMaybe<SortEnumType>;
  stopDate?: InputMaybe<SortEnumType>;
  tags?: InputMaybe<SortEnumType>;
  testimonialId?: InputMaybe<SortEnumType>;
  title?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
  videoFileName?: InputMaybe<SortEnumType>;
  videoThumbnailFileName?: InputMaybe<SortEnumType>;
};

export type Tev2MonthlySongInfo = {
  __typename?: 'Tev2MonthlySongInfo';
  introductionBanner: Scalars['String']['output'];
  month: Scalars['Int']['output'];
  seq?: Maybe<Scalars['Int']['output']>;
  tev2Banner: Scalars['String']['output'];
  tev2SongId: Scalars['String']['output'];
  vimeoId: Scalars['String']['output'];
  year: Scalars['Int']['output'];
};

export type Tev2MonthlySongInfoFilterInput = {
  and?: InputMaybe<Array<Tev2MonthlySongInfoFilterInput>>;
  introductionBanner?: InputMaybe<StringOperationFilterInput>;
  month?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<Tev2MonthlySongInfoFilterInput>>;
  seq?: InputMaybe<IntOperationFilterInput>;
  tev2Banner?: InputMaybe<StringOperationFilterInput>;
  tev2SongId?: InputMaybe<StringOperationFilterInput>;
  vimeoId?: InputMaybe<StringOperationFilterInput>;
  year?: InputMaybe<IntOperationFilterInput>;
};

export type Tev2MonthlySongInfoInput = {
  introductionBanner: Scalars['String']['input'];
  month: Scalars['Int']['input'];
  seq?: InputMaybe<Scalars['Int']['input']>;
  tev2Banner: Scalars['String']['input'];
  tev2SongId: Scalars['String']['input'];
  vimeoId: Scalars['String']['input'];
  year: Scalars['Int']['input'];
};

export type Tev2MonthlySongInfoSortInput = {
  introductionBanner?: InputMaybe<SortEnumType>;
  month?: InputMaybe<SortEnumType>;
  seq?: InputMaybe<SortEnumType>;
  tev2Banner?: InputMaybe<SortEnumType>;
  tev2SongId?: InputMaybe<SortEnumType>;
  vimeoId?: InputMaybe<SortEnumType>;
  year?: InputMaybe<SortEnumType>;
};

export type TrialCampaignChannel = {
  __typename?: 'TrialCampaignChannel';
  channel?: Maybe<Scalars['String']['output']>;
};

export type TrialCampaignChannelFilterInput = {
  and?: InputMaybe<Array<TrialCampaignChannelFilterInput>>;
  channel?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TrialCampaignChannelFilterInput>>;
};

export type TrialCampaignChannelSortInput = {
  channel?: InputMaybe<SortEnumType>;
};

export type TrialCampaignChannelUrl = {
  __typename?: 'TrialCampaignChannelUrl';
  url?: Maybe<Scalars['String']['output']>;
};

export type TrialCampaignChannelUrlFilterInput = {
  and?: InputMaybe<Array<TrialCampaignChannelUrlFilterInput>>;
  or?: InputMaybe<Array<TrialCampaignChannelUrlFilterInput>>;
  url?: InputMaybe<StringOperationFilterInput>;
};

export type TrialCampaignChannelUrlSortInput = {
  url?: InputMaybe<SortEnumType>;
};

export type TrialModeAppAnnouncementBarAddParameterInput = {
  imageUrl: Scalars['String']['input'];
  markets: Array<Scalars['String']['input']>;
  navigationType: Scalars['String']['input'];
  navigationUrl: Scalars['String']['input'];
  publishTime: Scalars['DateTime']['input'];
  stopTime: Scalars['DateTime']['input'];
};

export type TrialModeAppAnnouncementBarResult = {
  __typename?: 'TrialModeAppAnnouncementBarResult';
  appAnnouncementBarId: Scalars['Int']['output'];
  imageUrl: Scalars['String']['output'];
  isInUse: Scalars['Boolean']['output'];
  markets: Array<Scalars['String']['output']>;
  navigationType: Scalars['String']['output'];
  navigationUrl: Scalars['String']['output'];
  publishTime: Scalars['DateTime']['output'];
  stopTime: Scalars['DateTime']['output'];
};

export type TrialModeAppAnnouncementBarResultFilterInput = {
  and?: InputMaybe<Array<TrialModeAppAnnouncementBarResultFilterInput>>;
  appAnnouncementBarId?: InputMaybe<IntOperationFilterInput>;
  imageUrl?: InputMaybe<StringOperationFilterInput>;
  isInUse?: InputMaybe<BooleanOperationFilterInput>;
  markets?: InputMaybe<ListStringOperationFilterInput>;
  navigationType?: InputMaybe<StringOperationFilterInput>;
  navigationUrl?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TrialModeAppAnnouncementBarResultFilterInput>>;
  publishTime?: InputMaybe<DateTimeOperationFilterInput>;
  stopTime?: InputMaybe<DateTimeOperationFilterInput>;
};

export type TrialModeAppAnnouncementBarResultSortInput = {
  appAnnouncementBarId?: InputMaybe<SortEnumType>;
  imageUrl?: InputMaybe<SortEnumType>;
  isInUse?: InputMaybe<SortEnumType>;
  navigationType?: InputMaybe<SortEnumType>;
  navigationUrl?: InputMaybe<SortEnumType>;
  publishTime?: InputMaybe<SortEnumType>;
  stopTime?: InputMaybe<SortEnumType>;
};

export type TrialModeAppAnnouncementBarUpdateParameterInput = {
  appAnnouncementBarId: Scalars['Int']['input'];
  imageUrl: Scalars['String']['input'];
  markets: Array<Scalars['String']['input']>;
  navigationType: Scalars['String']['input'];
  navigationUrl: Scalars['String']['input'];
  publishTime: Scalars['DateTime']['input'];
  stopTime: Scalars['DateTime']['input'];
};

export type TrialModeMemberInput = {
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type TrialModeNotificationInput = {
  actionButton?: InputMaybe<Scalars['String']['input']>;
  buttonLinksTo?: InputMaybe<Scalars['String']['input']>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  createdTime?: InputMaybe<Scalars['DateTime']['input']>;
  creator?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageFileName?: InputMaybe<Scalars['String']['input']>;
  jobStatus?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Scalars['String']['input']>;
  mutationOperation?: InputMaybe<Scalars['String']['input']>;
  notificationId?: InputMaybe<Scalars['Int']['input']>;
  notificationType?: InputMaybe<TrialModeNotificationTypeInput>;
  notificationTypeId?: InputMaybe<Scalars['String']['input']>;
  removeNotificationId?: InputMaybe<Scalars['Int']['input']>;
  scheduleTime?: InputMaybe<Scalars['DateTime']['input']>;
  segmentation?: InputMaybe<Scalars['String']['input']>;
  templateMessage?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TrialModeNotificationTypeInput = {
  id: Scalars['String']['input'];
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  notificationName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGoGoLiveParentGuideLocaleRequestInput = {
  goGoLiveParentGuideLocaleId: Scalars['Int']['input'];
  introduction?: InputMaybe<Scalars['String']['input']>;
  learningGoals?: InputMaybe<Array<Scalars['String']['input']>>;
  showAndTell?: InputMaybe<Scalars['String']['input']>;
  user: Scalars['String']['input'];
};

export type UpdateGoGoLiveParentGuideRequestInput = {
  bookPage?: InputMaybe<Scalars['String']['input']>;
  goGoLiveParentGuideId: Scalars['Int']['input'];
  introduction: Scalars['String']['input'];
  isNotifyTeams?: InputMaybe<Scalars['Boolean']['input']>;
  languagePoint: Scalars['String']['input'];
  learningGoals: Array<Scalars['String']['input']>;
  lessonTitle: Scalars['String']['input'];
  previewVideoCoverImageFileName: Scalars['String']['input'];
  previewVideoVimeoId?: InputMaybe<Scalars['String']['input']>;
  printableSheet?: InputMaybe<Scalars['String']['input']>;
  sessions: Array<GoGoLiveSessionInfoInput>;
  showAndTell?: InputMaybe<Scalars['String']['input']>;
  songList: Array<GoGoLiveParentGuideSongInfoInput>;
  toys?: InputMaybe<Array<GoGoLiveToyInfoInput>>;
  user: Scalars['String']['input'];
  wordList: Array<TalkAlongCardInfoInput>;
};

export type UpdateLeadsReplySourceInformationRequestInput = {
  assignId: Scalars['Int']['input'];
  leadsNumber: Scalars['String']['input'];
  newSourceCode: Scalars['String']['input'];
  sourceId: Scalars['Int']['input'];
};

export type UploadPayload = {
  __typename?: 'UploadPayload';
  count: Scalars['Int']['output'];
  query: Query;
};

export type UuidOperationFilterInput = {
  eq?: InputMaybe<Scalars['UUID']['input']>;
  gt?: InputMaybe<Scalars['UUID']['input']>;
  gte?: InputMaybe<Scalars['UUID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  lt?: InputMaybe<Scalars['UUID']['input']>;
  lte?: InputMaybe<Scalars['UUID']['input']>;
  neq?: InputMaybe<Scalars['UUID']['input']>;
  ngt?: InputMaybe<Scalars['UUID']['input']>;
  ngte?: InputMaybe<Scalars['UUID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  nlt?: InputMaybe<Scalars['UUID']['input']>;
  nlte?: InputMaybe<Scalars['UUID']['input']>;
};

/** A */
export type Wf_AdminFirst_A = Node & {
  __typename?: 'WF_AdminFirst_A';
  /** A1 */
  a1?: Maybe<Scalars['String']['output']>;
  /** [COLLECTION] Abs */
  abs?: Maybe<Array<Maybe<Wf_AdminFirst_Ab>>>;
  /** [ID] AId */
  id: Scalars['ID']['output'];
  /** Text */
  text?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Wf_AdminFirst_AConnection = {
  __typename?: 'WF_AdminFirst_AConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_AdminFirst_AEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_AdminFirst_A>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_AdminFirst_AEdge = {
  __typename?: 'WF_AdminFirst_AEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_AdminFirst_A;
};

/** A */
export type Wf_AdminFirst_AFilterInput = {
  /** A1 */
  a1?: InputMaybe<StringOperationFilterInput>;
  /** [ID] AId */
  aId?: InputMaybe<IntOperationFilterInput>;
  /** [COLLECTION] Abs */
  abs?: InputMaybe<ListFilterInputTypeOfWf_AdminFirst_AbFilterInput>;
  and?: InputMaybe<Array<Wf_AdminFirst_AFilterInput>>;
  or?: InputMaybe<Array<Wf_AdminFirst_AFilterInput>>;
  /** Text */
  text?: InputMaybe<StringOperationFilterInput>;
};

/** A */
export type Wf_AdminFirst_AInput = {
  /** A1 */
  a1?: InputMaybe<Scalars['String']['input']>;
  /** [ID] AId */
  aId?: InputMaybe<Scalars['Int']['input']>;
  /** [COLLECTION] Abs */
  abs?: InputMaybe<Array<InputMaybe<Wf_AdminFirst_AbInput>>>;
  /** Text */
  text?: InputMaybe<Scalars['String']['input']>;
};

/** A */
export type Wf_AdminFirst_ASortInput = {
  /** A1 */
  a1?: InputMaybe<SortEnumType>;
  /** [ID] AId */
  aId?: InputMaybe<SortEnumType>;
  /** Text */
  text?: InputMaybe<SortEnumType>;
};

/** Ab */
export type Wf_AdminFirst_Ab = Node & {
  __typename?: 'WF_AdminFirst_Ab';
  /** [NOT NULL] AId */
  aId?: Maybe<Scalars['Int']['output']>;
  /** [NAVIGATION] AIdNavigation */
  aIdNavigation?: Maybe<Wf_AdminFirst_A>;
  /** [ID] AbId */
  id: Scalars['ID']['output'];
  /** Text */
  text?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Wf_AdminFirst_AbConnection = {
  __typename?: 'WF_AdminFirst_AbConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_AdminFirst_AbEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_AdminFirst_Ab>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_AdminFirst_AbEdge = {
  __typename?: 'WF_AdminFirst_AbEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_AdminFirst_Ab;
};

/** Ab */
export type Wf_AdminFirst_AbFilterInput = {
  /** [NOT NULL] AId */
  aId?: InputMaybe<IntOperationFilterInput>;
  /** [NAVIGATION] AIdNavigation */
  aIdNavigation?: InputMaybe<Wf_AdminFirst_AFilterInput>;
  /** [ID] AbId */
  abId?: InputMaybe<IntOperationFilterInput>;
  and?: InputMaybe<Array<Wf_AdminFirst_AbFilterInput>>;
  or?: InputMaybe<Array<Wf_AdminFirst_AbFilterInput>>;
  /** Text */
  text?: InputMaybe<StringOperationFilterInput>;
};

/** Ab */
export type Wf_AdminFirst_AbInput = {
  /** [NOT NULL] AId */
  aId?: InputMaybe<Scalars['Int']['input']>;
  /** [NAVIGATION] AIdNavigation */
  aIdNavigation?: InputMaybe<Wf_AdminFirst_AInput>;
  /** [ID] AbId */
  abId?: InputMaybe<Scalars['Int']['input']>;
  /** Text */
  text?: InputMaybe<Scalars['String']['input']>;
};

/** Ab */
export type Wf_AdminFirst_AbSortInput = {
  /** [NOT NULL] AId */
  aId?: InputMaybe<SortEnumType>;
  /** [NAVIGATION] AIdNavigation */
  aIdNavigation?: InputMaybe<Wf_AdminFirst_ASortInput>;
  /** [ID] AbId */
  abId?: InputMaybe<SortEnumType>;
  /** Text */
  text?: InputMaybe<SortEnumType>;
};

/** AfNotification */
export type Wf_AdminFirst_AfNotification = Node & {
  __typename?: 'WF_AdminFirst_AfNotification';
  /** ActionButton */
  actionButton?: Maybe<Scalars['String']['output']>;
  /** [COLLECTION] AfNotificationMemberLogs */
  afNotificationMemberLogs?: Maybe<Array<Maybe<Wf_AdminFirst_AfNotificationMemberLog>>>;
  /** AfNotificationServiceTypeId */
  afNotificationServiceTypeId?: Maybe<Scalars['String']['output']>;
  /** ButtonLinksTo */
  buttonLinksTo?: Maybe<Scalars['String']['output']>;
  /** ButtonText */
  buttonText?: Maybe<Scalars['String']['output']>;
  /** CreatedTime */
  createdTime?: Maybe<Scalars['DateTime']['output']>;
  /** Creator */
  creator?: Maybe<Scalars['String']['output']>;
  /** Error */
  error?: Maybe<Scalars['String']['output']>;
  /** ExcelFileName */
  excelFileName?: Maybe<Scalars['String']['output']>;
  /** [ID] AfNotificationId */
  id: Scalars['ID']['output'];
  /** ImageFileName */
  imageFileName?: Maybe<Scalars['String']['output']>;
  /** IsAllMembers */
  isAllMembers?: Maybe<Scalars['Boolean']['output']>;
  /** [NOT NULL] IsRegular */
  isRegular?: Maybe<Scalars['Boolean']['output']>;
  /** [NOT NULL] IsTestNotification */
  isTestNotification?: Maybe<Scalars['Boolean']['output']>;
  /** JobStatus */
  jobStatus?: Maybe<Scalars['String']['output']>;
  /** Market */
  market?: Maybe<Scalars['String']['output']>;
  /** MutationOperation */
  mutationOperation?: Maybe<Scalars['String']['output']>;
  /** RecipientSourceType */
  recipientSourceType?: Maybe<Scalars['String']['output']>;
  /** RemoveAfNotificationId */
  removeAfNotificationId?: Maybe<Scalars['Int']['output']>;
  /** ScheduleTime */
  scheduleTime?: Maybe<Scalars['DateTime']['output']>;
  /** TemplateMessage */
  templateMessage?: Maybe<Scalars['String']['output']>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
};

/** AfNotificationButtonLink */
export type Wf_AdminFirst_AfNotificationButtonLink = Node & {
  __typename?: 'WF_AdminFirst_AfNotificationButtonLink';
  /** [NOT NULL] ButtonLinkName */
  buttonLinkName?: Maybe<Scalars['String']['output']>;
  /** [ID] AfNotificationButtonLinkId */
  id: Scalars['ID']['output'];
};

/** A connection to a list of items. */
export type Wf_AdminFirst_AfNotificationButtonLinkConnection = {
  __typename?: 'WF_AdminFirst_AfNotificationButtonLinkConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_AdminFirst_AfNotificationButtonLinkEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_AdminFirst_AfNotificationButtonLink>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_AdminFirst_AfNotificationButtonLinkEdge = {
  __typename?: 'WF_AdminFirst_AfNotificationButtonLinkEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_AdminFirst_AfNotificationButtonLink;
};

/** AfNotificationButtonLink */
export type Wf_AdminFirst_AfNotificationButtonLinkFilterInput = {
  /** [ID] AfNotificationButtonLinkId */
  afNotificationButtonLinkId?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<Wf_AdminFirst_AfNotificationButtonLinkFilterInput>>;
  /** [NOT NULL] ButtonLinkName */
  buttonLinkName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Wf_AdminFirst_AfNotificationButtonLinkFilterInput>>;
};

/** AfNotificationButtonLink */
export type Wf_AdminFirst_AfNotificationButtonLinkInput = {
  /** [ID] AfNotificationButtonLinkId */
  afNotificationButtonLinkId?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] ButtonLinkName */
  buttonLinkName?: InputMaybe<Scalars['String']['input']>;
};

/** AfNotificationButtonLinkMarket */
export type Wf_AdminFirst_AfNotificationButtonLinkMarket = Node & {
  __typename?: 'WF_AdminFirst_AfNotificationButtonLinkMarket';
  /** [NOT NULL] AfNotificationButtonLinkId */
  afNotificationButtonLinkId?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] ButtonLinkName */
  buttonLinkName?: Maybe<Scalars['String']['output']>;
  /** [ID] AfNotificationButtonLinkMarketId */
  id: Scalars['ID']['output'];
  /** [NOT NULL] Market */
  market?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] SortOrder */
  sortOrder?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of items. */
export type Wf_AdminFirst_AfNotificationButtonLinkMarketConnection = {
  __typename?: 'WF_AdminFirst_AfNotificationButtonLinkMarketConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_AdminFirst_AfNotificationButtonLinkMarketEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_AdminFirst_AfNotificationButtonLinkMarket>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_AdminFirst_AfNotificationButtonLinkMarketEdge = {
  __typename?: 'WF_AdminFirst_AfNotificationButtonLinkMarketEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_AdminFirst_AfNotificationButtonLinkMarket;
};

/** AfNotificationButtonLinkMarket */
export type Wf_AdminFirst_AfNotificationButtonLinkMarketFilterInput = {
  /** [NOT NULL] AfNotificationButtonLinkId */
  afNotificationButtonLinkId?: InputMaybe<StringOperationFilterInput>;
  /** [ID] AfNotificationButtonLinkMarketId */
  afNotificationButtonLinkMarketId?: InputMaybe<IntOperationFilterInput>;
  and?: InputMaybe<Array<Wf_AdminFirst_AfNotificationButtonLinkMarketFilterInput>>;
  /** [NOT NULL] ButtonLinkName */
  buttonLinkName?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] Market */
  market?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Wf_AdminFirst_AfNotificationButtonLinkMarketFilterInput>>;
  /** [NOT NULL] SortOrder */
  sortOrder?: InputMaybe<IntOperationFilterInput>;
};

/** AfNotificationButtonLinkMarket */
export type Wf_AdminFirst_AfNotificationButtonLinkMarketInput = {
  /** [NOT NULL] AfNotificationButtonLinkId */
  afNotificationButtonLinkId?: InputMaybe<Scalars['String']['input']>;
  /** [ID] AfNotificationButtonLinkMarketId */
  afNotificationButtonLinkMarketId?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] ButtonLinkName */
  buttonLinkName?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] SortOrder */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/** AfNotificationButtonLinkMarket */
export type Wf_AdminFirst_AfNotificationButtonLinkMarketSortInput = {
  /** [NOT NULL] AfNotificationButtonLinkId */
  afNotificationButtonLinkId?: InputMaybe<SortEnumType>;
  /** [ID] AfNotificationButtonLinkMarketId */
  afNotificationButtonLinkMarketId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] ButtonLinkName */
  buttonLinkName?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Market */
  market?: InputMaybe<SortEnumType>;
  /** [NOT NULL] SortOrder */
  sortOrder?: InputMaybe<SortEnumType>;
};

/** AfNotificationButtonLink */
export type Wf_AdminFirst_AfNotificationButtonLinkSortInput = {
  /** [ID] AfNotificationButtonLinkId */
  afNotificationButtonLinkId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] ButtonLinkName */
  buttonLinkName?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type Wf_AdminFirst_AfNotificationConnection = {
  __typename?: 'WF_AdminFirst_AfNotificationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_AdminFirst_AfNotificationEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_AdminFirst_AfNotification>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_AdminFirst_AfNotificationEdge = {
  __typename?: 'WF_AdminFirst_AfNotificationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_AdminFirst_AfNotification;
};

/** AfNotification */
export type Wf_AdminFirst_AfNotificationFilterInput = {
  /** ActionButton */
  actionButton?: InputMaybe<StringOperationFilterInput>;
  /** [ID] AfNotificationId */
  afNotificationId?: InputMaybe<IntOperationFilterInput>;
  /** [COLLECTION] AfNotificationMemberLogs */
  afNotificationMemberLogs?: InputMaybe<ListFilterInputTypeOfWf_AdminFirst_AfNotificationMemberLogFilterInput>;
  /** AfNotificationServiceTypeId */
  afNotificationServiceTypeId?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<Wf_AdminFirst_AfNotificationFilterInput>>;
  /** ButtonLinksTo */
  buttonLinksTo?: InputMaybe<StringOperationFilterInput>;
  /** ButtonText */
  buttonText?: InputMaybe<StringOperationFilterInput>;
  /** CreatedTime */
  createdTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** Creator */
  creator?: InputMaybe<StringOperationFilterInput>;
  /** Error */
  error?: InputMaybe<StringOperationFilterInput>;
  /** ExcelFileName */
  excelFileName?: InputMaybe<StringOperationFilterInput>;
  /** ImageFileName */
  imageFileName?: InputMaybe<StringOperationFilterInput>;
  /** IsAllMembers */
  isAllMembers?: InputMaybe<BooleanOperationFilterInput>;
  /** [NOT NULL] IsRegular */
  isRegular?: InputMaybe<BooleanOperationFilterInput>;
  /** [NOT NULL] IsTestNotification */
  isTestNotification?: InputMaybe<BooleanOperationFilterInput>;
  /** JobStatus */
  jobStatus?: InputMaybe<StringOperationFilterInput>;
  /** Market */
  market?: InputMaybe<StringOperationFilterInput>;
  /** MutationOperation */
  mutationOperation?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Wf_AdminFirst_AfNotificationFilterInput>>;
  /** RecipientSourceType */
  recipientSourceType?: InputMaybe<StringOperationFilterInput>;
  /** RemoveAfNotificationId */
  removeAfNotificationId?: InputMaybe<IntOperationFilterInput>;
  /** ScheduleTime */
  scheduleTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** TemplateMessage */
  templateMessage?: InputMaybe<StringOperationFilterInput>;
  /** Title */
  title?: InputMaybe<StringOperationFilterInput>;
};

/** AfNotification */
export type Wf_AdminFirst_AfNotificationInput = {
  /** ActionButton */
  actionButton?: InputMaybe<Scalars['String']['input']>;
  /** [ID] AfNotificationId */
  afNotificationId?: InputMaybe<Scalars['Int']['input']>;
  /** [COLLECTION] AfNotificationMemberLogs */
  afNotificationMemberLogs?: InputMaybe<Array<InputMaybe<Wf_AdminFirst_AfNotificationMemberLogInput>>>;
  /** AfNotificationServiceTypeId */
  afNotificationServiceTypeId?: InputMaybe<Scalars['String']['input']>;
  /** ButtonLinksTo */
  buttonLinksTo?: InputMaybe<Scalars['String']['input']>;
  /** ButtonText */
  buttonText?: InputMaybe<Scalars['String']['input']>;
  /** CreatedTime */
  createdTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Creator */
  creator?: InputMaybe<Scalars['String']['input']>;
  /** Error */
  error?: InputMaybe<Scalars['String']['input']>;
  /** ExcelFileName */
  excelFileName?: InputMaybe<Scalars['String']['input']>;
  /** ImageFileName */
  imageFileName?: InputMaybe<Scalars['String']['input']>;
  /** IsAllMembers */
  isAllMembers?: InputMaybe<Scalars['Boolean']['input']>;
  /** [NOT NULL] IsRegular */
  isRegular?: InputMaybe<Scalars['Boolean']['input']>;
  /** [NOT NULL] IsTestNotification */
  isTestNotification?: InputMaybe<Scalars['Boolean']['input']>;
  /** JobStatus */
  jobStatus?: InputMaybe<Scalars['String']['input']>;
  /** Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** MutationOperation */
  mutationOperation?: InputMaybe<Scalars['String']['input']>;
  /** RecipientSourceType */
  recipientSourceType?: InputMaybe<Scalars['String']['input']>;
  /** RemoveAfNotificationId */
  removeAfNotificationId?: InputMaybe<Scalars['Int']['input']>;
  /** ScheduleTime */
  scheduleTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** TemplateMessage */
  templateMessage?: InputMaybe<Scalars['String']['input']>;
  /** Title */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** AfNotificationMember */
export type Wf_AdminFirst_AfNotificationMember = Node & {
  __typename?: 'WF_AdminFirst_AfNotificationMember';
  /** [NOT NULL] AfNotificationId */
  afNotificationId?: Maybe<Scalars['Int']['output']>;
  /** [ID] AfNotificationMemberId */
  id: Scalars['ID']['output'];
  /** [NOT NULL] MemberNumber */
  memberNumber?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Wf_AdminFirst_AfNotificationMemberConnection = {
  __typename?: 'WF_AdminFirst_AfNotificationMemberConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_AdminFirst_AfNotificationMemberEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_AdminFirst_AfNotificationMember>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_AdminFirst_AfNotificationMemberEdge = {
  __typename?: 'WF_AdminFirst_AfNotificationMemberEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_AdminFirst_AfNotificationMember;
};

/** AfNotificationMember */
export type Wf_AdminFirst_AfNotificationMemberFilterInput = {
  /** [NOT NULL] AfNotificationId */
  afNotificationId?: InputMaybe<IntOperationFilterInput>;
  /** [ID] AfNotificationMemberId */
  afNotificationMemberId?: InputMaybe<LongOperationFilterInput>;
  and?: InputMaybe<Array<Wf_AdminFirst_AfNotificationMemberFilterInput>>;
  /** [NOT NULL] MemberNumber */
  memberNumber?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Wf_AdminFirst_AfNotificationMemberFilterInput>>;
};

/** AfNotificationMember */
export type Wf_AdminFirst_AfNotificationMemberInput = {
  /** [NOT NULL] AfNotificationId */
  afNotificationId?: InputMaybe<Scalars['Int']['input']>;
  /** [ID] AfNotificationMemberId */
  afNotificationMemberId?: InputMaybe<Scalars['Long']['input']>;
  /** [NOT NULL] MemberNumber */
  memberNumber?: InputMaybe<Scalars['String']['input']>;
};

/** AfNotificationMemberLog */
export type Wf_AdminFirst_AfNotificationMemberLog = Node & {
  __typename?: 'WF_AdminFirst_AfNotificationMemberLog';
  /** [NAVIGATION] AfNotification */
  afNotification?: Maybe<Wf_AdminFirst_AfNotification>;
  /** [NOT NULL] AfNotificationId */
  afNotificationId?: Maybe<Scalars['Int']['output']>;
  /** [ID] AfNotificationMemberLogId */
  id: Scalars['ID']['output'];
  /** [NOT NULL] MemberNumber */
  memberNumber?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Wf_AdminFirst_AfNotificationMemberLogConnection = {
  __typename?: 'WF_AdminFirst_AfNotificationMemberLogConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_AdminFirst_AfNotificationMemberLogEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_AdminFirst_AfNotificationMemberLog>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_AdminFirst_AfNotificationMemberLogEdge = {
  __typename?: 'WF_AdminFirst_AfNotificationMemberLogEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_AdminFirst_AfNotificationMemberLog;
};

/** AfNotificationMemberLog */
export type Wf_AdminFirst_AfNotificationMemberLogFilterInput = {
  /** [NAVIGATION] AfNotification */
  afNotification?: InputMaybe<Wf_AdminFirst_AfNotificationFilterInput>;
  /** [NOT NULL] AfNotificationId */
  afNotificationId?: InputMaybe<IntOperationFilterInput>;
  /** [ID] AfNotificationMemberLogId */
  afNotificationMemberLogId?: InputMaybe<LongOperationFilterInput>;
  and?: InputMaybe<Array<Wf_AdminFirst_AfNotificationMemberLogFilterInput>>;
  /** [NOT NULL] MemberNumber */
  memberNumber?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Wf_AdminFirst_AfNotificationMemberLogFilterInput>>;
};

/** AfNotificationMemberLog */
export type Wf_AdminFirst_AfNotificationMemberLogInput = {
  /** [NAVIGATION] AfNotification */
  afNotification?: InputMaybe<Wf_AdminFirst_AfNotificationInput>;
  /** [NOT NULL] AfNotificationId */
  afNotificationId?: InputMaybe<Scalars['Int']['input']>;
  /** [ID] AfNotificationMemberLogId */
  afNotificationMemberLogId?: InputMaybe<Scalars['Long']['input']>;
  /** [NOT NULL] MemberNumber */
  memberNumber?: InputMaybe<Scalars['String']['input']>;
};

/** AfNotificationMemberLog */
export type Wf_AdminFirst_AfNotificationMemberLogSortInput = {
  /** [NAVIGATION] AfNotification */
  afNotification?: InputMaybe<Wf_AdminFirst_AfNotificationSortInput>;
  /** [NOT NULL] AfNotificationId */
  afNotificationId?: InputMaybe<SortEnumType>;
  /** [ID] AfNotificationMemberLogId */
  afNotificationMemberLogId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] MemberNumber */
  memberNumber?: InputMaybe<SortEnumType>;
};

/** AfNotificationMember */
export type Wf_AdminFirst_AfNotificationMemberSortInput = {
  /** [NOT NULL] AfNotificationId */
  afNotificationId?: InputMaybe<SortEnumType>;
  /** [ID] AfNotificationMemberId */
  afNotificationMemberId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] MemberNumber */
  memberNumber?: InputMaybe<SortEnumType>;
};

/** AfNotificationServiceType */
export type Wf_AdminFirst_AfNotificationServiceType = Node & {
  __typename?: 'WF_AdminFirst_AfNotificationServiceType';
  /** [ID] AfNotificationServiceTypeId */
  id: Scalars['ID']['output'];
  /** IsPublic */
  isPublic?: Maybe<Scalars['Boolean']['output']>;
  /** ServiceTypeName */
  serviceTypeName?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Wf_AdminFirst_AfNotificationServiceTypeConnection = {
  __typename?: 'WF_AdminFirst_AfNotificationServiceTypeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_AdminFirst_AfNotificationServiceTypeEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_AdminFirst_AfNotificationServiceType>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_AdminFirst_AfNotificationServiceTypeEdge = {
  __typename?: 'WF_AdminFirst_AfNotificationServiceTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_AdminFirst_AfNotificationServiceType;
};

/** AfNotificationServiceType */
export type Wf_AdminFirst_AfNotificationServiceTypeFilterInput = {
  /** [ID] AfNotificationServiceTypeId */
  afNotificationServiceTypeId?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<Wf_AdminFirst_AfNotificationServiceTypeFilterInput>>;
  /** IsPublic */
  isPublic?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<Wf_AdminFirst_AfNotificationServiceTypeFilterInput>>;
  /** ServiceTypeName */
  serviceTypeName?: InputMaybe<StringOperationFilterInput>;
};

/** AfNotificationServiceType */
export type Wf_AdminFirst_AfNotificationServiceTypeInput = {
  /** [ID] AfNotificationServiceTypeId */
  afNotificationServiceTypeId?: InputMaybe<Scalars['String']['input']>;
  /** IsPublic */
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  /** ServiceTypeName */
  serviceTypeName?: InputMaybe<Scalars['String']['input']>;
};

/** AfNotificationServiceTypeMarket */
export type Wf_AdminFirst_AfNotificationServiceTypeMarket = Node & {
  __typename?: 'WF_AdminFirst_AfNotificationServiceTypeMarket';
  /** [NOT NULL] AfNotificationServiceTypeId */
  afNotificationServiceTypeId?: Maybe<Scalars['String']['output']>;
  /** [ID] AfNotificationServiceTypeMarketId */
  id: Scalars['ID']['output'];
  /** [NOT NULL] Market */
  market?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] SortOrder */
  sortOrder?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of items. */
export type Wf_AdminFirst_AfNotificationServiceTypeMarketConnection = {
  __typename?: 'WF_AdminFirst_AfNotificationServiceTypeMarketConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_AdminFirst_AfNotificationServiceTypeMarketEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_AdminFirst_AfNotificationServiceTypeMarket>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_AdminFirst_AfNotificationServiceTypeMarketEdge = {
  __typename?: 'WF_AdminFirst_AfNotificationServiceTypeMarketEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_AdminFirst_AfNotificationServiceTypeMarket;
};

/** AfNotificationServiceTypeMarket */
export type Wf_AdminFirst_AfNotificationServiceTypeMarketFilterInput = {
  /** [NOT NULL] AfNotificationServiceTypeId */
  afNotificationServiceTypeId?: InputMaybe<StringOperationFilterInput>;
  /** [ID] AfNotificationServiceTypeMarketId */
  afNotificationServiceTypeMarketId?: InputMaybe<IntOperationFilterInput>;
  and?: InputMaybe<Array<Wf_AdminFirst_AfNotificationServiceTypeMarketFilterInput>>;
  /** [NOT NULL] Market */
  market?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Wf_AdminFirst_AfNotificationServiceTypeMarketFilterInput>>;
  /** [NOT NULL] SortOrder */
  sortOrder?: InputMaybe<IntOperationFilterInput>;
};

/** AfNotificationServiceTypeMarket */
export type Wf_AdminFirst_AfNotificationServiceTypeMarketInput = {
  /** [NOT NULL] AfNotificationServiceTypeId */
  afNotificationServiceTypeId?: InputMaybe<Scalars['String']['input']>;
  /** [ID] AfNotificationServiceTypeMarketId */
  afNotificationServiceTypeMarketId?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] SortOrder */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/** AfNotificationServiceTypeMarket */
export type Wf_AdminFirst_AfNotificationServiceTypeMarketSortInput = {
  /** [NOT NULL] AfNotificationServiceTypeId */
  afNotificationServiceTypeId?: InputMaybe<SortEnumType>;
  /** [ID] AfNotificationServiceTypeMarketId */
  afNotificationServiceTypeMarketId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Market */
  market?: InputMaybe<SortEnumType>;
  /** [NOT NULL] SortOrder */
  sortOrder?: InputMaybe<SortEnumType>;
};

/** AfNotificationServiceType */
export type Wf_AdminFirst_AfNotificationServiceTypeSortInput = {
  /** [ID] AfNotificationServiceTypeId */
  afNotificationServiceTypeId?: InputMaybe<SortEnumType>;
  /** IsPublic */
  isPublic?: InputMaybe<SortEnumType>;
  /** ServiceTypeName */
  serviceTypeName?: InputMaybe<SortEnumType>;
};

/** AfNotification */
export type Wf_AdminFirst_AfNotificationSortInput = {
  /** ActionButton */
  actionButton?: InputMaybe<SortEnumType>;
  /** [ID] AfNotificationId */
  afNotificationId?: InputMaybe<SortEnumType>;
  /** AfNotificationServiceTypeId */
  afNotificationServiceTypeId?: InputMaybe<SortEnumType>;
  /** ButtonLinksTo */
  buttonLinksTo?: InputMaybe<SortEnumType>;
  /** ButtonText */
  buttonText?: InputMaybe<SortEnumType>;
  /** CreatedTime */
  createdTime?: InputMaybe<SortEnumType>;
  /** Creator */
  creator?: InputMaybe<SortEnumType>;
  /** Error */
  error?: InputMaybe<SortEnumType>;
  /** ExcelFileName */
  excelFileName?: InputMaybe<SortEnumType>;
  /** ImageFileName */
  imageFileName?: InputMaybe<SortEnumType>;
  /** IsAllMembers */
  isAllMembers?: InputMaybe<SortEnumType>;
  /** [NOT NULL] IsRegular */
  isRegular?: InputMaybe<SortEnumType>;
  /** [NOT NULL] IsTestNotification */
  isTestNotification?: InputMaybe<SortEnumType>;
  /** JobStatus */
  jobStatus?: InputMaybe<SortEnumType>;
  /** Market */
  market?: InputMaybe<SortEnumType>;
  /** MutationOperation */
  mutationOperation?: InputMaybe<SortEnumType>;
  /** RecipientSourceType */
  recipientSourceType?: InputMaybe<SortEnumType>;
  /** RemoveAfNotificationId */
  removeAfNotificationId?: InputMaybe<SortEnumType>;
  /** ScheduleTime */
  scheduleTime?: InputMaybe<SortEnumType>;
  /** TemplateMessage */
  templateMessage?: InputMaybe<SortEnumType>;
  /** Title */
  title?: InputMaybe<SortEnumType>;
};

/** AfProgram */
export type Wf_AdminFirst_AfProgram = Node & {
  __typename?: 'WF_AdminFirst_AfProgram';
  /** [NAVIGATION] AfService */
  afService?: Maybe<Wf_AdminFirst_AfService>;
  /** [NOT NULL] AfServiceId */
  afServiceId?: Maybe<Scalars['Int']['output']>;
  /** [COLLECTION] AfUserPrograms */
  afUserPrograms?: Maybe<Array<Maybe<Wf_AdminFirst_AfUserProgram>>>;
  /** [ID] AfProgramId */
  id: Scalars['ID']['output'];
  /** [NOT NULL] IsUnavailable */
  isUnavailable?: Maybe<Scalars['Boolean']['output']>;
  /** ProgramName */
  programName?: Maybe<Scalars['String']['output']>;
  /** RouteName */
  routeName?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Wf_AdminFirst_AfProgramConnection = {
  __typename?: 'WF_AdminFirst_AfProgramConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_AdminFirst_AfProgramEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_AdminFirst_AfProgram>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_AdminFirst_AfProgramEdge = {
  __typename?: 'WF_AdminFirst_AfProgramEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_AdminFirst_AfProgram;
};

/** AfProgram */
export type Wf_AdminFirst_AfProgramFilterInput = {
  /** [ID] AfProgramId */
  afProgramId?: InputMaybe<IntOperationFilterInput>;
  /** [NAVIGATION] AfService */
  afService?: InputMaybe<Wf_AdminFirst_AfServiceFilterInput>;
  /** [NOT NULL] AfServiceId */
  afServiceId?: InputMaybe<IntOperationFilterInput>;
  /** [COLLECTION] AfUserPrograms */
  afUserPrograms?: InputMaybe<ListFilterInputTypeOfWf_AdminFirst_AfUserProgramFilterInput>;
  and?: InputMaybe<Array<Wf_AdminFirst_AfProgramFilterInput>>;
  /** [NOT NULL] IsUnavailable */
  isUnavailable?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<Wf_AdminFirst_AfProgramFilterInput>>;
  /** ProgramName */
  programName?: InputMaybe<StringOperationFilterInput>;
  /** RouteName */
  routeName?: InputMaybe<StringOperationFilterInput>;
};

/** AfProgram */
export type Wf_AdminFirst_AfProgramInput = {
  /** [ID] AfProgramId */
  afProgramId?: InputMaybe<Scalars['Int']['input']>;
  /** [NAVIGATION] AfService */
  afService?: InputMaybe<Wf_AdminFirst_AfServiceInput>;
  /** [NOT NULL] AfServiceId */
  afServiceId?: InputMaybe<Scalars['Int']['input']>;
  /** [COLLECTION] AfUserPrograms */
  afUserPrograms?: InputMaybe<Array<InputMaybe<Wf_AdminFirst_AfUserProgramInput>>>;
  /** [NOT NULL] IsUnavailable */
  isUnavailable?: InputMaybe<Scalars['Boolean']['input']>;
  /** ProgramName */
  programName?: InputMaybe<Scalars['String']['input']>;
  /** RouteName */
  routeName?: InputMaybe<Scalars['String']['input']>;
};

/** AfProgram */
export type Wf_AdminFirst_AfProgramSortInput = {
  /** [ID] AfProgramId */
  afProgramId?: InputMaybe<SortEnumType>;
  /** [NAVIGATION] AfService */
  afService?: InputMaybe<Wf_AdminFirst_AfServiceSortInput>;
  /** [NOT NULL] AfServiceId */
  afServiceId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] IsUnavailable */
  isUnavailable?: InputMaybe<SortEnumType>;
  /** ProgramName */
  programName?: InputMaybe<SortEnumType>;
  /** RouteName */
  routeName?: InputMaybe<SortEnumType>;
};

/** AfService */
export type Wf_AdminFirst_AfService = Node & {
  __typename?: 'WF_AdminFirst_AfService';
  /** [COLLECTION] AfPrograms */
  afPrograms?: Maybe<Array<Maybe<Wf_AdminFirst_AfProgram>>>;
  /** [COLLECTION] AfUserServices */
  afUserServices?: Maybe<Array<Maybe<Wf_AdminFirst_AfUserService>>>;
  /** [ID] AfServiceId */
  id: Scalars['ID']['output'];
  /** RouteName */
  routeName?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] ServiceName */
  serviceName?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Wf_AdminFirst_AfServiceConnection = {
  __typename?: 'WF_AdminFirst_AfServiceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_AdminFirst_AfServiceEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_AdminFirst_AfService>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_AdminFirst_AfServiceEdge = {
  __typename?: 'WF_AdminFirst_AfServiceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_AdminFirst_AfService;
};

/** AfService */
export type Wf_AdminFirst_AfServiceFilterInput = {
  /** [COLLECTION] AfPrograms */
  afPrograms?: InputMaybe<ListFilterInputTypeOfWf_AdminFirst_AfProgramFilterInput>;
  /** [ID] AfServiceId */
  afServiceId?: InputMaybe<IntOperationFilterInput>;
  /** [COLLECTION] AfUserServices */
  afUserServices?: InputMaybe<ListFilterInputTypeOfWf_AdminFirst_AfUserServiceFilterInput>;
  and?: InputMaybe<Array<Wf_AdminFirst_AfServiceFilterInput>>;
  or?: InputMaybe<Array<Wf_AdminFirst_AfServiceFilterInput>>;
  /** RouteName */
  routeName?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] ServiceName */
  serviceName?: InputMaybe<StringOperationFilterInput>;
};

/** AfService */
export type Wf_AdminFirst_AfServiceInput = {
  /** [COLLECTION] AfPrograms */
  afPrograms?: InputMaybe<Array<InputMaybe<Wf_AdminFirst_AfProgramInput>>>;
  /** [ID] AfServiceId */
  afServiceId?: InputMaybe<Scalars['Int']['input']>;
  /** [COLLECTION] AfUserServices */
  afUserServices?: InputMaybe<Array<InputMaybe<Wf_AdminFirst_AfUserServiceInput>>>;
  /** RouteName */
  routeName?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] ServiceName */
  serviceName?: InputMaybe<Scalars['String']['input']>;
};

/** AfService */
export type Wf_AdminFirst_AfServiceSortInput = {
  /** [ID] AfServiceId */
  afServiceId?: InputMaybe<SortEnumType>;
  /** RouteName */
  routeName?: InputMaybe<SortEnumType>;
  /** [NOT NULL] ServiceName */
  serviceName?: InputMaybe<SortEnumType>;
};

/** AfUser */
export type Wf_AdminFirst_AfUser = Node & {
  __typename?: 'WF_AdminFirst_AfUser';
  /** [COLLECTION] AfUserMarkets */
  afUserMarkets?: Maybe<Array<Maybe<Wf_AdminFirst_AfUserMarket>>>;
  /** [COLLECTION] AfUserPrograms */
  afUserPrograms?: Maybe<Array<Maybe<Wf_AdminFirst_AfUserProgram>>>;
  /** [COLLECTION] AfUserServices */
  afUserServices?: Maybe<Array<Maybe<Wf_AdminFirst_AfUserService>>>;
  /** AvatarUrl */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** [ID] AfUserId */
  id: Scalars['ID']['output'];
  /** IsAdministrator */
  isAdministrator?: Maybe<Scalars['Boolean']['output']>;
  /** StopDate */
  stopDate?: Maybe<Scalars['DateTime']['output']>;
  /** [NOT NULL] UserEmail */
  userEmail?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] UserName */
  userName?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Wf_AdminFirst_AfUserConnection = {
  __typename?: 'WF_AdminFirst_AfUserConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_AdminFirst_AfUserEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_AdminFirst_AfUser>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_AdminFirst_AfUserEdge = {
  __typename?: 'WF_AdminFirst_AfUserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_AdminFirst_AfUser;
};

/** AfUser */
export type Wf_AdminFirst_AfUserFilterInput = {
  /** [ID] AfUserId */
  afUserId?: InputMaybe<IntOperationFilterInput>;
  /** [COLLECTION] AfUserMarkets */
  afUserMarkets?: InputMaybe<ListFilterInputTypeOfWf_AdminFirst_AfUserMarketFilterInput>;
  /** [COLLECTION] AfUserPrograms */
  afUserPrograms?: InputMaybe<ListFilterInputTypeOfWf_AdminFirst_AfUserProgramFilterInput>;
  /** [COLLECTION] AfUserServices */
  afUserServices?: InputMaybe<ListFilterInputTypeOfWf_AdminFirst_AfUserServiceFilterInput>;
  and?: InputMaybe<Array<Wf_AdminFirst_AfUserFilterInput>>;
  /** AvatarUrl */
  avatarUrl?: InputMaybe<StringOperationFilterInput>;
  /** IsAdministrator */
  isAdministrator?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<Wf_AdminFirst_AfUserFilterInput>>;
  /** StopDate */
  stopDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** [NOT NULL] UserEmail */
  userEmail?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] UserName */
  userName?: InputMaybe<StringOperationFilterInput>;
};

/** AfUser */
export type Wf_AdminFirst_AfUserInput = {
  /** [ID] AfUserId */
  afUserId?: InputMaybe<Scalars['Int']['input']>;
  /** [COLLECTION] AfUserMarkets */
  afUserMarkets?: InputMaybe<Array<InputMaybe<Wf_AdminFirst_AfUserMarketInput>>>;
  /** [COLLECTION] AfUserPrograms */
  afUserPrograms?: InputMaybe<Array<InputMaybe<Wf_AdminFirst_AfUserProgramInput>>>;
  /** [COLLECTION] AfUserServices */
  afUserServices?: InputMaybe<Array<InputMaybe<Wf_AdminFirst_AfUserServiceInput>>>;
  /** AvatarUrl */
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  /** IsAdministrator */
  isAdministrator?: InputMaybe<Scalars['Boolean']['input']>;
  /** StopDate */
  stopDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** [NOT NULL] UserEmail */
  userEmail?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] UserName */
  userName?: InputMaybe<Scalars['String']['input']>;
};

/** AfUserMarket */
export type Wf_AdminFirst_AfUserMarket = Node & {
  __typename?: 'WF_AdminFirst_AfUserMarket';
  /** [NAVIGATION] AfUser */
  afUser?: Maybe<Wf_AdminFirst_AfUser>;
  /** [NOT NULL] AfUserId */
  afUserId?: Maybe<Scalars['Int']['output']>;
  /** [ID] AfUserMarketId */
  id: Scalars['ID']['output'];
  /** [NOT NULL] Market */
  market?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Wf_AdminFirst_AfUserMarketConnection = {
  __typename?: 'WF_AdminFirst_AfUserMarketConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_AdminFirst_AfUserMarketEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_AdminFirst_AfUserMarket>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_AdminFirst_AfUserMarketEdge = {
  __typename?: 'WF_AdminFirst_AfUserMarketEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_AdminFirst_AfUserMarket;
};

/** AfUserMarket */
export type Wf_AdminFirst_AfUserMarketFilterInput = {
  /** [NAVIGATION] AfUser */
  afUser?: InputMaybe<Wf_AdminFirst_AfUserFilterInput>;
  /** [NOT NULL] AfUserId */
  afUserId?: InputMaybe<IntOperationFilterInput>;
  /** [ID] AfUserMarketId */
  afUserMarketId?: InputMaybe<IntOperationFilterInput>;
  and?: InputMaybe<Array<Wf_AdminFirst_AfUserMarketFilterInput>>;
  /** [NOT NULL] Market */
  market?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Wf_AdminFirst_AfUserMarketFilterInput>>;
};

/** AfUserMarket */
export type Wf_AdminFirst_AfUserMarketInput = {
  /** [NAVIGATION] AfUser */
  afUser?: InputMaybe<Wf_AdminFirst_AfUserInput>;
  /** [NOT NULL] AfUserId */
  afUserId?: InputMaybe<Scalars['Int']['input']>;
  /** [ID] AfUserMarketId */
  afUserMarketId?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] Market */
  market?: InputMaybe<Scalars['String']['input']>;
};

/** AfUserMarket */
export type Wf_AdminFirst_AfUserMarketSortInput = {
  /** [NAVIGATION] AfUser */
  afUser?: InputMaybe<Wf_AdminFirst_AfUserSortInput>;
  /** [NOT NULL] AfUserId */
  afUserId?: InputMaybe<SortEnumType>;
  /** [ID] AfUserMarketId */
  afUserMarketId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Market */
  market?: InputMaybe<SortEnumType>;
};

/** AfUserProgram */
export type Wf_AdminFirst_AfUserProgram = Node & {
  __typename?: 'WF_AdminFirst_AfUserProgram';
  /** [NAVIGATION] AfProgram */
  afProgram?: Maybe<Wf_AdminFirst_AfProgram>;
  /** [NOT NULL] AfProgramId */
  afProgramId?: Maybe<Scalars['Int']['output']>;
  /** [NAVIGATION] AfUser */
  afUser?: Maybe<Wf_AdminFirst_AfUser>;
  /** [NOT NULL] AfUserId */
  afUserId?: Maybe<Scalars['Int']['output']>;
  /** [ID] AfUserProgramId */
  id: Scalars['ID']['output'];
};

/** A connection to a list of items. */
export type Wf_AdminFirst_AfUserProgramConnection = {
  __typename?: 'WF_AdminFirst_AfUserProgramConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_AdminFirst_AfUserProgramEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_AdminFirst_AfUserProgram>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_AdminFirst_AfUserProgramEdge = {
  __typename?: 'WF_AdminFirst_AfUserProgramEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_AdminFirst_AfUserProgram;
};

/** AfUserProgram */
export type Wf_AdminFirst_AfUserProgramFilterInput = {
  /** [NAVIGATION] AfProgram */
  afProgram?: InputMaybe<Wf_AdminFirst_AfProgramFilterInput>;
  /** [NOT NULL] AfProgramId */
  afProgramId?: InputMaybe<IntOperationFilterInput>;
  /** [NAVIGATION] AfUser */
  afUser?: InputMaybe<Wf_AdminFirst_AfUserFilterInput>;
  /** [NOT NULL] AfUserId */
  afUserId?: InputMaybe<IntOperationFilterInput>;
  /** [ID] AfUserProgramId */
  afUserProgramId?: InputMaybe<IntOperationFilterInput>;
  and?: InputMaybe<Array<Wf_AdminFirst_AfUserProgramFilterInput>>;
  or?: InputMaybe<Array<Wf_AdminFirst_AfUserProgramFilterInput>>;
};

/** AfUserProgram */
export type Wf_AdminFirst_AfUserProgramInput = {
  /** [NAVIGATION] AfProgram */
  afProgram?: InputMaybe<Wf_AdminFirst_AfProgramInput>;
  /** [NOT NULL] AfProgramId */
  afProgramId?: InputMaybe<Scalars['Int']['input']>;
  /** [NAVIGATION] AfUser */
  afUser?: InputMaybe<Wf_AdminFirst_AfUserInput>;
  /** [NOT NULL] AfUserId */
  afUserId?: InputMaybe<Scalars['Int']['input']>;
  /** [ID] AfUserProgramId */
  afUserProgramId?: InputMaybe<Scalars['Int']['input']>;
};

/** AfUserProgram */
export type Wf_AdminFirst_AfUserProgramSortInput = {
  /** [NAVIGATION] AfProgram */
  afProgram?: InputMaybe<Wf_AdminFirst_AfProgramSortInput>;
  /** [NOT NULL] AfProgramId */
  afProgramId?: InputMaybe<SortEnumType>;
  /** [NAVIGATION] AfUser */
  afUser?: InputMaybe<Wf_AdminFirst_AfUserSortInput>;
  /** [NOT NULL] AfUserId */
  afUserId?: InputMaybe<SortEnumType>;
  /** [ID] AfUserProgramId */
  afUserProgramId?: InputMaybe<SortEnumType>;
};

/** AfUserService */
export type Wf_AdminFirst_AfUserService = Node & {
  __typename?: 'WF_AdminFirst_AfUserService';
  /** [NAVIGATION] AfService */
  afService?: Maybe<Wf_AdminFirst_AfService>;
  /** [NOT NULL] AfServiceId */
  afServiceId?: Maybe<Scalars['Int']['output']>;
  /** [NAVIGATION] AfUser */
  afUser?: Maybe<Wf_AdminFirst_AfUser>;
  /** [NOT NULL] AfUserId */
  afUserId?: Maybe<Scalars['Int']['output']>;
  /** [ID] AfUserServiceId */
  id: Scalars['ID']['output'];
};

/** A connection to a list of items. */
export type Wf_AdminFirst_AfUserServiceConnection = {
  __typename?: 'WF_AdminFirst_AfUserServiceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_AdminFirst_AfUserServiceEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_AdminFirst_AfUserService>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_AdminFirst_AfUserServiceEdge = {
  __typename?: 'WF_AdminFirst_AfUserServiceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_AdminFirst_AfUserService;
};

/** AfUserService */
export type Wf_AdminFirst_AfUserServiceFilterInput = {
  /** [NAVIGATION] AfService */
  afService?: InputMaybe<Wf_AdminFirst_AfServiceFilterInput>;
  /** [NOT NULL] AfServiceId */
  afServiceId?: InputMaybe<IntOperationFilterInput>;
  /** [NAVIGATION] AfUser */
  afUser?: InputMaybe<Wf_AdminFirst_AfUserFilterInput>;
  /** [NOT NULL] AfUserId */
  afUserId?: InputMaybe<IntOperationFilterInput>;
  /** [ID] AfUserServiceId */
  afUserServiceId?: InputMaybe<IntOperationFilterInput>;
  and?: InputMaybe<Array<Wf_AdminFirst_AfUserServiceFilterInput>>;
  or?: InputMaybe<Array<Wf_AdminFirst_AfUserServiceFilterInput>>;
};

/** AfUserService */
export type Wf_AdminFirst_AfUserServiceInput = {
  /** [NAVIGATION] AfService */
  afService?: InputMaybe<Wf_AdminFirst_AfServiceInput>;
  /** [NOT NULL] AfServiceId */
  afServiceId?: InputMaybe<Scalars['Int']['input']>;
  /** [NAVIGATION] AfUser */
  afUser?: InputMaybe<Wf_AdminFirst_AfUserInput>;
  /** [NOT NULL] AfUserId */
  afUserId?: InputMaybe<Scalars['Int']['input']>;
  /** [ID] AfUserServiceId */
  afUserServiceId?: InputMaybe<Scalars['Int']['input']>;
};

/** AfUserService */
export type Wf_AdminFirst_AfUserServiceSortInput = {
  /** [NAVIGATION] AfService */
  afService?: InputMaybe<Wf_AdminFirst_AfServiceSortInput>;
  /** [NOT NULL] AfServiceId */
  afServiceId?: InputMaybe<SortEnumType>;
  /** [NAVIGATION] AfUser */
  afUser?: InputMaybe<Wf_AdminFirst_AfUserSortInput>;
  /** [NOT NULL] AfUserId */
  afUserId?: InputMaybe<SortEnumType>;
  /** [ID] AfUserServiceId */
  afUserServiceId?: InputMaybe<SortEnumType>;
};

/** AfUser */
export type Wf_AdminFirst_AfUserSortInput = {
  /** [ID] AfUserId */
  afUserId?: InputMaybe<SortEnumType>;
  /** AvatarUrl */
  avatarUrl?: InputMaybe<SortEnumType>;
  /** IsAdministrator */
  isAdministrator?: InputMaybe<SortEnumType>;
  /** StopDate */
  stopDate?: InputMaybe<SortEnumType>;
  /** [NOT NULL] UserEmail */
  userEmail?: InputMaybe<SortEnumType>;
  /** [NOT NULL] UserName */
  userName?: InputMaybe<SortEnumType>;
};

/** ChildGraduationApplication */
export type Wf_AdminFirst_ChildGraduationApplication = Node & {
  __typename?: 'WF_AdminFirst_ChildGraduationApplication';
  /** ApplicationCount */
  applicationCount?: Maybe<Scalars['Int']['output']>;
  /** [NOT NULL] ApplicationYear */
  applicationYear?: Maybe<Scalars['Int']['output']>;
  /** [NOT NULL] ApprovedCount */
  approvedCount?: Maybe<Scalars['Int']['output']>;
  /** [NOT NULL] ChildNo */
  childNo?: Maybe<Scalars['String']['output']>;
  /** GraduationDate */
  graduationDate?: Maybe<Scalars['DateTime']['output']>;
  /** [ID] ChildApplicationId */
  id: Scalars['ID']['output'];
  /** IsExcellent */
  isExcellent?: Maybe<Scalars['Boolean']['output']>;
  /** LastApprovalDate */
  lastApprovalDate?: Maybe<Scalars['DateTime']['output']>;
  /** [NOT NULL] Market */
  market?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] MemberNo */
  memberNo?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] RejectedCount */
  rejectedCount?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of items. */
export type Wf_AdminFirst_ChildGraduationApplicationConnection = {
  __typename?: 'WF_AdminFirst_ChildGraduationApplicationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_AdminFirst_ChildGraduationApplicationEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_AdminFirst_ChildGraduationApplication>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_AdminFirst_ChildGraduationApplicationEdge = {
  __typename?: 'WF_AdminFirst_ChildGraduationApplicationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_AdminFirst_ChildGraduationApplication;
};

/** ChildGraduationApplication */
export type Wf_AdminFirst_ChildGraduationApplicationFilterInput = {
  and?: InputMaybe<Array<Wf_AdminFirst_ChildGraduationApplicationFilterInput>>;
  /** ApplicationCount */
  applicationCount?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] ApplicationYear */
  applicationYear?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] ApprovedCount */
  approvedCount?: InputMaybe<IntOperationFilterInput>;
  /** [ID] ChildApplicationId */
  childApplicationId?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] ChildNo */
  childNo?: InputMaybe<StringOperationFilterInput>;
  /** GraduationDate */
  graduationDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** IsExcellent */
  isExcellent?: InputMaybe<BooleanOperationFilterInput>;
  /** LastApprovalDate */
  lastApprovalDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** [NOT NULL] Market */
  market?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] MemberNo */
  memberNo?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Wf_AdminFirst_ChildGraduationApplicationFilterInput>>;
  /** [NOT NULL] RejectedCount */
  rejectedCount?: InputMaybe<IntOperationFilterInput>;
};

/** ChildGraduationApplication */
export type Wf_AdminFirst_ChildGraduationApplicationInput = {
  /** ApplicationCount */
  applicationCount?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] ApplicationYear */
  applicationYear?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] ApprovedCount */
  approvedCount?: InputMaybe<Scalars['Int']['input']>;
  /** [ID] ChildApplicationId */
  childApplicationId?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] ChildNo */
  childNo?: InputMaybe<Scalars['String']['input']>;
  /** GraduationDate */
  graduationDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** IsExcellent */
  isExcellent?: InputMaybe<Scalars['Boolean']['input']>;
  /** LastApprovalDate */
  lastApprovalDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** [NOT NULL] Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] MemberNo */
  memberNo?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] RejectedCount */
  rejectedCount?: InputMaybe<Scalars['Int']['input']>;
};

/** ChildGraduationApplication */
export type Wf_AdminFirst_ChildGraduationApplicationSortInput = {
  /** ApplicationCount */
  applicationCount?: InputMaybe<SortEnumType>;
  /** [NOT NULL] ApplicationYear */
  applicationYear?: InputMaybe<SortEnumType>;
  /** [NOT NULL] ApprovedCount */
  approvedCount?: InputMaybe<SortEnumType>;
  /** [ID] ChildApplicationId */
  childApplicationId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] ChildNo */
  childNo?: InputMaybe<SortEnumType>;
  /** GraduationDate */
  graduationDate?: InputMaybe<SortEnumType>;
  /** IsExcellent */
  isExcellent?: InputMaybe<SortEnumType>;
  /** LastApprovalDate */
  lastApprovalDate?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Market */
  market?: InputMaybe<SortEnumType>;
  /** [NOT NULL] MemberNo */
  memberNo?: InputMaybe<SortEnumType>;
  /** [NOT NULL] RejectedCount */
  rejectedCount?: InputMaybe<SortEnumType>;
};

/** GraduationApplication */
export type Wf_AdminFirst_GraduationApplication = Node & {
  __typename?: 'WF_AdminFirst_GraduationApplication';
  /** Age */
  age?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] ApplicationDate */
  applicationDate?: Maybe<Scalars['DateTime']['output']>;
  /** ApprovalDate */
  approvalDate?: Maybe<Scalars['DateTime']['output']>;
  /** AudioFile */
  audioFile?: Maybe<Scalars['String']['output']>;
  /** ChildEnglishName */
  childEnglishName?: Maybe<Scalars['String']['output']>;
  /** ChildName */
  childName?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] ChildNo */
  childNo?: Maybe<Scalars['String']['output']>;
  /** CreatedTime */
  createdTime?: Maybe<Scalars['DateTime']['output']>;
  /** Creator */
  creator?: Maybe<Scalars['String']['output']>;
  /** FinishDate */
  finishDate?: Maybe<Scalars['DateTime']['output']>;
  /** [ID] ApplicationId */
  id: Scalars['ID']['output'];
  /** IsExcellent */
  isExcellent?: Maybe<Scalars['Boolean']['output']>;
  /** IsPassed */
  isPassed?: Maybe<Scalars['Boolean']['output']>;
  /** [NOT NULL] Market */
  market?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] MemberNo */
  memberNo?: Maybe<Scalars['String']['output']>;
  /** OverallComment */
  overallComment?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] TaskId */
  taskId?: Maybe<Scalars['Int']['output']>;
  /** UpdatedTime */
  updatedTime?: Maybe<Scalars['DateTime']['output']>;
  /** Updater */
  updater?: Maybe<Scalars['String']['output']>;
  /** VideoUrl */
  videoUrl?: Maybe<Scalars['String']['output']>;
  /** YearCount */
  yearCount?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Wf_AdminFirst_GraduationApplicationConnection = {
  __typename?: 'WF_AdminFirst_GraduationApplicationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_AdminFirst_GraduationApplicationEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_AdminFirst_GraduationApplication>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_AdminFirst_GraduationApplicationEdge = {
  __typename?: 'WF_AdminFirst_GraduationApplicationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_AdminFirst_GraduationApplication;
};

/** GraduationApplication */
export type Wf_AdminFirst_GraduationApplicationFilterInput = {
  /** Age */
  age?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<Wf_AdminFirst_GraduationApplicationFilterInput>>;
  /** [NOT NULL] ApplicationDate */
  applicationDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** [ID] ApplicationId */
  applicationId?: InputMaybe<IntOperationFilterInput>;
  /** ApprovalDate */
  approvalDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** AudioFile */
  audioFile?: InputMaybe<StringOperationFilterInput>;
  /** ChildEnglishName */
  childEnglishName?: InputMaybe<StringOperationFilterInput>;
  /** ChildName */
  childName?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] ChildNo */
  childNo?: InputMaybe<StringOperationFilterInput>;
  /** CreatedTime */
  createdTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** Creator */
  creator?: InputMaybe<StringOperationFilterInput>;
  /** FinishDate */
  finishDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** IsExcellent */
  isExcellent?: InputMaybe<BooleanOperationFilterInput>;
  /** IsPassed */
  isPassed?: InputMaybe<BooleanOperationFilterInput>;
  /** [NOT NULL] Market */
  market?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] MemberNo */
  memberNo?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Wf_AdminFirst_GraduationApplicationFilterInput>>;
  /** OverallComment */
  overallComment?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] TaskId */
  taskId?: InputMaybe<IntOperationFilterInput>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** Updater */
  updater?: InputMaybe<StringOperationFilterInput>;
  /** VideoUrl */
  videoUrl?: InputMaybe<StringOperationFilterInput>;
  /** YearCount */
  yearCount?: InputMaybe<StringOperationFilterInput>;
};

/** GraduationApplication */
export type Wf_AdminFirst_GraduationApplicationInput = {
  /** Age */
  age?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] ApplicationDate */
  applicationDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** [ID] ApplicationId */
  applicationId?: InputMaybe<Scalars['Int']['input']>;
  /** ApprovalDate */
  approvalDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** AudioFile */
  audioFile?: InputMaybe<Scalars['String']['input']>;
  /** ChildEnglishName */
  childEnglishName?: InputMaybe<Scalars['String']['input']>;
  /** ChildName */
  childName?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] ChildNo */
  childNo?: InputMaybe<Scalars['String']['input']>;
  /** CreatedTime */
  createdTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Creator */
  creator?: InputMaybe<Scalars['String']['input']>;
  /** FinishDate */
  finishDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** IsExcellent */
  isExcellent?: InputMaybe<Scalars['Boolean']['input']>;
  /** IsPassed */
  isPassed?: InputMaybe<Scalars['Boolean']['input']>;
  /** [NOT NULL] Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] MemberNo */
  memberNo?: InputMaybe<Scalars['String']['input']>;
  /** OverallComment */
  overallComment?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] TaskId */
  taskId?: InputMaybe<Scalars['Int']['input']>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Updater */
  updater?: InputMaybe<Scalars['String']['input']>;
  /** VideoUrl */
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  /** YearCount */
  yearCount?: InputMaybe<Scalars['String']['input']>;
};

/** GraduationApplication */
export type Wf_AdminFirst_GraduationApplicationSortInput = {
  /** Age */
  age?: InputMaybe<SortEnumType>;
  /** [NOT NULL] ApplicationDate */
  applicationDate?: InputMaybe<SortEnumType>;
  /** [ID] ApplicationId */
  applicationId?: InputMaybe<SortEnumType>;
  /** ApprovalDate */
  approvalDate?: InputMaybe<SortEnumType>;
  /** AudioFile */
  audioFile?: InputMaybe<SortEnumType>;
  /** ChildEnglishName */
  childEnglishName?: InputMaybe<SortEnumType>;
  /** ChildName */
  childName?: InputMaybe<SortEnumType>;
  /** [NOT NULL] ChildNo */
  childNo?: InputMaybe<SortEnumType>;
  /** CreatedTime */
  createdTime?: InputMaybe<SortEnumType>;
  /** Creator */
  creator?: InputMaybe<SortEnumType>;
  /** FinishDate */
  finishDate?: InputMaybe<SortEnumType>;
  /** IsExcellent */
  isExcellent?: InputMaybe<SortEnumType>;
  /** IsPassed */
  isPassed?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Market */
  market?: InputMaybe<SortEnumType>;
  /** [NOT NULL] MemberNo */
  memberNo?: InputMaybe<SortEnumType>;
  /** OverallComment */
  overallComment?: InputMaybe<SortEnumType>;
  /** [NOT NULL] TaskId */
  taskId?: InputMaybe<SortEnumType>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<SortEnumType>;
  /** Updater */
  updater?: InputMaybe<SortEnumType>;
  /** VideoUrl */
  videoUrl?: InputMaybe<SortEnumType>;
  /** YearCount */
  yearCount?: InputMaybe<SortEnumType>;
};

/** GraphqlAccess */
export type Wf_AdminFirst_GraphqlAccess = Node & {
  __typename?: 'WF_AdminFirst_GraphqlAccess';
  /** AccessSchema */
  accessSchema?: Maybe<Scalars['String']['output']>;
  /** AccessSchemaHash */
  accessSchemaHash?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Database */
  database?: Maybe<Scalars['String']['output']>;
  /** [NAVIGATION] GraphqlSchema */
  graphqlSchema?: Maybe<Wf_AdminFirst_GraphqlSchema>;
  /** [NOT NULL] GraphqlSchemaId */
  graphqlSchemaId?: Maybe<Scalars['UUID']['output']>;
  /** [ID] GraphqlAccessId */
  id: Scalars['ID']['output'];
  /** [NOT NULL] ProjectId */
  projectId?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Server */
  server?: Maybe<Scalars['String']['output']>;
  /** UpdateTime */
  updateTime?: Maybe<Scalars['DateTime']['output']>;
};

/** A connection to a list of items. */
export type Wf_AdminFirst_GraphqlAccessConnection = {
  __typename?: 'WF_AdminFirst_GraphqlAccessConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_AdminFirst_GraphqlAccessEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_AdminFirst_GraphqlAccess>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_AdminFirst_GraphqlAccessEdge = {
  __typename?: 'WF_AdminFirst_GraphqlAccessEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_AdminFirst_GraphqlAccess;
};

/** GraphqlAccess */
export type Wf_AdminFirst_GraphqlAccessFilterInput = {
  /** AccessSchema */
  accessSchema?: InputMaybe<StringOperationFilterInput>;
  /** AccessSchemaHash */
  accessSchemaHash?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<Wf_AdminFirst_GraphqlAccessFilterInput>>;
  /** [NOT NULL] Database */
  database?: InputMaybe<StringOperationFilterInput>;
  /** [ID] GraphqlAccessId */
  graphqlAccessId?: InputMaybe<UuidOperationFilterInput>;
  /** [NAVIGATION] GraphqlSchema */
  graphqlSchema?: InputMaybe<Wf_AdminFirst_GraphqlSchemaFilterInput>;
  /** [NOT NULL] GraphqlSchemaId */
  graphqlSchemaId?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<Wf_AdminFirst_GraphqlAccessFilterInput>>;
  /** [NOT NULL] ProjectId */
  projectId?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] Server */
  server?: InputMaybe<StringOperationFilterInput>;
  /** UpdateTime */
  updateTime?: InputMaybe<DateTimeOperationFilterInput>;
};

/** GraphqlAccess */
export type Wf_AdminFirst_GraphqlAccessInput = {
  /** AccessSchema */
  accessSchema?: InputMaybe<Scalars['String']['input']>;
  /** AccessSchemaHash */
  accessSchemaHash?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Database */
  database?: InputMaybe<Scalars['String']['input']>;
  /** [ID] GraphqlAccessId */
  graphqlAccessId?: InputMaybe<Scalars['UUID']['input']>;
  /** [NAVIGATION] GraphqlSchema */
  graphqlSchema?: InputMaybe<Wf_AdminFirst_GraphqlSchemaInput>;
  /** [NOT NULL] GraphqlSchemaId */
  graphqlSchemaId?: InputMaybe<Scalars['UUID']['input']>;
  /** [NOT NULL] ProjectId */
  projectId?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Server */
  server?: InputMaybe<Scalars['String']['input']>;
  /** UpdateTime */
  updateTime?: InputMaybe<Scalars['DateTime']['input']>;
};

/** GraphqlAccess */
export type Wf_AdminFirst_GraphqlAccessSortInput = {
  /** AccessSchema */
  accessSchema?: InputMaybe<SortEnumType>;
  /** AccessSchemaHash */
  accessSchemaHash?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Database */
  database?: InputMaybe<SortEnumType>;
  /** [ID] GraphqlAccessId */
  graphqlAccessId?: InputMaybe<SortEnumType>;
  /** [NAVIGATION] GraphqlSchema */
  graphqlSchema?: InputMaybe<Wf_AdminFirst_GraphqlSchemaSortInput>;
  /** [NOT NULL] GraphqlSchemaId */
  graphqlSchemaId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] ProjectId */
  projectId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Server */
  server?: InputMaybe<SortEnumType>;
  /** UpdateTime */
  updateTime?: InputMaybe<SortEnumType>;
};

/** GraphqlSchema */
export type Wf_AdminFirst_GraphqlSchema = Node & {
  __typename?: 'WF_AdminFirst_GraphqlSchema';
  /** [NOT NULL] Database */
  database?: Maybe<Scalars['String']['output']>;
  /** [COLLECTION] GraphqlAccesses */
  graphqlAccesses?: Maybe<Array<Maybe<Wf_AdminFirst_GraphqlAccess>>>;
  /** [ID] GraphqlSchemaId */
  id: Scalars['ID']['output'];
  /** Schema */
  schema?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Server */
  server?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Wf_AdminFirst_GraphqlSchemaConnection = {
  __typename?: 'WF_AdminFirst_GraphqlSchemaConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_AdminFirst_GraphqlSchemaEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_AdminFirst_GraphqlSchema>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_AdminFirst_GraphqlSchemaEdge = {
  __typename?: 'WF_AdminFirst_GraphqlSchemaEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_AdminFirst_GraphqlSchema;
};

/** GraphqlSchema */
export type Wf_AdminFirst_GraphqlSchemaFilterInput = {
  and?: InputMaybe<Array<Wf_AdminFirst_GraphqlSchemaFilterInput>>;
  /** [NOT NULL] Database */
  database?: InputMaybe<StringOperationFilterInput>;
  /** [COLLECTION] GraphqlAccesses */
  graphqlAccesses?: InputMaybe<ListFilterInputTypeOfWf_AdminFirst_GraphqlAccessFilterInput>;
  /** [ID] GraphqlSchemaId */
  graphqlSchemaId?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<Wf_AdminFirst_GraphqlSchemaFilterInput>>;
  /** Schema */
  schema?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] Server */
  server?: InputMaybe<StringOperationFilterInput>;
};

/** GraphqlSchema */
export type Wf_AdminFirst_GraphqlSchemaInput = {
  /** [NOT NULL] Database */
  database?: InputMaybe<Scalars['String']['input']>;
  /** [COLLECTION] GraphqlAccesses */
  graphqlAccesses?: InputMaybe<Array<InputMaybe<Wf_AdminFirst_GraphqlAccessInput>>>;
  /** [ID] GraphqlSchemaId */
  graphqlSchemaId?: InputMaybe<Scalars['UUID']['input']>;
  /** Schema */
  schema?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Server */
  server?: InputMaybe<Scalars['String']['input']>;
};

/** GraphqlSchema */
export type Wf_AdminFirst_GraphqlSchemaSortInput = {
  /** [NOT NULL] Database */
  database?: InputMaybe<SortEnumType>;
  /** [ID] GraphqlSchemaId */
  graphqlSchemaId?: InputMaybe<SortEnumType>;
  /** Schema */
  schema?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Server */
  server?: InputMaybe<SortEnumType>;
};

export type Wf_AdminFirst_Mutation_Add = {
  __typename?: 'WF_AdminFirst_Mutation_Add';
  a?: Maybe<Wf_AdminFirst_A>;
  ab?: Maybe<Wf_AdminFirst_Ab>;
  afNotification?: Maybe<Wf_AdminFirst_AfNotification>;
  afNotificationButtonLink?: Maybe<Wf_AdminFirst_AfNotificationButtonLink>;
  afNotificationButtonLinkMarket?: Maybe<Wf_AdminFirst_AfNotificationButtonLinkMarket>;
  afNotificationMember?: Maybe<Wf_AdminFirst_AfNotificationMember>;
  afNotificationMemberLog?: Maybe<Wf_AdminFirst_AfNotificationMemberLog>;
  afNotificationServiceType?: Maybe<Wf_AdminFirst_AfNotificationServiceType>;
  afNotificationServiceTypeMarket?: Maybe<Wf_AdminFirst_AfNotificationServiceTypeMarket>;
  afProgram?: Maybe<Wf_AdminFirst_AfProgram>;
  afService?: Maybe<Wf_AdminFirst_AfService>;
  afUser?: Maybe<Wf_AdminFirst_AfUser>;
  afUserMarket?: Maybe<Wf_AdminFirst_AfUserMarket>;
  afUserProgram?: Maybe<Wf_AdminFirst_AfUserProgram>;
  afUserService?: Maybe<Wf_AdminFirst_AfUserService>;
  childGraduationApplication?: Maybe<Wf_AdminFirst_ChildGraduationApplication>;
  graduationApplication?: Maybe<Wf_AdminFirst_GraduationApplication>;
  graphqlAccess?: Maybe<Wf_AdminFirst_GraphqlAccess>;
  graphqlSchema?: Maybe<Wf_AdminFirst_GraphqlSchema>;
  teamSetting?: Maybe<Wf_AdminFirst_TeamSetting>;
  tempFaceCall?: Maybe<Wf_AdminFirst_TempFaceCall>;
  tempPrepaidMembershipFee?: Maybe<Wf_AdminFirst_TempPrepaidMembershipFee>;
  tepsDailyHour?: Maybe<Wf_AdminFirst_TepsDailyHour>;
  tepsDailyHourLocationType?: Maybe<Wf_AdminFirst_TepsDailyHourLocationType>;
  tepsDailyHourType?: Maybe<Wf_AdminFirst_TepsDailyHourType>;
  tepsProject?: Maybe<Wf_AdminFirst_TepsProject>;
  tepsProjectAllocatedType?: Maybe<Wf_AdminFirst_TepsProjectAllocatedType>;
  tepsProjectType?: Maybe<Wf_AdminFirst_TepsProjectType>;
  tepsProjection?: Maybe<Wf_AdminFirst_TepsProjection>;
  tepsUser?: Maybe<Wf_AdminFirst_TepsUser>;
  tepsUserProject?: Maybe<Wf_AdminFirst_TepsUserProject>;
};

export type Wf_AdminFirst_Mutation_AddInput = {
  a?: InputMaybe<Wf_AdminFirst_AInput>;
  ab?: InputMaybe<Wf_AdminFirst_AbInput>;
  afNotification?: InputMaybe<Wf_AdminFirst_AfNotificationInput>;
  afNotificationButtonLink?: InputMaybe<Wf_AdminFirst_AfNotificationButtonLinkInput>;
  afNotificationButtonLinkMarket?: InputMaybe<Wf_AdminFirst_AfNotificationButtonLinkMarketInput>;
  afNotificationMember?: InputMaybe<Wf_AdminFirst_AfNotificationMemberInput>;
  afNotificationMemberLog?: InputMaybe<Wf_AdminFirst_AfNotificationMemberLogInput>;
  afNotificationServiceType?: InputMaybe<Wf_AdminFirst_AfNotificationServiceTypeInput>;
  afNotificationServiceTypeMarket?: InputMaybe<Wf_AdminFirst_AfNotificationServiceTypeMarketInput>;
  afProgram?: InputMaybe<Wf_AdminFirst_AfProgramInput>;
  afService?: InputMaybe<Wf_AdminFirst_AfServiceInput>;
  afUser?: InputMaybe<Wf_AdminFirst_AfUserInput>;
  afUserMarket?: InputMaybe<Wf_AdminFirst_AfUserMarketInput>;
  afUserProgram?: InputMaybe<Wf_AdminFirst_AfUserProgramInput>;
  afUserService?: InputMaybe<Wf_AdminFirst_AfUserServiceInput>;
  childGraduationApplication?: InputMaybe<Wf_AdminFirst_ChildGraduationApplicationInput>;
  graduationApplication?: InputMaybe<Wf_AdminFirst_GraduationApplicationInput>;
  graphqlAccess?: InputMaybe<Wf_AdminFirst_GraphqlAccessInput>;
  graphqlSchema?: InputMaybe<Wf_AdminFirst_GraphqlSchemaInput>;
  teamSetting?: InputMaybe<Wf_AdminFirst_TeamSettingInput>;
  tempFaceCall?: InputMaybe<Wf_AdminFirst_TempFaceCallInput>;
  tempPrepaidMembershipFee?: InputMaybe<Wf_AdminFirst_TempPrepaidMembershipFeeInput>;
  tepsDailyHour?: InputMaybe<Wf_AdminFirst_TepsDailyHourInput>;
  tepsDailyHourLocationType?: InputMaybe<Wf_AdminFirst_TepsDailyHourLocationTypeInput>;
  tepsDailyHourType?: InputMaybe<Wf_AdminFirst_TepsDailyHourTypeInput>;
  tepsProject?: InputMaybe<Wf_AdminFirst_TepsProjectInput>;
  tepsProjectAllocatedType?: InputMaybe<Wf_AdminFirst_TepsProjectAllocatedTypeInput>;
  tepsProjectType?: InputMaybe<Wf_AdminFirst_TepsProjectTypeInput>;
  tepsProjection?: InputMaybe<Wf_AdminFirst_TepsProjectionInput>;
  tepsUser?: InputMaybe<Wf_AdminFirst_TepsUserInput>;
  tepsUserProject?: InputMaybe<Wf_AdminFirst_TepsUserProjectInput>;
};

export type Wf_AdminFirst_Mutation_AddRange = {
  __typename?: 'WF_AdminFirst_Mutation_AddRange';
  abs?: Maybe<Array<Wf_AdminFirst_Ab>>;
  afNotificationButtonLinkMarkets?: Maybe<Array<Wf_AdminFirst_AfNotificationButtonLinkMarket>>;
  afNotificationButtonLinks?: Maybe<Array<Wf_AdminFirst_AfNotificationButtonLink>>;
  afNotificationMemberLogs?: Maybe<Array<Wf_AdminFirst_AfNotificationMemberLog>>;
  afNotificationMembers?: Maybe<Array<Wf_AdminFirst_AfNotificationMember>>;
  afNotificationServiceTypeMarkets?: Maybe<Array<Wf_AdminFirst_AfNotificationServiceTypeMarket>>;
  afNotificationServiceTypes?: Maybe<Array<Wf_AdminFirst_AfNotificationServiceType>>;
  afNotifications?: Maybe<Array<Wf_AdminFirst_AfNotification>>;
  afPrograms?: Maybe<Array<Wf_AdminFirst_AfProgram>>;
  afServices?: Maybe<Array<Wf_AdminFirst_AfService>>;
  afUserMarkets?: Maybe<Array<Wf_AdminFirst_AfUserMarket>>;
  afUserPrograms?: Maybe<Array<Wf_AdminFirst_AfUserProgram>>;
  afUserServices?: Maybe<Array<Wf_AdminFirst_AfUserService>>;
  afUsers?: Maybe<Array<Wf_AdminFirst_AfUser>>;
  as?: Maybe<Array<Wf_AdminFirst_A>>;
  childGraduationApplications?: Maybe<Array<Wf_AdminFirst_ChildGraduationApplication>>;
  graduationApplications?: Maybe<Array<Wf_AdminFirst_GraduationApplication>>;
  graphqlAccesses?: Maybe<Array<Wf_AdminFirst_GraphqlAccess>>;
  graphqlSchemas?: Maybe<Array<Wf_AdminFirst_GraphqlSchema>>;
  teamSettings?: Maybe<Array<Wf_AdminFirst_TeamSetting>>;
  tempFaceCalls?: Maybe<Array<Wf_AdminFirst_TempFaceCall>>;
  tempPrepaidMembershipFees?: Maybe<Array<Wf_AdminFirst_TempPrepaidMembershipFee>>;
  tepsDailyHourLocationTypes?: Maybe<Array<Wf_AdminFirst_TepsDailyHourLocationType>>;
  tepsDailyHourTypes?: Maybe<Array<Wf_AdminFirst_TepsDailyHourType>>;
  tepsDailyHours?: Maybe<Array<Wf_AdminFirst_TepsDailyHour>>;
  tepsProjectAllocatedTypes?: Maybe<Array<Wf_AdminFirst_TepsProjectAllocatedType>>;
  tepsProjectTypes?: Maybe<Array<Wf_AdminFirst_TepsProjectType>>;
  tepsProjections?: Maybe<Array<Wf_AdminFirst_TepsProjection>>;
  tepsProjects?: Maybe<Array<Wf_AdminFirst_TepsProject>>;
  tepsUserProjects?: Maybe<Array<Wf_AdminFirst_TepsUserProject>>;
  tepsUsers?: Maybe<Array<Wf_AdminFirst_TepsUser>>;
};

export type Wf_AdminFirst_Mutation_AddRangeInput = {
  abs?: InputMaybe<Array<Wf_AdminFirst_AbInput>>;
  afNotificationButtonLinkMarkets?: InputMaybe<Array<Wf_AdminFirst_AfNotificationButtonLinkMarketInput>>;
  afNotificationButtonLinks?: InputMaybe<Array<Wf_AdminFirst_AfNotificationButtonLinkInput>>;
  afNotificationMemberLogs?: InputMaybe<Array<Wf_AdminFirst_AfNotificationMemberLogInput>>;
  afNotificationMembers?: InputMaybe<Array<Wf_AdminFirst_AfNotificationMemberInput>>;
  afNotificationServiceTypeMarkets?: InputMaybe<Array<Wf_AdminFirst_AfNotificationServiceTypeMarketInput>>;
  afNotificationServiceTypes?: InputMaybe<Array<Wf_AdminFirst_AfNotificationServiceTypeInput>>;
  afNotifications?: InputMaybe<Array<Wf_AdminFirst_AfNotificationInput>>;
  afPrograms?: InputMaybe<Array<Wf_AdminFirst_AfProgramInput>>;
  afServices?: InputMaybe<Array<Wf_AdminFirst_AfServiceInput>>;
  afUserMarkets?: InputMaybe<Array<Wf_AdminFirst_AfUserMarketInput>>;
  afUserPrograms?: InputMaybe<Array<Wf_AdminFirst_AfUserProgramInput>>;
  afUserServices?: InputMaybe<Array<Wf_AdminFirst_AfUserServiceInput>>;
  afUsers?: InputMaybe<Array<Wf_AdminFirst_AfUserInput>>;
  as?: InputMaybe<Array<Wf_AdminFirst_AInput>>;
  childGraduationApplications?: InputMaybe<Array<Wf_AdminFirst_ChildGraduationApplicationInput>>;
  graduationApplications?: InputMaybe<Array<Wf_AdminFirst_GraduationApplicationInput>>;
  graphqlAccesses?: InputMaybe<Array<Wf_AdminFirst_GraphqlAccessInput>>;
  graphqlSchemas?: InputMaybe<Array<Wf_AdminFirst_GraphqlSchemaInput>>;
  teamSettings?: InputMaybe<Array<Wf_AdminFirst_TeamSettingInput>>;
  tempFaceCalls?: InputMaybe<Array<Wf_AdminFirst_TempFaceCallInput>>;
  tempPrepaidMembershipFees?: InputMaybe<Array<Wf_AdminFirst_TempPrepaidMembershipFeeInput>>;
  tepsDailyHourLocationTypes?: InputMaybe<Array<Wf_AdminFirst_TepsDailyHourLocationTypeInput>>;
  tepsDailyHourTypes?: InputMaybe<Array<Wf_AdminFirst_TepsDailyHourTypeInput>>;
  tepsDailyHours?: InputMaybe<Array<Wf_AdminFirst_TepsDailyHourInput>>;
  tepsProjectAllocatedTypes?: InputMaybe<Array<Wf_AdminFirst_TepsProjectAllocatedTypeInput>>;
  tepsProjectTypes?: InputMaybe<Array<Wf_AdminFirst_TepsProjectTypeInput>>;
  tepsProjections?: InputMaybe<Array<Wf_AdminFirst_TepsProjectionInput>>;
  tepsProjects?: InputMaybe<Array<Wf_AdminFirst_TepsProjectInput>>;
  tepsUserProjects?: InputMaybe<Array<Wf_AdminFirst_TepsUserProjectInput>>;
  tepsUsers?: InputMaybe<Array<Wf_AdminFirst_TepsUserInput>>;
};

export type Wf_AdminFirst_Mutation_Payload = {
  __typename?: 'WF_AdminFirst_Mutation_Payload';
  addContext?: Maybe<Wf_AdminFirst_Mutation_Add>;
  addRangeContext?: Maybe<Wf_AdminFirst_Mutation_AddRange>;
  count: Scalars['Int']['output'];
  query: Query;
  updateContext?: Maybe<Wf_AdminFirst_Mutation_Update>;
  updateRangeContext?: Maybe<Wf_AdminFirst_Mutation_UpdateRange>;
};

export type Wf_AdminFirst_Mutation_RemoveInput = {
  a?: InputMaybe<Wf_AdminFirst_AInput>;
  ab?: InputMaybe<Wf_AdminFirst_AbInput>;
  afNotification?: InputMaybe<Wf_AdminFirst_AfNotificationInput>;
  afNotificationButtonLink?: InputMaybe<Wf_AdminFirst_AfNotificationButtonLinkInput>;
  afNotificationButtonLinkMarket?: InputMaybe<Wf_AdminFirst_AfNotificationButtonLinkMarketInput>;
  afNotificationMember?: InputMaybe<Wf_AdminFirst_AfNotificationMemberInput>;
  afNotificationMemberLog?: InputMaybe<Wf_AdminFirst_AfNotificationMemberLogInput>;
  afNotificationServiceType?: InputMaybe<Wf_AdminFirst_AfNotificationServiceTypeInput>;
  afNotificationServiceTypeMarket?: InputMaybe<Wf_AdminFirst_AfNotificationServiceTypeMarketInput>;
  afProgram?: InputMaybe<Wf_AdminFirst_AfProgramInput>;
  afService?: InputMaybe<Wf_AdminFirst_AfServiceInput>;
  afUser?: InputMaybe<Wf_AdminFirst_AfUserInput>;
  afUserMarket?: InputMaybe<Wf_AdminFirst_AfUserMarketInput>;
  afUserProgram?: InputMaybe<Wf_AdminFirst_AfUserProgramInput>;
  afUserService?: InputMaybe<Wf_AdminFirst_AfUserServiceInput>;
  childGraduationApplication?: InputMaybe<Wf_AdminFirst_ChildGraduationApplicationInput>;
  graduationApplication?: InputMaybe<Wf_AdminFirst_GraduationApplicationInput>;
  graphqlAccess?: InputMaybe<Wf_AdminFirst_GraphqlAccessInput>;
  graphqlSchema?: InputMaybe<Wf_AdminFirst_GraphqlSchemaInput>;
  teamSetting?: InputMaybe<Wf_AdminFirst_TeamSettingInput>;
  tempFaceCall?: InputMaybe<Wf_AdminFirst_TempFaceCallInput>;
  tempPrepaidMembershipFee?: InputMaybe<Wf_AdminFirst_TempPrepaidMembershipFeeInput>;
  tepsDailyHour?: InputMaybe<Wf_AdminFirst_TepsDailyHourInput>;
  tepsDailyHourLocationType?: InputMaybe<Wf_AdminFirst_TepsDailyHourLocationTypeInput>;
  tepsDailyHourType?: InputMaybe<Wf_AdminFirst_TepsDailyHourTypeInput>;
  tepsProject?: InputMaybe<Wf_AdminFirst_TepsProjectInput>;
  tepsProjectAllocatedType?: InputMaybe<Wf_AdminFirst_TepsProjectAllocatedTypeInput>;
  tepsProjectType?: InputMaybe<Wf_AdminFirst_TepsProjectTypeInput>;
  tepsProjection?: InputMaybe<Wf_AdminFirst_TepsProjectionInput>;
  tepsUser?: InputMaybe<Wf_AdminFirst_TepsUserInput>;
  tepsUserProject?: InputMaybe<Wf_AdminFirst_TepsUserProjectInput>;
};

export type Wf_AdminFirst_Mutation_RemoveRangeInput = {
  abs?: InputMaybe<Array<Wf_AdminFirst_AbInput>>;
  afNotificationButtonLinkMarkets?: InputMaybe<Array<Wf_AdminFirst_AfNotificationButtonLinkMarketInput>>;
  afNotificationButtonLinks?: InputMaybe<Array<Wf_AdminFirst_AfNotificationButtonLinkInput>>;
  afNotificationMemberLogs?: InputMaybe<Array<Wf_AdminFirst_AfNotificationMemberLogInput>>;
  afNotificationMembers?: InputMaybe<Array<Wf_AdminFirst_AfNotificationMemberInput>>;
  afNotificationServiceTypeMarkets?: InputMaybe<Array<Wf_AdminFirst_AfNotificationServiceTypeMarketInput>>;
  afNotificationServiceTypes?: InputMaybe<Array<Wf_AdminFirst_AfNotificationServiceTypeInput>>;
  afNotifications?: InputMaybe<Array<Wf_AdminFirst_AfNotificationInput>>;
  afPrograms?: InputMaybe<Array<Wf_AdminFirst_AfProgramInput>>;
  afServices?: InputMaybe<Array<Wf_AdminFirst_AfServiceInput>>;
  afUserMarkets?: InputMaybe<Array<Wf_AdminFirst_AfUserMarketInput>>;
  afUserPrograms?: InputMaybe<Array<Wf_AdminFirst_AfUserProgramInput>>;
  afUserServices?: InputMaybe<Array<Wf_AdminFirst_AfUserServiceInput>>;
  afUsers?: InputMaybe<Array<Wf_AdminFirst_AfUserInput>>;
  as?: InputMaybe<Array<Wf_AdminFirst_AInput>>;
  childGraduationApplications?: InputMaybe<Array<Wf_AdminFirst_ChildGraduationApplicationInput>>;
  graduationApplications?: InputMaybe<Array<Wf_AdminFirst_GraduationApplicationInput>>;
  graphqlAccesses?: InputMaybe<Array<Wf_AdminFirst_GraphqlAccessInput>>;
  graphqlSchemas?: InputMaybe<Array<Wf_AdminFirst_GraphqlSchemaInput>>;
  teamSettings?: InputMaybe<Array<Wf_AdminFirst_TeamSettingInput>>;
  tempFaceCalls?: InputMaybe<Array<Wf_AdminFirst_TempFaceCallInput>>;
  tempPrepaidMembershipFees?: InputMaybe<Array<Wf_AdminFirst_TempPrepaidMembershipFeeInput>>;
  tepsDailyHourLocationTypes?: InputMaybe<Array<Wf_AdminFirst_TepsDailyHourLocationTypeInput>>;
  tepsDailyHourTypes?: InputMaybe<Array<Wf_AdminFirst_TepsDailyHourTypeInput>>;
  tepsDailyHours?: InputMaybe<Array<Wf_AdminFirst_TepsDailyHourInput>>;
  tepsProjectAllocatedTypes?: InputMaybe<Array<Wf_AdminFirst_TepsProjectAllocatedTypeInput>>;
  tepsProjectTypes?: InputMaybe<Array<Wf_AdminFirst_TepsProjectTypeInput>>;
  tepsProjections?: InputMaybe<Array<Wf_AdminFirst_TepsProjectionInput>>;
  tepsProjects?: InputMaybe<Array<Wf_AdminFirst_TepsProjectInput>>;
  tepsUserProjects?: InputMaybe<Array<Wf_AdminFirst_TepsUserProjectInput>>;
  tepsUsers?: InputMaybe<Array<Wf_AdminFirst_TepsUserInput>>;
};

export type Wf_AdminFirst_Mutation_Update = {
  __typename?: 'WF_AdminFirst_Mutation_Update';
  a?: Maybe<Wf_AdminFirst_A>;
  ab?: Maybe<Wf_AdminFirst_Ab>;
  afNotification?: Maybe<Wf_AdminFirst_AfNotification>;
  afNotificationButtonLink?: Maybe<Wf_AdminFirst_AfNotificationButtonLink>;
  afNotificationButtonLinkMarket?: Maybe<Wf_AdminFirst_AfNotificationButtonLinkMarket>;
  afNotificationMember?: Maybe<Wf_AdminFirst_AfNotificationMember>;
  afNotificationMemberLog?: Maybe<Wf_AdminFirst_AfNotificationMemberLog>;
  afNotificationServiceType?: Maybe<Wf_AdminFirst_AfNotificationServiceType>;
  afNotificationServiceTypeMarket?: Maybe<Wf_AdminFirst_AfNotificationServiceTypeMarket>;
  afProgram?: Maybe<Wf_AdminFirst_AfProgram>;
  afService?: Maybe<Wf_AdminFirst_AfService>;
  afUser?: Maybe<Wf_AdminFirst_AfUser>;
  afUserMarket?: Maybe<Wf_AdminFirst_AfUserMarket>;
  afUserProgram?: Maybe<Wf_AdminFirst_AfUserProgram>;
  afUserService?: Maybe<Wf_AdminFirst_AfUserService>;
  childGraduationApplication?: Maybe<Wf_AdminFirst_ChildGraduationApplication>;
  graduationApplication?: Maybe<Wf_AdminFirst_GraduationApplication>;
  graphqlAccess?: Maybe<Wf_AdminFirst_GraphqlAccess>;
  graphqlSchema?: Maybe<Wf_AdminFirst_GraphqlSchema>;
  teamSetting?: Maybe<Wf_AdminFirst_TeamSetting>;
  tempFaceCall?: Maybe<Wf_AdminFirst_TempFaceCall>;
  tempPrepaidMembershipFee?: Maybe<Wf_AdminFirst_TempPrepaidMembershipFee>;
  tepsDailyHour?: Maybe<Wf_AdminFirst_TepsDailyHour>;
  tepsDailyHourLocationType?: Maybe<Wf_AdminFirst_TepsDailyHourLocationType>;
  tepsDailyHourType?: Maybe<Wf_AdminFirst_TepsDailyHourType>;
  tepsProject?: Maybe<Wf_AdminFirst_TepsProject>;
  tepsProjectAllocatedType?: Maybe<Wf_AdminFirst_TepsProjectAllocatedType>;
  tepsProjectType?: Maybe<Wf_AdminFirst_TepsProjectType>;
  tepsProjection?: Maybe<Wf_AdminFirst_TepsProjection>;
  tepsUser?: Maybe<Wf_AdminFirst_TepsUser>;
  tepsUserProject?: Maybe<Wf_AdminFirst_TepsUserProject>;
};

export type Wf_AdminFirst_Mutation_UpdateInput = {
  a?: InputMaybe<Wf_AdminFirst_AInput>;
  ab?: InputMaybe<Wf_AdminFirst_AbInput>;
  afNotification?: InputMaybe<Wf_AdminFirst_AfNotificationInput>;
  afNotificationButtonLink?: InputMaybe<Wf_AdminFirst_AfNotificationButtonLinkInput>;
  afNotificationButtonLinkMarket?: InputMaybe<Wf_AdminFirst_AfNotificationButtonLinkMarketInput>;
  afNotificationMember?: InputMaybe<Wf_AdminFirst_AfNotificationMemberInput>;
  afNotificationMemberLog?: InputMaybe<Wf_AdminFirst_AfNotificationMemberLogInput>;
  afNotificationServiceType?: InputMaybe<Wf_AdminFirst_AfNotificationServiceTypeInput>;
  afNotificationServiceTypeMarket?: InputMaybe<Wf_AdminFirst_AfNotificationServiceTypeMarketInput>;
  afProgram?: InputMaybe<Wf_AdminFirst_AfProgramInput>;
  afService?: InputMaybe<Wf_AdminFirst_AfServiceInput>;
  afUser?: InputMaybe<Wf_AdminFirst_AfUserInput>;
  afUserMarket?: InputMaybe<Wf_AdminFirst_AfUserMarketInput>;
  afUserProgram?: InputMaybe<Wf_AdminFirst_AfUserProgramInput>;
  afUserService?: InputMaybe<Wf_AdminFirst_AfUserServiceInput>;
  childGraduationApplication?: InputMaybe<Wf_AdminFirst_ChildGraduationApplicationInput>;
  graduationApplication?: InputMaybe<Wf_AdminFirst_GraduationApplicationInput>;
  graphqlAccess?: InputMaybe<Wf_AdminFirst_GraphqlAccessInput>;
  graphqlSchema?: InputMaybe<Wf_AdminFirst_GraphqlSchemaInput>;
  teamSetting?: InputMaybe<Wf_AdminFirst_TeamSettingInput>;
  tempFaceCall?: InputMaybe<Wf_AdminFirst_TempFaceCallInput>;
  tempPrepaidMembershipFee?: InputMaybe<Wf_AdminFirst_TempPrepaidMembershipFeeInput>;
  tepsDailyHour?: InputMaybe<Wf_AdminFirst_TepsDailyHourInput>;
  tepsDailyHourLocationType?: InputMaybe<Wf_AdminFirst_TepsDailyHourLocationTypeInput>;
  tepsDailyHourType?: InputMaybe<Wf_AdminFirst_TepsDailyHourTypeInput>;
  tepsProject?: InputMaybe<Wf_AdminFirst_TepsProjectInput>;
  tepsProjectAllocatedType?: InputMaybe<Wf_AdminFirst_TepsProjectAllocatedTypeInput>;
  tepsProjectType?: InputMaybe<Wf_AdminFirst_TepsProjectTypeInput>;
  tepsProjection?: InputMaybe<Wf_AdminFirst_TepsProjectionInput>;
  tepsUser?: InputMaybe<Wf_AdminFirst_TepsUserInput>;
  tepsUserProject?: InputMaybe<Wf_AdminFirst_TepsUserProjectInput>;
};

export type Wf_AdminFirst_Mutation_UpdateRange = {
  __typename?: 'WF_AdminFirst_Mutation_UpdateRange';
  abs?: Maybe<Array<Wf_AdminFirst_Ab>>;
  afNotificationButtonLinkMarkets?: Maybe<Array<Wf_AdminFirst_AfNotificationButtonLinkMarket>>;
  afNotificationButtonLinks?: Maybe<Array<Wf_AdminFirst_AfNotificationButtonLink>>;
  afNotificationMemberLogs?: Maybe<Array<Wf_AdminFirst_AfNotificationMemberLog>>;
  afNotificationMembers?: Maybe<Array<Wf_AdminFirst_AfNotificationMember>>;
  afNotificationServiceTypeMarkets?: Maybe<Array<Wf_AdminFirst_AfNotificationServiceTypeMarket>>;
  afNotificationServiceTypes?: Maybe<Array<Wf_AdminFirst_AfNotificationServiceType>>;
  afNotifications?: Maybe<Array<Wf_AdminFirst_AfNotification>>;
  afPrograms?: Maybe<Array<Wf_AdminFirst_AfProgram>>;
  afServices?: Maybe<Array<Wf_AdminFirst_AfService>>;
  afUserMarkets?: Maybe<Array<Wf_AdminFirst_AfUserMarket>>;
  afUserPrograms?: Maybe<Array<Wf_AdminFirst_AfUserProgram>>;
  afUserServices?: Maybe<Array<Wf_AdminFirst_AfUserService>>;
  afUsers?: Maybe<Array<Wf_AdminFirst_AfUser>>;
  as?: Maybe<Array<Wf_AdminFirst_A>>;
  childGraduationApplications?: Maybe<Array<Wf_AdminFirst_ChildGraduationApplication>>;
  graduationApplications?: Maybe<Array<Wf_AdminFirst_GraduationApplication>>;
  graphqlAccesses?: Maybe<Array<Wf_AdminFirst_GraphqlAccess>>;
  graphqlSchemas?: Maybe<Array<Wf_AdminFirst_GraphqlSchema>>;
  teamSettings?: Maybe<Array<Wf_AdminFirst_TeamSetting>>;
  tempFaceCalls?: Maybe<Array<Wf_AdminFirst_TempFaceCall>>;
  tempPrepaidMembershipFees?: Maybe<Array<Wf_AdminFirst_TempPrepaidMembershipFee>>;
  tepsDailyHourLocationTypes?: Maybe<Array<Wf_AdminFirst_TepsDailyHourLocationType>>;
  tepsDailyHourTypes?: Maybe<Array<Wf_AdminFirst_TepsDailyHourType>>;
  tepsDailyHours?: Maybe<Array<Wf_AdminFirst_TepsDailyHour>>;
  tepsProjectAllocatedTypes?: Maybe<Array<Wf_AdminFirst_TepsProjectAllocatedType>>;
  tepsProjectTypes?: Maybe<Array<Wf_AdminFirst_TepsProjectType>>;
  tepsProjections?: Maybe<Array<Wf_AdminFirst_TepsProjection>>;
  tepsProjects?: Maybe<Array<Wf_AdminFirst_TepsProject>>;
  tepsUserProjects?: Maybe<Array<Wf_AdminFirst_TepsUserProject>>;
  tepsUsers?: Maybe<Array<Wf_AdminFirst_TepsUser>>;
};

export type Wf_AdminFirst_Mutation_UpdateRangeInput = {
  abs?: InputMaybe<Array<Wf_AdminFirst_AbInput>>;
  afNotificationButtonLinkMarkets?: InputMaybe<Array<Wf_AdminFirst_AfNotificationButtonLinkMarketInput>>;
  afNotificationButtonLinks?: InputMaybe<Array<Wf_AdminFirst_AfNotificationButtonLinkInput>>;
  afNotificationMemberLogs?: InputMaybe<Array<Wf_AdminFirst_AfNotificationMemberLogInput>>;
  afNotificationMembers?: InputMaybe<Array<Wf_AdminFirst_AfNotificationMemberInput>>;
  afNotificationServiceTypeMarkets?: InputMaybe<Array<Wf_AdminFirst_AfNotificationServiceTypeMarketInput>>;
  afNotificationServiceTypes?: InputMaybe<Array<Wf_AdminFirst_AfNotificationServiceTypeInput>>;
  afNotifications?: InputMaybe<Array<Wf_AdminFirst_AfNotificationInput>>;
  afPrograms?: InputMaybe<Array<Wf_AdminFirst_AfProgramInput>>;
  afServices?: InputMaybe<Array<Wf_AdminFirst_AfServiceInput>>;
  afUserMarkets?: InputMaybe<Array<Wf_AdminFirst_AfUserMarketInput>>;
  afUserPrograms?: InputMaybe<Array<Wf_AdminFirst_AfUserProgramInput>>;
  afUserServices?: InputMaybe<Array<Wf_AdminFirst_AfUserServiceInput>>;
  afUsers?: InputMaybe<Array<Wf_AdminFirst_AfUserInput>>;
  as?: InputMaybe<Array<Wf_AdminFirst_AInput>>;
  childGraduationApplications?: InputMaybe<Array<Wf_AdminFirst_ChildGraduationApplicationInput>>;
  graduationApplications?: InputMaybe<Array<Wf_AdminFirst_GraduationApplicationInput>>;
  graphqlAccesses?: InputMaybe<Array<Wf_AdminFirst_GraphqlAccessInput>>;
  graphqlSchemas?: InputMaybe<Array<Wf_AdminFirst_GraphqlSchemaInput>>;
  teamSettings?: InputMaybe<Array<Wf_AdminFirst_TeamSettingInput>>;
  tempFaceCalls?: InputMaybe<Array<Wf_AdminFirst_TempFaceCallInput>>;
  tempPrepaidMembershipFees?: InputMaybe<Array<Wf_AdminFirst_TempPrepaidMembershipFeeInput>>;
  tepsDailyHourLocationTypes?: InputMaybe<Array<Wf_AdminFirst_TepsDailyHourLocationTypeInput>>;
  tepsDailyHourTypes?: InputMaybe<Array<Wf_AdminFirst_TepsDailyHourTypeInput>>;
  tepsDailyHours?: InputMaybe<Array<Wf_AdminFirst_TepsDailyHourInput>>;
  tepsProjectAllocatedTypes?: InputMaybe<Array<Wf_AdminFirst_TepsProjectAllocatedTypeInput>>;
  tepsProjectTypes?: InputMaybe<Array<Wf_AdminFirst_TepsProjectTypeInput>>;
  tepsProjections?: InputMaybe<Array<Wf_AdminFirst_TepsProjectionInput>>;
  tepsProjects?: InputMaybe<Array<Wf_AdminFirst_TepsProjectInput>>;
  tepsUserProjects?: InputMaybe<Array<Wf_AdminFirst_TepsUserProjectInput>>;
  tepsUsers?: InputMaybe<Array<Wf_AdminFirst_TepsUserInput>>;
};

/** TeamSetting */
export type Wf_AdminFirst_TeamSetting = Node & {
  __typename?: 'WF_AdminFirst_TeamSetting';
  /** ChannelId */
  channelId?: Maybe<Scalars['String']['output']>;
  /** [ID] TeamSettingId */
  id: Scalars['ID']['output'];
  /** IncomingWebhookUrl */
  incomingWebhookUrl?: Maybe<Scalars['String']['output']>;
  /** TeamId */
  teamId?: Maybe<Scalars['String']['output']>;
  /** TeamName */
  teamName?: Maybe<Scalars['String']['output']>;
  /** TeamType */
  teamType?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Wf_AdminFirst_TeamSettingConnection = {
  __typename?: 'WF_AdminFirst_TeamSettingConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_AdminFirst_TeamSettingEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_AdminFirst_TeamSetting>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_AdminFirst_TeamSettingEdge = {
  __typename?: 'WF_AdminFirst_TeamSettingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_AdminFirst_TeamSetting;
};

/** TeamSetting */
export type Wf_AdminFirst_TeamSettingFilterInput = {
  and?: InputMaybe<Array<Wf_AdminFirst_TeamSettingFilterInput>>;
  /** ChannelId */
  channelId?: InputMaybe<StringOperationFilterInput>;
  /** IncomingWebhookUrl */
  incomingWebhookUrl?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Wf_AdminFirst_TeamSettingFilterInput>>;
  /** TeamId */
  teamId?: InputMaybe<StringOperationFilterInput>;
  /** TeamName */
  teamName?: InputMaybe<StringOperationFilterInput>;
  /** [ID] TeamSettingId */
  teamSettingId?: InputMaybe<IntOperationFilterInput>;
  /** TeamType */
  teamType?: InputMaybe<StringOperationFilterInput>;
};

/** TeamSetting */
export type Wf_AdminFirst_TeamSettingInput = {
  /** ChannelId */
  channelId?: InputMaybe<Scalars['String']['input']>;
  /** IncomingWebhookUrl */
  incomingWebhookUrl?: InputMaybe<Scalars['String']['input']>;
  /** TeamId */
  teamId?: InputMaybe<Scalars['String']['input']>;
  /** TeamName */
  teamName?: InputMaybe<Scalars['String']['input']>;
  /** [ID] TeamSettingId */
  teamSettingId?: InputMaybe<Scalars['Int']['input']>;
  /** TeamType */
  teamType?: InputMaybe<Scalars['String']['input']>;
};

/** TeamSetting */
export type Wf_AdminFirst_TeamSettingSortInput = {
  /** ChannelId */
  channelId?: InputMaybe<SortEnumType>;
  /** IncomingWebhookUrl */
  incomingWebhookUrl?: InputMaybe<SortEnumType>;
  /** TeamId */
  teamId?: InputMaybe<SortEnumType>;
  /** TeamName */
  teamName?: InputMaybe<SortEnumType>;
  /** [ID] TeamSettingId */
  teamSettingId?: InputMaybe<SortEnumType>;
  /** TeamType */
  teamType?: InputMaybe<SortEnumType>;
};

/** TempFaceCall */
export type Wf_AdminFirst_TempFaceCall = Node & {
  __typename?: 'WF_AdminFirst_TempFaceCall';
  /** CreatedDate */
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  /** [ID] Seq */
  id: Scalars['ID']['output'];
  /** PerformerName */
  performerName?: Maybe<Scalars['String']['output']>;
  /** SongName */
  songName?: Maybe<Scalars['String']['output']>;
  /** Theme */
  theme?: Maybe<Scalars['String']['output']>;
  /** VimeoIdJp */
  vimeoIdJp?: Maybe<Scalars['String']['output']>;
  /** VimeoIdTw */
  vimeoIdTw?: Maybe<Scalars['String']['output']>;
  /** VimeoLink */
  vimeoLink?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Wf_AdminFirst_TempFaceCallConnection = {
  __typename?: 'WF_AdminFirst_TempFaceCallConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_AdminFirst_TempFaceCallEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_AdminFirst_TempFaceCall>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_AdminFirst_TempFaceCallEdge = {
  __typename?: 'WF_AdminFirst_TempFaceCallEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_AdminFirst_TempFaceCall;
};

/** TempFaceCall */
export type Wf_AdminFirst_TempFaceCallFilterInput = {
  and?: InputMaybe<Array<Wf_AdminFirst_TempFaceCallFilterInput>>;
  /** CreatedDate */
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<Wf_AdminFirst_TempFaceCallFilterInput>>;
  /** PerformerName */
  performerName?: InputMaybe<StringOperationFilterInput>;
  /** [ID] Seq */
  seq?: InputMaybe<IntOperationFilterInput>;
  /** SongName */
  songName?: InputMaybe<StringOperationFilterInput>;
  /** Theme */
  theme?: InputMaybe<StringOperationFilterInput>;
  /** VimeoIdJp */
  vimeoIdJp?: InputMaybe<StringOperationFilterInput>;
  /** VimeoIdTw */
  vimeoIdTw?: InputMaybe<StringOperationFilterInput>;
  /** VimeoLink */
  vimeoLink?: InputMaybe<StringOperationFilterInput>;
};

/** TempFaceCall */
export type Wf_AdminFirst_TempFaceCallInput = {
  /** CreatedDate */
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** PerformerName */
  performerName?: InputMaybe<Scalars['String']['input']>;
  /** [ID] Seq */
  seq?: InputMaybe<Scalars['Int']['input']>;
  /** SongName */
  songName?: InputMaybe<Scalars['String']['input']>;
  /** Theme */
  theme?: InputMaybe<Scalars['String']['input']>;
  /** VimeoIdJp */
  vimeoIdJp?: InputMaybe<Scalars['String']['input']>;
  /** VimeoIdTw */
  vimeoIdTw?: InputMaybe<Scalars['String']['input']>;
  /** VimeoLink */
  vimeoLink?: InputMaybe<Scalars['String']['input']>;
};

/** TempFaceCall */
export type Wf_AdminFirst_TempFaceCallSortInput = {
  /** CreatedDate */
  createdDate?: InputMaybe<SortEnumType>;
  /** PerformerName */
  performerName?: InputMaybe<SortEnumType>;
  /** [ID] Seq */
  seq?: InputMaybe<SortEnumType>;
  /** SongName */
  songName?: InputMaybe<SortEnumType>;
  /** Theme */
  theme?: InputMaybe<SortEnumType>;
  /** VimeoIdJp */
  vimeoIdJp?: InputMaybe<SortEnumType>;
  /** VimeoIdTw */
  vimeoIdTw?: InputMaybe<SortEnumType>;
  /** VimeoLink */
  vimeoLink?: InputMaybe<SortEnumType>;
};

/** TempPrepaidMembershipFee */
export type Wf_AdminFirst_TempPrepaidMembershipFee = Node & {
  __typename?: 'WF_AdminFirst_TempPrepaidMembershipFee';
  /** AuthorSeq */
  authorSeq?: Maybe<Scalars['String']['output']>;
  /** [ID] FeeId */
  id: Scalars['ID']['output'];
  /** MemNo */
  memNo?: Maybe<Scalars['String']['output']>;
  /** TransactionId */
  transactionId?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Wf_AdminFirst_TempPrepaidMembershipFeeConnection = {
  __typename?: 'WF_AdminFirst_TempPrepaidMembershipFeeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_AdminFirst_TempPrepaidMembershipFeeEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_AdminFirst_TempPrepaidMembershipFee>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_AdminFirst_TempPrepaidMembershipFeeEdge = {
  __typename?: 'WF_AdminFirst_TempPrepaidMembershipFeeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_AdminFirst_TempPrepaidMembershipFee;
};

/** TempPrepaidMembershipFee */
export type Wf_AdminFirst_TempPrepaidMembershipFeeFilterInput = {
  and?: InputMaybe<Array<Wf_AdminFirst_TempPrepaidMembershipFeeFilterInput>>;
  /** AuthorSeq */
  authorSeq?: InputMaybe<StringOperationFilterInput>;
  /** [ID] FeeId */
  feeId?: InputMaybe<StringOperationFilterInput>;
  /** MemNo */
  memNo?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Wf_AdminFirst_TempPrepaidMembershipFeeFilterInput>>;
  /** TransactionId */
  transactionId?: InputMaybe<StringOperationFilterInput>;
};

/** TempPrepaidMembershipFee */
export type Wf_AdminFirst_TempPrepaidMembershipFeeInput = {
  /** AuthorSeq */
  authorSeq?: InputMaybe<Scalars['String']['input']>;
  /** [ID] FeeId */
  feeId: Scalars['String']['input'];
  /** MemNo */
  memNo?: InputMaybe<Scalars['String']['input']>;
  /** TransactionId */
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

/** TempPrepaidMembershipFee */
export type Wf_AdminFirst_TempPrepaidMembershipFeeSortInput = {
  /** AuthorSeq */
  authorSeq?: InputMaybe<SortEnumType>;
  /** [ID] FeeId */
  feeId?: InputMaybe<SortEnumType>;
  /** MemNo */
  memNo?: InputMaybe<SortEnumType>;
  /** TransactionId */
  transactionId?: InputMaybe<SortEnumType>;
};

/** TepsDailyHour */
export type Wf_AdminFirst_TepsDailyHour = Node & {
  __typename?: 'WF_AdminFirst_TepsDailyHour';
  /** Date */
  date?: Maybe<Scalars['DateTime']['output']>;
  /** Description */
  description?: Maybe<Scalars['String']['output']>;
  /** Hours */
  hours?: Maybe<Scalars['Decimal']['output']>;
  /** [ID] TepsDailyHourId */
  id: Scalars['ID']['output'];
  /** [NAVIGATION] TepsDailyHourLocationType */
  tepsDailyHourLocationType?: Maybe<Wf_AdminFirst_TepsDailyHourLocationType>;
  /** TepsDailyHourLocationTypeId */
  tepsDailyHourLocationTypeId?: Maybe<Scalars['Int']['output']>;
  /** [NAVIGATION] TepsDailyHourType */
  tepsDailyHourType?: Maybe<Wf_AdminFirst_TepsDailyHourType>;
  /** TepsDailyHourTypeId */
  tepsDailyHourTypeId?: Maybe<Scalars['Int']['output']>;
  /** [NAVIGATION] TepsProject */
  tepsProject?: Maybe<Wf_AdminFirst_TepsProject>;
  /** TepsProjectId */
  tepsProjectId?: Maybe<Scalars['Int']['output']>;
  /** [NAVIGATION] TepsUser */
  tepsUser?: Maybe<Wf_AdminFirst_TepsUser>;
  /** TepsUserId */
  tepsUserId?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of items. */
export type Wf_AdminFirst_TepsDailyHourConnection = {
  __typename?: 'WF_AdminFirst_TepsDailyHourConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_AdminFirst_TepsDailyHourEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_AdminFirst_TepsDailyHour>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_AdminFirst_TepsDailyHourEdge = {
  __typename?: 'WF_AdminFirst_TepsDailyHourEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_AdminFirst_TepsDailyHour;
};

/** TepsDailyHour */
export type Wf_AdminFirst_TepsDailyHourFilterInput = {
  and?: InputMaybe<Array<Wf_AdminFirst_TepsDailyHourFilterInput>>;
  /** Date */
  date?: InputMaybe<DateTimeOperationFilterInput>;
  /** Description */
  description?: InputMaybe<StringOperationFilterInput>;
  /** Hours */
  hours?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<Wf_AdminFirst_TepsDailyHourFilterInput>>;
  /** [ID] TepsDailyHourId */
  tepsDailyHourId?: InputMaybe<IntOperationFilterInput>;
  /** [NAVIGATION] TepsDailyHourLocationType */
  tepsDailyHourLocationType?: InputMaybe<Wf_AdminFirst_TepsDailyHourLocationTypeFilterInput>;
  /** TepsDailyHourLocationTypeId */
  tepsDailyHourLocationTypeId?: InputMaybe<IntOperationFilterInput>;
  /** [NAVIGATION] TepsDailyHourType */
  tepsDailyHourType?: InputMaybe<Wf_AdminFirst_TepsDailyHourTypeFilterInput>;
  /** TepsDailyHourTypeId */
  tepsDailyHourTypeId?: InputMaybe<IntOperationFilterInput>;
  /** [NAVIGATION] TepsProject */
  tepsProject?: InputMaybe<Wf_AdminFirst_TepsProjectFilterInput>;
  /** TepsProjectId */
  tepsProjectId?: InputMaybe<IntOperationFilterInput>;
  /** [NAVIGATION] TepsUser */
  tepsUser?: InputMaybe<Wf_AdminFirst_TepsUserFilterInput>;
  /** TepsUserId */
  tepsUserId?: InputMaybe<IntOperationFilterInput>;
};

/** TepsDailyHour */
export type Wf_AdminFirst_TepsDailyHourInput = {
  /** Date */
  date?: InputMaybe<Scalars['DateTime']['input']>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Hours */
  hours?: InputMaybe<Scalars['Decimal']['input']>;
  /** [ID] TepsDailyHourId */
  tepsDailyHourId?: InputMaybe<Scalars['Int']['input']>;
  /** [NAVIGATION] TepsDailyHourLocationType */
  tepsDailyHourLocationType?: InputMaybe<Wf_AdminFirst_TepsDailyHourLocationTypeInput>;
  /** TepsDailyHourLocationTypeId */
  tepsDailyHourLocationTypeId?: InputMaybe<Scalars['Int']['input']>;
  /** [NAVIGATION] TepsDailyHourType */
  tepsDailyHourType?: InputMaybe<Wf_AdminFirst_TepsDailyHourTypeInput>;
  /** TepsDailyHourTypeId */
  tepsDailyHourTypeId?: InputMaybe<Scalars['Int']['input']>;
  /** [NAVIGATION] TepsProject */
  tepsProject?: InputMaybe<Wf_AdminFirst_TepsProjectInput>;
  /** TepsProjectId */
  tepsProjectId?: InputMaybe<Scalars['Int']['input']>;
  /** [NAVIGATION] TepsUser */
  tepsUser?: InputMaybe<Wf_AdminFirst_TepsUserInput>;
  /** TepsUserId */
  tepsUserId?: InputMaybe<Scalars['Int']['input']>;
};

/** TepsDailyHourLocationType */
export type Wf_AdminFirst_TepsDailyHourLocationType = Node & {
  __typename?: 'WF_AdminFirst_TepsDailyHourLocationType';
  /** [ID] TepsDailyHourLocationTypeId */
  id: Scalars['ID']['output'];
  /** [NOT NULL] Name */
  name?: Maybe<Scalars['String']['output']>;
  /** [COLLECTION] TepsDailyHours */
  tepsDailyHours?: Maybe<Array<Maybe<Wf_AdminFirst_TepsDailyHour>>>;
};

/** A connection to a list of items. */
export type Wf_AdminFirst_TepsDailyHourLocationTypeConnection = {
  __typename?: 'WF_AdminFirst_TepsDailyHourLocationTypeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_AdminFirst_TepsDailyHourLocationTypeEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_AdminFirst_TepsDailyHourLocationType>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_AdminFirst_TepsDailyHourLocationTypeEdge = {
  __typename?: 'WF_AdminFirst_TepsDailyHourLocationTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_AdminFirst_TepsDailyHourLocationType;
};

/** TepsDailyHourLocationType */
export type Wf_AdminFirst_TepsDailyHourLocationTypeFilterInput = {
  and?: InputMaybe<Array<Wf_AdminFirst_TepsDailyHourLocationTypeFilterInput>>;
  /** [NOT NULL] Name */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Wf_AdminFirst_TepsDailyHourLocationTypeFilterInput>>;
  /** [ID] TepsDailyHourLocationTypeId */
  tepsDailyHourLocationTypeId?: InputMaybe<IntOperationFilterInput>;
  /** [COLLECTION] TepsDailyHours */
  tepsDailyHours?: InputMaybe<ListFilterInputTypeOfWf_AdminFirst_TepsDailyHourFilterInput>;
};

/** TepsDailyHourLocationType */
export type Wf_AdminFirst_TepsDailyHourLocationTypeInput = {
  /** [NOT NULL] Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** [ID] TepsDailyHourLocationTypeId */
  tepsDailyHourLocationTypeId?: InputMaybe<Scalars['Int']['input']>;
  /** [COLLECTION] TepsDailyHours */
  tepsDailyHours?: InputMaybe<Array<InputMaybe<Wf_AdminFirst_TepsDailyHourInput>>>;
};

/** TepsDailyHourLocationType */
export type Wf_AdminFirst_TepsDailyHourLocationTypeSortInput = {
  /** [NOT NULL] Name */
  name?: InputMaybe<SortEnumType>;
  /** [ID] TepsDailyHourLocationTypeId */
  tepsDailyHourLocationTypeId?: InputMaybe<SortEnumType>;
};

/** TepsDailyHour */
export type Wf_AdminFirst_TepsDailyHourSortInput = {
  /** Date */
  date?: InputMaybe<SortEnumType>;
  /** Description */
  description?: InputMaybe<SortEnumType>;
  /** Hours */
  hours?: InputMaybe<SortEnumType>;
  /** [ID] TepsDailyHourId */
  tepsDailyHourId?: InputMaybe<SortEnumType>;
  /** [NAVIGATION] TepsDailyHourLocationType */
  tepsDailyHourLocationType?: InputMaybe<Wf_AdminFirst_TepsDailyHourLocationTypeSortInput>;
  /** TepsDailyHourLocationTypeId */
  tepsDailyHourLocationTypeId?: InputMaybe<SortEnumType>;
  /** [NAVIGATION] TepsDailyHourType */
  tepsDailyHourType?: InputMaybe<Wf_AdminFirst_TepsDailyHourTypeSortInput>;
  /** TepsDailyHourTypeId */
  tepsDailyHourTypeId?: InputMaybe<SortEnumType>;
  /** [NAVIGATION] TepsProject */
  tepsProject?: InputMaybe<Wf_AdminFirst_TepsProjectSortInput>;
  /** TepsProjectId */
  tepsProjectId?: InputMaybe<SortEnumType>;
  /** [NAVIGATION] TepsUser */
  tepsUser?: InputMaybe<Wf_AdminFirst_TepsUserSortInput>;
  /** TepsUserId */
  tepsUserId?: InputMaybe<SortEnumType>;
};

/** TepsDailyHourType */
export type Wf_AdminFirst_TepsDailyHourType = Node & {
  __typename?: 'WF_AdminFirst_TepsDailyHourType';
  /** [ID] TepsDailyHourTypeId */
  id: Scalars['ID']['output'];
  /** [NOT NULL] Name */
  name?: Maybe<Scalars['String']['output']>;
  /** [COLLECTION] TepsDailyHours */
  tepsDailyHours?: Maybe<Array<Maybe<Wf_AdminFirst_TepsDailyHour>>>;
};

/** A connection to a list of items. */
export type Wf_AdminFirst_TepsDailyHourTypeConnection = {
  __typename?: 'WF_AdminFirst_TepsDailyHourTypeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_AdminFirst_TepsDailyHourTypeEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_AdminFirst_TepsDailyHourType>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_AdminFirst_TepsDailyHourTypeEdge = {
  __typename?: 'WF_AdminFirst_TepsDailyHourTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_AdminFirst_TepsDailyHourType;
};

/** TepsDailyHourType */
export type Wf_AdminFirst_TepsDailyHourTypeFilterInput = {
  and?: InputMaybe<Array<Wf_AdminFirst_TepsDailyHourTypeFilterInput>>;
  /** [NOT NULL] Name */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Wf_AdminFirst_TepsDailyHourTypeFilterInput>>;
  /** [ID] TepsDailyHourTypeId */
  tepsDailyHourTypeId?: InputMaybe<IntOperationFilterInput>;
  /** [COLLECTION] TepsDailyHours */
  tepsDailyHours?: InputMaybe<ListFilterInputTypeOfWf_AdminFirst_TepsDailyHourFilterInput>;
};

/** TepsDailyHourType */
export type Wf_AdminFirst_TepsDailyHourTypeInput = {
  /** [NOT NULL] Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** [ID] TepsDailyHourTypeId */
  tepsDailyHourTypeId?: InputMaybe<Scalars['Int']['input']>;
  /** [COLLECTION] TepsDailyHours */
  tepsDailyHours?: InputMaybe<Array<InputMaybe<Wf_AdminFirst_TepsDailyHourInput>>>;
};

/** TepsDailyHourType */
export type Wf_AdminFirst_TepsDailyHourTypeSortInput = {
  /** [NOT NULL] Name */
  name?: InputMaybe<SortEnumType>;
  /** [ID] TepsDailyHourTypeId */
  tepsDailyHourTypeId?: InputMaybe<SortEnumType>;
};

/** TepsProject */
export type Wf_AdminFirst_TepsProject = Node & {
  __typename?: 'WF_AdminFirst_TepsProject';
  /** Description */
  description?: Maybe<Scalars['String']['output']>;
  /** EndDate */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** [ID] TepsProjectId */
  id: Scalars['ID']['output'];
  /** JiraProjectLink */
  jiraProjectLink?: Maybe<Scalars['String']['output']>;
  /** Legacy */
  legacy?: Maybe<Scalars['Boolean']['output']>;
  /** Task */
  task?: Maybe<Scalars['String']['output']>;
  /** [COLLECTION] TepsDailyHours */
  tepsDailyHours?: Maybe<Array<Maybe<Wf_AdminFirst_TepsDailyHour>>>;
  /** TepsProjectTypeId */
  tepsProjectTypeId?: Maybe<Scalars['Int']['output']>;
  /** [COLLECTION] TepsProjectTypes */
  tepsProjectTypes?: Maybe<Array<Maybe<Wf_AdminFirst_TepsProjectType>>>;
  /** [COLLECTION] TepsProjections */
  tepsProjections?: Maybe<Array<Maybe<Wf_AdminFirst_TepsProjection>>>;
  /** [NAVIGATION] TepsUser */
  tepsUser?: Maybe<Wf_AdminFirst_TepsUser>;
  /** TepsUserId */
  tepsUserId?: Maybe<Scalars['Int']['output']>;
  /** [COLLECTION] TepsUserProjects */
  tepsUserProjects?: Maybe<Array<Maybe<Wf_AdminFirst_TepsUserProject>>>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
  /** Wfi */
  wfi?: Maybe<Scalars['Boolean']['output']>;
};

/** TepsProjectAllocatedType */
export type Wf_AdminFirst_TepsProjectAllocatedType = Node & {
  __typename?: 'WF_AdminFirst_TepsProjectAllocatedType';
  /** [ID] TepsProjectAllocatedTypeId */
  id: Scalars['ID']['output'];
  /** [NOT NULL] Name */
  name?: Maybe<Scalars['String']['output']>;
  /** [COLLECTION] TepsProjectTypes */
  tepsProjectTypes?: Maybe<Array<Maybe<Wf_AdminFirst_TepsProjectType>>>;
};

/** A connection to a list of items. */
export type Wf_AdminFirst_TepsProjectAllocatedTypeConnection = {
  __typename?: 'WF_AdminFirst_TepsProjectAllocatedTypeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_AdminFirst_TepsProjectAllocatedTypeEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_AdminFirst_TepsProjectAllocatedType>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_AdminFirst_TepsProjectAllocatedTypeEdge = {
  __typename?: 'WF_AdminFirst_TepsProjectAllocatedTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_AdminFirst_TepsProjectAllocatedType;
};

/** TepsProjectAllocatedType */
export type Wf_AdminFirst_TepsProjectAllocatedTypeFilterInput = {
  and?: InputMaybe<Array<Wf_AdminFirst_TepsProjectAllocatedTypeFilterInput>>;
  /** [NOT NULL] Name */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Wf_AdminFirst_TepsProjectAllocatedTypeFilterInput>>;
  /** [ID] TepsProjectAllocatedTypeId */
  tepsProjectAllocatedTypeId?: InputMaybe<IntOperationFilterInput>;
  /** [COLLECTION] TepsProjectTypes */
  tepsProjectTypes?: InputMaybe<ListFilterInputTypeOfWf_AdminFirst_TepsProjectTypeFilterInput>;
};

/** TepsProjectAllocatedType */
export type Wf_AdminFirst_TepsProjectAllocatedTypeInput = {
  /** [NOT NULL] Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** [ID] TepsProjectAllocatedTypeId */
  tepsProjectAllocatedTypeId?: InputMaybe<Scalars['Int']['input']>;
  /** [COLLECTION] TepsProjectTypes */
  tepsProjectTypes?: InputMaybe<Array<InputMaybe<Wf_AdminFirst_TepsProjectTypeInput>>>;
};

/** TepsProjectAllocatedType */
export type Wf_AdminFirst_TepsProjectAllocatedTypeSortInput = {
  /** [NOT NULL] Name */
  name?: InputMaybe<SortEnumType>;
  /** [ID] TepsProjectAllocatedTypeId */
  tepsProjectAllocatedTypeId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type Wf_AdminFirst_TepsProjectConnection = {
  __typename?: 'WF_AdminFirst_TepsProjectConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_AdminFirst_TepsProjectEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_AdminFirst_TepsProject>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_AdminFirst_TepsProjectEdge = {
  __typename?: 'WF_AdminFirst_TepsProjectEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_AdminFirst_TepsProject;
};

/** TepsProject */
export type Wf_AdminFirst_TepsProjectFilterInput = {
  and?: InputMaybe<Array<Wf_AdminFirst_TepsProjectFilterInput>>;
  /** Description */
  description?: InputMaybe<StringOperationFilterInput>;
  /** EndDate */
  endDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** JiraProjectLink */
  jiraProjectLink?: InputMaybe<StringOperationFilterInput>;
  /** Legacy */
  legacy?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<Wf_AdminFirst_TepsProjectFilterInput>>;
  /** Task */
  task?: InputMaybe<StringOperationFilterInput>;
  /** [COLLECTION] TepsDailyHours */
  tepsDailyHours?: InputMaybe<ListFilterInputTypeOfWf_AdminFirst_TepsDailyHourFilterInput>;
  /** [ID] TepsProjectId */
  tepsProjectId?: InputMaybe<IntOperationFilterInput>;
  /** TepsProjectTypeId */
  tepsProjectTypeId?: InputMaybe<IntOperationFilterInput>;
  /** [COLLECTION] TepsProjectTypes */
  tepsProjectTypes?: InputMaybe<ListFilterInputTypeOfWf_AdminFirst_TepsProjectTypeFilterInput>;
  /** [COLLECTION] TepsProjections */
  tepsProjections?: InputMaybe<ListFilterInputTypeOfWf_AdminFirst_TepsProjectionFilterInput>;
  /** [NAVIGATION] TepsUser */
  tepsUser?: InputMaybe<Wf_AdminFirst_TepsUserFilterInput>;
  /** TepsUserId */
  tepsUserId?: InputMaybe<IntOperationFilterInput>;
  /** [COLLECTION] TepsUserProjects */
  tepsUserProjects?: InputMaybe<ListFilterInputTypeOfWf_AdminFirst_TepsUserProjectFilterInput>;
  /** Title */
  title?: InputMaybe<StringOperationFilterInput>;
  /** Wfi */
  wfi?: InputMaybe<BooleanOperationFilterInput>;
};

/** TepsProject */
export type Wf_AdminFirst_TepsProjectInput = {
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** EndDate */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** JiraProjectLink */
  jiraProjectLink?: InputMaybe<Scalars['String']['input']>;
  /** Legacy */
  legacy?: InputMaybe<Scalars['Boolean']['input']>;
  /** Task */
  task?: InputMaybe<Scalars['String']['input']>;
  /** [COLLECTION] TepsDailyHours */
  tepsDailyHours?: InputMaybe<Array<InputMaybe<Wf_AdminFirst_TepsDailyHourInput>>>;
  /** [ID] TepsProjectId */
  tepsProjectId?: InputMaybe<Scalars['Int']['input']>;
  /** TepsProjectTypeId */
  tepsProjectTypeId?: InputMaybe<Scalars['Int']['input']>;
  /** [COLLECTION] TepsProjectTypes */
  tepsProjectTypes?: InputMaybe<Array<InputMaybe<Wf_AdminFirst_TepsProjectTypeInput>>>;
  /** [COLLECTION] TepsProjections */
  tepsProjections?: InputMaybe<Array<InputMaybe<Wf_AdminFirst_TepsProjectionInput>>>;
  /** [NAVIGATION] TepsUser */
  tepsUser?: InputMaybe<Wf_AdminFirst_TepsUserInput>;
  /** TepsUserId */
  tepsUserId?: InputMaybe<Scalars['Int']['input']>;
  /** [COLLECTION] TepsUserProjects */
  tepsUserProjects?: InputMaybe<Array<InputMaybe<Wf_AdminFirst_TepsUserProjectInput>>>;
  /** Title */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Wfi */
  wfi?: InputMaybe<Scalars['Boolean']['input']>;
};

/** TepsProject */
export type Wf_AdminFirst_TepsProjectSortInput = {
  /** Description */
  description?: InputMaybe<SortEnumType>;
  /** EndDate */
  endDate?: InputMaybe<SortEnumType>;
  /** JiraProjectLink */
  jiraProjectLink?: InputMaybe<SortEnumType>;
  /** Legacy */
  legacy?: InputMaybe<SortEnumType>;
  /** Task */
  task?: InputMaybe<SortEnumType>;
  /** [ID] TepsProjectId */
  tepsProjectId?: InputMaybe<SortEnumType>;
  /** TepsProjectTypeId */
  tepsProjectTypeId?: InputMaybe<SortEnumType>;
  /** [NAVIGATION] TepsUser */
  tepsUser?: InputMaybe<Wf_AdminFirst_TepsUserSortInput>;
  /** TepsUserId */
  tepsUserId?: InputMaybe<SortEnumType>;
  /** Title */
  title?: InputMaybe<SortEnumType>;
  /** Wfi */
  wfi?: InputMaybe<SortEnumType>;
};

/** TepsProjectType */
export type Wf_AdminFirst_TepsProjectType = Node & {
  __typename?: 'WF_AdminFirst_TepsProjectType';
  /** [ID] TepsProjectTypeId */
  id: Scalars['ID']['output'];
  /** [NAVIGATION] TepsProject */
  tepsProject?: Maybe<Wf_AdminFirst_TepsProject>;
  /** [NAVIGATION] TepsProjectAllocatedType */
  tepsProjectAllocatedType?: Maybe<Wf_AdminFirst_TepsProjectAllocatedType>;
  /** [NOT NULL] TepsProjectAllocatedTypeId */
  tepsProjectAllocatedTypeId?: Maybe<Scalars['Int']['output']>;
  /** [NOT NULL] TepsProjectId */
  tepsProjectId?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of items. */
export type Wf_AdminFirst_TepsProjectTypeConnection = {
  __typename?: 'WF_AdminFirst_TepsProjectTypeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_AdminFirst_TepsProjectTypeEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_AdminFirst_TepsProjectType>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_AdminFirst_TepsProjectTypeEdge = {
  __typename?: 'WF_AdminFirst_TepsProjectTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_AdminFirst_TepsProjectType;
};

/** TepsProjectType */
export type Wf_AdminFirst_TepsProjectTypeFilterInput = {
  and?: InputMaybe<Array<Wf_AdminFirst_TepsProjectTypeFilterInput>>;
  or?: InputMaybe<Array<Wf_AdminFirst_TepsProjectTypeFilterInput>>;
  /** [NAVIGATION] TepsProject */
  tepsProject?: InputMaybe<Wf_AdminFirst_TepsProjectFilterInput>;
  /** [NAVIGATION] TepsProjectAllocatedType */
  tepsProjectAllocatedType?: InputMaybe<Wf_AdminFirst_TepsProjectAllocatedTypeFilterInput>;
  /** [NOT NULL] TepsProjectAllocatedTypeId */
  tepsProjectAllocatedTypeId?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] TepsProjectId */
  tepsProjectId?: InputMaybe<IntOperationFilterInput>;
  /** [ID] TepsProjectTypeId */
  tepsProjectTypeId?: InputMaybe<LongOperationFilterInput>;
};

/** TepsProjectType */
export type Wf_AdminFirst_TepsProjectTypeInput = {
  /** [NAVIGATION] TepsProject */
  tepsProject?: InputMaybe<Wf_AdminFirst_TepsProjectInput>;
  /** [NAVIGATION] TepsProjectAllocatedType */
  tepsProjectAllocatedType?: InputMaybe<Wf_AdminFirst_TepsProjectAllocatedTypeInput>;
  /** [NOT NULL] TepsProjectAllocatedTypeId */
  tepsProjectAllocatedTypeId?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] TepsProjectId */
  tepsProjectId?: InputMaybe<Scalars['Int']['input']>;
  /** [ID] TepsProjectTypeId */
  tepsProjectTypeId?: InputMaybe<Scalars['Long']['input']>;
};

/** TepsProjectType */
export type Wf_AdminFirst_TepsProjectTypeSortInput = {
  /** [NAVIGATION] TepsProject */
  tepsProject?: InputMaybe<Wf_AdminFirst_TepsProjectSortInput>;
  /** [NAVIGATION] TepsProjectAllocatedType */
  tepsProjectAllocatedType?: InputMaybe<Wf_AdminFirst_TepsProjectAllocatedTypeSortInput>;
  /** [NOT NULL] TepsProjectAllocatedTypeId */
  tepsProjectAllocatedTypeId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] TepsProjectId */
  tepsProjectId?: InputMaybe<SortEnumType>;
  /** [ID] TepsProjectTypeId */
  tepsProjectTypeId?: InputMaybe<SortEnumType>;
};

/** TepsProjection */
export type Wf_AdminFirst_TepsProjection = Node & {
  __typename?: 'WF_AdminFirst_TepsProjection';
  /** DesignManQuarter */
  designManQuarter?: Maybe<Scalars['Short']['output']>;
  /** DeveloperManQuarter */
  developerManQuarter?: Maybe<Scalars['Short']['output']>;
  /** Developing */
  developing?: Maybe<Scalars['Boolean']['output']>;
  /** [ID] TepsProjectionsId */
  id: Scalars['ID']['output'];
  /** Maintaining */
  maintaining?: Maybe<Scalars['Boolean']['output']>;
  /** Quarter */
  quarter?: Maybe<Scalars['String']['output']>;
  /** [NAVIGATION] TepsProject */
  tepsProject?: Maybe<Wf_AdminFirst_TepsProject>;
  /** TepsProjectId */
  tepsProjectId?: Maybe<Scalars['Int']['output']>;
  /** VietnamManQuarter */
  vietnamManQuarter?: Maybe<Scalars['Short']['output']>;
  /** Years */
  years?: Maybe<Scalars['Short']['output']>;
};

/** A connection to a list of items. */
export type Wf_AdminFirst_TepsProjectionConnection = {
  __typename?: 'WF_AdminFirst_TepsProjectionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_AdminFirst_TepsProjectionEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_AdminFirst_TepsProjection>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_AdminFirst_TepsProjectionEdge = {
  __typename?: 'WF_AdminFirst_TepsProjectionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_AdminFirst_TepsProjection;
};

/** TepsProjection */
export type Wf_AdminFirst_TepsProjectionFilterInput = {
  and?: InputMaybe<Array<Wf_AdminFirst_TepsProjectionFilterInput>>;
  /** DesignManQuarter */
  designManQuarter?: InputMaybe<ShortOperationFilterInput>;
  /** DeveloperManQuarter */
  developerManQuarter?: InputMaybe<ShortOperationFilterInput>;
  /** Developing */
  developing?: InputMaybe<BooleanOperationFilterInput>;
  /** Maintaining */
  maintaining?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<Wf_AdminFirst_TepsProjectionFilterInput>>;
  /** Quarter */
  quarter?: InputMaybe<StringOperationFilterInput>;
  /** [NAVIGATION] TepsProject */
  tepsProject?: InputMaybe<Wf_AdminFirst_TepsProjectFilterInput>;
  /** TepsProjectId */
  tepsProjectId?: InputMaybe<IntOperationFilterInput>;
  /** [ID] TepsProjectionsId */
  tepsProjectionsId?: InputMaybe<IntOperationFilterInput>;
  /** VietnamManQuarter */
  vietnamManQuarter?: InputMaybe<ShortOperationFilterInput>;
  /** Years */
  years?: InputMaybe<ShortOperationFilterInput>;
};

/** TepsProjection */
export type Wf_AdminFirst_TepsProjectionInput = {
  /** DesignManQuarter */
  designManQuarter?: InputMaybe<Scalars['Short']['input']>;
  /** DeveloperManQuarter */
  developerManQuarter?: InputMaybe<Scalars['Short']['input']>;
  /** Developing */
  developing?: InputMaybe<Scalars['Boolean']['input']>;
  /** Maintaining */
  maintaining?: InputMaybe<Scalars['Boolean']['input']>;
  /** Quarter */
  quarter?: InputMaybe<Scalars['String']['input']>;
  /** [NAVIGATION] TepsProject */
  tepsProject?: InputMaybe<Wf_AdminFirst_TepsProjectInput>;
  /** TepsProjectId */
  tepsProjectId?: InputMaybe<Scalars['Int']['input']>;
  /** [ID] TepsProjectionsId */
  tepsProjectionsId?: InputMaybe<Scalars['Int']['input']>;
  /** VietnamManQuarter */
  vietnamManQuarter?: InputMaybe<Scalars['Short']['input']>;
  /** Years */
  years?: InputMaybe<Scalars['Short']['input']>;
};

/** TepsProjection */
export type Wf_AdminFirst_TepsProjectionSortInput = {
  /** DesignManQuarter */
  designManQuarter?: InputMaybe<SortEnumType>;
  /** DeveloperManQuarter */
  developerManQuarter?: InputMaybe<SortEnumType>;
  /** Developing */
  developing?: InputMaybe<SortEnumType>;
  /** Maintaining */
  maintaining?: InputMaybe<SortEnumType>;
  /** Quarter */
  quarter?: InputMaybe<SortEnumType>;
  /** [NAVIGATION] TepsProject */
  tepsProject?: InputMaybe<Wf_AdminFirst_TepsProjectSortInput>;
  /** TepsProjectId */
  tepsProjectId?: InputMaybe<SortEnumType>;
  /** [ID] TepsProjectionsId */
  tepsProjectionsId?: InputMaybe<SortEnumType>;
  /** VietnamManQuarter */
  vietnamManQuarter?: InputMaybe<SortEnumType>;
  /** Years */
  years?: InputMaybe<SortEnumType>;
};

/** TepsUser */
export type Wf_AdminFirst_TepsUser = Node & {
  __typename?: 'WF_AdminFirst_TepsUser';
  /** Blocked */
  blocked?: Maybe<Scalars['Boolean']['output']>;
  /** DisplayName */
  displayName?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Email */
  email?: Maybe<Scalars['String']['output']>;
  /** EmpCode */
  empCode?: Maybe<Scalars['String']['output']>;
  /** [ID] TepsUserId */
  id: Scalars['ID']['output'];
  /** JiraId */
  jiraId?: Maybe<Scalars['String']['output']>;
  /** JoinDate */
  joinDate?: Maybe<Scalars['DateTime']['output']>;
  /** Leader */
  leader?: Maybe<Scalars['Boolean']['output']>;
  /** PhotoUrl */
  photoUrl?: Maybe<Scalars['String']['output']>;
  /** Role */
  role?: Maybe<Scalars['String']['output']>;
  /** TeamId */
  teamId?: Maybe<Scalars['String']['output']>;
  /** [COLLECTION] TepsDailyHours */
  tepsDailyHours?: Maybe<Array<Maybe<Wf_AdminFirst_TepsDailyHour>>>;
  /** [COLLECTION] TepsProjects */
  tepsProjects?: Maybe<Array<Maybe<Wf_AdminFirst_TepsProject>>>;
  /** [COLLECTION] TepsUserProjects */
  tepsUserProjects?: Maybe<Array<Maybe<Wf_AdminFirst_TepsUserProject>>>;
};

/** A connection to a list of items. */
export type Wf_AdminFirst_TepsUserConnection = {
  __typename?: 'WF_AdminFirst_TepsUserConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_AdminFirst_TepsUserEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_AdminFirst_TepsUser>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_AdminFirst_TepsUserEdge = {
  __typename?: 'WF_AdminFirst_TepsUserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_AdminFirst_TepsUser;
};

/** TepsUser */
export type Wf_AdminFirst_TepsUserFilterInput = {
  and?: InputMaybe<Array<Wf_AdminFirst_TepsUserFilterInput>>;
  /** Blocked */
  blocked?: InputMaybe<BooleanOperationFilterInput>;
  /** DisplayName */
  displayName?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] Email */
  email?: InputMaybe<StringOperationFilterInput>;
  /** EmpCode */
  empCode?: InputMaybe<StringOperationFilterInput>;
  /** JiraId */
  jiraId?: InputMaybe<StringOperationFilterInput>;
  /** JoinDate */
  joinDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Leader */
  leader?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<Wf_AdminFirst_TepsUserFilterInput>>;
  /** PhotoUrl */
  photoUrl?: InputMaybe<StringOperationFilterInput>;
  /** Role */
  role?: InputMaybe<StringOperationFilterInput>;
  /** TeamId */
  teamId?: InputMaybe<StringOperationFilterInput>;
  /** [COLLECTION] TepsDailyHours */
  tepsDailyHours?: InputMaybe<ListFilterInputTypeOfWf_AdminFirst_TepsDailyHourFilterInput>;
  /** [COLLECTION] TepsProjects */
  tepsProjects?: InputMaybe<ListFilterInputTypeOfWf_AdminFirst_TepsProjectFilterInput>;
  /** [ID] TepsUserId */
  tepsUserId?: InputMaybe<IntOperationFilterInput>;
  /** [COLLECTION] TepsUserProjects */
  tepsUserProjects?: InputMaybe<ListFilterInputTypeOfWf_AdminFirst_TepsUserProjectFilterInput>;
};

/** TepsUser */
export type Wf_AdminFirst_TepsUserInput = {
  /** Blocked */
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  /** DisplayName */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** EmpCode */
  empCode?: InputMaybe<Scalars['String']['input']>;
  /** JiraId */
  jiraId?: InputMaybe<Scalars['String']['input']>;
  /** JoinDate */
  joinDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Leader */
  leader?: InputMaybe<Scalars['Boolean']['input']>;
  /** PhotoUrl */
  photoUrl?: InputMaybe<Scalars['String']['input']>;
  /** Role */
  role?: InputMaybe<Scalars['String']['input']>;
  /** TeamId */
  teamId?: InputMaybe<Scalars['String']['input']>;
  /** [COLLECTION] TepsDailyHours */
  tepsDailyHours?: InputMaybe<Array<InputMaybe<Wf_AdminFirst_TepsDailyHourInput>>>;
  /** [COLLECTION] TepsProjects */
  tepsProjects?: InputMaybe<Array<InputMaybe<Wf_AdminFirst_TepsProjectInput>>>;
  /** [ID] TepsUserId */
  tepsUserId?: InputMaybe<Scalars['Int']['input']>;
  /** [COLLECTION] TepsUserProjects */
  tepsUserProjects?: InputMaybe<Array<InputMaybe<Wf_AdminFirst_TepsUserProjectInput>>>;
};

/** TepsUserProject */
export type Wf_AdminFirst_TepsUserProject = Node & {
  __typename?: 'WF_AdminFirst_TepsUserProject';
  /** [ID] TepsUserProjectId */
  id: Scalars['ID']['output'];
  /** [NAVIGATION] TepsProject */
  tepsProject?: Maybe<Wf_AdminFirst_TepsProject>;
  /** [NOT NULL] TepsProjectId */
  tepsProjectId?: Maybe<Scalars['Int']['output']>;
  /** [NAVIGATION] TepsUser */
  tepsUser?: Maybe<Wf_AdminFirst_TepsUser>;
  /** [NOT NULL] TepsUserId */
  tepsUserId?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of items. */
export type Wf_AdminFirst_TepsUserProjectConnection = {
  __typename?: 'WF_AdminFirst_TepsUserProjectConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_AdminFirst_TepsUserProjectEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_AdminFirst_TepsUserProject>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_AdminFirst_TepsUserProjectEdge = {
  __typename?: 'WF_AdminFirst_TepsUserProjectEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_AdminFirst_TepsUserProject;
};

/** TepsUserProject */
export type Wf_AdminFirst_TepsUserProjectFilterInput = {
  and?: InputMaybe<Array<Wf_AdminFirst_TepsUserProjectFilterInput>>;
  or?: InputMaybe<Array<Wf_AdminFirst_TepsUserProjectFilterInput>>;
  /** [NAVIGATION] TepsProject */
  tepsProject?: InputMaybe<Wf_AdminFirst_TepsProjectFilterInput>;
  /** [NOT NULL] TepsProjectId */
  tepsProjectId?: InputMaybe<IntOperationFilterInput>;
  /** [NAVIGATION] TepsUser */
  tepsUser?: InputMaybe<Wf_AdminFirst_TepsUserFilterInput>;
  /** [NOT NULL] TepsUserId */
  tepsUserId?: InputMaybe<IntOperationFilterInput>;
  /** [ID] TepsUserProjectId */
  tepsUserProjectId?: InputMaybe<IntOperationFilterInput>;
};

/** TepsUserProject */
export type Wf_AdminFirst_TepsUserProjectInput = {
  /** [NAVIGATION] TepsProject */
  tepsProject?: InputMaybe<Wf_AdminFirst_TepsProjectInput>;
  /** [NOT NULL] TepsProjectId */
  tepsProjectId?: InputMaybe<Scalars['Int']['input']>;
  /** [NAVIGATION] TepsUser */
  tepsUser?: InputMaybe<Wf_AdminFirst_TepsUserInput>;
  /** [NOT NULL] TepsUserId */
  tepsUserId?: InputMaybe<Scalars['Int']['input']>;
  /** [ID] TepsUserProjectId */
  tepsUserProjectId?: InputMaybe<Scalars['Int']['input']>;
};

/** TepsUserProject */
export type Wf_AdminFirst_TepsUserProjectSortInput = {
  /** [NAVIGATION] TepsProject */
  tepsProject?: InputMaybe<Wf_AdminFirst_TepsProjectSortInput>;
  /** [NOT NULL] TepsProjectId */
  tepsProjectId?: InputMaybe<SortEnumType>;
  /** [NAVIGATION] TepsUser */
  tepsUser?: InputMaybe<Wf_AdminFirst_TepsUserSortInput>;
  /** [NOT NULL] TepsUserId */
  tepsUserId?: InputMaybe<SortEnumType>;
  /** [ID] TepsUserProjectId */
  tepsUserProjectId?: InputMaybe<SortEnumType>;
};

/** TepsUser */
export type Wf_AdminFirst_TepsUserSortInput = {
  /** Blocked */
  blocked?: InputMaybe<SortEnumType>;
  /** DisplayName */
  displayName?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Email */
  email?: InputMaybe<SortEnumType>;
  /** EmpCode */
  empCode?: InputMaybe<SortEnumType>;
  /** JiraId */
  jiraId?: InputMaybe<SortEnumType>;
  /** JoinDate */
  joinDate?: InputMaybe<SortEnumType>;
  /** Leader */
  leader?: InputMaybe<SortEnumType>;
  /** PhotoUrl */
  photoUrl?: InputMaybe<SortEnumType>;
  /** Role */
  role?: InputMaybe<SortEnumType>;
  /** TeamId */
  teamId?: InputMaybe<SortEnumType>;
  /** [ID] TepsUserId */
  tepsUserId?: InputMaybe<SortEnumType>;
};

/** AllParentTip */
export type Wf_TrialModeLeads_AllParentTip = Node & {
  __typename?: 'WF_TrialModeLeads_AllParentTip';
  /** Date */
  date?: Maybe<Scalars['DateTime']['output']>;
  /** English */
  english?: Maybe<Scalars['String']['output']>;
  /** Hk */
  hk?: Maybe<Scalars['String']['output']>;
  /** [ID] Id */
  id: Scalars['ID']['output'];
  /** Kr */
  kr?: Maybe<Scalars['String']['output']>;
  /** Tw */
  tw?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Wf_TrialModeLeads_AllParentTipConnection = {
  __typename?: 'WF_TrialModeLeads_AllParentTipConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_TrialModeLeads_AllParentTipEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_TrialModeLeads_AllParentTip>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_TrialModeLeads_AllParentTipEdge = {
  __typename?: 'WF_TrialModeLeads_AllParentTipEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_TrialModeLeads_AllParentTip;
};

/** AllParentTip */
export type Wf_TrialModeLeads_AllParentTipFilterInput = {
  and?: InputMaybe<Array<Wf_TrialModeLeads_AllParentTipFilterInput>>;
  /** Date */
  date?: InputMaybe<DateTimeOperationFilterInput>;
  /** English */
  english?: InputMaybe<StringOperationFilterInput>;
  /** Hk */
  hk?: InputMaybe<StringOperationFilterInput>;
  /** [ID] Id */
  id?: InputMaybe<FloatOperationFilterInput>;
  /** Kr */
  kr?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Wf_TrialModeLeads_AllParentTipFilterInput>>;
  /** Tw */
  tw?: InputMaybe<StringOperationFilterInput>;
};

/** AllParentTip */
export type Wf_TrialModeLeads_AllParentTipInput = {
  /** Date */
  date?: InputMaybe<Scalars['DateTime']['input']>;
  /** English */
  english?: InputMaybe<Scalars['String']['input']>;
  /** Hk */
  hk?: InputMaybe<Scalars['String']['input']>;
  /** [ID] Id */
  id: Scalars['Float']['input'];
  /** Kr */
  kr?: InputMaybe<Scalars['String']['input']>;
  /** Tw */
  tw?: InputMaybe<Scalars['String']['input']>;
};

/** AllParentTip */
export type Wf_TrialModeLeads_AllParentTipSortInput = {
  /** Date */
  date?: InputMaybe<SortEnumType>;
  /** English */
  english?: InputMaybe<SortEnumType>;
  /** Hk */
  hk?: InputMaybe<SortEnumType>;
  /** [ID] Id */
  id?: InputMaybe<SortEnumType>;
  /** Kr */
  kr?: InputMaybe<SortEnumType>;
  /** Tw */
  tw?: InputMaybe<SortEnumType>;
};

/** AppAnnouncementBar */
export type Wf_TrialModeLeads_AppAnnouncementBar = Node & {
  __typename?: 'WF_TrialModeLeads_AppAnnouncementBar';
  /** CreatedTime */
  createdTime?: Maybe<Scalars['DateTime']['output']>;
  /** [ID] AppAnnouncementBarId */
  id: Scalars['ID']['output'];
  /** [NOT NULL] ImageUrl */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] NavigationType */
  navigationType?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] NavigationUrl */
  navigationUrl?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] PublishTime */
  publishTime?: Maybe<Scalars['DateTime']['output']>;
  /** [NOT NULL] StopTime */
  stopTime?: Maybe<Scalars['DateTime']['output']>;
  /** UpdatedTime */
  updatedTime?: Maybe<Scalars['DateTime']['output']>;
};

/** A connection to a list of items. */
export type Wf_TrialModeLeads_AppAnnouncementBarConnection = {
  __typename?: 'WF_TrialModeLeads_AppAnnouncementBarConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_TrialModeLeads_AppAnnouncementBarEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_TrialModeLeads_AppAnnouncementBar>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_TrialModeLeads_AppAnnouncementBarEdge = {
  __typename?: 'WF_TrialModeLeads_AppAnnouncementBarEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_TrialModeLeads_AppAnnouncementBar;
};

/** AppAnnouncementBar */
export type Wf_TrialModeLeads_AppAnnouncementBarFilterInput = {
  and?: InputMaybe<Array<Wf_TrialModeLeads_AppAnnouncementBarFilterInput>>;
  /** [ID] AppAnnouncementBarId */
  appAnnouncementBarId?: InputMaybe<IntOperationFilterInput>;
  /** CreatedTime */
  createdTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** [NOT NULL] ImageUrl */
  imageUrl?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] NavigationType */
  navigationType?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] NavigationUrl */
  navigationUrl?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Wf_TrialModeLeads_AppAnnouncementBarFilterInput>>;
  /** [NOT NULL] PublishTime */
  publishTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** [NOT NULL] StopTime */
  stopTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<DateTimeOperationFilterInput>;
};

/** AppAnnouncementBar */
export type Wf_TrialModeLeads_AppAnnouncementBarInput = {
  /** [ID] AppAnnouncementBarId */
  appAnnouncementBarId?: InputMaybe<Scalars['Int']['input']>;
  /** CreatedTime */
  createdTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** [NOT NULL] ImageUrl */
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] NavigationType */
  navigationType?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] NavigationUrl */
  navigationUrl?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] PublishTime */
  publishTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** [NOT NULL] StopTime */
  stopTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<Scalars['DateTime']['input']>;
};

/** AppAnnouncementBarMarket */
export type Wf_TrialModeLeads_AppAnnouncementBarMarket = Node & {
  __typename?: 'WF_TrialModeLeads_AppAnnouncementBarMarket';
  /** [NOT NULL] AppAnnouncementBarId */
  appAnnouncementBarId?: Maybe<Scalars['Int']['output']>;
  /** [ID] AppAnnouncementBarMarketId */
  id: Scalars['ID']['output'];
  /** [NOT NULL] Market */
  market?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Wf_TrialModeLeads_AppAnnouncementBarMarketConnection = {
  __typename?: 'WF_TrialModeLeads_AppAnnouncementBarMarketConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_TrialModeLeads_AppAnnouncementBarMarketEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_TrialModeLeads_AppAnnouncementBarMarket>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_TrialModeLeads_AppAnnouncementBarMarketEdge = {
  __typename?: 'WF_TrialModeLeads_AppAnnouncementBarMarketEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_TrialModeLeads_AppAnnouncementBarMarket;
};

/** AppAnnouncementBarMarket */
export type Wf_TrialModeLeads_AppAnnouncementBarMarketFilterInput = {
  and?: InputMaybe<Array<Wf_TrialModeLeads_AppAnnouncementBarMarketFilterInput>>;
  /** [NOT NULL] AppAnnouncementBarId */
  appAnnouncementBarId?: InputMaybe<IntOperationFilterInput>;
  /** [ID] AppAnnouncementBarMarketId */
  appAnnouncementBarMarketId?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] Market */
  market?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Wf_TrialModeLeads_AppAnnouncementBarMarketFilterInput>>;
};

/** AppAnnouncementBarMarket */
export type Wf_TrialModeLeads_AppAnnouncementBarMarketInput = {
  /** [NOT NULL] AppAnnouncementBarId */
  appAnnouncementBarId?: InputMaybe<Scalars['Int']['input']>;
  /** [ID] AppAnnouncementBarMarketId */
  appAnnouncementBarMarketId?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] Market */
  market?: InputMaybe<Scalars['String']['input']>;
};

/** AppAnnouncementBarMarket */
export type Wf_TrialModeLeads_AppAnnouncementBarMarketSortInput = {
  /** [NOT NULL] AppAnnouncementBarId */
  appAnnouncementBarId?: InputMaybe<SortEnumType>;
  /** [ID] AppAnnouncementBarMarketId */
  appAnnouncementBarMarketId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Market */
  market?: InputMaybe<SortEnumType>;
};

/** AppAnnouncementBar */
export type Wf_TrialModeLeads_AppAnnouncementBarSortInput = {
  /** [ID] AppAnnouncementBarId */
  appAnnouncementBarId?: InputMaybe<SortEnumType>;
  /** CreatedTime */
  createdTime?: InputMaybe<SortEnumType>;
  /** [NOT NULL] ImageUrl */
  imageUrl?: InputMaybe<SortEnumType>;
  /** [NOT NULL] NavigationType */
  navigationType?: InputMaybe<SortEnumType>;
  /** [NOT NULL] NavigationUrl */
  navigationUrl?: InputMaybe<SortEnumType>;
  /** [NOT NULL] PublishTime */
  publishTime?: InputMaybe<SortEnumType>;
  /** [NOT NULL] StopTime */
  stopTime?: InputMaybe<SortEnumType>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<SortEnumType>;
};

/** AutoMail */
export type Wf_TrialModeLeads_AutoMail = Node & {
  __typename?: 'WF_TrialModeLeads_AutoMail';
  /** CreatedTime */
  createdTime?: Maybe<Scalars['DateTime']['output']>;
  /** [ID] MailId */
  id: Scalars['ID']['output'];
  /** MailBcc */
  mailBcc?: Maybe<Scalars['String']['output']>;
  /** MailCc */
  mailCc?: Maybe<Scalars['String']['output']>;
  /** MailContent */
  mailContent?: Maybe<Scalars['String']['output']>;
  /** MailStatus */
  mailStatus?: Maybe<Scalars['String']['output']>;
  /** MailSubject */
  mailSubject?: Maybe<Scalars['String']['output']>;
  /** MailTo */
  mailTo?: Maybe<Scalars['String']['output']>;
  /** Market */
  market?: Maybe<Scalars['String']['output']>;
  /** SenderAddress */
  senderAddress?: Maybe<Scalars['String']['output']>;
  /** SenderName */
  senderName?: Maybe<Scalars['String']['output']>;
  /** UpdatedTime */
  updatedTime?: Maybe<Scalars['DateTime']['output']>;
};

/** A connection to a list of items. */
export type Wf_TrialModeLeads_AutoMailConnection = {
  __typename?: 'WF_TrialModeLeads_AutoMailConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_TrialModeLeads_AutoMailEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_TrialModeLeads_AutoMail>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_TrialModeLeads_AutoMailEdge = {
  __typename?: 'WF_TrialModeLeads_AutoMailEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_TrialModeLeads_AutoMail;
};

/** AutoMail */
export type Wf_TrialModeLeads_AutoMailFilterInput = {
  and?: InputMaybe<Array<Wf_TrialModeLeads_AutoMailFilterInput>>;
  /** CreatedTime */
  createdTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** MailBcc */
  mailBcc?: InputMaybe<StringOperationFilterInput>;
  /** MailCc */
  mailCc?: InputMaybe<StringOperationFilterInput>;
  /** MailContent */
  mailContent?: InputMaybe<StringOperationFilterInput>;
  /** [ID] MailId */
  mailId?: InputMaybe<IntOperationFilterInput>;
  /** MailStatus */
  mailStatus?: InputMaybe<StringOperationFilterInput>;
  /** MailSubject */
  mailSubject?: InputMaybe<StringOperationFilterInput>;
  /** MailTo */
  mailTo?: InputMaybe<StringOperationFilterInput>;
  /** Market */
  market?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Wf_TrialModeLeads_AutoMailFilterInput>>;
  /** SenderAddress */
  senderAddress?: InputMaybe<StringOperationFilterInput>;
  /** SenderName */
  senderName?: InputMaybe<StringOperationFilterInput>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<DateTimeOperationFilterInput>;
};

/** AutoMail */
export type Wf_TrialModeLeads_AutoMailInput = {
  /** CreatedTime */
  createdTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** MailBcc */
  mailBcc?: InputMaybe<Scalars['String']['input']>;
  /** MailCc */
  mailCc?: InputMaybe<Scalars['String']['input']>;
  /** MailContent */
  mailContent?: InputMaybe<Scalars['String']['input']>;
  /** [ID] MailId */
  mailId?: InputMaybe<Scalars['Int']['input']>;
  /** MailStatus */
  mailStatus?: InputMaybe<Scalars['String']['input']>;
  /** MailSubject */
  mailSubject?: InputMaybe<Scalars['String']['input']>;
  /** MailTo */
  mailTo?: InputMaybe<Scalars['String']['input']>;
  /** Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** SenderAddress */
  senderAddress?: InputMaybe<Scalars['String']['input']>;
  /** SenderName */
  senderName?: InputMaybe<Scalars['String']['input']>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<Scalars['DateTime']['input']>;
};

/** AutoMail */
export type Wf_TrialModeLeads_AutoMailSortInput = {
  /** CreatedTime */
  createdTime?: InputMaybe<SortEnumType>;
  /** MailBcc */
  mailBcc?: InputMaybe<SortEnumType>;
  /** MailCc */
  mailCc?: InputMaybe<SortEnumType>;
  /** MailContent */
  mailContent?: InputMaybe<SortEnumType>;
  /** [ID] MailId */
  mailId?: InputMaybe<SortEnumType>;
  /** MailStatus */
  mailStatus?: InputMaybe<SortEnumType>;
  /** MailSubject */
  mailSubject?: InputMaybe<SortEnumType>;
  /** MailTo */
  mailTo?: InputMaybe<SortEnumType>;
  /** Market */
  market?: InputMaybe<SortEnumType>;
  /** SenderAddress */
  senderAddress?: InputMaybe<SortEnumType>;
  /** SenderName */
  senderName?: InputMaybe<SortEnumType>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<SortEnumType>;
};

/** CallToAction */
export type Wf_TrialModeLeads_CallToAction = Node & {
  __typename?: 'WF_TrialModeLeads_CallToAction';
  /** ButtonLinksTo */
  buttonLinksTo?: Maybe<Scalars['String']['output']>;
  /** ButtonText */
  buttonText?: Maybe<Scalars['String']['output']>;
  /** [COLLECTION] CallToActionContents */
  callToActionContents?: Maybe<Array<Maybe<Wf_TrialModeLeads_CallToActionContent>>>;
  /** CreatedTime */
  createdTime?: Maybe<Scalars['DateTime']['output']>;
  /** Creator */
  creator?: Maybe<Scalars['String']['output']>;
  /** [NAVIGATION] CtaExperienceType */
  ctaExperienceType?: Maybe<Wf_TrialModeLeads_CallToActionExperienceType>;
  /** [NOT NULL] CtaExperienceTypeId */
  ctaExperienceTypeId?: Maybe<Scalars['Int']['output']>;
  /** [ID] CtaId */
  id: Scalars['ID']['output'];
  /** ImageCharacter */
  imageCharacter?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Market */
  market?: Maybe<Scalars['String']['output']>;
  /** PhotoFileName */
  photoFileName?: Maybe<Scalars['String']['output']>;
  /** Segmentation */
  segmentation?: Maybe<Scalars['String']['output']>;
  /** Template */
  template?: Maybe<Scalars['String']['output']>;
  /** UpdatedTime */
  updatedTime?: Maybe<Scalars['DateTime']['output']>;
  /** Updater */
  updater?: Maybe<Scalars['String']['output']>;
  /** VideoUrl */
  videoUrl?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Wf_TrialModeLeads_CallToActionConnection = {
  __typename?: 'WF_TrialModeLeads_CallToActionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_TrialModeLeads_CallToActionEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_TrialModeLeads_CallToAction>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** CallToActionContent */
export type Wf_TrialModeLeads_CallToActionContent = Node & {
  __typename?: 'WF_TrialModeLeads_CallToActionContent';
  /** CreatedTime */
  createdTime?: Maybe<Scalars['DateTime']['output']>;
  /** Creator */
  creator?: Maybe<Scalars['String']['output']>;
  /** [NAVIGATION] Cta */
  cta?: Maybe<Wf_TrialModeLeads_CallToAction>;
  /** CtaContent */
  ctaContent?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] CtaId */
  ctaId?: Maybe<Scalars['Int']['output']>;
  /** CtaTitle */
  ctaTitle?: Maybe<Scalars['String']['output']>;
  /** [ID] CtaContentId */
  id: Scalars['ID']['output'];
  /** UpdatedTime */
  updatedTime?: Maybe<Scalars['DateTime']['output']>;
  /** Updater */
  updater?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Wf_TrialModeLeads_CallToActionContentConnection = {
  __typename?: 'WF_TrialModeLeads_CallToActionContentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_TrialModeLeads_CallToActionContentEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_TrialModeLeads_CallToActionContent>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_TrialModeLeads_CallToActionContentEdge = {
  __typename?: 'WF_TrialModeLeads_CallToActionContentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_TrialModeLeads_CallToActionContent;
};

/** CallToActionContent */
export type Wf_TrialModeLeads_CallToActionContentFilterInput = {
  and?: InputMaybe<Array<Wf_TrialModeLeads_CallToActionContentFilterInput>>;
  /** CreatedTime */
  createdTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** Creator */
  creator?: InputMaybe<StringOperationFilterInput>;
  /** [NAVIGATION] Cta */
  cta?: InputMaybe<Wf_TrialModeLeads_CallToActionFilterInput>;
  /** CtaContent */
  ctaContent?: InputMaybe<StringOperationFilterInput>;
  /** [ID] CtaContentId */
  ctaContentId?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] CtaId */
  ctaId?: InputMaybe<IntOperationFilterInput>;
  /** CtaTitle */
  ctaTitle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Wf_TrialModeLeads_CallToActionContentFilterInput>>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** Updater */
  updater?: InputMaybe<StringOperationFilterInput>;
};

/** CallToActionContent */
export type Wf_TrialModeLeads_CallToActionContentInput = {
  /** CreatedTime */
  createdTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Creator */
  creator?: InputMaybe<Scalars['String']['input']>;
  /** [NAVIGATION] Cta */
  cta?: InputMaybe<Wf_TrialModeLeads_CallToActionInput>;
  /** CtaContent */
  ctaContent?: InputMaybe<Scalars['String']['input']>;
  /** [ID] CtaContentId */
  ctaContentId?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] CtaId */
  ctaId?: InputMaybe<Scalars['Int']['input']>;
  /** CtaTitle */
  ctaTitle?: InputMaybe<Scalars['String']['input']>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Updater */
  updater?: InputMaybe<Scalars['String']['input']>;
};

/** CallToActionContent */
export type Wf_TrialModeLeads_CallToActionContentSortInput = {
  /** CreatedTime */
  createdTime?: InputMaybe<SortEnumType>;
  /** Creator */
  creator?: InputMaybe<SortEnumType>;
  /** [NAVIGATION] Cta */
  cta?: InputMaybe<Wf_TrialModeLeads_CallToActionSortInput>;
  /** CtaContent */
  ctaContent?: InputMaybe<SortEnumType>;
  /** [ID] CtaContentId */
  ctaContentId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] CtaId */
  ctaId?: InputMaybe<SortEnumType>;
  /** CtaTitle */
  ctaTitle?: InputMaybe<SortEnumType>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<SortEnumType>;
  /** Updater */
  updater?: InputMaybe<SortEnumType>;
};

/** An edge in a connection. */
export type Wf_TrialModeLeads_CallToActionEdge = {
  __typename?: 'WF_TrialModeLeads_CallToActionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_TrialModeLeads_CallToAction;
};

/** CallToActionExperienceType */
export type Wf_TrialModeLeads_CallToActionExperienceType = Node & {
  __typename?: 'WF_TrialModeLeads_CallToActionExperienceType';
  /** [COLLECTION] CallToActions */
  callToActions?: Maybe<Array<Maybe<Wf_TrialModeLeads_CallToAction>>>;
  /** ExperienceDescription */
  experienceDescription?: Maybe<Scalars['String']['output']>;
  /** ExperienceName */
  experienceName?: Maybe<Scalars['String']['output']>;
  /** [ID] CtaExperienceTypeId */
  id: Scalars['ID']['output'];
};

/** A connection to a list of items. */
export type Wf_TrialModeLeads_CallToActionExperienceTypeConnection = {
  __typename?: 'WF_TrialModeLeads_CallToActionExperienceTypeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_TrialModeLeads_CallToActionExperienceTypeEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_TrialModeLeads_CallToActionExperienceType>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_TrialModeLeads_CallToActionExperienceTypeEdge = {
  __typename?: 'WF_TrialModeLeads_CallToActionExperienceTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_TrialModeLeads_CallToActionExperienceType;
};

/** CallToActionExperienceType */
export type Wf_TrialModeLeads_CallToActionExperienceTypeFilterInput = {
  and?: InputMaybe<Array<Wf_TrialModeLeads_CallToActionExperienceTypeFilterInput>>;
  /** [COLLECTION] CallToActions */
  callToActions?: InputMaybe<ListFilterInputTypeOfWf_TrialModeLeads_CallToActionFilterInput>;
  /** [ID] CtaExperienceTypeId */
  ctaExperienceTypeId?: InputMaybe<IntOperationFilterInput>;
  /** ExperienceDescription */
  experienceDescription?: InputMaybe<StringOperationFilterInput>;
  /** ExperienceName */
  experienceName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Wf_TrialModeLeads_CallToActionExperienceTypeFilterInput>>;
};

/** CallToActionExperienceType */
export type Wf_TrialModeLeads_CallToActionExperienceTypeInput = {
  /** [COLLECTION] CallToActions */
  callToActions?: InputMaybe<Array<InputMaybe<Wf_TrialModeLeads_CallToActionInput>>>;
  /** [ID] CtaExperienceTypeId */
  ctaExperienceTypeId?: InputMaybe<Scalars['Int']['input']>;
  /** ExperienceDescription */
  experienceDescription?: InputMaybe<Scalars['String']['input']>;
  /** ExperienceName */
  experienceName?: InputMaybe<Scalars['String']['input']>;
};

/** CallToActionExperienceType */
export type Wf_TrialModeLeads_CallToActionExperienceTypeSortInput = {
  /** [ID] CtaExperienceTypeId */
  ctaExperienceTypeId?: InputMaybe<SortEnumType>;
  /** ExperienceDescription */
  experienceDescription?: InputMaybe<SortEnumType>;
  /** ExperienceName */
  experienceName?: InputMaybe<SortEnumType>;
};

/** CallToAction */
export type Wf_TrialModeLeads_CallToActionFilterInput = {
  and?: InputMaybe<Array<Wf_TrialModeLeads_CallToActionFilterInput>>;
  /** ButtonLinksTo */
  buttonLinksTo?: InputMaybe<StringOperationFilterInput>;
  /** ButtonText */
  buttonText?: InputMaybe<StringOperationFilterInput>;
  /** [COLLECTION] CallToActionContents */
  callToActionContents?: InputMaybe<ListFilterInputTypeOfWf_TrialModeLeads_CallToActionContentFilterInput>;
  /** CreatedTime */
  createdTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** Creator */
  creator?: InputMaybe<StringOperationFilterInput>;
  /** [NAVIGATION] CtaExperienceType */
  ctaExperienceType?: InputMaybe<Wf_TrialModeLeads_CallToActionExperienceTypeFilterInput>;
  /** [NOT NULL] CtaExperienceTypeId */
  ctaExperienceTypeId?: InputMaybe<IntOperationFilterInput>;
  /** [ID] CtaId */
  ctaId?: InputMaybe<IntOperationFilterInput>;
  /** ImageCharacter */
  imageCharacter?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] Market */
  market?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Wf_TrialModeLeads_CallToActionFilterInput>>;
  /** PhotoFileName */
  photoFileName?: InputMaybe<StringOperationFilterInput>;
  /** Segmentation */
  segmentation?: InputMaybe<StringOperationFilterInput>;
  /** Template */
  template?: InputMaybe<StringOperationFilterInput>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** Updater */
  updater?: InputMaybe<StringOperationFilterInput>;
  /** VideoUrl */
  videoUrl?: InputMaybe<StringOperationFilterInput>;
};

/** CallToAction */
export type Wf_TrialModeLeads_CallToActionInput = {
  /** ButtonLinksTo */
  buttonLinksTo?: InputMaybe<Scalars['String']['input']>;
  /** ButtonText */
  buttonText?: InputMaybe<Scalars['String']['input']>;
  /** [COLLECTION] CallToActionContents */
  callToActionContents?: InputMaybe<Array<InputMaybe<Wf_TrialModeLeads_CallToActionContentInput>>>;
  /** CreatedTime */
  createdTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Creator */
  creator?: InputMaybe<Scalars['String']['input']>;
  /** [NAVIGATION] CtaExperienceType */
  ctaExperienceType?: InputMaybe<Wf_TrialModeLeads_CallToActionExperienceTypeInput>;
  /** [NOT NULL] CtaExperienceTypeId */
  ctaExperienceTypeId?: InputMaybe<Scalars['Int']['input']>;
  /** [ID] CtaId */
  ctaId?: InputMaybe<Scalars['Int']['input']>;
  /** ImageCharacter */
  imageCharacter?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** PhotoFileName */
  photoFileName?: InputMaybe<Scalars['String']['input']>;
  /** Segmentation */
  segmentation?: InputMaybe<Scalars['String']['input']>;
  /** Template */
  template?: InputMaybe<Scalars['String']['input']>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Updater */
  updater?: InputMaybe<Scalars['String']['input']>;
  /** VideoUrl */
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

/** CallToAction */
export type Wf_TrialModeLeads_CallToActionSortInput = {
  /** ButtonLinksTo */
  buttonLinksTo?: InputMaybe<SortEnumType>;
  /** ButtonText */
  buttonText?: InputMaybe<SortEnumType>;
  /** CreatedTime */
  createdTime?: InputMaybe<SortEnumType>;
  /** Creator */
  creator?: InputMaybe<SortEnumType>;
  /** [NAVIGATION] CtaExperienceType */
  ctaExperienceType?: InputMaybe<Wf_TrialModeLeads_CallToActionExperienceTypeSortInput>;
  /** [NOT NULL] CtaExperienceTypeId */
  ctaExperienceTypeId?: InputMaybe<SortEnumType>;
  /** [ID] CtaId */
  ctaId?: InputMaybe<SortEnumType>;
  /** ImageCharacter */
  imageCharacter?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Market */
  market?: InputMaybe<SortEnumType>;
  /** PhotoFileName */
  photoFileName?: InputMaybe<SortEnumType>;
  /** Segmentation */
  segmentation?: InputMaybe<SortEnumType>;
  /** Template */
  template?: InputMaybe<SortEnumType>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<SortEnumType>;
  /** Updater */
  updater?: InputMaybe<SortEnumType>;
  /** VideoUrl */
  videoUrl?: InputMaybe<SortEnumType>;
};

/** DesignImage */
export type Wf_TrialModeLeads_DesignImage = Node & {
  __typename?: 'WF_TrialModeLeads_DesignImage';
  /** [ID] DesignImageId */
  id: Scalars['ID']['output'];
  /** ImageFileName */
  imageFileName?: Maybe<Scalars['String']['output']>;
  /** ImageType */
  imageType?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Wf_TrialModeLeads_DesignImageConnection = {
  __typename?: 'WF_TrialModeLeads_DesignImageConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_TrialModeLeads_DesignImageEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_TrialModeLeads_DesignImage>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_TrialModeLeads_DesignImageEdge = {
  __typename?: 'WF_TrialModeLeads_DesignImageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_TrialModeLeads_DesignImage;
};

/** DesignImage */
export type Wf_TrialModeLeads_DesignImageFilterInput = {
  and?: InputMaybe<Array<Wf_TrialModeLeads_DesignImageFilterInput>>;
  /** [ID] DesignImageId */
  designImageId?: InputMaybe<IntOperationFilterInput>;
  /** ImageFileName */
  imageFileName?: InputMaybe<StringOperationFilterInput>;
  /** ImageType */
  imageType?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Wf_TrialModeLeads_DesignImageFilterInput>>;
};

/** DesignImage */
export type Wf_TrialModeLeads_DesignImageInput = {
  /** [ID] DesignImageId */
  designImageId?: InputMaybe<Scalars['Int']['input']>;
  /** ImageFileName */
  imageFileName?: InputMaybe<Scalars['String']['input']>;
  /** ImageType */
  imageType?: InputMaybe<Scalars['String']['input']>;
};

/** DesignImage */
export type Wf_TrialModeLeads_DesignImageSortInput = {
  /** [ID] DesignImageId */
  designImageId?: InputMaybe<SortEnumType>;
  /** ImageFileName */
  imageFileName?: InputMaybe<SortEnumType>;
  /** ImageType */
  imageType?: InputMaybe<SortEnumType>;
};

/** FeaturedEvent */
export type Wf_TrialModeLeads_FeaturedEvent = Node & {
  __typename?: 'WF_TrialModeLeads_FeaturedEvent';
  /** CreatedTime */
  createdTime?: Maybe<Scalars['DateTime']['output']>;
  /** Creator */
  creator?: Maybe<Scalars['String']['output']>;
  /** EndDate */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** [ID] FeaturedEventId */
  id: Scalars['ID']['output'];
  /** ImageFileName */
  imageFileName?: Maybe<Scalars['String']['output']>;
  /** Market */
  market?: Maybe<Scalars['String']['output']>;
  /** NavigationUrl */
  navigationUrl?: Maybe<Scalars['String']['output']>;
  /** SortId */
  sortId?: Maybe<Scalars['Int']['output']>;
  /** StartDate */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  /** UpdatedTime */
  updatedTime?: Maybe<Scalars['DateTime']['output']>;
  /** Updater */
  updater?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Wf_TrialModeLeads_FeaturedEventConnection = {
  __typename?: 'WF_TrialModeLeads_FeaturedEventConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_TrialModeLeads_FeaturedEventEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_TrialModeLeads_FeaturedEvent>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_TrialModeLeads_FeaturedEventEdge = {
  __typename?: 'WF_TrialModeLeads_FeaturedEventEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_TrialModeLeads_FeaturedEvent;
};

/** FeaturedEvent */
export type Wf_TrialModeLeads_FeaturedEventFilterInput = {
  and?: InputMaybe<Array<Wf_TrialModeLeads_FeaturedEventFilterInput>>;
  /** CreatedTime */
  createdTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** Creator */
  creator?: InputMaybe<StringOperationFilterInput>;
  /** EndDate */
  endDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** [ID] FeaturedEventId */
  featuredEventId?: InputMaybe<IntOperationFilterInput>;
  /** ImageFileName */
  imageFileName?: InputMaybe<StringOperationFilterInput>;
  /** Market */
  market?: InputMaybe<StringOperationFilterInput>;
  /** NavigationUrl */
  navigationUrl?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Wf_TrialModeLeads_FeaturedEventFilterInput>>;
  /** SortId */
  sortId?: InputMaybe<IntOperationFilterInput>;
  /** StartDate */
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** Updater */
  updater?: InputMaybe<StringOperationFilterInput>;
};

/** FeaturedEvent */
export type Wf_TrialModeLeads_FeaturedEventInput = {
  /** CreatedTime */
  createdTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Creator */
  creator?: InputMaybe<Scalars['String']['input']>;
  /** EndDate */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** [ID] FeaturedEventId */
  featuredEventId?: InputMaybe<Scalars['Int']['input']>;
  /** ImageFileName */
  imageFileName?: InputMaybe<Scalars['String']['input']>;
  /** Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** NavigationUrl */
  navigationUrl?: InputMaybe<Scalars['String']['input']>;
  /** SortId */
  sortId?: InputMaybe<Scalars['Int']['input']>;
  /** StartDate */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Updater */
  updater?: InputMaybe<Scalars['String']['input']>;
};

/** FeaturedEvent */
export type Wf_TrialModeLeads_FeaturedEventSortInput = {
  /** CreatedTime */
  createdTime?: InputMaybe<SortEnumType>;
  /** Creator */
  creator?: InputMaybe<SortEnumType>;
  /** EndDate */
  endDate?: InputMaybe<SortEnumType>;
  /** [ID] FeaturedEventId */
  featuredEventId?: InputMaybe<SortEnumType>;
  /** ImageFileName */
  imageFileName?: InputMaybe<SortEnumType>;
  /** Market */
  market?: InputMaybe<SortEnumType>;
  /** NavigationUrl */
  navigationUrl?: InputMaybe<SortEnumType>;
  /** SortId */
  sortId?: InputMaybe<SortEnumType>;
  /** StartDate */
  startDate?: InputMaybe<SortEnumType>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<SortEnumType>;
  /** Updater */
  updater?: InputMaybe<SortEnumType>;
};

/** GraphqlAccess */
export type Wf_TrialModeLeads_GraphqlAccess = Node & {
  __typename?: 'WF_TrialModeLeads_GraphqlAccess';
  /** AccessSchema */
  accessSchema?: Maybe<Scalars['String']['output']>;
  /** AccessSchemaHash */
  accessSchemaHash?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Database */
  database?: Maybe<Scalars['String']['output']>;
  /** [NAVIGATION] GraphqlSchema */
  graphqlSchema?: Maybe<Wf_TrialModeLeads_GraphqlSchema>;
  /** [NOT NULL] GraphqlSchemaId */
  graphqlSchemaId?: Maybe<Scalars['UUID']['output']>;
  /** [ID] GraphqlAccessId */
  id: Scalars['ID']['output'];
  /** [NOT NULL] ProjectId */
  projectId?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Server */
  server?: Maybe<Scalars['String']['output']>;
  /** UpdateTime */
  updateTime?: Maybe<Scalars['DateTime']['output']>;
};

/** A connection to a list of items. */
export type Wf_TrialModeLeads_GraphqlAccessConnection = {
  __typename?: 'WF_TrialModeLeads_GraphqlAccessConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_TrialModeLeads_GraphqlAccessEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_TrialModeLeads_GraphqlAccess>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_TrialModeLeads_GraphqlAccessEdge = {
  __typename?: 'WF_TrialModeLeads_GraphqlAccessEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_TrialModeLeads_GraphqlAccess;
};

/** GraphqlAccess */
export type Wf_TrialModeLeads_GraphqlAccessFilterInput = {
  /** AccessSchema */
  accessSchema?: InputMaybe<StringOperationFilterInput>;
  /** AccessSchemaHash */
  accessSchemaHash?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<Wf_TrialModeLeads_GraphqlAccessFilterInput>>;
  /** [NOT NULL] Database */
  database?: InputMaybe<StringOperationFilterInput>;
  /** [ID] GraphqlAccessId */
  graphqlAccessId?: InputMaybe<UuidOperationFilterInput>;
  /** [NAVIGATION] GraphqlSchema */
  graphqlSchema?: InputMaybe<Wf_TrialModeLeads_GraphqlSchemaFilterInput>;
  /** [NOT NULL] GraphqlSchemaId */
  graphqlSchemaId?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<Wf_TrialModeLeads_GraphqlAccessFilterInput>>;
  /** [NOT NULL] ProjectId */
  projectId?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] Server */
  server?: InputMaybe<StringOperationFilterInput>;
  /** UpdateTime */
  updateTime?: InputMaybe<DateTimeOperationFilterInput>;
};

/** GraphqlAccess */
export type Wf_TrialModeLeads_GraphqlAccessInput = {
  /** AccessSchema */
  accessSchema?: InputMaybe<Scalars['String']['input']>;
  /** AccessSchemaHash */
  accessSchemaHash?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Database */
  database?: InputMaybe<Scalars['String']['input']>;
  /** [ID] GraphqlAccessId */
  graphqlAccessId?: InputMaybe<Scalars['UUID']['input']>;
  /** [NAVIGATION] GraphqlSchema */
  graphqlSchema?: InputMaybe<Wf_TrialModeLeads_GraphqlSchemaInput>;
  /** [NOT NULL] GraphqlSchemaId */
  graphqlSchemaId?: InputMaybe<Scalars['UUID']['input']>;
  /** [NOT NULL] ProjectId */
  projectId?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Server */
  server?: InputMaybe<Scalars['String']['input']>;
  /** UpdateTime */
  updateTime?: InputMaybe<Scalars['DateTime']['input']>;
};

/** GraphqlAccess */
export type Wf_TrialModeLeads_GraphqlAccessSortInput = {
  /** AccessSchema */
  accessSchema?: InputMaybe<SortEnumType>;
  /** AccessSchemaHash */
  accessSchemaHash?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Database */
  database?: InputMaybe<SortEnumType>;
  /** [ID] GraphqlAccessId */
  graphqlAccessId?: InputMaybe<SortEnumType>;
  /** [NAVIGATION] GraphqlSchema */
  graphqlSchema?: InputMaybe<Wf_TrialModeLeads_GraphqlSchemaSortInput>;
  /** [NOT NULL] GraphqlSchemaId */
  graphqlSchemaId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] ProjectId */
  projectId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Server */
  server?: InputMaybe<SortEnumType>;
  /** UpdateTime */
  updateTime?: InputMaybe<SortEnumType>;
};

/** GraphqlSchema */
export type Wf_TrialModeLeads_GraphqlSchema = Node & {
  __typename?: 'WF_TrialModeLeads_GraphqlSchema';
  /** [NOT NULL] Database */
  database?: Maybe<Scalars['String']['output']>;
  /** [COLLECTION] GraphqlAccesses */
  graphqlAccesses?: Maybe<Array<Maybe<Wf_TrialModeLeads_GraphqlAccess>>>;
  /** [ID] GraphqlSchemaId */
  id: Scalars['ID']['output'];
  /** Schema */
  schema?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Server */
  server?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Wf_TrialModeLeads_GraphqlSchemaConnection = {
  __typename?: 'WF_TrialModeLeads_GraphqlSchemaConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_TrialModeLeads_GraphqlSchemaEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_TrialModeLeads_GraphqlSchema>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_TrialModeLeads_GraphqlSchemaEdge = {
  __typename?: 'WF_TrialModeLeads_GraphqlSchemaEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_TrialModeLeads_GraphqlSchema;
};

/** GraphqlSchema */
export type Wf_TrialModeLeads_GraphqlSchemaFilterInput = {
  and?: InputMaybe<Array<Wf_TrialModeLeads_GraphqlSchemaFilterInput>>;
  /** [NOT NULL] Database */
  database?: InputMaybe<StringOperationFilterInput>;
  /** [COLLECTION] GraphqlAccesses */
  graphqlAccesses?: InputMaybe<ListFilterInputTypeOfWf_TrialModeLeads_GraphqlAccessFilterInput>;
  /** [ID] GraphqlSchemaId */
  graphqlSchemaId?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<Wf_TrialModeLeads_GraphqlSchemaFilterInput>>;
  /** Schema */
  schema?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] Server */
  server?: InputMaybe<StringOperationFilterInput>;
};

/** GraphqlSchema */
export type Wf_TrialModeLeads_GraphqlSchemaInput = {
  /** [NOT NULL] Database */
  database?: InputMaybe<Scalars['String']['input']>;
  /** [COLLECTION] GraphqlAccesses */
  graphqlAccesses?: InputMaybe<Array<InputMaybe<Wf_TrialModeLeads_GraphqlAccessInput>>>;
  /** [ID] GraphqlSchemaId */
  graphqlSchemaId?: InputMaybe<Scalars['UUID']['input']>;
  /** Schema */
  schema?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Server */
  server?: InputMaybe<Scalars['String']['input']>;
};

/** GraphqlSchema */
export type Wf_TrialModeLeads_GraphqlSchemaSortInput = {
  /** [NOT NULL] Database */
  database?: InputMaybe<SortEnumType>;
  /** [ID] GraphqlSchemaId */
  graphqlSchemaId?: InputMaybe<SortEnumType>;
  /** Schema */
  schema?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Server */
  server?: InputMaybe<SortEnumType>;
};

/** Installation */
export type Wf_TrialModeLeads_Installation = Node & {
  __typename?: 'WF_TrialModeLeads_Installation';
  /** [ID] Seq */
  id: Scalars['ID']['output'];
  /** InstallDate */
  installDate?: Maybe<Scalars['DateTime']['output']>;
  /** InstallationCampaignIds */
  installationCampaignIds?: Maybe<Scalars['String']['output']>;
  /** Numbers */
  numbers?: Maybe<Scalars['Short']['output']>;
};

/** A connection to a list of items. */
export type Wf_TrialModeLeads_InstallationConnection = {
  __typename?: 'WF_TrialModeLeads_InstallationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_TrialModeLeads_InstallationEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_TrialModeLeads_Installation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_TrialModeLeads_InstallationEdge = {
  __typename?: 'WF_TrialModeLeads_InstallationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_TrialModeLeads_Installation;
};

/** Installation */
export type Wf_TrialModeLeads_InstallationFilterInput = {
  and?: InputMaybe<Array<Wf_TrialModeLeads_InstallationFilterInput>>;
  /** InstallDate */
  installDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** InstallationCampaignIds */
  installationCampaignIds?: InputMaybe<StringOperationFilterInput>;
  /** Numbers */
  numbers?: InputMaybe<ShortOperationFilterInput>;
  or?: InputMaybe<Array<Wf_TrialModeLeads_InstallationFilterInput>>;
  /** [ID] Seq */
  seq?: InputMaybe<IntOperationFilterInput>;
};

/** Installation */
export type Wf_TrialModeLeads_InstallationInput = {
  /** InstallDate */
  installDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** InstallationCampaignIds */
  installationCampaignIds?: InputMaybe<Scalars['String']['input']>;
  /** Numbers */
  numbers?: InputMaybe<Scalars['Short']['input']>;
  /** [ID] Seq */
  seq?: InputMaybe<Scalars['Int']['input']>;
};

/** InstallationLog */
export type Wf_TrialModeLeads_InstallationLog = Node & {
  __typename?: 'WF_TrialModeLeads_InstallationLog';
  /** CreationDate */
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  /** DeviceType */
  deviceType?: Maybe<Scalars['String']['output']>;
  /** [ID] InstallationLogId */
  id: Scalars['ID']['output'];
  /** Market */
  market?: Maybe<Scalars['String']['output']>;
  /** SourceCode */
  sourceCode?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Wf_TrialModeLeads_InstallationLogConnection = {
  __typename?: 'WF_TrialModeLeads_InstallationLogConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_TrialModeLeads_InstallationLogEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_TrialModeLeads_InstallationLog>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_TrialModeLeads_InstallationLogEdge = {
  __typename?: 'WF_TrialModeLeads_InstallationLogEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_TrialModeLeads_InstallationLog;
};

/** InstallationLog */
export type Wf_TrialModeLeads_InstallationLogFilterInput = {
  and?: InputMaybe<Array<Wf_TrialModeLeads_InstallationLogFilterInput>>;
  /** CreationDate */
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** DeviceType */
  deviceType?: InputMaybe<StringOperationFilterInput>;
  /** [ID] InstallationLogId */
  installationLogId?: InputMaybe<IntOperationFilterInput>;
  /** Market */
  market?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Wf_TrialModeLeads_InstallationLogFilterInput>>;
  /** SourceCode */
  sourceCode?: InputMaybe<StringOperationFilterInput>;
};

/** InstallationLog */
export type Wf_TrialModeLeads_InstallationLogInput = {
  /** CreationDate */
  creationDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** DeviceType */
  deviceType?: InputMaybe<Scalars['String']['input']>;
  /** [ID] InstallationLogId */
  installationLogId?: InputMaybe<Scalars['Int']['input']>;
  /** Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** SourceCode */
  sourceCode?: InputMaybe<Scalars['String']['input']>;
};

/** InstallationLog */
export type Wf_TrialModeLeads_InstallationLogSortInput = {
  /** CreationDate */
  creationDate?: InputMaybe<SortEnumType>;
  /** DeviceType */
  deviceType?: InputMaybe<SortEnumType>;
  /** [ID] InstallationLogId */
  installationLogId?: InputMaybe<SortEnumType>;
  /** Market */
  market?: InputMaybe<SortEnumType>;
  /** SourceCode */
  sourceCode?: InputMaybe<SortEnumType>;
};

/** Installation */
export type Wf_TrialModeLeads_InstallationSortInput = {
  /** InstallDate */
  installDate?: InputMaybe<SortEnumType>;
  /** InstallationCampaignIds */
  installationCampaignIds?: InputMaybe<SortEnumType>;
  /** Numbers */
  numbers?: InputMaybe<SortEnumType>;
  /** [ID] Seq */
  seq?: InputMaybe<SortEnumType>;
};

/** JourneyCard */
export type Wf_TrialModeLeads_JourneyCard = Node & {
  __typename?: 'WF_TrialModeLeads_JourneyCard';
  /** CreatedTime */
  createdTime?: Maybe<Scalars['DateTime']['output']>;
  /** Creator */
  creator?: Maybe<Scalars['String']['output']>;
  /** ExperienceCharacter */
  experienceCharacter?: Maybe<Scalars['String']['output']>;
  /** ExperienceNavigationUrl */
  experienceNavigationUrl?: Maybe<Scalars['String']['output']>;
  /** ExperienceNavigationWording */
  experienceNavigationWording?: Maybe<Scalars['String']['output']>;
  /** ExperiencePromotionWording */
  experiencePromotionWording?: Maybe<Scalars['String']['output']>;
  /** Greeting */
  greeting?: Maybe<Scalars['String']['output']>;
  /** [ID] JourneyCardId */
  id: Scalars['ID']['output'];
  /** IsDisplayVideo */
  isDisplayVideo?: Maybe<Scalars['Boolean']['output']>;
  /** [NAVIGATION] JourneyExperienceType */
  journeyExperienceType?: Maybe<Wf_TrialModeLeads_JourneyExperienceType>;
  /** [NOT NULL] JourneyExperienceTypeId */
  journeyExperienceTypeId?: Maybe<Scalars['Int']['output']>;
  /** Market */
  market?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] Segmentation */
  segmentation?: Maybe<Scalars['String']['output']>;
  /** UpdatedTime */
  updatedTime?: Maybe<Scalars['DateTime']['output']>;
  /** Updater */
  updater?: Maybe<Scalars['String']['output']>;
  /** VideoUrl */
  videoUrl?: Maybe<Scalars['String']['output']>;
  /** VideoWording */
  videoWording?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Wf_TrialModeLeads_JourneyCardConnection = {
  __typename?: 'WF_TrialModeLeads_JourneyCardConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_TrialModeLeads_JourneyCardEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_TrialModeLeads_JourneyCard>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_TrialModeLeads_JourneyCardEdge = {
  __typename?: 'WF_TrialModeLeads_JourneyCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_TrialModeLeads_JourneyCard;
};

/** JourneyCard */
export type Wf_TrialModeLeads_JourneyCardFilterInput = {
  and?: InputMaybe<Array<Wf_TrialModeLeads_JourneyCardFilterInput>>;
  /** CreatedTime */
  createdTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** Creator */
  creator?: InputMaybe<StringOperationFilterInput>;
  /** ExperienceCharacter */
  experienceCharacter?: InputMaybe<StringOperationFilterInput>;
  /** ExperienceNavigationUrl */
  experienceNavigationUrl?: InputMaybe<StringOperationFilterInput>;
  /** ExperienceNavigationWording */
  experienceNavigationWording?: InputMaybe<StringOperationFilterInput>;
  /** ExperiencePromotionWording */
  experiencePromotionWording?: InputMaybe<StringOperationFilterInput>;
  /** Greeting */
  greeting?: InputMaybe<StringOperationFilterInput>;
  /** IsDisplayVideo */
  isDisplayVideo?: InputMaybe<BooleanOperationFilterInput>;
  /** [ID] JourneyCardId */
  journeyCardId?: InputMaybe<IntOperationFilterInput>;
  /** [NAVIGATION] JourneyExperienceType */
  journeyExperienceType?: InputMaybe<Wf_TrialModeLeads_JourneyExperienceTypeFilterInput>;
  /** [NOT NULL] JourneyExperienceTypeId */
  journeyExperienceTypeId?: InputMaybe<IntOperationFilterInput>;
  /** Market */
  market?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Wf_TrialModeLeads_JourneyCardFilterInput>>;
  /** [NOT NULL] Segmentation */
  segmentation?: InputMaybe<StringOperationFilterInput>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** Updater */
  updater?: InputMaybe<StringOperationFilterInput>;
  /** VideoUrl */
  videoUrl?: InputMaybe<StringOperationFilterInput>;
  /** VideoWording */
  videoWording?: InputMaybe<StringOperationFilterInput>;
};

/** JourneyCard */
export type Wf_TrialModeLeads_JourneyCardInput = {
  /** CreatedTime */
  createdTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Creator */
  creator?: InputMaybe<Scalars['String']['input']>;
  /** ExperienceCharacter */
  experienceCharacter?: InputMaybe<Scalars['String']['input']>;
  /** ExperienceNavigationUrl */
  experienceNavigationUrl?: InputMaybe<Scalars['String']['input']>;
  /** ExperienceNavigationWording */
  experienceNavigationWording?: InputMaybe<Scalars['String']['input']>;
  /** ExperiencePromotionWording */
  experiencePromotionWording?: InputMaybe<Scalars['String']['input']>;
  /** Greeting */
  greeting?: InputMaybe<Scalars['String']['input']>;
  /** IsDisplayVideo */
  isDisplayVideo?: InputMaybe<Scalars['Boolean']['input']>;
  /** [ID] JourneyCardId */
  journeyCardId?: InputMaybe<Scalars['Int']['input']>;
  /** [NAVIGATION] JourneyExperienceType */
  journeyExperienceType?: InputMaybe<Wf_TrialModeLeads_JourneyExperienceTypeInput>;
  /** [NOT NULL] JourneyExperienceTypeId */
  journeyExperienceTypeId?: InputMaybe<Scalars['Int']['input']>;
  /** Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] Segmentation */
  segmentation?: InputMaybe<Scalars['String']['input']>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Updater */
  updater?: InputMaybe<Scalars['String']['input']>;
  /** VideoUrl */
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  /** VideoWording */
  videoWording?: InputMaybe<Scalars['String']['input']>;
};

/** JourneyCard */
export type Wf_TrialModeLeads_JourneyCardSortInput = {
  /** CreatedTime */
  createdTime?: InputMaybe<SortEnumType>;
  /** Creator */
  creator?: InputMaybe<SortEnumType>;
  /** ExperienceCharacter */
  experienceCharacter?: InputMaybe<SortEnumType>;
  /** ExperienceNavigationUrl */
  experienceNavigationUrl?: InputMaybe<SortEnumType>;
  /** ExperienceNavigationWording */
  experienceNavigationWording?: InputMaybe<SortEnumType>;
  /** ExperiencePromotionWording */
  experiencePromotionWording?: InputMaybe<SortEnumType>;
  /** Greeting */
  greeting?: InputMaybe<SortEnumType>;
  /** IsDisplayVideo */
  isDisplayVideo?: InputMaybe<SortEnumType>;
  /** [ID] JourneyCardId */
  journeyCardId?: InputMaybe<SortEnumType>;
  /** [NAVIGATION] JourneyExperienceType */
  journeyExperienceType?: InputMaybe<Wf_TrialModeLeads_JourneyExperienceTypeSortInput>;
  /** [NOT NULL] JourneyExperienceTypeId */
  journeyExperienceTypeId?: InputMaybe<SortEnumType>;
  /** Market */
  market?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Segmentation */
  segmentation?: InputMaybe<SortEnumType>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<SortEnumType>;
  /** Updater */
  updater?: InputMaybe<SortEnumType>;
  /** VideoUrl */
  videoUrl?: InputMaybe<SortEnumType>;
  /** VideoWording */
  videoWording?: InputMaybe<SortEnumType>;
};

/** JourneyExperienceType */
export type Wf_TrialModeLeads_JourneyExperienceType = Node & {
  __typename?: 'WF_TrialModeLeads_JourneyExperienceType';
  /** ExperienceDescription */
  experienceDescription?: Maybe<Scalars['String']['output']>;
  /** ExperienceName */
  experienceName?: Maybe<Scalars['String']['output']>;
  /** [ID] JourneyExperienceTypeId */
  id: Scalars['ID']['output'];
  /** [COLLECTION] JourneyCards */
  journeyCards?: Maybe<Array<Maybe<Wf_TrialModeLeads_JourneyCard>>>;
};

/** A connection to a list of items. */
export type Wf_TrialModeLeads_JourneyExperienceTypeConnection = {
  __typename?: 'WF_TrialModeLeads_JourneyExperienceTypeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_TrialModeLeads_JourneyExperienceTypeEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_TrialModeLeads_JourneyExperienceType>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_TrialModeLeads_JourneyExperienceTypeEdge = {
  __typename?: 'WF_TrialModeLeads_JourneyExperienceTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_TrialModeLeads_JourneyExperienceType;
};

/** JourneyExperienceType */
export type Wf_TrialModeLeads_JourneyExperienceTypeFilterInput = {
  and?: InputMaybe<Array<Wf_TrialModeLeads_JourneyExperienceTypeFilterInput>>;
  /** ExperienceDescription */
  experienceDescription?: InputMaybe<StringOperationFilterInput>;
  /** ExperienceName */
  experienceName?: InputMaybe<StringOperationFilterInput>;
  /** [COLLECTION] JourneyCards */
  journeyCards?: InputMaybe<ListFilterInputTypeOfWf_TrialModeLeads_JourneyCardFilterInput>;
  /** [ID] JourneyExperienceTypeId */
  journeyExperienceTypeId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<Wf_TrialModeLeads_JourneyExperienceTypeFilterInput>>;
};

/** JourneyExperienceType */
export type Wf_TrialModeLeads_JourneyExperienceTypeInput = {
  /** ExperienceDescription */
  experienceDescription?: InputMaybe<Scalars['String']['input']>;
  /** ExperienceName */
  experienceName?: InputMaybe<Scalars['String']['input']>;
  /** [COLLECTION] JourneyCards */
  journeyCards?: InputMaybe<Array<InputMaybe<Wf_TrialModeLeads_JourneyCardInput>>>;
  /** [ID] JourneyExperienceTypeId */
  journeyExperienceTypeId?: InputMaybe<Scalars['Int']['input']>;
};

/** JourneyExperienceType */
export type Wf_TrialModeLeads_JourneyExperienceTypeSortInput = {
  /** ExperienceDescription */
  experienceDescription?: InputMaybe<SortEnumType>;
  /** ExperienceName */
  experienceName?: InputMaybe<SortEnumType>;
  /** [ID] JourneyExperienceTypeId */
  journeyExperienceTypeId?: InputMaybe<SortEnumType>;
};

export type Wf_TrialModeLeads_Mutation_Add = {
  __typename?: 'WF_TrialModeLeads_Mutation_Add';
  allParentTip?: Maybe<Wf_TrialModeLeads_AllParentTip>;
  appAnnouncementBar?: Maybe<Wf_TrialModeLeads_AppAnnouncementBar>;
  appAnnouncementBarMarket?: Maybe<Wf_TrialModeLeads_AppAnnouncementBarMarket>;
  autoMail?: Maybe<Wf_TrialModeLeads_AutoMail>;
  callToAction?: Maybe<Wf_TrialModeLeads_CallToAction>;
  callToActionContent?: Maybe<Wf_TrialModeLeads_CallToActionContent>;
  callToActionExperienceType?: Maybe<Wf_TrialModeLeads_CallToActionExperienceType>;
  designImage?: Maybe<Wf_TrialModeLeads_DesignImage>;
  featuredEvent?: Maybe<Wf_TrialModeLeads_FeaturedEvent>;
  graphqlAccess?: Maybe<Wf_TrialModeLeads_GraphqlAccess>;
  graphqlSchema?: Maybe<Wf_TrialModeLeads_GraphqlSchema>;
  installation?: Maybe<Wf_TrialModeLeads_Installation>;
  installationLog?: Maybe<Wf_TrialModeLeads_InstallationLog>;
  journeyCard?: Maybe<Wf_TrialModeLeads_JourneyCard>;
  journeyExperienceType?: Maybe<Wf_TrialModeLeads_JourneyExperienceType>;
  notification?: Maybe<Wf_TrialModeLeads_Notification>;
  notificationChild?: Maybe<Wf_TrialModeLeads_NotificationChild>;
  notificationMember?: Maybe<Wf_TrialModeLeads_NotificationMember>;
  notificationToChildAge?: Maybe<Wf_TrialModeLeads_NotificationToChildAge>;
  notificationToSegmentation?: Maybe<Wf_TrialModeLeads_NotificationToSegmentation>;
  notificationType?: Maybe<Wf_TrialModeLeads_NotificationType>;
  parentTip?: Maybe<Wf_TrialModeLeads_ParentTip>;
  productCategory?: Maybe<Wf_TrialModeLeads_ProductCategory>;
  productSong?: Maybe<Wf_TrialModeLeads_ProductSong>;
  productSongAndMarket?: Maybe<Wf_TrialModeLeads_ProductSongAndMarket>;
  productVideo?: Maybe<Wf_TrialModeLeads_ProductVideo>;
  productVideoAndMarket?: Maybe<Wf_TrialModeLeads_ProductVideoAndMarket>;
  regularEvent?: Maybe<Wf_TrialModeLeads_RegularEvent>;
  tacoTest?: Maybe<Wf_TrialModeLeads_TacoTest>;
  tempProductVideo?: Maybe<Wf_TrialModeLeads_TempProductVideo>;
  testimonial?: Maybe<Wf_TrialModeLeads_Testimonial>;
  testimonialTag?: Maybe<Wf_TrialModeLeads_TestimonialTag>;
  testimonialTagMapping?: Maybe<Wf_TrialModeLeads_TestimonialTagMapping>;
  tip?: Maybe<Wf_TrialModeLeads_Tip>;
  trialCampaignUrl?: Maybe<Wf_TrialModeLeads_TrialCampaignUrl>;
  trialMailLog?: Maybe<Wf_TrialModeLeads_TrialMailLog>;
  trialMailSetting?: Maybe<Wf_TrialModeLeads_TrialMailSetting>;
  trialMessageSetting?: Maybe<Wf_TrialModeLeads_TrialMessageSetting>;
  trialOneTimeToken?: Maybe<Wf_TrialModeLeads_TrialOneTimeToken>;
  trialPushType?: Maybe<Wf_TrialModeLeads_TrialPushType>;
  trialSegmentation?: Maybe<Wf_TrialModeLeads_TrialSegmentation>;
  trialSetting?: Maybe<Wf_TrialModeLeads_TrialSetting>;
  trialTestPhone?: Maybe<Wf_TrialModeLeads_TrialTestPhone>;
  trialToken?: Maybe<Wf_TrialModeLeads_TrialToken>;
  trialTrackingLog?: Maybe<Wf_TrialModeLeads_TrialTrackingLog>;
  trialUser?: Maybe<Wf_TrialModeLeads_TrialUser>;
  trialUserMessageLog?: Maybe<Wf_TrialModeLeads_TrialUserMessageLog>;
  trialUserNotification?: Maybe<Wf_TrialModeLeads_TrialUserNotification>;
  trialUserSegmentationLog?: Maybe<Wf_TrialModeLeads_TrialUserSegmentationLog>;
};

export type Wf_TrialModeLeads_Mutation_AddInput = {
  allParentTip?: InputMaybe<Wf_TrialModeLeads_AllParentTipInput>;
  appAnnouncementBar?: InputMaybe<Wf_TrialModeLeads_AppAnnouncementBarInput>;
  appAnnouncementBarMarket?: InputMaybe<Wf_TrialModeLeads_AppAnnouncementBarMarketInput>;
  autoMail?: InputMaybe<Wf_TrialModeLeads_AutoMailInput>;
  callToAction?: InputMaybe<Wf_TrialModeLeads_CallToActionInput>;
  callToActionContent?: InputMaybe<Wf_TrialModeLeads_CallToActionContentInput>;
  callToActionExperienceType?: InputMaybe<Wf_TrialModeLeads_CallToActionExperienceTypeInput>;
  designImage?: InputMaybe<Wf_TrialModeLeads_DesignImageInput>;
  featuredEvent?: InputMaybe<Wf_TrialModeLeads_FeaturedEventInput>;
  graphqlAccess?: InputMaybe<Wf_TrialModeLeads_GraphqlAccessInput>;
  graphqlSchema?: InputMaybe<Wf_TrialModeLeads_GraphqlSchemaInput>;
  installation?: InputMaybe<Wf_TrialModeLeads_InstallationInput>;
  installationLog?: InputMaybe<Wf_TrialModeLeads_InstallationLogInput>;
  journeyCard?: InputMaybe<Wf_TrialModeLeads_JourneyCardInput>;
  journeyExperienceType?: InputMaybe<Wf_TrialModeLeads_JourneyExperienceTypeInput>;
  notification?: InputMaybe<Wf_TrialModeLeads_NotificationInput>;
  notificationChild?: InputMaybe<Wf_TrialModeLeads_NotificationChildInput>;
  notificationMember?: InputMaybe<Wf_TrialModeLeads_NotificationMemberInput>;
  notificationToChildAge?: InputMaybe<Wf_TrialModeLeads_NotificationToChildAgeInput>;
  notificationToSegmentation?: InputMaybe<Wf_TrialModeLeads_NotificationToSegmentationInput>;
  notificationType?: InputMaybe<Wf_TrialModeLeads_NotificationTypeInput>;
  parentTip?: InputMaybe<Wf_TrialModeLeads_ParentTipInput>;
  productCategory?: InputMaybe<Wf_TrialModeLeads_ProductCategoryInput>;
  productSong?: InputMaybe<Wf_TrialModeLeads_ProductSongInput>;
  productSongAndMarket?: InputMaybe<Wf_TrialModeLeads_ProductSongAndMarketInput>;
  productVideo?: InputMaybe<Wf_TrialModeLeads_ProductVideoInput>;
  productVideoAndMarket?: InputMaybe<Wf_TrialModeLeads_ProductVideoAndMarketInput>;
  regularEvent?: InputMaybe<Wf_TrialModeLeads_RegularEventInput>;
  tacoTest?: InputMaybe<Wf_TrialModeLeads_TacoTestInput>;
  tempProductVideo?: InputMaybe<Wf_TrialModeLeads_TempProductVideoInput>;
  testimonial?: InputMaybe<Wf_TrialModeLeads_TestimonialInput>;
  testimonialTag?: InputMaybe<Wf_TrialModeLeads_TestimonialTagInput>;
  testimonialTagMapping?: InputMaybe<Wf_TrialModeLeads_TestimonialTagMappingInput>;
  tip?: InputMaybe<Wf_TrialModeLeads_TipInput>;
  trialCampaignUrl?: InputMaybe<Wf_TrialModeLeads_TrialCampaignUrlInput>;
  trialMailLog?: InputMaybe<Wf_TrialModeLeads_TrialMailLogInput>;
  trialMailSetting?: InputMaybe<Wf_TrialModeLeads_TrialMailSettingInput>;
  trialMessageSetting?: InputMaybe<Wf_TrialModeLeads_TrialMessageSettingInput>;
  trialOneTimeToken?: InputMaybe<Wf_TrialModeLeads_TrialOneTimeTokenInput>;
  trialPushType?: InputMaybe<Wf_TrialModeLeads_TrialPushTypeInput>;
  trialSegmentation?: InputMaybe<Wf_TrialModeLeads_TrialSegmentationInput>;
  trialSetting?: InputMaybe<Wf_TrialModeLeads_TrialSettingInput>;
  trialTestPhone?: InputMaybe<Wf_TrialModeLeads_TrialTestPhoneInput>;
  trialToken?: InputMaybe<Wf_TrialModeLeads_TrialTokenInput>;
  trialTrackingLog?: InputMaybe<Wf_TrialModeLeads_TrialTrackingLogInput>;
  trialUser?: InputMaybe<Wf_TrialModeLeads_TrialUserInput>;
  trialUserMessageLog?: InputMaybe<Wf_TrialModeLeads_TrialUserMessageLogInput>;
  trialUserNotification?: InputMaybe<Wf_TrialModeLeads_TrialUserNotificationInput>;
  trialUserSegmentationLog?: InputMaybe<Wf_TrialModeLeads_TrialUserSegmentationLogInput>;
};

export type Wf_TrialModeLeads_Mutation_AddRange = {
  __typename?: 'WF_TrialModeLeads_Mutation_AddRange';
  allParentTips?: Maybe<Array<Wf_TrialModeLeads_AllParentTip>>;
  appAnnouncementBarMarkets?: Maybe<Array<Wf_TrialModeLeads_AppAnnouncementBarMarket>>;
  appAnnouncementBars?: Maybe<Array<Wf_TrialModeLeads_AppAnnouncementBar>>;
  autoMails?: Maybe<Array<Wf_TrialModeLeads_AutoMail>>;
  callToActionContents?: Maybe<Array<Wf_TrialModeLeads_CallToActionContent>>;
  callToActionExperienceTypes?: Maybe<Array<Wf_TrialModeLeads_CallToActionExperienceType>>;
  callToActions?: Maybe<Array<Wf_TrialModeLeads_CallToAction>>;
  designImages?: Maybe<Array<Wf_TrialModeLeads_DesignImage>>;
  featuredEvents?: Maybe<Array<Wf_TrialModeLeads_FeaturedEvent>>;
  graphqlAccesses?: Maybe<Array<Wf_TrialModeLeads_GraphqlAccess>>;
  graphqlSchemas?: Maybe<Array<Wf_TrialModeLeads_GraphqlSchema>>;
  installationLogs?: Maybe<Array<Wf_TrialModeLeads_InstallationLog>>;
  installations?: Maybe<Array<Wf_TrialModeLeads_Installation>>;
  journeyCards?: Maybe<Array<Wf_TrialModeLeads_JourneyCard>>;
  journeyExperienceTypes?: Maybe<Array<Wf_TrialModeLeads_JourneyExperienceType>>;
  notificationChildren?: Maybe<Array<Wf_TrialModeLeads_NotificationChild>>;
  notificationMembers?: Maybe<Array<Wf_TrialModeLeads_NotificationMember>>;
  notificationToChildAges?: Maybe<Array<Wf_TrialModeLeads_NotificationToChildAge>>;
  notificationToSegmentations?: Maybe<Array<Wf_TrialModeLeads_NotificationToSegmentation>>;
  notificationTypes?: Maybe<Array<Wf_TrialModeLeads_NotificationType>>;
  notifications?: Maybe<Array<Wf_TrialModeLeads_Notification>>;
  parentTips?: Maybe<Array<Wf_TrialModeLeads_ParentTip>>;
  productCategories?: Maybe<Array<Wf_TrialModeLeads_ProductCategory>>;
  productSongAndMarkets?: Maybe<Array<Wf_TrialModeLeads_ProductSongAndMarket>>;
  productSongs?: Maybe<Array<Wf_TrialModeLeads_ProductSong>>;
  productVideoAndMarkets?: Maybe<Array<Wf_TrialModeLeads_ProductVideoAndMarket>>;
  productVideos?: Maybe<Array<Wf_TrialModeLeads_ProductVideo>>;
  regularEvents?: Maybe<Array<Wf_TrialModeLeads_RegularEvent>>;
  tacoTests?: Maybe<Array<Wf_TrialModeLeads_TacoTest>>;
  tempProductVideos?: Maybe<Array<Wf_TrialModeLeads_TempProductVideo>>;
  testimonialTagMappings?: Maybe<Array<Wf_TrialModeLeads_TestimonialTagMapping>>;
  testimonialTags?: Maybe<Array<Wf_TrialModeLeads_TestimonialTag>>;
  testimonials?: Maybe<Array<Wf_TrialModeLeads_Testimonial>>;
  tips?: Maybe<Array<Wf_TrialModeLeads_Tip>>;
  trialCampaignUrls?: Maybe<Array<Wf_TrialModeLeads_TrialCampaignUrl>>;
  trialMailLogs?: Maybe<Array<Wf_TrialModeLeads_TrialMailLog>>;
  trialMailSettings?: Maybe<Array<Wf_TrialModeLeads_TrialMailSetting>>;
  trialMessageSettings?: Maybe<Array<Wf_TrialModeLeads_TrialMessageSetting>>;
  trialOneTimeTokens?: Maybe<Array<Wf_TrialModeLeads_TrialOneTimeToken>>;
  trialPushTypes?: Maybe<Array<Wf_TrialModeLeads_TrialPushType>>;
  trialSegmentations?: Maybe<Array<Wf_TrialModeLeads_TrialSegmentation>>;
  trialSettings?: Maybe<Array<Wf_TrialModeLeads_TrialSetting>>;
  trialTestPhones?: Maybe<Array<Wf_TrialModeLeads_TrialTestPhone>>;
  trialTokens?: Maybe<Array<Wf_TrialModeLeads_TrialToken>>;
  trialTrackingLogs?: Maybe<Array<Wf_TrialModeLeads_TrialTrackingLog>>;
  trialUserMessageLogs?: Maybe<Array<Wf_TrialModeLeads_TrialUserMessageLog>>;
  trialUserNotifications?: Maybe<Array<Wf_TrialModeLeads_TrialUserNotification>>;
  trialUserSegmentationLogs?: Maybe<Array<Wf_TrialModeLeads_TrialUserSegmentationLog>>;
  trialUsers?: Maybe<Array<Wf_TrialModeLeads_TrialUser>>;
};

export type Wf_TrialModeLeads_Mutation_AddRangeInput = {
  allParentTips?: InputMaybe<Array<Wf_TrialModeLeads_AllParentTipInput>>;
  appAnnouncementBarMarkets?: InputMaybe<Array<Wf_TrialModeLeads_AppAnnouncementBarMarketInput>>;
  appAnnouncementBars?: InputMaybe<Array<Wf_TrialModeLeads_AppAnnouncementBarInput>>;
  autoMails?: InputMaybe<Array<Wf_TrialModeLeads_AutoMailInput>>;
  callToActionContents?: InputMaybe<Array<Wf_TrialModeLeads_CallToActionContentInput>>;
  callToActionExperienceTypes?: InputMaybe<Array<Wf_TrialModeLeads_CallToActionExperienceTypeInput>>;
  callToActions?: InputMaybe<Array<Wf_TrialModeLeads_CallToActionInput>>;
  designImages?: InputMaybe<Array<Wf_TrialModeLeads_DesignImageInput>>;
  featuredEvents?: InputMaybe<Array<Wf_TrialModeLeads_FeaturedEventInput>>;
  graphqlAccesses?: InputMaybe<Array<Wf_TrialModeLeads_GraphqlAccessInput>>;
  graphqlSchemas?: InputMaybe<Array<Wf_TrialModeLeads_GraphqlSchemaInput>>;
  installationLogs?: InputMaybe<Array<Wf_TrialModeLeads_InstallationLogInput>>;
  installations?: InputMaybe<Array<Wf_TrialModeLeads_InstallationInput>>;
  journeyCards?: InputMaybe<Array<Wf_TrialModeLeads_JourneyCardInput>>;
  journeyExperienceTypes?: InputMaybe<Array<Wf_TrialModeLeads_JourneyExperienceTypeInput>>;
  notificationChildren?: InputMaybe<Array<Wf_TrialModeLeads_NotificationChildInput>>;
  notificationMembers?: InputMaybe<Array<Wf_TrialModeLeads_NotificationMemberInput>>;
  notificationToChildAges?: InputMaybe<Array<Wf_TrialModeLeads_NotificationToChildAgeInput>>;
  notificationToSegmentations?: InputMaybe<Array<Wf_TrialModeLeads_NotificationToSegmentationInput>>;
  notificationTypes?: InputMaybe<Array<Wf_TrialModeLeads_NotificationTypeInput>>;
  notifications?: InputMaybe<Array<Wf_TrialModeLeads_NotificationInput>>;
  parentTips?: InputMaybe<Array<Wf_TrialModeLeads_ParentTipInput>>;
  productCategories?: InputMaybe<Array<Wf_TrialModeLeads_ProductCategoryInput>>;
  productSongAndMarkets?: InputMaybe<Array<Wf_TrialModeLeads_ProductSongAndMarketInput>>;
  productSongs?: InputMaybe<Array<Wf_TrialModeLeads_ProductSongInput>>;
  productVideoAndMarkets?: InputMaybe<Array<Wf_TrialModeLeads_ProductVideoAndMarketInput>>;
  productVideos?: InputMaybe<Array<Wf_TrialModeLeads_ProductVideoInput>>;
  regularEvents?: InputMaybe<Array<Wf_TrialModeLeads_RegularEventInput>>;
  tacoTests?: InputMaybe<Array<Wf_TrialModeLeads_TacoTestInput>>;
  tempProductVideos?: InputMaybe<Array<Wf_TrialModeLeads_TempProductVideoInput>>;
  testimonialTagMappings?: InputMaybe<Array<Wf_TrialModeLeads_TestimonialTagMappingInput>>;
  testimonialTags?: InputMaybe<Array<Wf_TrialModeLeads_TestimonialTagInput>>;
  testimonials?: InputMaybe<Array<Wf_TrialModeLeads_TestimonialInput>>;
  tips?: InputMaybe<Array<Wf_TrialModeLeads_TipInput>>;
  trialCampaignUrls?: InputMaybe<Array<Wf_TrialModeLeads_TrialCampaignUrlInput>>;
  trialMailLogs?: InputMaybe<Array<Wf_TrialModeLeads_TrialMailLogInput>>;
  trialMailSettings?: InputMaybe<Array<Wf_TrialModeLeads_TrialMailSettingInput>>;
  trialMessageSettings?: InputMaybe<Array<Wf_TrialModeLeads_TrialMessageSettingInput>>;
  trialOneTimeTokens?: InputMaybe<Array<Wf_TrialModeLeads_TrialOneTimeTokenInput>>;
  trialPushTypes?: InputMaybe<Array<Wf_TrialModeLeads_TrialPushTypeInput>>;
  trialSegmentations?: InputMaybe<Array<Wf_TrialModeLeads_TrialSegmentationInput>>;
  trialSettings?: InputMaybe<Array<Wf_TrialModeLeads_TrialSettingInput>>;
  trialTestPhones?: InputMaybe<Array<Wf_TrialModeLeads_TrialTestPhoneInput>>;
  trialTokens?: InputMaybe<Array<Wf_TrialModeLeads_TrialTokenInput>>;
  trialTrackingLogs?: InputMaybe<Array<Wf_TrialModeLeads_TrialTrackingLogInput>>;
  trialUserMessageLogs?: InputMaybe<Array<Wf_TrialModeLeads_TrialUserMessageLogInput>>;
  trialUserNotifications?: InputMaybe<Array<Wf_TrialModeLeads_TrialUserNotificationInput>>;
  trialUserSegmentationLogs?: InputMaybe<Array<Wf_TrialModeLeads_TrialUserSegmentationLogInput>>;
  trialUsers?: InputMaybe<Array<Wf_TrialModeLeads_TrialUserInput>>;
};

export type Wf_TrialModeLeads_Mutation_Payload = {
  __typename?: 'WF_TrialModeLeads_Mutation_Payload';
  addContext?: Maybe<Wf_TrialModeLeads_Mutation_Add>;
  addRangeContext?: Maybe<Wf_TrialModeLeads_Mutation_AddRange>;
  count: Scalars['Int']['output'];
  query: Query;
  updateContext?: Maybe<Wf_TrialModeLeads_Mutation_Update>;
  updateRangeContext?: Maybe<Wf_TrialModeLeads_Mutation_UpdateRange>;
};

export type Wf_TrialModeLeads_Mutation_RemoveInput = {
  allParentTip?: InputMaybe<Wf_TrialModeLeads_AllParentTipInput>;
  appAnnouncementBar?: InputMaybe<Wf_TrialModeLeads_AppAnnouncementBarInput>;
  appAnnouncementBarMarket?: InputMaybe<Wf_TrialModeLeads_AppAnnouncementBarMarketInput>;
  autoMail?: InputMaybe<Wf_TrialModeLeads_AutoMailInput>;
  callToAction?: InputMaybe<Wf_TrialModeLeads_CallToActionInput>;
  callToActionContent?: InputMaybe<Wf_TrialModeLeads_CallToActionContentInput>;
  callToActionExperienceType?: InputMaybe<Wf_TrialModeLeads_CallToActionExperienceTypeInput>;
  designImage?: InputMaybe<Wf_TrialModeLeads_DesignImageInput>;
  featuredEvent?: InputMaybe<Wf_TrialModeLeads_FeaturedEventInput>;
  graphqlAccess?: InputMaybe<Wf_TrialModeLeads_GraphqlAccessInput>;
  graphqlSchema?: InputMaybe<Wf_TrialModeLeads_GraphqlSchemaInput>;
  installation?: InputMaybe<Wf_TrialModeLeads_InstallationInput>;
  installationLog?: InputMaybe<Wf_TrialModeLeads_InstallationLogInput>;
  journeyCard?: InputMaybe<Wf_TrialModeLeads_JourneyCardInput>;
  journeyExperienceType?: InputMaybe<Wf_TrialModeLeads_JourneyExperienceTypeInput>;
  notification?: InputMaybe<Wf_TrialModeLeads_NotificationInput>;
  notificationChild?: InputMaybe<Wf_TrialModeLeads_NotificationChildInput>;
  notificationMember?: InputMaybe<Wf_TrialModeLeads_NotificationMemberInput>;
  notificationToChildAge?: InputMaybe<Wf_TrialModeLeads_NotificationToChildAgeInput>;
  notificationToSegmentation?: InputMaybe<Wf_TrialModeLeads_NotificationToSegmentationInput>;
  notificationType?: InputMaybe<Wf_TrialModeLeads_NotificationTypeInput>;
  parentTip?: InputMaybe<Wf_TrialModeLeads_ParentTipInput>;
  productCategory?: InputMaybe<Wf_TrialModeLeads_ProductCategoryInput>;
  productSong?: InputMaybe<Wf_TrialModeLeads_ProductSongInput>;
  productSongAndMarket?: InputMaybe<Wf_TrialModeLeads_ProductSongAndMarketInput>;
  productVideo?: InputMaybe<Wf_TrialModeLeads_ProductVideoInput>;
  productVideoAndMarket?: InputMaybe<Wf_TrialModeLeads_ProductVideoAndMarketInput>;
  regularEvent?: InputMaybe<Wf_TrialModeLeads_RegularEventInput>;
  tacoTest?: InputMaybe<Wf_TrialModeLeads_TacoTestInput>;
  tempProductVideo?: InputMaybe<Wf_TrialModeLeads_TempProductVideoInput>;
  testimonial?: InputMaybe<Wf_TrialModeLeads_TestimonialInput>;
  testimonialTag?: InputMaybe<Wf_TrialModeLeads_TestimonialTagInput>;
  testimonialTagMapping?: InputMaybe<Wf_TrialModeLeads_TestimonialTagMappingInput>;
  tip?: InputMaybe<Wf_TrialModeLeads_TipInput>;
  trialCampaignUrl?: InputMaybe<Wf_TrialModeLeads_TrialCampaignUrlInput>;
  trialMailLog?: InputMaybe<Wf_TrialModeLeads_TrialMailLogInput>;
  trialMailSetting?: InputMaybe<Wf_TrialModeLeads_TrialMailSettingInput>;
  trialMessageSetting?: InputMaybe<Wf_TrialModeLeads_TrialMessageSettingInput>;
  trialOneTimeToken?: InputMaybe<Wf_TrialModeLeads_TrialOneTimeTokenInput>;
  trialPushType?: InputMaybe<Wf_TrialModeLeads_TrialPushTypeInput>;
  trialSegmentation?: InputMaybe<Wf_TrialModeLeads_TrialSegmentationInput>;
  trialSetting?: InputMaybe<Wf_TrialModeLeads_TrialSettingInput>;
  trialTestPhone?: InputMaybe<Wf_TrialModeLeads_TrialTestPhoneInput>;
  trialToken?: InputMaybe<Wf_TrialModeLeads_TrialTokenInput>;
  trialTrackingLog?: InputMaybe<Wf_TrialModeLeads_TrialTrackingLogInput>;
  trialUser?: InputMaybe<Wf_TrialModeLeads_TrialUserInput>;
  trialUserMessageLog?: InputMaybe<Wf_TrialModeLeads_TrialUserMessageLogInput>;
  trialUserNotification?: InputMaybe<Wf_TrialModeLeads_TrialUserNotificationInput>;
  trialUserSegmentationLog?: InputMaybe<Wf_TrialModeLeads_TrialUserSegmentationLogInput>;
};

export type Wf_TrialModeLeads_Mutation_RemoveRangeInput = {
  allParentTips?: InputMaybe<Array<Wf_TrialModeLeads_AllParentTipInput>>;
  appAnnouncementBarMarkets?: InputMaybe<Array<Wf_TrialModeLeads_AppAnnouncementBarMarketInput>>;
  appAnnouncementBars?: InputMaybe<Array<Wf_TrialModeLeads_AppAnnouncementBarInput>>;
  autoMails?: InputMaybe<Array<Wf_TrialModeLeads_AutoMailInput>>;
  callToActionContents?: InputMaybe<Array<Wf_TrialModeLeads_CallToActionContentInput>>;
  callToActionExperienceTypes?: InputMaybe<Array<Wf_TrialModeLeads_CallToActionExperienceTypeInput>>;
  callToActions?: InputMaybe<Array<Wf_TrialModeLeads_CallToActionInput>>;
  designImages?: InputMaybe<Array<Wf_TrialModeLeads_DesignImageInput>>;
  featuredEvents?: InputMaybe<Array<Wf_TrialModeLeads_FeaturedEventInput>>;
  graphqlAccesses?: InputMaybe<Array<Wf_TrialModeLeads_GraphqlAccessInput>>;
  graphqlSchemas?: InputMaybe<Array<Wf_TrialModeLeads_GraphqlSchemaInput>>;
  installationLogs?: InputMaybe<Array<Wf_TrialModeLeads_InstallationLogInput>>;
  installations?: InputMaybe<Array<Wf_TrialModeLeads_InstallationInput>>;
  journeyCards?: InputMaybe<Array<Wf_TrialModeLeads_JourneyCardInput>>;
  journeyExperienceTypes?: InputMaybe<Array<Wf_TrialModeLeads_JourneyExperienceTypeInput>>;
  notificationChildren?: InputMaybe<Array<Wf_TrialModeLeads_NotificationChildInput>>;
  notificationMembers?: InputMaybe<Array<Wf_TrialModeLeads_NotificationMemberInput>>;
  notificationToChildAges?: InputMaybe<Array<Wf_TrialModeLeads_NotificationToChildAgeInput>>;
  notificationToSegmentations?: InputMaybe<Array<Wf_TrialModeLeads_NotificationToSegmentationInput>>;
  notificationTypes?: InputMaybe<Array<Wf_TrialModeLeads_NotificationTypeInput>>;
  notifications?: InputMaybe<Array<Wf_TrialModeLeads_NotificationInput>>;
  parentTips?: InputMaybe<Array<Wf_TrialModeLeads_ParentTipInput>>;
  productCategories?: InputMaybe<Array<Wf_TrialModeLeads_ProductCategoryInput>>;
  productSongAndMarkets?: InputMaybe<Array<Wf_TrialModeLeads_ProductSongAndMarketInput>>;
  productSongs?: InputMaybe<Array<Wf_TrialModeLeads_ProductSongInput>>;
  productVideoAndMarkets?: InputMaybe<Array<Wf_TrialModeLeads_ProductVideoAndMarketInput>>;
  productVideos?: InputMaybe<Array<Wf_TrialModeLeads_ProductVideoInput>>;
  regularEvents?: InputMaybe<Array<Wf_TrialModeLeads_RegularEventInput>>;
  tacoTests?: InputMaybe<Array<Wf_TrialModeLeads_TacoTestInput>>;
  tempProductVideos?: InputMaybe<Array<Wf_TrialModeLeads_TempProductVideoInput>>;
  testimonialTagMappings?: InputMaybe<Array<Wf_TrialModeLeads_TestimonialTagMappingInput>>;
  testimonialTags?: InputMaybe<Array<Wf_TrialModeLeads_TestimonialTagInput>>;
  testimonials?: InputMaybe<Array<Wf_TrialModeLeads_TestimonialInput>>;
  tips?: InputMaybe<Array<Wf_TrialModeLeads_TipInput>>;
  trialCampaignUrls?: InputMaybe<Array<Wf_TrialModeLeads_TrialCampaignUrlInput>>;
  trialMailLogs?: InputMaybe<Array<Wf_TrialModeLeads_TrialMailLogInput>>;
  trialMailSettings?: InputMaybe<Array<Wf_TrialModeLeads_TrialMailSettingInput>>;
  trialMessageSettings?: InputMaybe<Array<Wf_TrialModeLeads_TrialMessageSettingInput>>;
  trialOneTimeTokens?: InputMaybe<Array<Wf_TrialModeLeads_TrialOneTimeTokenInput>>;
  trialPushTypes?: InputMaybe<Array<Wf_TrialModeLeads_TrialPushTypeInput>>;
  trialSegmentations?: InputMaybe<Array<Wf_TrialModeLeads_TrialSegmentationInput>>;
  trialSettings?: InputMaybe<Array<Wf_TrialModeLeads_TrialSettingInput>>;
  trialTestPhones?: InputMaybe<Array<Wf_TrialModeLeads_TrialTestPhoneInput>>;
  trialTokens?: InputMaybe<Array<Wf_TrialModeLeads_TrialTokenInput>>;
  trialTrackingLogs?: InputMaybe<Array<Wf_TrialModeLeads_TrialTrackingLogInput>>;
  trialUserMessageLogs?: InputMaybe<Array<Wf_TrialModeLeads_TrialUserMessageLogInput>>;
  trialUserNotifications?: InputMaybe<Array<Wf_TrialModeLeads_TrialUserNotificationInput>>;
  trialUserSegmentationLogs?: InputMaybe<Array<Wf_TrialModeLeads_TrialUserSegmentationLogInput>>;
  trialUsers?: InputMaybe<Array<Wf_TrialModeLeads_TrialUserInput>>;
};

export type Wf_TrialModeLeads_Mutation_Update = {
  __typename?: 'WF_TrialModeLeads_Mutation_Update';
  allParentTip?: Maybe<Wf_TrialModeLeads_AllParentTip>;
  appAnnouncementBar?: Maybe<Wf_TrialModeLeads_AppAnnouncementBar>;
  appAnnouncementBarMarket?: Maybe<Wf_TrialModeLeads_AppAnnouncementBarMarket>;
  autoMail?: Maybe<Wf_TrialModeLeads_AutoMail>;
  callToAction?: Maybe<Wf_TrialModeLeads_CallToAction>;
  callToActionContent?: Maybe<Wf_TrialModeLeads_CallToActionContent>;
  callToActionExperienceType?: Maybe<Wf_TrialModeLeads_CallToActionExperienceType>;
  designImage?: Maybe<Wf_TrialModeLeads_DesignImage>;
  featuredEvent?: Maybe<Wf_TrialModeLeads_FeaturedEvent>;
  graphqlAccess?: Maybe<Wf_TrialModeLeads_GraphqlAccess>;
  graphqlSchema?: Maybe<Wf_TrialModeLeads_GraphqlSchema>;
  installation?: Maybe<Wf_TrialModeLeads_Installation>;
  installationLog?: Maybe<Wf_TrialModeLeads_InstallationLog>;
  journeyCard?: Maybe<Wf_TrialModeLeads_JourneyCard>;
  journeyExperienceType?: Maybe<Wf_TrialModeLeads_JourneyExperienceType>;
  notification?: Maybe<Wf_TrialModeLeads_Notification>;
  notificationChild?: Maybe<Wf_TrialModeLeads_NotificationChild>;
  notificationMember?: Maybe<Wf_TrialModeLeads_NotificationMember>;
  notificationToChildAge?: Maybe<Wf_TrialModeLeads_NotificationToChildAge>;
  notificationToSegmentation?: Maybe<Wf_TrialModeLeads_NotificationToSegmentation>;
  notificationType?: Maybe<Wf_TrialModeLeads_NotificationType>;
  parentTip?: Maybe<Wf_TrialModeLeads_ParentTip>;
  productCategory?: Maybe<Wf_TrialModeLeads_ProductCategory>;
  productSong?: Maybe<Wf_TrialModeLeads_ProductSong>;
  productSongAndMarket?: Maybe<Wf_TrialModeLeads_ProductSongAndMarket>;
  productVideo?: Maybe<Wf_TrialModeLeads_ProductVideo>;
  productVideoAndMarket?: Maybe<Wf_TrialModeLeads_ProductVideoAndMarket>;
  regularEvent?: Maybe<Wf_TrialModeLeads_RegularEvent>;
  tacoTest?: Maybe<Wf_TrialModeLeads_TacoTest>;
  tempProductVideo?: Maybe<Wf_TrialModeLeads_TempProductVideo>;
  testimonial?: Maybe<Wf_TrialModeLeads_Testimonial>;
  testimonialTag?: Maybe<Wf_TrialModeLeads_TestimonialTag>;
  testimonialTagMapping?: Maybe<Wf_TrialModeLeads_TestimonialTagMapping>;
  tip?: Maybe<Wf_TrialModeLeads_Tip>;
  trialCampaignUrl?: Maybe<Wf_TrialModeLeads_TrialCampaignUrl>;
  trialMailLog?: Maybe<Wf_TrialModeLeads_TrialMailLog>;
  trialMailSetting?: Maybe<Wf_TrialModeLeads_TrialMailSetting>;
  trialMessageSetting?: Maybe<Wf_TrialModeLeads_TrialMessageSetting>;
  trialOneTimeToken?: Maybe<Wf_TrialModeLeads_TrialOneTimeToken>;
  trialPushType?: Maybe<Wf_TrialModeLeads_TrialPushType>;
  trialSegmentation?: Maybe<Wf_TrialModeLeads_TrialSegmentation>;
  trialSetting?: Maybe<Wf_TrialModeLeads_TrialSetting>;
  trialTestPhone?: Maybe<Wf_TrialModeLeads_TrialTestPhone>;
  trialToken?: Maybe<Wf_TrialModeLeads_TrialToken>;
  trialTrackingLog?: Maybe<Wf_TrialModeLeads_TrialTrackingLog>;
  trialUser?: Maybe<Wf_TrialModeLeads_TrialUser>;
  trialUserMessageLog?: Maybe<Wf_TrialModeLeads_TrialUserMessageLog>;
  trialUserNotification?: Maybe<Wf_TrialModeLeads_TrialUserNotification>;
  trialUserSegmentationLog?: Maybe<Wf_TrialModeLeads_TrialUserSegmentationLog>;
};

export type Wf_TrialModeLeads_Mutation_UpdateInput = {
  allParentTip?: InputMaybe<Wf_TrialModeLeads_AllParentTipInput>;
  appAnnouncementBar?: InputMaybe<Wf_TrialModeLeads_AppAnnouncementBarInput>;
  appAnnouncementBarMarket?: InputMaybe<Wf_TrialModeLeads_AppAnnouncementBarMarketInput>;
  autoMail?: InputMaybe<Wf_TrialModeLeads_AutoMailInput>;
  callToAction?: InputMaybe<Wf_TrialModeLeads_CallToActionInput>;
  callToActionContent?: InputMaybe<Wf_TrialModeLeads_CallToActionContentInput>;
  callToActionExperienceType?: InputMaybe<Wf_TrialModeLeads_CallToActionExperienceTypeInput>;
  designImage?: InputMaybe<Wf_TrialModeLeads_DesignImageInput>;
  featuredEvent?: InputMaybe<Wf_TrialModeLeads_FeaturedEventInput>;
  graphqlAccess?: InputMaybe<Wf_TrialModeLeads_GraphqlAccessInput>;
  graphqlSchema?: InputMaybe<Wf_TrialModeLeads_GraphqlSchemaInput>;
  installation?: InputMaybe<Wf_TrialModeLeads_InstallationInput>;
  installationLog?: InputMaybe<Wf_TrialModeLeads_InstallationLogInput>;
  journeyCard?: InputMaybe<Wf_TrialModeLeads_JourneyCardInput>;
  journeyExperienceType?: InputMaybe<Wf_TrialModeLeads_JourneyExperienceTypeInput>;
  notification?: InputMaybe<Wf_TrialModeLeads_NotificationInput>;
  notificationChild?: InputMaybe<Wf_TrialModeLeads_NotificationChildInput>;
  notificationMember?: InputMaybe<Wf_TrialModeLeads_NotificationMemberInput>;
  notificationToChildAge?: InputMaybe<Wf_TrialModeLeads_NotificationToChildAgeInput>;
  notificationToSegmentation?: InputMaybe<Wf_TrialModeLeads_NotificationToSegmentationInput>;
  notificationType?: InputMaybe<Wf_TrialModeLeads_NotificationTypeInput>;
  parentTip?: InputMaybe<Wf_TrialModeLeads_ParentTipInput>;
  productCategory?: InputMaybe<Wf_TrialModeLeads_ProductCategoryInput>;
  productSong?: InputMaybe<Wf_TrialModeLeads_ProductSongInput>;
  productSongAndMarket?: InputMaybe<Wf_TrialModeLeads_ProductSongAndMarketInput>;
  productVideo?: InputMaybe<Wf_TrialModeLeads_ProductVideoInput>;
  productVideoAndMarket?: InputMaybe<Wf_TrialModeLeads_ProductVideoAndMarketInput>;
  regularEvent?: InputMaybe<Wf_TrialModeLeads_RegularEventInput>;
  tacoTest?: InputMaybe<Wf_TrialModeLeads_TacoTestInput>;
  tempProductVideo?: InputMaybe<Wf_TrialModeLeads_TempProductVideoInput>;
  testimonial?: InputMaybe<Wf_TrialModeLeads_TestimonialInput>;
  testimonialTag?: InputMaybe<Wf_TrialModeLeads_TestimonialTagInput>;
  testimonialTagMapping?: InputMaybe<Wf_TrialModeLeads_TestimonialTagMappingInput>;
  tip?: InputMaybe<Wf_TrialModeLeads_TipInput>;
  trialCampaignUrl?: InputMaybe<Wf_TrialModeLeads_TrialCampaignUrlInput>;
  trialMailLog?: InputMaybe<Wf_TrialModeLeads_TrialMailLogInput>;
  trialMailSetting?: InputMaybe<Wf_TrialModeLeads_TrialMailSettingInput>;
  trialMessageSetting?: InputMaybe<Wf_TrialModeLeads_TrialMessageSettingInput>;
  trialOneTimeToken?: InputMaybe<Wf_TrialModeLeads_TrialOneTimeTokenInput>;
  trialPushType?: InputMaybe<Wf_TrialModeLeads_TrialPushTypeInput>;
  trialSegmentation?: InputMaybe<Wf_TrialModeLeads_TrialSegmentationInput>;
  trialSetting?: InputMaybe<Wf_TrialModeLeads_TrialSettingInput>;
  trialTestPhone?: InputMaybe<Wf_TrialModeLeads_TrialTestPhoneInput>;
  trialToken?: InputMaybe<Wf_TrialModeLeads_TrialTokenInput>;
  trialTrackingLog?: InputMaybe<Wf_TrialModeLeads_TrialTrackingLogInput>;
  trialUser?: InputMaybe<Wf_TrialModeLeads_TrialUserInput>;
  trialUserMessageLog?: InputMaybe<Wf_TrialModeLeads_TrialUserMessageLogInput>;
  trialUserNotification?: InputMaybe<Wf_TrialModeLeads_TrialUserNotificationInput>;
  trialUserSegmentationLog?: InputMaybe<Wf_TrialModeLeads_TrialUserSegmentationLogInput>;
};

export type Wf_TrialModeLeads_Mutation_UpdateRange = {
  __typename?: 'WF_TrialModeLeads_Mutation_UpdateRange';
  allParentTips?: Maybe<Array<Wf_TrialModeLeads_AllParentTip>>;
  appAnnouncementBarMarkets?: Maybe<Array<Wf_TrialModeLeads_AppAnnouncementBarMarket>>;
  appAnnouncementBars?: Maybe<Array<Wf_TrialModeLeads_AppAnnouncementBar>>;
  autoMails?: Maybe<Array<Wf_TrialModeLeads_AutoMail>>;
  callToActionContents?: Maybe<Array<Wf_TrialModeLeads_CallToActionContent>>;
  callToActionExperienceTypes?: Maybe<Array<Wf_TrialModeLeads_CallToActionExperienceType>>;
  callToActions?: Maybe<Array<Wf_TrialModeLeads_CallToAction>>;
  designImages?: Maybe<Array<Wf_TrialModeLeads_DesignImage>>;
  featuredEvents?: Maybe<Array<Wf_TrialModeLeads_FeaturedEvent>>;
  graphqlAccesses?: Maybe<Array<Wf_TrialModeLeads_GraphqlAccess>>;
  graphqlSchemas?: Maybe<Array<Wf_TrialModeLeads_GraphqlSchema>>;
  installationLogs?: Maybe<Array<Wf_TrialModeLeads_InstallationLog>>;
  installations?: Maybe<Array<Wf_TrialModeLeads_Installation>>;
  journeyCards?: Maybe<Array<Wf_TrialModeLeads_JourneyCard>>;
  journeyExperienceTypes?: Maybe<Array<Wf_TrialModeLeads_JourneyExperienceType>>;
  notificationChildren?: Maybe<Array<Wf_TrialModeLeads_NotificationChild>>;
  notificationMembers?: Maybe<Array<Wf_TrialModeLeads_NotificationMember>>;
  notificationToChildAges?: Maybe<Array<Wf_TrialModeLeads_NotificationToChildAge>>;
  notificationToSegmentations?: Maybe<Array<Wf_TrialModeLeads_NotificationToSegmentation>>;
  notificationTypes?: Maybe<Array<Wf_TrialModeLeads_NotificationType>>;
  notifications?: Maybe<Array<Wf_TrialModeLeads_Notification>>;
  parentTips?: Maybe<Array<Wf_TrialModeLeads_ParentTip>>;
  productCategories?: Maybe<Array<Wf_TrialModeLeads_ProductCategory>>;
  productSongAndMarkets?: Maybe<Array<Wf_TrialModeLeads_ProductSongAndMarket>>;
  productSongs?: Maybe<Array<Wf_TrialModeLeads_ProductSong>>;
  productVideoAndMarkets?: Maybe<Array<Wf_TrialModeLeads_ProductVideoAndMarket>>;
  productVideos?: Maybe<Array<Wf_TrialModeLeads_ProductVideo>>;
  regularEvents?: Maybe<Array<Wf_TrialModeLeads_RegularEvent>>;
  tacoTests?: Maybe<Array<Wf_TrialModeLeads_TacoTest>>;
  tempProductVideos?: Maybe<Array<Wf_TrialModeLeads_TempProductVideo>>;
  testimonialTagMappings?: Maybe<Array<Wf_TrialModeLeads_TestimonialTagMapping>>;
  testimonialTags?: Maybe<Array<Wf_TrialModeLeads_TestimonialTag>>;
  testimonials?: Maybe<Array<Wf_TrialModeLeads_Testimonial>>;
  tips?: Maybe<Array<Wf_TrialModeLeads_Tip>>;
  trialCampaignUrls?: Maybe<Array<Wf_TrialModeLeads_TrialCampaignUrl>>;
  trialMailLogs?: Maybe<Array<Wf_TrialModeLeads_TrialMailLog>>;
  trialMailSettings?: Maybe<Array<Wf_TrialModeLeads_TrialMailSetting>>;
  trialMessageSettings?: Maybe<Array<Wf_TrialModeLeads_TrialMessageSetting>>;
  trialOneTimeTokens?: Maybe<Array<Wf_TrialModeLeads_TrialOneTimeToken>>;
  trialPushTypes?: Maybe<Array<Wf_TrialModeLeads_TrialPushType>>;
  trialSegmentations?: Maybe<Array<Wf_TrialModeLeads_TrialSegmentation>>;
  trialSettings?: Maybe<Array<Wf_TrialModeLeads_TrialSetting>>;
  trialTestPhones?: Maybe<Array<Wf_TrialModeLeads_TrialTestPhone>>;
  trialTokens?: Maybe<Array<Wf_TrialModeLeads_TrialToken>>;
  trialTrackingLogs?: Maybe<Array<Wf_TrialModeLeads_TrialTrackingLog>>;
  trialUserMessageLogs?: Maybe<Array<Wf_TrialModeLeads_TrialUserMessageLog>>;
  trialUserNotifications?: Maybe<Array<Wf_TrialModeLeads_TrialUserNotification>>;
  trialUserSegmentationLogs?: Maybe<Array<Wf_TrialModeLeads_TrialUserSegmentationLog>>;
  trialUsers?: Maybe<Array<Wf_TrialModeLeads_TrialUser>>;
};

export type Wf_TrialModeLeads_Mutation_UpdateRangeInput = {
  allParentTips?: InputMaybe<Array<Wf_TrialModeLeads_AllParentTipInput>>;
  appAnnouncementBarMarkets?: InputMaybe<Array<Wf_TrialModeLeads_AppAnnouncementBarMarketInput>>;
  appAnnouncementBars?: InputMaybe<Array<Wf_TrialModeLeads_AppAnnouncementBarInput>>;
  autoMails?: InputMaybe<Array<Wf_TrialModeLeads_AutoMailInput>>;
  callToActionContents?: InputMaybe<Array<Wf_TrialModeLeads_CallToActionContentInput>>;
  callToActionExperienceTypes?: InputMaybe<Array<Wf_TrialModeLeads_CallToActionExperienceTypeInput>>;
  callToActions?: InputMaybe<Array<Wf_TrialModeLeads_CallToActionInput>>;
  designImages?: InputMaybe<Array<Wf_TrialModeLeads_DesignImageInput>>;
  featuredEvents?: InputMaybe<Array<Wf_TrialModeLeads_FeaturedEventInput>>;
  graphqlAccesses?: InputMaybe<Array<Wf_TrialModeLeads_GraphqlAccessInput>>;
  graphqlSchemas?: InputMaybe<Array<Wf_TrialModeLeads_GraphqlSchemaInput>>;
  installationLogs?: InputMaybe<Array<Wf_TrialModeLeads_InstallationLogInput>>;
  installations?: InputMaybe<Array<Wf_TrialModeLeads_InstallationInput>>;
  journeyCards?: InputMaybe<Array<Wf_TrialModeLeads_JourneyCardInput>>;
  journeyExperienceTypes?: InputMaybe<Array<Wf_TrialModeLeads_JourneyExperienceTypeInput>>;
  notificationChildren?: InputMaybe<Array<Wf_TrialModeLeads_NotificationChildInput>>;
  notificationMembers?: InputMaybe<Array<Wf_TrialModeLeads_NotificationMemberInput>>;
  notificationToChildAges?: InputMaybe<Array<Wf_TrialModeLeads_NotificationToChildAgeInput>>;
  notificationToSegmentations?: InputMaybe<Array<Wf_TrialModeLeads_NotificationToSegmentationInput>>;
  notificationTypes?: InputMaybe<Array<Wf_TrialModeLeads_NotificationTypeInput>>;
  notifications?: InputMaybe<Array<Wf_TrialModeLeads_NotificationInput>>;
  parentTips?: InputMaybe<Array<Wf_TrialModeLeads_ParentTipInput>>;
  productCategories?: InputMaybe<Array<Wf_TrialModeLeads_ProductCategoryInput>>;
  productSongAndMarkets?: InputMaybe<Array<Wf_TrialModeLeads_ProductSongAndMarketInput>>;
  productSongs?: InputMaybe<Array<Wf_TrialModeLeads_ProductSongInput>>;
  productVideoAndMarkets?: InputMaybe<Array<Wf_TrialModeLeads_ProductVideoAndMarketInput>>;
  productVideos?: InputMaybe<Array<Wf_TrialModeLeads_ProductVideoInput>>;
  regularEvents?: InputMaybe<Array<Wf_TrialModeLeads_RegularEventInput>>;
  tacoTests?: InputMaybe<Array<Wf_TrialModeLeads_TacoTestInput>>;
  tempProductVideos?: InputMaybe<Array<Wf_TrialModeLeads_TempProductVideoInput>>;
  testimonialTagMappings?: InputMaybe<Array<Wf_TrialModeLeads_TestimonialTagMappingInput>>;
  testimonialTags?: InputMaybe<Array<Wf_TrialModeLeads_TestimonialTagInput>>;
  testimonials?: InputMaybe<Array<Wf_TrialModeLeads_TestimonialInput>>;
  tips?: InputMaybe<Array<Wf_TrialModeLeads_TipInput>>;
  trialCampaignUrls?: InputMaybe<Array<Wf_TrialModeLeads_TrialCampaignUrlInput>>;
  trialMailLogs?: InputMaybe<Array<Wf_TrialModeLeads_TrialMailLogInput>>;
  trialMailSettings?: InputMaybe<Array<Wf_TrialModeLeads_TrialMailSettingInput>>;
  trialMessageSettings?: InputMaybe<Array<Wf_TrialModeLeads_TrialMessageSettingInput>>;
  trialOneTimeTokens?: InputMaybe<Array<Wf_TrialModeLeads_TrialOneTimeTokenInput>>;
  trialPushTypes?: InputMaybe<Array<Wf_TrialModeLeads_TrialPushTypeInput>>;
  trialSegmentations?: InputMaybe<Array<Wf_TrialModeLeads_TrialSegmentationInput>>;
  trialSettings?: InputMaybe<Array<Wf_TrialModeLeads_TrialSettingInput>>;
  trialTestPhones?: InputMaybe<Array<Wf_TrialModeLeads_TrialTestPhoneInput>>;
  trialTokens?: InputMaybe<Array<Wf_TrialModeLeads_TrialTokenInput>>;
  trialTrackingLogs?: InputMaybe<Array<Wf_TrialModeLeads_TrialTrackingLogInput>>;
  trialUserMessageLogs?: InputMaybe<Array<Wf_TrialModeLeads_TrialUserMessageLogInput>>;
  trialUserNotifications?: InputMaybe<Array<Wf_TrialModeLeads_TrialUserNotificationInput>>;
  trialUserSegmentationLogs?: InputMaybe<Array<Wf_TrialModeLeads_TrialUserSegmentationLogInput>>;
  trialUsers?: InputMaybe<Array<Wf_TrialModeLeads_TrialUserInput>>;
};

/** Notification */
export type Wf_TrialModeLeads_Notification = Node & {
  __typename?: 'WF_TrialModeLeads_Notification';
  /** ActionButton */
  actionButton?: Maybe<Scalars['String']['output']>;
  /** ButtonLinksTo */
  buttonLinksTo?: Maybe<Scalars['String']['output']>;
  /** ButtonText */
  buttonText?: Maybe<Scalars['String']['output']>;
  /** CreatedTime */
  createdTime?: Maybe<Scalars['DateTime']['output']>;
  /** Creator */
  creator?: Maybe<Scalars['String']['output']>;
  /** Error */
  error?: Maybe<Scalars['String']['output']>;
  /** [ID] NotificationId */
  id: Scalars['ID']['output'];
  /** ImageFileName */
  imageFileName?: Maybe<Scalars['String']['output']>;
  /** JobStatus */
  jobStatus?: Maybe<Scalars['String']['output']>;
  /** Market */
  market?: Maybe<Scalars['String']['output']>;
  /** MutationOperation */
  mutationOperation?: Maybe<Scalars['String']['output']>;
  /** [COLLECTION] NotificationToChildAges */
  notificationToChildAges?: Maybe<Array<Maybe<Wf_TrialModeLeads_NotificationToChildAge>>>;
  /** [COLLECTION] NotificationToSegmentations */
  notificationToSegmentations?: Maybe<Array<Maybe<Wf_TrialModeLeads_NotificationToSegmentation>>>;
  /** [NAVIGATION] NotificationType */
  notificationType?: Maybe<Wf_TrialModeLeads_NotificationType>;
  /** [NOT NULL] NotificationTypeId */
  notificationTypeId?: Maybe<Scalars['String']['output']>;
  /** RemoveNotificationId */
  removeNotificationId?: Maybe<Scalars['Int']['output']>;
  /** ScheduleTime */
  scheduleTime?: Maybe<Scalars['DateTime']['output']>;
  /** Segmentation */
  segmentation?: Maybe<Scalars['String']['output']>;
  /** TemplateMessage */
  templateMessage?: Maybe<Scalars['String']['output']>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
};

/** NotificationChild */
export type Wf_TrialModeLeads_NotificationChild = Node & {
  __typename?: 'WF_TrialModeLeads_NotificationChild';
  /** [ID] NotificationChildAgeId */
  id: Scalars['ID']['output'];
  /** [NOT NULL] NotificationChildAge */
  notificationChildAge?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] NotificationChildAgeName */
  notificationChildAgeName?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Wf_TrialModeLeads_NotificationChildConnection = {
  __typename?: 'WF_TrialModeLeads_NotificationChildConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_TrialModeLeads_NotificationChildEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_TrialModeLeads_NotificationChild>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_TrialModeLeads_NotificationChildEdge = {
  __typename?: 'WF_TrialModeLeads_NotificationChildEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_TrialModeLeads_NotificationChild;
};

/** NotificationChild */
export type Wf_TrialModeLeads_NotificationChildFilterInput = {
  and?: InputMaybe<Array<Wf_TrialModeLeads_NotificationChildFilterInput>>;
  /** [NOT NULL] NotificationChildAge */
  notificationChildAge?: InputMaybe<StringOperationFilterInput>;
  /** [ID] NotificationChildAgeId */
  notificationChildAgeId?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] NotificationChildAgeName */
  notificationChildAgeName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Wf_TrialModeLeads_NotificationChildFilterInput>>;
};

/** NotificationChild */
export type Wf_TrialModeLeads_NotificationChildInput = {
  /** [NOT NULL] NotificationChildAge */
  notificationChildAge?: InputMaybe<Scalars['String']['input']>;
  /** [ID] NotificationChildAgeId */
  notificationChildAgeId?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] NotificationChildAgeName */
  notificationChildAgeName?: InputMaybe<Scalars['String']['input']>;
};

/** NotificationChild */
export type Wf_TrialModeLeads_NotificationChildSortInput = {
  /** [NOT NULL] NotificationChildAge */
  notificationChildAge?: InputMaybe<SortEnumType>;
  /** [ID] NotificationChildAgeId */
  notificationChildAgeId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] NotificationChildAgeName */
  notificationChildAgeName?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type Wf_TrialModeLeads_NotificationConnection = {
  __typename?: 'WF_TrialModeLeads_NotificationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_TrialModeLeads_NotificationEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_TrialModeLeads_Notification>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_TrialModeLeads_NotificationEdge = {
  __typename?: 'WF_TrialModeLeads_NotificationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_TrialModeLeads_Notification;
};

/** Notification */
export type Wf_TrialModeLeads_NotificationFilterInput = {
  /** ActionButton */
  actionButton?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<Wf_TrialModeLeads_NotificationFilterInput>>;
  /** ButtonLinksTo */
  buttonLinksTo?: InputMaybe<StringOperationFilterInput>;
  /** ButtonText */
  buttonText?: InputMaybe<StringOperationFilterInput>;
  /** CreatedTime */
  createdTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** Creator */
  creator?: InputMaybe<StringOperationFilterInput>;
  /** Error */
  error?: InputMaybe<StringOperationFilterInput>;
  /** ImageFileName */
  imageFileName?: InputMaybe<StringOperationFilterInput>;
  /** JobStatus */
  jobStatus?: InputMaybe<StringOperationFilterInput>;
  /** Market */
  market?: InputMaybe<StringOperationFilterInput>;
  /** MutationOperation */
  mutationOperation?: InputMaybe<StringOperationFilterInput>;
  /** [ID] NotificationId */
  notificationId?: InputMaybe<IntOperationFilterInput>;
  /** [COLLECTION] NotificationToChildAges */
  notificationToChildAges?: InputMaybe<ListFilterInputTypeOfWf_TrialModeLeads_NotificationToChildAgeFilterInput>;
  /** [COLLECTION] NotificationToSegmentations */
  notificationToSegmentations?: InputMaybe<ListFilterInputTypeOfWf_TrialModeLeads_NotificationToSegmentationFilterInput>;
  /** [NAVIGATION] NotificationType */
  notificationType?: InputMaybe<Wf_TrialModeLeads_NotificationTypeFilterInput>;
  /** [NOT NULL] NotificationTypeId */
  notificationTypeId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Wf_TrialModeLeads_NotificationFilterInput>>;
  /** RemoveNotificationId */
  removeNotificationId?: InputMaybe<IntOperationFilterInput>;
  /** ScheduleTime */
  scheduleTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** Segmentation */
  segmentation?: InputMaybe<StringOperationFilterInput>;
  /** TemplateMessage */
  templateMessage?: InputMaybe<StringOperationFilterInput>;
  /** Title */
  title?: InputMaybe<StringOperationFilterInput>;
};

/** Notification */
export type Wf_TrialModeLeads_NotificationInput = {
  /** ActionButton */
  actionButton?: InputMaybe<Scalars['String']['input']>;
  /** ButtonLinksTo */
  buttonLinksTo?: InputMaybe<Scalars['String']['input']>;
  /** ButtonText */
  buttonText?: InputMaybe<Scalars['String']['input']>;
  /** CreatedTime */
  createdTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Creator */
  creator?: InputMaybe<Scalars['String']['input']>;
  /** Error */
  error?: InputMaybe<Scalars['String']['input']>;
  /** ImageFileName */
  imageFileName?: InputMaybe<Scalars['String']['input']>;
  /** JobStatus */
  jobStatus?: InputMaybe<Scalars['String']['input']>;
  /** Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** MutationOperation */
  mutationOperation?: InputMaybe<Scalars['String']['input']>;
  /** [ID] NotificationId */
  notificationId?: InputMaybe<Scalars['Int']['input']>;
  /** [COLLECTION] NotificationToChildAges */
  notificationToChildAges?: InputMaybe<Array<InputMaybe<Wf_TrialModeLeads_NotificationToChildAgeInput>>>;
  /** [COLLECTION] NotificationToSegmentations */
  notificationToSegmentations?: InputMaybe<Array<InputMaybe<Wf_TrialModeLeads_NotificationToSegmentationInput>>>;
  /** [NAVIGATION] NotificationType */
  notificationType?: InputMaybe<Wf_TrialModeLeads_NotificationTypeInput>;
  /** [NOT NULL] NotificationTypeId */
  notificationTypeId?: InputMaybe<Scalars['String']['input']>;
  /** RemoveNotificationId */
  removeNotificationId?: InputMaybe<Scalars['Int']['input']>;
  /** ScheduleTime */
  scheduleTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Segmentation */
  segmentation?: InputMaybe<Scalars['String']['input']>;
  /** TemplateMessage */
  templateMessage?: InputMaybe<Scalars['String']['input']>;
  /** Title */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** NotificationMember */
export type Wf_TrialModeLeads_NotificationMember = Node & {
  __typename?: 'WF_TrialModeLeads_NotificationMember';
  /** [ID] NotificationMemberId */
  id: Scalars['ID']['output'];
  /** [NOT NULL] NotificationId */
  notificationId?: Maybe<Scalars['Int']['output']>;
  /** PhoneNumber */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] TrialUserId */
  trialUserId?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of items. */
export type Wf_TrialModeLeads_NotificationMemberConnection = {
  __typename?: 'WF_TrialModeLeads_NotificationMemberConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_TrialModeLeads_NotificationMemberEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_TrialModeLeads_NotificationMember>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_TrialModeLeads_NotificationMemberEdge = {
  __typename?: 'WF_TrialModeLeads_NotificationMemberEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_TrialModeLeads_NotificationMember;
};

/** NotificationMember */
export type Wf_TrialModeLeads_NotificationMemberFilterInput = {
  and?: InputMaybe<Array<Wf_TrialModeLeads_NotificationMemberFilterInput>>;
  /** [NOT NULL] NotificationId */
  notificationId?: InputMaybe<IntOperationFilterInput>;
  /** [ID] NotificationMemberId */
  notificationMemberId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<Wf_TrialModeLeads_NotificationMemberFilterInput>>;
  /** PhoneNumber */
  phoneNumber?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] TrialUserId */
  trialUserId?: InputMaybe<IntOperationFilterInput>;
};

/** NotificationMember */
export type Wf_TrialModeLeads_NotificationMemberInput = {
  /** [NOT NULL] NotificationId */
  notificationId?: InputMaybe<Scalars['Int']['input']>;
  /** [ID] NotificationMemberId */
  notificationMemberId?: InputMaybe<Scalars['Long']['input']>;
  /** PhoneNumber */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] TrialUserId */
  trialUserId?: InputMaybe<Scalars['Int']['input']>;
};

/** NotificationMember */
export type Wf_TrialModeLeads_NotificationMemberSortInput = {
  /** [NOT NULL] NotificationId */
  notificationId?: InputMaybe<SortEnumType>;
  /** [ID] NotificationMemberId */
  notificationMemberId?: InputMaybe<SortEnumType>;
  /** PhoneNumber */
  phoneNumber?: InputMaybe<SortEnumType>;
  /** [NOT NULL] TrialUserId */
  trialUserId?: InputMaybe<SortEnumType>;
};

/** Notification */
export type Wf_TrialModeLeads_NotificationSortInput = {
  /** ActionButton */
  actionButton?: InputMaybe<SortEnumType>;
  /** ButtonLinksTo */
  buttonLinksTo?: InputMaybe<SortEnumType>;
  /** ButtonText */
  buttonText?: InputMaybe<SortEnumType>;
  /** CreatedTime */
  createdTime?: InputMaybe<SortEnumType>;
  /** Creator */
  creator?: InputMaybe<SortEnumType>;
  /** Error */
  error?: InputMaybe<SortEnumType>;
  /** ImageFileName */
  imageFileName?: InputMaybe<SortEnumType>;
  /** JobStatus */
  jobStatus?: InputMaybe<SortEnumType>;
  /** Market */
  market?: InputMaybe<SortEnumType>;
  /** MutationOperation */
  mutationOperation?: InputMaybe<SortEnumType>;
  /** [ID] NotificationId */
  notificationId?: InputMaybe<SortEnumType>;
  /** [NAVIGATION] NotificationType */
  notificationType?: InputMaybe<Wf_TrialModeLeads_NotificationTypeSortInput>;
  /** [NOT NULL] NotificationTypeId */
  notificationTypeId?: InputMaybe<SortEnumType>;
  /** RemoveNotificationId */
  removeNotificationId?: InputMaybe<SortEnumType>;
  /** ScheduleTime */
  scheduleTime?: InputMaybe<SortEnumType>;
  /** Segmentation */
  segmentation?: InputMaybe<SortEnumType>;
  /** TemplateMessage */
  templateMessage?: InputMaybe<SortEnumType>;
  /** Title */
  title?: InputMaybe<SortEnumType>;
};

/** NotificationToChildAge */
export type Wf_TrialModeLeads_NotificationToChildAge = Node & {
  __typename?: 'WF_TrialModeLeads_NotificationToChildAge';
  /** ChildAge */
  childAge?: Maybe<Scalars['String']['output']>;
  /** [ID] NotificationToChildAgeId */
  id: Scalars['ID']['output'];
  /** [NAVIGATION] Notification */
  notification?: Maybe<Wf_TrialModeLeads_Notification>;
  /** NotificationId */
  notificationId?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of items. */
export type Wf_TrialModeLeads_NotificationToChildAgeConnection = {
  __typename?: 'WF_TrialModeLeads_NotificationToChildAgeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_TrialModeLeads_NotificationToChildAgeEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_TrialModeLeads_NotificationToChildAge>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_TrialModeLeads_NotificationToChildAgeEdge = {
  __typename?: 'WF_TrialModeLeads_NotificationToChildAgeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_TrialModeLeads_NotificationToChildAge;
};

/** NotificationToChildAge */
export type Wf_TrialModeLeads_NotificationToChildAgeFilterInput = {
  and?: InputMaybe<Array<Wf_TrialModeLeads_NotificationToChildAgeFilterInput>>;
  /** ChildAge */
  childAge?: InputMaybe<StringOperationFilterInput>;
  /** [NAVIGATION] Notification */
  notification?: InputMaybe<Wf_TrialModeLeads_NotificationFilterInput>;
  /** NotificationId */
  notificationId?: InputMaybe<IntOperationFilterInput>;
  /** [ID] NotificationToChildAgeId */
  notificationToChildAgeId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<Wf_TrialModeLeads_NotificationToChildAgeFilterInput>>;
};

/** NotificationToChildAge */
export type Wf_TrialModeLeads_NotificationToChildAgeInput = {
  /** ChildAge */
  childAge?: InputMaybe<Scalars['String']['input']>;
  /** [NAVIGATION] Notification */
  notification?: InputMaybe<Wf_TrialModeLeads_NotificationInput>;
  /** NotificationId */
  notificationId?: InputMaybe<Scalars['Int']['input']>;
  /** [ID] NotificationToChildAgeId */
  notificationToChildAgeId?: InputMaybe<Scalars['Int']['input']>;
};

/** NotificationToChildAge */
export type Wf_TrialModeLeads_NotificationToChildAgeSortInput = {
  /** ChildAge */
  childAge?: InputMaybe<SortEnumType>;
  /** [NAVIGATION] Notification */
  notification?: InputMaybe<Wf_TrialModeLeads_NotificationSortInput>;
  /** NotificationId */
  notificationId?: InputMaybe<SortEnumType>;
  /** [ID] NotificationToChildAgeId */
  notificationToChildAgeId?: InputMaybe<SortEnumType>;
};

/** NotificationToSegmentation */
export type Wf_TrialModeLeads_NotificationToSegmentation = Node & {
  __typename?: 'WF_TrialModeLeads_NotificationToSegmentation';
  /** [ID] NotificationToSegmentationId */
  id: Scalars['ID']['output'];
  /** [NAVIGATION] Notification */
  notification?: Maybe<Wf_TrialModeLeads_Notification>;
  /** NotificationId */
  notificationId?: Maybe<Scalars['Int']['output']>;
  /** Segmentation */
  segmentation?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Wf_TrialModeLeads_NotificationToSegmentationConnection = {
  __typename?: 'WF_TrialModeLeads_NotificationToSegmentationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_TrialModeLeads_NotificationToSegmentationEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_TrialModeLeads_NotificationToSegmentation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_TrialModeLeads_NotificationToSegmentationEdge = {
  __typename?: 'WF_TrialModeLeads_NotificationToSegmentationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_TrialModeLeads_NotificationToSegmentation;
};

/** NotificationToSegmentation */
export type Wf_TrialModeLeads_NotificationToSegmentationFilterInput = {
  and?: InputMaybe<Array<Wf_TrialModeLeads_NotificationToSegmentationFilterInput>>;
  /** [NAVIGATION] Notification */
  notification?: InputMaybe<Wf_TrialModeLeads_NotificationFilterInput>;
  /** NotificationId */
  notificationId?: InputMaybe<IntOperationFilterInput>;
  /** [ID] NotificationToSegmentationId */
  notificationToSegmentationId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<Wf_TrialModeLeads_NotificationToSegmentationFilterInput>>;
  /** Segmentation */
  segmentation?: InputMaybe<StringOperationFilterInput>;
};

/** NotificationToSegmentation */
export type Wf_TrialModeLeads_NotificationToSegmentationInput = {
  /** [NAVIGATION] Notification */
  notification?: InputMaybe<Wf_TrialModeLeads_NotificationInput>;
  /** NotificationId */
  notificationId?: InputMaybe<Scalars['Int']['input']>;
  /** [ID] NotificationToSegmentationId */
  notificationToSegmentationId?: InputMaybe<Scalars['Int']['input']>;
  /** Segmentation */
  segmentation?: InputMaybe<Scalars['String']['input']>;
};

/** NotificationToSegmentation */
export type Wf_TrialModeLeads_NotificationToSegmentationSortInput = {
  /** [NAVIGATION] Notification */
  notification?: InputMaybe<Wf_TrialModeLeads_NotificationSortInput>;
  /** NotificationId */
  notificationId?: InputMaybe<SortEnumType>;
  /** [ID] NotificationToSegmentationId */
  notificationToSegmentationId?: InputMaybe<SortEnumType>;
  /** Segmentation */
  segmentation?: InputMaybe<SortEnumType>;
};

/** NotificationType */
export type Wf_TrialModeLeads_NotificationType = Node & {
  __typename?: 'WF_TrialModeLeads_NotificationType';
  /** [ID] NotificationTypeId */
  id: Scalars['ID']['output'];
  /** [NOT NULL] IsPublic */
  isPublic?: Maybe<Scalars['Boolean']['output']>;
  /** [NOT NULL] NotificationName */
  notificationName?: Maybe<Scalars['String']['output']>;
  /** [COLLECTION] Notifications */
  notifications?: Maybe<Array<Maybe<Wf_TrialModeLeads_Notification>>>;
};

/** A connection to a list of items. */
export type Wf_TrialModeLeads_NotificationTypeConnection = {
  __typename?: 'WF_TrialModeLeads_NotificationTypeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_TrialModeLeads_NotificationTypeEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_TrialModeLeads_NotificationType>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_TrialModeLeads_NotificationTypeEdge = {
  __typename?: 'WF_TrialModeLeads_NotificationTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_TrialModeLeads_NotificationType;
};

/** NotificationType */
export type Wf_TrialModeLeads_NotificationTypeFilterInput = {
  and?: InputMaybe<Array<Wf_TrialModeLeads_NotificationTypeFilterInput>>;
  /** [NOT NULL] IsPublic */
  isPublic?: InputMaybe<BooleanOperationFilterInput>;
  /** [NOT NULL] NotificationName */
  notificationName?: InputMaybe<StringOperationFilterInput>;
  /** [ID] NotificationTypeId */
  notificationTypeId?: InputMaybe<StringOperationFilterInput>;
  /** [COLLECTION] Notifications */
  notifications?: InputMaybe<ListFilterInputTypeOfWf_TrialModeLeads_NotificationFilterInput>;
  or?: InputMaybe<Array<Wf_TrialModeLeads_NotificationTypeFilterInput>>;
};

/** NotificationType */
export type Wf_TrialModeLeads_NotificationTypeInput = {
  /** [NOT NULL] IsPublic */
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  /** [NOT NULL] NotificationName */
  notificationName?: InputMaybe<Scalars['String']['input']>;
  /** [ID] NotificationTypeId */
  notificationTypeId?: InputMaybe<Scalars['String']['input']>;
  /** [COLLECTION] Notifications */
  notifications?: InputMaybe<Array<InputMaybe<Wf_TrialModeLeads_NotificationInput>>>;
};

/** NotificationType */
export type Wf_TrialModeLeads_NotificationTypeSortInput = {
  /** [NOT NULL] IsPublic */
  isPublic?: InputMaybe<SortEnumType>;
  /** [NOT NULL] NotificationName */
  notificationName?: InputMaybe<SortEnumType>;
  /** [ID] NotificationTypeId */
  notificationTypeId?: InputMaybe<SortEnumType>;
};

/** ParentTip */
export type Wf_TrialModeLeads_ParentTip = Node & {
  __typename?: 'WF_TrialModeLeads_ParentTip';
  /** [ID] Id */
  id: Scalars['ID']['output'];
  /** [NOT NULL] TipDate */
  tipDate?: Maybe<Scalars['DateTime']['output']>;
  /** TipsEn */
  tipsEn?: Maybe<Scalars['String']['output']>;
  /** TipsHk */
  tipsHk?: Maybe<Scalars['String']['output']>;
  /** TipsKr */
  tipsKr?: Maybe<Scalars['String']['output']>;
  /** TipsTw */
  tipsTw?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Wf_TrialModeLeads_ParentTipConnection = {
  __typename?: 'WF_TrialModeLeads_ParentTipConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_TrialModeLeads_ParentTipEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_TrialModeLeads_ParentTip>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_TrialModeLeads_ParentTipEdge = {
  __typename?: 'WF_TrialModeLeads_ParentTipEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_TrialModeLeads_ParentTip;
};

/** ParentTip */
export type Wf_TrialModeLeads_ParentTipFilterInput = {
  and?: InputMaybe<Array<Wf_TrialModeLeads_ParentTipFilterInput>>;
  /** [ID] Id */
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<Wf_TrialModeLeads_ParentTipFilterInput>>;
  /** [NOT NULL] TipDate */
  tipDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** TipsEn */
  tipsEn?: InputMaybe<StringOperationFilterInput>;
  /** TipsHk */
  tipsHk?: InputMaybe<StringOperationFilterInput>;
  /** TipsKr */
  tipsKr?: InputMaybe<StringOperationFilterInput>;
  /** TipsTw */
  tipsTw?: InputMaybe<StringOperationFilterInput>;
};

/** ParentTip */
export type Wf_TrialModeLeads_ParentTipInput = {
  /** [ID] Id */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] TipDate */
  tipDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** TipsEn */
  tipsEn?: InputMaybe<Scalars['String']['input']>;
  /** TipsHk */
  tipsHk?: InputMaybe<Scalars['String']['input']>;
  /** TipsKr */
  tipsKr?: InputMaybe<Scalars['String']['input']>;
  /** TipsTw */
  tipsTw?: InputMaybe<Scalars['String']['input']>;
};

/** ParentTip */
export type Wf_TrialModeLeads_ParentTipSortInput = {
  /** [ID] Id */
  id?: InputMaybe<SortEnumType>;
  /** [NOT NULL] TipDate */
  tipDate?: InputMaybe<SortEnumType>;
  /** TipsEn */
  tipsEn?: InputMaybe<SortEnumType>;
  /** TipsHk */
  tipsHk?: InputMaybe<SortEnumType>;
  /** TipsKr */
  tipsKr?: InputMaybe<SortEnumType>;
  /** TipsTw */
  tipsTw?: InputMaybe<SortEnumType>;
};

/** ProductCategory */
export type Wf_TrialModeLeads_ProductCategory = Node & {
  __typename?: 'WF_TrialModeLeads_ProductCategory';
  /** Category */
  category?: Maybe<Scalars['String']['output']>;
  /** CategoryName */
  categoryName?: Maybe<Scalars['String']['output']>;
  /** CategoryThumbnail */
  categoryThumbnail?: Maybe<Scalars['String']['output']>;
  /** DwePackage */
  dwePackage?: Maybe<Scalars['String']['output']>;
  /** [ID] ProductCategoryId */
  id: Scalars['ID']['output'];
  /** [COLLECTION] ProductSongs */
  productSongs?: Maybe<Array<Maybe<Wf_TrialModeLeads_ProductSong>>>;
  /** [COLLECTION] ProductVideos */
  productVideos?: Maybe<Array<Maybe<Wf_TrialModeLeads_ProductVideo>>>;
};

/** A connection to a list of items. */
export type Wf_TrialModeLeads_ProductCategoryConnection = {
  __typename?: 'WF_TrialModeLeads_ProductCategoryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_TrialModeLeads_ProductCategoryEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_TrialModeLeads_ProductCategory>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_TrialModeLeads_ProductCategoryEdge = {
  __typename?: 'WF_TrialModeLeads_ProductCategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_TrialModeLeads_ProductCategory;
};

/** ProductCategory */
export type Wf_TrialModeLeads_ProductCategoryFilterInput = {
  and?: InputMaybe<Array<Wf_TrialModeLeads_ProductCategoryFilterInput>>;
  /** Category */
  category?: InputMaybe<StringOperationFilterInput>;
  /** CategoryName */
  categoryName?: InputMaybe<StringOperationFilterInput>;
  /** CategoryThumbnail */
  categoryThumbnail?: InputMaybe<StringOperationFilterInput>;
  /** DwePackage */
  dwePackage?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Wf_TrialModeLeads_ProductCategoryFilterInput>>;
  /** [ID] ProductCategoryId */
  productCategoryId?: InputMaybe<IntOperationFilterInput>;
  /** [COLLECTION] ProductSongs */
  productSongs?: InputMaybe<ListFilterInputTypeOfWf_TrialModeLeads_ProductSongFilterInput>;
  /** [COLLECTION] ProductVideos */
  productVideos?: InputMaybe<ListFilterInputTypeOfWf_TrialModeLeads_ProductVideoFilterInput>;
};

/** ProductCategory */
export type Wf_TrialModeLeads_ProductCategoryInput = {
  /** Category */
  category?: InputMaybe<Scalars['String']['input']>;
  /** CategoryName */
  categoryName?: InputMaybe<Scalars['String']['input']>;
  /** CategoryThumbnail */
  categoryThumbnail?: InputMaybe<Scalars['String']['input']>;
  /** DwePackage */
  dwePackage?: InputMaybe<Scalars['String']['input']>;
  /** [ID] ProductCategoryId */
  productCategoryId?: InputMaybe<Scalars['Int']['input']>;
  /** [COLLECTION] ProductSongs */
  productSongs?: InputMaybe<Array<InputMaybe<Wf_TrialModeLeads_ProductSongInput>>>;
  /** [COLLECTION] ProductVideos */
  productVideos?: InputMaybe<Array<InputMaybe<Wf_TrialModeLeads_ProductVideoInput>>>;
};

/** ProductCategory */
export type Wf_TrialModeLeads_ProductCategorySortInput = {
  /** Category */
  category?: InputMaybe<SortEnumType>;
  /** CategoryName */
  categoryName?: InputMaybe<SortEnumType>;
  /** CategoryThumbnail */
  categoryThumbnail?: InputMaybe<SortEnumType>;
  /** DwePackage */
  dwePackage?: InputMaybe<SortEnumType>;
  /** [ID] ProductCategoryId */
  productCategoryId?: InputMaybe<SortEnumType>;
};

/** ProductSong */
export type Wf_TrialModeLeads_ProductSong = Node & {
  __typename?: 'WF_TrialModeLeads_ProductSong';
  /** AudioFileName */
  audioFileName?: Maybe<Scalars['String']['output']>;
  /** CreatedTime */
  createdTime?: Maybe<Scalars['DateTime']['output']>;
  /** Creator */
  creator?: Maybe<Scalars['String']['output']>;
  /** [ID] ProductSongId */
  id: Scalars['ID']['output'];
  /** LyricsFileName */
  lyricsFileName?: Maybe<Scalars['String']['output']>;
  /** [NAVIGATION] ProductCategory */
  productCategory?: Maybe<Wf_TrialModeLeads_ProductCategory>;
  /** [NOT NULL] ProductCategoryId */
  productCategoryId?: Maybe<Scalars['Int']['output']>;
  /** [COLLECTION] ProductSongAndMarkets */
  productSongAndMarkets?: Maybe<Array<Maybe<Wf_TrialModeLeads_ProductSongAndMarket>>>;
  /** SongTitle */
  songTitle?: Maybe<Scalars['String']['output']>;
  /** SortId */
  sortId?: Maybe<Scalars['Int']['output']>;
  /** UpdatedTime */
  updatedTime?: Maybe<Scalars['DateTime']['output']>;
  /** Updater */
  updater?: Maybe<Scalars['String']['output']>;
};

/** ProductSongAndMarket */
export type Wf_TrialModeLeads_ProductSongAndMarket = Node & {
  __typename?: 'WF_TrialModeLeads_ProductSongAndMarket';
  /** [ID] ProductSongAndMarketId */
  id: Scalars['ID']['output'];
  /** [NOT NULL] Market */
  market?: Maybe<Scalars['String']['output']>;
  /** [NAVIGATION] ProductSong */
  productSong?: Maybe<Wf_TrialModeLeads_ProductSong>;
  /** [NOT NULL] ProductSongId */
  productSongId?: Maybe<Scalars['Int']['output']>;
  /** [NOT NULL] Segmentation */
  segmentation?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Wf_TrialModeLeads_ProductSongAndMarketConnection = {
  __typename?: 'WF_TrialModeLeads_ProductSongAndMarketConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_TrialModeLeads_ProductSongAndMarketEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_TrialModeLeads_ProductSongAndMarket>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_TrialModeLeads_ProductSongAndMarketEdge = {
  __typename?: 'WF_TrialModeLeads_ProductSongAndMarketEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_TrialModeLeads_ProductSongAndMarket;
};

/** ProductSongAndMarket */
export type Wf_TrialModeLeads_ProductSongAndMarketFilterInput = {
  and?: InputMaybe<Array<Wf_TrialModeLeads_ProductSongAndMarketFilterInput>>;
  /** [NOT NULL] Market */
  market?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Wf_TrialModeLeads_ProductSongAndMarketFilterInput>>;
  /** [NAVIGATION] ProductSong */
  productSong?: InputMaybe<Wf_TrialModeLeads_ProductSongFilterInput>;
  /** [ID] ProductSongAndMarketId */
  productSongAndMarketId?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] ProductSongId */
  productSongId?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] Segmentation */
  segmentation?: InputMaybe<StringOperationFilterInput>;
};

/** ProductSongAndMarket */
export type Wf_TrialModeLeads_ProductSongAndMarketInput = {
  /** [NOT NULL] Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** [NAVIGATION] ProductSong */
  productSong?: InputMaybe<Wf_TrialModeLeads_ProductSongInput>;
  /** [ID] ProductSongAndMarketId */
  productSongAndMarketId?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] ProductSongId */
  productSongId?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] Segmentation */
  segmentation?: InputMaybe<Scalars['String']['input']>;
};

/** ProductSongAndMarket */
export type Wf_TrialModeLeads_ProductSongAndMarketSortInput = {
  /** [NOT NULL] Market */
  market?: InputMaybe<SortEnumType>;
  /** [NAVIGATION] ProductSong */
  productSong?: InputMaybe<Wf_TrialModeLeads_ProductSongSortInput>;
  /** [ID] ProductSongAndMarketId */
  productSongAndMarketId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] ProductSongId */
  productSongId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Segmentation */
  segmentation?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type Wf_TrialModeLeads_ProductSongConnection = {
  __typename?: 'WF_TrialModeLeads_ProductSongConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_TrialModeLeads_ProductSongEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_TrialModeLeads_ProductSong>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_TrialModeLeads_ProductSongEdge = {
  __typename?: 'WF_TrialModeLeads_ProductSongEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_TrialModeLeads_ProductSong;
};

/** ProductSong */
export type Wf_TrialModeLeads_ProductSongFilterInput = {
  and?: InputMaybe<Array<Wf_TrialModeLeads_ProductSongFilterInput>>;
  /** AudioFileName */
  audioFileName?: InputMaybe<StringOperationFilterInput>;
  /** CreatedTime */
  createdTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** Creator */
  creator?: InputMaybe<StringOperationFilterInput>;
  /** LyricsFileName */
  lyricsFileName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Wf_TrialModeLeads_ProductSongFilterInput>>;
  /** [NAVIGATION] ProductCategory */
  productCategory?: InputMaybe<Wf_TrialModeLeads_ProductCategoryFilterInput>;
  /** [NOT NULL] ProductCategoryId */
  productCategoryId?: InputMaybe<IntOperationFilterInput>;
  /** [COLLECTION] ProductSongAndMarkets */
  productSongAndMarkets?: InputMaybe<ListFilterInputTypeOfWf_TrialModeLeads_ProductSongAndMarketFilterInput>;
  /** [ID] ProductSongId */
  productSongId?: InputMaybe<IntOperationFilterInput>;
  /** SongTitle */
  songTitle?: InputMaybe<StringOperationFilterInput>;
  /** SortId */
  sortId?: InputMaybe<IntOperationFilterInput>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** Updater */
  updater?: InputMaybe<StringOperationFilterInput>;
};

/** ProductSong */
export type Wf_TrialModeLeads_ProductSongInput = {
  /** AudioFileName */
  audioFileName?: InputMaybe<Scalars['String']['input']>;
  /** CreatedTime */
  createdTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Creator */
  creator?: InputMaybe<Scalars['String']['input']>;
  /** LyricsFileName */
  lyricsFileName?: InputMaybe<Scalars['String']['input']>;
  /** [NAVIGATION] ProductCategory */
  productCategory?: InputMaybe<Wf_TrialModeLeads_ProductCategoryInput>;
  /** [NOT NULL] ProductCategoryId */
  productCategoryId?: InputMaybe<Scalars['Int']['input']>;
  /** [COLLECTION] ProductSongAndMarkets */
  productSongAndMarkets?: InputMaybe<Array<InputMaybe<Wf_TrialModeLeads_ProductSongAndMarketInput>>>;
  /** [ID] ProductSongId */
  productSongId?: InputMaybe<Scalars['Int']['input']>;
  /** SongTitle */
  songTitle?: InputMaybe<Scalars['String']['input']>;
  /** SortId */
  sortId?: InputMaybe<Scalars['Int']['input']>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Updater */
  updater?: InputMaybe<Scalars['String']['input']>;
};

/** ProductSong */
export type Wf_TrialModeLeads_ProductSongSortInput = {
  /** AudioFileName */
  audioFileName?: InputMaybe<SortEnumType>;
  /** CreatedTime */
  createdTime?: InputMaybe<SortEnumType>;
  /** Creator */
  creator?: InputMaybe<SortEnumType>;
  /** LyricsFileName */
  lyricsFileName?: InputMaybe<SortEnumType>;
  /** [NAVIGATION] ProductCategory */
  productCategory?: InputMaybe<Wf_TrialModeLeads_ProductCategorySortInput>;
  /** [NOT NULL] ProductCategoryId */
  productCategoryId?: InputMaybe<SortEnumType>;
  /** [ID] ProductSongId */
  productSongId?: InputMaybe<SortEnumType>;
  /** SongTitle */
  songTitle?: InputMaybe<SortEnumType>;
  /** SortId */
  sortId?: InputMaybe<SortEnumType>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<SortEnumType>;
  /** Updater */
  updater?: InputMaybe<SortEnumType>;
};

/** ProductVideo */
export type Wf_TrialModeLeads_ProductVideo = Node & {
  __typename?: 'WF_TrialModeLeads_ProductVideo';
  /** BlobIntroVideoFileName */
  blobIntroVideoFileName?: Maybe<Scalars['String']['output']>;
  /** BlobVideoFileName */
  blobVideoFileName?: Maybe<Scalars['String']['output']>;
  /** CreatedTime */
  createdTime?: Maybe<Scalars['DateTime']['output']>;
  /** Creator */
  creator?: Maybe<Scalars['String']['output']>;
  /** [ID] ProductVideoId */
  id: Scalars['ID']['output'];
  /** IntroVideoFileName */
  introVideoFileName?: Maybe<Scalars['String']['output']>;
  /** [NAVIGATION] ProductCategory */
  productCategory?: Maybe<Wf_TrialModeLeads_ProductCategory>;
  /** [NOT NULL] ProductCategoryId */
  productCategoryId?: Maybe<Scalars['Int']['output']>;
  /** [COLLECTION] ProductVideoAndMarkets */
  productVideoAndMarkets?: Maybe<Array<Maybe<Wf_TrialModeLeads_ProductVideoAndMarket>>>;
  /** SortId */
  sortId?: Maybe<Scalars['Int']['output']>;
  /** UpdatedTime */
  updatedTime?: Maybe<Scalars['DateTime']['output']>;
  /** Updater */
  updater?: Maybe<Scalars['String']['output']>;
  /** VideoFileName */
  videoFileName?: Maybe<Scalars['String']['output']>;
  /** VideoThumbnail */
  videoThumbnail?: Maybe<Scalars['String']['output']>;
  /** VideoTitle */
  videoTitle?: Maybe<Scalars['String']['output']>;
};

/** ProductVideoAndMarket */
export type Wf_TrialModeLeads_ProductVideoAndMarket = Node & {
  __typename?: 'WF_TrialModeLeads_ProductVideoAndMarket';
  /** [ID] ProductVideoAndMarketId */
  id: Scalars['ID']['output'];
  /** [NOT NULL] Market */
  market?: Maybe<Scalars['String']['output']>;
  /** [NAVIGATION] ProductVideo */
  productVideo?: Maybe<Wf_TrialModeLeads_ProductVideo>;
  /** [NOT NULL] ProductVideoId */
  productVideoId?: Maybe<Scalars['Int']['output']>;
  /** [NOT NULL] Segmentation */
  segmentation?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Wf_TrialModeLeads_ProductVideoAndMarketConnection = {
  __typename?: 'WF_TrialModeLeads_ProductVideoAndMarketConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_TrialModeLeads_ProductVideoAndMarketEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_TrialModeLeads_ProductVideoAndMarket>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_TrialModeLeads_ProductVideoAndMarketEdge = {
  __typename?: 'WF_TrialModeLeads_ProductVideoAndMarketEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_TrialModeLeads_ProductVideoAndMarket;
};

/** ProductVideoAndMarket */
export type Wf_TrialModeLeads_ProductVideoAndMarketFilterInput = {
  and?: InputMaybe<Array<Wf_TrialModeLeads_ProductVideoAndMarketFilterInput>>;
  /** [NOT NULL] Market */
  market?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Wf_TrialModeLeads_ProductVideoAndMarketFilterInput>>;
  /** [NAVIGATION] ProductVideo */
  productVideo?: InputMaybe<Wf_TrialModeLeads_ProductVideoFilterInput>;
  /** [ID] ProductVideoAndMarketId */
  productVideoAndMarketId?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] ProductVideoId */
  productVideoId?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] Segmentation */
  segmentation?: InputMaybe<StringOperationFilterInput>;
};

/** ProductVideoAndMarket */
export type Wf_TrialModeLeads_ProductVideoAndMarketInput = {
  /** [NOT NULL] Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** [NAVIGATION] ProductVideo */
  productVideo?: InputMaybe<Wf_TrialModeLeads_ProductVideoInput>;
  /** [ID] ProductVideoAndMarketId */
  productVideoAndMarketId?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] ProductVideoId */
  productVideoId?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] Segmentation */
  segmentation?: InputMaybe<Scalars['String']['input']>;
};

/** ProductVideoAndMarket */
export type Wf_TrialModeLeads_ProductVideoAndMarketSortInput = {
  /** [NOT NULL] Market */
  market?: InputMaybe<SortEnumType>;
  /** [NAVIGATION] ProductVideo */
  productVideo?: InputMaybe<Wf_TrialModeLeads_ProductVideoSortInput>;
  /** [ID] ProductVideoAndMarketId */
  productVideoAndMarketId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] ProductVideoId */
  productVideoId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] Segmentation */
  segmentation?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type Wf_TrialModeLeads_ProductVideoConnection = {
  __typename?: 'WF_TrialModeLeads_ProductVideoConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_TrialModeLeads_ProductVideoEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_TrialModeLeads_ProductVideo>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_TrialModeLeads_ProductVideoEdge = {
  __typename?: 'WF_TrialModeLeads_ProductVideoEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_TrialModeLeads_ProductVideo;
};

/** ProductVideo */
export type Wf_TrialModeLeads_ProductVideoFilterInput = {
  and?: InputMaybe<Array<Wf_TrialModeLeads_ProductVideoFilterInput>>;
  /** BlobIntroVideoFileName */
  blobIntroVideoFileName?: InputMaybe<StringOperationFilterInput>;
  /** BlobVideoFileName */
  blobVideoFileName?: InputMaybe<StringOperationFilterInput>;
  /** CreatedTime */
  createdTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** Creator */
  creator?: InputMaybe<StringOperationFilterInput>;
  /** IntroVideoFileName */
  introVideoFileName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Wf_TrialModeLeads_ProductVideoFilterInput>>;
  /** [NAVIGATION] ProductCategory */
  productCategory?: InputMaybe<Wf_TrialModeLeads_ProductCategoryFilterInput>;
  /** [NOT NULL] ProductCategoryId */
  productCategoryId?: InputMaybe<IntOperationFilterInput>;
  /** [COLLECTION] ProductVideoAndMarkets */
  productVideoAndMarkets?: InputMaybe<ListFilterInputTypeOfWf_TrialModeLeads_ProductVideoAndMarketFilterInput>;
  /** [ID] ProductVideoId */
  productVideoId?: InputMaybe<IntOperationFilterInput>;
  /** SortId */
  sortId?: InputMaybe<IntOperationFilterInput>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** Updater */
  updater?: InputMaybe<StringOperationFilterInput>;
  /** VideoFileName */
  videoFileName?: InputMaybe<StringOperationFilterInput>;
  /** VideoThumbnail */
  videoThumbnail?: InputMaybe<StringOperationFilterInput>;
  /** VideoTitle */
  videoTitle?: InputMaybe<StringOperationFilterInput>;
};

/** ProductVideo */
export type Wf_TrialModeLeads_ProductVideoInput = {
  /** BlobIntroVideoFileName */
  blobIntroVideoFileName?: InputMaybe<Scalars['String']['input']>;
  /** BlobVideoFileName */
  blobVideoFileName?: InputMaybe<Scalars['String']['input']>;
  /** CreatedTime */
  createdTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Creator */
  creator?: InputMaybe<Scalars['String']['input']>;
  /** IntroVideoFileName */
  introVideoFileName?: InputMaybe<Scalars['String']['input']>;
  /** [NAVIGATION] ProductCategory */
  productCategory?: InputMaybe<Wf_TrialModeLeads_ProductCategoryInput>;
  /** [NOT NULL] ProductCategoryId */
  productCategoryId?: InputMaybe<Scalars['Int']['input']>;
  /** [COLLECTION] ProductVideoAndMarkets */
  productVideoAndMarkets?: InputMaybe<Array<InputMaybe<Wf_TrialModeLeads_ProductVideoAndMarketInput>>>;
  /** [ID] ProductVideoId */
  productVideoId?: InputMaybe<Scalars['Int']['input']>;
  /** SortId */
  sortId?: InputMaybe<Scalars['Int']['input']>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Updater */
  updater?: InputMaybe<Scalars['String']['input']>;
  /** VideoFileName */
  videoFileName?: InputMaybe<Scalars['String']['input']>;
  /** VideoThumbnail */
  videoThumbnail?: InputMaybe<Scalars['String']['input']>;
  /** VideoTitle */
  videoTitle?: InputMaybe<Scalars['String']['input']>;
};

/** ProductVideo */
export type Wf_TrialModeLeads_ProductVideoSortInput = {
  /** BlobIntroVideoFileName */
  blobIntroVideoFileName?: InputMaybe<SortEnumType>;
  /** BlobVideoFileName */
  blobVideoFileName?: InputMaybe<SortEnumType>;
  /** CreatedTime */
  createdTime?: InputMaybe<SortEnumType>;
  /** Creator */
  creator?: InputMaybe<SortEnumType>;
  /** IntroVideoFileName */
  introVideoFileName?: InputMaybe<SortEnumType>;
  /** [NAVIGATION] ProductCategory */
  productCategory?: InputMaybe<Wf_TrialModeLeads_ProductCategorySortInput>;
  /** [NOT NULL] ProductCategoryId */
  productCategoryId?: InputMaybe<SortEnumType>;
  /** [ID] ProductVideoId */
  productVideoId?: InputMaybe<SortEnumType>;
  /** SortId */
  sortId?: InputMaybe<SortEnumType>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<SortEnumType>;
  /** Updater */
  updater?: InputMaybe<SortEnumType>;
  /** VideoFileName */
  videoFileName?: InputMaybe<SortEnumType>;
  /** VideoThumbnail */
  videoThumbnail?: InputMaybe<SortEnumType>;
  /** VideoTitle */
  videoTitle?: InputMaybe<SortEnumType>;
};

/** RegularEvent */
export type Wf_TrialModeLeads_RegularEvent = Node & {
  __typename?: 'WF_TrialModeLeads_RegularEvent';
  /** CreatedTime */
  createdTime?: Maybe<Scalars['DateTime']['output']>;
  /** Creator */
  creator?: Maybe<Scalars['String']['output']>;
  /** EndDate */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** EventDescription */
  eventDescription?: Maybe<Scalars['String']['output']>;
  /** EventTitle */
  eventTitle?: Maybe<Scalars['String']['output']>;
  /** [ID] RegularEventId */
  id: Scalars['ID']['output'];
  /** ImageFileName */
  imageFileName?: Maybe<Scalars['String']['output']>;
  /** Market */
  market?: Maybe<Scalars['String']['output']>;
  /** NavigationUrl */
  navigationUrl?: Maybe<Scalars['String']['output']>;
  /** SortId */
  sortId?: Maybe<Scalars['Int']['output']>;
  /** StartDate */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  /** UpdatedTime */
  updatedTime?: Maybe<Scalars['DateTime']['output']>;
  /** Updater */
  updater?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Wf_TrialModeLeads_RegularEventConnection = {
  __typename?: 'WF_TrialModeLeads_RegularEventConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_TrialModeLeads_RegularEventEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_TrialModeLeads_RegularEvent>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_TrialModeLeads_RegularEventEdge = {
  __typename?: 'WF_TrialModeLeads_RegularEventEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_TrialModeLeads_RegularEvent;
};

/** RegularEvent */
export type Wf_TrialModeLeads_RegularEventFilterInput = {
  and?: InputMaybe<Array<Wf_TrialModeLeads_RegularEventFilterInput>>;
  /** CreatedTime */
  createdTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** Creator */
  creator?: InputMaybe<StringOperationFilterInput>;
  /** EndDate */
  endDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** EventDescription */
  eventDescription?: InputMaybe<StringOperationFilterInput>;
  /** EventTitle */
  eventTitle?: InputMaybe<StringOperationFilterInput>;
  /** ImageFileName */
  imageFileName?: InputMaybe<StringOperationFilterInput>;
  /** Market */
  market?: InputMaybe<StringOperationFilterInput>;
  /** NavigationUrl */
  navigationUrl?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Wf_TrialModeLeads_RegularEventFilterInput>>;
  /** [ID] RegularEventId */
  regularEventId?: InputMaybe<IntOperationFilterInput>;
  /** SortId */
  sortId?: InputMaybe<IntOperationFilterInput>;
  /** StartDate */
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** Updater */
  updater?: InputMaybe<StringOperationFilterInput>;
};

/** RegularEvent */
export type Wf_TrialModeLeads_RegularEventInput = {
  /** CreatedTime */
  createdTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Creator */
  creator?: InputMaybe<Scalars['String']['input']>;
  /** EndDate */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** EventDescription */
  eventDescription?: InputMaybe<Scalars['String']['input']>;
  /** EventTitle */
  eventTitle?: InputMaybe<Scalars['String']['input']>;
  /** ImageFileName */
  imageFileName?: InputMaybe<Scalars['String']['input']>;
  /** Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** NavigationUrl */
  navigationUrl?: InputMaybe<Scalars['String']['input']>;
  /** [ID] RegularEventId */
  regularEventId?: InputMaybe<Scalars['Int']['input']>;
  /** SortId */
  sortId?: InputMaybe<Scalars['Int']['input']>;
  /** StartDate */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Updater */
  updater?: InputMaybe<Scalars['String']['input']>;
};

/** RegularEvent */
export type Wf_TrialModeLeads_RegularEventSortInput = {
  /** CreatedTime */
  createdTime?: InputMaybe<SortEnumType>;
  /** Creator */
  creator?: InputMaybe<SortEnumType>;
  /** EndDate */
  endDate?: InputMaybe<SortEnumType>;
  /** EventDescription */
  eventDescription?: InputMaybe<SortEnumType>;
  /** EventTitle */
  eventTitle?: InputMaybe<SortEnumType>;
  /** ImageFileName */
  imageFileName?: InputMaybe<SortEnumType>;
  /** Market */
  market?: InputMaybe<SortEnumType>;
  /** NavigationUrl */
  navigationUrl?: InputMaybe<SortEnumType>;
  /** [ID] RegularEventId */
  regularEventId?: InputMaybe<SortEnumType>;
  /** SortId */
  sortId?: InputMaybe<SortEnumType>;
  /** StartDate */
  startDate?: InputMaybe<SortEnumType>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<SortEnumType>;
  /** Updater */
  updater?: InputMaybe<SortEnumType>;
};

/** TacoTest */
export type Wf_TrialModeLeads_TacoTest = Node & {
  __typename?: 'WF_TrialModeLeads_TacoTest';
  /** [ID] Id */
  id: Scalars['ID']['output'];
};

/** A connection to a list of items. */
export type Wf_TrialModeLeads_TacoTestConnection = {
  __typename?: 'WF_TrialModeLeads_TacoTestConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_TrialModeLeads_TacoTestEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_TrialModeLeads_TacoTest>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_TrialModeLeads_TacoTestEdge = {
  __typename?: 'WF_TrialModeLeads_TacoTestEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_TrialModeLeads_TacoTest;
};

/** TacoTest */
export type Wf_TrialModeLeads_TacoTestFilterInput = {
  and?: InputMaybe<Array<Wf_TrialModeLeads_TacoTestFilterInput>>;
  /** [ID] Id */
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Wf_TrialModeLeads_TacoTestFilterInput>>;
};

/** TacoTest */
export type Wf_TrialModeLeads_TacoTestInput = {
  /** [ID] Id */
  id: Scalars['String']['input'];
};

/** TacoTest */
export type Wf_TrialModeLeads_TacoTestSortInput = {
  /** [ID] Id */
  id?: InputMaybe<SortEnumType>;
};

/** TempProductVideo */
export type Wf_TrialModeLeads_TempProductVideo = Node & {
  __typename?: 'WF_TrialModeLeads_TempProductVideo';
  /** BlobIntroVideoFileName */
  blobIntroVideoFileName?: Maybe<Scalars['String']['output']>;
  /** BlobVideoFileName */
  blobVideoFileName?: Maybe<Scalars['String']['output']>;
  /** CreatedTime */
  createdTime?: Maybe<Scalars['String']['output']>;
  /** Creator */
  creator?: Maybe<Scalars['String']['output']>;
  /** [ID] ProductVideoId */
  id: Scalars['ID']['output'];
  /** IntroVideoFileName */
  introVideoFileName?: Maybe<Scalars['String']['output']>;
  /** ProductCategoryId */
  productCategoryId?: Maybe<Scalars['String']['output']>;
  /** SortId */
  sortId?: Maybe<Scalars['String']['output']>;
  /** UpdatedTime */
  updatedTime?: Maybe<Scalars['String']['output']>;
  /** Updater */
  updater?: Maybe<Scalars['String']['output']>;
  /** VideoFileName */
  videoFileName?: Maybe<Scalars['String']['output']>;
  /** VideoThumbnail */
  videoThumbnail?: Maybe<Scalars['String']['output']>;
  /** VideoTitle */
  videoTitle?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Wf_TrialModeLeads_TempProductVideoConnection = {
  __typename?: 'WF_TrialModeLeads_TempProductVideoConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_TrialModeLeads_TempProductVideoEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_TrialModeLeads_TempProductVideo>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_TrialModeLeads_TempProductVideoEdge = {
  __typename?: 'WF_TrialModeLeads_TempProductVideoEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_TrialModeLeads_TempProductVideo;
};

/** TempProductVideo */
export type Wf_TrialModeLeads_TempProductVideoFilterInput = {
  and?: InputMaybe<Array<Wf_TrialModeLeads_TempProductVideoFilterInput>>;
  /** BlobIntroVideoFileName */
  blobIntroVideoFileName?: InputMaybe<StringOperationFilterInput>;
  /** BlobVideoFileName */
  blobVideoFileName?: InputMaybe<StringOperationFilterInput>;
  /** CreatedTime */
  createdTime?: InputMaybe<StringOperationFilterInput>;
  /** Creator */
  creator?: InputMaybe<StringOperationFilterInput>;
  /** IntroVideoFileName */
  introVideoFileName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Wf_TrialModeLeads_TempProductVideoFilterInput>>;
  /** ProductCategoryId */
  productCategoryId?: InputMaybe<StringOperationFilterInput>;
  /** [ID] ProductVideoId */
  productVideoId?: InputMaybe<StringOperationFilterInput>;
  /** SortId */
  sortId?: InputMaybe<StringOperationFilterInput>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<StringOperationFilterInput>;
  /** Updater */
  updater?: InputMaybe<StringOperationFilterInput>;
  /** VideoFileName */
  videoFileName?: InputMaybe<StringOperationFilterInput>;
  /** VideoThumbnail */
  videoThumbnail?: InputMaybe<StringOperationFilterInput>;
  /** VideoTitle */
  videoTitle?: InputMaybe<StringOperationFilterInput>;
};

/** TempProductVideo */
export type Wf_TrialModeLeads_TempProductVideoInput = {
  /** BlobIntroVideoFileName */
  blobIntroVideoFileName?: InputMaybe<Scalars['String']['input']>;
  /** BlobVideoFileName */
  blobVideoFileName?: InputMaybe<Scalars['String']['input']>;
  /** CreatedTime */
  createdTime?: InputMaybe<Scalars['String']['input']>;
  /** Creator */
  creator?: InputMaybe<Scalars['String']['input']>;
  /** IntroVideoFileName */
  introVideoFileName?: InputMaybe<Scalars['String']['input']>;
  /** ProductCategoryId */
  productCategoryId?: InputMaybe<Scalars['String']['input']>;
  /** [ID] ProductVideoId */
  productVideoId: Scalars['String']['input'];
  /** SortId */
  sortId?: InputMaybe<Scalars['String']['input']>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<Scalars['String']['input']>;
  /** Updater */
  updater?: InputMaybe<Scalars['String']['input']>;
  /** VideoFileName */
  videoFileName?: InputMaybe<Scalars['String']['input']>;
  /** VideoThumbnail */
  videoThumbnail?: InputMaybe<Scalars['String']['input']>;
  /** VideoTitle */
  videoTitle?: InputMaybe<Scalars['String']['input']>;
};

/** TempProductVideo */
export type Wf_TrialModeLeads_TempProductVideoSortInput = {
  /** BlobIntroVideoFileName */
  blobIntroVideoFileName?: InputMaybe<SortEnumType>;
  /** BlobVideoFileName */
  blobVideoFileName?: InputMaybe<SortEnumType>;
  /** CreatedTime */
  createdTime?: InputMaybe<SortEnumType>;
  /** Creator */
  creator?: InputMaybe<SortEnumType>;
  /** IntroVideoFileName */
  introVideoFileName?: InputMaybe<SortEnumType>;
  /** ProductCategoryId */
  productCategoryId?: InputMaybe<SortEnumType>;
  /** [ID] ProductVideoId */
  productVideoId?: InputMaybe<SortEnumType>;
  /** SortId */
  sortId?: InputMaybe<SortEnumType>;
  /** UpdatedTime */
  updatedTime?: InputMaybe<SortEnumType>;
  /** Updater */
  updater?: InputMaybe<SortEnumType>;
  /** VideoFileName */
  videoFileName?: InputMaybe<SortEnumType>;
  /** VideoThumbnail */
  videoThumbnail?: InputMaybe<SortEnumType>;
  /** VideoTitle */
  videoTitle?: InputMaybe<SortEnumType>;
};

/** Testimonial */
export type Wf_TrialModeLeads_Testimonial = Node & {
  __typename?: 'WF_TrialModeLeads_Testimonial';
  /** CreatedBy */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** CreatedDate */
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  /** EndDate */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** [ID] TestimonialId */
  id: Scalars['ID']['output'];
  /** Market */
  market?: Maybe<Scalars['String']['output']>;
  /** PublishDate */
  publishDate?: Maybe<Scalars['DateTime']['output']>;
  /** [NOT NULL] SortOrder */
  sortOrder?: Maybe<Scalars['Int']['output']>;
  /** [COLLECTION] TestimonialTagMappings */
  testimonialTagMappings?: Maybe<Array<Maybe<Wf_TrialModeLeads_TestimonialTagMapping>>>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
  /** UpdatedBy */
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] UpdatedDate */
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
  /** VideoFileName */
  videoFileName?: Maybe<Scalars['String']['output']>;
  /** VideoThumbnailFileName */
  videoThumbnailFileName?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Wf_TrialModeLeads_TestimonialConnection = {
  __typename?: 'WF_TrialModeLeads_TestimonialConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_TrialModeLeads_TestimonialEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_TrialModeLeads_Testimonial>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_TrialModeLeads_TestimonialEdge = {
  __typename?: 'WF_TrialModeLeads_TestimonialEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_TrialModeLeads_Testimonial;
};

/** Testimonial */
export type Wf_TrialModeLeads_TestimonialFilterInput = {
  and?: InputMaybe<Array<Wf_TrialModeLeads_TestimonialFilterInput>>;
  /** CreatedBy */
  createdBy?: InputMaybe<StringOperationFilterInput>;
  /** CreatedDate */
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** EndDate */
  endDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Market */
  market?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Wf_TrialModeLeads_TestimonialFilterInput>>;
  /** PublishDate */
  publishDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** [NOT NULL] SortOrder */
  sortOrder?: InputMaybe<IntOperationFilterInput>;
  /** [ID] TestimonialId */
  testimonialId?: InputMaybe<IntOperationFilterInput>;
  /** [COLLECTION] TestimonialTagMappings */
  testimonialTagMappings?: InputMaybe<ListFilterInputTypeOfWf_TrialModeLeads_TestimonialTagMappingFilterInput>;
  /** Title */
  title?: InputMaybe<StringOperationFilterInput>;
  /** UpdatedBy */
  updatedBy?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] UpdatedDate */
  updatedDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** VideoFileName */
  videoFileName?: InputMaybe<StringOperationFilterInput>;
  /** VideoThumbnailFileName */
  videoThumbnailFileName?: InputMaybe<StringOperationFilterInput>;
};

/** Testimonial */
export type Wf_TrialModeLeads_TestimonialInput = {
  /** CreatedBy */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** CreatedDate */
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** EndDate */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** PublishDate */
  publishDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** [NOT NULL] SortOrder */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  /** [ID] TestimonialId */
  testimonialId?: InputMaybe<Scalars['Int']['input']>;
  /** [COLLECTION] TestimonialTagMappings */
  testimonialTagMappings?: InputMaybe<Array<InputMaybe<Wf_TrialModeLeads_TestimonialTagMappingInput>>>;
  /** Title */
  title?: InputMaybe<Scalars['String']['input']>;
  /** UpdatedBy */
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] UpdatedDate */
  updatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** VideoFileName */
  videoFileName?: InputMaybe<Scalars['String']['input']>;
  /** VideoThumbnailFileName */
  videoThumbnailFileName?: InputMaybe<Scalars['String']['input']>;
};

/** Testimonial */
export type Wf_TrialModeLeads_TestimonialSortInput = {
  /** CreatedBy */
  createdBy?: InputMaybe<SortEnumType>;
  /** CreatedDate */
  createdDate?: InputMaybe<SortEnumType>;
  /** EndDate */
  endDate?: InputMaybe<SortEnumType>;
  /** Market */
  market?: InputMaybe<SortEnumType>;
  /** PublishDate */
  publishDate?: InputMaybe<SortEnumType>;
  /** [NOT NULL] SortOrder */
  sortOrder?: InputMaybe<SortEnumType>;
  /** [ID] TestimonialId */
  testimonialId?: InputMaybe<SortEnumType>;
  /** Title */
  title?: InputMaybe<SortEnumType>;
  /** UpdatedBy */
  updatedBy?: InputMaybe<SortEnumType>;
  /** [NOT NULL] UpdatedDate */
  updatedDate?: InputMaybe<SortEnumType>;
  /** VideoFileName */
  videoFileName?: InputMaybe<SortEnumType>;
  /** VideoThumbnailFileName */
  videoThumbnailFileName?: InputMaybe<SortEnumType>;
};

/** TestimonialTag */
export type Wf_TrialModeLeads_TestimonialTag = Node & {
  __typename?: 'WF_TrialModeLeads_TestimonialTag';
  /** [ID] TagId */
  id: Scalars['ID']['output'];
  /** [NOT NULL] IsUsed */
  isUsed?: Maybe<Scalars['Boolean']['output']>;
  /** Market */
  market?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] SortOrder */
  sortOrder?: Maybe<Scalars['Int']['output']>;
  /** TagName */
  tagName?: Maybe<Scalars['String']['output']>;
  /** [COLLECTION] TestimonialTagMappings */
  testimonialTagMappings?: Maybe<Array<Maybe<Wf_TrialModeLeads_TestimonialTagMapping>>>;
};

/** A connection to a list of items. */
export type Wf_TrialModeLeads_TestimonialTagConnection = {
  __typename?: 'WF_TrialModeLeads_TestimonialTagConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_TrialModeLeads_TestimonialTagEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_TrialModeLeads_TestimonialTag>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_TrialModeLeads_TestimonialTagEdge = {
  __typename?: 'WF_TrialModeLeads_TestimonialTagEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_TrialModeLeads_TestimonialTag;
};

/** TestimonialTag */
export type Wf_TrialModeLeads_TestimonialTagFilterInput = {
  and?: InputMaybe<Array<Wf_TrialModeLeads_TestimonialTagFilterInput>>;
  /** [NOT NULL] IsUsed */
  isUsed?: InputMaybe<BooleanOperationFilterInput>;
  /** Market */
  market?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Wf_TrialModeLeads_TestimonialTagFilterInput>>;
  /** [NOT NULL] SortOrder */
  sortOrder?: InputMaybe<IntOperationFilterInput>;
  /** [ID] TagId */
  tagId?: InputMaybe<IntOperationFilterInput>;
  /** TagName */
  tagName?: InputMaybe<StringOperationFilterInput>;
  /** [COLLECTION] TestimonialTagMappings */
  testimonialTagMappings?: InputMaybe<ListFilterInputTypeOfWf_TrialModeLeads_TestimonialTagMappingFilterInput>;
};

/** TestimonialTag */
export type Wf_TrialModeLeads_TestimonialTagInput = {
  /** [NOT NULL] IsUsed */
  isUsed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] SortOrder */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  /** [ID] TagId */
  tagId?: InputMaybe<Scalars['Int']['input']>;
  /** TagName */
  tagName?: InputMaybe<Scalars['String']['input']>;
  /** [COLLECTION] TestimonialTagMappings */
  testimonialTagMappings?: InputMaybe<Array<InputMaybe<Wf_TrialModeLeads_TestimonialTagMappingInput>>>;
};

/** TestimonialTagMapping */
export type Wf_TrialModeLeads_TestimonialTagMapping = Node & {
  __typename?: 'WF_TrialModeLeads_TestimonialTagMapping';
  /** [ID] Seq */
  id: Scalars['ID']['output'];
  /** [NAVIGATION] Tag */
  tag?: Maybe<Wf_TrialModeLeads_TestimonialTag>;
  /** [NOT NULL] TagId */
  tagId?: Maybe<Scalars['Int']['output']>;
  /** [NAVIGATION] Testimonial */
  testimonial?: Maybe<Wf_TrialModeLeads_Testimonial>;
  /** [NOT NULL] TestimonialId */
  testimonialId?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of items. */
export type Wf_TrialModeLeads_TestimonialTagMappingConnection = {
  __typename?: 'WF_TrialModeLeads_TestimonialTagMappingConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_TrialModeLeads_TestimonialTagMappingEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_TrialModeLeads_TestimonialTagMapping>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_TrialModeLeads_TestimonialTagMappingEdge = {
  __typename?: 'WF_TrialModeLeads_TestimonialTagMappingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_TrialModeLeads_TestimonialTagMapping;
};

/** TestimonialTagMapping */
export type Wf_TrialModeLeads_TestimonialTagMappingFilterInput = {
  and?: InputMaybe<Array<Wf_TrialModeLeads_TestimonialTagMappingFilterInput>>;
  or?: InputMaybe<Array<Wf_TrialModeLeads_TestimonialTagMappingFilterInput>>;
  /** [ID] Seq */
  seq?: InputMaybe<IntOperationFilterInput>;
  /** [NAVIGATION] Tag */
  tag?: InputMaybe<Wf_TrialModeLeads_TestimonialTagFilterInput>;
  /** [NOT NULL] TagId */
  tagId?: InputMaybe<IntOperationFilterInput>;
  /** [NAVIGATION] Testimonial */
  testimonial?: InputMaybe<Wf_TrialModeLeads_TestimonialFilterInput>;
  /** [NOT NULL] TestimonialId */
  testimonialId?: InputMaybe<IntOperationFilterInput>;
};

/** TestimonialTagMapping */
export type Wf_TrialModeLeads_TestimonialTagMappingInput = {
  /** [ID] Seq */
  seq?: InputMaybe<Scalars['Int']['input']>;
  /** [NAVIGATION] Tag */
  tag?: InputMaybe<Wf_TrialModeLeads_TestimonialTagInput>;
  /** [NOT NULL] TagId */
  tagId?: InputMaybe<Scalars['Int']['input']>;
  /** [NAVIGATION] Testimonial */
  testimonial?: InputMaybe<Wf_TrialModeLeads_TestimonialInput>;
  /** [NOT NULL] TestimonialId */
  testimonialId?: InputMaybe<Scalars['Int']['input']>;
};

/** TestimonialTagMapping */
export type Wf_TrialModeLeads_TestimonialTagMappingSortInput = {
  /** [ID] Seq */
  seq?: InputMaybe<SortEnumType>;
  /** [NAVIGATION] Tag */
  tag?: InputMaybe<Wf_TrialModeLeads_TestimonialTagSortInput>;
  /** [NOT NULL] TagId */
  tagId?: InputMaybe<SortEnumType>;
  /** [NAVIGATION] Testimonial */
  testimonial?: InputMaybe<Wf_TrialModeLeads_TestimonialSortInput>;
  /** [NOT NULL] TestimonialId */
  testimonialId?: InputMaybe<SortEnumType>;
};

/** TestimonialTag */
export type Wf_TrialModeLeads_TestimonialTagSortInput = {
  /** [NOT NULL] IsUsed */
  isUsed?: InputMaybe<SortEnumType>;
  /** Market */
  market?: InputMaybe<SortEnumType>;
  /** [NOT NULL] SortOrder */
  sortOrder?: InputMaybe<SortEnumType>;
  /** [ID] TagId */
  tagId?: InputMaybe<SortEnumType>;
  /** TagName */
  tagName?: InputMaybe<SortEnumType>;
};

/** Tip */
export type Wf_TrialModeLeads_Tip = Node & {
  __typename?: 'WF_TrialModeLeads_Tip';
  /** [ID] TipsTw */
  id: Scalars['ID']['output'];
  /** TipsEn */
  tipsEn?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Wf_TrialModeLeads_TipConnection = {
  __typename?: 'WF_TrialModeLeads_TipConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_TrialModeLeads_TipEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_TrialModeLeads_Tip>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_TrialModeLeads_TipEdge = {
  __typename?: 'WF_TrialModeLeads_TipEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_TrialModeLeads_Tip;
};

/** Tip */
export type Wf_TrialModeLeads_TipFilterInput = {
  and?: InputMaybe<Array<Wf_TrialModeLeads_TipFilterInput>>;
  or?: InputMaybe<Array<Wf_TrialModeLeads_TipFilterInput>>;
  /** TipsEn */
  tipsEn?: InputMaybe<StringOperationFilterInput>;
  /** [ID] TipsTw */
  tipsTw?: InputMaybe<StringOperationFilterInput>;
};

/** Tip */
export type Wf_TrialModeLeads_TipInput = {
  /** TipsEn */
  tipsEn?: InputMaybe<Scalars['String']['input']>;
  /** [ID] TipsTw */
  tipsTw: Scalars['String']['input'];
};

/** Tip */
export type Wf_TrialModeLeads_TipSortInput = {
  /** TipsEn */
  tipsEn?: InputMaybe<SortEnumType>;
  /** [ID] TipsTw */
  tipsTw?: InputMaybe<SortEnumType>;
};

/** TrialCampaignUrl */
export type Wf_TrialModeLeads_TrialCampaignUrl = Node & {
  __typename?: 'WF_TrialModeLeads_TrialCampaignUrl';
  /** CampaignChannel */
  campaignChannel?: Maybe<Scalars['String']['output']>;
  /** CampaignUrl */
  campaignUrl?: Maybe<Scalars['String']['output']>;
  /** Device */
  device?: Maybe<Scalars['String']['output']>;
  /** [ID] CampaignId */
  id: Scalars['ID']['output'];
  /** Market */
  market?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Wf_TrialModeLeads_TrialCampaignUrlConnection = {
  __typename?: 'WF_TrialModeLeads_TrialCampaignUrlConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_TrialModeLeads_TrialCampaignUrlEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_TrialModeLeads_TrialCampaignUrl>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_TrialModeLeads_TrialCampaignUrlEdge = {
  __typename?: 'WF_TrialModeLeads_TrialCampaignUrlEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_TrialModeLeads_TrialCampaignUrl;
};

/** TrialCampaignUrl */
export type Wf_TrialModeLeads_TrialCampaignUrlFilterInput = {
  and?: InputMaybe<Array<Wf_TrialModeLeads_TrialCampaignUrlFilterInput>>;
  /** CampaignChannel */
  campaignChannel?: InputMaybe<StringOperationFilterInput>;
  /** [ID] CampaignId */
  campaignId?: InputMaybe<IntOperationFilterInput>;
  /** CampaignUrl */
  campaignUrl?: InputMaybe<StringOperationFilterInput>;
  /** Device */
  device?: InputMaybe<StringOperationFilterInput>;
  /** Market */
  market?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Wf_TrialModeLeads_TrialCampaignUrlFilterInput>>;
};

/** TrialCampaignUrl */
export type Wf_TrialModeLeads_TrialCampaignUrlInput = {
  /** CampaignChannel */
  campaignChannel?: InputMaybe<Scalars['String']['input']>;
  /** [ID] CampaignId */
  campaignId?: InputMaybe<Scalars['Int']['input']>;
  /** CampaignUrl */
  campaignUrl?: InputMaybe<Scalars['String']['input']>;
  /** Device */
  device?: InputMaybe<Scalars['String']['input']>;
  /** Market */
  market?: InputMaybe<Scalars['String']['input']>;
};

/** TrialCampaignUrl */
export type Wf_TrialModeLeads_TrialCampaignUrlSortInput = {
  /** CampaignChannel */
  campaignChannel?: InputMaybe<SortEnumType>;
  /** [ID] CampaignId */
  campaignId?: InputMaybe<SortEnumType>;
  /** CampaignUrl */
  campaignUrl?: InputMaybe<SortEnumType>;
  /** Device */
  device?: InputMaybe<SortEnumType>;
  /** Market */
  market?: InputMaybe<SortEnumType>;
};

/** TrialMailLog */
export type Wf_TrialModeLeads_TrialMailLog = Node & {
  __typename?: 'WF_TrialModeLeads_TrialMailLog';
  /** CreatedTime */
  createdTime?: Maybe<Scalars['DateTime']['output']>;
  /** [ID] TrialMailLogId */
  id: Scalars['ID']['output'];
  /** MailBcc */
  mailBcc?: Maybe<Scalars['String']['output']>;
  /** MailCc */
  mailCc?: Maybe<Scalars['String']['output']>;
  /** MailContent */
  mailContent?: Maybe<Scalars['String']['output']>;
  /** MailSubject */
  mailSubject?: Maybe<Scalars['String']['output']>;
  /** MailTo */
  mailTo?: Maybe<Scalars['String']['output']>;
  /** [NOT NULL] TrialUserId */
  trialUserId?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of items. */
export type Wf_TrialModeLeads_TrialMailLogConnection = {
  __typename?: 'WF_TrialModeLeads_TrialMailLogConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_TrialModeLeads_TrialMailLogEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_TrialModeLeads_TrialMailLog>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_TrialModeLeads_TrialMailLogEdge = {
  __typename?: 'WF_TrialModeLeads_TrialMailLogEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_TrialModeLeads_TrialMailLog;
};

/** TrialMailLog */
export type Wf_TrialModeLeads_TrialMailLogFilterInput = {
  and?: InputMaybe<Array<Wf_TrialModeLeads_TrialMailLogFilterInput>>;
  /** CreatedTime */
  createdTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** MailBcc */
  mailBcc?: InputMaybe<StringOperationFilterInput>;
  /** MailCc */
  mailCc?: InputMaybe<StringOperationFilterInput>;
  /** MailContent */
  mailContent?: InputMaybe<StringOperationFilterInput>;
  /** MailSubject */
  mailSubject?: InputMaybe<StringOperationFilterInput>;
  /** MailTo */
  mailTo?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Wf_TrialModeLeads_TrialMailLogFilterInput>>;
  /** [ID] TrialMailLogId */
  trialMailLogId?: InputMaybe<IntOperationFilterInput>;
  /** [NOT NULL] TrialUserId */
  trialUserId?: InputMaybe<IntOperationFilterInput>;
};

/** TrialMailLog */
export type Wf_TrialModeLeads_TrialMailLogInput = {
  /** CreatedTime */
  createdTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** MailBcc */
  mailBcc?: InputMaybe<Scalars['String']['input']>;
  /** MailCc */
  mailCc?: InputMaybe<Scalars['String']['input']>;
  /** MailContent */
  mailContent?: InputMaybe<Scalars['String']['input']>;
  /** MailSubject */
  mailSubject?: InputMaybe<Scalars['String']['input']>;
  /** MailTo */
  mailTo?: InputMaybe<Scalars['String']['input']>;
  /** [ID] TrialMailLogId */
  trialMailLogId?: InputMaybe<Scalars['Int']['input']>;
  /** [NOT NULL] TrialUserId */
  trialUserId?: InputMaybe<Scalars['Int']['input']>;
};

/** TrialMailLog */
export type Wf_TrialModeLeads_TrialMailLogSortInput = {
  /** CreatedTime */
  createdTime?: InputMaybe<SortEnumType>;
  /** MailBcc */
  mailBcc?: InputMaybe<SortEnumType>;
  /** MailCc */
  mailCc?: InputMaybe<SortEnumType>;
  /** MailContent */
  mailContent?: InputMaybe<SortEnumType>;
  /** MailSubject */
  mailSubject?: InputMaybe<SortEnumType>;
  /** MailTo */
  mailTo?: InputMaybe<SortEnumType>;
  /** [ID] TrialMailLogId */
  trialMailLogId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] TrialUserId */
  trialUserId?: InputMaybe<SortEnumType>;
};

/** TrialMailSetting */
export type Wf_TrialModeLeads_TrialMailSetting = Node & {
  __typename?: 'WF_TrialModeLeads_TrialMailSetting';
  /** CreatedTime */
  createdTime?: Maybe<Scalars['DateTime']['output']>;
  /** [ID] TrialMailSettingId */
  id: Scalars['ID']['output'];
  /** MailBody */
  mailBody?: Maybe<Scalars['String']['output']>;
  /** MailSubject */
  mailSubject?: Maybe<Scalars['String']['output']>;
  /** MailTo */
  mailTo?: Maybe<Scalars['String']['output']>;
  /** MailType */
  mailType?: Maybe<Scalars['String']['output']>;
  /** Market */
  market?: Maybe<Scalars['String']['output']>;
  /** SenderAddress */
  senderAddress?: Maybe<Scalars['String']['output']>;
  /** SenderName */
  senderName?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Wf_TrialModeLeads_TrialMailSettingConnection = {
  __typename?: 'WF_TrialModeLeads_TrialMailSettingConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_TrialModeLeads_TrialMailSettingEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_TrialModeLeads_TrialMailSetting>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_TrialModeLeads_TrialMailSettingEdge = {
  __typename?: 'WF_TrialModeLeads_TrialMailSettingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_TrialModeLeads_TrialMailSetting;
};

/** TrialMailSetting */
export type Wf_TrialModeLeads_TrialMailSettingFilterInput = {
  and?: InputMaybe<Array<Wf_TrialModeLeads_TrialMailSettingFilterInput>>;
  /** CreatedTime */
  createdTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** MailBody */
  mailBody?: InputMaybe<StringOperationFilterInput>;
  /** MailSubject */
  mailSubject?: InputMaybe<StringOperationFilterInput>;
  /** MailTo */
  mailTo?: InputMaybe<StringOperationFilterInput>;
  /** MailType */
  mailType?: InputMaybe<StringOperationFilterInput>;
  /** Market */
  market?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Wf_TrialModeLeads_TrialMailSettingFilterInput>>;
  /** SenderAddress */
  senderAddress?: InputMaybe<StringOperationFilterInput>;
  /** SenderName */
  senderName?: InputMaybe<StringOperationFilterInput>;
  /** [ID] TrialMailSettingId */
  trialMailSettingId?: InputMaybe<IntOperationFilterInput>;
};

/** TrialMailSetting */
export type Wf_TrialModeLeads_TrialMailSettingInput = {
  /** CreatedTime */
  createdTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** MailBody */
  mailBody?: InputMaybe<Scalars['String']['input']>;
  /** MailSubject */
  mailSubject?: InputMaybe<Scalars['String']['input']>;
  /** MailTo */
  mailTo?: InputMaybe<Scalars['String']['input']>;
  /** MailType */
  mailType?: InputMaybe<Scalars['String']['input']>;
  /** Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** SenderAddress */
  senderAddress?: InputMaybe<Scalars['String']['input']>;
  /** SenderName */
  senderName?: InputMaybe<Scalars['String']['input']>;
  /** [ID] TrialMailSettingId */
  trialMailSettingId?: InputMaybe<Scalars['Int']['input']>;
};

/** TrialMailSetting */
export type Wf_TrialModeLeads_TrialMailSettingSortInput = {
  /** CreatedTime */
  createdTime?: InputMaybe<SortEnumType>;
  /** MailBody */
  mailBody?: InputMaybe<SortEnumType>;
  /** MailSubject */
  mailSubject?: InputMaybe<SortEnumType>;
  /** MailTo */
  mailTo?: InputMaybe<SortEnumType>;
  /** MailType */
  mailType?: InputMaybe<SortEnumType>;
  /** Market */
  market?: InputMaybe<SortEnumType>;
  /** SenderAddress */
  senderAddress?: InputMaybe<SortEnumType>;
  /** SenderName */
  senderName?: InputMaybe<SortEnumType>;
  /** [ID] TrialMailSettingId */
  trialMailSettingId?: InputMaybe<SortEnumType>;
};

/** TrialMessageSetting */
export type Wf_TrialModeLeads_TrialMessageSetting = Node & {
  __typename?: 'WF_TrialModeLeads_TrialMessageSetting';
  /** CreatedTime */
  createdTime?: Maybe<Scalars['DateTime']['output']>;
  /** [ID] TrialMessageSettingId */
  id: Scalars['ID']['output'];
  /** Market */
  market?: Maybe<Scalars['String']['output']>;
  /** MessageType */
  messageType?: Maybe<Scalars['String']['output']>;
  /** NotificationId */
  notificationId?: Maybe<Scalars['Int']['output']>;
  /** PushMessage */
  pushMessage?: Maybe<Scalars['String']['output']>;
  /** SmsMessage */
  smsMessage?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Wf_TrialModeLeads_TrialMessageSettingConnection = {
  __typename?: 'WF_TrialModeLeads_TrialMessageSettingConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_TrialModeLeads_TrialMessageSettingEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_TrialModeLeads_TrialMessageSetting>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_TrialModeLeads_TrialMessageSettingEdge = {
  __typename?: 'WF_TrialModeLeads_TrialMessageSettingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_TrialModeLeads_TrialMessageSetting;
};

/** TrialMessageSetting */
export type Wf_TrialModeLeads_TrialMessageSettingFilterInput = {
  and?: InputMaybe<Array<Wf_TrialModeLeads_TrialMessageSettingFilterInput>>;
  /** CreatedTime */
  createdTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** Market */
  market?: InputMaybe<StringOperationFilterInput>;
  /** MessageType */
  messageType?: InputMaybe<StringOperationFilterInput>;
  /** NotificationId */
  notificationId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<Wf_TrialModeLeads_TrialMessageSettingFilterInput>>;
  /** PushMessage */
  pushMessage?: InputMaybe<StringOperationFilterInput>;
  /** SmsMessage */
  smsMessage?: InputMaybe<StringOperationFilterInput>;
  /** [ID] TrialMessageSettingId */
  trialMessageSettingId?: InputMaybe<IntOperationFilterInput>;
};

/** TrialMessageSetting */
export type Wf_TrialModeLeads_TrialMessageSettingInput = {
  /** CreatedTime */
  createdTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** MessageType */
  messageType?: InputMaybe<Scalars['String']['input']>;
  /** NotificationId */
  notificationId?: InputMaybe<Scalars['Int']['input']>;
  /** PushMessage */
  pushMessage?: InputMaybe<Scalars['String']['input']>;
  /** SmsMessage */
  smsMessage?: InputMaybe<Scalars['String']['input']>;
  /** [ID] TrialMessageSettingId */
  trialMessageSettingId?: InputMaybe<Scalars['Int']['input']>;
};

/** TrialMessageSetting */
export type Wf_TrialModeLeads_TrialMessageSettingSortInput = {
  /** CreatedTime */
  createdTime?: InputMaybe<SortEnumType>;
  /** Market */
  market?: InputMaybe<SortEnumType>;
  /** MessageType */
  messageType?: InputMaybe<SortEnumType>;
  /** NotificationId */
  notificationId?: InputMaybe<SortEnumType>;
  /** PushMessage */
  pushMessage?: InputMaybe<SortEnumType>;
  /** SmsMessage */
  smsMessage?: InputMaybe<SortEnumType>;
  /** [ID] TrialMessageSettingId */
  trialMessageSettingId?: InputMaybe<SortEnumType>;
};

/** TrialOneTimeToken */
export type Wf_TrialModeLeads_TrialOneTimeToken = Node & {
  __typename?: 'WF_TrialModeLeads_TrialOneTimeToken';
  /** CreatedTime */
  createdTime?: Maybe<Scalars['DateTime']['output']>;
  /** DeviceId */
  deviceId?: Maybe<Scalars['String']['output']>;
  /** [ID] TrialOneTimeTokenId */
  id: Scalars['ID']['output'];
  /** Market */
  market?: Maybe<Scalars['String']['output']>;
  /** PhoneNumber */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** TrialUserId */
  trialUserId?: Maybe<Scalars['Int']['output']>;
  /** TrialUserName */
  trialUserName?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Wf_TrialModeLeads_TrialOneTimeTokenConnection = {
  __typename?: 'WF_TrialModeLeads_TrialOneTimeTokenConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_TrialModeLeads_TrialOneTimeTokenEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_TrialModeLeads_TrialOneTimeToken>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_TrialModeLeads_TrialOneTimeTokenEdge = {
  __typename?: 'WF_TrialModeLeads_TrialOneTimeTokenEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_TrialModeLeads_TrialOneTimeToken;
};

/** TrialOneTimeToken */
export type Wf_TrialModeLeads_TrialOneTimeTokenFilterInput = {
  and?: InputMaybe<Array<Wf_TrialModeLeads_TrialOneTimeTokenFilterInput>>;
  /** CreatedTime */
  createdTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** DeviceId */
  deviceId?: InputMaybe<StringOperationFilterInput>;
  /** Market */
  market?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Wf_TrialModeLeads_TrialOneTimeTokenFilterInput>>;
  /** PhoneNumber */
  phoneNumber?: InputMaybe<StringOperationFilterInput>;
  /** [ID] TrialOneTimeTokenId */
  trialOneTimeTokenId?: InputMaybe<UuidOperationFilterInput>;
  /** TrialUserId */
  trialUserId?: InputMaybe<IntOperationFilterInput>;
  /** TrialUserName */
  trialUserName?: InputMaybe<StringOperationFilterInput>;
};

/** TrialOneTimeToken */
export type Wf_TrialModeLeads_TrialOneTimeTokenInput = {
  /** CreatedTime */
  createdTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** DeviceId */
  deviceId?: InputMaybe<Scalars['String']['input']>;
  /** Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** PhoneNumber */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** [ID] TrialOneTimeTokenId */
  trialOneTimeTokenId?: InputMaybe<Scalars['UUID']['input']>;
  /** TrialUserId */
  trialUserId?: InputMaybe<Scalars['Int']['input']>;
  /** TrialUserName */
  trialUserName?: InputMaybe<Scalars['String']['input']>;
};

/** TrialOneTimeToken */
export type Wf_TrialModeLeads_TrialOneTimeTokenSortInput = {
  /** CreatedTime */
  createdTime?: InputMaybe<SortEnumType>;
  /** DeviceId */
  deviceId?: InputMaybe<SortEnumType>;
  /** Market */
  market?: InputMaybe<SortEnumType>;
  /** PhoneNumber */
  phoneNumber?: InputMaybe<SortEnumType>;
  /** [ID] TrialOneTimeTokenId */
  trialOneTimeTokenId?: InputMaybe<SortEnumType>;
  /** TrialUserId */
  trialUserId?: InputMaybe<SortEnumType>;
  /** TrialUserName */
  trialUserName?: InputMaybe<SortEnumType>;
};

/** TrialPushType */
export type Wf_TrialModeLeads_TrialPushType = Node & {
  __typename?: 'WF_TrialModeLeads_TrialPushType';
  /** [ID] PushTypeId */
  id: Scalars['ID']['output'];
  /** [NOT NULL] IsPublic */
  isPublic?: Maybe<Scalars['Boolean']['output']>;
  /** [NOT NULL] PushTypeName */
  pushTypeName?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Wf_TrialModeLeads_TrialPushTypeConnection = {
  __typename?: 'WF_TrialModeLeads_TrialPushTypeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_TrialModeLeads_TrialPushTypeEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_TrialModeLeads_TrialPushType>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_TrialModeLeads_TrialPushTypeEdge = {
  __typename?: 'WF_TrialModeLeads_TrialPushTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_TrialModeLeads_TrialPushType;
};

/** TrialPushType */
export type Wf_TrialModeLeads_TrialPushTypeFilterInput = {
  and?: InputMaybe<Array<Wf_TrialModeLeads_TrialPushTypeFilterInput>>;
  /** [NOT NULL] IsPublic */
  isPublic?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<Wf_TrialModeLeads_TrialPushTypeFilterInput>>;
  /** [ID] PushTypeId */
  pushTypeId?: InputMaybe<StringOperationFilterInput>;
  /** [NOT NULL] PushTypeName */
  pushTypeName?: InputMaybe<StringOperationFilterInput>;
};

/** TrialPushType */
export type Wf_TrialModeLeads_TrialPushTypeInput = {
  /** [NOT NULL] IsPublic */
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  /** [ID] PushTypeId */
  pushTypeId?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] PushTypeName */
  pushTypeName?: InputMaybe<Scalars['String']['input']>;
};

/** TrialPushType */
export type Wf_TrialModeLeads_TrialPushTypeSortInput = {
  /** [NOT NULL] IsPublic */
  isPublic?: InputMaybe<SortEnumType>;
  /** [ID] PushTypeId */
  pushTypeId?: InputMaybe<SortEnumType>;
  /** [NOT NULL] PushTypeName */
  pushTypeName?: InputMaybe<SortEnumType>;
};

/** TrialSegmentation */
export type Wf_TrialModeLeads_TrialSegmentation = Node & {
  __typename?: 'WF_TrialModeLeads_TrialSegmentation';
  /** [ID] SegmentationId */
  id: Scalars['ID']['output'];
  /** Segmentation */
  segmentation?: Maybe<Scalars['String']['output']>;
  /** SegmentationDescription */
  segmentationDescription?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Wf_TrialModeLeads_TrialSegmentationConnection = {
  __typename?: 'WF_TrialModeLeads_TrialSegmentationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_TrialModeLeads_TrialSegmentationEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_TrialModeLeads_TrialSegmentation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_TrialModeLeads_TrialSegmentationEdge = {
  __typename?: 'WF_TrialModeLeads_TrialSegmentationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_TrialModeLeads_TrialSegmentation;
};

/** TrialSegmentation */
export type Wf_TrialModeLeads_TrialSegmentationFilterInput = {
  and?: InputMaybe<Array<Wf_TrialModeLeads_TrialSegmentationFilterInput>>;
  or?: InputMaybe<Array<Wf_TrialModeLeads_TrialSegmentationFilterInput>>;
  /** Segmentation */
  segmentation?: InputMaybe<StringOperationFilterInput>;
  /** SegmentationDescription */
  segmentationDescription?: InputMaybe<StringOperationFilterInput>;
  /** [ID] SegmentationId */
  segmentationId?: InputMaybe<IntOperationFilterInput>;
};

/** TrialSegmentation */
export type Wf_TrialModeLeads_TrialSegmentationInput = {
  /** Segmentation */
  segmentation?: InputMaybe<Scalars['String']['input']>;
  /** SegmentationDescription */
  segmentationDescription?: InputMaybe<Scalars['String']['input']>;
  /** [ID] SegmentationId */
  segmentationId?: InputMaybe<Scalars['Int']['input']>;
};

/** TrialSegmentation */
export type Wf_TrialModeLeads_TrialSegmentationSortInput = {
  /** Segmentation */
  segmentation?: InputMaybe<SortEnumType>;
  /** SegmentationDescription */
  segmentationDescription?: InputMaybe<SortEnumType>;
  /** [ID] SegmentationId */
  segmentationId?: InputMaybe<SortEnumType>;
};

/** TrialSetting */
export type Wf_TrialModeLeads_TrialSetting = Node & {
  __typename?: 'WF_TrialModeLeads_TrialSetting';
  /** [ID] TrialSettingId */
  id: Scalars['ID']['output'];
  /** Market */
  market?: Maybe<Scalars['String']['output']>;
  /** TrialSettingKey */
  trialSettingKey?: Maybe<Scalars['String']['output']>;
  /** TrialSettingValue */
  trialSettingValue?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Wf_TrialModeLeads_TrialSettingConnection = {
  __typename?: 'WF_TrialModeLeads_TrialSettingConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_TrialModeLeads_TrialSettingEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_TrialModeLeads_TrialSetting>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_TrialModeLeads_TrialSettingEdge = {
  __typename?: 'WF_TrialModeLeads_TrialSettingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_TrialModeLeads_TrialSetting;
};

/** TrialSetting */
export type Wf_TrialModeLeads_TrialSettingFilterInput = {
  and?: InputMaybe<Array<Wf_TrialModeLeads_TrialSettingFilterInput>>;
  /** Market */
  market?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Wf_TrialModeLeads_TrialSettingFilterInput>>;
  /** [ID] TrialSettingId */
  trialSettingId?: InputMaybe<IntOperationFilterInput>;
  /** TrialSettingKey */
  trialSettingKey?: InputMaybe<StringOperationFilterInput>;
  /** TrialSettingValue */
  trialSettingValue?: InputMaybe<StringOperationFilterInput>;
};

/** TrialSetting */
export type Wf_TrialModeLeads_TrialSettingInput = {
  /** Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** [ID] TrialSettingId */
  trialSettingId?: InputMaybe<Scalars['Int']['input']>;
  /** TrialSettingKey */
  trialSettingKey?: InputMaybe<Scalars['String']['input']>;
  /** TrialSettingValue */
  trialSettingValue?: InputMaybe<Scalars['String']['input']>;
};

/** TrialSetting */
export type Wf_TrialModeLeads_TrialSettingSortInput = {
  /** Market */
  market?: InputMaybe<SortEnumType>;
  /** [ID] TrialSettingId */
  trialSettingId?: InputMaybe<SortEnumType>;
  /** TrialSettingKey */
  trialSettingKey?: InputMaybe<SortEnumType>;
  /** TrialSettingValue */
  trialSettingValue?: InputMaybe<SortEnumType>;
};

/** TrialTestPhone */
export type Wf_TrialModeLeads_TrialTestPhone = Node & {
  __typename?: 'WF_TrialModeLeads_TrialTestPhone';
  /** [ID] Market */
  id: Scalars['ID']['output'];
  /** [NOT NULL] PhoneNumber */
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Wf_TrialModeLeads_TrialTestPhoneConnection = {
  __typename?: 'WF_TrialModeLeads_TrialTestPhoneConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_TrialModeLeads_TrialTestPhoneEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_TrialModeLeads_TrialTestPhone>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_TrialModeLeads_TrialTestPhoneEdge = {
  __typename?: 'WF_TrialModeLeads_TrialTestPhoneEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_TrialModeLeads_TrialTestPhone;
};

/** TrialTestPhone */
export type Wf_TrialModeLeads_TrialTestPhoneFilterInput = {
  and?: InputMaybe<Array<Wf_TrialModeLeads_TrialTestPhoneFilterInput>>;
  /** [ID] Market */
  market?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Wf_TrialModeLeads_TrialTestPhoneFilterInput>>;
  /** [NOT NULL] PhoneNumber */
  phoneNumber?: InputMaybe<StringOperationFilterInput>;
};

/** TrialTestPhone */
export type Wf_TrialModeLeads_TrialTestPhoneInput = {
  /** [ID] Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** [NOT NULL] PhoneNumber */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

/** TrialTestPhone */
export type Wf_TrialModeLeads_TrialTestPhoneSortInput = {
  /** [ID] Market */
  market?: InputMaybe<SortEnumType>;
  /** [NOT NULL] PhoneNumber */
  phoneNumber?: InputMaybe<SortEnumType>;
};

/** TrialToken */
export type Wf_TrialModeLeads_TrialToken = Node & {
  __typename?: 'WF_TrialModeLeads_TrialToken';
  /** AccessKey */
  accessKey?: Maybe<Scalars['String']['output']>;
  /** CreatedTime */
  createdTime?: Maybe<Scalars['DateTime']['output']>;
  /** [ID] TrialTokenId */
  id: Scalars['ID']['output'];
  /** Token */
  token?: Maybe<Scalars['String']['output']>;
  /** [NAVIGATION] TrialUser */
  trialUser?: Maybe<Wf_TrialModeLeads_TrialUser>;
  /** TrialUserId */
  trialUserId?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of items. */
export type Wf_TrialModeLeads_TrialTokenConnection = {
  __typename?: 'WF_TrialModeLeads_TrialTokenConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_TrialModeLeads_TrialTokenEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_TrialModeLeads_TrialToken>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_TrialModeLeads_TrialTokenEdge = {
  __typename?: 'WF_TrialModeLeads_TrialTokenEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_TrialModeLeads_TrialToken;
};

/** TrialToken */
export type Wf_TrialModeLeads_TrialTokenFilterInput = {
  /** AccessKey */
  accessKey?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<Wf_TrialModeLeads_TrialTokenFilterInput>>;
  /** CreatedTime */
  createdTime?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<Wf_TrialModeLeads_TrialTokenFilterInput>>;
  /** Token */
  token?: InputMaybe<StringOperationFilterInput>;
  /** [ID] TrialTokenId */
  trialTokenId?: InputMaybe<StringOperationFilterInput>;
  /** [NAVIGATION] TrialUser */
  trialUser?: InputMaybe<Wf_TrialModeLeads_TrialUserFilterInput>;
  /** TrialUserId */
  trialUserId?: InputMaybe<IntOperationFilterInput>;
};

/** TrialToken */
export type Wf_TrialModeLeads_TrialTokenInput = {
  /** AccessKey */
  accessKey?: InputMaybe<Scalars['String']['input']>;
  /** CreatedTime */
  createdTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Token */
  token?: InputMaybe<Scalars['String']['input']>;
  /** [ID] TrialTokenId */
  trialTokenId?: InputMaybe<Scalars['String']['input']>;
  /** [NAVIGATION] TrialUser */
  trialUser?: InputMaybe<Wf_TrialModeLeads_TrialUserInput>;
  /** TrialUserId */
  trialUserId?: InputMaybe<Scalars['Int']['input']>;
};

/** TrialToken */
export type Wf_TrialModeLeads_TrialTokenSortInput = {
  /** AccessKey */
  accessKey?: InputMaybe<SortEnumType>;
  /** CreatedTime */
  createdTime?: InputMaybe<SortEnumType>;
  /** Token */
  token?: InputMaybe<SortEnumType>;
  /** [ID] TrialTokenId */
  trialTokenId?: InputMaybe<SortEnumType>;
  /** [NAVIGATION] TrialUser */
  trialUser?: InputMaybe<Wf_TrialModeLeads_TrialUserSortInput>;
  /** TrialUserId */
  trialUserId?: InputMaybe<SortEnumType>;
};

/** TrialTrackingLog */
export type Wf_TrialModeLeads_TrialTrackingLog = Node & {
  __typename?: 'WF_TrialModeLeads_TrialTrackingLog';
  /** CreatedTime */
  createdTime?: Maybe<Scalars['DateTime']['output']>;
  /** [ID] TrialTrackingLogId */
  id: Scalars['ID']['output'];
  /** Segmentation */
  segmentation?: Maybe<Scalars['String']['output']>;
  /** SegmentationId */
  segmentationId?: Maybe<Scalars['Int']['output']>;
  /** TrialEventId */
  trialEventId?: Maybe<Scalars['String']['output']>;
  /** TrialPageId */
  trialPageId?: Maybe<Scalars['String']['output']>;
  /** TrialUserId */
  trialUserId?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of items. */
export type Wf_TrialModeLeads_TrialTrackingLogConnection = {
  __typename?: 'WF_TrialModeLeads_TrialTrackingLogConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_TrialModeLeads_TrialTrackingLogEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_TrialModeLeads_TrialTrackingLog>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_TrialModeLeads_TrialTrackingLogEdge = {
  __typename?: 'WF_TrialModeLeads_TrialTrackingLogEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_TrialModeLeads_TrialTrackingLog;
};

/** TrialTrackingLog */
export type Wf_TrialModeLeads_TrialTrackingLogFilterInput = {
  and?: InputMaybe<Array<Wf_TrialModeLeads_TrialTrackingLogFilterInput>>;
  /** CreatedTime */
  createdTime?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<Wf_TrialModeLeads_TrialTrackingLogFilterInput>>;
  /** Segmentation */
  segmentation?: InputMaybe<StringOperationFilterInput>;
  /** SegmentationId */
  segmentationId?: InputMaybe<IntOperationFilterInput>;
  /** TrialEventId */
  trialEventId?: InputMaybe<StringOperationFilterInput>;
  /** TrialPageId */
  trialPageId?: InputMaybe<StringOperationFilterInput>;
  /** [ID] TrialTrackingLogId */
  trialTrackingLogId?: InputMaybe<LongOperationFilterInput>;
  /** TrialUserId */
  trialUserId?: InputMaybe<IntOperationFilterInput>;
};

/** TrialTrackingLog */
export type Wf_TrialModeLeads_TrialTrackingLogInput = {
  /** CreatedTime */
  createdTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Segmentation */
  segmentation?: InputMaybe<Scalars['String']['input']>;
  /** SegmentationId */
  segmentationId?: InputMaybe<Scalars['Int']['input']>;
  /** TrialEventId */
  trialEventId?: InputMaybe<Scalars['String']['input']>;
  /** TrialPageId */
  trialPageId?: InputMaybe<Scalars['String']['input']>;
  /** [ID] TrialTrackingLogId */
  trialTrackingLogId?: InputMaybe<Scalars['Long']['input']>;
  /** TrialUserId */
  trialUserId?: InputMaybe<Scalars['Int']['input']>;
};

/** TrialTrackingLog */
export type Wf_TrialModeLeads_TrialTrackingLogSortInput = {
  /** CreatedTime */
  createdTime?: InputMaybe<SortEnumType>;
  /** Segmentation */
  segmentation?: InputMaybe<SortEnumType>;
  /** SegmentationId */
  segmentationId?: InputMaybe<SortEnumType>;
  /** TrialEventId */
  trialEventId?: InputMaybe<SortEnumType>;
  /** TrialPageId */
  trialPageId?: InputMaybe<SortEnumType>;
  /** [ID] TrialTrackingLogId */
  trialTrackingLogId?: InputMaybe<SortEnumType>;
  /** TrialUserId */
  trialUserId?: InputMaybe<SortEnumType>;
};

/** TrialUser */
export type Wf_TrialModeLeads_TrialUser = Node & {
  __typename?: 'WF_TrialModeLeads_TrialUser';
  /** AppVersion */
  appVersion?: Maybe<Scalars['String']['output']>;
  /** AppointmentDate */
  appointmentDate?: Maybe<Scalars['DateTime']['output']>;
  /** ChildBirthday */
  childBirthday?: Maybe<Scalars['DateTime']['output']>;
  /** CreatedTime */
  createdTime?: Maybe<Scalars['DateTime']['output']>;
  /** DemoDate */
  demoDate?: Maybe<Scalars['DateTime']['output']>;
  /** DeviceId */
  deviceId?: Maybe<Scalars['String']['output']>;
  /** EncryptedPhoneNumber */
  encryptedPhoneNumber?: Maybe<Scalars['String']['output']>;
  /** ExpiredDate */
  expiredDate?: Maybe<Scalars['DateTime']['output']>;
  /** FirstLogingDate */
  firstLogingDate?: Maybe<Scalars['DateTime']['output']>;
  /** [ID] TrialUserId */
  id: Scalars['ID']['output'];
  /** IsVerified */
  isVerified?: Maybe<Scalars['Boolean']['output']>;
  /** LastLogingDate */
  lastLogingDate?: Maybe<Scalars['DateTime']['output']>;
  /** LeadsAdapterExecutionTime */
  leadsAdapterExecutionTime?: Maybe<Scalars['DateTime']['output']>;
  /** Market */
  market?: Maybe<Scalars['String']['output']>;
  /** MemberJoinDate */
  memberJoinDate?: Maybe<Scalars['DateTime']['output']>;
  /** MemberNo */
  memberNo?: Maybe<Scalars['String']['output']>;
  /** MobileBrand */
  mobileBrand?: Maybe<Scalars['String']['output']>;
  /** Osversion */
  osversion?: Maybe<Scalars['String']['output']>;
  /** PhoneNumber */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Pushtoken */
  pushtoken?: Maybe<Scalars['String']['output']>;
  /** Referral */
  referral?: Maybe<Scalars['String']['output']>;
  /** Segmentation */
  segmentation?: Maybe<Scalars['String']['output']>;
  /** SegmentationDate */
  segmentationDate?: Maybe<Scalars['DateTime']['output']>;
  /** SharedEa */
  sharedEa?: Maybe<Scalars['String']['output']>;
  /** SharedMember */
  sharedMember?: Maybe<Scalars['String']['output']>;
  /** SourceType */
  sourceType?: Maybe<Scalars['String']['output']>;
  /** [COLLECTION] TrialTokens */
  trialTokens?: Maybe<Array<Maybe<Wf_TrialModeLeads_TrialToken>>>;
  /** TrialUserKey */
  trialUserKey?: Maybe<Scalars['String']['output']>;
  /** TrialUserName */
  trialUserName?: Maybe<Scalars['String']['output']>;
  /** [COLLECTION] TrialUserNotifications */
  trialUserNotifications?: Maybe<Array<Maybe<Wf_TrialModeLeads_TrialUserNotification>>>;
  /** [COLLECTION] TrialUserSegmentationLogs */
  trialUserSegmentationLogs?: Maybe<Array<Maybe<Wf_TrialModeLeads_TrialUserSegmentationLog>>>;
  /** VerificationCode */
  verificationCode?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type Wf_TrialModeLeads_TrialUserConnection = {
  __typename?: 'WF_TrialModeLeads_TrialUserConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_TrialModeLeads_TrialUserEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_TrialModeLeads_TrialUser>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_TrialModeLeads_TrialUserEdge = {
  __typename?: 'WF_TrialModeLeads_TrialUserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_TrialModeLeads_TrialUser;
};

/** TrialUser */
export type Wf_TrialModeLeads_TrialUserFilterInput = {
  and?: InputMaybe<Array<Wf_TrialModeLeads_TrialUserFilterInput>>;
  /** AppVersion */
  appVersion?: InputMaybe<StringOperationFilterInput>;
  /** AppointmentDate */
  appointmentDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** ChildBirthday */
  childBirthday?: InputMaybe<DateTimeOperationFilterInput>;
  /** CreatedTime */
  createdTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** DemoDate */
  demoDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** DeviceId */
  deviceId?: InputMaybe<StringOperationFilterInput>;
  /** EncryptedPhoneNumber */
  encryptedPhoneNumber?: InputMaybe<StringOperationFilterInput>;
  /** ExpiredDate */
  expiredDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** FirstLogingDate */
  firstLogingDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** IsVerified */
  isVerified?: InputMaybe<BooleanOperationFilterInput>;
  /** LastLogingDate */
  lastLogingDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** LeadsAdapterExecutionTime */
  leadsAdapterExecutionTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** Market */
  market?: InputMaybe<StringOperationFilterInput>;
  /** MemberJoinDate */
  memberJoinDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** MemberNo */
  memberNo?: InputMaybe<StringOperationFilterInput>;
  /** MobileBrand */
  mobileBrand?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Wf_TrialModeLeads_TrialUserFilterInput>>;
  /** Osversion */
  osversion?: InputMaybe<StringOperationFilterInput>;
  /** PhoneNumber */
  phoneNumber?: InputMaybe<StringOperationFilterInput>;
  /** Pushtoken */
  pushtoken?: InputMaybe<StringOperationFilterInput>;
  /** Referral */
  referral?: InputMaybe<StringOperationFilterInput>;
  /** Segmentation */
  segmentation?: InputMaybe<StringOperationFilterInput>;
  /** SegmentationDate */
  segmentationDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** SharedEa */
  sharedEa?: InputMaybe<StringOperationFilterInput>;
  /** SharedMember */
  sharedMember?: InputMaybe<StringOperationFilterInput>;
  /** SourceType */
  sourceType?: InputMaybe<StringOperationFilterInput>;
  /** [COLLECTION] TrialTokens */
  trialTokens?: InputMaybe<ListFilterInputTypeOfWf_TrialModeLeads_TrialTokenFilterInput>;
  /** [ID] TrialUserId */
  trialUserId?: InputMaybe<IntOperationFilterInput>;
  /** TrialUserKey */
  trialUserKey?: InputMaybe<StringOperationFilterInput>;
  /** TrialUserName */
  trialUserName?: InputMaybe<StringOperationFilterInput>;
  /** [COLLECTION] TrialUserNotifications */
  trialUserNotifications?: InputMaybe<ListFilterInputTypeOfWf_TrialModeLeads_TrialUserNotificationFilterInput>;
  /** [COLLECTION] TrialUserSegmentationLogs */
  trialUserSegmentationLogs?: InputMaybe<ListFilterInputTypeOfWf_TrialModeLeads_TrialUserSegmentationLogFilterInput>;
  /** VerificationCode */
  verificationCode?: InputMaybe<StringOperationFilterInput>;
};

/** TrialUser */
export type Wf_TrialModeLeads_TrialUserInput = {
  /** AppVersion */
  appVersion?: InputMaybe<Scalars['String']['input']>;
  /** AppointmentDate */
  appointmentDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** ChildBirthday */
  childBirthday?: InputMaybe<Scalars['DateTime']['input']>;
  /** CreatedTime */
  createdTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** DemoDate */
  demoDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** DeviceId */
  deviceId?: InputMaybe<Scalars['String']['input']>;
  /** EncryptedPhoneNumber */
  encryptedPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** ExpiredDate */
  expiredDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** FirstLogingDate */
  firstLogingDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** IsVerified */
  isVerified?: InputMaybe<Scalars['Boolean']['input']>;
  /** LastLogingDate */
  lastLogingDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** LeadsAdapterExecutionTime */
  leadsAdapterExecutionTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Market */
  market?: InputMaybe<Scalars['String']['input']>;
  /** MemberJoinDate */
  memberJoinDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** MemberNo */
  memberNo?: InputMaybe<Scalars['String']['input']>;
  /** MobileBrand */
  mobileBrand?: InputMaybe<Scalars['String']['input']>;
  /** Osversion */
  osversion?: InputMaybe<Scalars['String']['input']>;
  /** PhoneNumber */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Pushtoken */
  pushtoken?: InputMaybe<Scalars['String']['input']>;
  /** Referral */
  referral?: InputMaybe<Scalars['String']['input']>;
  /** Segmentation */
  segmentation?: InputMaybe<Scalars['String']['input']>;
  /** SegmentationDate */
  segmentationDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** SharedEa */
  sharedEa?: InputMaybe<Scalars['String']['input']>;
  /** SharedMember */
  sharedMember?: InputMaybe<Scalars['String']['input']>;
  /** SourceType */
  sourceType?: InputMaybe<Scalars['String']['input']>;
  /** [COLLECTION] TrialTokens */
  trialTokens?: InputMaybe<Array<InputMaybe<Wf_TrialModeLeads_TrialTokenInput>>>;
  /** [ID] TrialUserId */
  trialUserId?: InputMaybe<Scalars['Int']['input']>;
  /** TrialUserKey */
  trialUserKey?: InputMaybe<Scalars['String']['input']>;
  /** TrialUserName */
  trialUserName?: InputMaybe<Scalars['String']['input']>;
  /** [COLLECTION] TrialUserNotifications */
  trialUserNotifications?: InputMaybe<Array<InputMaybe<Wf_TrialModeLeads_TrialUserNotificationInput>>>;
  /** [COLLECTION] TrialUserSegmentationLogs */
  trialUserSegmentationLogs?: InputMaybe<Array<InputMaybe<Wf_TrialModeLeads_TrialUserSegmentationLogInput>>>;
  /** VerificationCode */
  verificationCode?: InputMaybe<Scalars['String']['input']>;
};

/** TrialUserMessageLog */
export type Wf_TrialModeLeads_TrialUserMessageLog = Node & {
  __typename?: 'WF_TrialModeLeads_TrialUserMessageLog';
  /** CreatedTime */
  createdTime?: Maybe<Scalars['DateTime']['output']>;
  /** [ID] LogId */
  id: Scalars['ID']['output'];
  /** MessageType */
  messageType?: Maybe<Scalars['String']['output']>;
  /** TrialUserId */
  trialUserId?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of items. */
export type Wf_TrialModeLeads_TrialUserMessageLogConnection = {
  __typename?: 'WF_TrialModeLeads_TrialUserMessageLogConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_TrialModeLeads_TrialUserMessageLogEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_TrialModeLeads_TrialUserMessageLog>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_TrialModeLeads_TrialUserMessageLogEdge = {
  __typename?: 'WF_TrialModeLeads_TrialUserMessageLogEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_TrialModeLeads_TrialUserMessageLog;
};

/** TrialUserMessageLog */
export type Wf_TrialModeLeads_TrialUserMessageLogFilterInput = {
  and?: InputMaybe<Array<Wf_TrialModeLeads_TrialUserMessageLogFilterInput>>;
  /** CreatedTime */
  createdTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** [ID] LogId */
  logId?: InputMaybe<IntOperationFilterInput>;
  /** MessageType */
  messageType?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Wf_TrialModeLeads_TrialUserMessageLogFilterInput>>;
  /** TrialUserId */
  trialUserId?: InputMaybe<IntOperationFilterInput>;
};

/** TrialUserMessageLog */
export type Wf_TrialModeLeads_TrialUserMessageLogInput = {
  /** CreatedTime */
  createdTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** [ID] LogId */
  logId?: InputMaybe<Scalars['Int']['input']>;
  /** MessageType */
  messageType?: InputMaybe<Scalars['String']['input']>;
  /** TrialUserId */
  trialUserId?: InputMaybe<Scalars['Int']['input']>;
};

/** TrialUserMessageLog */
export type Wf_TrialModeLeads_TrialUserMessageLogSortInput = {
  /** CreatedTime */
  createdTime?: InputMaybe<SortEnumType>;
  /** [ID] LogId */
  logId?: InputMaybe<SortEnumType>;
  /** MessageType */
  messageType?: InputMaybe<SortEnumType>;
  /** TrialUserId */
  trialUserId?: InputMaybe<SortEnumType>;
};

/** TrialUserNotification */
export type Wf_TrialModeLeads_TrialUserNotification = Node & {
  __typename?: 'WF_TrialModeLeads_TrialUserNotification';
  /** CreatedTime */
  createdTime?: Maybe<Scalars['DateTime']['output']>;
  /** [ID] TrialUserNotificationId */
  id: Scalars['ID']['output'];
  /** LinkNo */
  linkNo?: Maybe<Scalars['String']['output']>;
  /** LookedDate */
  lookedDate?: Maybe<Scalars['String']['output']>;
  /** Message */
  message?: Maybe<Scalars['String']['output']>;
  /** MessageDate */
  messageDate?: Maybe<Scalars['DateTime']['output']>;
  /** NotificationId */
  notificationId?: Maybe<Scalars['Int']['output']>;
  /** NotificationTypeId */
  notificationTypeId?: Maybe<Scalars['String']['output']>;
  /** PublicFlg */
  publicFlg?: Maybe<Scalars['Boolean']['output']>;
  /** PushFlg */
  pushFlg?: Maybe<Scalars['String']['output']>;
  /** ScheduleTime */
  scheduleTime?: Maybe<Scalars['DateTime']['output']>;
  /** SendFlg */
  sendFlg?: Maybe<Scalars['String']['output']>;
  /** [NAVIGATION] TrialUser */
  trialUser?: Maybe<Wf_TrialModeLeads_TrialUser>;
  /** [NOT NULL] TrialUserId */
  trialUserId?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of items. */
export type Wf_TrialModeLeads_TrialUserNotificationConnection = {
  __typename?: 'WF_TrialModeLeads_TrialUserNotificationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_TrialModeLeads_TrialUserNotificationEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_TrialModeLeads_TrialUserNotification>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_TrialModeLeads_TrialUserNotificationEdge = {
  __typename?: 'WF_TrialModeLeads_TrialUserNotificationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_TrialModeLeads_TrialUserNotification;
};

/** TrialUserNotification */
export type Wf_TrialModeLeads_TrialUserNotificationFilterInput = {
  and?: InputMaybe<Array<Wf_TrialModeLeads_TrialUserNotificationFilterInput>>;
  /** CreatedTime */
  createdTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** LinkNo */
  linkNo?: InputMaybe<StringOperationFilterInput>;
  /** LookedDate */
  lookedDate?: InputMaybe<StringOperationFilterInput>;
  /** Message */
  message?: InputMaybe<StringOperationFilterInput>;
  /** MessageDate */
  messageDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** NotificationId */
  notificationId?: InputMaybe<IntOperationFilterInput>;
  /** NotificationTypeId */
  notificationTypeId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Wf_TrialModeLeads_TrialUserNotificationFilterInput>>;
  /** PublicFlg */
  publicFlg?: InputMaybe<BooleanOperationFilterInput>;
  /** PushFlg */
  pushFlg?: InputMaybe<StringOperationFilterInput>;
  /** ScheduleTime */
  scheduleTime?: InputMaybe<DateTimeOperationFilterInput>;
  /** SendFlg */
  sendFlg?: InputMaybe<StringOperationFilterInput>;
  /** [NAVIGATION] TrialUser */
  trialUser?: InputMaybe<Wf_TrialModeLeads_TrialUserFilterInput>;
  /** [NOT NULL] TrialUserId */
  trialUserId?: InputMaybe<IntOperationFilterInput>;
  /** [ID] TrialUserNotificationId */
  trialUserNotificationId?: InputMaybe<IntOperationFilterInput>;
};

/** TrialUserNotification */
export type Wf_TrialModeLeads_TrialUserNotificationInput = {
  /** CreatedTime */
  createdTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** LinkNo */
  linkNo?: InputMaybe<Scalars['String']['input']>;
  /** LookedDate */
  lookedDate?: InputMaybe<Scalars['String']['input']>;
  /** Message */
  message?: InputMaybe<Scalars['String']['input']>;
  /** MessageDate */
  messageDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** NotificationId */
  notificationId?: InputMaybe<Scalars['Int']['input']>;
  /** NotificationTypeId */
  notificationTypeId?: InputMaybe<Scalars['String']['input']>;
  /** PublicFlg */
  publicFlg?: InputMaybe<Scalars['Boolean']['input']>;
  /** PushFlg */
  pushFlg?: InputMaybe<Scalars['String']['input']>;
  /** ScheduleTime */
  scheduleTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** SendFlg */
  sendFlg?: InputMaybe<Scalars['String']['input']>;
  /** [NAVIGATION] TrialUser */
  trialUser?: InputMaybe<Wf_TrialModeLeads_TrialUserInput>;
  /** [NOT NULL] TrialUserId */
  trialUserId?: InputMaybe<Scalars['Int']['input']>;
  /** [ID] TrialUserNotificationId */
  trialUserNotificationId?: InputMaybe<Scalars['Int']['input']>;
};

/** TrialUserNotification */
export type Wf_TrialModeLeads_TrialUserNotificationSortInput = {
  /** CreatedTime */
  createdTime?: InputMaybe<SortEnumType>;
  /** LinkNo */
  linkNo?: InputMaybe<SortEnumType>;
  /** LookedDate */
  lookedDate?: InputMaybe<SortEnumType>;
  /** Message */
  message?: InputMaybe<SortEnumType>;
  /** MessageDate */
  messageDate?: InputMaybe<SortEnumType>;
  /** NotificationId */
  notificationId?: InputMaybe<SortEnumType>;
  /** NotificationTypeId */
  notificationTypeId?: InputMaybe<SortEnumType>;
  /** PublicFlg */
  publicFlg?: InputMaybe<SortEnumType>;
  /** PushFlg */
  pushFlg?: InputMaybe<SortEnumType>;
  /** ScheduleTime */
  scheduleTime?: InputMaybe<SortEnumType>;
  /** SendFlg */
  sendFlg?: InputMaybe<SortEnumType>;
  /** [NAVIGATION] TrialUser */
  trialUser?: InputMaybe<Wf_TrialModeLeads_TrialUserSortInput>;
  /** [NOT NULL] TrialUserId */
  trialUserId?: InputMaybe<SortEnumType>;
  /** [ID] TrialUserNotificationId */
  trialUserNotificationId?: InputMaybe<SortEnumType>;
};

/** TrialUserSegmentationLog */
export type Wf_TrialModeLeads_TrialUserSegmentationLog = Node & {
  __typename?: 'WF_TrialModeLeads_TrialUserSegmentationLog';
  /** CreatedTime */
  createdTime?: Maybe<Scalars['DateTime']['output']>;
  /** [ID] SegmentationLogId */
  id: Scalars['ID']['output'];
  /** SegmentationNew */
  segmentationNew?: Maybe<Scalars['String']['output']>;
  /** SegmentationOld */
  segmentationOld?: Maybe<Scalars['String']['output']>;
  /** [NAVIGATION] TrialUser */
  trialUser?: Maybe<Wf_TrialModeLeads_TrialUser>;
  /** TrialUserId */
  trialUserId?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of items. */
export type Wf_TrialModeLeads_TrialUserSegmentationLogConnection = {
  __typename?: 'WF_TrialModeLeads_TrialUserSegmentationLogConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Wf_TrialModeLeads_TrialUserSegmentationLogEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Wf_TrialModeLeads_TrialUserSegmentationLog>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Wf_TrialModeLeads_TrialUserSegmentationLogEdge = {
  __typename?: 'WF_TrialModeLeads_TrialUserSegmentationLogEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Wf_TrialModeLeads_TrialUserSegmentationLog;
};

/** TrialUserSegmentationLog */
export type Wf_TrialModeLeads_TrialUserSegmentationLogFilterInput = {
  and?: InputMaybe<Array<Wf_TrialModeLeads_TrialUserSegmentationLogFilterInput>>;
  /** CreatedTime */
  createdTime?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<Wf_TrialModeLeads_TrialUserSegmentationLogFilterInput>>;
  /** [ID] SegmentationLogId */
  segmentationLogId?: InputMaybe<IntOperationFilterInput>;
  /** SegmentationNew */
  segmentationNew?: InputMaybe<StringOperationFilterInput>;
  /** SegmentationOld */
  segmentationOld?: InputMaybe<StringOperationFilterInput>;
  /** [NAVIGATION] TrialUser */
  trialUser?: InputMaybe<Wf_TrialModeLeads_TrialUserFilterInput>;
  /** TrialUserId */
  trialUserId?: InputMaybe<IntOperationFilterInput>;
};

/** TrialUserSegmentationLog */
export type Wf_TrialModeLeads_TrialUserSegmentationLogInput = {
  /** CreatedTime */
  createdTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** [ID] SegmentationLogId */
  segmentationLogId?: InputMaybe<Scalars['Int']['input']>;
  /** SegmentationNew */
  segmentationNew?: InputMaybe<Scalars['String']['input']>;
  /** SegmentationOld */
  segmentationOld?: InputMaybe<Scalars['String']['input']>;
  /** [NAVIGATION] TrialUser */
  trialUser?: InputMaybe<Wf_TrialModeLeads_TrialUserInput>;
  /** TrialUserId */
  trialUserId?: InputMaybe<Scalars['Int']['input']>;
};

/** TrialUserSegmentationLog */
export type Wf_TrialModeLeads_TrialUserSegmentationLogSortInput = {
  /** CreatedTime */
  createdTime?: InputMaybe<SortEnumType>;
  /** [ID] SegmentationLogId */
  segmentationLogId?: InputMaybe<SortEnumType>;
  /** SegmentationNew */
  segmentationNew?: InputMaybe<SortEnumType>;
  /** SegmentationOld */
  segmentationOld?: InputMaybe<SortEnumType>;
  /** [NAVIGATION] TrialUser */
  trialUser?: InputMaybe<Wf_TrialModeLeads_TrialUserSortInput>;
  /** TrialUserId */
  trialUserId?: InputMaybe<SortEnumType>;
};

/** TrialUser */
export type Wf_TrialModeLeads_TrialUserSortInput = {
  /** AppVersion */
  appVersion?: InputMaybe<SortEnumType>;
  /** AppointmentDate */
  appointmentDate?: InputMaybe<SortEnumType>;
  /** ChildBirthday */
  childBirthday?: InputMaybe<SortEnumType>;
  /** CreatedTime */
  createdTime?: InputMaybe<SortEnumType>;
  /** DemoDate */
  demoDate?: InputMaybe<SortEnumType>;
  /** DeviceId */
  deviceId?: InputMaybe<SortEnumType>;
  /** EncryptedPhoneNumber */
  encryptedPhoneNumber?: InputMaybe<SortEnumType>;
  /** ExpiredDate */
  expiredDate?: InputMaybe<SortEnumType>;
  /** FirstLogingDate */
  firstLogingDate?: InputMaybe<SortEnumType>;
  /** IsVerified */
  isVerified?: InputMaybe<SortEnumType>;
  /** LastLogingDate */
  lastLogingDate?: InputMaybe<SortEnumType>;
  /** LeadsAdapterExecutionTime */
  leadsAdapterExecutionTime?: InputMaybe<SortEnumType>;
  /** Market */
  market?: InputMaybe<SortEnumType>;
  /** MemberJoinDate */
  memberJoinDate?: InputMaybe<SortEnumType>;
  /** MemberNo */
  memberNo?: InputMaybe<SortEnumType>;
  /** MobileBrand */
  mobileBrand?: InputMaybe<SortEnumType>;
  /** Osversion */
  osversion?: InputMaybe<SortEnumType>;
  /** PhoneNumber */
  phoneNumber?: InputMaybe<SortEnumType>;
  /** Pushtoken */
  pushtoken?: InputMaybe<SortEnumType>;
  /** Referral */
  referral?: InputMaybe<SortEnumType>;
  /** Segmentation */
  segmentation?: InputMaybe<SortEnumType>;
  /** SegmentationDate */
  segmentationDate?: InputMaybe<SortEnumType>;
  /** SharedEa */
  sharedEa?: InputMaybe<SortEnumType>;
  /** SharedMember */
  sharedMember?: InputMaybe<SortEnumType>;
  /** SourceType */
  sourceType?: InputMaybe<SortEnumType>;
  /** [ID] TrialUserId */
  trialUserId?: InputMaybe<SortEnumType>;
  /** TrialUserKey */
  trialUserKey?: InputMaybe<SortEnumType>;
  /** TrialUserName */
  trialUserName?: InputMaybe<SortEnumType>;
  /** VerificationCode */
  verificationCode?: InputMaybe<SortEnumType>;
};

export type WarrantyInfoListParameterInput = {
  applicationIds: Array<Scalars['Long']['input']>;
};

export type WarrantyInfoResponse = {
  __typename?: 'WarrantyInfoResponse';
  accountNo: Scalars['String']['output'];
  applicationDate: Scalars['String']['output'];
  applicationId: Scalars['Long']['output'];
  applicationNo: Scalars['String']['output'];
  itemQty: Scalars['Int']['output'];
  otherProductList: Array<ProductGroup>;
  status: Scalars['String']['output'];
  talkalongCardProductList: Array<ProductGroup>;
  updateDate: Scalars['String']['output'];
};

export type WarrantyListParameterInput = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  market: Scalars['String']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  status: Scalars['String']['input'];
};

export type WarrantyListResponse = {
  __typename?: 'WarrantyListResponse';
  accountNo: Scalars['String']['output'];
  applicationDate: Scalars['String']['output'];
  applicationId: Scalars['Long']['output'];
  applicationNo: Scalars['String']['output'];
  categoryNames: Scalars['String']['output'];
  itemQty: Scalars['Int']['output'];
  status: Scalars['String']['output'];
};

export type WarrantyStatusInput = {
  applicationId: Array<Scalars['Long']['input']>;
  status: Scalars['String']['input'];
  updateBy: Scalars['String']['input'];
};
